import { appDemoDe } from "./appDemoTranslations";
import {  navigationMenuDe } from "./navigationMenuTranslations";
import { memberAdminNavigationDe } from "./memberAdminNavigationTranslations";
import { bankingDe } from "../../../../../../shared/frontend/banking/bankingTranslations";
import { merchantPaymentDe } from "../../../../../../shared/frontend/payments/merchantPaymentTranslations";
import { paymentProfileDe } from "./paymentProfileTranslations";
import { settingsNavigationDe } from "./settingsNavigationTranslations";
import { themeDe } from "../../../../../../shared/frontend/theme/themeTranslations";
import { wizardDe } from "../../../../../../shared/frontend/wizard/wizardTranslations";
import { smtpEmailAccountDe } from "../../../../../../shared/frontend/smtp-relay/smtpEmailAccountTranslations";
import { sharedInvoiceDesignDe } from "../../../../../../shared/frontend/billing/invoiceDesignTranslations";
import { sharedPeriodSelectorDe } from "../../../../../../shared/frontend/components/periodSelectorTranslations";
import { sharedAdminDe } from "../../../../../../shared/frontend/admin/adminTranslations";
import { sharedProviderAccessDe } from "../../../../../../shared/frontend/ai/providerAccessTranslations";
import { sharedOfferedModelsDe } from "../../../../../../shared/frontend/ai/offeredModelsTranslations";
import { sharedProviderPricingDe } from "../../../../../../shared/frontend/ai/providerPricingTranslations";
import { sharedAgentModelSelectionDe } from "../../../../../../shared/frontend/ai/agentModelSelectionTranslations";

/**
 * German translations (keys are English).
 */
import { publicIdentityDe } from "../../features/publicForm/publicIdentityTranslations";
export const de = {
  "Message goal": "Ziel",
  "Assign the person to this email first.": "Ordne dieser E-Mail zuerst die Person zu.",
  "Request evidence": "Beleg",
  "Appointment booking request": "Terminbuchung",
  "Appointment acceptance": "Terminzusage",
  "Process appointment request": "Terminanliegen bearbeiten",
  "Select the appointment for this request.": "Wähle den Termin zu diesem Anliegen aus.",
  ...appDemoDe,
  "Available for manual payments": "Für manuelle Zahlungen verfügbar",
  "Payment methods could not be loaded.": "Die Zahlungsarten konnten nicht geladen werden.",
  ...publicIdentityDe,
  "Assignment readers could not be loaded.": "Die Zuweisungsleser konnten nicht geladen werden.",
  "Set the current location in Check-in before assigning an access medium.": "Lege vor der Zuweisung den aktuellen Standort im Check-in fest.",
  "No assignment reader configured at this location.": "An diesem Standort ist kein Zuweisungsleser konfiguriert.",
  "Monitored readers": "Überwachte Leser",
  "All configured assignment readers are offline.": "Alle konfigurierten Zuweisungsleser sind offline.",
  "Present the chip to one of these readers.": "Halte den Chip an einen dieser Leser.",
  "Access medium scan failed.": "Der Chip konnte nicht zugewiesen werden.",
  "Bank account ID is missing. Reload the bank accounts and try again.": "Die Bankkonto-ID fehlt. Lade die Bankkonten neu und versuche es erneut.",
  ...paymentProfileDe,
  "Bank statement booking status": "Buchungsstatus",
  "E_BankStatementCreditConsumed": "Das Guthaben dieser Einzahlung wurde bereits verwendet. Kläre zuerst die zugehörigen Guthabenverrechnungen, bevor du die Einzahlung stornierst.",
  "Bank statement partially booked": "teilweise verbucht",
  "Bank statement open": "offen",
  "Bank statement ambiguous": "mehrdeutig",
  "Bank statement refresh assignments": "Zuordnungen prüfen",
  "Bank statement candidates": "Kandidaten",
  "Bank statement record partial payment": "Teilbetrag buchen",
  "Bank statement amount exceeds remainder": "Der Teilbetrag darf den noch zu verbuchenden Betrag nicht überschreiten.",
  "Bank statement booked amount": "verbuchter Betrag",
  "Bank statement unallocated amount": "noch zu verbuchen",
  "E_BankStatementAllocationChanged": "Die Zuordnung dieses Bankumsatzes wurde inzwischen geändert. Lade den Kontoauszug neu und prüfe den noch offenen Betrag.",
  "Bank statement known only": "nur bekannte Umsätze",
  "Import maintenance package progress": "Beitragskalender: {0}/{1} Vertragspakete",
  "Bank statement person identified": "Person erkannt",
  "Bank statement contribution identified": "Position erkannt",
  "Bank statement remember payer question": "Ist {0} eine Überweisungs-IBAN von {1}? Zuordnung merken.",
  "Bank statement remember payer effect": "Nach erfolgreicher Buchung werden Name und IBAN für diese Person hinterlegt. Weitere Überweisungen mit derselben Kombination können dann erkannt werden.",
  "Bank statement payer recognition": "Zahlererkennung",
  "Bank statement revoke payer": "Zuordnung aufheben",
  "Bank statement revoke payer title": "Gespeicherte Zahlerzuordnung aufheben?",
  "Bank statement revoke payer consequence": "Diese bestätigte Name-/IBAN-Zuordnung wird künftig nicht mehr zur Erkennung verwendet. Bestehende Buchungen bleiben erhalten.",
  "E_BankStatementPayerUnavailable": "Der Bankumsatz enthält keine gültige Kombination aus Zahlername und IBAN. Buche ohne gespeicherte Zahlerzuordnung.",
  "E_BankStatementPayerConflict": "Name und IBAN sind bereits einer anderen Person zugeordnet. Prüfe die gespeicherte Zuordnung oder buche ohne neue Zahlerzuordnung.",
  "Bank statement last fetched": "Letzter Abruf",
  "Bank statement confirmed assignment": "eindeutige IBAN- oder Referenzzuordnung",
  "Bank statement suggested assignment": "Zuordnung prüfen: eingeschränkter Nachweis",
  "Bank statement member payment": "Mitgliedszahlung",
  "E_BankStatementAlreadyBooked": "Diese Bankbuchung wurde bereits verbucht.",

  "E_BankingSettings": "Bankleitzahl, Bankserver und Protokollversion müssen vollständig sein. RAH-10 benötigt FinTS 3.0.",
  "Banking customer ID optional": "Kunden-ID (optional)",
  "Banking section access": "Zugang",
  "Banking section usage": "Verwendung",
  "E_BankingNameRequired": "Bitte einen Namen für die Online-Verbindung angeben.",
  "E_BankingNameDuplicate": "Dieser Name ist bereits für eine andere Online-Verbindung vergeben.",
  "E_BankingOrderUnsupported": "Die Bank bietet diesen Auftrag über die Online-Anbindung nicht an. Bitte die SEPA-Datei herunterladen und im Onlinebanking einreichen.",
  "E_BankingNoConnection": "Für dieses Bankkonto ist keine aktive Online-Anbindung eingerichtet oder keine als Standard markiert (Einstellungen → Bank → Online-Anbindungen).",
  "E_BankingOrderAccountMismatch": "Der Lauf zieht nicht vollständig auf das Konto der Online-Anbindung ein und kann deshalb nicht online eingereicht werden.",
  "E_BankingOrderRejected": "Die Bank hat den Auftrag abgelehnt. Er wurde nicht ausgeführt.",
  "E_BankingOrderUnknown": "Ob die Bank den Auftrag angenommen hat, ist unklar. Bitte im Onlinebanking prüfen und das Ergebnis hier bestätigen; bis dahin ist keine erneute Einreichung möglich.",
  "E_BankingOrderState": "Der Auftrag ist bereits eingereicht oder wartet auf Klärung.",
  "E_BankingOrderAfterDownload": "Die SEPA-Datei wurde bereits heruntergeladen. Bitte bestätigen, dass sie nicht schon bei der Bank hochgeladen wurde.",
  "Banking credentials blocked": "Zugang gesperrt",
  "Banking credentials blocked hint": "Die Bank hat die Anmeldung zu oft abgelehnt. Zugangsdaten prüfen und speichern, um den Zugang wieder freizugeben.",
  "E_BankingCredentialsBlocked": "Bankzugang gesperrt: Die Bank hat die Anmeldung zu oft abgelehnt. Bitte die Zugangsdaten in der Einrichtung der Online-Verbindung neu eingeben und speichern.",
  "E_BankingMethodNotAllowed": "Dieses Zugangsverfahren ist für die Bankanbindung derzeit nicht zugelassen. Bitte in der Einrichtung ein zugelassenes Verfahren wählen.",
  "E_BankingPolicyNoMethod": "Mindestens ein Zugangsverfahren muss zugelassen sein.",
  "E_BankingPayeeDeclined": "Auftrag nach der Empfängerüberprüfung abgebrochen. Er wurde nicht ausgeführt.",
  "E_TransferOrderMixedAccounts": "Die ausgewählten Rückerstattungen gehören zu verschiedenen Bankkonten. Bitte je Konto getrennt überweisen.",
  "Bank order submitted": "Auftrag an die Bank übermittelt.",
  "Banking use statement": "Kontoauszug",
  "Banking use direct debit": "Lastschrift",
  "Banking use transfer": "Überweisung",
  "Banking default for direct debit": "Standard für Lastschrift",
  "Banking default for transfer": "Standard für Überweisung",
  "Online connection": "Online-Anbindung",
  "Banking payee check": "Empfängerüberprüfung",
  "Banking execute order": "Auftrag ausführen",
  "Banking cancel order": "Auftrag abbrechen",
  "Banking payee check instruction": "Name und Konto stimmen nicht oder nur teilweise überein. Wird der Auftrag trotzdem ausgeführt, haftet die Bank nicht, falls das Geld beim falschen Empfänger ankommt.",
  "Banking order resolve instruction": "Bitte im Onlinebanking nachsehen, ob der Auftrag eingegangen ist.",
  "Please select an option.": "Bitte eine Auswahl treffen.",
  "SEPA file already downloaded": "SEPA-Datei bereits heruntergeladen",
  "Banking submit after download warning": "Wurde die Datei schon im Onlinebanking hochgeladen, würde eine Online-Einreichung doppelt einziehen.",
  "Banking send to bank": "an Bank senden",
  "Banking send to bank again": "erneut an Bank senden",
  "Banking submit direct debit run": "Lastschriftlauf an Bank senden",
  "Banking resolve submission": "Einreichung klären",
  "Banking order arrived at bank": "bei der Bank eingegangen",
  "Banking order not at bank": "nicht bei der Bank eingegangen",
  "Banking submitted to bank": "an Bank übermittelt",
  "Banking submission unclear": "Einreichung unklar",
  "Banking rejected by bank": "von Bank abgelehnt",
  "Bank handover": "Bankübergabe",
  "Banking resolve submission before posting": "Erst die Online-Einreichung klären, dann verbuchen.",
  "Transfer open": "Überweisung offen",
  "Transfer submitting": "wird übermittelt",
  "Transfer submitted": "überwiesen",
  "Transfer rejected": "von Bank abgelehnt",
  "Transfer unclear": "Übermittlung unklar",
  "Transfer done outside": "außerhalb erledigt",
  "Transfer refunds": "Rückerstattungen überweisen",
  "Banking resolve transfer": "Überweisung klären",
  "Transfer done outside m1member": "außerhalb von m1member erledigt",
  "Banking default for statement": "Standard für Kontoauszug",
  "Banking default short": "Standard",
  "Banking stored PIN in use": "Leer lassen, um die gespeicherte PIN zu verwenden.",
  "Banking save PIN": "Passwort speichern",
  "Banking save file password": "Datei-PIN speichern",
  "Banking save PIN hint": "Wird erst nach erfolgreicher Anmeldung verschlüsselt gespeichert. TAN-Freigaben bleiben nötig. Abwählen löscht die gespeicherte PIN.",
  "Select bank": "Bank wählen",
  "Bank reference": "Bankreferenz",
  "Bank statement transaction": "Umsatz",
  "Bank statement booking day": "Buchungstag",
  "Bank statement value date": "Wertstellung",
  "Bank statement assignment": "Zuordnung",
  "Bank statement booked": "verbucht",
  "Bank statement direct debit collection": "Lastschrifteinzug",
  "Bank statement book chargeback": "Rücklastschrift buchen",
  "Select returned payments": "zurückgegebene Zahlungen auswählen",
  "No payments available for chargeback.": "Keine Zahlungen für eine Rücklastschrift vorhanden.",
  "Chargeback amount": "Rücklastschriftbetrag",
  "Available payment amount": "verfügbarer Zahlungsbetrag",
  "Chargeback date": "Rücklastschriftdatum",
  "Chargeback date is required": "Rücklastschriftdatum ist erforderlich",
  "Chargeback date must not be in the future": "Rücklastschriftdatum darf nicht in der Zukunft liegen",
  "Bank statement open run": "Lauf öffnen",
  "Bank statement end-to-end ID": "End-to-End-ID",
  "Banking port": "Port",
  "Banking inspect file": "Datei prüfen",
  "Banking test connection": "Verbindung testen",
  "Banking signature counter": "Signaturzähler",
  "Banking file check completed": "Datei erfolgreich geprüft.",
  "Banking connection test completed": "Verbindung erfolgreich geprüft.",

  "Banking tested": "getestet",
  "Banking untested": "ungetestet",
  "Banking security file stored": "Sicherheitsdatei verschlüsselt hinterlegt",
  "E_BankingFileRequired": "Bitte für dieses Zugangsverfahren eine Sicherheitsdatei und deren Datei-PIN angeben.",
  "E_BankingFileEntry": "Die Datei enthält keinen eindeutigen Zugang zur ausgewählten Bank. Bitte die zugehörige Benutzerkennung angeben.",
  "Banking optical TAN signal": "Optisches TAN-Signal",
  "Banking optical width": "Breite",
  "Banking optical speed": "Geschwindigkeit",
  "Banking verify bank key": "Bankschlüssel prüfen",
  "Banking verify bank key instruction": "Vergleiche den angezeigten Prüfwert mit den unabhängig bezogenen Unterlagen deiner Bank und trage den Prüfwert aus diesen Unterlagen ein.",
  "Banking bank document fingerprint": "Prüfwert aus den Bankunterlagen",
  "Banking use changed password": "Geändertes Onlinebanking-Passwort verwenden",
  "E_BankingEndpoint": "Der Bankserver stimmt nicht mit dem Verzeichnis der Bank überein. Bitte die Bankeinstellungen prüfen.",
  "E_BankingUseStatement": "Bitte den Bankzugang auf der Seite Kontoauszug verwenden.",
  "E_BankingUnavailable": "Der Bankadapter oder seine Produktregistrierung ist nicht eingerichtet. Bitte die Systemadministration informieren.",
  "E_BankingCredentials": "Der Bankzugang konnte nicht entsperrt werden. Bitte Kennung, PIN und gegebenenfalls die Sicherheitsdatei prüfen.",
  "E_BankingBusy": "Für diesen Bankzugang läuft bereits ein Vorgang.",
  "E_BankingFailed": "Der Bankabruf ist fehlgeschlagen. Es wurde kein automatischer Wiederholungsversuch gestartet.",
  "E_BankingCancelled": "Der Bankabruf wurde abgebrochen oder die Freigabe ist abgelaufen.",
  "E_BankingFileUnsupported": "Die Sicherheitsdatei konnte nicht eingelesen werden. Das ALF-BanCo-Dateiformat wird noch nicht direkt unterstützt.",
  "E_BankingAccountUnavailable": "Das ausgewählte Konto ist für diesen Bankzugang nicht verfügbar.",
  "E_BankingTrustRequired": "Die Bankschlüssel müssen vor der Verwendung anhand der Bankunterlagen geprüft werden. Der Abruf wurde beendet.",
  "Banking access method": "Zugangsverfahren",
  "Banking RAH10 file": "Sicherheitsdatei (RAH-10)",
  "Banking RDH file": "Sicherheitsdatei (RDH)",
  "Banking security file": "Sicherheitsdatei",
  "Banking security file entry": "Bankzugang in der Sicherheitsdatei",
  "Banking file password": "PIN der Sicherheitsdatei",
  "Banking security file required": "Bitte die Sicherheitsdatei auswählen.",
  "Banking host": "Bankserver",
  "Banking app approval": "Freigabe in der Banking-App",
  "Banking approval completed": "Freigabe prüfen",
  "Banking TAN image": "Grafik für den TAN-Generator",
  "Open bank statement": "Kontoauszug öffnen",
  "Bank statement fetch completed": "Kontoauszug abgerufen.",
  "Complete chargeback processing": "Bearbeitung abschließen",
  "Handle chargeback claim": "Zahlungsaufforderung / erneuter Einzug",
  "Check mandate and debit blocks": "Bankverbindung und Einzugssperren prüfen",
  "Processing result": "Bearbeitungsergebnis",
  "Original request note": "ursprüngliche Nachricht",
  "E_ContractRequestChanged": "Das Anliegen wurde geändert, zurückgenommen oder bereits bearbeitet. Öffne es erneut und prüfe den aktuellen Stand.",
  "Cancellation by email": "Kündigung per E-Mail",
  "Cancellation via app": "Kündigung per App",
  "Rest period via app": "Ruhezeit per App",
  "Rest period by email": "Ruhezeit per E-Mail",
  "Process cancellation": "Kündigung bearbeiten",
  "Process rest period": "Ruhezeit bearbeiten",
  "Request processed": "Anliegen bearbeitet",
  "This request can be linked to an existing contract change.": "Für dieses Anliegen ist bereits eine Vertragsänderung vorhanden. Prüfe die Originalnachricht vor der Zuordnung.",
  "Link existing cancellation": "Vorhandene Kündigung zuordnen",
  "Link existing rest period": "Vorhandene Ruhezeit zuordnen",
  "Cancellation processed": "Kündigung bearbeitet",
  "Rest period processed": "Ruhezeit bearbeitet",
  "Check the email assignment before processing.": "Prüfe vor der Bearbeitung die Zuordnung und Angaben der E-Mail.",
  "Check email assignment": "E-Mail-Zuordnung prüfen",
  ...merchantPaymentDe,
  ...bankingDe,
  ...navigationMenuDe,
  ...settingsNavigationDe,
  "Module & Leistungsumfang nach Vereinbarung": "Module & Leistungsumfang nach Vereinbarung",
  "Standortpreise & Abrechnung nach Vereinbarung": "Standortpreise & Abrechnung nach Vereinbarung",
  "Support, Ansprechpartner & SLA nach Vereinbarung": "Support, Ansprechpartner & SLA nach Vereinbarung",
  "Onboarding, Schulung & Datenübernahme nach Vereinbarung": "Onboarding, Schulung & Datenübernahme nach Vereinbarung",
  ...smtpEmailAccountDe,
  ...themeDe,
  ...wizardDe,
  "E_AccountAlreadyUsed": "Dieser Benutzer wurde bereits genutzt. Setze ihn stattdessen inaktiv; seine Zuordnungen und historischen Daten bleiben erhalten.",
  "E_EntityInactive": "Der gewählte Eintrag ist nicht mehr aktiv und kann für diesen neuen Vorgang nicht verwendet werden.",
  "E_RestPeriodCancelled": "Die Ruhezeit ist storniert und kann nicht bearbeitet oder erneut bestätigt werden.",
  "Aggregator checks": "Aggregator-Prüfungen",
  "Aggregator linked": "verknüpft",
  "Aggregator identity required": "Mitgliedszuordnung fehlt",
  "Link aggregator membership": "Mitgliedschaft verknüpfen",
  "Unlink aggregator membership?": "Mitgliedschaft trennen?",
  "Aggregator unlink consequence": "Die Anbieterzuordnung wird für alle zugehörigen Verträge und Wertekonten dieser Person getrennt. Zutritt über diese Mitgliedschaft ist danach erst nach erneuter Verknüpfung möglich.",
  "Integration Urban Sports Club description": "Zusätzliche Zutrittsprüfung über Urban Sports Club.",
  "Aggregators": "Aggregatoren",
  "EGYM Wellpass": "EGYM Wellpass",
  "Urban Sports Club": "Urban Sports Club",
  "Integration EGYM Wellpass description": "Zutrittsprüfung für Wellpass-Mitglieder. Voraussetzung ist ein von EGYM freigeschalteter API-Schlüssel für dieses Studio.",
  "Wellpass environment": "Umgebung",
  "Test environment": "Testumgebung",
  "Replace API key": "API-Schlüssel ersetzen",
  "Link Wellpass": "Wellpass verknüpfen",
  "Relink Wellpass": "Wellpass-Verknüpfung prüfen",
  "Unlink": "Verknüpfung trennen",
  "Unlink Wellpass?": "Wellpass-Verknüpfung trennen?",
  "Wellpass unlink consequence": "Die lokale Verknüpfung wird entfernt. Zutritt über einen Wellpass-Vertrag oder ein Wellpass-Wertekonto ist dann gesperrt. Das EGYM-Konto und die Wellpass-Mitgliedschaft bleiben bestehen.",
  "Studio connection": "Studioverbindung",
  "Wellpass TAN": "Wellpass-TAN",
  "Wellpass TAN source": "Die neunstellige TAN erhält das Mitglied in der Wellpass-App oder im Wellpass-Konto.",
  "Wellpass TAN format": "Bitte eine neunstellige TAN eingeben.",
  "Wellpass setup required": "Zuerst eine aktive EGYM-Wellpass-Verbindung für das Studio unter Schnittstellen einrichten.",
  "Wellpass connection verified": "Der API-Zugang wurde bestätigt. Die Zutrittsberechtigung einer Person wird erst beim Zutritt geprüft.",
  "E_AggregatorWellpassProfileRequired": "Für die Wellpass-Verknüpfung müssen Vorname, Nachname, E-Mail-Adresse und Geschlecht in der Personenakte hinterlegt sein.",
  "E_AggregatorWellpassTanInvalid": "Bitte eine gültige neunstellige Wellpass-TAN verwenden.",
  "E_AggregatorWellpassExpired": "Die Wellpass-Mitgliedschaft ist abgelaufen.",
  "E_AggregatorWellpassNotStarted": "Die Wellpass-Mitgliedschaft hat noch nicht begonnen.",
  "E_AggregatorWellpassStudioNotInNetwork": "Dieses Studio ist für die Wellpass-Schnittstelle nicht als Partner freigeschaltet. Bitte die Freischaltung mit EGYM klären.",
  "E_AggregatorWellpassPlus1Denied": "Die Wellpass-Plus1-Mitgliedschaft berechtigt nicht zum Zutritt in diesem Studio.",
  "E_AggregatorWellpassAppCheckInRequired": "Bitte zuerst in der Wellpass-App einchecken und anschließend das Zutrittsmedium erneut verwenden.",
  "E_AggregatorWellpassLinkConflict": "EGYM meldet einen Kontokonflikt. Bitte bestehende Konten und die TAN mit EGYM klären, bevor die Person erneut verknüpft wird.",
  "E_AggregatorWellpassAccountNotFound": "EGYM konnte das Konto oder die TAN für dieses Studio nicht finden. Bitte die Verknüpfung mit einer aktuellen TAN prüfen.",
  "E_AggregatorWellpassRequestInvalid": "EGYM hat die übermittelten Daten abgelehnt. Bitte Personendaten und TAN prüfen.",
  "E_AggregatorWellpassFirstAdmission": "Zutritt bestätigt: erster Wellpass-Besuch in diesem Studio. Bitte die Einweisung durchführen.",
  "E_AggregatorWellpassEnvironmentConflict": "Alle Wellpass-Verbindungen müssen dieselbe Umgebung verwenden. Vor einem Umgebungswechsel die bestehenden Personenverknüpfungen trennen.",
  "One aggregator confirmation is sufficient": "Eine bestätigte Alternative genügt.",
  "Aggregator options unavailable": "Aggregator-Schnittstellen konnten nicht geladen werden.",
  "Aggregator identities unavailable": "Aggregator-Kennungen konnten nicht geladen werden.",
  "USC customer ID": "USC-Customer-ID",
  "USC location ID": "USC-Standort-ID",
  "Invalid USC location ID": "Die USC-Standort-ID muss eine gültige UUID sein.",
  "E_AggregatorNotConfigured": "Die Aggregator-Verbindung für diesen Standort ist nicht eingerichtet.",
  "E_AggregatorUnavailable": "Die Aggregator-Prüfung ist derzeit nicht erreichbar.",
  "E_AggregatorCheckInRequired": "Kein gültiger Aggregator-Check-in für diese Nutzung bestätigt.",
  "E_AggregatorIdentityRequired": "Die Aggregator-Kennung der Person fehlt.",
  "E_AggregatorAssignmentInvalid": "Die Aggregator-Zuweisung oder Standortkonfiguration ist ungültig.",
  "E_AggregatorIdentityConflict": "Diese Aggregator-Kennung gehört bereits zu einer anderen Person.",
  "E_EntityAlreadyUsed": "Dieser Eintrag wird noch verwendet. Setze ihn stattdessen inaktiv; bestehende Zuordnungen und historische Daten bleiben erhalten.",
  "E_AccountLastActiveAdministrator": "Der letzte aktive Firmenadministrator kann nicht inaktiv gesetzt werden.",
  "Only unused users can be deleted. Deactivate users who have already been used.": "Nur unbenutzte Benutzer können gelöscht werden. Setze bereits genutzte Benutzer stattdessen inaktiv.",
  "Deactivate user?": "Benutzer inaktiv setzen?",
  "Deactivating this user revokes all sessions, app access and access media. Historical data and assignments are retained.": "Alle Sitzungen werden widerrufen, der App-Zugang wird gesperrt und Zutrittsmedien werden deaktiviert. Historische Daten und Zuordnungen bleiben erhalten.",
  "Please reassign remaining appointments, shifts, default shifts and assigned contacts.": "Bitte verteile verbleibende Termine, Schichten, Standardschichten und zugewiesene Kontakte neu.",
  "Shifts": "Schichten",
  "Default shifts": "Standardschichten",
  "Assigned contacts": "zugewiesene Kontakte",
  "Cancellable amount": "stornierbar",
  "Cancellation allocation": "Stornoanteil",
  "Contribution cancellation reasons": "Stornogründe",
  "Contribution cancellation reason": "Stornogrund",
  "Reasons for contribution cancellations": "Gründe für das Stornieren von Beiträgen und offenen Posten",
  "New contribution cancellation reason": "neuer Stornogrund",
  "Edit contribution cancellation reason": "Stornogrund bearbeiten",
  "Contribution cancellation reason created": "Stornogrund angelegt",
  "Contribution cancellation reason updated": "Stornogrund aktualisiert",
  "Contribution cancellation reason deleted": "Stornogrund gelöscht",
  "Cancellation explanation": "Erläuterung (optional)",
  "No contribution cancellation reasons available": "Keine aktiven Stornogründe vorhanden.",
  "Manage contribution cancellation reasons": "Stornogründe verwalten",
  "Contribution cancellation reasons permission help": "Erlaubt das Anzeigen oder Bearbeiten der Stornogründe für Beiträge und offene Posten.",
  "E_76cbcc883743aa05": "Wählen Sie einen aktiven Stornogrund für den Beitrag aus.",
  "E_76cbcc883743aa06": "Dieser Grund wurde bereits verwendet. Sie können ihn deaktivieren, aber nicht löschen.",
  "E_76cbcc883743aa07": "Die Bezeichnung des Grundes muss 1 bis 200 Zeichen lang sein.",
  "E_76cbcc883743aa08": "Der gewählte Zahlungsstornogrund ist nicht mehr verfügbar. Wählen Sie einen aktiven Grund aus.",
  "openItems.cancel.amount": "Stornobetrag",
  "openItems.cancel.cancelledAmount": "Bisheriger Stornobetrag",
  "openItems.cancel.partial": "teilweise storniert",
  "openItems.cancel.none": "Keine stornierbaren Beiträge vorhanden.",
  "openItems.cancel.history": "Beitrag storniert",
  "E_76cbcc883743aa01": "Dieser Beitrag kann nicht storniert werden. Prüfe vorhandene Stornos, Lastschriftläufe, Inkasso und den Verkaufsstorno bei Artikeln.",
  "E_76cbcc883743aa02": "Der Stornobetrag muss mindestens 0,01 betragen und darf den verbleibenden Beitrag nach bisherigen Stornos nicht überschreiten.",
  "E_76cbcc883743aa03": "Die Erläuterung darf höchstens 500 Zeichen lang sein.",
  "E_76cbcc883743aa04": "Eine Stornoverrechnung kann nicht als Zahlung zurückgenommen werden. Die Belegkorrektur bleibt nachvollziehbar erhalten.",

  ...sharedInvoiceDesignDe,
  ...sharedPeriodSelectorDe,
  ...sharedAdminDe,
  ...sharedProviderAccessDe,
  ...sharedOfferedModelsDe,
  ...sharedProviderPricingDe,
  ...sharedAgentModelSelectionDe,
  "Export appearance": "Erscheinungsbild exportieren",
  "Import appearance": "Erscheinungsbild importieren",
  "Appearance exported successfully": "Erscheinungsbild erfolgreich exportiert.",
  "Appearance imported successfully": "Erscheinungsbild erfolgreich importiert.",
  "Invalid appearance file format": "Ungültiges Dateiformat für Erscheinungsbild.",
  "Could not read appearance file": "Erscheinungsbild-Datei konnte nicht gelesen werden.",
  "Alignment": "Ausrichtung",
  "Formatting": "Formatierung",
  "Reset block to standard": "Baustein auf Standard zurücksetzen",
  "Reset to standard": "Auf Standard zurücksetzen",
  "Reset block formatting confirmation": "Möchtest du alle Formatierungen dieses Bausteins zurücksetzen? Der Baustein erbt dann wieder die zentralen Einstellungen des Formats.",
  "Line color": "Linienfarbe",
  "Line thickness": "Linienstärke",
  "Width": "Breite",
  "Block anchor": "Verankerung",
  "Block anchor tooltip": "Im Textfluss steht der Baustein hinter seinem Vorgänger und wandert mit dem Text. Am Blattfuß steht er unmittelbar über der Fußzeile — unabhängig davon, wo der Text endet. Dasselbe geschieht beim Ziehen: an der Fußzeile losgelassen, hängt der Baustein dort.",
  "In the text flow": "im Textfluss",
  "At the page footer": "am Blattfuß",
  "Backup & transfer": "Sicherung & Übertragung",

  "Agent assignments": "Agenten",
  "Agent assignments are fixed": "Jede Zeile ist eine Stelle, an der m1member ein Modell aufruft. Neue Modellprofile werden im Tab Modellprofile angelegt.",
  "No model available for this profile": "kein passendes Modellprofil vorhanden",
  "No matching model in catalog": "Für diesen Zweck ist kein aktives Modellprofil vorhanden. Bitte im Tab Modellprofile ein passendes Profil anlegen oder aktivieren.",
  "Used by model profile": "von einem Modellprofil verwendet",
  "Model not in catalog": "Modell steht nicht im Katalog",
  "OfferedModelUnknown": "Das ausgewählte Modellprofil steht nicht mehr im Modellkatalog. Bitte die Liste neu laden und erneut auswählen.",
  "OfferedModelInUse": "Das Modellprofil wird noch von mindestens einem Agenten verwendet und kann nicht deaktiviert oder gelöscht werden.",
  "No price available": "kein Preis hinterlegt",
  "All tenants": "alle Mandanten",
  "Provider costs platform admin only": "Diese Auswertung ist nur für Plattformadministratoren sichtbar.",
  "Delete model": "Modell entfernen",
  "Refresh model list": "Modellliste neu laden",
  "Select or enter model name": "Modell wählen oder Namen eingeben",
  "Model name required": "Der Modellname wird benötigt.",
  "Use custom model": "eigenes Modell verwenden: {model}",

  // Qeddy help assistant
  "Qeddy": "Qeddy",
  "Qeddy help": "Qeddy-Hilfe",
  "Open Qeddy": "Qeddy öffnen",
  "Qeddy unavailable": "Qeddy ist gerade nicht verfügbar",
  "Qeddy credit exhausted": "Der KI-Dienst ist gerade nicht verfügbar",
  "Qeddy intro": "Qeddy hilft dir bei der Bedienung von m1member. Qeddy sieht keine Mitglieds- oder Studiodaten und führt keine Änderungen aus.",
  "Qeddy AI notice": "",
  "Qeddy input placeholder": "Was möchtest du in m1member erledigen?",
  "Qeddy empty": "Stelle eine Frage zur Bedienung von m1member.",
  "Qeddy thinking": "Qeddy denkt nach",
  "Qeddy compacting": "Qeddy fasst den bisherigen Gesprächskontext zusammen",
  "Qeddy conversation compacted": "Der bisherige Gesprächskontext wurde zusammengefasst.",
  "Qeddy new conversation": "neues Gespräch",
  "Qeddy conversation expired": "Nach längerer Inaktivität wurde ein neues Gespräch begonnen.",
  "Qeddy open page": "Seite öffnen",
  "Qeddy related pages": "passende Seiten",
  "Qeddy helpful": "hilfreich",
  "Qeddy not helpful": "nicht hilfreich",
  "Qeddy feedback thanks": "Danke für deine Rückmeldung.",
  "Qeddy feedback not answered": "Frage nicht beantwortet",
  "Qeddy feedback unclear": "Antwort unklar",
  "Qeddy feedback outdated": "Hilfe veraltet",
  "Qeddy feedback steps incorrect": "Schritte stimmen nicht",
  "Qeddy feedback failed": "Die Rückmeldung konnte nicht gespeichert werden.",
  "Qeddy suggestions": "Passend zu dieser Seite",
  "Qeddy metrics 30 days": "Qeddy-Nutzung der letzten 30 Tage",
  "Qeddy metric answers": "Antworten",
  "Qeddy metric clarifications": "Rückfragen",
  "Qeddy metric suggestions": "Vorschläge",
  "Qeddy metric not answerable": "nicht beantwortbar",
  "Qeddy metric operational errors": "technische Fehler",
  "Qeddy metric helpful": "hilfreich",
  "Qeddy metric not helpful": "nicht hilfreich",
  "Qeddy metric support handoffs": "Supportübergänge",
  "Qeddy metric active tenants": "aktive Mandanten",
  "Qeddy metric average duration": "mittlere Dauer",
  "Qeddy metric average model stages": "mittlere Modellstufen",
  "Qeddy model profiles": "Qeddy-Modellprofile",
  "Qeddy model profile": "Qeddy-Modellprofil",
  "Qeddy answer model": "Qeddy Antwortmodell",
  "Qeddy documentation model": "Qeddy Dokumentationsmodell",
  "Qeddy search model": "Qeddy Suchmodell",
  "Answer generation": "Antwortgenerierung",
  "Help search and indexing": "Hilfen finden und Index aufbauen",
  "AI providers settings card description": "KI-Anbieterzugänge und Modellprofile für Qeddy verwalten",
  "Use": "Verwendung",
  "All languages": "alle Sprachen",
  "Agent model profiles": "Agenten-Modellprofile",
  "Agent model profile": "Agenten-Modellprofil",
  "Member email intake model": "Modell für den Mitglieder-Posteingang",
  "Email intake classification": "E-Mail-Eingang analysieren und klassifizieren",
  "Relevant": "relevant",
  "Irrelevant": "nicht relevant",
  "Uncertain": "unklar",
  "Review required": "Prüfung erforderlich",
  "Processing status": "Verarbeitungsstatus",
  "Relevance": "Relevanz",
  "Request type": "Anliegen",
  "(no subject)": "(kein Betreff)",
  "Confidence": "Konfidenz",
  "Not assigned": "nicht zugeordnet",
  "Search sender, subject, content, person or contract": "Absender, Betreff, Inhalt, Person oder Vertrag suchen",
  "All relevance levels": "alle Relevanzen",
  "All processing statuses": "alle Verarbeitungsstatus",
  "Mailbox": "Postfach",
  "Manually corrected": "manuell korrigiert",
  "Not manually corrected": "nicht manuell korrigiert",
  "Correction status": "Korrekturstatus",
  "Attachments": "Anhänge",
  "With attachments": "mit Anhängen",
  "Without attachments": "ohne Anhänge",
  "Processing failed": "Verarbeitung fehlgeschlagen",
  "Original message": "Originalnachricht",
  "No attachments": "keine Anhänge",
  "AI classification": "KI-Klassifizierung",
  "Original relevance": "ursprüngliche Relevanz",
  "Original request type": "ursprüngliches Anliegen",
  "Evidence": "Fundstellen",
  "Cancellation comparison": "Kündigungsvergleich",
  "Cancellation received": "Kündigungseingang",
  "Requested cancellation date": "Kündigung zum",
  "Calculated cancellation date": "realistischer Kündigungstermin",
  "Rest period details": "Ruhezeitangaben",
  "Detected candidates": "erkannte Kandidaten",
  "Correct classification": "Klassifizierung korrigieren",
  "Save correction": "Korrektur speichern",
  "Save result": "Ergebnis speichern",
  "Decision basis": "Entscheidungsgrundlagen",
  "Core requests": "Kernanliegen",
  "Extracted information": "erkannte Angaben",
  "Open points": "offene Punkte",
  "Current message": "aktuelle Nachricht",
  "Sender": "Absender",
  "Directly available": "direkt vorhanden",
  "Name in the message": "Name im Schreiben",
  "Matched uniquely": "eindeutig zugeordnet",
  "Not assigned automatically": "nicht automatisch zugeordnet",
  "Explicitly stated": "ausdrücklich genannt",
  "The person was matched uniquely.": "Die Person wurde eindeutig zugeordnet.",
  "The assignment is ambiguous and needs review.": "Die Zuordnung ist mehrdeutig und muss geprüft werden.",
  "Classification assignment": "Zuordnung",
  "Contract candidates": "Vertragskandidaten",
  "No textual evidence was extracted.": "Es wurden keine Textstellen extrahiert.",
  "AI confidence": "KI-Sicherheit",
  "Assessment confidence": "Sicherheit der Einschätzung",
  "Not assessed": "nicht bewertet",
  "No business request recognized": "kein fachliches Anliegen erkannt",
  "No core request identified": "kein Kernanliegen erkannt",
  "Not analyzed": "noch nicht analysiert",
  "Quoted history": "zitierter Verlauf",
  "Appointment change": "Terminänderung",
  "Appointment cancellation": "Terminabsage",
  "Appointment reschedule": "Terminverschiebung",
  "Other service request": "sonstiges Anliegen",
  "Appointment candidates": "Terminkandidaten",
  "No matching appointment was found.": "Es wurde kein passender Termin gefunden.",
  "uniquely matched": "eindeutig zugeordnet",
  "Reschedule": "Verschiebung",
  "Unclear": "unklar",
  "Person reference in the message": "Personenbezug laut Schreiben",
  "Without an assigned person there are no contract candidates.":
    "Ohne zugeordnete Person gibt es keine Vertragskandidaten.",
  "Assessment": "Bewertung",
  "No contracts found": "keine Verträge gefunden",
  "Contract is active": "Vertrag ist aktiv",
  "Contract already ended or cancelled": "Vertrag ist bereits beendet oder gekündigt",
  "Rest periods are allowed": "Ruhezeiten sind erlaubt",
  "Rest periods are not allowed": "Ruhezeiten sind nicht erlaubt",
  "Fixed-term contract": "Vertrag hat eine Laufzeit",
  "No fixed term": "Vertrag hat keine Laufzeit",
  "Requested date matches contract end": "Gewünschter Termin entspricht dem Vertragsende",
  "Requested date is near contract end": "Gewünschter Termin liegt nahe am Vertragsende",
  "Requested date is close to contract end": "Gewünschter Termin liegt in der Nähe des Vertragsendes",
  "Suggested from previous assignments": "Vorschlag aus bisherigen Zuordnungen",
  "Text extracted": "Text extrahiert",
  "Unsupported attachment": "Anhang nicht unterstützt",
  "Extraction failed": "Textextraktion fehlgeschlagen",
  "Review inbox classifications": "Posteingangs-Klassifizierungen prüfen",
  "Review inbox classifications permission help": "KI-Klassifizierungen eingegangener E-Mails prüfen und manuell korrigieren.",
  "Qeddy help admin card description": "Hilfedokumente, Review und RAG-Index verwalten",
  "Qeddy source language": "Quellsprache",
  "Qeddy canonical index": "kanonischer Qeddy-Index",
  "Qeddy pending reviews title": "Freigaben ausstehend",
  "Qeddy pending updates description": "Qeddy verwendet weiterhin die zuletzt freigegebenen Hilfen. Neue oder überarbeitete Fassungen werden erst nach ihrer Freigabe verwendet.",
  "Qeddy initial review required description": "Es ist noch kein freigegebener Hilfestand vorhanden. Prüfe die Hilfedokumente und gib sie frei, damit Qeddy sie verwenden kann.",
  "Qeddy reindex finished": "Qeddy-Index wurde aktualisiert",
  "Qeddy reindex failed": "Qeddy-Reindex fehlgeschlagen: {0}",
  "Qeddy reindex produced no index": "Qeddy-Reindex wurde ausgeführt, hat aber keinen aktiven Index erzeugt.",
  "Qeddy reindex started": "Qeddy-Reindex wurde gestartet",
  "Qeddy reindex queued": "Qeddy-Reindex wartet auf Start",
  "Qeddy reindex cancelled": "Qeddy-Reindex wurde abgebrochen",
  "Qeddy reindex required after review": "Die Freigabe ist erst nach dem Neuindizieren für Qeddy verfügbar.",
  "Qeddy reindex required title": "Neuindizierung erforderlich",
  "Qeddy reindex required description": "Es wurden Hilfen freigegeben oder geändert, die im aktiven Qeddy-Index noch nicht enthalten sind. Starte die Neuindizierung, damit Qeddy diesen Stand nutzt.",
  "Qeddy reindex job title": "Qeddy-Hilfe neu indexieren",
  "qeddyReindex.job.queued": "Qeddy-Reindex wartet auf Start",
  "qeddyReindex.job.readDocuments": "Hilfedokumente werden gelesen",
  "qeddyReindex.job.syncDocuments": "Hilfedokumente werden abgeglichen",
  "qeddyReindex.job.checkReviews": "Freigaben werden geprüft",
  "qeddyReindex.job.noReviewedDocuments": "keine freigegebenen Hilfedokumente gefunden",
  "qeddyReindex.job.resolveModel": "Embedding-Modell wird vorbereitet",
  "qeddyReindex.job.createEmbeddings": "Suchabschnitte werden indiziert",
  "qeddyReindex.job.saveIndex": "Qeddy-Index wird gespeichert",
  "qeddyReindex.job.done": "Qeddy-Index ist fertig",
  "qeddyReindex.job.failed": "Qeddy-Reindex ist fehlgeschlagen",
  "Qeddy documents reviewed": "Qeddy-Hilfen wurden freigegeben",
  "Qeddy review all": "alle aktuellen Hilfen freigeben",
  "Qeddy review all disabled hint": "Es sind keine aktuellen Hilfen geladen, die freigegeben werden können.",
  "Qeddy review all no changes hint": "Es gibt keine neuen, veralteten oder geänderten Hilfen zum Freigeben.",
  "Qeddy review all confirm title": "Aktuelle Hilfen freigeben?",
  "Qeddy review all confirm text": "Es werden {0} aktuell geladene Hilfedokumente freigegeben. Prüfe die Dokumente vorher in der Liste oder Vorschau.",
  "Qeddy current help documents": "aktuelle Hilfen",
  "Qeddy reviewed help documents": "geprüfte Hilfen",
  "Qeddy draft help documents": "Entwürfe",
  "Qeddy stale help documents": "veraltete Hilfen",
  "Qeddy reindex requires reviewed documents": "Zum Neuindizieren muss mindestens eine Hilfe geprüft sein.",
  "Qeddy review status draft": "Entwurf",
  "Qeddy review status stale": "veraltet",
  "Qeddy review status reviewed": "geprüft",
  "Feature generated cancellation confirmation": "Kündigungsbestätigung systemgeneriert",
  "Feature qeddy help": "Qeddy-Hilfe",
  "Feature flags": "Feature-Flags",
  "Index status": "Indexstatus",
  "Menu path": "Menüpfad",
  "Review status": "Prüfstatus",
  "Chunks": "Abschnitte",
  "Last reindex": "letzter Reindex",
  "Last status": "letzter Status",
  "Last reviewed": "zuletzt geprüft",
  "Source review status": "Quell-Prüfstatus",
  "Source hash": "Quell-Hash",
  "Reviewed source hash": "freigegebener Quell-Hash",
  "Source changes": "Quelländerungen",
  "Changed": "geändert",
  "Unchanged": "unverändert",
  "Source file": "Quelldatei",
  "Markdown preview": "Markdown-Vorschau",
  "Enabled providers": "aktive Provider",
  "Reindex": "neu indexieren",
  "Not ready": "nicht bereit",
  "Outdated": "veraltet",
  "Never": "nie",
  "Ready": "bereit",
  "Ask": "fragen",
  "Review": "prüfen",

  // Auswertungen: eigene Listen
  "Custom lists": "Eigene Listen",
  "Custom recipient list": "eigene Empfängerliste",
  "Build reusable target tables from approved data bases": "wiederverwendbare Zieltabellen aus freigegebenen Datenbasen erstellen",
  "New list": "neue Liste",
  "Delete list": "Liste löschen",
  "Really delete list?": "Liste wirklich löschen?",
  "Fields": "Felder",
  "Search fields": "Felder suchen",
  "No fields found": "keine Felder gefunden",
  "Field already selected": "Feld bereits ausgewählt",
  "Target table": "Zieltabelle",
  "Drag fields here": "Felder hierher ziehen",
  "Drag fields into the table": "Felder in die Tabelle ziehen",
  "Move column": "Spalte verschieben",
  "Column name": "Spaltenname",
  "Rename column": "Spalte umbenennen",
  "Clear filter": "Filter entfernen",
  "contains": "enthält",
  "equals": "ist gleich",
  "greater than or equal": "größer oder gleich",
  "less than or equal": "kleiner oder gleich",
  "after": "nach",
  "before": "vor",
  "is empty": "ist leer",
  "is not empty": "ist nicht leer",
  "Date and time": "Datum und Uhrzeit",
  "Yes/No": "Ja/Nein",
  "Load preview": "Vorschau laden",
  "Preview is outdated": "Vorschau ist veraltet",
  "Preview row limit reached": "Vorschau zeigt maximal {0} Zeilen",
  "Load preview to show real data": "Vorschau laden, um echte Daten anzuzeigen",
  "Fields cannot be combined in this list": "Diese Felder können in dieser Liste nicht gemeinsam ausgewertet werden: {0}",
  "Field cannot be linked to the current list": "Dieses Feld kann mit der aktuellen Liste nicht verknüpft werden: {0}",
  "List settings": "Listeneinstellungen",
  "Data basis": "Datenbasis",
  "Source table": "Quelltabelle",
  "Start template": "Startvorlage",
  "Visibility": "Sichtbarkeit",
  "List name placeholder": "z. B. offene Posten für Mahnung",
  "Person type": "Personentyp",
  "Form of address": "Anredeform",
  "WhatsApp status": "WhatsApp-Status",
  "SEPA direct debit blocked until": "SEPA-Lastschrift gesperrt bis",
  "Manual check-in blocked": "manueller Check-in gesperrt",
  "Mobile phone": "Mobilnummer",
  "Contract value": "Vertragswert",
  "Open amount": "offen",
  "Total open": "gesamt offen",
  "Total overdue": "überfällig offen",
  "Open item count": "Anzahl offene Posten",
  "Oldest due date": "älteste Fälligkeit",
  "Primary contract": "Hauptvertrag",
  "Original contract end": "ursprüngliches Vertragsende",
  "Access scope": "Zugangsbereich",
  "Requires no arrears": "Zugang nur ohne Rückstand",
  "Allows access": "Zugang erlaubt",
  "Manual override": "manuelle Änderung",
  "Externally managed until": "extern verwaltet bis",
  "Period start": "Periodenbeginn",
  "Period end": "Periodenende",
  "Document number": "Belegnummer",
  "Submitted to SEPA at": "an SEPA übergeben am",
  "Booked at": "gebucht am",
  "Check-in time": "Check-in-Zeit",
  "Reader endpoint": "Leser-Endpunkt",
  "Reader endpoint identifier": "Leser-Endpunktkennung",
  "Last check-in": "letzter Check-in",
  "Days since last check-in": "Tage seit letztem Check-in",
  "Lead origin": "Lead-Herkunft",
  "Closed at": "geschlossen am",
  "Closed outcome": "Abschlussgrund",
  "Inbound text": "Eingangstext",
  "Assigned employee": "zuständiger Mitarbeiter",
  "Report list purpose recipients": "Empfängerliste",
  "Report list purpose analysis": "Analyse",
  "Report list purpose export": "Export",
  "Report list purpose work list": "Arbeitsliste",
  "Report list visibility private": "privat",
  "Report list visibility tenant": "für alle sichtbar",
  "Report list source persons": "Personen",
  "Report list source persons description": "Personen- und Kontaktdaten",
  "Report list source contracts": "Verträge",
  "Report list source contracts description": "Vertragsdaten mit Person und Studio",
  "Report list source open items": "offene Posten",
  "Report list source open items description": "offene und überfällige Forderungen",
  "Report list source check ins": "Check-ins",
  "Report list source check ins description": "Nutzungsereignisse mit Person, Studio und Gerät",
  "Report list source leads": "Leads",
  "Report list source leads description": "Lead-Daten mit verknüpfter Person",
  "Report list template blank persons": "leere Personenliste",
  "Report list template active members": "aktive Mitglieder",
  "Report list template birthdays": "Geburtstage",
  "Report list template expiring contracts": "auslaufende Verträge",
  "Report list template open items": "offene Posten",
  "Report list template overdue open items": "überfällige Posten",
  "Report list template check ins": "Check-ins",
  "Report list template leads follow up": "Leads zur Nachverfolgung",
  "Report list relationship direct": "direkt verknüpft",
  "Report list relationship via person": "über Person verknüpft",
  "Report list relationship via contract": "über Vertrag verknüpft",
  "Report list relationship via lead person": "über Lead-Person verknüpft",
  "Report list relationship via check ins": "über Check-ins ermittelt",
  "Report list source is not allowed": "Datenbasis ist nicht erlaubt",
  "Report list field is not allowed": "Feld ist für diese Datenbasis nicht erlaubt",
  "Report list filter is not allowed": "Filter ist für diese Datenbasis nicht erlaubt",

  // Mandanten-Sicherungen (tools/backup)
  "Backup details": "Sicherungsdetails",
  "Backup label hint": "optionale Beschreibung — sonst wird Datum und Uhrzeit angezeigt",
  "Backup label placeholder": "z. B. „vor Datenkorrektur Mai 2026“",
  "Backup details saved": "Sicherungsdetails gespeichert",
  "Tenant backup schema version": "Schemaversion",
  "Create new appointment notification": "neue Terminbenachrichtigung erstellen",
  "Create new template": "neue Vorlage erstellen",
  "Edit assigned template": "zugeordnete Vorlage bearbeiten",
  "Assigned template is no longer available": "die ausgewählte Vorlage ist nicht mehr verfügbar",
  "Set up appointment notification": "Terminbenachrichtigung einrichten",
  "Appointment notification setup context": "Für Terminart „{0}“",
  "Appointment notification guided editor hint": "Richten Sie die Benachrichtigung in diesem Editor ein. Erst beim Speichern wird sie mit der Terminart verknüpft.",
  "Appointment notification draft status hint": "Entwürfe bleiben bearbeitbar und werden nicht automatisch versendet.",
  "Appointment reminder template name": "Terminerinnerung – {0}",
  "Appointment confirmation template name": "Terminbestätigung – {0}",
  "Appointment reminder subject": "Ihre Terminerinnerung",
  "Appointment confirmation subject": "Ihre Terminbestätigung",
  "Appointment reminder body draft": "Bitte bearbeiten Sie diesen Entwurf für die Terminerinnerung.",
  "Appointment confirmation body draft": "Bitte bearbeiten Sie diesen Entwurf für die Terminbestätigung.",
  "Appointment reminder text draft": "Bitte bearbeiten Sie diesen Entwurf für die Terminerinnerung.",
  "Appointment confirmation text draft": "Bitte bearbeiten Sie diesen Entwurf für die Terminbestätigung.",
  "Appointment notification email template usage tooltip": "Für Terminbestätigungen und Terminerinnerungen sind nur E-Mail-Vorlagen mit dem Verwendungszweck „Benachrichtigungen“ auswählbar.",
  "No notification email templates available": "keine E-Mail-Vorlagen mit Verwendungszweck „Benachrichtigungen“ vorhanden.",
  "Template required for enabled notification channel": "für jeden aktivierten Benachrichtigungskanal ist eine Vorlage erforderlich.",
  "Usage purpose information": "Information zum Verwendungszweck",
  "Usage purpose contract management description": "Für E-Mails rund um Verträge, Vertragsunterlagen, Kündigungen und den Briefversand.",
  "Usage purpose password sending description": "Für Passwort-, OTP- und Login-E-Mails.",
  "Usage purpose notifications description": "Für Terminbestätigungen, Terminerinnerungen, Automationen und allgemeine Benachrichtigungen.",
  "Usage purpose marketing description": "Für Marketing- und Kampagnen-E-Mails.",
  "Usage purpose system error notifications description": "Für technische Fehlerberichte im Release-Betrieb. Diese Option ist nur im Admin-Kontext relevant.",
  "Usage purpose member inbox description": "Nur Konten mit diesem Verwendungszweck und aktivem IMAP-Eingang werden für den Mitgliederposteingang abgerufen.",

  // Personen-Detail: konsolidierter Dokumente-Tab (Timeline)
  "Documents": "Dokumente",
  "Direction": "Richtung",
  "Attachment": "Anhang",
  "Attachment available": "Anhang vorhanden",
  "Incoming": "Eingang",
  "Outgoing": "Ausgang",
  "Write letter": "Brief schreiben",
  "Open PDF": "PDF öffnen",
  "Open email": "E-Mail öffnen",
  "Tenant capabilities": "Mandantenfunktionen",
  "Manage tenant capabilities": "Module und Schnittstellen je Mandant freigeben",
  "Included in plan": "im Tarif enthalten",
  "Not included in plan": "nicht im Tarif enthalten",
  "like plan": "wie Tarif",
  "on": "an",
  "off": "aus",
  "Base function without plan": "Grundfunktion, ohne Tarif aktiv",
  "No plan booked": "kein Tarif gebucht",
  "Active by default": "standardmäßig aktiv",
  "Inactive by default": "standardmäßig inaktiv",
  "Capability calendar": "Terminkalender",
  "Capability reminders": "Mahnwesen",
  "Capability finance": "Finanzen",
  "Capability communication": "Kommunikation",
  "Capability debt collection": "Inkasso",
  "Capability lead manager": "Lead-Manager",
  "Capability member app": "App",
  "Capability finTS": "FinTS-Bankanbindung",
  "Capability article sales": "Artikelverkauf",
  "Capability reports": "Auswertungen",
  "Capability booking widgets": "Buchungswidgets",
  "Capability contract signing widgets": "Vertragsabschluss-Widgets",
  "Capability import export": "Import/Export",
  "Capability staff scheduling": "Personalplanung",
  "Integration gateway": "Gateway-API",
  "Integration online brief 24": "onlinebrief24.de",
  "Integration lead import": "Lead-Import",
  "Integration m1member": "m1member-Integration",
  "Integration google calendar": "Google-Kalender",
  "Integration meta whatsapp": "WhatsApp (Meta)",
  "Add tenant": "Mandant hinzufügen",
  "Delete tenant confirmation": "Soll dieser Mandant wirklich gelöscht werden?",
  "Dispatch": "Postausgang",
  "Pending approval": "wartet auf Freigabe",
  "Approve dispatch": "Freigabe erteilen",
  "Do you want to approve this dispatch now?": "Diese ausgehende Nachricht jetzt freigeben?",
  "Dispatch cancelled": "aus dem Postausgang entfernt",
  "Cancel dispatch": "aus Postausgang entfernen",
  "Do you want to cancel this dispatch?": "Diese ausgehende Nachricht wirklich abbrechen?",
  "Retry scheduled": "erneut versucht",
  "Dispatch & approvals": "Postausgang & Freigaben",
  "Configure which dispatches require approval before they are sent.": "Legen Sie fest, welche ausgehenden Nachrichten vor dem Absenden freigegeben werden müssen.",
  "Communication test mode": "Kommunikations-Testmodus",
  "Communication test mode is active.": "Der Kommunikations-Testmodus ist aktiv.",
  "Default requires approval": "Standard: Freigabe erforderlich",
  "Allow editing while pending approval": "Bearbeitung während Freigabe möglich",
  "Approval rules (JSON)": "Freigabe-Regeln (JSON)",
  "Rules override the default. Highest priority wins.": "Regeln überschreiben den Standard. Höchste Priorität gewinnt.",
  "Selected channels are sent to this address. Leave empty to suppress external delivery.": "Die ausgewählten Kanäle werden an diese Adresse gesendet. Leer lassen, um externe Zustellung zu unterdrücken.",
  "Test email address": "Test-E-Mail-Adresse",
  "If the test email address is empty, selected channels are completed without external delivery.": "Wenn die Test-E-Mail-Adresse leer ist, werden ausgewählte Kanäle ohne externe Zustellung abgeschlossen.",
  "When the communication test mode is active, selected channels are redirected to the test email address or suppressed when no test email address is set.": "Wenn der Kommunikations-Testmodus aktiv ist, werden ausgewählte Kanäle an die Test-E-Mail-Adresse umgeleitet oder unterdrückt, wenn keine Test-E-Mail-Adresse gesetzt ist.",
  "Approval rules for dispatch and central approvals": "Freigabe-Regeln für Postausgang und zentrale Freigaben",
  "Open dispatch queue": "Postausgang öffnen",
  "No data": "keine Daten",
  "Bulk dispatch created: {0} created, {1} pending approval, {2} queued, {3} skipped": "Postausgang: {0} erstellt, {1} warten auf Freigabe, {2} in Warteschlange, {3} übersprungen",
  "Articles": "Artikel",
  "Article sales": "Artikelverkauf",
  "View article sales": "Artikelverkäufe ansehen",
  "Cash registers": "Kassen",
  "Cash register": "Kasse",
  "Cash register saved": "Kasse gespeichert",
  "Configure default cash registers for cash payments": "Standardkassen für Barzahlungen konfigurieren",
  "e.g. Main cash register": "z. B. Hauptkasse",
  "e.g. KASSE-1": "z. B. KASSE-1",
  "CashRegisterDefaultMissing": "Für Barzahlungen ist keine aktive Standardkasse für das Studio konfiguriert.",
  "CashRegisterStudioRequired": "Für die Barzahlung konnte kein Studio ermittelt werden.",
  "Record article sales": "Artikelverkauf erfassen",
  "View articles": "Artikel ansehen",
  "Edit articles": "Artikel bearbeiten",
  "Article": "Artikel",
  "Add article": "Artikel hinzufügen",
  "Edit article": "Artikel bearbeiten",
  "Create contract package template": "Vertragspaket anlegen",
  "Edit contract package template": "Vertragspaket bearbeiten",
  "Duplicate contract package template": "Vertragspaket duplizieren",
  "Assign multiple articles to a contract package template (quantity per package closing).": "mehrere Artikel dem Vertragspaket zuordnen (Menge pro Paketabschluss).",
  "No articles available (Settings → Articles).": "keine Artikel vorhanden (Einstellungen → Artikel).",
  "ArticleStudioScopeMismatch": "Dieser Artikel ist für das gewählte Verkaufs-Studio nicht freigegeben.",
  "ArticleCannotDeleteInUse": "Der Artikel kann nicht gelöscht werden, weil er noch in Verkäufen vorkommt oder einer Vertragspaket-Vorlage zugeordnet ist.",
  "Article master data for article sales": "Artikelstamm für Artikelverkäufe",
  "SKU": "SKU",
  "Accounting account": "Buchhaltungskonto",
  "Accounting exports": "Buchführungsexporte",
  "Accounting exports card description": "Buchungen, offene Posten und DATEV-orientierte Dateien exportieren.",
  "Accounting export billing period": "Abrechnungszeitraum",
  "Download tax advisor package": "Exportpaket herunterladen",
  "Export period": "Zeitraum",
  "Please select an export period.": "Bitte Zeitraum auswählen.",
  "Selected period": "gewählter Zeitraum",
  "Studio scope": "Studio-Auswahl",
  "Tax advisor export": "Steuerberater-Export",
  "Tax advisor export description": "Exportpaket für Buchführung und Steuerberater mit Buchungen, offenen Posten und Zusammenfassung.",
  "Tax advisor export downloaded.": "Steuerberater-Export heruntergeladen.",
  "Sell articles": "Artikel verkaufen",
  "Create an article sale for a person": "Artikelverkauf für eine Person anlegen",
  "Please select a person.": "Bitte Person auswählen.",
  "Person search min chars hint": "Bitte mindestens zwei Zeichen eingeben.",
  "Please add at least one article.": "Bitte mindestens einen Artikel hinzufügen.",
  "Please select a payment method.": "Bitte Zahlungsart auswählen.",
  "Gross": "Brutto",
  "Sales count": "Anzahl Verkäufe",
  "Visits suffix": "Besuche",
  "Total gross (article sales)": "Summe brutto (Artikelverkäufe)",
  "Article sales report": "Artikelverkäufe",
  "Article sales report description": "Artikelverkäufe nach Verkaufszeitraum: brutto, netto, MwSt. und Anzahl.",
  "Sale date": "Verkaufsdatum",
  "Generate receipt number": "Belegnummer vergeben",
  "Register immediate payment": "Sofortzahlung verbuchen",
  "New article sale": "neuer Verkauf",
  "Article sales history": "letzte Verkäufe",
  "Article sale status open": "offen",
  "Article sale status paid": "bezahlt",
  "Article sale status cancelled": "storniert",
  "German / EU": "Deutsch / EU",
  "English (UK)": "Englisch (UK)",
  "English (US)": "Englisch (US)",
  "European": "europäisch",
  "English/US": "Englisch/US",
  "Level must be >= 1": "Level muss >= 1 sein",
  "Days after due date must be >= 0": "Tage nach Fälligkeit müssen >= 0 sein",
  "Studio app preview for March 2025": "für März 2025",
  "Direct debit": "Lastschrift",
  "Bank transfer": "Überweisung",
  "Debt collection": "Inkasso",
  "Editor unavailable": "Editor nicht verfügbar",
  "rows skipped": "Zeilen übersprungen",
  "available": "verfügbar",
  "not available": "nicht verfügbar",
  "no value": "keine Angabe",
  "No matching email template for this studio configured": "Keine passende E-Mail-Vorlage für dieses Studio konfiguriert. Bitte in den E-Mail-Einstellungen unter Vorlagen konfigurieren.",
  "Email template validation failed": "Fehler bei der Validierung",
  "No linked login account": "kein Login-Account verknüpft",
  "Regenerate password confirmation": "Passwort wirklich neu erstellen? Das alte Passwort ist danach ungültig.",
  "Response is not JSON": "Antwort ist kein JSON",
  "Response body is empty": "Antworttext ist leer. Möglicherweise wurde der Endpunkt nicht gefunden.",
  "Full request URL": "vollständige Anfrage-URL",
  "Could not queue command": "Befehl konnte nicht in die Warteschlange eingereiht werden",
  "Gateway test started": "Test gestartet: Device-ID: {0}, QR-ID: {1}",
  "Gateway base URL log": "Gateway Base URL: {0}",
  "Gateway full URL log": "vollständige Gateway-URL: {0}",
  "Gateway base URL missing": "Gateway Base URL nicht konfiguriert",
  "Gateway settings load failed": "Gateway-Settings konnten nicht geladen werden: {0}",
  "Request body log": "Request Body: {0}",
  "Request URL relative log": "Request-URL (relativ): {0}",
  "Request URL full log": "Request-URL (vollständig): {0}",
  "Authorization log": "Authorization: {0}",
  "No token": "kein Token",
  "Raw response status log": "Raw Response Status: {0}",
  "Raw response text log": "Raw Response Text: {0}",
  "Raw response headers log": "Raw Response Headers: {0}",
  "Parsed error response log": "Parsed Error Response: {0}",
  "Gateway URL log": "Gateway URL: {0}",
  "Gateway status code log": "Gateway Status Code: {0}",
  "Gateway status text log": "Gateway Status Text: {0}",
  "Gateway response body log": "Gateway Response Body: {0}",
  "Gateway response headers log": "Gateway Response Headers: {0}",
  "Response status log": "Response Status: {0}",
  "Response body log": "Response Body: {0}",
  "Request ID log": "Request-ID: {0}",
  "Unexpected request error log": "unerwarteter Fehler beim Request: {0}",
  "Gateway ping test started": "Ping-Test gestartet...",
  "Ping success log": "Ping erfolgreich! Server-Zeit: {0}",
  "Ping failed log": "Ping fehlgeschlagen: {0}",
  "Starting status polling": "Status-Polling wird gestartet",
  "Waiting for device": "warte auf Gerät",
  "Command not found yet, waiting": "Befehl noch nicht gefunden, warte …",
  "Tariff: Duration incomplete or invalid.": "Tarif: Laufzeit unvollständig oder ungültig.",
  "Tariff: If no duration is defined, no renewal may be defined.": "Tarif: Wenn keine Laufzeit definiert ist, darf auch keine Verlängerung definiert werden.",
  "Tariff: Renewal incomplete or invalid.": "Tarif: Verlängerung unvollständig oder ungültig.",
  "Tariff: Usage limit incomplete or invalid.": "Tarif: Nutzungslimit unvollständig oder ungültig.",
  "Wallet: Initial value must be >= 0.": "Wertekonto: Startwert muss >= 0 sein.",
  "Wallet: Validity incomplete or invalid.": "Wertekonto: Gültigkeit unvollständig oder ungültig.",
  "Wallet: Usage limit incomplete or invalid.": "Wertekonto: Nutzungslimit unvollständig oder ungültig.",
  "Wallet: For selected studios only, studios must be selected.": "Wertekonto: Bei „nur ausgewählte Studios“ müssen Studios ausgewählt werden.",
  "Weekly contributions count": "{0} Wochenbeiträge",
  "extends contract": "verlängert Vertrag",
  "does not extend contract": "verlängert Vertrag nicht",
  "payment continues": "Beitrag läuft weiter",
  "free until term end": "gratis bis zum Laufzeitende",
  "check-in allowed": "Check-in erlaubt",
  "Delete rest period": "Ruhezeit löschen",
  "delete": "löschen",
  "cancel": "abbrechen",
  "Cancel article sale": "Artikelverkauf stornieren",
  "Confirm article sale void": "Verkauf stornieren",
  "Article sale void action": "stornieren",
  "Article sale void hint": "Der Verkauf bleibt als storniert sichtbar. Der bereits gezahlte Betrag wird als Guthaben verrechnet.",
  "Delete article sale": "Artikelverkauf löschen",
  "Confirm article sale delete": "Verkauf löschen",
  "Article sale delete action": "löschen",
  "Article sale delete hint": "Auf diesen Verkauf wurde nichts gezahlt. Er wird aus den Verkaufslisten entfernt und bleibt nur in der Änderungshistorie nachvollziehbar.",
  "Article sale created": "Artikel verkauft",
  "Article sale cancelled": "Artikelverkauf storniert",
  "Article sale deleted": "Artikelverkauf gelöscht",
  "Article sale sepa group changed": "Lastschriftgruppe geändert",
  "Article sale sepa group hint": "Bestimmt, in welchem Lastschriftlauf die Ware eingezogen wird. Ohne Gruppe bleibt der Beleg außerhalb jedes Laufs.",
  "Edit article sale": "Artikelverkauf",
  "Receipt": "Beleg",
  "Article sales receipt settings": "Artikelverkäufe — Belegnummern",
  "Article sales receipt settings intro": "Legen Sie Präfix und nächste laufende Nummer fest, die bei der automatischen Belegnummer-Vergabe für Artikelverkäufe verwendet werden.",
  "Receipt number prefix": "Beleg-Präfix",
  "Next receipt number": "nächste Nummer",
  "Receipt prefix is required": "Beleg-Präfix ist erforderlich.",
  "Article default account hint": "Das Standard-Buchhaltungskonto für neue Artikel wird in der Buchhaltung gespeichert.",
  "Open accounting settings": "Buchhaltung öffnen",
  "Edit JSON": "JSON bearbeiten",
  "Widget JSON configuration": "Formular-Konfiguration (JSON)",
  "JSON applied": "JSON übernommen.",
  "You can edit the widget configuration as JSON.": "Sie können die Formular-Konfiguration als JSON bearbeiten.",
  "Selected slot not available": "Der gewählte Termin ist nicht mehr verfügbar. Bitte wählen Sie einen anderen Zeitslot.",
  "Default booking widget header text": "Buchen Sie Ihren Termin online",
  "Default booking widget confirmation title": "Vielen Dank für Ihre Buchung!",
  "Default booking widget confirmation message": "Ihr Termin wurde übermittelt. Terminnummer: {{bookingNumber}}",
  "Street / House No.": "Straße / Hausnr.",
  " (Copy)": " (Kopie)",
  " months": " Monate",
  "(all resources)": "(alle Ressourcen)",
  "StaffShiftAccountNotInScope": "Ein Schichtblock gehört zu einem Mitarbeiter außerhalb der gewählten Auswahl.",
  "(all statuses)": "(alle Status)",
  "(all studios for primary account)": "(alle Studios für primären Account)",
  "(all studios)": "(alle Studios)",
  "(all)": "(alle)",
  "(Copy)": "(Kopie)",
  "(default pipeline)": "(Standard-Pipeline)",
  "(different)": "(unterschiedlich)",
  "(locked)": "(gesperrt)",
  "(no default)": "(kein Standard)",
  "(no limit)": "(kein Limit)",
  "(no member)": "(kein Mitglied)",
  "(no name)": "(ohne Namen)",
  "(no name)__alt1": "(ohne Name)",
  "(no title)": "(keine Bezeichnung)",
  "(none)": "(keine)",
  "(none)__alt2": "(keiner)",
  "(none)__alt3": "(keines)",
  "(none)__alt4": "(keins)",
  "(optional)": "",
  "(please select)": "(bitte auswählen)",
  "(Primary account)": "(primärer Account)",
  "(required for primary account)": "(für primären Account erforderlich)",
  "(same as default)": "(wie Mandant)",
  "(system)": "(System)",
  "-": "-",
  "12345": "12345",
  "30-60 Days Inactive": "30-60 Tage inaktiv",
  "31-60 Days": "31-60 Tage",
  "60-90 Days Inactive": "60-90 Tage inaktiv",
  "61-90 Days": "61-90 Tage",
  "90+ Days Inactive": "90+ Tage inaktiv",
  "A configuration for all studios already exists. Please edit it or select at least one studio.": "Es existiert bereits eine Konfiguration für alle Studios. Bitte bearbeiten Sie diese oder wählen Sie mindestens ein Studio.",
  "A higher batch size speeds up sending, but may cause issues with the email provider.": "Eine höhere Batch-Größe beschleunigt den Versand, kann aber zu Problemen mit dem E-Mail-Provider führen.",
  "A lead with this data already exists.": "Ein Kontakt mit diesen Daten existiert bereits.",
  "A SEPA group must be selected when payment method is SEPA.": "Bei Zahlungsmethode SEPA muss eine Lastschriftgruppe ausgewählt sein.",
  "Abbr.": "Kürzel",
  "Abbreviation": "Kürzel",
  "Collection user": "Sammelbenutzer",
  "Allows this account to sign in to the web application.": "Erlaubt diesem Benutzerkonto die Anmeldung an der Webanwendung.",
  "Allows this account to use the m1app.": "Erlaubt diesem Benutzerkonto die Nutzung der m1app.",
  "Lists this account as an employee in staff planning.": "Führt dieses Benutzerkonto in der Personalplanung als Mitarbeiter.",
  "For collection users, an abbreviation is requested to identify the acting person.": "Bei Sammelbenutzern wird zur Zuordnung der handelnden Person ein Kürzel abgefragt.",
  "Abbreviation for confirmation": "Kürzel zur Bestätigung",
  "Abbreviation is invalid or not found": "Kürzel ungültig oder nicht gefunden",
  "Abbreviation is required": "Kürzel ist erforderlich",
  "Abbreviation of the person's home studio (configurable in studio settings)": "Kürzel des Heimatstudios der Person (in Studio-Einstellungen konfigurierbar)",
  "Author": "Autor",
  "Acceptance Required": "Zustimmung erforderlich",
  "Access & Devices": "Zutritt & Geräte",
  "Access & Restrictions": "Zugriff & Einschränkungen",
  "Access block removed": "Zutrittssperre entfernt",
  "App manufacturer": "mQorva",
  "Access blocked": "Zutritt gesperrt",
  "Access blocking": "Zutrittssperre",
  "Access denied": "keine Berechtigung",
  "Access denied__alt2": "Zugriff verweigert",
  "Access media": "Zutrittsmedien",
  "Access media permission help": "Erlaubt das Anzeigen oder Zuweisen, Überschreiben und Entfernen von Zutrittsmedien bei Personen, ohne die Lesegerätekonfiguration zu bearbeiten.",
  "Access medium deleted.": "Zutrittsmedium gelöscht.",
  "Access medium": "Zutrittsmedium",
  "Access medium reassigned.": "Zutrittsmedium überschrieben.",
  "Access medium saved.": "Zutrittsmedium gespeichert.",
  "Access right": "Zutrittsrecht",
  "Access": "Zutritt",
  "Access__alt1": "Zugriff",
  "Account created.": "Konto angelegt.",
  "Account deleted.": "Konto gelöscht.",
  "Account holder": "Kontoinhaber",
  "Account Number": "Kontonummer",
  "Account number is required": "Kontonummer ist erforderlich",
  "Account saved.": "Konto gespeichert.",
  "Accounting": "Buchführung",
  "Accounting Account": "Buchführungskonto",
  "accounts": "Konten",
  "Accounts": "Konten",
  "Accounts & spooler": "Konten & Spooler",
  "Accounts, assignments & cost centers": "Konten, Zuordnungen & Kostenstellen",
  "Actions": "Aktionen",
  "Standort für QR-Zutritt prüfen": "Standort für QR-Zutritt prüfen",
  "ReaderDeviceLocationCheckUnavailable": "Die Standortprüfung kann erst aktiviert werden, wenn die Studio-Adresse erfolgreich aufgelöst wurde.",
  "PersonDateOfBirthInvalid": "Das Geburtsdatum muss ab dem Jahr 1900 liegen und darf nicht in der Zukunft liegen.",
  "Activate tenant": "Mandant aktivieren",
  "Active": "aktiv",
  "Active__aktiv": "aktiv",
  "Inactive__inaktiv": "inaktiv",
  "Active contract": "Vertrag aktiv",
  "Active contract (signed)": "Vertrag aktiv (abgeschlossen)",
  "Active contracts": "aktive Verträge",
  "Active Contracts": "aktive Verträge",
  "Active contracts/wallets": "aktive Verträge/Wertekonten",
  "Active media": "aktive Medien",
  "Active wallets": "aktive Wertekonten",
  "Activity Rate": "Aktivitätsrate",
  "Add": "hinzufügen",
  "add__hinzufügen": "hinzufügen",
  "add_configuration__hinzufügen": "Konfiguration hinzufügen",
  "Add access medium": "Zutrittsmedium hinzufügen",
  "Add note": "Notiz hinzufügen",
  "Add account": "Konto hinzufügen",
  "Add appointment notification": "neue Benachrichtigung",
  "Add bank account": "Bankverbindung anlegen",
  "Add calendar configuration": "neue Kalender-Konfiguration",
  "Add configuration": "Konfiguration hinzufügen",
  "Add contract package": "Vertragspaket hinzufügen",
  "Add contract package…": "Vertragspaket hinzufügen…",
  "Add Custom Holiday": "eigenen Feiertag hinzufügen",
  "Add priceAdjustment": "Preisanpassung hinzufügen",
  "Add price adjustment": "Preisanpassung hinzufügen",
  "Add document": "Dokument hinzufügen",
  "Add email address": "E-Mail-Adresse hinzufügen",
  "Add entry": "Eintrag hinzufügen",
  "Add holiday": "Feiertag anlegen",
  "Add payment": "Zahlung hinzufügen",
  "Add person": "Person hinzufügen",
  "Add phase": "Phase anlegen",
  "Add rest period": "Ruhezeit eintragen",
  "Add rule": "Regel hinzufügen",
  "Add schedule": "Rhythmus hinzufügen",
  "Add Slot": "Slot hinzufügen",
  "Add source": "Quelle hinzufügen",
  "Add studio app configuration": "Studio-App-Konfiguration hinzufügen",
  "Add member app configuration": "Studio-App-Konfiguration hinzufügen",
  "Add transition": "Übergang hinzufügen",
  "Add unavailability": "Abwesenheit anlegen",
  "Add version": "Version hinzufügen",
  "Add wallet": "Wertekonto hinzufügen",
  "Address": "Adresse",
  "Address (formal/informal)": "Ansprache (Sie/Du)",
  "Address is required": "Ansprache ist erforderlich",
  "Addressing": "Ansprache",
  "Addressing (formal/informal)": "Ansprache (Sie/Du)",
  "Addressing is required": "Ansprache ist erforderlich",
  "Adjust amount": "Betrag anpassen",
  "Adjust contributions (calculate proportionally)": "Beiträge anpassen (anteilig berechnen)",
  "Admin": "Admin",
  "Admin deleted": "Admin gelöscht",
  "Admin Settings": "Admin-Einstellungen",
  "Admin settings hub card description": "globale Einstellungen und Systemvorgaben",
  "Import run column created": "erstellt",
  "Import run column status": "Status",
  "Import run column tenant name": "Mandant (Name)",
  "Import run column designation": "Bezeichnung",
  "Import run schema outdated tag": "Schema veraltet",
  "Import run schema outdated tooltip": "Das zugrunde liegende Import-Schema ist hinter dem aktuellen Zielmodell zurück. Bitte das Schema aus der Vorlage aktualisieren, bevor du den Import ausführst.",
  "Import run schema changed title": "Import-Schema wurde in einem anderen Tab geändert",
  "Import run schema changed details": "Der aktuell geladene Schema-Stand ist nicht mehr aktuell. Lade das Schema neu, bevor du speicherst, den Precheck startest oder den Import ausführst, damit keine alten Zuordnungen verwendet oder gespeichert werden.",
  "Import run schema changed reload": "Schema neu laden",
  "Import run schema changed reload success": "Schema wurde neu geladen.",
  "Import run schema changed blocking error": "Das Import-Schema wurde in einem anderen Tab geändert. Bitte Schema neu laden.",
  "Import run edit designation aria": "Bezeichnung ändern",
  "Import run designation saved": "Bezeichnung gespeichert.",
  "Import run status Committed": "abgeschlossen",
  "Import run status Draft": "Entwurf",
  "Import run status Failed": "Validierung fehlgeschlagen",
  "Import run status Ready": "bereit",
  "Import run status RolledBack": "zurückgerollt",
  "Import run status Uploaded": "hochgeladen",
  "Import run status Validating": "wird validiert",
  "Import run confirm delete": "Importvorgang und alle hochgeladenen Dateien wirklich löschen?",
  "Import run create": "neuer Importvorgang",
  "Import run list continue": "fortsetzen",
  "Import run created": "Importvorgang erstellt.",
  "Import run delete error": "Importvorgang konnte nicht gelöscht werden.",
  "Import run deleted": "Importvorgang gelöscht.",
  "Import run drop zip": "ZIP-Datei hier ablegen oder klicken zum Auswählen",
  "Import run select schema": "Schema wählen",
  "Import run select tenant": "Mandant wählen",
  "Import run select zip": "Bitte eine ZIP-Datei auswählen.",
  "Import run select files": "Bitte mindestens eine Datei auswählen.",
  "Import run tenant required": "Mandant ist erforderlich.",
  "Import run upload zip": "ZIP hochladen",
  "Import run upload zip hint": "Eine ZIP-Datei mit CSV-Dateien, Bildern oder anderen Importdaten. Der Inhalt wird unter dem Importvorgang im Objektspeicher gespeichert.",
  "Import run upload data": "Importdaten hochladen",
  "Import run drop data file": "Dateien hier ablegen oder klicken",
  "Import run clear upload data": "alle hochgeladenen Daten löschen",
  "Import run clear upload confirm title": "hochgeladene Daten löschen?",
  "Import run clear upload confirm desc": "Alle Dateien unter dem Upload-Pfad (inkl. Unterordner) werden im Speicher gelöscht. Bezeichnung und Schema bleiben erhalten.",
  "Import run clear upload success": "Alle Daten wurden gelöscht.",
  "Import run clear upload error": "Daten konnten nicht gelöscht werden.",
  "Import run clear upload data hint": "ZIP-Inhalt und Zwischenstände (Validierung, Vorschau) entfernen.",
  "Import run clear upload no data hint": "Es sind noch keine Daten hochgeladen.",
  "Import run upload blocked while clearing": "Bitte warten, bis das Löschen abgeschlossen ist.",
  "Import run recover from storage": "Es wurden vorhandene Daten im Speicher gefunden.",
  "Import run recover from storage title": "vorhandene Upload-Daten erkannt",
  "Import run upload completed in background": "Die Upload-Verbindung wurde unterbrochen, der Server hat die Verarbeitung aber abgeschlossen. Bitte in der Validierung prüfen, ob alle Dateien angekommen sind.",
  "Import run upload completed in background title": "Upload serverseitig abgeschlossen",
  "Import run step upload": "hochladen",
  "Import run step validate": "validieren",
  "Import run step preview": "Vorschau",
  "Import run step mapping": "Zuordnung",
  "Import run step package snapshot rules": "Paket-Snapshots",
  "Import run step data select": "Datenauswahl",
  "Import run step data select desc": "Wählen Sie, welche Datenbereiche importiert werden sollen. Abhängige Bereiche sind erst wählbar, wenn die Basis aktiv ist. Beim Speichern wird die Auswahl ins Schema übernommen.",
  "Import run data select no schema": "kein Schema geladen. Bitte zuerst im Schritt Mapping ein Import-Schema zuweisen.",
  "Import data area basis": "Stamm / Basis",
  "Import data area personen": "Personen",
  "Import data area vertraege": "Verträge",
  "Import data area finanzen": "Zahlungen / Finanzen",
  "Import data area mahnwesen": "Mahnwesen",
  "Import data area leads": "Kontakte",
  "Import data cat prerequisite hint": "erst wählbar, wenn die vorausgesetzten Bereiche aktiv sind.",
  "Import data cat go to mapping": "zum Mapping →",
  "Import data cat unmapped required fk warning": "Pflicht-Fremdschlüssel ohne Zuordnung im Mapping",
  "Import data cat detail entity col": "Ziel (Entität / Feld)",
  "Import data cat detail source col": "Quelltabelle",
  "Import data cat detail source none": "(keine)",
  "Import data cat detail toggle": "Details",
  "Import data cat studios": "Studios",
  "Import data cat persons": "Personendaten",
  "Import data cat person photos": "Personenfotos (Profilbild)",
  "Import data cat person notes": "Personennotizen",
  "Import data cat person documents": "Personendokumente",
  "Import data cat check ins": "Check-ins",
  "Import data cat contract packages": "Kundenverträge",
  "Import data cat contracts": "Verträge",
  "Import data cat rest periods": "Ruhezeiten",
  "Import data cat rest period reasons": "Ruhezeitgründe",
  "Import data cat cancellation reasons": "Kündigungsgründe",
  "Import data cat cancellation models": "Kündigungsmodelle",
  "Import data cat contract templates": "Vertragsbausteine",
  "Import data cat tariff templates": "Tarifvorlagen (Paket, Pläne, Laufzeiten)",
  "Import data cat rest period templates": "Ruhezeiten-Vorlagen",
  "Import data cat priceAdjustments": "Preisanpassungen",
  "Import data cat payments": "Zahlungen",
  "Import data cat open items": "offene Posten",
  "Import data cat article sales": "Artikelverkäufe",
  "Import data cat accounts": "Benutzerkonten (Mitarbeiter-Logins)",
  "Import data cat sepa groups": "SEPA-Lastschriftgruppen",
  "Import data cat wallet products": "Wallet-Produkte",
  "Import data cat wallets": "Wallets & Wallet-Transaktionen",
  "Import data cat bank data": "Bankdaten & Bankkonten",
  "Import data cat payment plans": "Ratenpläne",
  "Import data cat payment methods": "Zahlungsarten",
  "Import data cat payment cancel reasons": "Zahlungsstornogründe",
  "Import data cat chargeback reasons": "Chargeback-Gründe",
  "Import data cat reminder levels": "Mahnstufen",
  "Import data cat reminders": "Mahnungen",
  "Import data cat debt collection": "Inkassostellen",
  "Import data cat lead widget ui presets": "Lead-Formulare",
  "Import data cat lead sources": "Lead-Quellen",
  "Import data cat lead pipelines": "Lead-Pipelines",
  "Import data cat lead phases": "Lead-Phasen",
  "Import run step precheck": "Vorprüfung",
  "Import run step execute": "Import ausführen",
  "Import run step mapping desc": "Schritt für Schritt: Quelltabelle, Quellspalte und Konverter pro Zielfeld zuweisen. Änderungen ins Schema speichern.",
  "Import run step package snapshot rules desc":
    "Legen Sie hier Snapshot-Regeln für Vertragspakete sowie zugehörige Einstellungen zum Mitgliedschaftskalender fest. Beim Speichern werden die Werte ins Schema übernommen.",
  "Import run step upload short": "Daten hochladen",
  "Import run step upload desc": "Laden Sie eine ZIP-Datei mit CSV-Dateien (und optional Bildern) direkt in diesem Schritt hoch.",
  "Import run step validate desc": "Prüfung der hochgeladenen Dateien und des Schemas.",
  "Import run step preview desc": "Vorschau der zu importierenden Daten. Schema bei Bedarf anpassen.",
  "Import run step precheck desc": "Precheck vor dem Import: alle importierten Tabellen/Zeilen lesen, Konverter prüfen und Zielzugriff validieren.",
  "Import run step execute desc": "Daten in die Mandanten-Datenbank schreiben. Nach erfolgreichem Import kann bei Bedarf ein zurückrollen ausgelöst werden.",
  "Import run open upload drawer": "Importdaten hochladen",
  "Import run open settings drawer": "Importdaten & Einstellungen",
  "Import run drawer settings title": "Importdaten & Einstellungen",
  "Import run settings drawer hint": "Hier können Sie zusätzliche Daten und Bilder für den Importvorgang ergänzen.",
  "Import run drawer upload title": "Daten & Bilder hinzufügen",
  "Import run drawer upload hint": "Sie können hier weitere Daten und Bilder hochladen.",
  "Import run drawer drop file": "Datei hier ablegen oder klicken (Daten und Bilder)",
  "Import run drawer upload button": "hochladen",
  "Import run drawer schema json label": "Schema-JSON",
  "Import run continue to validate": "weiter zur Validierung",
  "Import run continue to preview": "weiter zur Vorschau",
  "Import run step upload done": "Upload & Import abgeschlossen.",
  "Import run step upload pending": "Noch keine Importdaten hochgeladen.",
  "Import run step validate pending": "Validierung noch nicht ausgeführt.",
  "Import run step validate passed": "Validierung erfolgreich abgeschlossen.",
  "Import run step validate failed hint": "Validierung meldet Fehler. Bitte Daten oder Schema prüfen und erneut validieren.",
  "Import run uploading in progress": "Importdaten werden hochgeladen …",
  "Import run validating in progress": "Validierung läuft …",
  "Import run loading in progress": "Importvorgang wird geladen …",
  "Import run long running hint": "Der Vorgang dauert ungewöhnlich lange. Bitte warten oder die Seite neu laden.",
  "Import run validation rebuild lookup index": "Index neu aufbauen",
  "Import run validation rebuild forced after upload hint":
    "Nach neuem Upload ist das aktiviert, bis die Validierung einmal durchgelaufen ist.",
  "Import run validation rebuild lookup index hint": "Nur aktivieren, wenn neue oder geänderte Dateien und Relationen berücksichtigt werden sollen. Ohne Haken wird der vorhandene Index wiederverwendet.",
  "Import run validation rerun on next": "Validierung erneut ausführen",
  "Import run status summary title": "aktueller Stand",
  "Import run status summary upload done": "Daten sind hochgeladen.",
  "Import run status summary upload pending": "Noch keine Daten hochgeladen.",
  "Import run status summary validation done": "Validierung ist abgeschlossen.",
  "Import run status summary validation failed": "Validierung hat Fehler gemeldet.",
  "Import run status summary validation pending": "Validierung ist noch ausstehend.",
  "Import run status summary can revalidate": "Validierung kann jederzeit erneut gestartet werden.",
  "Import run committing in progress": "Import wird ausgeführt …",
  "Import run progress uploading": "Importdaten werden hochgeladen …",
  "Import run progress server processing": "Server verarbeitet Daten …",
  "Import run progress server unzipping": "ZIP wird entpackt ({0}/{1}): {2}",
  "Import run progress upload stalled": "Upload hängt – warte auf Serverantwort …",
  "Import run progress extracting": "Daten werden entpackt …",
  "Import run progress saving files": "Dateien werden gespeichert …",
  "Import run progress listing files": "Dateien werden aufgelistet …",
  "Import run progress indexing complete": "Indizierung abgeschlossen",
  "Import run progress validating tables": "Tabellen werden geprüft …",
  "Import run progress validating tables detail": "Tabelle {2} wird geprüft ({0}/{1})",
  "Import run progress validating tables current": "Tabelle {0} wird geprüft …",
  "Import run progress validating data": "Tabellen und Dateien werden geprüft …",
  "Import run progress analyzing relations": "Beziehungen werden analysiert ({0}/{1}): {2}",
  "Import run progress prechecking": "Precheck läuft …",
  "Import run progress precheck running preview": "Precheck: Vorschau wird ausgeführt …",
  "Import run progress precheck loading data": "Precheck: Daten werden geladen …",
  "Import run progress precheck loading table pending": "Precheck: Tabelle {0} (wird geladen)",
  "Import run progress precheck loading table detail": "Precheck: Tabelle {2} ({0} von {1} Zeilen)",
  "Import run progress precheck entities detail": "Precheck: Entität {2} ({0} von {1})",
  "Import run progress committing": "Daten werden in die Datenbank geschrieben …",
  "Import run progress creating tenant backup": "Mandantensicherung wird erstellt …",
  "Import run progress committing preparing": "Import wird vorbereitet …",
  "Import run progress committing open item status": "offene Posten werden aktualisiert …",
  "Import run progress committing wallet balances": "Wallet-Salden werden berechnet …",
  "Import run progress committing debt collection cases": "Inkasso-Fälle werden verknüpft …",
  "Import run progress committing package snapshots": "Vertragspaket-Snapshots werden erstellt …",
  "Import run progress committing entities detail": "Schreibe {2} ({0} von {1})",
  "Import run progress committing entities current": "Datenbank-Schreibvorgang: Entität {0}",
  "Import run progress committing files detail": "Dateien werden übernommen ({0} von {1})",
  "Import run progress clearing": "hochgeladene Dateien werden gelöscht",
  "Import run upload extracting": "Upload entpacken",
  "Import run zip uploaded uncounted": "Upload erfolgreich, Daten werden gleich validiert.",
  "Import run drawer schema section": "Schema / Mapping (JSON)",
  "Import run drawer schema save": "Schema speichern",
  "Import run drawer schema saved": "Schema gespeichert.",
  "Import run drawer schema save error": "Schema konnte nicht gespeichert werden.",
  "Import run step save": "speichern",
  "Import run undo": "Änderungen verwerfen",
  "Import run undo confirm title": "Ungesicherte Änderungen verwerfen?",
  "Import run undo confirm": "Alle Änderungen seit der letzten Speicherung werden verworfen. Fortfahren?",
  "Import run undo success": "Änderungen wurden auf den letzten Speicherstand zurückgesetzt.",
  "Import run undo error": "Änderungen konnten nicht zurückgesetzt werden.",
  "Import run save tooltip unsaved": "Ungesicherte Änderungen vorhanden. Bitte speichern.",
  "Import run step save not available": "Für diesen Schritt gibt es aktuell nichts zu speichern.",
  "Import run step saved": "Importvorgang gespeichert.",
  "Import run step save error": "Importvorgang konnte nicht gespeichert werden.",
  "Import run wizard step locked hint": "Dieser Schritt ist noch nicht freigegeben. Bitte die vorherigen Schritte abschließen.",
  "Import run step locked reason upload": "Bitte zuerst Dateien hochladen.",
  "Import run step locked reason validate": "Bitte zuerst die Validierung abschließen.",
  "Import run step locked reason mapping": "Bitte zuerst das Mapping konfigurieren.",
  "Import run step locked reason dataselect": "Bitte zuerst die Datenauswahl abschließen.",
  "Import run step locked reason precheck": "Bitte zuerst den Precheck ausführen und alle Fehler lösen.",
  "Import run unsaved changes hint": "Es gibt ungesicherte Änderungen im Mapping oder in den Relationen. Erst „speichern“ schreibt diesen Stand ins Schema; „Änderungen verwerfen“ setzt beides zurück.",
  "Import run preview table tab": "{0} → {1}",
  "Import run validate": "validieren",
  "Import run validation failed": "Validierung fehlgeschlagen.",
  "Import run validation result success": "Validierung erfolgreich",
  "Import run validation result success detail": "{0} Dateien erkannt: {1} Tabellen, {2} Bilder, {3} Dokumente.",
  "Import run validation storage structure": "Dateiliste indiziert. Unterordner: {0}. Oberste Ordner: {1}. Dateien: {2} CSV, {3} Bilder, {4} Dokumente.",
  "Import run validation storage structure yes": "ja",
  "Import run validation storage structure no": "nein",
  "Import run validation ok": "Validierung OK. {0} Datei(en) im Importvorgang.",
  "Import run zip error": "ZIP-Upload fehlgeschlagen.",
  "Import run upload stalled warning": "Upload-Fortschritt steht. Verbindung/Proxy wird geprüft …",
  "Import run upload stalled error": "Upload hängt seit längerer Zeit ohne Fortschritt und wurde abgebrochen.",
  "Import run upload timeout": "Upload wurde nach maximaler Wartezeit abgebrochen. Evtl. Datei verkleinern oder Verbindung prüfen.",
  "Import run upload interrupted": "Upload-Verbindung wurde unterbrochen (keine Serverantwort). Bitte Netzwerk/Proxy prüfen und erneut versuchen.",
  "Import run upload too large": "Datei ist für den Server-Upload zu groß (HTTP 413). Bitte Proxy-Upload-Limit prüfen.",
  "Import run zip uploaded": "{0} Datei(en) hochgeladen.",
  "Import runs": "Mapping-Importe",
  "Import runs started": "begonnene Mapping-Importe",
  "Import runs empty hint": "Noch keine Importvorgänge. Erstellen Sie einen Importvorgang und laden Sie eine ZIP hoch.",
  "Import runs started empty hint": "Noch keine begonnenen Importvorgänge. Erstellen Sie einen Importvorgang und laden Sie eine ZIP hoch.",
  "Admin Import": "Import",
  "Mapping templates": "Mapping-Vorlagen",
  "Mapping imports": "Mapping-Importe",
  "Adapter imports": "Adapter-Importe",
  "Mapping templates group card description": "wiederverwendbare Tabellen-Mapping-Vorlagen (CSV ↔ Datenbank-Tabellen)",
  "Mapping imports group card description": "konkrete Import-Vorgänge auf Basis einer Mapping-Vorlage",
  "Adapter imports group card description": "Import-Vorgänge über System-Adapter (z. B. CenterCom)",
  "Import schemas group card description": "Import-Schemata verwalten und Quell-Ziel-Mapping bearbeiten",
  "Import runs group card description": "Importvorgänge anlegen, Vorschau, Ausführung und rückgängig machen",
  "Back to Import": "zurück zu Import",
  "Import run preview": "Vorschau laden",
  "Import run preview title": "Import-Vorschau",
  "Import run preview loading": "Vorschau wird geladen…",
  "Import run preview error": "Vorschau fehlgeschlagen.",
  "Import run target preview error": "Zielvorschau konnte nicht geladen werden.",
  "Import run source preview error": "Quellvorschau konnte nicht geladen werden.",
  "Import run source columns error": "Quellspalten konnten nicht geladen werden.",
  "Import run enum source values error": "Quellwerte für die Zuordnung konnten nicht geladen werden.",
  "Import run preview warning": "Vorschau mit Warnungen",
  "Import run preview include unresolved foreign keys": "nicht aufgelöste Datensätze dennoch importieren",
  "Import run preview include unresolved foreign keys short": "nicht aufgelöste Zeilen dennoch importieren",
  "Import run precheck strict fk rows skipped notice":
    "Diese Quellzeilen werden beim Import nicht übernommen, weil der Bezug (z. B. zur Person) fehlt. Übrige Zeilen der Quelltabelle sind nicht betroffen.",
  "Import run precheck strict fk skip acknowledge": "nicht aufgelöste Zeilen überspringen",
  "Import run precheck strict fk include unresolved blocking":
    "Für diesen Lauf sind nicht aufgelöste FK-Zeilen in der Vorschau enthalten; bitte Option in der API deaktivieren oder Daten korrigieren.",
  "Import run preview no data": "keine Vorschaudaten (Schema ohne Quellzuordnung oder Lauf ohne Dateien).",
  "Import run preview mapping hint": "Im Schema fehlt eine nutzbare Quellzuordnung. Bitte Mapping prüfen und speichern.",
  "Import run go to mapping": "zum Mapping",
  "Import run mapping preview title": "Vorschau",
  "Import run mapping preview mode": "Ansicht",
  "Import run mapping preview source": "Quelle",
  "Import run mapping preview target": "Ziel",
  "Import run mapping preview conversion mode": "Zieldaten",
  "Import run mapping preview conversion raw": "Rohdaten",
  "Import run mapping preview conversion converted": "Anzeigedaten",
  "Import run mapping preview debug mode": "Debug-Ausgabe",
  "Import run mapping preview debug output": "Debug-Ausgabe (zum Kopieren)",
  "Import run mapping preview source loading": "Quellvorschau wird geladen …",
  "Import run mapping preview source loading table": "Quellvorschau wird geladen: {0} …",
  "Import run mapping preview source loading detail": "Quellvorschau: Entität {0}/{1} · Tabelle {2} · Zeilen {3}/{4}",
  "Import run mapping preview target loading": "Zielvorschau wird geladen …",
  "Import run mapping preview target loading detail": "Zielvorschau: Entität {0}/{1} · {2} · Zeilen {3}/{4}",
  "Import run mapping preview target loading detail entity and table": "Zielvorschau: Entität {0}/{1} · {2} · Tabelle {3} · Zeilen {4}/{5}",
  "Import run mapping preview target existing loading": "Bestandsdaten werden geladen …",
  "Import run mapping preview target progress status": "Zielvorschau läuft",
  "Import run mapping preview target progress requesting": "Anfrage wird verarbeitet",
  "Import run mapping preview target progress processing": "Ergebnis wird aufbereitet",
  "Import run mapping preview target data source mode": "Datenbasis",
  "Import run mapping preview target data source planned": "Importvorschau",
  "Import run mapping preview target data source existing": "Bestandsdaten",
  "Import run mapping preview source empty": "keine Quelldaten für diese Tabelle verfügbar.",
  "Import run mapping preview source waiting for enum": "warte auf Enum-Werte …",
  "Import run mapping preview target waiting for source": "warte auf Quellvorschau …",
  "Import run mapping preview source not selected": "Es ist keine Quelltabelle ausgewählt.",
  "Import run mapping preview target empty": "keine Zieldaten nach Konvertierung verfügbar.",
  "Import run mapping preview target empty with source hint": "keine Zieldaten für die aktuelle Zuordnung verfügbar. Bitte Feldzuordnung und Zieltabelle prüfen.",
  "Import run mapping preview target existing empty": "keine Bestandsdaten für diese Ziel-Entität verfügbar.",
  "Import run preview phase entity": "Phase {0}: {1}",
  "Import run preview rows": "{0} Zeilen",
  "Import run precheck": "Precheck ausführen",
  "Import run precheck success": "Precheck erfolgreich: {0} Tabellen/Entitäten geprüft, {1} Zeilen gelesen.",
  "Import run precheck failed": "Precheck fehlgeschlagen.",
  "Import run precheck failed with count": "Precheck fehlgeschlagen ({0} Fehler).",
  "Import run precheck failed details": "Der Precheck hat Fehler gefunden. Bitte Mapping/Zuordnung korrigieren.",
  "Import run precheck failed errors heading": "gemeldete Fehler:",
  "Import run precheck failed errors col text": "Fehler",
  "Import run precheck blocking errors banner":
    "{0} schwerwiegende Fehler (z. B. fehlende Tabelle, falsche Beziehung) – nicht durch Bestätigen behebbar.",
  "Import run precheck global blocking errors title": "blockierende Fehler (Import nicht möglich)",
  "Import run precheck run again": "Precheck erneut ausführen",
  "Import run precheck debug export title": "Precheck-Debug-Export (für Support)",
  "Import run precheck debug export desc":
    "Klartext-Snapshot zu Precheck-Kontext, einheitlichen Gruppen, flachen Fehlern und Warnungen. Vor dem Kopieren nach „offen“ bzw. „erledigt“ filtern.",
  "Import run precheck debug filter open": "offene Einträge einschließen",
  "Import run precheck debug filter resolved": "erledigte Einträge einschließen",
  "Import run precheck debug copied": "in die Zwischenablage kopiert",
  "Import run precheck debug copy failed": "Fehler beim Kopieren",
  "Import run precheck debug copy": "in Zwischenablage kopieren",
  "Import run precheck debug clipboard truncated": "… Ausgabe für die Zwischenablage gekürzt.",
  "Import run precheck debug section context": "Kontext & Zusammenfassung",
  "Import run precheck debug section groups": "einheitliche Gruppen",
  "Import run precheck debug section errors": "flache Precheck-Fehler",
  "Import run precheck debug section warnings": "flache Precheck-Warnungen",
  "Import run precheck debug filter none": "Mindestens einen Filter aktivieren (offen oder erledigt), um Text zu erzeugen.",
  "Import run precheck debug tag open": "offen",
  "Import run precheck debug tag resolved": "erledigt",
  "Import run precheck debug valid ok": "ja",
  "Import run precheck debug valid failed": "nein",
  "Import run precheck debug valid unknown": "unbekannt",
  "Import run precheck debug can proceed yes": "ja",
  "Import run precheck debug can proceed no": "nein",
  "Import run precheck debug report banner": "=== m1member Precheck Debug-Export ===",
  "Import run precheck debug report k timestamp utc": "Zeitstempel (UTC):",
  "Import run precheck debug report k import run id": "Importlauf-ID:",
  "Import run precheck debug report empty collection": "(keine)",
  "Import run precheck debug report k precheck valid": "Precheck gültig:",
  "Import run precheck debug report k can proceed": "Ausführung des Imports möglich:",
  "Import run precheck debug report k skip rows": "übersprungene Zeilen je Quelltabelle:",
  "Import run precheck debug report skip row line": "  {0}: anzahl={1}, stichprobe={2}",
  "Import run precheck debug report k fill timestamps": "leere Zeitstempel auffüllen (Quelltabelle(n)):",
  "Import run precheck debug report k accept fk cells": "ausdrücklich erlaubte leere FK-Zellen:",
  "Import run precheck debug report accept fk count": "anzahl={0}",
  "Import run precheck debug report accept fk row": "  - {0} Zeile {1} Spalte {2}",
  "Import run precheck debug report more": "  … (+{0} weitere)",
  "Import run precheck debug report no groups": "(keine Gruppen mit aktuellem Filter)",
  "Import run precheck debug report no error lines": "(keine Fehlerzeilen mit aktuellem Filter)",
  "Import run precheck debug report no warning lines": "(keine Warnzeilen mit aktuellem Filter)",
  "Import run precheck debug report row sample none": "(keine)",
  "Import run precheck debug report row sample more": " … (+{0} weitere)",
  "Import run precheck debug report entity line":
    "- {0} <= {1}: gesamt={2}, übersprungen_filter={3}, übersprungen_fk={4}, zu_importieren={5}, commitUnterstützt={6}",
  "Import run precheck debug report entity summary":
    "ZUSAMMENFASSUNG (Quelle dedupliziert): gesamt={0}, übersprungen={1}, zu_importieren={2}",
  "Import run precheck debug report na": "k. A.",
  "Import run precheck warnings": "Precheck-Hinweise",
  "Import run precheck result title": "Precheck-Ergebnis",
  "Import run precheck col phase": "Mapping-Phase",
  "Import run precheck col target": "Ziel-Entität",
  "Import run precheck col source": "Quelltabelle",
  "Import run precheck col rows": "Zeilen",
  "Import run precheck row count skip tooltip":
    "Für diese Quelltabelle sind Zeilen als übersprungen markiert. Die Zahl entspricht der letzten Precheck-Vorschau (ohne diese Zeilen). Kurz warten, bis der Precheck nach der Auswahl automatisch fertig ist.",
  "Import run precheck col commit": "beim Ausführen des Imports",
  "Import run precheck importable": "wird in die Datenbank geschrieben",
  "Import run precheck not importable": "nicht importierbar",
  "Import run precheck no commit handler": "keine Importbehandlung (wird übersprungen)",
  "Import run precheck not written to db": "wird nicht geschrieben (noch nicht angeboten)",
  "Import run precheck row summary title": "Zeilenzahlen (pro Quelltabelle)",
  "Import run precheck row summary col total": "Zeilen gesamt",
  "Import run precheck row summary col filter skipped": "übersprungen (Filter)",
  "Import run precheck row summary col filter skipped tooltip": "Schemafilter: {0}",
  "Import run precheck row summary col cascade": "Kaskade",
  "Import run precheck row summary col cascade hint":
    "Kaskadiert übersprungen: Zeilen, deren FK-Ziel durch Konfiguration ausgeschlossen wurde.",
  "Import run precheck row summary col error skipped": "übersprungen (Fehler)",
  "Import run precheck row summary col to import": "zu importieren",
  "Import run precheck row summary col multi col lookup": "FK-Auflösung (Treffer/mehrdeutig/kein Treffer)",
  "Import schema mapping multi col lookup preview heading": "Vorschau: FK-Auflösung (alle Zeilen)",
  "Import schema mapping multi col lookup preview empty": "Noch keine Konfiguration. Sobald Schlüsselspalten gesetzt sind, erscheint hier automatisch die Trefferstatistik.",
  "Import schema mapping multi col lookup preview source only hint":
    "Dieses Target stellt nur den Composite-Schlüssel (LookupKeyColumns) bereit. Die Treffer-Statistik siehst du beim FK-Feld im nutzenden Target (z. B. OpenItems.contract_id) — wechsle dort hinein und öffne dort den Drawer.",
  "Import schema mapping multi col lookup preview total": "{0} Zeilen geprüft",
  "Import schema mapping multi col lookup preview hits label": "eindeutig (mehrere Spalten)",
  "Import schema mapping multi col lookup preview fallback label": "Fallback (nackter PK)",
  "Import schema mapping multi col lookup preview cascade label": "Kaskadenübersprung (gefiltert)",
  "Import schema mapping multi col lookup preview ambig label": "mehrdeutig (mehrere Treffer)",
  "Import schema mapping multi col lookup preview miss label": "keinen Treffer gefunden",
  "Import schema mapping multi col lookup preview ambig rows": "Beispiel-Zeilen (mehrdeutig): {0}",
  "Import schema mapping multi col lookup preview miss rows": "Beispiel-Zeilen (kein Treffer): {0}",
  "Import schema mapping multi col lookup preview ambig rows header": "Beispielzeilen mit mehrdeutigem Treffer:",
  "Import schema mapping multi col lookup preview miss rows header": "Beispiel-Zeilen ohne Treffer:",
  "Import schema mapping multi col lookup preview all miss title": "keine einzige Zeile wurde aufgelöst",
  "Import schema mapping multi col lookup preview all miss hint":
    "Prüfe: (1) Sind an ALLEN Quell-Targets derselben Ziel-Entität die LookupKeyColumns gesetzt? (2) Passen die Lookup-Match-Spalten (links) namentlich zu den Spalten der aktuellen Quelltabelle? (3) Sind Datums-/Zahlenformate normalisierbar (z. B. dd.MM.yyyy oder yyyy-MM-dd, Komma oder Punkt bei Dezimalwerten)?",
  "Import schema mapping multi col lookup debug search keys": "gesuchte Schlüssel (aus Quelle)",
  "Import schema mapping multi col lookup debug buckets empty":
    "Die Ziel-Buckets sind leer. LookupKeyColumns sind an den Ziel-Quell-Targets nicht gesetzt oder liefern keine Werte.",
  "Import schema mapping multi col lookup desc":
    "Für Ziel-Entitäten, die von mehreren Quell-Tabellen bedient werden (z. B. Contracts aus VERTHIST + Sonderzahlung), kann hier der eindeutige Schlüssel definiert werden. Die FK-Auflösung probiert alle Buckets und nimmt den eindeutigen Treffer.",
  "Import schema mapping lookup key columns label": "Lookup-Schlüsselspalten (Quelltabelle)",
  "Import schema mapping lookup key columns hint":
    "Spalten dieser Quell-Tabelle, die einen Eintrag eindeutig identifizieren (Reihenfolge wichtig). Beispiel VERTHIST: VertragsID + VertBegn.",
  "Import schema mapping lookup key columns placeholder": "Spalten wählen …",
  "Import schema mapping lookup match columns label": "Lookup-Trefferspalten pro FK-Feld",
  "Import schema mapping lookup match columns placeholder": "Quellspalten wählen …",
  "Import schema mapping lookup indexes id field icon tooltip": "zusammengesetzte Lookup-Indizes pflegen",
  "Import schema mapping lookup indexes section": "zusammengesetzte Lookup-Indizes (am ID-Feld)",
  "Import schema mapping lookup indexes hint":
    "Sekundäre Indexe der Ziel-Tabelle, über die FK-Felder anderer Entitäten dieses Target erreichen können. Mehrere Indexe pro id möglich. Reihenfolge der Spalten ist Teil des Schlüssels.",
  "Import schema mapping lookup index name label": "Index-Name",
  "Import schema mapping lookup index name placeholder": "z. B. byPersonNummer",
  "Import schema mapping lookup index columns label": "Spalten",
  "Import schema mapping lookup index columns placeholder": "Spalten der Quelltabelle wählen …",
  "Import schema mapping lookup index add": "Index hinzufügen",
  "Import schema mapping lookup index remove": "entfernen",
  "Import schema mapping lookup index empty": "Noch keine zusammengesetzten Indizes definiert.",
  "Import schema mapping lookup index legacy migrate label": "Altformat vorhanden – ans ID-Feld migrieren",
  "Import schema mapping lookup index legacy migrate hint":
    "Dieses Schema verwendet noch die alten LookupKeyColumns am Target-Block. Mit „übernehmen“ werden sie als unbenannter Index ans id-Feld portiert; die Block-Level-Konfiguration wird entfernt.",
  "Import schema mapping lookup index legacy migrate apply": "Migration übernehmen",
  "Import schema mapping lookup config drawer title": "Lookup-Konfiguration",
  "Import schema mapping lookup config drawer title focused": "Lookup-Konfiguration — {0}",
  "Import schema mapping lookup config drawer fk no focus":
    "Diese Sektion zeigt die FK-Auflösung für ein einzelnes Feld. Klicke an einem FK-Feld auf die Lupe, um es hier zu konfigurieren.",
  "Import schema mapping fk source table placeholder": "Bucket …",
  "Import schema mapping multi col lookup test loading": "Lookup-Vorschau wird aktualisiert …",
  "Import schema mapping multi col lookup progress stage": "Phase: {0}",
  "Import schema mapping multi col lookup progress entities": "Entitäten: {0} / {1}",
  "Import schema mapping multi col lookup progress rows": "Zeilen: {0} / {1}",
  "Import run precheck multi col lookup hit": "Treffer",
  "Import run precheck multi col lookup ambiguous": "mehrdeutig",
  "Import run precheck multi col lookup miss": "ohne Treffer",
  "Import run precheck row summary total row": "Summe",
  "Import schema mapping row filter op equals": "gleich",
  "Import schema mapping row filter op not equals": "ungleich",
  "Import schema mapping row filter op is empty": "ist leer",
  "Import schema mapping row filter op is not empty": "ist nicht leer",
  "Import schema mapping row filter op contains": "enthält",
  "Import schema mapping row filter op not contains": "enthält nicht",
  "Import schema mapping row filter op starts with": "beginnt mit",
  "Import schema mapping row filter op ends with": "endet mit",
  "Import schema mapping row filter op regex": "Regex",
  "Import schema mapping row filter relation path": "Lookup-Pfad (verknüpfte Tabelle)",
  "Import schema mapping dedup cols placeholder": "Spalten auswählen …",
  "Import schema mapping dedup hint":
    "Zeilen mit gleichen Werten in allen ausgewählten Spalten gelten als Duplikate; pro eindeutiger Kombination bleibt beim Import nur eine Zeile erhalten.",
  "Import schema mapping dedup title": "Deduplizierung",
  "Import schema mapping dedup priority title": "Bevorzugung bei Duplikaten",
  "Import schema mapping dedup priority hint":
    "Optional: Wenn pro Schlüssel mehrere Zeilen vorhanden sind, gewinnt die Zeile, deren Wert in der angegebenen Spalte in der Positiv-Liste steht. Ohne Treffer bleibt das Standardverhalten (erste Zeile gewinnt).",
  "Import schema mapping dedup priority col label": "Spalte",
  "Import schema mapping dedup priority col placeholder": "Spalte auswählen …",
  "Import schema mapping dedup priority values label": "bevorzugte Werte",
  "Import schema mapping dedup priority values placeholder": "Werte eingeben (Enter), leerer Wert = leere Spalte",
  "Import schema mapping dedup priority values placeholder suggestions": "Vorschläge aus Spalte – auch eigene Werte tippbar",
  "Import schema mapping row filter add": "Bedingung hinzufügen",
  "Import schema mapping row filter add rule": "Regel hinzufügen",
  "Import schema mapping row filter col": "Spalte",
  "Import schema mapping row filter hint":
    "Zeilen, die die Bedingungen dieser Regel erfüllen, werden für diese Quelltabelle nicht importiert (übersprungen).",
  "Import schema mapping row filter hint include":
    "Nur Zeilen, die die Bedingungen dieser Regel erfüllen, werden importiert; alle übrigen Zeilen dieser Quelltabelle werden übersprungen.",
  "Import schema mapping row filter logic and": "UND",
  "Import schema mapping row filter logic or": "ODER",
  "Import schema mapping row filter mode exclude": "Treffer auslassen",
  "Import schema mapping row filter mode include": "nur Treffer importieren",
  "Import schema mapping row filter multiple exclude hint":
    "mehrere Regeln werden mit ODER verknüpft: eine Zeile wird ausgeschlossen, wenn sie mindestens einer Regel entspricht.",
  "Import schema mapping row filter multiple include hint":
    "mehrere Regeln werden mit ODER verknüpft: eine Zeile wird importiert, wenn sie mindestens einer Regel entspricht.",
  "Import schema mapping row filter multiple mixed hint":
    "Die Regeln nutzen unterschiedliche Modi (nur Treffer vs. Treffer auslassen); jede Regel gilt für sich.",
  "Import schema mapping row filter op": "Operator",
  "Import schema mapping row filter rule or separator": "oder",
  "Import schema mapping row filter rule title": "Regel {0}",
  "Import schema mapping row filter title": "Zeilenfilter",
  "Import schema mapping row filter val": "Wert",
  "Import schema mapping row filter val empty": "(leer)",
  "Import schema mapping row filter column invalid tooltip":
    "Spalte \"{0}\" existiert nicht in Quelltabelle \"{1}\". Der Filter greift dadurch wie \"leer\" auf jede Zeile und filtert alles aus. Bitte Spalte korrigieren oder Filter entfernen.",
  "Import schema mapping row filter column invalid badge": "nicht in Quelltabelle",
  "Import package snapshot rules title": "Vertragspakete: Snapshot-Regeln",
  "Import package snapshot rules enabled": "Regeln aktivieren",
  "Import package snapshot rules distinct load error title": "Eindeutigkeitsprüfung fehlgeschlagen",
  "Import package snapshot rules distinct load error": "Eindeutigkeitsprüfung konnte nicht geladen werden.",
  "Import package snapshot rules rest section": "Ruhezeitregeln",
  "Import package snapshot rules cancellation section": "Kündigungsregeln",
  "Import package snapshot rules empty rules": "keine Regeln vorhanden.",
  "Import package snapshot rules rule title": "Regel {0}",
  "Import package snapshot rules remove rule": "Regel entfernen",
  "Import package snapshot rules rest template": "Ruhezeitmodell",
  "Import package snapshot rules template select": "Modell auswählen …",
  "Import package snapshot rules cancellation template": "Kündigungsmodell",
  "Import package snapshot rules add rest rule": "Ruhezeitregel hinzufügen",
  "Import package snapshot rules add cancellation rule": "Kündigungsmodell-Regel hinzufügen",
  "Import package snapshot rules add condition": "Bedingung hinzufügen",
  "Import package snapshot rules remove condition": "Bedingung entfernen",
  "Import package snapshot rules logic and": "UND",
  "Import package snapshot rules logic or": "ODER",
  "Import package snapshot rules filter field placeholder": "Feld auswählen …",
  "Import package snapshot rules filter value select placeholder": "Wert …",
  "Import package snapshot rules filter case sensitive": "Groß-/Kleinschreibung",
  "Import cc generation mode title": "Beitragskalender: Erzeugungsmodus",
  "Import cc generation mode hint": "Bestimmt, wie der Beitragskalender beim Import aufgebaut wird.",
  "Import cc generation mode auto label": "Auto (empfohlen)",
  "Import cc generation mode auto desc": "Beitragskalender wird 1:1 aus den importierten Rechnungen (offene Posten) abgeleitet: gleiche Fälligkeit, gleicher Betrag, Status aus dem OI-Status zugeordnet. Ruhezeiten werden als Informationsdatensätze importiert und beeinflussen den Kalender nicht. Direkter CSV-Import des Kalenders wird unterdrückt.",
  "Import cc generation mode direct label": "Direktimport",
  "Import cc generation mode direct desc": "Beitragskalender-Zeilen werden direkt aus CSV importiert. Der Prozessor wird nicht ausgeführt.",
  "Import contribution paid override title": "Beiträge per Regel als bezahlt markieren",
  "Import contribution paid override hint": "Gilt nur für in diesem Importlauf neu geschriebene Vertragspakete. Berechnete Beitragszeilen werden als bezahlt markiert, ohne automatisch passende Zahlungen anzulegen.",
  "Import contribution paid override enabled": "Regeln aktivieren",
  "Import contribution paid override rules section": "Regeln",
  "Import contribution paid override rule title": "Regel {0}",
  "Import contribution paid override add rule": "Regel hinzufügen",
  "Import contribution paid override filter value placeholder": "Wert …",
  "Import contribution paid override due on or before": "Fälligkeitsdatum bis einschl.",
  "Import contribution paid override due on or after": "Fälligkeitsdatum ab einschl.",
  "Import contribution paid override payment placeholder": "Zahlart auswählen …",
  "Import contribution paid override pm 1": "Bar",
  "Import contribution paid override pm 2": "Lastschrift",
  "Import contribution paid override pm 3": "Überweisung",
  "Import contribution paid override pm 4": "EC-Karte",
  "Import contribution paid override pm 5": "Kreditkarte",
  "Import contribution paid override pm 6": "Paypal",
  "Import contribution paid override pm 7": "SEPA-Überweisung",
  "Import contribution paid override pm 8": "Sonstige",
  "Import contribution paid override pm 9": "Gutschein",
  "Import run precheck entity section generated": "systemseitig generiert (kein Quelldaten-Import)",
  "Import run precheck entity cc will build": "wird aufgebaut",
  "Import run precheck entity cc will build auto": "wird aufgebaut (Prozessor)",
  "Import run precheck entity cc skipped": "wird übersprungen",
  "Import run precheck entity section written": "Ziele mit Datenbank-Import",
  "Import run precheck entity section not written": "weitere Ziele mit Vorschau-Zeilen ({0}) – ohne Datenbank-Import",
  "Import run precheck entity section not written hint":
    "Hier erscheinen Ziele, für die die Vorschau Zeilen liefert, aber noch kein Commit-Handler für die Mandanten-Datenbank verfügbar ist. Ein Mapping allein reicht nicht – der Import muss fachlich implementiert sein, bevor diese Zeilen übernommen werden können.",
  "Import run precheck entity hidden zero rows":
    "{0} weitere Ziel-Zeilen ohne Vorschau-Daten ausgeblendet (z. B. nur als Referenz im Mapping).",
  "Import run precheck entity table supported empty":
    "kein Ziel mit aktivem Datenbank-Import in dieser Vorschau – siehe aufgeklappte Liste unten, falls vorhanden.",
  "Import run precheck no validation errors for target": "ok",
  "Import run precheck entity status ok": "ok",
  "Import run precheck entity file pending": "noch offen",
  "Import run precheck entity strict fk pending": "noch offen",
  "Import run precheck entity file resolved": "gelöst",
  "Import run precheck target ok import blocked globally": "Import gesamt blockiert, Ziel ohne Fehler",
  "Import run precheck ambiguous photo accept action": "mehrdeutige Foto-Zuordnungen beim Import dennoch übernehmen",
  "Import run precheck summary importable": "Import ist freigegeben. Precheck ohne Fehler abgeschlossen.",
  "Import run precheck summary importable with decisions": "Import ist freigegeben. Entscheidungen aus dem Precheck werden übernommen.",
  "Import run precheck summary decision pending": "Vor dem Import: fehlende Dateien unten pro Quelltabelle bestätigen.",
  "Import run precheck summary not importable": "Import ist nicht freigegeben. Bitte gemeldete Fehler korrigieren.",
  "Import run precheck error groups by source": "Fehler nach Quelltabelle",
  "Import run precheck affected rows": "betroffene Zeilen",
  "Import run precheck affected rows count": "Zeilen",
  "Import run precheck show source records": "Quelltabelle wählen (betroffene Datensätze anzeigen)",
  "Import run precheck source preview tabular none": "Es gibt keine tabellarischen Validierungsfehler – Dateihinweise siehe oben bei „Dateireferenzen“.",
  "Import run precheck source preview tabular empty selection": "Für diese Auswahl liegen keine Validierungsfehler vor (andere Quelltabelle wählen).",
  "Import run precheck no rows in preview": "keine Zeilen in der Vorschau (max. Zeilenanzahl überschritten?).",
  "Import run precheck empty rows omitted": "{0} leere Zeilen werden nicht angezeigt.",
  "Import run precheck col row": "Zeile",
  "Import run precheck problem columns": "betroffene Spalten",
  "Import run precheck skip rows": "betroffene Zeilen überspringen",
  "Import run precheck decision open": "noch nicht entschieden",
  "Import run precheck fk option import clear": "Zeilen importieren, Fremdschlüssel leer lassen",
  "Import run precheck fk option import clear with target": "{0} {1}-Zeilen importieren, Fremdschlüssel leer lassen",
  "Import run precheck fk option skip rows": "Zeilen nicht importieren",
  "Import run precheck optional fk filtered option import clear":
    "Zeilen mit gefiltertem Paket-FK übernehmen (Fremdschlüssel bleibt leer)",
  "Import run precheck optional fk filtered option skip rows":
    "Zeilen mit gefiltertem Paket-FK ebenfalls filtern (Zeilen nicht importieren)",
  "Import run precheck unified title": "Prüfergebnis",
  "Import precheck section mapping issues": "Mapping-Probleme (Zuordnung fehlt oder falsch)",
  "Import precheck section source issues": "Quelldaten-Probleme (Daten in der CSV)",
  "Import precheck cause mapping": "Zuordnung",
  "Import precheck cause source": "Quelldaten",
  "Import precheck source value hint": "Quellwert (konnte nicht aufgelöst werden)",
  "Import run precheck unified global heading": "weitere Meldungen",
  "Import run precheck unified col severity": " ",
  "Import run precheck unified col message": "Meldung",
  "Import run precheck unified sev blocking": "blockiert",
  "Import run precheck unified sev action": "Entscheidung erforderlich",
  "Import run precheck unified sev warning": "Hinweis",
  "Import run precheck unified sev cleared": "gelöst",
  "Import run precheck unified cat file": "Datei / Speicher",
  "Import run precheck unified cat timestamp": "Zeitstempel",
  "Import run precheck unified cat fk empty": "optionaler Fremdschlüssel",
  "Import run precheck unified cat fk filtered dep": "Fremdschlüssel auf gefilterten Datensatz",
  "Import run precheck unified cat multiple primary": "mehrfache Hauptverträge pro Paket",
  "Import run precheck multiple primary in package help": "Pro Vertragspaket darf nur ein Vertrag mit „is_primary_in_package=true\" existieren. Bitte eine Strategie wählen; sie wird auf alle betroffenen Pakete angewandt.",
  "Import run precheck multiple primary option prefer active": "aktiven Vertrag bevorzugen (Vertrag ohne Endedatum gewinnt; sonst erster)",
  "Import run precheck multiple primary option prefer first": "erster gewinnt (in CSV-Reihenfolge)",
  "Import run precheck multiple primary option prefer last": "letzter gewinnt (in CSV-Reihenfolge)",
  "Import run precheck multiple primary samples header": "Beispiele betroffene Pakete:",
  "Import run precheck unified cat fk strict": "Fremdschlüssel-Ziel",
  "Import run precheck unified cat fk validation miss": "FK-Validierung",
  "Import run precheck unified cat contract no billing": "Vertragspaket / Mitgliedschaftskalender",
  "Import run precheck unified cat validation": "Validierung",
  "Import run precheck unified source label": "Quelltabelle",
  "Import run precheck unified source column label": "Quelle",
  "Import run precheck unified hint label": "Hinweis",
  "Import run precheck unified examples label": "Beispiele",
  "Import run precheck unified rows label": "Datenzeilen (CSV)",
  "Import run precheck unified affected records": "betroffene Datensätze",
  "Import run precheck unified affected records with total": "von {0} Datensätzen: {1} betroffen",
  "Import run precheck unified affected and unaffected with total": "von {0} Datensätzen: {1} betroffen, nicht betroffen: {2}",
  "Import run precheck unified unaffected records": "nicht betroffen: {0}",
  "Import run precheck unified details available": "Details vorhanden",
  "Import run precheck unified details missing": "Details fehlen",
  "Import run precheck unified tabular col fields": "Spalten",
  "Import run precheck unified tabular col excerpt": "Zeilenauszug",
  "Import run precheck unified tabular error title": "Fehler",
  "Import run precheck unified tabular empty cell": "(leer)",
  "Import run precheck unified tabular empty": "keine Zeilen",
  "Import run precheck unified tabular loading": "CSV wird geladen …",
  "Import run precheck unified tabular load failed": "CSV-Zeilen konnten nicht geladen werden.",
  "Import run precheck unified positives not yet in sample": "positive Beispiele liegen außerhalb der aktuell geladenen Stichprobe.",
  "Import run precheck unified tabular partial loaded": "Stichprobe reduziert geladen ({0} Zeilen), für betroffene Zeilen bis {1} mehr laden.",
  "Import run precheck unified fk strict hint":
    "Einzelheiten in der Quellstichprobe unten. Import mit leerem Schlüssel nur sinnvoll, wenn die Zieldatensätze existieren.",
  "Import run precheck unified enum solution headline": "Enum-Zuordnung „{0}“: {1} ungültige Werte",
  "Import run precheck unified enum solution source target": "Feldmapping: {0}",
  "Import run precheck unified enum solution map heading": "Quellwerte auf Zielwerte abbilden",
  "Import run precheck unified enum solution map source col": "Quellwert",
  "Import run precheck unified enum solution map target col": "Zielwert",
  "Import run precheck unified enum solution map target placeholder": "Zielwert wählen oder eingeben",
  "Import run precheck unified enum solution map use entered": "„{0}“ verwenden",
  "Import run precheck unified enum solution map apply": "Zuordnung übernehmen",
  "Import run precheck unified enum solution map applied": "Zuordnung übernommen.",
  "Import run precheck unified enum solution option disable": "oder Feld für den Import deaktivieren",
  "Import run precheck unified enum solution decision disable field": "Feld {0} nicht importieren",
  "Import run precheck unified enum solution rerun": "Nach dem Speichern der Änderungen Precheck erneut ausführen.",
  "Import run precheck unified enum solution decision apply failed": "Enum-Zuordnung konnte nicht gespeichert werden.",
  "Import run precheck unified enum solution decision applied": "Enum-Zuordnung gespeichert.",
  "Import run precheck unified fk diagnosis source empty": "Quellschlüsselspalte ist leer.",
  "Import run precheck unified fk diagnosis source unresolved": "Quellschlüssel konnte entlang des konfigurierten Pfads nicht aufgelöst werden.",
  "Import run precheck unified fk diagnosis target missing": "passender Zieldatensatz wurde nicht gefunden.",
  "Import run precheck unified fk diagnosis generic": "Fremdschlüssel konnte nicht aufgelöst werden.",
  "Import run precheck navigate to field": "Feld im Mapping öffnen",
  "Import run precheck unified fk path break config error label": "Mapping-/Konfigurationsproblem",
  "Import run precheck unified fk target field label": "Zielfeld",
  "Import run precheck unified source column inline label": "Quellspalte",
  "Import run precheck unified fk path label": "Auflösungspfad",
  "Import run precheck unified fk path break config error": "Pfad unterbrochen bei Schritt {0}{1}",
  "Import run precheck unified fk path break with reason": "Pfad unterbrochen bei Schritt {0}: {1}",
  "Import run precheck unified fk path break label": "Pfad unterbrochen bei Schritt {0}",
  "Import run precheck unified fk target label": "Ziel",
  "Import run precheck unified rows table source": "Quelltabelle: {0}",
  "Import run precheck unified tabular rows beyond preview":
    "{0} betroffene Zeile(n) liegen außerhalb der geladenen Vorschau.",
  "Import run precheck unified fk dep exclusion schema filter": "Schemafilter",
  "Import run precheck unified fk dep exclusion dedup": "Duplikat-Erkennung",
  "Import run precheck unified fk dep exclusion conditional rule": "bedingte Regel (SkipRow)",
  "Import run precheck unified fk dep exclusion enum unmapped": "Enum-Zuordnung (kein Treffer)",
  "Import run precheck unified fk dep exclusion precheck decision": "Precheck-Entscheidung (Zeilen überspringen)",
  "Import run precheck unified fk dep total rows": "{0} Zeilen gesamt",
  "Import run precheck unified sample keys skipped rows": "{0} in übersprungenen Zeilen",
  "Import run precheck unified sample keys schema filter": "{0} per Schema-Filter",
  "Import run precheck unified sample keys not in source": "{0} nicht in Quelldatei",
  "Import run precheck unified sample keys label": "Beispiel-Schlüssel (Spalte {0}): {1}",
  "Import run precheck cause fk keys missing in source": "Die FK-Schlüssel existieren nicht in der Quelltabelle \"{0}\". Ohne Datenkorrektur nicht auflösbar.",
  "Import run precheck cause manually skipped entries": "{0} manuell übersprungene {1}-Einträge",
  "Import run precheck cause schema filtered entries": "{0} durch Schemafilter ausgeschlossene {1}-Einträge{2}",
  "Import run precheck cause unmapped enum entries": "{0} durch fehlendes Enum-Mapping ausgeschlossene {1}-Einträge",
  "Import run precheck cause deduplicated entries": "{0} durch Deduplizierung ausgeschlossene {1}-Einträge",
  "Import run precheck cause conditional rule entries": "{0} durch bedingte Regel ausgeschlossene {1}-Einträge",
  "Import run precheck cause final with target": "{0}. Diese {1}-Zeilen haben keinen auflösbaren Zieleintrag mehr.",
  "Import run precheck cause final without target": "{0}. Diese Zeilen haben keinen auflösbaren Zieleintrag mehr.",
  "Import run precheck entity filter detail suffix": ": {0}",
  "Import run precheck entity filter dedup detail suffix": " (Schlüssel: {0})",
  "Import run precheck entity filter enum detail suffix": " (Felder: {0})",
  "Import run precheck entity filter schema": "{0} per Zeilenfilter (Entitätsebene){1}",
  "Import run precheck entity filter conditional rule": "{0} per bedingter Regel{1}",
  "Import run precheck entity filter dedup": "{0} per Deduplizierung{1}",
  "Import run precheck entity filter enum": "{0} wegen fehlendem Enum-Mapping{1}",
  "Import run precheck entity filter message": "{0} {1}-Zeilen werden durch Konfigurationsfilter ausgeschlossen.{2}",
  "Import run precheck unified fk kind optional fk": "optionaler FK",
  "Import run precheck unified fk kind strict fk": "strikter FK",
  "Import run precheck unified fk kind empty fk source": "leere FK-Quelle",
  "Import run precheck unified fk kind validation fk": "Validierungs-FK",
  "Import run precheck unified fk kind other": "Validierungsfehler",
  "Import run precheck unified fk kind contract calendar": "Mitgliedschaftskalender",
  "Import run precheck unified fk strict overlap rows":
    "{0} dieser Zeilen werden bereits durch eine andere strikte FK-Prüfung für dieselbe Entität ausgeschlossen.",
  "Import run precheck warnings unified title": "weitere Hinweise (Vorschau)",
  "Import run precheck warnings unified fk heading": "Fremdschlüssel / Zuordnung",
  "Import run precheck warnings unified other heading": "Sonstiges",
  "Import run precheck warnings technical diagnostics in debug": "Technische Filter-Hinweise ({0}): vollständiger Text im Debug-Export unten — dort absichtlich zusammengefasst, damit dieselben Meldungen nicht zusätzlich in dieser Box stehen.",
  "Import run precheck sample data section title": "Quellstichprobe",
  "Import run precheck sample include ok rows": "fehlerfreie Beispielzeilen einblenden",
  "Import run precheck sample data intro":
    "Zeilen der gewählten CSV-Tabelle: fehlerhafte markiert; optional bis zu fünf fehlerfreie Zeilen zum Vergleich (passt zu den Einträgen im Prüfergebnis).",
  "Import run precheck sample only errors none in preview":
    "In der geladenen Vorschau keine der betroffenen Fehlerzeilen – ggf. andere Tabelle wählen oder mehr Zeilen laden.",
  "Import run precheck sample tag validation": "{0}× Validierung",
  "Import run precheck sample tag file missing": "{0}× Datei fehlt",
  "Import run precheck sample tag file ambiguous": "{0}× Datei mehrdeutig",
  "Import run precheck row status validation": "Validierung",
  "Import run precheck row status strict fk unresolved": "Verknüpfung fehlt",
  "Import run precheck sample tag strict fk": "{0}× Verknüpfung fehlt",
  "Import run precheck row status file missing": "Datei fehlt",
  "Import run precheck row status file ambiguous": "Datei mehrdeutig",
  "Import run precheck missing files block title": "Dateireferenzen (Fotos/Dokumente)",
  "Import run precheck file kind photo": "Personenfoto",
  "Import run precheck file kind document": "Personendokument",
  "Import run precheck file kind ambiguous": "Foto mehrdeutig",
  "Import run precheck missing file effect photo": "Fehler: Foto nicht gefunden",
  "Import run precheck missing file effect document": "Ohne Treffer: Dokumentzeile entfällt.",
  "Import run precheck missing file effect ambiguous": "mehrere Dateien passen – Referenz im Quellsystem präzisieren.",
  "Import run precheck missing file single field": "Personenfoto",
  "Import run precheck ambiguous photo field": "Foto mehrdeutig",
  "Import run precheck missing file whole row": "Personendokument",
  "Import run precheck missing file list": "Fehlende Referenzen (Beispiele, max. 50):",
  "Import run precheck missing file list exact": "Diese Werte wurden nicht gefunden (exakt so, nach Konverter/Stamm – Beispiele, max. 50):",
  "Import run precheck missing file list more": "… und {0} weitere",
  "Import run precheck missing file search path label": "Suche unter",
  "Import run precheck missing file stats line": "von {0} Referenzen: {1} mit eindeutigem Treffer in den Import-Dateien, {2} ohne Treffer{3}",
  "Import run precheck missing file stats ambiguous suffix": " · {0} mehrdeutig",
  "Import run precheck missing file counts label": "Dateireferenzen",
  "Import run precheck missing file counts with total": "geprüft: {0}, gefunden: {1}, fehlend: {2}, mehrdeutig: {3}",
  "Import run precheck missing file counts missing only": "fehlend: {0}",
  "Import run precheck missing file badge ok": "ok: {0}",
  "Import run precheck missing file badge missing": "fehlend: {0}",
  "Import run precheck missing file badge ambiguous": "mehrdeutig: {0}",
  "Import run precheck entity pending file checkbox": "noch offen",
  "Import run precheck missing file decision pending": "noch zu bestätigen: {0} Quelltabelle(n) – Checkbox je Karte.",
  "Import run precheck missing photo accept action": "fehlende Fotos beim Import leer lassen",
  "Import run precheck missing document accept action": "fehlende Dokumente beim Import nicht anlegen (kein Dokument setzen)",
  "Import run precheck missing file decision required title": "Dateifehler noch nicht entschieden",
  "Import run precheck missing file decision required details": "Bitte im Prüfergebnis bei jedem offenen Datei-Eintrag die Checkbox setzen.",
  "Import run precheck missing file decision required tables": "Quelltabellen ohne Entscheidung:",
  "Import run precheck resolved file table title": "Aufgelöste Treffer (Beispiele, max. 20)",
  "Import run precheck resolved file col path": "Aufgelöster Pfad",
  "Import run precheck missing file list row fallback": "Nur Zeilennummern (Referenzwerte nicht geliefert)",
  "Import run precheck missing file col status": " ",
  "Import run precheck missing file rows affected": "{0} Zeilen ohne Treffer (keine Detailstichprobe).",
  "Import run precheck missing file col row": "Zeile",
  "Import run precheck missing file col cell": "Inhalt der Zelle",
  "Import run precheck missing file col path": "Suchmuster (kein Treffer)",
  "Import run precheck col status": "Status",
  "Import run precheck status ok": "ok",
  "Import run precheck status error": "fehlerhaft",
  "Import run precheck status missing": "fehlend",
  "Import run precheck status ambiguous": "mehrdeutig",
  "Import run precheck table sample ok": "Beispielzeilen ok: {0}",
  "Import run precheck table sample error": "Beispielzeilen fehlerhaft: {0}",
  "Import run precheck row label": "Zeile",
  "Import run fill empty created at updated at": "diese Fehler akzeptieren und betroffene Felder beim Import mit Standardwerten füllen",
  "Import run commit": "Import ausführen",
  "Import run commit confirm": "Daten in die Mandanten-DB schreiben und Dateien übernehmen? Danach kann bei Bedarf über „Import rückgängig machen“ ein zurückrollen gestartet werden.",
  "Import run commit success": "Import ausgeführt: {0}.",
  "Import run commit error": "Import fehlgeschlagen.",
  "Import run commit error detail intro": "Folgende Fehler sind aufgetreten:",
  "Import run commit imported rows": "{0} Datensätze importiert",
  "Import run commit failed details": "Folgende Fehler sind aufgetreten:",
  "Import run already committed": "Dieser Importvorgang wurde bereits ausgeführt.",
  "Import run commit files copied": "{0} Dateien kopiert",
  "Import run rollback": "Import zurückrollen",
  "Import run rollback confirm": "Alle durch diesen Importlauf angelegten Daten werden gelöscht. Hochgeladene Quelldateien bleiben erhalten, sodass ein erneuter Import ohne Upload möglich ist. Fortfahren?",
  "Import run rollback success": "Import wurde zurückgerollt.",
  "Import run rollback error": "Fehler beim zurückrollen.",
  "Import run precheck cluster siblings title": "{0} weitere(r) Fehler betrifft dieselben Zeilen:",
  "Import run precheck cluster siblings hint": "Die Entscheidung auf dieser Karte wirkt auf alle aufgelisteten Fehler gleichzeitig.",
  "Import run admin actions title": "Aktionen nach Import",
  "Import run rollback tooltip": "Alle durch diesen Importlauf importierten Daten entfernen. Die hochgeladenen Quelldateien bleiben erhalten, sodass ein erneuter Import ohne Upload möglich ist.",
  "Import precheck sort label": "Sortierung",
  "Import precheck sort default": "Standard (wie geprüft)",
  "Import precheck sort by severity": "nach Wichtigkeit (blockierend zuerst)",
  "Import precheck sort by status": "nach Status (offen zuerst)",
  "Import precheck sort by source table": "nach Quelltabelle (A–Z)",
  "Import precheck hide info groups": "Infofelder ausblenden ({0})",
  "Import precheck info groups hidden empty": "Alle Infofelder sind ausgeblendet.",
  "Import run cleanup storage": "Quelldateien löschen",
  "Import run cleanup storage tooltip": "hochgeladene CSVs, Bilder und Dokumente aus dem Speicher entfernen (z. B. nach erfolgreicher Importausführung, um Platz freizugeben).",
  "Import run cleanup storage confirm": "Alle hochgeladenen Quelldateien dieses Importlaufs werden unwiderruflich aus dem Speicher gelöscht. Ein erneuter Import oder ein zurückrollen ist danach nur nach erneutem Upload möglich. Fortfahren?",
  "Import run cleanup storage success": "Quelldateien wurden aus dem Speicher entfernt.",
  "Import run cleanup storage error": "Quelldateien konnten nicht gelöscht werden.",
  "Back to Import runs": "zurück zu Mapping-Importen",
  "Import run page heading bare": "Importvorgang",
  "Import run page heading with schema": "Importvorgang {0}",
  "Import run not found": "Importvorgang nicht gefunden.",
  "Import run load error": "Importvorgang konnte nicht geladen werden.",
  "Import schema confirm delete": "Import-Schema wirklich löschen?",
  "Import schema add": "Schema anlegen",
  "Import schema create": "Schema erstellen",
  "Import schema create description": "Ohne Datei: Es wird das aktuelle System-Mapping als Vorlage verwendet (wie auf der Seite „Ziel-Mapping-Schema“). Mit hochgeladener JSON-Datei wird ein bestehendes Schema übernommen. Bei älterem Stand kann das Schema später auf das aktuelle Mapping aktualisiert werden.",
  "Import schema create from template": "Schema erstellen",
  "Import schema create from template description": "Ohne Datei wird das aktuelle System-Mapping als Vorlage verwendet. Mit JSON-Datei wird das Schema übernommen (bei älterem Stand später aktualisierbar).",
  "Import schema created from template": "Import-Schema erstellt.",
  "Import schema upload json optional": "Schema-JSON",
  "Import schema upload json hint": "JSON-Datei hier ablegen oder klicken. Ohne Datei wird das aktuelle System-Mapping als Vorlage verwendet.",
  "Import schema update from template": "Auf aktuelles Mapping aktualisieren",
  "Import schema update from template hint": "Übernimmt das aktuelle m1member-Datenmodell und behält Ihre Quellzuordnungen (SourceTable, SourceColumn, Konverter) bei. Neue Tabellen/Felder werden ergänzt. Bereits ausgefüllte Kurztexte (ShortDescription) pro Tabelle/Feld bleiben unverändert; leere werden aus dem System übernommen.",
  "Import schema outdated save to update hint": "Speichern Sie das Schema zuerst; danach steht die Schaltfläche „aus Vorlage aktualisieren“ zur Verfügung.",
  "Import schema updated from template": "Schema wurde auf das aktuelle Mapping aktualisiert.",
  "Import schema updated from template locally": "Schema-Update wurde übernommen. Bitte speichern, um Mapping und Relationen ins Schema zu schreiben.",
  "Import schema update from template error": "Schema konnte nicht auf das aktuelle Mapping aktualisiert werden.",
  "Import schema tenant resolution fallback warning": "{0} Ziel-Zuordnungen wurden im aktuellen Mandanten nicht gefunden und fallen beim Speichern auf Import zurück.",
  "Import schema template merge preview title": "Schema-Update prüfen",
  "Import schema template merge confirm": "Änderungen übernehmen",
  "Import schema template merge preview summary": "{0} Feld-Konfigurationen und {1} Ziel-Konfigurationen bleiben erhalten.",
  "Import schema template merge lost config warning": "{0} vorhandene Konfigurationen würden durch dieses Update entfernt, weil die zugehörige Tabelle oder Spalte im aktuellen Datenmodell nicht mehr existiert. Bitte prüfen Sie die Details vor dem Übernehmen.",
  "Import schema template merge no lost config": "Es wurden keine vorhandenen Zuordnungen oder Konfigurationen gefunden, die durch das Update verloren gehen.",
  "Import schema template merge no changes in group": "keine Änderungen in dieser Gruppe.",
  "Import schema template merge added targets": "neue Zieltabellen ({0})",
  "Import schema template merge removed targets": "Entfernte Zieltabellen ({0})",
  "Import schema template merge added fields": "neue Felder ({0})",
  "Import schema template merge removed fields": "Entfernte Felder ({0})",
  "Import schema template merge lost configured targets": "Konfigurierte Zieltabellen, die entfernt würden ({0})",
  "Import schema template merge lost configured fields": "Konfigurierte Felder, die entfernt würden ({0})",
  "Import schema refresh column descriptions": "Spaltenkurztexte aktualisieren",
  "Import schema refresh column descriptions hint": "Überschreibt alle Kurzbeschreibungen (ShortDescription) aus dem aktuellen Datenmodell in Ihrer UI-Sprache, auch manuell geänderte Texte. Zuordnungen (SourceTable, SourceColumn, Konverter) bleiben unverändert. Ohne diese Schaltfläche bleiben eigene Kurztexte beim Laden und bei „auf aktuelles Mapping aktualisieren“ erhalten (leere Felder werden weiterhin automatisch befüllt). Neue Tabellen oder Spalten: zuerst „auf aktuelles Mapping aktualisieren“.",
  "Import schema refreshed column descriptions": "Spaltenkurztexte wurden aktualisiert.",
  "Import schema refresh column descriptions error": "Spaltenkurztexte konnten nicht aktualisiert werden.",
  "Import schema template status outdated": "Schema basiert auf einem älteren Stand des Datenmodells. Aktualisierung verfügbar.",
  "Import schema template status up to date": "Schema entspricht dem aktuellen Mapping.",
  "Import schema download mapping": "Mapping herunterladen",
  "Import schema duplicated": "Import-Schema dupliziert.",
  "Import schema duplicate error": "Import-Schema konnte nicht dupliziert werden.",
  "Import schema deleted": "Import-Schema gelöscht.",
  "Import schema delete error": "Import-Schema konnte nicht gelöscht werden.",
  "Import schema in use cannot delete": "Das Schema wird noch von mindestens einem Importlauf verwendet und kann nicht gelöscht werden.",
  "Import schema json required": "Schema-JSON ist erforderlich.",
  "Import schema load error": "Import-Schema konnte nicht geladen werden.",
  "Import schema changed since load": "Das Import-Schema wurde inzwischen geändert. Bitte neu laden und die Änderung erneut prüfen.",
  "Import schemas": "Mapping-Vorlagen",
  "Import schemas column name": "Name",
  "Import schemas column source tag": "Quellsystem",
  "Import schemas column source tag hint": "Freitext, nur zur Kennzeichnung (z. B. CenterCom 2.4). Wird beim Import nicht ausgewertet.",
  "Import schemas column tenant": "Mandant",
  "Import schemas column tenant hint":
    "Optional. Nur für Listenfilter und Zuordnung. Für den eigentlichen Import gilt der Mandant des Laufs.",
  "Import schemas column updated": "aktualisiert",
  "Import schemas name required": "Name ist erforderlich.",
  "Import schema mapping": "Zuordnung",
  "Import schema edit drawer title": "Schema bearbeiten",
  "Import schema duplicate drawer title": "Kopie anlegen",
  "Import schema duplicate copy suffix": "Kopie",
  "Import schema mapping edit": "Mapping bearbeiten",
  "Import schema source relations title": "Quell-Relationen",
  "Import schema source relations hint": "Relations-JSON laden, damit FK-Zuordnungen/Lookup im Mapping automatisch besser vorgeschlagen werden.",
  "Import schema source relations status": "Relationen geladen: {0} Entitäten, {1} Kanten",
  "Import schema source relations missing": "keine Quell-Relationen im Schema hinterlegt.",
  "Import schema source relations import button": "Relations-JSON laden",
  "Import schema source relations download button": "Relations-JSON herunterladen",
  "Import schema source relations remove button": "Relationen entfernen",
  "Import schema source relations imported": "Relationen geladen ({0} Entitäten, {1} Kanten).",
  "Import schema source relations removed": "Quell-Relationen entfernt.",
  "Import schema source relations import error": "Relations-JSON konnte nicht geladen werden.",
  "Import schema mapping import button": "Mapping-JSON laden",
  "Import schema mapping remove button": "Mapping entfernen",
  "Import schema mapping imported": "Mapping-JSON geladen.",
  "Import schema mapping loaded status": "Mapping-JSON wurde geladen.",
  "Import schema mapping removed": "Mapping entfernt.",
  "Import schema mapping import error": "Mapping-JSON konnte nicht geladen werden.",
  "Import schema mapping run hint": "Importlauf auswählen, um Quelltabellen und -spalten zu laden.",
  "Import schema mapping source table": "Quelltabelle",
  "Import schema mapping source table default": "Standard-Quelltabelle",
  "Import schema mapping source table manual": "manuell",
  "Import schema mapping source table mode direct": "direkt",
  "Import schema mapping source table mode lookup": "nachschlagen",
  "Import schema mapping relation hint": "Bezug: {0}.id über {1}.{2}",
  "Import schema mapping relation marker short": "Bezug",
  "Import schema mapping relation source marker": "Bezugsschlüssel",
  "Import schema mapping relation locked": "automatisch über Bezug",
  "Import schema mapping relation selector placeholder": "Relation wählen",
  "Import schema mapping relation selector applied": "Relation übernommen.",
  "Import schema mapping lookup assistant": "Lookup-Assistent",
  "Import schema mapping lookup assistant path": "Pfad",
  "Import schema mapping lookup assistant coverage": "Trefferquote",
  "Import schema mapping lookup assistant apply": "übernehmen",
  "Import schema mapping lookup assistant continue": "als nächste Basis",
  "Import schema mapping lookup assistant resolve paths": "Pfade auflösen",
  "Import schema mapping lookup assistant empty": "keine passenden Lookup-Vorschläge gefunden.",
  "Import schema mapping lookup assistant load error": "Lookup-Vorschläge konnten nicht geladen werden.",
  "Import schema mapping lookup assistant applied": "Lookup-Vorschlag übernommen.",
  "Import schema mapping lookup assistant missing base table": "Bitte zuerst eine Quelltabelle für die Zieltabelle auswählen.",
  "Import schema mapping lookup assistant current base": "aktuelle Basis: {0} · Schlüssel: {1}",
  "Import schema mapping lookup assistant current path": "aktuelle Feldauswahl (manuell): {0}.{1} -> {2}.{3}",
  "Import schema mapping lookup assistant current relation path": "aktueller Feldpfad: {0}",
  "Import schema mapping lookup assistant relation type current": "Beziehungsart: manuelle aktuelle Auswahl",
  "Import schema mapping lookup assistant relation type schema": "Beziehungsart: Schema-Relation",
  "Import schema mapping lookup assistant relation type indexed": "Beziehungsart: indizierte Relation",
  "Import schema mapping lookup assistant target resolution": "Zielauflösung: {0} -> {1}.{2}",
  "Import schema mapping lookup assistant target resolution full path": "Zielauflösung: {0}",
  "Import schema mapping lookup assistant target source": "Zielquelle: {0}.{1}",
  "Import schema mapping lookup assistant target resolution unknown": "Zielauflösung: nicht eindeutig",
  "Import schema mapping lookup assistant id path": "ID-Pfad",
  "Import schema mapping lookup assistant no schema path hint": "kein Pfad im Relations-JSON: Von der aktuellen Quelle wurde keine Schema-Relation zur FK-Zielquelle gefunden.",
  "Import schema mapping lookup assistant mode target": "führt zur Ziel-Entität",
  "Import schema mapping lookup assistant mode step": "Zwischenschritt (mehrstufige Kette)",
  "Import schema mapping lookup assistant known only": "nur bekannte Relationen",
  "Import schema mapping lookup assistant known only no relation": "Für dieses Feld ist keine bekannte Relation im Relations-JSON vorhanden.",
  "Import schema mapping lookup assistant manual title": "manueller Pfad (Tabelle + Spalte)",
  "Import schema mapping lookup assistant relation path title": "Pfad für die Relation",
  "Import schema mapping lookup assistant take path": "Pfad nach oben übernehmen",
  "Import schema mapping lookup assistant manual table": "Tabelle",
  "Import schema mapping lookup assistant manual column": "Spalte",
  "Import schema mapping lookup assistant manual missing": "Bitte zuerst Tabelle und Spalte auswählen.",
  "Import schema mapping lookup assistant multi select hint": "Mehrere Spalten in jeder Pfadstufe ergeben zusammengesetzte Brücken, mehrere Spalten am Endpunkt ergeben zusammengesetzte Treffer.",
  "Import schema mapping lookup assistant id field hint": "Eine Spalte → Primärschlüsselquelle. Mehrere Spalten → zusammengesetzte Identität pro Quellzeile.",
  "Import schema mapping lookup assistant mixed source warning": "Zusammengesetzte Spalten müssen aus derselben Quelltabelle bzw. demselben Quellpfad stammen.",
  "Import schema mapping lookup assistant id field multi select warning": "Primärschlüsselfelder müssen genau eine Quellspalte haben. Zusammengesetzte Zuordnungen sind nur für FK-Felder zulässig.",
  "Import schema mapping source cell composite reset tooltip": "Composite-Lookup zurücksetzen",
  "Import schema mapping source cell bridge reset tooltip": "Bridge-Pfad zurücksetzen",
  "Import schema mapping lookup assistant path add row": "Pfadzeile hinzufügen",
  "Import schema mapping lookup assistant path remove row": "Pfadzeile entfernen",
  "Import schema mapping lookup assistant path details": "Pfaddetails",
  "Import schema mapping lookup assistant result column": "Ergebnis-Spalte",
  "Import schema mapping lookup assistant result column final": "Ziel-ID",
  "Import schema mapping lookup assistant result column intermediate": "Weitergabespalte",
  "Import schema mapping lookup assistant output column": "Ausgabe",
  "Import schema mapping lookup assistant result column placeholder": "optional: Wert für nächsten Schritt",
  "Import schema mapping lookup assistant path filter": "Filter",
  "Import schema mapping lookup assistant path filter count": "{0} Filter",
  "Import schema mapping lookup assistant path filter empty": "keine Filter",
  "Import schema mapping lookup assistant path filter add": "Schrittfilter hinzufügen",
  "Import schema mapping lookup assistant path filter remove": "Schrittfilter entfernen",
  "Import schema mapping lookup assistant path filter column": "Filterspalte",
  "Import schema mapping lookup assistant path filter value": "Wert",
  "Import schema mapping lookup assistant filter include": "Begriffe einschließen",
  "Import schema mapping lookup assistant filter exclude": "Begriffe ausschließen",
  "Import schema mapping lookup assistant filter suggestions": "Vorschläge nach Tabelle oder Spalte filtern …",
  "Import schema mapping lookup assistant filter no match": "kein Vorschlag entspricht der Suche. Anderen Suchbegriff eingeben.",
  "Import schema mapping lookup assistant check path": "Pfad prüfen",
  "Import schema mapping lookup assistant check path missing": "Bitte mindestens zwei vollständige Pfadzeilen auswählen.",
  "Import schema mapping lookup assistant check path running": "Pfad wird geprüft …",
  "Import schema mapping lookup assistant check path success": "Pfad ist auflösbar.",
  "Import schema mapping lookup assistant check path failed segment": "Pfad ist nicht auflösbar: {0}.",
  "Import schema mapping lookup assistant max tables": "maximale Tabellen",
  "Import schema mapping lookup assistant debug": "Debug-Log",
  "Import schema mapping lookup assistant debug clear": "leeren",
  "Import schema mapping lookup assistant debug empty": "Noch keine Debug-Einträge.",
  "Import schema mapping mode": "Modus",
  "Import schema mapping disabled hint": "Import für diese Tabelle ist deaktiviert. Feldzuordnung und Enum-Zuordnung sind ausgeblendet.",
  "Import schema mapping mode import": "importieren",
  "Import schema mapping mode reference": "nur Referenzmapping",
  "Import schema mapping mode hybrid": "Hybrid (Referenz + Import)",
  "Import schema mapping reference source label column": "Anzeigespalte",
  "Import schema mapping reference source label column placeholder": "Quell-Bezeichnung",
  "Import schema mapping reference source label": "Quellbezeichnung",
  "Import schema mapping enum source label column": "Anzeigespalte",
  "Import schema mapping enum source label column placeholder": "Quell-Bezeichnung",
  "Import schema mapping enum source label": "Quellbezeichnung",
  "Import schema label path editor button": "Pfad …",
  "Import schema label path editor title": "Anzeigespalte über Pfad",
  "Import schema label path editor hint": "Wenn die Bezeichnung in einer verknüpften Tabelle liegt: Zieltabelle wählen und die Spalte, in der die Quell-ID steht. Die Anzeigespalte ist die Klartext-Spalte in dieser Zieltabelle.",
  "Import schema label path editor hop table": "Verknüpfte Tabelle",
  "Import schema label path editor hop column": "Trefferspalte (enthält die Quell-ID)",
  "Import schema label path editor label column": "Anzeigespalte in der verknüpften Tabelle",
  "Import schema label path editor base relations": "vorhandene Basis-Relation",
  "Import schema label path editor base relations placeholder": "aus gespeicherten Relationen wählen …",
  "Import schema label path editor save as base relation": "Diese Relation als Basis speichern (für andere Mappings wiederverwendbar)",
  "Import schema mapping source column": "Quellspalte",
  "Import schema mapping source column invalid for selected table": "Spalte nicht in gewählter Quelltabelle",
  "Import schema mapping source columns loading": "Spalten werden geladen …",
  "Import schema mapping source column or value": "Quellspalte/Wert",
  "Import schema mapping source csv file override": "Quell-CSV überschreiben",
  "Import schema mapping source csv file override hint": "Optional: Dateiname einer CSV aus diesem Importlauf; für diese Quelltabelle werden die Zeilen dann aus dieser Datei gelesen statt über die Standardzuordnung.",
  "Import schema mapping reference source column": "Referenz-Quellspalte",
  "Import schema mapping reference target id column": "Zielspalte (ID)",
  "Import schema mapping reference assignments title": "Zuordnung",
  "Import schema mapping reference hint": "Ordne hier Quell-IDs auf bestehende Ziel-IDs zu. Die referenzierte Tabelle wird nicht importiert, sondern nur für Fremdschlüssel aufgelöst.",
  "Import schema mapping reference step source": "1. Quelle festlegen",
  "Import schema mapping reference step mapping": "2. Quell-ID auf Ziel-ID zuordnen",
  "Import schema mapping reference source value": "Quell-ID",
  "Import schema mapping reference target value": "Ziel-ID",
  "Import schema mapping reference target label": "Zielbezeichnung",
  "Import schema mapping reference target null": "(NULL)",
  "Import schema mapping reference add row": "Zuordnung hinzufügen",
  "Import schema mapping reference options empty": "Für diese Ziel-Entität sind keine Zielwerte verfügbar.",
  "Import schema mapping reference values empty": "keine Referenz-Quellwerte gefunden. Bitte Referenz-Quellspalte wählen oder Vorschau laden.",
  "Import schema mapping enum values title": "Enum- und Werte-Zuordnung",
  "Import schema mapping enum values hint": "Feld „{0}“ nutzt Enum „{1}“. Diese Zuordnung wird global für alle Felder mit demselben Enum wiederverwendet.",
  "Import schema mapping enum values field select": "Enum-/Werte-Feld",
  "Import schema mapping enum values unavailable": "keine Enum- oder Werte-Zuordnung aktiv.",
  "Import schema mapping enum values unavailable hint": "Wähle in der Spalte „Konverter“ für ein Feld „Enum-Zuordnung“ oder „Werte-Zuordnung“, dann erscheint es hier.",
  "Import schema mapping enum values empty": "keine Quellwerte gefunden. Bitte Quellspalte wählen oder Vorschau laden.",
  "Import schema mapping enum source value": "Quellwert",
  "Import schema mapping enum source value title": "Quellwert: {0}",
  "Import schema mapping enum source value empty": "(leer)",
  "Import schema mapping enum source distinct loading": "Quellwerte werden geladen …",
  "Import schema mapping enum source count": "Anzahl in Quelle",
  "Import schema mapping enum target value": "Zielwert",
  "Import schema mapping mapping group id": "Mapping-Gruppe",
  "Import schema mapping mapping group id placeholder": "z. B. zahlungszyklus",
  "Import schema mapping enum group key mismatch": "Felder in derselben Mapping-Gruppe nutzen unterschiedliche Enum-Mapping-Schlüssel. Bitte angleichen.",
  "Import schema mapping enum group source column mismatch": "Felder in derselben Mapping-Gruppe sollten dieselbe Quellspalte haben.",
  "Import schema mapping enum ignore source case": "Groß-/Kleinschreibung bei Quellwerten ignorieren",
  "Import schema mapping enum composite column enum suffix": "Enum",
  "Import schema mapping enum composite column value suffix": "Wert",
  "Import schema mapping manual enum select placeholder": "Zielwert wählen",
  "Import schema mapping enum target null": "(NULL)",
  "Import schema mapping enum clear": "zurücksetzen",
  "Import schema mapping enabled": "aktivieren",
  "Import schema mapping enum conditional rules column": "bedingte Regeln",
  "Import schema mapping enum conditional rules tooltip": "Quelldatenkorrektur: Wert weicht in Sonderfällen vom Standardmapping ab. Erste passende Regel gewinnt.",
  "Import schema mapping enum conditional rules configured": "bedingte Regeln (konfiguriert)",
  "Import schema mapping enum conditional rules drawer title": "bedingte Regeln für \"{0}\"",
  "Import schema mapping enum conditional rules target heading": "abweichende Zielwerte (greift bei Treffer der Bedingungen)",
  "Import schema mapping enum conditional rules target value label": "Zielwert",
  "Import schema mapping enum conditional rules target value placeholder": "abweichender Zielwert",
  "Import schema mapping enum conditional rules property target placeholder": "abweichender Wert für diese Spalte",
  "Import schema mapping enum managed below": "über Enum-Zuordnung",
  "Import schema mapping enum option not specified": "nicht gesetzt",
  "Import schema mapping enum option male": "männlich",
  "Import schema mapping enum option female": "weiblich",
  "Import schema mapping enum option diverse": "divers",
  "Import schema mapping enum option mr": "Herr",
  "Import schema mapping enum option mrs": "Frau",
  "Import schema mapping enum label PersonKind": "Personenart",
  "Import schema mapping conditional rules": "bedingte Zuordnungsregeln",
  "Import schema mapping conditional rules action include row": "Zeile importieren",
  "Import schema mapping conditional rules action set value": "Wert setzen",
  "Import schema mapping conditional rules action skip row": "Zeile auslassen",
  "Import schema mapping conditional rules action negate": "Wert negieren (Vorzeichen umkehren)",
  "Import schema mapping conditional rules add": "Regel hinzufügen",
  "Import schema mapping conditional rules base table": "Basistabelle: {0}",
  "Import schema mapping conditional rules case sensitive": "Groß-/Kleinschreibung beachten",
  "Import schema mapping conditional rules clear": "Regeln leeren",
  "Import schema mapping conditional rules column": "Quellspalte",
  "Import schema mapping conditional rules condition add": "Bedingung hinzufügen",
  "Import schema mapping conditional rules condition remove": "Bedingung entfernen",
  "Import schema mapping conditional rules conditions title": "Bedingungen",
  "Import schema mapping conditional rules configured": "bedingte Regeln (konfiguriert)",
  "Import schema mapping conditional rules context missing": "Zuordnungskontext ist nicht verfügbar.",
  "Import schema mapping conditional rules drawer title": "bedingte Regeln: {0}",
  "Import schema mapping conditional rules empty": "Noch keine Regeln definiert.",
  "Import schema mapping conditional rules join and": "und",
  "Import schema mapping conditional rules join or": "oder",
  "Import schema mapping conditional rules manual only": "Bedingte Regeln sind nur bei manuellen Werten oder Fremdschlüsselfeldern möglich.",
  "Import schema mapping conditional rules missing base table": "Bitte zuerst eine Quelltabelle für dieses Ziel auswählen.",
  "Import schema mapping conditional rules operator contains": "enthält",
  "Import schema mapping conditional rules operator ends with": "endet mit",
  "Import schema mapping conditional rules operator equals": "gleich",
  "Import schema mapping conditional rules operator not contains": "enthält nicht",
  "Import schema mapping conditional rules operator not ends with": "endet nicht mit",
  "Import schema mapping conditional rules operator not equals": "ungleich",
  "Import schema mapping conditional rules operator not starts with": "beginnt nicht mit",
  "Import schema mapping conditional rules operator not wildcard": "entspricht nicht dem Platzhalter",
  "Import schema mapping conditional rules operator starts with": "beginnt mit",
  "Import schema mapping conditional rules operator wildcard": "entspricht Platzhalter",
  "Import schema mapping conditional rules preview action": "Aktion",
  "Import schema mapping conditional rules preview count": "{0} Treffer (von {1} Vorschauzeilen)",
  "Import schema mapping conditional rules preview count total": "gesamt",
  "Import schema mapping conditional rules preview empty": "keine Zeilen für die Vorschau.",
  "Import schema mapping conditional rules preview no match hint": "keine Treffer in der geladenen Stichprobe. Die Regel wird beim Import trotzdem auf alle Zeilen angewendet.",
  "Import schema mapping conditional rules preview load error": "Vorschaudaten konnten nicht geladen werden.",
  "Import schema mapping conditional rules preview target value": "Ergebniswert",
  "Import schema mapping conditional rules preview title": "Vorschau passender Zeilen",
  "Import schema mapping conditional rules preview value column": "Hervorgehobene Spalte",
  "Import schema mapping conditional rules remove": "Regel entfernen",
  "Import schema mapping conditional rules rule title": "Regel {0}",
  "Import schema mapping conditional rules target value": "Zielwert",
  "Import schema mapping conditional rules value": "Vergleichswert",
  "Import schema mapping conditional target enum key placeholder": "Enum-Zuordnungs-Key",
  "Import schema mapping conditional target enum mapping empty hint": "In diesem Schema sind keine Enum-Wertzuordnungen definiert. Legen Sie Enum-Zuordnungen an, um diese Option zu nutzen.",
  "Import schema mapping conditional target enum source placeholder": "Quellwert (aus Zuordnung)",
  "Import schema mapping conditional target mode enum mapping": "Enum-Zuordnung",
  "Import schema mapping conditional target mode literal": "Textwert",
  "Import schema mapping converter": "Konverter",
  "Import schema mapping converter enum": "Enum-Zuordnung",
  "Import schema mapping converter value map": "Werte-Zuordnung",
  "Import schema mapping converter related row exists": "verknüpfte Zeile existiert",
  "Import schema mapping converter related row missing": "verknüpfte Zeile existiert nicht",
  "Import schema mapping converter manual": "manuell",
  "Import schema mapping converter key disabled": "Schlüsselfeld – kein Konverter",
  "Import schema mapping tenant fixed": "fest auf Mandant",
  "Import schema mapping boolean true": "wahr",
  "Import schema mapping boolean false": "falsch",
  "Import schema mapping fixed value": "fester Wert",
  "Import schema mapping skip": "aktivieren",
  "Import schema mapping include table": "importieren",
  "Import schema mapping remove assignment button": "Zuordnungstabelle entfernen",
  "Import schema mapping remove assignment confirm title": "Zuordnungstabelle entfernen?",
  "Import schema mapping remove assignment confirm desc": "Die Zuordnung für „{0}“ wird entfernt. Das Basisschema bleibt unverändert.",
  "Import schema mapping remove assignment success": "Zuordnungstabelle entfernt.",
  "Import schema mapping target entity": "Ziel-Entität",
  "Import schema mapping show field comments": "Notizen",
  "Import schema mapping mapping short description": "ShortDescription",
  "Import schema mapping mapping notes": "Notizen",
  "Import schema mapping mapping short description placeholder": "Kurztext zur Quelle …",
  "Import schema mapping mapping notes placeholder": "Hinweis zur Quelle …",
  "Import schema mapping field": "Zielfeld",
  "Import schema mapping key field": "Schlüsselfeld",
  "Import schema mapping required field hint": "Pflichtfeld (NOT NULL) — muss zugeordnet werden",
  "Import schema mapping required field mapped hint": "Pflichtfeld zugeordnet",
  "Import schema mapping virtual field tag": "virtuell",
  "Import schema mapping save success": "Mapping gespeichert.",
  "Import schema mapping no run": "kein Importlauf",
  "Import schema mapping assigned steps": "zugeordnete Schritte",
  "Import schema mapping add more steps": "weitere Schritte",
  "Import schema mapping add assignment": "Zuordnung anlegen",
  "Import schema mapping unassigned hint": "{0} Ziel-Tabelle(n) ohne Zuordnung. Mit „Zuordnung anlegen“ können Sie Quelltabelle und Spalten zuweisen.",
  "Import schema edit json hint": "Ziel-Mapping (Targets, Felder, Konverter). Die konkrete Zuordnung zu Quelltabellen/Spalten erfolgt beim Import.",
  "Import schema json invalid": "Das Schema-JSON ist ungültig.",
  "Import schema json collapse label": "Schema (JSON)",
  "Import schema mapping no targets": "keine Ziel-Entitäten mit Feldern im Schema.",
  "Import schema mapping add step button": "hinzufügen",
  "Import schema mapping add section title": "weitere Tabelle hinzufügen",
  "Import schema mapping add section empty": "Alle Zieltabellen sind bereits gemappt.",
  "Import schema mapping step new table": "neue Tabelle zuordnen",
  "Import schema mapping step new table hint":
    "Wähle die nächste Ziel-Entität und die Quell-CSV. Nach dem Hinzufügen kannst du die Felder zuordnen. Mit „weiter“ gelangst du wieder zu diesem Schritt, solange noch Tabellen zugeordnet werden können.",
  "Import schema mapping table progress": "Tabelle {0} von {1}",
  "Import schema mapping source variant label": "Quellzuordnung {0} von {1}",
  "Import schema mapping source variant requires primary source":
    "aktiviere zuerst die erste Quellzuordnung für dieses Ziel, bevor du weitere Quellen nutzt.",
  "Import schema mapping source variant duplicate table warning":
    "zwei aktive Zuordnungen nutzen dieselbe Quelltabelle – Quelle ändern oder eine Zuordnung deaktivieren.",
  "Import schema mapping source variant missing key source warning":
    "mehrere Quellen für diese Entität und eingehende Verweise: bitte die ID aus einer Quellspalte zuordnen, damit Verweise eindeutig bleiben.",
  "Import schema mapping table title": "Feldzuordnung",
  "Import schema mapping table previous": "vorige Tabelle",
  "Import schema mapping table next": "nächste Tabelle",
  "Import schema mapping add step modal title": "Schritt aus Vorlage hinzufügen",
  "Import schema mapping add step select entity": "Ziel-Entität",
  "Import schema mapping add step no options": "keine weiteren Entitäten in der Vorlage.",
  "Admin sign in": "Admin-Anmeldung",
  "Administrator": "Administrator",
  "Advance (days)": "Vorlauf (Tage)",
  "Advance Booking Period (Days)": "Vorlauf für Kalenderbuchungen (Tage)",
  "Advanced filters": "erweiterte Filter",
  "Advanced filters active": "erweiterte Filter aktiv",
  "Advanced filters…": "erweiterte Filter…",
  "Advanced search": "erweiterte Suche",
  "Advanced search active": "erweiterte Suche aktiv",
  "Advanced search…": "erweiterte Suche…",
  "Person detail no access embedded": "kein Zugriff auf diese Person.",
  "Person detail no access redirect to list": "kein Zugriff auf diese Person. Sie wurden zur Personenliste zurückgeleitet.",
  "Person detail not found embedded": "Diese Person wurde nicht gefunden.",
  "Person detail not found redirect to list": "Diese Person wurde nicht gefunden. Sie wurden zur Personenliste zurückgeleitet.",
  "all": "alle",
  "All changes deleted.": "Alle Änderungen wurden gelöscht.",
  "All categories": "alle Kategorien",
  "All custom holidays and exclusions in this scope will be removed. Continue?": "Alle benutzerdefinierten Feiertage und Ausblendungen in diesem Bereich werden entfernt. Fortfahren?",
  "Holiday calendar assignment and all custom holidays in this scope will be removed. The scope can be added again later. Continue?": "Die Feiertagskalender-Zuordnung und alle eigenen Feiertage in diesem Bereich werden entfernt. Fortfahren?",
  "All scopes already have a holiday configuration.": "Jeder Bereich (Mandanten-Standard und jedes Studio) darf nur einmal vorkommen.",
  "All Direct Debits": "alle Lastschriften",
  "All errors have been fixed. You can now download the SEPA file.": "Alle Fehler wurden behoben. Sie können die SEPA-Datei nun herunterladen.",
  "All groups": "alle Gruppen",
  "All leads": "alle Kontakte",
  "All permitted studios": "alle erlaubten Studios",
  "All resources": "alle Ressourcen",
  "All resources available in this booking. Empty = derive from selected appointment types. Multiple selection possible (e.g. same appointment type bookable twice).": "alle Ressourcen, die in dieser Buchung verfügbar sein sollen. Leer = aus den gewählten Terminarten ableiten. Mehrfachauswahl möglich (z. B. gleiche Terminart doppelt buchbar).",
  "all studios": "alle Studios",
  "all studios__alt1": "alle Standorte",
  "All statuses": "alle Statuswerte",
  "All types": "alle Typen",
  "All__alt2": "alles",
  "Allow Access": "Zutritt erlauben",
  "Allow Free Bookings": "kostenfreie Buchungen erlauben",
  "Allow Paid Bookings": "kostenpflichtige Buchungen erlauben",
  "Allow trial period cancellation": "Probezeit-Kündigung zulassen",
  "Allow withdrawal": "Widerruf zulassen",
  "Allowed": "erlaubt",
  "allowed": "erlaubt",
  "Allowed Actions": "erlaubte Aktionen",
  "Allowed studios": "erlaubte Studios",
  "Allow overlapping appointment bookings": "Überschneidende Terminbelegung erlauben",
  "Allows booking appointments despite overlaps or insufficient resource capacity.": "Erlaubt das Buchen von Terminen trotz Überschneidung oder unzureichender Ressourcen-Kapazität.",
  "Allows changing start and end time/duration when creating or editing appointments.": "Erlaubt das Ändern der Termindauer beim Anlegen und Bearbeiten von Terminen.",
  "Allows changing the appointment duration instead of using the duration from the appointment type.": "Erlaubt das Ändern der Termindauer statt der Dauer aus der Terminart.",
  "Allows changing the appointment price instead of using the appointment type price.": "Erlaubt das Ändern des Terminpreises statt des Preises aus der Terminart.",
  "Allows creating appointments outside stored resource or staff availability.": "Erlaubt das Anlegen von Terminen außerhalb hinterlegter Ressourcen- oder Mitarbeiter-Verfügbarkeit.",
  "Already paid": "bereits bezahlt",
  "Already posted": "bereits verbucht",
  "Amount": "Betrag",
  "Rows": "Zeilen",
  "Amount is required": "Betrag ist erforderlich",
  "Amount must be > 0": "Betrag muss > 0 sein",
  "Amount must be greater than 0": "Betrag muss größer als 0 sein",
  "Amount must not exceed balance.": "Betrag darf den Saldo nicht überschreiten.",
  "Amount must not exceed payment amount": "Betrag darf nicht größer als der Zahlungsbetrag sein",
  "Amount must not exceed selected payment total": "Betrag darf nicht größer als die Summe der ausgewählten Zahlungen sein",
  "Anytime": "jederzeit",
  "API key": "API-Schlüssel",
  "API key is required": "API-Schlüssel ist erforderlich",
  "App": "App",
  "Appearance": "Darstellung",
  "Append free time to end": "gratis ans Ende anhängen",
  "Append to end": "ans Ende anhängen",
  "Applies to": "gilt für",
  "Applies to ping/open/status requests from m1member to the gateway.": "Gilt für Ping-/Open-/Status-Anfragen von m1member zum Gateway.",
  "Apply all": "alle übernehmen",
  "Changes applied.": "Änderungen übernommen.",
  "Change applied.": "Änderung übernommen.",
  "Apply check-in settings": "Check-in-Einstellungen anwenden",
  "Apply to next due items": "mit Folgebeiträgen verrechnen",
  "Apply to studios__alt1": "für diese Studios",
  "Apply to studios__alt2": "für diese Studios übernehmen",
  "Apply__alt2": "übernehmen",
  "Appointment": "Termin",
  "Appointment cannot be moved to this resource.": "Der Termin kann nicht in diese Ressource verschoben werden.",
  "Appointment deleted": "Termin gelöscht",
  "Appointment Details": "Termindetails",
  "Appointment move from": "bisher",
  "Appointment move to": "neu",
  "Appointment moved.": "Termin verschoben.",
  "Appointment notifications": "Termin-Benachrichtigungen",
  "Appointment notification scope": "Studios",
  "Appointment notification scope tooltip": "Studios, in denen diese Vorlage bei Terminen wählbar ist. Leer = überall wählbar.",
  "Appointment notification template intro": "Diese Vorlage kann Terminen zugeordnet werden. Leer = für alle Studios wählbar, sonst nur für die ausgewählten Studios.",
  "Appointment outcomes": "Termin-Ergebnisse",
  "Appointment Type": "Terminart",
  "Appointment type": "Terminart",
  "Appointment participant status attended": "teilgenommen",
  "Appointment participant status cancelled by customer": "durch Kunde abgesagt",
  "Appointment participant status cancelled by studio": "durch Studio abgesagt",
  "Appointment participant status no-show": "nicht erschienen",
  "Appointment participant status planned": "geplant",
  "Appointment completion result": "Abschluss",
  "Appointment completion result none": "ohne Abschluss",
  "Appointment completion result open": "offen",
  "Appointment completion result successful": "erfolgreich",
  "Appointment completion result unsuccessful": "nicht erfolgreich",
  "Appointment status completed": "durchgeführt",
  "Appointment status no-show": "nicht erschienen",
  "Appointment status scheduled": "geplant",
  "Appointment type created": "Terminart angelegt",
  "Appointment type deleted": "Terminart gelöscht",
  "Appointment type is required": "Terminart ist erforderlich",
  "Appointment type updated": "Terminart aktualisiert",
  "Appointment types": "Terminarten",
  "appointment(s)": "Termin(e)",
  "Appointments": "Termine",
  "Arrears": "Rückstände",
  "Asset": "Aktivkonto",
  "Assign access medium": "Zutrittsmedium zuweisen",
  "Assigned automatically": "automatisch zugewiesen",
  "Assigned Persons": "zugewiesene Personen",
  "Assigned__alt2": "zuständig",
  "Assign": "zuweisen",
  "Assigned": "zugeordnet",
  "Assignments": "Zuordnung",
  "Assignment saved": "Zuordnung gespeichert",
  "Assignment reader": "Zuweisungsleser",
  "Assignment": "Zuweisung",
  "Assignments saved.": "Zuordnungen gespeichert.",
  "Reader device assignments conflict": "Diese Zuordnung existiert bereits. Lade die Zuordnungen neu und versuche es erneut.",
  "Reader device assignments save failed": "Zuordnungen konnten nicht gespeichert werden. Bitte lade die Seite neu und versuche es erneut.",
  "Reader device assignments save server error": "Zuordnungen konnten nicht gespeichert werden. Wenn das nach einem Update passiert, müssen wahrscheinlich die Datenbankmigrationen ausgeführt werden.",
  "Assignments__alt2": "Zuordnungen",
  "Assignments__zuordnung": "Zuordnung",
  "At least 8 characters": "mindestens 8 Zeichen",
  "At least one active tariff block is required.": "Mindestens ein aktiver Vertragsbaustein ist erforderlich.",
  "At least one digit": "mindestens eine Ziffer",
  "At least one lowercase letter": "mindestens ein Kleinbuchstabe",
  "At least one schedule is required": "Mindestens ein Rhythmus ist erforderlich",
  "At least one schedule is required.": "Mindestens ein Rhythmus ist erforderlich.",
  "At least one special character (!@#$%^&*...)": "mindestens ein Sonderzeichen (!@#$%^&*…)",
  "At least one uppercase letter": "mindestens ein Großbuchstabe",
  "Auto changelog saved": "automatisches Changelog gespeichert",
  "Auto-communication": "Auto-Kommunikation",
  "Auto-Refresh": "automatische Aktualisierung",
  "Automatic changelog entries…": "automatische Changelog-Einträge…",
  "Automatic changes (Cursor)": "automatische Änderungen (Cursor)",
  "Automatic emails & notifications": "automatische E-Mails & Benachrichtigungen",
  "Automatic SEPA direct debits": "automatische SEPA-Lastschrifteinzüge",
  "Automatic Updates": "automatische Updates",
  "Automatically determined from IBAN": "wird automatisch aus IBAN ermittelt",
  "Bank placeholder example": "z. B. Musterbank",
  "Automation": "Automatisierung",
  "Automation rules for leads": "Automatisierungsregeln für Kontakte",
  "Availabilities": "Verfügbarkeiten",
  "Availability": "Verfügbarkeit",
  "Available": "verfügbar",
  "Available folders:": "verfügbare Ordner:",
  "Available Placeholders": "verfügbare Platzhalter",
  "Available variables": "verfügbare Variablen",
  "Average Duration": "durchschnittliche Laufzeit",
  "Average Frequency": "durchschnittliche Frequenz",
  "Average per Month": "Durchschnitt pro Monat",
  "Average Utilization": "durchschnittliche Auslastung",
  "Avg Attendance": "Ø Teilnehmer",
  "Avg. check-ins per active member": "Ø Check-ins pro aktivem Mitglied",
  "Avg. Check-ins/Member": "Ø Check-ins/Mitglied",
  "Avg. per Day": "Ø pro Tag",
  "Avg. per Month": "Ø pro Monat",
  "Avg. per week": "Ø pro Woche",
  "Back": "zurück",
  "Back to Access & Devices": "zurück zu Zutritt & Geräte",
  "Back to Automation": "zurück zu Automatisierung",
  "Back to Calendar": "zurück zum Kalender",
  "Back to Calendar & Appointments": "zurück zu Kalender & Termine",
  "Back to Communication": "zurück zu Kommunikation",
  "Back to Contracts": "zurück zu Verträgen",
  "Back to default search": "zur Standardsuche",
  "Back to dashboard": "zurück zum Dashboard",
  "Back to inbox": "zurück zum Posteingang",
  "Back to direct debits": "zurück zu Lastschriften",
  "Back to direct debit run": "zurück zum Lastschriftlauf",
  "Back to finance": "zurück zu Finanzen",
  "Back to Finances": "zurück zu Finanzen",
  "Back to Leads": "zurück zu Kontakten",
  "Back to contract signing settings": "zurück zu Vertragsabschluss",
  "Back to login": "zurück zur Anmeldung",
  "Back to Member management": "zurück zu Mitgliederverwaltung",
  "Back to Members": "zurück zu Mitgliedern",
  "Back to Organisation & Users": "zurück zu Organisation & Benutzern",
  "Back to Payments & Billing": "zurück zu Zahlungen & Abrechnung",
  "Back to Products & Contracts": "zurück zu Produkten & Verträgen",
  "Back to reports": "zurück zu Auswertungen",
  "Back to report: {0}": "zurück zu {0}",
  "Back to sales": "zurück zu Vertrieb",
  "Back to sending": "zurück zu Versand",
  "Back to Admin": "zurück zu Admin",
  "Back to Admin Settings": "zurück zu Admin-Einstellungen",
  "Back to settings": "zurück zu Einstellungen",
  "Back to tools": "zurück zu Werkzeugen",
  "Back to System": "zurück zu System",
  "Back to Usage": "zurück zu Nutzung",
  "Back to Prospects": "zurück zu Interessenten",
  "Back to Former": "zurück zu Ehemalige",
  "Back to People": "zurück zu Personen",
  "Back to Open items": "zurück zu offenen Posten",
  "Back to Check-in": "zurück zu Check-in",
  "Back to Reminders": "zurück zu Mahnungen",
  "Back to duplicate finder": "zurück zum Duplikatfinder",
  "Back to tasks": "zurück zu Aufgaben",
  "Back to birthday list": "zurück zur Geburtstagsliste",
  "Back to custom lists": "zurück zu eigenen Listen",
  "Back to lead": "zurück zum Kontakt",
  "Back to list": "zurück zur Liste",
  "Background Color": "Hintergrundfarbe",
  "Background color": "Hintergrundfarbe",
  "Background Services": "Hintergrunddienste",
  "Scheduler tick interval (seconds)": "Scheduler-Prüfintervall (Sekunden)",
  "Scheduler tick interval (seconds) description": "Wie oft der Scheduler prüft, ob Dienste fällig sind (10–3600).",
  "Scheduler interval saved": "Scheduler-Intervall gespeichert",
  "Interval (minutes)": "Intervall (Minuten)",
  "Scheduled service holiday auto import": "automatischer Feiertagsabruf",
  "Scheduled service holiday auto import description": "importiert globale Feiertage (DE, AT, CH) gemäß Intervall",
  "Scheduled service bank data auto update": "automatische Bankabfrage",
  "Scheduled service bank data auto update description": "aktualisiert Bankdaten (Bundesbank) gemäß Intervall und Konfiguration",
  "Scheduled service gateway ping": "Gateway-Ping",
  "Scheduled service gateway ping description": "sendet periodisch einen Ping an das m1gateway (Admin-Tenant).",
  "Scheduled service member inbox polling": "Mitglieder-Posteingang abrufen",
  "Scheduled service payment providers": "Zahlungsanbieter",
  "Scheduled service payment providers description": "prüft die verfügbaren Zahlungsarten regelmäßig über die Auftragswarteschlange",
  "Scheduled service payment providers queued": "Zahlungsanbieterprüfung eingeplant",
  "Scheduled service member inbox polling description": "ruft neue E-Mails aus den aktivierten Konten für den Mitglieder-Posteingang ab",
  "Scheduled service email queue": "E-Mail-Warteschlange",
  "Scheduled service email queue description": "versendet E-Mails aus der Warteschlange",
  "Scheduled service check-in auto checkout": "automatischer Check-out",
  "Scheduled service check-in auto checkout description": "checkt veraltete Check-ins automatisch aus",
  "Scheduled service communication rules": "Auto-Kommunikation",
  "Scheduled service communication rules description": "verarbeitet Kommunikationsregeln und versendet Nachrichten",
  "Scheduled service member promotions": "Mitgliederaktionen",
  "Scheduled service member promotions description": "prüft und verarbeitet geplante Mitgliederaktionen",
  "Scheduled service contract status check": "Vertragsprüfung",
  "Scheduled service contract status check description": "prüft Verträge und setzt Status auf 'beendet', wenn Enddatum überschritten ist",
  "Scheduled service contribution calendar": "Beitragskalender",
  "Scheduled service contribution calendar description": "berechnet und aktualisiert den Beitragskalender",
  "Scheduled service birthday tasks": "Geburtstags-Aufgaben",
  "Scheduled service birthday tasks description": "legt fällige Geburtstags-Aufgaben nach Personen-Standardregeln an",
  "Admin services scheduler configuration updated": "Scheduler-Konfiguration aktualisiert",
  "Admin service configuration updated": "Konfiguration aktualisiert",
  "Scheduled service holiday auto import completed": "Feiertags-Import ausgeführt",
  "Scheduled service member inbox polling completed": "Mitglieder-Posteingang abgerufen",
  "Scheduled service member inbox polling completed with errors": "Mitglieder-Posteingang mit Fehlern abgerufen",
  "Scheduled service email queue completed": "E-Mail-Warteschlange verarbeitet",
  "Scheduled service check-in auto checkout completed": "automatischer Check-out ausgeführt",
  "Scheduled service communication rules completed": "Kommunikationsregeln verarbeitet",
  "Scheduled service contract status check completed": "Vertragsstatus geprüft",
  "Scheduled service contribution calendar completed": "Beitragskalender aktualisiert",
  "EmailQueueService": "E-Mail-Warteschlange",
  "CheckInAutoCheckoutService": "automatischer Check-out",
  "CommunicationRuleService": "Auto-Kommunikation",
  "ContributionCalendarService": "Beitragskalender",
  "GlobalHolidayImport": "Feiertagsimport",
  "BankDataAutoUpdate": "automatische Bankdatenaktualisierung",
  "GatewayPingService": "Gateway-Ping",
  "Service executed successfully": "Dienst erfolgreich ausgeführt",
  "Running": "läuft",
  "Stopped": "gestoppt",
  "Balance credited.": "Saldo aufgebucht.",
  "Balance debited.": "Saldo abgebucht.",
  "Credit (currency)": "einzahlen",
  "Debit (currency)": "auszahlen",
  "Post entry": "buchen",
  "credited (past)": "aufgebucht",
  "debited (past)": "abgebucht",
  "deposited (past)": "eingezahlt",
  "withdrawn (past)": "ausgezahlt",
  "Balance deposited.": "Betrag eingezahlt.",
  "Balance withdrawn.": "Betrag ausgezahlt.",
  "wallet.reason.manualAdjustment": "manuelle Anpassung",
  "wallet.reason.stornoCredit": "Storno-Guthaben",
  "wallet.reason.offsetAgainstReceivable": "Guthabenverrechnung",
  "wallet.reason.paymentTopUp": "Aufladung",
  "wallet.reason.usage": "Verbrauch",
  "wallet.reason.import": "Datenübernahme",
  "wallet.reason.promotionBonus": "Aktion/Bonus",
  "wallet.reason.restPeriodCredit": "Ruhezeit",
  "wallet.reason.priceCorrectionCredit": "Preiskorrektur",
  "Balance is required": "Saldo ist erforderlich",
  "Balance retrieved successfully": "Guthaben erfolgreich abgerufen",
  "Balance:": "Saldo:",
  "Balance (history)": "Saldo",
  "Balance": "Saldo",
  "Balance__alt1": "Bestand",
  "Balance__alt2": "Guthaben",
  "Bank": "Bank",
  "Bank / SEPA": "Bank / SEPA",
  "Bank account": "Bankverbindung",
  "Bank account deleted.": "Bankverbindung gelöscht.",
  "Bank account saved.": "Bankverbindung gespeichert.",
  "Bank statement": "Kontoauszug",
  "Fetch statement": "Abruf starten",
  "Fetch statement and show transaction list": "Abruf starten, Umsatzliste anzeigen und zuordnen",
  "Bank statement book run": "Lastschriftlauf verbuchen",
  "Bank statement fetch added": "Abruf durchgeführt: {count} neue Umsätze.",
  "Fetch completed.": "Abruf durchgeführt.",
  "Fetch failed.": "Abruf fehlgeschlagen.",
  "Transaction list": "Umsatzliste",
  "No transactions yet.": "Noch keine Umsätze.",
  "Bank statement fetch hint": "Falls Ihre Bank eine TAN verlangt, erscheint ein Dialog zur TAN-Eingabe.",
  "Bank statement fetch hint tan required": "Diese Bank verlangt eine TAN. Bitte geben Sie sie im Dialog ein.",
  "Bank statement tan title": "TAN eingeben",
  "Bank statement tan prompt": "Ihre Bank verlangt eine TAN. Bitte geben Sie die angezeigte TAN ein.",
  "Bank statement tan placeholder": "TAN",
  "Bank statement tan submitted": "TAN übermittelt.",
  "Bank statement tan submit": "TAN absenden",
  "Book": "verbuchen",
  "Bank statement book success": "Zahlung zugeordnet.",
  "Bank statement book already booked": "Diese Buchung wurde bereits verbucht.",
  "Bank statement book error": "Verbuchung fehlgeschlagen.",
  "Bank statement book hint": "Buchung",
  "Select open item": "offenen Posten wählen",
  "Select open items": "offene Posten auswählen",
  "Select contributions": "Beiträge auswählen",
  "Select items": "Positionen auswählen",
  "No contributions available": "keine Beiträge verfügbar",
  "No open items available": "keine offenen Posten verfügbar",
  "No items available": "keine Positionen verfügbar",
  "Overpayment": "Überzahlung",
  "Underpayment amount distributed": "Der Betrag wird automatisch nach Fälligkeit verteilt.",
  "Terms": "AGB",
  "Loading history…": "Historie wird geladen …",
  "No history entries yet.": "Noch keine Einträge.",
  "Pagination range": "{0}-{1} von {2}",
  "Total count": "Gesamt: {0}",
  "Installments of amount": "{0} Raten à {1}",
  "Number of installments must be between": "Anzahl Raten muss zwischen {0} und {1} liegen",
  "Installment plan created for items": "Ratenzahlung für {0} Posten angelegt",
  "per installment": " pro Rate",
  "of total": "vom Gesamtbetrag",
  "Financial breakdown": "Finanzielle Aufschlüsselung",
  "Base amount (open item)": "Basisbetrag (offener Posten)",
  "Base amount (selected open items)": "Basisbetrag (ausgewählte offene Posten)",
  "Resend document": "Dokument erneut senden",
  "Resend document__brief": "Brief erneut senden",
  "Print failed.": "Fehler beim Drucken.",
  "Resend": "erneut senden",
  "How should the document be sent?": "Wie soll das Dokument versendet werden?",
  "Document sent to person email": "Das Dokument wird an die hinterlegte E-Mail-Adresse der Person gesendet. Bei PDF als Anhang, sonst als E-Mail-Inhalt.",
  "Online letter (Brief24)": "Online-Brief (Brief24)",
  "Coming soon.": "In Kürze verfügbar.",
  "Person data": "Personendaten",
  "Person overview access entitled": "erlaubt",
  "Person overview access limited": "eingeschränkt",
  "Person overview access not entitled": "kein Zutritt",
  "Person overview access blocked": "gesperrt",
  "Person overview access reason manual": "manuell",
  "Person overview access reason rest period": "Ruhezeit",
  "Person overview access reason studio limited": "nicht in allen Studios",
  "Person overview access reason no basis": "kein gültiger Vertrag",
  "Person overview open balance": "offen",
  "Person overview next contribution": "nächster Beitrag",
  "Person overview change home studio": "Stammstudio ändern",
  "Person overview never": "noch nie",
  "Person overview todo title": "Handlungsbedarf",
  "Person overview todo open item overdue": "1 mahnfälliger Posten über {0}, fällig seit {1}",
  "Person overview todo open items overdue": "{0} mahnfällige Posten, zusammen {1}, ältester fällig seit {2}",
  "Person overview todo access blocked manual": "Zutritt manuell gesperrt",
  "Person overview todo access blocked reminder": "Zutritt gesperrt durch {0}",
  "Person overview todo sepa iban": "Lastschrift ohne IBAN: {0}",
  "Person overview todo sepa mandate": "Lastschrift ohne Mandatsreferenz: {0}",
  "Person overview todo app request cancellation": "App-Anfrage Kündigung vom {0}",
  "Person overview todo app request rest period": "App-Anfrage Ruhezeit vom {0}",
  "Person overview todo contract cancelled": "{0}: Kündigung wirksam zum {1}",
  "Person overview todo contract term end": "{0}: Laufzeit endet am {1}",
  "Person overview todo rest period ending": "{0}: Ruhezeit endet am {1}",
  "Person overview todo care follow up": "{0}: Wiedervorlage am {1}",
  "Person overview todo no valid contract": "kein gültiger Vertrag",
  "Person overview todo action request": "zur Anfrage",
  "Person overview todo action care": "zum Vorgang",
  "Person overview unblock access": "Sperre aufheben",
  "Person overview block access": "Zutritt sperren",
  "Person overview add access medium": "Zutrittsmedium",
  "Person overview no check-ins": "keine Check-ins",
  "Person overview no open items": "keine offenen Posten",
  "Person overview no timeline entries": "keine Einträge",
  "Person overview no todos": "kein Handlungsbedarf",
  "Person overview situation title": "Lagebild",
  "Person overview timeline title": "letzte Vorgänge",
  "Person overview check-ins total": "Check-ins gesamt",
  "Person overview rows per list": "Zeilen",
  "Person overview rows count": "{0} Zeilen",
  "Person overview configure layout": "Übersicht anordnen",
  "Person overview attendance title": "Anwesenheit",
  "Person overview membership title": "Mitgliedschaft",
  "Person overview since": "seit {0}",
  "Person overview until": "bis {0}",
  "Person overview cancelled to": "gekündigt zum {0}",
  "Person overview rest period range": "Ruhezeit {0}",
  "Person overview no running contract": "kein laufender Vertrag",
  "Person overview credit": "Guthaben",
  "Person overview points": "Punkte",
  "Person overview chip overdue": "{0} mahnfällig · {1}",
  "Person overview chip access blocked": "Zutritt gesperrt",
  "Person overview chip iban missing": "IBAN fehlt",
  "Person overview chip mandate missing": "Mandat fehlt",
  "Person overview chip cancellation request": "Kündigungsanfrage",
  "Person overview chip rest period request": "Ruhezeitanfrage",
  "Person overview chip contract cancelled": "gekündigt zum {0}",
  "Person overview chip contract term end": "Laufzeitende {0}",
  "Person overview chip rest period ending": "Ruhezeit endet {0}",
  "Person overview chip care follow up": "Wiedervorlage {0}",
  "Person overview visits 30 days": "Besuche in 30 Tagen",
  "Person overview per week": "Ø pro Woche",
  "Person overview trend tooltip": "{0} gegenüber den 30 Tagen davor",
  "Person overview heatmap cell": "{0}: {1} Besuche",
  "Person overview heatmap label": "Besuche der letzten 13 Wochen",
  "Person overview renews": "verlängert sich",
  "Person overview term progress": "{0} % der Laufzeit vergangen",
  "Person overview no reader actions yet": "Noch keine Lesegerät- oder Wallet-Aktionen.",
  "Manual check-in block confirm title": "Check-in manuell sperren?",
  "Manual check-in block confirm content":
    "Die Person kann danach nicht mehr einchecken, bis Sie die Sperre aufheben. Mahnstufen-bedingte Sperren bleiben unverändert.",
  "Manual check-in block confirm ok": "Ja, Check-in sperren",
  "Consent (App)": "Zustimmung (App)",
  "Cancellation / Rest period": "Kündigung / Ruhezeit",
  "Contract cancelled": "Vertrag gekündigt",
  "Purpose__column": "Zweck",
  "Consent__column": "Zustimmung",
  "Type__column": "Art",
  "Installment payment plan": "Ratenzahlung ({0})",
  "Number of installments must be between min max": "Ratenanzahl muss zwischen {0} und {1} liegen.",
  "Min max installments": "Min. {0} / Max. {1}",
  "contributions selected": "{0} Beitrag(e) ausgewählt",
  "Document created and sent": "Dokument wurde erstellt und versendet.",
  "Document ready for printing.": "Dokument wurde erstellt und zum Drucken geöffnet.",
  "Preparing print...": "Druck wird vorbereitet...",
  "Change home studio to": "Stammstudio auf „{0}“ ändern?",
  "Mandate reference exists confirm": "Es existiert bereits eine Mandatsreferenz. Wenn du sie neu erstellst, wird die alte Referenz überschrieben und das Mandatsdatum auf das Standarddatum gesetzt.\n\nFortfahren?",
  "Delete contract package confirm": "Möchten Sie das Vertragspaket „{0}“ löschen?",
  "Delete document confirm": "Möchten Sie „{0}“ wirklich löschen?",
  "Delete sub-contract confirm": "Möchten Sie den Untervertrag „{0}“ wirklich löschen?",
  "Contract package in studio change home": "Dieses Vertragspaket wird im Studio „{0}“ abgeschlossen.\n\nSoll das Stammstudio der Person ebenfalls auf dieses Studio geändert werden?",
  "Delete wallet confirm": "Möchten Sie das Wertekonto „{0}“ wirklich löschen?",
  "Chip already assigned to": "Dieser Chip ist bereits zugewiesen: {0}",
  "Select bank account": "Bankverbindung wählen",
  "Bank Accounts": "Bankverbindungen",
  "Bank accounts": "Bankkonten",
  "Bank Data": "Bankdaten",
  "Bank data additional settings": "Zusatzeinstellungen (Bankdaten)",
  "Bank Data List": "Bankdaten-Liste",
  "Bank details": "Bankdaten",
  "Bank details, direct debit groups & mandate reference": "Bankdaten, Lastschrift-Gruppen & Mandatsreferenz",
  "Bank details__alt2": "Bankverbindung",
  "Bank Name": "Bankname",
  "Bank name (automatically filled from IBAN)": "Bankname (wird automatisch aus IBAN übernommen)",
  "Base URL": "Base-URL",
  "Base URL is required": "Base-URL ist erforderlich",
  "Base URL example placeholder": "z. B. https://api.example.com",
  "Base URL max 500 characters": "Base-URL darf höchstens 500 Zeichen haben",
  "Base URL must start with http or https": "Base-URL muss mit http:// oder https:// beginnen",
  "Basic Information": "Grunddaten",
  "Batch size": "Batch-Größe",
  "Batch size is required": "Batch-Größe ist erforderlich",
  "Became member": "Mitglied geworden",
  "Beginning Balance": "Anfangsbestand",
  "Behavior": "Verhalten",
  "Behavior on holidays": "Verhalten an Feiertagen",
  "Available on holidays": "an Feiertagen verfügbar",
  "Holiday calendar per studio hint": "Der Feiertagskalender wird pro Studio in der Terminkonfiguration (Feiertage) festgelegt.",
  "BIC": "BIC",
  "BIC is required for foreign IBANs": "BIC ist für ausländische IBANs erforderlich",
  "Billing cycle": "Zahlungszyklus",
  "Birthdate": "Geburtsdatum",
  "Birthday": "Geburtstag",
  "Birthday today": "heute Geburtstag",
  "Birthdays": "Geburtstage",
  "Member birthdays in selected period": "Geburtstage von Mitgliedern im gewählten Zeitraum",
  "With last attendance": "mit letzter Anwesenheit",
  "Without last attendance": "ohne letzte Anwesenheit",
  "Last attendance": "letzte Anwesenheit",
  "Last attendance within days": "letzte Anwesenheit innerhalb von Tagen",
  "Days since last attendance": "Tage seit letzter Anwesenheit",
  "Age": "Alter",
  "Report period last week": "letzte Woche",
  "Report period current month": "dieser Monat",
  "Report period last month": "letzter Monat",
  "Report period last quarter": "letztes Quartal",
  "Report period last half year": "letzte 6 Monate",
  "Report period current year": "dieses Jahr",
  "Report period last year": "letztes Jahr",
  "Report period last 12 months": "letzte 12 Monate",
  "Next month": "nächster Monat",
  "Custom period": "benutzerdefiniert",
  "Currently in studio": "aktuell im Studio",
  "Resting contracts": "ruhende Verträge",
  "Cancelled still running": "gekündigt, noch laufend",
  "Open app requests": "offene App-Anliegen",
  "Open items total": "offene Posten gesamt",
  "Total revenue": "Umsatz",
  "of which article sales": "davon Artikelverkäufe",
  "Chargeback rate": "Rücklastschriftquote",
  "Won leads": "gewonnene Kontakte",
  "Membership entries": "Neuzugänge",
  "Member departures": "Abgänge",
  "New members": "neue Mitglieder",
  "New contracts": "neue Verträge",
  "Net member change": "Netto",
  "Contract member history": "Vertragsmitglieder im Zeitverlauf",
  "Change in contract members": "Veränderung",
  "Joins and cancellations": "Zugänge und Kündigungen",
  "Next 7 days": "nächste 7 Tage",
  "Next 30 days": "nächste 30 Tage",
  "Next 60 days": "nächste 60 Tage",
  "Next 90 days": "nächste 90 Tage",
  "Today's appointments": "heutige Termine",
  "To calendar": "zum Kalender",
  "No appointments today": "heute keine Termine",
  "No appointments in period": "keine Termine im Zeitraum",
  "No birthdays this week": "diese Woche keine Geburtstage",
  "No birthdays in period": "keine Geburtstage im Zeitraum",
  "Create tasks for birthdays": "Aufgaben für Geburtstage erstellen",
  "Birthday tasks only for members": "Geburtstags-Aufgaben nur für Mitglieder",
  "Hide prospect detail sections": "Check-ins, Beiträge und offene Posten bei Interessenten ausblenden",
  "Hide unused person features": "ungenutzte Personenfunktionen ausblenden",
  "Birthday task drawer title": "Geburtstag",
  "Birthday task note label": "Notiz (optional)",
  "Birthday task note hint": "optional für dich, z. B. Gratulation erledigt",
  "Birthday task mark done": "als erledigt markieren",
  "Birthday task done message": "Geburtstags-Erinnerung als erledigt markiert.",
  "To tasks": "zur Aufgabenliste",
  "Task type": "Aufgabentyp",
  "Block access:": "Zutritt sperren:",
  "Block check-in": "Check-in sperren",
  "Block contact": "Kontakt sperren",
  "Block until": "Sperre bis",
  "blocked": "gesperrt",
  "SEPA direct debit blocked": "SEPA-Lastschrift gesperrt",
  "SEPA blocked": "SEPA gesperrt",
  "SEPA blocks": "SEPA-Sperren",
  "SEPA blocks card description": "aktive und aufgehobene Lastschriftsperren einsehen und verwalten",
  "Payment cancellations": "Stornierungen",
  "This person is blocked for SEPA direct debits (e.g. after a chargeback). You can unblock after clarification.": "Diese Person ist für SEPA-Lastschriften gesperrt (z. B. nach Rücklastschrift). Nach Klärung können Sie die Sperre aufheben.",
  "Unblock SEPA": "SEPA-Sperre aufheben",
  "SEPA unblocked.": "SEPA-Sperre aufgehoben.",
  "SEPA block note": "SEPA-Notiz",
  "Comment (optional, saved when unblocking SEPA)": "Kommentar (optional, wird bei Aufhebung der SEPA-Sperre gespeichert)",
  "Open reminder assistant afterwards": "Mahnassistent anschließend öffnen",
  "No dunnable open item, reminder assistant skipped": "Kein mahnfähiger offener Posten — Mahnassistent entfällt.",
  "Blocked (no access)": "gesperrt (kein Zutritt)",
  "blocks": "Blöcke",
  "Blue": "blau",
  "BLZ": "BLZ",
  "Body": "Text",
  "Book appointment": "Termin buchen",
  "Book appointment anyway?": "Trotzdem buchen?",
  "Book Now": "jetzt buchen",
  "Book payments": "Zahlungen verbuchen",
  "Booked": "gebucht",
  "Booked direct debit runs cannot be deleted.": "bereits verbuchte Lastschriftläufe können nicht gelöscht werden.",
  "Booking code": "Buchungscode",
  "Booking date": "Buchungsdatum",
  "Booking group": "Buchungsgruppe",
  "Booking link": "Buchungslink",
  "Widget link": "Formular-Link",
  "Booking links & embed": "Buchungslinks & Einbettung",
  "Booking restrictions": "Buchungseinschränkungen",
  "Booking Widget": "Buchungsformular",
  "Booking widgets": "Buchungsformulare",
  "Booking widgets for leads": "Buchungsformulare für Kontakte",
  "Online bookings, design & iFrame configuration": "Online-Buchungen, Design & iFrame-Konfiguration",
  "Bookings": "Buchungen",
  "Border Radius": "Eckenradius",
  "Border radius": "Eckenradius",
  "Branding": "Branding",
  "Briefly note what happened …": "Kurz notieren, was passiert ist …",
  "Bulk Communication": "Serienkommunikation",
  "Bulk email": "Serien-E-Mail",
  "Bulk email sending (selection, preview, queue).": "Serienversand von E-Mails (Auswahl, Vorschau, Warteschlange).",
  "Bulk letter": "Serienbrief",
  "Bulk letters (selection, merge, print/export).": "Serienbriefe (Auswahl, Seriendruck, Druck/Export).",
  "Bulk sending": "Serienversand",
  "Button uses server reset. New password is filled into the field (not revealable for security reasons).": "Die Schaltfläche nutzt das Zurücksetzen auf dem Server. Das neue Passwort wird ins Feld übernommen (aus Sicherheitsgründen nicht einblendbar).",
  "Calculate proportionally": "anteilig berechnen",
  "No proportional calculation": "keine anteilige Berechnung",
  "Calculation Method": "Berechnungsmethode",
  "Calculation method for last contribution on cancellation": "Berechnungsmethode für letzten Beitrag bei Kündigung",
  "Calendar": "Kalender",
  "Calendar filter studio and resources": "Studio & Ressourcen",
  "Calendar filter resources": "Ressourcen",
  "Hide resources without availability": "Ressourcen und Mitarbeiter ohne Verfügbarkeit ausblenden",
  "Show resources without availability": "Ressourcen und Mitarbeiter ohne Verfügbarkeit einblenden",
  "Calendar & Appointments": "Kalender & Termine",
  "Calendar configuration": "Kalender-Konfiguration",
  "Calendar studio already has configuration": "Mindestens ein Studio hat bereits eine Kalender-Konfiguration.",
  "Calendar module": "Modul Kalender",
  "Calendar Reports": "Kalenderauswertungen",
  "Calendar reports": "Kalenderauswertungen",
  "Calendar role created": "Kalender-Rolle angelegt",
  "Calendar role deleted": "Kalender-Rolle gelöscht",
  "Calendar role updated": "Kalender-Rolle aktualisiert",
  "Fill screen: on – click for standard row height": "Bildschirm füllen: an – Klick für Standard-Zeilenhöhe",
  "Fill screen: off – click to fill the screen": "Bildschirm füllen: aus – Klick füllt den Bildschirm",
  "Call": "Anruf",
  "Call__alt2": "anrufen",
  "Call__anrufen": "anrufen",
  "Camera access is not available.": "Kamerazugriff nicht verfügbar.",
  "Camera access was denied. Please allow camera permission in your browser.": "Kamerazugriff wurde verweigert. Bitte Kameraberechtigung im Browser erlauben.",
  "Camera is not ready yet. Please wait a moment.": "Kamera ist noch nicht bereit. Bitte kurz warten.",
  "Camera is not supported by the browser. Please use file upload.": "Kamera wird vom Browser nicht unterstützt. Bitte nutzen Sie den Datei-Upload.",
  "Automation leads to:": "Automatik führt zu:",
  "No automation configured": "keine Automatik hinterlegt",
  "Default email template": "Standard-Vorlage für E-Mails",
  "Default email template help": "Wird beim Verfassen einer E-Mail an einen Kontakt in dieser Phase vorausgewählt. Ohne Auswahl wird bewusst keine Vorlage geladen.",
  "Calendar for appointments": "Kalender für Termine",
  "Calendar for appointments help": "Bestimmt, in welchem Kalender ein Termin angelegt wird, wenn er für einen Kontakt dieser Pipeline gebucht wird.",
  "Appointment types for lead booking": "Terminarten für die Lead-Buchung",
  "Appointment types for lead booking help": "Diese Terminarten werden angeboten, wenn ein Termin aus dem Lead gebucht wird. Jeder mit dem Lead verknüpfte Termin zählt unabhängig von dieser Auswahl für die Phasenautomatik.",
  "Phases are the steps a contact goes through. Drag to reorder.": "Phasen sind die Schritte, die ein Kontakt durchläuft. Die Reihenfolge ändern Sie per Ziehen.",
  "Phase type": "Art der Phase",
  "Phase type in progress": "laufend",
  "Phase type won": "Kunde geworden",
  "Phase type not realized": "nicht zustande gekommen",
  "Phase type neutral": "ohne Wertung",
  "Cancel contract": "Vertrag kündigen",
  "Cancel contracts": "Verträge kündigen",
  "Customize contract cancellations": "Kündigungen individuell anpassen",
  "Customize contract cancellations help":
    "Kündigungswirkungsdatum und Mitgliedsende manuell setzen. Ohne dieses Recht gelten nur die vom Kündigungsmodell berechneten Termine (Voraussetzung: Verträge kündigen).",
  "Customize rest periods": "Ruhezeiten individuell anpassen",
  "Customize rest periods help":
    "Anderes Ruhezeitmodell wählen oder Gebühren und Optionen manuell setzen. Ohne dieses Recht werden nur die Werte des am Vertrag hinterlegten Ruhezeitmodells genutzt (Voraussetzung: Ruhezeiten bearbeiten).",
  "Cancellation dates follow system model help":
    "Kündigungsdatum und Mitgliedsende richten sich nach dem Kündigungsmodell; ohne Recht „Kündigungen individuell anpassen“ sind sie nicht änderbar.",
  "Rest period contract package missing template warning":
    "Am gewählten Vertragspaket ist kein Ruhezeitmodell hinterlegt. Eintragen ist erst möglich, wenn in den Vertragsdaten ein Modell gesetzt ist.",
  "Rest period model locked to contract help":
    "Modell, Gebühren und Optionen entsprechen dem am Vertrag hinterlegten Ruhezeitmodell; ohne Recht „Ruhezeiten individuell anpassen“ sind sie nicht änderbar.",
  "Edit cancellation": "Kündigung bearbeiten",
  "Cancel direct debit": "Lastschrift stornieren",
  "Cancel direct debit run": "Lastschriftlauf stornieren",
  "Cancel payment": "Zahlungsstorno",
  "Cancel run": "Lauf stornieren",
  "Cancel booking": "Termin stornieren",
  "Do you really want to cancel this booking?": "Möchten Sie diesen Termin wirklich stornieren?",
  "Booking reference": "Terminreferenz",
  "Reason (optional)": "Grund",
  "Booking cancelled successfully.": "Der Termin wurde storniert.",
  "Invalid or missing booking reference.": "ungültige oder fehlende Terminreferenz.",
  "Booking not found.": "Termin nicht gefunden.",
  "Email is required": "E-Mail ist erforderlich.",
  "Email does not match.": "Die E-Mail-Adresse stimmt nicht überein.",
  "Email not registered": "E-Mail nicht registriert",
  "Booking cannot be cancelled.": "Der Termin kann nicht storniert werden.",
  "Cancel": "abbrechen",
  "Cancel booking link": "Termin stornieren URL",
  "Terminate": "kündigen",
  "Void": "stornieren",
  "Stornierung": "Stornierung",
  "Cancellation": "Kündigung",
  "Cancellation confirmation": "Kündigungsbestätigung",
  "Cancellation blocked during free period": "Während des gewährten Gratiszeitraums ist laut Verkaufsaktion keine Kündigung möglich.",
  "Cancellation date": "Kündigungseingang",
  "Cancellation Date": "Kündigungsdatum",
  "Cancellation Model": "Kündigungsmodell",
  "Cancellation model": "Kündigungsmodell",
  "Cancellation model (optional)": "Kündigungsmodell",
  "Cancellation models": "Kündigungsmodelle",
  "Cancellation note": "Kündigungsnotiz",
  "Cancellation processed by": "Kündigung bearbeitet von",
  "Cancellation reason created": "Kündigungsgrund angelegt",
  "Cancellation reason deleted": "Kündigungsgrund gelöscht",
  "Cancellation reason updated": "Kündigungsgrund aktualisiert",
  "Cancellation reason": "Kündigungsgrund",
  "Cancellation reason__alt2": "Stornierungsgrund",
  "Cancellation reason__stornierungsgrund": "Stornierungsgrund",
  "Cancellation reasons": "Kündigungsgründe",
  "Cancellation request date": "Eingang der Kündigung",
  "Cancellation request date is required": "Eingang der Kündigung ist erforderlich",
  "Cancellation revoked.": "Kündigung zurückgenommen.",
  "Cancellation type": "Stornoart",
  "Cancellations": "Kündigungen",
  "Kündigungen": "Kündigungen",
  "Cancellations & Churn": "Kündigungen",
  "Stornierungen": "Stornierungen",
  "Payment cancellations description": "stornierte Zahlungen einsehen",
  "Cancelled amount": "stornierter Betrag",
  "Cancelled": "gekündigt",
  "Appointment status cancelled": "abgesagt",
  "Cancelled__alt1": "storniert",
  "Cancelled__alt2": "abgesagt",
  "Cancelled__alt4": "storniert",
  "Cannot delete: payments have already been booked for this contract.": "Kann nicht gelöscht werden: Für diesen Vertrag wurden bereits Zahlungen verbucht.",
  "Cannot save": "Kann nicht gespeichert werden",
  "Capabilities": "Fähigkeiten",
  "Capacity": "Kapazität",
  "Capture": "aufnehmen",
  "Capture failed.": "Fehler beim Aufnehmen.",
  "Cash": "Barzahlung",
  "Cash transactions at checkout": "Bargeldtransaktionen an der Kasse",
  "Categories": "Kategorien",
  "Categories for text templates": "Kategorien für Textvorlagen",
  "Category": "Kategorie",
  "Central settings for reminder and confirmation (email/SMS). An entry can apply to all studios or to selected studios.": "Zentrale Einstellung für Erinnerung und Bestätigung (E-Mail/SMS). Ein Eintrag kann für alle Studios oder für ausgewählte Studios gelten.",
  "Change appointment (duration)": "Termin (Dauer) ändern",
  "Change home studio": "Stammstudio ändern",
  "Change home studio?": "Stammstudio ändern?",
  "Change language": "Sprache ändern",
  "Change order": "Reihenfolge ändern",
  "Change password": "Passwort ändern",
  "Change": "ändern",
  "Change__alt2": "Änderung",
  "Changelog": "Änderungshistorie",
  "What's new": "Was ist neu",
  "Changes": "Änderungen",
  "Channel": "Kanal",
  "Channel is required": "Kanal ist erforderlich",
  "Channel change": "Kanal wechseln",
  "If you change the channel, the current content may be lost or become invalid. Continue?": "Beim Wechsel des Kanals kann der aktuelle Inhalt verloren gehen oder ungültig werden. Fortfahren?",
  "Unsaved changes": "ungespeicherte Änderungen",
  "You have unsaved changes. Leave anyway?": "Es gibt ungespeicherte Änderungen. Wirklich verlassen?",
  "Save or discard changes?": "Vorher speichern oder Änderungen verwerfen?",
  "Leave": "verlassen",
  "Chargeback": "Rücklastschrift",
  "Checking email availability…": "E-Mail-Verfügbarkeit wird geprüft…",
  "Chargebacks last 7 days": "Rücklastschriften (letzte 7 Tage)",
  "Chargeback Rate": "Rücklastschriftenquote",
  "Rücklastschriftenquote": "Rücklastschriftenquote",
  "Chargeback Rate__alt1": "Rücklastschriften",
  "Chargeback reason": "RL-Grund",
  "Manual chargeback reason MS03": "Sonstige Gründe",
  "Manual chargeback reason MS02": "Lastschrift vor Abbuchung vom Kunden abgelehnt",
  "Manual chargeback reason MD06": "Lastschriftwiderspruch durch den Kunden",
  "Manual chargeback reason MD01": "Kein gültiges Lastschriftmandat",
  "Manual chargeback reason MD02": "Mandatsangaben fehlerhaft oder unvollständig",
  "Manual chargeback reason AC01": "IBAN fehlerhaft",
  "Manual chargeback reason AC04": "Konto aufgelöst",
  "Manual chargeback reason AC06": "Konto gesperrt",
  "Manual chargeback reason AG01": "Lastschrift für dieses Konto nicht zulässig",
  "Manual chargeback reason SL01": "Lastschrift vom Kunden gesperrt",
  "Manual chargeback reason AM04": "Mangels Deckung",
  "Manual chargeback reason AM05": "Lastschrift doppelt eingereicht",
  "Chargeback reason AC01": "Kontonummer fehlerhaft",
  "Chargeback reason AC04": "Konto geschlossen",
  "Chargeback reason AC06": "Konto gesperrt",
  "Chargeback reason AC13": "Kontoart unzulässig (Verbraucherkonto)",
  "Chargeback reason AG01": "Lastschriftverfahren nicht erlaubt",
  "Chargeback reason AG02": "ungültiger Buchungscode",
  "Chargeback reason AM04": "Kontodeckung unzureichend",
  "Chargeback reason AM05": "Doppeleinreichung",
  "Chargeback reason BE05": "Gläubiger-Identifikation unbekannt",
  "Chargeback reason FF01": "ungültiges Dateiformat",
  "Chargeback reason FF05": "ungültiges Lastschriftverfahren",
  "Chargeback reason MD01": "kein gültiges Mandat",
  "Chargeback reason MD02": "Mandatsangaben unvollständig",
  "Chargeback reason MD06": "Widerspruch des Zahlungspflichtigen",
  "Chargeback reason MD07": "Zahlungspflichtiger verstorben",
  "Chargeback reason MS02": "Verweigerung durch Zahlungspflichtigen",
  "Chargeback reason MS03": "Grund nicht angegeben (Bank)",
  "Chargeback reason RC01": "BIC fehlerhaft",
  "Chargeback reason RR01": "Angaben zum Zahler fehlen",
  "Chargeback reason RR02": "Name/Anschrift des Zahlers fehlt",
  "Chargeback reason RR03": "Name/Anschrift des Zahlungsempfängers fehlt",
  "Chargeback reason RR04": "regulatorischer Grund",
  "Chargeback reason SL01": "vom Zahlungspflichtigen gesperrt",
  "Chargeback reason TM01": "Annahmeschluss überschritten",
  "Chargeback fee (per chargeback)": "Rücklastschriftgebühr (pro Rücklastschrift)",
  "Chargeback fee (% of chargeback amount)": "Rücklastgebühr in % des Rücklastbetrags",
  "If set, this amount is automatically posted as an open item when a payment is cancelled as chargeback (SEPA return).": "Falls gesetzt, wird dieser Betrag bei Storno als Rücklastschrift automatisch als offener Posten gebucht.",
  "Chargebacks": "Rücklastschriften",
  "Check in": "Check-in",
  "Check in__alt1": "Check-in",
  "Check out": "Check-out",
  "Check out__alt2": "Check-out",
  "Check-in": "Check-in",
  "Check-in allowed": "Check-in erlaubt",
  "check-in blocked": "Check-in gesperrt",
  "Check-in failed": "Check-in fehlgeschlagen",
  "Check-in settings": "Check-in-Einstellungen",
  "Check-in settings saved.": "Check-in-Einstellungen gespeichert.",
  "Check-in view": "Check-in-Ansicht",
  "Check-in current list photo": "Foto",
  "Check-ins last 30 days": "Check-ins der letzten 30 Tage",
  "Check-ins today": "Check-ins heute",
  "Check-ins": "Check-ins",
  "Check-ins (attendance)": "Anwesenheiten",
  "Walk-in guest": "hereinkommender Besucher",
  "Inbound call at desk": "eingehender Anruf",
  "Capture walk-in guest": "hereinkommender Besucher",
  "Capture inbound call": "eingehender Anruf",
  "Walk-in guest recorded": "hereinkommender Besucher erfasst",
  "Inbound call recorded": "eingehender Anruf erfasst",
  "Reception next step": "Was wurde daraus?",
  "Reception follow-up done": "nicht erfasst",
  "Reception follow-up done help": "Weder Kontakt aufnehmen noch Termin buchen.",
  "Reception follow-up done help call": "Weder Kontakt aufnehmen noch Termin buchen.",
  "Put on call list": "als Kontakt erfassen",
  "Put on call list help": "Name und Telefon aufnehmen, ohne einen Termin zu buchen.",
  "Put on call list already help": "Name und Telefon aufnehmen, ohne einen Termin zu buchen.",
  "Put on call list done": "Als Kontakt erfasst.",
  "Reception chip booked": "Termin",
  "Reception chip on call list": "Kontakt",
  "Book appointment from reception": "Termin buchen",
  "Book appointment from reception help": "Einen Termin buchen.",
  "Reception studio missing": "Zuerst das Studio an diesem Rechner setzen.",
  "Reception today": "heute am Tresen",
  "Reception guests today": "hereinkommende Besucher heute",
  "Reception calls today": "eingehende Anrufe heute",
  "No reception guests yet": "Heute noch kein hereinkommender Besucher.",
  "No reception calls yet": "Heute noch kein eingehender Anruf.",
  "No reception entries yet": "Heute noch kein Eintrag.",
  "Reception kind": "Art",
  "Reception kind short walk-in": "hB",
  "Reception kind short call": "eA",
  "Reception guest unnamed": "hereinkommender Besucher",
  "Reception call unnamed": "eingehender Anruf",
  "Back to check-in": "zurück zum Check-in",
  "Check-ins__alt1": "Anwesenheiten",
  "Checked in": "eingecheckt",
  "Checked in since": "eingecheckt seit",
  "Checked out": "ausgecheckt",
  "Automatically checked out": "automatisch ausgecheckt (Timeout)",
  "Checked-in": "eingecheckt",
  "Checkin": "Check-in",
  "checking": "wird geprüft",
  "Checkout": "Check-out",
  "Checkout failed": "Check-out fehlgeschlagen",
  "Chip": "Chip",
  "Magnetic stripe card": "Magnetstreifenkarte",
  "Choose file": "Datei auswählen",
  "Churn Rate": "Kündigungsquote",
  "Churn Rate %": "Kündigungsquote %",
  "City (optional)": "Ort",
  "City__alt2": "Stadt",
  "Claims in debt collection process": "Forderungen im Inkassoverfahren",
  "Clean up": "bereinigen",
  "Clean up orphaned items": "verwaiste offene Posten bereinigen",
  "Clean up orphaned open items": "verwaiste offene Posten bereinigen",
  "Clear": "leeren",
  "Clear logs": "Systemprotokoll leeren",
  "Clear logs__alt2": "Protokolleinträge löschen",
  "Clear system logs": "Systemprotokoll leeren",
  "Close & edit contracts": "Verträge abschließen & bearbeiten",
  "Close a new contract for a person": "neuen Vertrag für eine Person abschließen",
  "Close contract": "Vertrag abschließen",
  "Close contracts": "Verträge abschließen",
  "Close lead": "Kontakt abschließen",
  "Close phase description": "Abschlussgründe, die der Mitarbeiter beim Kontakt-Abschluss in dieser Phase zur Auswahl bekommt. Nur für Phasen ohne Folgephasen (loses Ende) möglich; ob die Phase gewonnen oder verloren bedeutet, ergibt sich aus den zugeordneten Gründen.",
  "Close phase requires no transitions": "nur möglich, wenn die Phase keine Folgephasen hat",
  "Closed": "abgeschlossen",
  "Open leads": "offen",
  "Reset filters": "Filter zurücksetzen",
  "Create contract": "Vertrag anlegen",
  "Email delivery pending": "in Zustellung",
  "Email delivery sent": "gesendet",
  "Email delivery failed": "fehlgeschlagen",
  "Email delivery cancelled": "storniert",
  "Close reason": "Abschlussgrund",
  "Close reasons": "Abschlussgründe",
  "Close reasons description": "Gründe für den Kontakt-Abschluss inkl. Kennzeichen „Kunde geworden\"",
  "New close reason": "neuer Abschlussgrund",
  "Edit close reason": "Abschlussgrund bearbeiten",
  "Close reason created": "Abschlussgrund angelegt",
  "Close reason updated": "Abschlussgrund aktualisiert",
  "Close reason deleted": "Abschlussgrund gelöscht",
  "Became customer": "Kunde geworden",
  "Close reasons missing": "Abschlussgründe fehlen",
  "Pipeline activation requires close reasons": "Aktivierung erst möglich, wenn alle Endphasen ohne Folgephasen Abschlussgründe zugeordnet haben",
  "Log note": "Notiz erfassen",
  "Close reasons could not be loaded": "Abschlussgründe konnten nicht geladen werden. Bitte Seite neu laden.",
  "No close reasons configured in pipeline": "im Phasenmodell ist keine Endphase mit Abschlussgründen konfiguriert",
  "Close moves lead to phase": "der Kontakt wird dabei in die Phase „{0}“ verschoben",
  "Last 30 days": "letzte 30 Tage",
  "Last 90 days": "letzte 90 Tage",
  "This year": "dieses Jahr",
  "Clear period": "Zeitraum entfernen",
  "Close__alt1": "abschließen",
  "Reached": "erreicht",
  "Due today": "heute fällig",
  "Reopen lead": "Kontakt wieder öffnen",
  "Lead reopened.": "Kontakt wieder geöffnet.",
  "Change phase": "Phase wechseln",
  "Phase changed.": "Phase gewechselt.",
  "New phase": "neue Phase",
  "Closes contact": "schließt ab",
  "No close reasons configured for this phase": "für diese Phase sind keine Abschlussgründe hinterlegt",
  "Close reason is mandatory": "Abschlussgrund ist Pflicht",
  "+{0} days": "+{0} Tage",
  "+{0} weeks": "+{0} Wochen",
  "+{0} months": "+{0} Monate",
  "+1 day": "+1 Tag",
  "+2 days": "+2 Tage",
  "+3 days": "+3 Tage",
  "+1 week": "+1 Woche",
  "+2 weeks": "+2 Wochen",
  "+1 month": "+1 Monat",
  "e.g. Info material - {{person.firstName}} {{person.lastName}}": "z. B. Infomaterial - {{person.firstName}} {{person.lastName}}",
  "e.g. Document title - {{person.firstName}} {{person.lastName}}": "z. B. Dokumenttitel - {{person.firstName}} {{person.lastName}}",
  "Closed by": "Abschluss",
  "Closed, use configured holidays": "geschlossen, hinterlegte Feiertage verwenden",
  "Closing": "Abschluss",
  "Closing date": "Abschlussdatum",
  "Closing date is required": "Abschlussdatum ist erforderlich",
  "Closing date is required.": "Abschlussdatum ist erforderlich.",
  "Closing employee": "Abschlussmitarbeiter",
  "Closing user": "Abschlussbenutzer",
  "Code": "Code",
  "Code (for link)": "Code (für Link)",
  "Code cannot be changed if payment method is already in use": "Code kann nicht geändert werden, wenn die Zahlungsart bereits verwendet wird",
  "Code copied!": "Code kopiert!",
  "Code is required": "Code ist erforderlich",
  "Code regenerated": "Code neu generiert",
  "Color": "Farbe",
  "Color (Calendar View)": "Farbe (Kalenderansicht)",
  "Color (optional)": "Farbe",
  "Color for calendar view": "Farbe für die Kalenderansicht",
  "Color picker blue channel": "Blau",
  "Color picker green channel": "Grün",
  "Color picker hex value": "Hex-Wert",
  "Color picker red channel": "Rot",
  "Color picker tonal variants": "Tonwerte",
  "Column settings deleted": "Spalteneinstellung gelöscht",
  "Column settings saved": "Spalteneinstellung gespeichert",
  "Columns": "Spalten",
  "Comment": "Kommentar",
  "Commercial (nearest)": "kaufmännisch (nächstliegend)",
  "Communication": "Kommunikation",
  "Communication spooler nav": "System-Ausgang (E-Mail/SMS)",
  "Compact": "kompakt",
  "Detailed": "ausführlich",
  "Compact View": "kompakte Ansicht",
  "Company & Studios": "Firma & Studios",
  "Company Name": "Firmenname",
  "Complete": "abschließen",
  "Complete amount": "kompletter Beitrag",
  "Complete phase": "Phase abschließen",
  "Completed": "abgeschlossen",
  "Completion": "Abschluss",
  "Components for contract packages": "Bausteine für Vertragspakete",
  "Conditions": "Bedingungen",
  "Conditions (all must match)": "Bedingungen (alle erfüllt)",
  "Configuration created": "Konfiguration angelegt",
  "Configuration deleted": "Konfiguration gelöscht",
  "Configuration duplicated": "Konfiguration dupliziert",
  "Configuration for incoming email via IMAP.": "Konfiguration für den E-Mail-Eingang über IMAP.",
  "Configure reminder levels": "Mahnstufen konfigurieren",
  "Configure when and how often bank data should be automatically updated from the German Bundesbank.": "Konfigurieren Sie, wann und wie oft die Bankdaten automatisch von der Deutschen Bundesbank aktualisiert werden sollen.",
  "Confirm": "bestätigen",
  "Confirm new password": "neues Passwort bestätigen",
  "Confirm password": "Passwort bestätigen",
  "Confirmation": "Bestätigung",
  "Confirmation Email": "Bestätigungs-E-Mail",
  "Confirmation Message": "Bestätigungsnachricht",
  "Confirmation text:": "Bestätigungstext:",
  "Confirmation Title": "Bestätigungstitel",
  "Confirmation & Reminder": "Bestätigung & Erinnerung",
  "The actual confirmation and reminder emails for appointments are configured under Settings → Appointment notifications.": "Die eigentliche Bestätigungs- und Erinnerungs-E-Mail für Termine wird unter Einstellungen → Termin-Benachrichtigungen konfiguriert.",
  "Restriction & Lead on Booking": "Einschränkung & Kontakt bei Buchung",
  "When membersOnly or leadsOnly is set, the backend checks on book whether the person is a member/lead; otherwise the appointment is not confirmed. When the customer books as a lead, a lead can be created.": "Wenn die Buchung nur für Mitglieder oder nur für Nichtmitglieder erlaubt ist, prüft das Backend beim Buchen, ob die Person zu der erlaubten Gruppe gehört; sonst wird der Termin nicht bestätigt. Bei Buchung als Kontakt kann ein Kontakt angelegt werden.",
  "Connection failed": "Verbindung fehlgeschlagen",
  "Connection successful": "Verbindung erfolgreich",
  "Connection successful!": "Verbindung erfolgreich!",
  "Connection successful. The API integration is working correctly.": "Verbindung erfolgreich. Die API-Schnittstelle funktioniert korrekt.",
  "Connection test failed": "Verbindungstest fehlgeschlagen",
  "Consideration of bank business days and lead times for SEPA submission.": "Berücksichtigung von Bankarbeitstagen und Vorlaufzeiten für SEPA-Einreichung.",
  "Contact": "Kontakt",
  "Contact & address": "Kontakt & Adresse",
  "Contact data on booking": "Kontaktdaten bei Buchung",
  "Contact person": "Ansprechpartner",
  "Contact Person": "Ansprechpartner",
  "Contact form fields": "Kontaktformular-Felder",
  "Select which fields are shown in the booking form and which are required.": "Legen Sie fest, welche Felder im Buchungsformular angezeigt werden und welche erforderlich sind.",
  "Field": "Feld",
  "Continue": "fortfahren",
  "Choose the visit that fits you best": "Wählen Sie die Terminart, die am besten zu Ihnen passt.",
  "Custom CSS placeholder": ".booking-widget { /* your styles */ }",
  "Arial": "Arial",
  "Helvetica": "Helvetica",
  "Georgia": "Georgia",
  "Times New Roman": "Times New Roman",
  "Review & confirm": "prüfen & bestätigen",
  "Select studios (optional)": "Studios auswählen",
  "continue payment": "Beitrag weiter",
  "Continue payment": "Beitrag weiterzahlen",
  "Contract block": "Vertragsbaustein",
  "Contract blocks": "Vertragsbausteine",
  "Primary contract block": "Hauptbaustein",
  "Contract cancelled.": "Vertrag gekündigt.",
  "Contract closed.": "Vertrag abgeschlossen.",
  "The contract is now available in m1member.": "Der Vertrag ist jetzt in m1member verfügbar.",
  "Contract closing date": "Abschlussdatum",
  "Contract component": "Vertragsbaustein",
  "Contract components": "Vertragsbausteine",
  "Contract created": "Vertrag erstellt",
  "Contract Duration (Months)": "Vertragsdauer (Monate)",
  "Contract end date": "Vertragsende",
  "Contract extension": "Vertragsverlängerung",
  "Contract is required": "Vertrag ist erforderlich",
  "Contract management": "Vertragswesen",
  "Member inbox": "Mitgliederposteingang",
  "Try again": "Erneut analysieren",
  "Original person": "Ursprünglich erkannte Person",
  "Original contract": "Ursprünglich erkannter Vertrag",
  "Corrected person": "Korrigierte Person",
  "Corrected contract": "Korrigierter Vertrag",
  "Contract name/Plan": "Vertragsname / Tarif",
  "Contract not found": "Vertrag nicht gefunden",
  "Contract not found.": "Vertrag nicht gefunden.",
  "The requested contract could not be found. It may have been deleted or is not assigned to this person.": "Der angeforderte Vertrag wurde nicht gefunden. Er wurde möglicherweise gelöscht oder gehört nicht zu dieser Person.",
  "The task could not be loaded. Please try again or open the person directly.": "Die Aufgabe konnte nicht geladen werden. Bitte erneut versuchen oder die Person direkt öffnen.",
  "Contract Options": "Vertragsoptionen",
  "Selected color": "ausgewählte Farbe",
  "Selected customer": "ausgewählter Kunde",
  "Please select a contract package first": "Bitte zuerst Vertragspaket wählen",
  "Contract package": "Vertragspaket",
  "Contract package added.": "Vertragspaket hinzugefügt.",
  "Contract package deleted.": "Vertragspaket gelöscht.",
  "Contract package not found": "Vertragspaket nicht gefunden",
  "Contract package templates": "Vertragspaketvorlagen",
  "Contract packages": "Vertragspakete",
  "Contract price": "Vertragspreis",
  "Contract Reports": "Vertragsauswertungen",
  "Contract reports": "Vertragsauswertungen",
  "Contract start": "Vertragsbeginn",
  "Contract Start": "Vertragsbeginn",
  "Contract start date": "Vertragsstart",
  "Contract start date is required": "Vertragsbeginn ist erforderlich",
  "Contract start is required": "Vertragsbeginn ist erforderlich",
  "Contract starting": "Vertragsstart",
  "Contract status": "Vertragsstatus",
  "Contract Template": "Vertragsbaustein",
  "Contract template": "Vertragsvorlage",
  "Contract templates": "Vertragsbausteine",
  "Contract templates__alt1": "Vertragsbausteinvorlagen",
  "Contract templates__vertragsbaustein-vorlagen": "Vertragsbausteinvorlagen",
  "Contract": "Vertrag",
  "Contract__alt2": "Vertragsbaustein",
  "Contracts": "Verträge",
  "Contracts (SEPA)": "Verträge (SEPA)",
  "Contribution": "Beitrag",
  "Contribution manually waived": "Beitrag entfällt (manuell)",
  "Contribution deleted.": "Beitrag gelöscht.",
  "Contribution is already fully paid": "Beitrag ist bereits vollständig bezahlt",
  "Already paid contributions cannot be edited": "bereits gezahlte Beiträge können nicht bearbeitet werden.",
  "Amount locked due to partial payment": "Betrag bei Teilzahlung gesperrt – nur Zahlungsart änderbar.",
  "Contribution is already in a SEPA direct debit run": "Beitrag ist bereits in einem SEPA-Lastschriftlauf enthalten",
  "Contribution is already in a SEPA direct debit run and cannot be paid manually": "Beitrag ist bereits in einem SEPA-Lastschriftlauf enthalten und kann nicht manuell bezahlt werden",
  "Contribution saved.": "Beitrag gespeichert.",
  "Contributions": "Beiträge",
  "Conversion Rate": "Conversion-Rate",
  "Conversions": "Konversionen",
  "Converted": "konvertiert",
  "Copy all": "alle kopieren",
  "Copy column settings": "Spalteneinstellung kopieren",
  "Copy column settings to user:": "Spalteneinstellung für Benutzer kopieren:",
  "Copy code": "Code kopieren",
  "Copy link": "Link kopieren",
  "Copy not possible (browser permission).": "Kann nicht kopiert werden (Browser-Berechtigung).",
  "Copy template": "Vorlage kopieren",
  "Copy user preferences": "Benutzer-Einstellungen kopieren",
  "Copy user preferences hint": "Wählen Sie einen Quellbenutzer, einen oder mehrere Zielbenutzer und die Einstellungen, die übernommen werden sollen.",
  "Source user": "Quellbenutzer",
  "Target users": "Zielbenutzer",
  "Which icons are shown in the check-in list.": "Welche Symbole in der Check-in-Liste angezeigt werden.",
  "What do you want to automate?": "Was möchtest du automatisieren?",
  "What to copy": "Was kopieren?",
  "Copy report templates": "Auswertungsansichten kopieren",
  "Copy list layouts": "Listen-Layouts kopieren",
  "Copy table columns": "Tabellenspalten kopieren",
  "Copy dashboard layout": "Dashboard-Layout kopieren",
  "Copy preferences": "Einstellungen kopieren",
  "Preferences copied successfully": "Einstellungen wurden erfolgreich kopiert.",
  "Select at least one item to copy": "Bitte wählen Sie mindestens eine Option zum Kopieren.",
  "Copy template to user:": "Vorlage für Benutzer kopieren:",
  "Copy to other weeks": "auf andere Wochen kopieren",
  "Copy/reset": "kopieren/zurücksetzen",
  "Copy availabilities": "Verfügbarkeiten kopieren",
  "Please select at least one studio and one resource for source.": "Bitte wählen Sie mindestens ein Studio und eine Ressource als Quelle.",
  "Please select at least one studio and one resource for target.": "Bitte wählen Sie mindestens ein Studio und eine Ressource als Ziel.",
  "Please select at least one studio and one employee for reset.": "Bitte wählen Sie mindestens ein Studio und einen Mitarbeiter zum Zurücksetzen.",
  "Source and target studios must not overlap.": "Quell- und Zielstudios dürfen sich nicht überschneiden.",
  "Reset explicit week shifts so the default week applies again.": "Löscht nur direkt gesetzte Wochen-Schichten. Die Standardwoche bleibt erhalten und gilt danach wieder.",
  "Copying…": "kopieren…",
  "Importing…": "importieren…",
  "Copy is 1:1 by order: first source studio → first target studio, first source resource → first target resource, etc.": "Kopie erfolgt 1:1 nach Reihenfolge: erstes Quell-Studio → erstes Ziel-Studio, erste Quell-Ressource → erste Ziel-Ressource usw.",
  "All shifts of the source week are copied to the selected target week(s). Existing shifts of selected target employees in those weeks are replaced.": "Alle Schichten der Quellwoche werden in die ausgewählten Zielwochen kopiert. Vorhandene Schichten der ausgewählten Ziel-Mitarbeiter werden in diesen Wochen ersetzt.",
  "Select only studios that are not in the source.": "Wählen Sie nur Studios, die nicht in der Quelle vorkommen.",
  "Reset all availabilities": "alle Verfügbarkeiten zurücksetzen",
  "Reset all availabilities?": "alle Verfügbarkeiten zurücksetzen?",
  "Reset all availabilities confirmation": "Alle Verfügbarkeitsblöcke für alle Ressourcen und Studios werden endgültig gelöscht. Das kann nicht rückgängig gemacht werden.",
  "All availabilities reset": "Alle Verfügbarkeiten wurden zurückgesetzt.",
  "Copy__alt1": "Kopie",
  "Chargeback fee": "Rücklastschriftgebühr",
  "Fee type": "Gebührenart",
  "System fees": "Systemgebühren",
  "Tax": "Steuer",
  "Cost center": "Kostenstelle",
  "Cost Center": "Kostenstelle",
  "Cost center saved": "Kostenstelle gespeichert",
  "Cost centers": "Kostenstellen",
  "Costs & Calculation": "Kosten & Berechnung",
  "Count": "Anzahl",
  "Correction document": "Stornobeleg",
  "Country": "Land",
  "Country (optional)": "Land",
  "Country is required": "Land ist erforderlich",
  "Create account": "Konto anlegen",
  "Create admin": "Admin anlegen",
  "Create appointment": "Termin anlegen",
  "Create appointment anyway (with confirmation)": "Termin trotzdem anlegen",
  "Create appointment outside availability": "Termin außerhalb der Verfügbarkeit anlegen",
  "Create Appointment Outcome": "Abschluss-Szenario anlegen",
  "Create appointment?": "Termin anlegen?",
  "Create category": "Kategorie anlegen",
  "Create configuration": "Konfiguration anlegen",
  "Create Contract Template__alt1": "Vertragsbaustein anlegen",
  "Create Contract Template__alt2": "Vertragspaket anlegen",
  "Create Debt Collection Agency": "Inkasso-Dienstleister anlegen",
  "Create direct debit run": "Lastschriftlauf anlegen",
  "Create PriceAdjustment": "Preisanpassung anlegen",
  "Create price adjustment": "Preisanpassung anlegen",
  "Create installment plan": "Ratenzahlung anlegen",
  "Create lead": "Kontakt anlegen",
  "Create lead on first app login": "Kontakt beim ersten App-Login anlegen",
  "Create lead when creating person": "Kontakt erstellen",
  "Create new": "neu anlegen",
  "Create online booking": "Online-Buchung anlegen",
  "Create payment method": "Zahlungsart anlegen",
  "Create Payment Plan": "Zahlungsplan anlegen",
  "Create phase": "Phase anlegen",
  "Create pipeline": "Phasenmodell anlegen",
  "Create preset": "Vorlage anlegen",
  "Create reminder": "Mahnung erstellen",
  "Create reminders": "Mahnungen erstellen",
  "Create reminder…": "Mahnung erstellen…",
  "Create Rest Period Template": "neues Ruhezeitmodell",
  "Create role": "Rolle anlegen",
  "Create SEPA Group": "SEPA-Gruppe anlegen",
  "Create tenant": "Mandant anlegen",
  "Create text template": "Textvorlage anlegen",
  "Create VAT setting": "USt-Einstellung anlegen",
  "Create Wallet Product": "neue Vorlage",
  "Create widget": "Formular anlegen",
  "Create, export and post direct debit runs": "Lastschriftläufe anlegen, exportieren und verbuchen",
  "Create/send reminders": "Mahnungen erzeugen / versenden",
  "Reminders execute group": "Mahnungen erstellen",
  "Create__alt2": "erstellen",
  "Created at": "erstellt am",
  "Created at__alt1": "angelegt am",
  "Created.": "angelegt.",
  "Created": "erstellt",
  "Created__alt1": "angelegt",
  "Credit": "aufbuchen",
  "Credit account": "Guthabenkonto",
  "Credit automation": "Guthabenautomatik",
  "Credit account per scope": "Guthabenkonto pro Bereich",
  "Credit account used for credit payments. You can set a different account per studio; otherwise the tenant default applies.": "Wertekonto, das für Guthabenzahlungen verwendet wird. Pro Studio kann ein eigenes Konto gewählt werden, sonst gilt der Mandanten-Standard.",
  "Transfer surplus contribution credits to credit account": "Überschüssige Beitragsguthaben ins Guthabenkonto übertragen",
  "Paid contribution corrections are moved to the configured credit account when they leave a surplus.": "Bezahlte Beitragskorrekturen werden bei einem Überschuss auf das konfigurierte Guthabenkonto übertragen.",
  "Automatically apply credit account to open receivables": "Guthabenkonto automatisch mit offenen Forderungen verrechnen",
  "Available credit is automatically used to settle open items.": "Verfügbares Guthaben wird automatisch zum Ausgleich offener Posten verwendet.",
  "Credit/debit card payments": "Kredit-/Debitkartenzahlungen",
  "Recurring bank transfers / standing orders": "Wiederkehrende Banküberweisungen / Daueraufträge",
  "Creditor ID": "Gläubiger-ID",
  "Creditor ID (for SEPA direct debit)": "Gläubiger-ID (für SEPA-Lastschrift)",
  "Creditor ID is required when direct debit is active": "Gläubiger-ID ist erforderlich, wenn Lastschrift aktiv ist",
  "Cross-tenant import": "Mandantenübergreifender Import",
  "Currency": "Währung",
  "Current": "aktuell",
  "Current date": "aktuelles Datum",
  "current date": "aktuelles Datum",
  "Current date & time": "aktuelles Datum & Uhrzeit",
  "Current date (long)": "aktuelles Datum (lang)",
  "Current day": "aktueller Tag",
  "Current Members": "aktueller Bestand",
  "Current month": "aktueller Monat",
  "Current password": "aktuelles Passwort",
  "Current phase": "aktuelle Phase",
  "Current time": "aktuelle Uhrzeit",
  "Current year": "aktuelles Jahr",
  "Custom": "individuell",
  "Custom CSS Rules": "eigene CSS-Regeln",
  "Custom CSS__alt1": "Custom CSS",
  "Custom CSS__alt2": "Eigenes CSS",
  "Custom Holiday": "eigenen Feiertag",
  "Custom reason": "eigener Grund",
  "Manual correction": "manuelle Korrektur",
  "Cancellation reason type": "Art des Stornogrunds",
  "Payments & amount": "Zahlungen & Betrag",
  "Please select a reason": "bitte einen Grund wählen",
  "Please select a cancellation type": "bitte eine Storno-Art wählen",
  "No chargeback reasons configured.": "keine Rücklastschrift-Gründe konfiguriert.",
  "Select reason…": "Grund wählen…",
  "Select type": "Typ wählen",
  "Selected payments count": "{0} Zahlung(en) ausgewählt",
  "Type is required": "Typ ist erforderlich",
  "Customer": "Kunde",
  "Customer Number": "Kundennummer",
  "Customer Type": "Kunden-Typ",
  "Column": "Spalte",
  "Custom sender text": "Eigener Absendertext",
  "Custom sender text tooltip": "Optionaler individueller Absendertext. Wenn leer, werden die Daten aus der gewählten Quelle (Studio bzw. Mandant) verwendet.",
  "Customize columns": "Spalten anpassen",
  "Cycle": "Zyklus",
  "Cycle unit once": "einmalig",
  "Cycle unit daily": "täglich",
  "Cycle unit weekly": "wöchentlich",
  "Cycle unit monthly": "monatlich",
  "Cycle unit yearly": "jährlich",
  "Daily Distribution": "Tägliche Verteilung",
  "Dark": "dunkel",
  "Dashboard": "Dashboard",
  "Dashboard & Check-in": "Dashboard & Check-in",
  "Configure dashboard layout": "Dashboard-Layout konfigurieren",
  "Save dashboard layout": "Dashboard-Layout speichern",
  "Save layout": "Layout speichern",
  "Primary action": "primäre Aktion",
  "Secondary action": "sekundäre Aktion",
  "No action": "keine Aktion",
  "Copy my dashboard layout to this user": "Mein Dashboard-Layout auf diesen Benutzer kopieren",
  "Dashboard layout": "Dashboard-Layout",
  "Dashboard layout hint": "Reihenfolge per Drag & Drop ändern, Kacheln ein- oder ausblenden. Im normalen Modus werden nur die aktivierten Kacheln angezeigt.",
  "Drop here": "Hier ablegen",
  "Dashboard copy to user hint": "Wählen Sie einen Benutzer und übernehmen Sie Ihr aktuelles Dashboard-Layout (sichtbare Kacheln und Reihenfolge) auf dessen Konto.",
  "Also apply to (users)": "Auch anwenden auf (Benutzer)",
  "Save for me only": "Nur für mich speichern",
  "Data updated": "Daten aktualisiert",
  "Date": "Datum",
  "Date & Time": "Datum & Zeit",
  "Date format (Locale)": "Datumsformat (Locale)",
  "Date is required": "Datum ist erforderlich",
  "Date of birth": "Geburtsdatum",
  "Date, time, timezone, currency": "Datum, Uhrzeit, Zeitzone, Währung",
  "Date, time, timezone, currency – your settings in admin": "Datum, Uhrzeit, Zeitzone, Währung – Ihre Einstellungen im Admin",
  "Date/time is invalid": "Datum/Zeit ist ungültig",
  "Date/time is required": "Datum/Zeit ist erforderlich",
  "Day": "Tag",
  "Day of month": "Tag des Monats",
  "Day of month (e.g. 1st or 15th)": "Tag des Monats (z. B. 1. oder 15.)",
  "Day:": "Tag:",
  "Days": "Tage",
  "Days After Due Date": "Tage nach Fälligkeit",
  "Days Inactive": "Tage inaktiv",
  "Days Overdue": "Tage überfällig",
  "Days Until Expiry": "Tage bis Ablauf",
  "Days/Month": "Tage/Monat",
  "Days/month": "Tage/Monat",
  "Days/Year": "Tage/Jahr",
  "Days/year": "Tage/Jahr",
  "DE": "DE",
  "EN": "EN",
  "Deactivate tenant": "Mandant deaktivieren",
  "Deadline passed! Execution date is not reachable.": "Frist abgelaufen! Ausführungsdatum ist nicht erreichbar.",
  "Deadlines & rules for cancellations": "Fristen & Regeln für Kündigungen",
  "Dear (formal)": "Sehr geehrte/Sehr geehrter",
  "Dear neutral": "Liebe/Lieber",
  "Dear + first name": "Liebe/r + Vorname",
  "Dear + Mr./Ms. last name": "Liebe/r + Herr/Frau Nachname",
  "Dear Sir/Madam + last name": "Sehr geehrte/r + Herr/Frau Nachname",
  "Dear__alt1": "Liebe",
  "Dear__alt2": "Liebe/Lieber",
  "Dear__alt3": "Lieber",
  "Dear__alt4": "Sehr geehrte*r",
  "Debit": "abbuchen",
  "Debt Collection": "Inkasso",
  "Debt management tab agencies": "Inkasso-Dienstleister",
  "Debt collection (status)": "Inkasso",
  "Debt collection case submitted": "Inkasso-Fall wurde angelegt.",
  "Debt collection case validation hint": "Bitte Person, Inkasso-Dienstleister und mindestens einen offenen Posten wählen.",
  "Debt collection cases": "Inkasso-Fälle",
  "Debt collection cases card description": "Inkasso-Fälle ansehen; vorbereitete Übergaben abschließen.",
  "Debt collection cases hint":
    "Übergaben ohne Zahlungsbuchung in Payments. Neue Inkasso-Fälle entstehen im Mahnwesen (Inkasso-Stufe). Posten sind dem Fall zugeordnet; zweistufige Übergaben mit „Jetzt final übergeben“ in dieser Liste abschließen.",
  "Debt collection interface": "Schnittstelle",
  "Debt collection interface type": "Schnittstellentyp",
  "KOHL GmbH & Co. KG (E-Mail)": "KOHL GmbH & Co. KG (E-Mail)",
  "Debt collection handover amount": "Übergabebetrag",
  "Debt collection person total handover": "Summe Übergaben",
  "Debt collection with agency": "Inkasso: {0}",
  "Debt collection transmission id": "Übermittlungs-Kennung",
  "External reference": "Externe Referenz",
  "DebtCollectionCaseAgencyInvalid": "Inkasso-Dienstleister ungültig oder inaktiv.",
  "DebtCollectionCaseOpenItemsNotAllowed": "Mindestens ein Posten ist nicht offen, passt nicht zur Person oder wurde bereits ans Inkasso übergeben.",
  "DebtCollectionCaseOpenItemsRequired": "Bitte mindestens einen offenen Posten auswählen.",
  "DebtCollectionCaseNotPrepared": "Der Inkasso-Fall ist nicht im Status „vorbereitet“ oder kann nicht final übergeben werden.",
  "DebtCollectionCaseFinalizeOpenItemsInvalid": "Für die finale Übergabe müssen alle Posten des Falls noch offen sein und zur Person des Falls gehören.",
  "Submitted at": "Übergeben am",
  "Deduct points": "Punkte abziehen",
  "Default": "Standard",
  "Default pipeline": "Standard-Phasenmodell",
  "Default (for all weeks)": "Standard (für alle Wochen)",
  "Default (tenant)": "Standard (Mandant)",
  "Default Account for Contract Templates": "Standard-Konto für Vertragsbausteine",
  "Default account for credit payments": "Standardkonto für Guthabenzahlungen",
  "Default Account for Articles": "Standard-Konto für neue Artikel (Artikelverkauf)",
  "Default addressing (formal/informal)": "Standard-Ansprache (Sie/Du)",
  "Default appointment type": "Standard-Terminart",
  "Default appointment type (for “Book appointment”)": "Standard-Terminart (für „Termin buchen“)",
  "Default assignments": "Standard-Zuordnungen",
  "Default assignments saved.": "Standard-Zuordnungen gespeichert.",
  "Default availabilities": "Standard-Verfügbarkeiten",
  "Default Balance": "Standard-Saldo",
  "Default balance must be >= 0": "Standard-Saldo muss >= 0 sein",
  "Default End Time": "Standard-Endzeit",
  "Default history window": "Standard-Anzeige im Check-in",
  "Default language": "Standard-Sprache",
  "Default Lead Source": "Standard-Kontaktquelle",
  "Default Price": "Standardpreis",
  "Default Price (optional)": "Standardpreis",
  "Default role for new users": "Standard-Rolle für neue Benutzer",
  "Default Start": "Standard-Beginn",
  "Default Start Time": "Standard-Startzeit",
  "Default Studios": "Standard-Studios",
  "Default template": "Standardvorlage",
  "Default template cleared.": "Standardvorlage entfernt.",
  "Default template set.": "Standardvorlage gesetzt.",
  "Default templates": "Standardvorlagen",
  "Default templates & categories": "Standard-Vorlagen & Kategorien",
  "Default templates and sending settings__alt1": "Standardvorlagen und Versand-Einstellungen",
  "Default templates and sending settings__alt2": "Standardvorlagen & Versand-Einstellungen",
  "Default theme": "Standard-Design",
  "Available themes and app default": "verfügbare Designs und Standard der App",
  "Default theme for users without own choice": "Design für alle Benutzer ohne eigene Wahl",
  "Default login image": "Standard-Login-Bild",
  "Default login image saved": "Standard-Login-Bild gespeichert",
  "Default login image removed": "Standard-Login-Bild entfernt",
  "Image shown on the member app login screen before tenant selection. Recommended format: 1080×1920.": "Bild auf dem Studio-App-Loginbildschirm vor der Mandantenauswahl. Empfohlenes Format: 1080×1920.",
  "Studio app default": "Studio-App-Standard",
  "Studio app default (before login)": "Studio-App-Standard (vor dem Login)",
  "Design and images for member app before login": "Design und Bilder der Studio-App vor dem Login",
  "Design and images shown in the member app before the user has logged in. Used as standard when no tenant is selected.": "Design und Bilder, die in der Studio-App vor der Anmeldung angezeigt werden. Wird als Standard genutzt, wenn kein Mandant gewählt ist.",
  "Comma-separated: home, contracts, bookings, wallets, openItems, payments, paymentMethods, checkinHistory, profile, settings, studios, restPeriods, cancellation": "Kommagetrennt: home, contracts, bookings, wallets, openItems, payments, paymentMethods, checkinHistory, profile, settings, studios, restPeriods, cancellation",
  "Default Usage Limit": "Standard-Nutzungslimit",
  "Default Validity": "Standard-Gültigkeit",
  "Default values for new members & start page": "Standardwerte für neue Mitglieder & Startseite",
  "Default window": "Standard-Fenster",
  "Defines the permissions for this user. Roles can be managed under 'Settings > Roles'.": "Legt die Berechtigungen für diesen Benutzer fest. Rollen können unter 'Einstellungen > Rollen' verwaltet werden.",
  "Delete": "löschen",
  "Delete document": "Dokument löschen",
  "Delete__löschen": "löschen",
  "Delete access medium?": "Zutrittsmedium löschen?",
  "Delete account?": "Konto löschen?",
  "Delete admin": "Admin löschen",
  "Delete block": "Block löschen",
  "Delete all changes": "alle Änderungen löschen",
  "Delete all changes?": "alle Änderungen löschen?",
  "Delete already booked entities": "bereits bebuchte Entitäten löschen",
  "Delete anyway": "Trotzdem löschen",
  "Delete appointment?": "Termin löschen?",
  "Delete bank account?": "Bankverbindung löschen?",
  "Delete Cancellation Model": "Kündigungsmodell löschen",
  "Delete category": "Kategorie löschen",
  "Delete column settings": "Spalten-Einstellung löschen",
  "Delete contract package": "Vertragspaket löschen",
  "Delete Contract Template": "Vertragspaket löschen",
  "Delete contribution": "Beitrag löschen",
  "Delete Debt Collection Agency": "Inkasso-Dienstleister löschen",
  "Delete direct debit run with SEPA file?": "Lastschriftlauf mit SEPA-Datei löschen?",
  "Delete direct debit run?": "Lastschriftlauf löschen?",
  "Delete priceAdjustment": "Preisanpassung löschen",
  "Delete PriceAdjustment": "Preisanpassung löschen",
  "Delete price adjustment": "Preisanpassung löschen",
  "Delete document?": "Dokument löschen?",
  "Delete email account?": "E-Mail-Konto löschen?",
  "Delete failed": "Fehler beim Löschen",
  "Delete blocked title": "Kann nicht gelöscht werden",
  "Delete holiday configuration?": "Feiertagskonfiguration löschen?",
  "Delete holiday?": "Feiertag löschen?",
  "Holidays (current and next year)": "Feiertage (aktuelles und nächstes Jahr)",
  "Really delete this holiday?": "Diesen Feiertag wirklich löschen?",
  "Delete integration": "Schnittstelle löschen",
  "Delete lead": "Kontakt löschen",
  "Delete leads": "Kontakte löschen",
  "Delete logs": "Protokolleinträge löschen",
  "Delete logs description": "Protokolleinträge filtern und löschen.",
  "Delete payment method": "Zahlungsart löschen",
  "Delete payment method?": "Zahlungsart löschen?",
  "Delete Payment Plan": "Zahlungsplan löschen",
  "Delete reader device": "Lesegerät löschen",
  "Delete Rest Period Template": "Ruhezeitmodell löschen",
  "Delete rest period template": "Ruhezeitmodell löschen",
  "Delete role": "Rolle löschen",
  "Delete rule?": "Regel löschen?",
  "Delete SEPA Group": "SEPA-Gruppe löschen",
  "Delete setting?": "Einstellung löschen?",
  "Delete sub-contract": "Untervertrag löschen",
  "Delete template": "Vorlage löschen",
  "Delete tenant": "Mandant löschen",
  "Delete my data": "Meine Daten löschen",
  "Delete VAT setting?": "USt-Einstellung löschen?",
  "Delete version": "Version löschen",
  "Delete wallet": "Wertekonto löschen",
  "Delete Wallet Product": "Wertekonto-Vorlage löschen",
  "Deleted": "gelöscht",
  "Deleted.": "gelöscht.",
  "Delete people": "Personen löschen",
  "Delete people help": "Erlaubt das Löschen leerer Personen ohne Verträge, Zahlungen, Termine oder andere verknüpfte Daten.",
  "Delete person": "Person löschen",
  "Delete person action": "Löschen",
  "Delete person confirmation": "Diese Person wird dauerhaft gelöscht. Ein ausschließlich zugehöriger Kontakt inklusive Verlauf wird ebenfalls gelöscht. Andere verknüpfte Daten verhindern das Löschen.",
  "Delivery channel": "Versandkanal",
  "Delivery channels": "Versandkanäle",
  "Denied": "verweigert",
  "Denied__alt1": "abgewiesen",
  "Describe changes…": "Änderungen beschreiben…",
  "Description (DE)": "Beschreibung (DE)",
  "Description (EN)": "Beschreibung (EN)",
  "Description__alt2": "Bezeichnung",
  "Click an element in the preview to configure it": "Klicke ein Element in der Vorschau, um es zu konfigurieren",
  "Design": "Design",
  "Design & Colors": "Design & Farben",
  "Design mode": "Design-Modus",
  "Design preview page": "Seite in der Vorschau",
  "Design page type": "Terminart",
  "Design page slot": "Termin & Uhrzeit",
  "Design page contact": "Kontaktdaten",
  "Design page review": "prüfen & bestätigen",
  "Design page done": "fertig",
  "Design Editor": "Design-Editor",
  "Design editor editing": "bearbeiten",
  "Design element page": "Seite",
  "Design element header": "Kopfbereich",
  "Design element stepsIndicator": "Schrittanzeige",
  "Design element appointmentTypeCard": "Terminart-Karte",
  "Design element appointmentTypeIcon": "Terminart-Icon",
  "Design element weekBar": "Wochenleiste",
  "Design element daySelectorContainer": "Tagesauswahl",
  "Design element daySelector": "Tages-Kachel",
  "Design element daySelectorIndicator": "Tages-Indikator",
  "Design element timeSlot": "Zeitslot",
  "Design element secondaryButton": "sekundäre Schaltfläche",
  "Design element primaryButton": "primäre Schaltfläche",
  "Design element card": "Karte",
  "Design element contactForm": "Kontaktformular",
  "Design element footer": "Fußzeile",
  "Design element reviewConfirm": "Überblick & Bestätigung",
  "Design element confirmation": "Bestätigungsanzeige",
  "Design element buttonBar": "Schaltflächenleiste",
  "Button bar alignment": "Ausrichtung der Schaltflächenleiste",
  "Design element studioSelector": "Studio-Auswahl",
  "Design element studioCard": "Studio-Kachel",
  "Design style background": "Hintergrund",
  "Design style border": "Rahmenfarbe",
  "Design style step active": "Schritt aktiv",
  "Design style step inactive": "Schritt inaktiv",
  "Design style step text active": "Textfarbe Schritt aktiv",
  "Design style step text inactive": "Textfarbe Schritt inaktiv",
  "Design style day tile unselected": "Tages-Kachel (nicht gewählt)",
  "Design style day tile selected": "Tages-Kachel (gewählt)",
  "Design style border width": "Rahmenstärke",
  "Design style duration color": "Dauer-/Zeitfarbe",
  "Design style price color": "Preisfarbe",
  "Design style day tile date": "Datum-Farbe",
  "Design style day tile weekday": "Wochentag-Farbe",
  "Design style border selected": "Rahmen (ausgewählt)",
  "Design style label and card border": "Label- und Kartenrahmenfarbe",
  "Design style card border": "Kartenrahmenfarbe",
  "Design style label color": "Label-Farbe",
  "Design style background selected": "Hintergrund (ausgewählt)",
  "Design style text color selected": "Textfarbe (ausgewählt)",
  "Design style input background": "Textfeld-Hintergrund",
  "Design style input border and text": "Textfeld Rahmen & Text",
  "Design style input border": "Textfeld-Rahmenfarbe",
  "Design style input border width": "Textfeld-Rahmenstärke",
  "Design style input text": "Textfeld-Textfarbe",
  "Design style card shadow": "Karten-Schatten",
  "Design style input size": "Eingabefeld-Größe",
  "Design style card body padding": "Karten-Innenabstand",
  "Design style contract preview shadow": "Schatten Vertragsvorschau",
  "Design style form field spacing": "Abstand Formularfelder",
  "Required and validation error color": "Pflichtfeld und Validierungsfehler",
  "Contact form alignment excludes selected slot card": "Gilt nur für Überschrift und Formular, nicht für die Karte „ausgewählter Termin“.",
  "Design style selected slot background": "Hintergrund ausgewählter Termin",
  "Design style selected slot border": "Rahmen ausgewählter Termin",
  "Design style selected slot text": "Text ausgewählter Termin",
  "Design style confirmation title color": "Bestätigung Titel-Farbe",
  "Design style confirmation subtitle color": "Bestätigung Untertitel-Farbe",
  "Design style hover background": "Hover-Hintergrund",
  "Design style hover text": "Hover-Textfarbe",
  "Link color": "Linkfarbe",
  "Link color tooltip": "Farbe für Links (z. B. Datenschutz, AGB, „Ändern“).",
  "Contact form heading color": "Überschrift Kontaktformular",
  "Selected slot contact and confirmation": "ausgewählter Termin (Kontakt & Bestätigung)",
  "Privacy policy text color": "Textfarbe Datenschutzerklärung",
  "Review confirm heading color": "Überschrift Überblick & Bestätigung",
  "Checkmark color selected": "Häkchenfarbe gewählt",
  "Checkmark color unselected": "Häkchenfarbe nicht gewählt",
  "Header heading color": "Überschrift",
  "Header text color": "Text (Fließtext)",
  "Step number color active": "Schrittzahl aktiv",
  "Step number color inactive": "Schrittzahl inaktiv",
  "Studio selector heading color": "Überschrift",
  "Studio selector text color": "Text",
  "Studio card heading color": "Überschrift (Studioname)",
  "Studio card text color": "Text",
  "Studio name": "Studioname",
  "Day tile weekday unselected": "Wochentag (nicht gewählt)",
  "Day tile weekday selected": "Wochentag (gewählt)",
  "Day tile text unselected": "Text/Datum (nicht gewählt)",
  "Day tile text selected": "Text/Datum (gewählt)",
  "Availability indicator shape": "Form Verfügbarkeits-Anzeige",
  "Availability shape round": "rund",
  "Availability shape square": "eckig",
  "Availability shape trapezoid": "Trapez",
  "Availability shape diamond": "Raute",
  "Week bar button color": "Schaltflächenfarbe",
  "Week bar button border": "Rahmenfarbe der Schaltfläche",
  "Week bar button border width": "Rahmenstärke der Schaltfläche",
  "Design panel general": "Allgemein",
  "Design panel general colors": "Allgemeine Farben",
  "Design panel font and corners": "Schrift & Ecken",
  "Design color clear hint": "zum Zurücksetzen auf transparent/keine Farbe das Löschen-Symbol (×) klicken.",
  "Design & iFrame configuration": "Design & iFrame-Konfiguration",
  "Design preset": "Design-Vorlage",
  "Design presets for booking widgets": "Design-Vorlagen für Buchungsformulare",
  "Details": "Details",
  "Details__alt1": "Daten",
  "Device": "Gerät",
  "Device default": "Gerätestandard",
  "Device ID": "Device-ID",
  "Device is offline": "Gerät ist offline",
  "Device is online": "Gerät ist online",
  "Device is registered": "Gerät ist registriert",
  "Device was successfully registered and synchronized with m1connect": "Gerät wurde erfolgreich registriert und mit m1connect synchronisiert",
  "Disconnect m1connect": "m1connect trennen",
  "Disconnect m1connect device?": "m1connect-Gerät trennen?",
  "m1connect device disconnected.": "m1connect-Gerät wurde getrennt.",
  "m1connect client ID": "m1connect-Client-ID",
  "The reader device remains in m1member, but the current m1connect client will be disconnected and must register again with a new registration code.": "Das Lesegerät bleibt in m1member erhalten, aber der aktuelle m1connect-Client wird getrennt und muss sich mit einem neuen Registrierungscode erneut registrieren.",
  "DeviceId": "Geräte-Id",
  "DeviceId is required": "Geräte-Id ist erforderlich",
  "DeviceId must be exactly 32 hexadecimal characters": "Geräte-Id muss genau 32 hexadezimale Zeichen sein",
  "DeviceId must contain hexadecimal characters only": "Geräte-Id muss hexadezimale Zeichen enthalten",
  "DE…": "DE…",
  "Different Tariffs": "verschiedene Tarife",
  "Digital file": "Dokumente",
  "Direct Debit": "Lastschrift",
  "Direct debit active": "Lastschrift aktiv",
  "Direct debit cancelled.": "Lastschrift storniert.",
  "Direct debit export": "Lastschrift-Export",
  "Direct debit group is required": "Lastschrift-Gruppe ist erforderlich",
  "Direct debit group(s)": "Lastschrift-Gruppe(n)",
  "Direct Debit Groups": "Lastschrift-Gruppen",
  "Direct debit report": "Lastschriftbericht",
  "Direct debit run": "Lastschriftlauf",
  "Direct debit run deleted.": "Lastschriftlauf gelöscht.",
  "Direct debit run deletion failed.": "Lastschriftlauf konnte wegen eines Systemfehlers nicht gelöscht werden.",
  "Direct debit run is being deleted": "Lastschriftlauf wird gelöscht",
  "Direct debit item excluded.": "Lastschriftposition ausgelassen.",
  "Deleting direct debit run": "Lastschriftlauf wird gelöscht",
  "Sepa direct debit create empty modal title": "kein Lastschriftlauf angelegt",
  "Sepa direct debit create empty modal default":
    "Es wurden keine fälligen Zeilen im Beitragskalender gefunden, die zu diesem Lauf passen (Studios, Lastschrift-Gruppen, „Fällig bis“ bzw. Ausführungsdatum). Das ist kein Widerspruch zu „offenen Posten“: dort erscheinen alle noch offenen Forderungen der Person — also auch Verkäufe, Rechnungszahlung, Ratenzahlung oder Beiträge ohne Lastschrift — während der Sammellauf nur Kalenderzeilen mit passender SEPA-Gruppe, Zahlungsart Lastschrift und Fälligkeit übernimmt.",
  "Sepa direct debit create empty modal footnote":
    "Kurz: offene Posten = Kontenstand vieler Arten; Lastschriftlauf = gefilterte Kalender-Lastschriften. Wenn oben technische Gründe stehen, zuerst diese Zeilen lesen.",
  "Direct debit run posted.": "Lastschriftlauf verbucht.",
  "Direct debit run posting started.": "Verbuchung läuft im Hintergrund.",
  "Direct debit run has errors": "Lastschriftlauf enthält Fehler",
  "Fix the direct debit errors before downloading or posting this run.": "Prüfen Sie die Fehlerdetails, bevor Sie diesen Lauf herunterladen oder verbuchen.",
  "Exclude customer": "Kunden auslassen",
  "Include customer": "Kunden aufnehmen",
  "Sepa direct debit create job title": "Lastschriftlauf wird angelegt",
  "Sepa direct debit create job started": "Lastschriftlauf wird im Hintergrund angelegt.",
  "Selected studio and direct debit group combination is already reserved.": "Mindestens eine gewählte Kombination aus Studio und Lastschriftgruppe ist bereits durch einen laufenden Lastschriftlauf reserviert.",
  "SepaReportExecutionDateRequired": "Der Lastschriftbericht ist erst verfügbar, wenn ein Ausführungsdatum gesetzt ist.",
  "SepaBookingDateInFuture": "Tatsächliches Ausführungsdatum darf nicht in der Zukunft liegen.",
  "sepaDirectDebitRuns.createJob.prepare": "Lastschriftlauf wird vorbereitet",
  "sepaDirectDebitRuns.createJob.calendar": "Beitragskalender wird aktualisiert",
  "sepaDirectDebitRuns.createJob.collect": "Beiträge werden ermittelt",
  "sepaDirectDebitRuns.createJob.openItems": "offene Posten werden vorbereitet",
  "sepaDirectDebitRuns.createJob.items": "Lastschriftpositionen werden erstellt",
  "sepaDirectDebitRuns.createJob.xml": "SEPA-Datei wird erstellt",
  "sepaDirectDebitRuns.createJob.done": "Lastschriftlauf wurde angelegt",
  "Direct debit run is already being posted.": "Dieser Lastschriftlauf wird bereits verbucht.",
  "Direct Debit Runs (Admin)": "Lastschriftläufe (Admin)",
  "Direct Debit Settings": "Lastschrift-Einstellungen",
  "Direct debit submitted": "LS eingereicht",
  "Dispatch failed messages": "fehlgeschlagene Sendungen",
  "Dispatch pending approvals": "offene Freigaben",
  "Rebooking": "Umbuchung",
  "Applied correction": "verrechnet",
  "Import post-import hooks title": "Post-Import-Hooks",
  "Import post-import hooks hint": "Heuristische Korrekturen, die nach dem Schema-Import laufen. Standard: aktiv. Pro Schema deaktivierbar, wenn sie für den Mandanten nicht passen.",
  "CenterCom": "CenterCom",
  "Overridden": "abweichend vom Standard",
  "Direct Debits": "Lastschriften",
  "Direct debits": "Lastschriften",
  "Disabled": "deaktiviert",
  "disabled": "deaktiviert",
  "Discard": "verwerfen",
  "PriceAdjustment": "Preisanpassung",
  "PriceAdjustment (optional)": "Preisanpassung",
  "PriceAdjustment is required": "Preisanpassung ist erforderlich",
  "PriceAdjustment templates for contracts": "Vorlagen für Preisanpassungen in Verträgen",
  "PriceAdjustment value cannot be negative": "Preisanpassungswert darf nicht negativ sein",
  "PriceAdjustment value is required": "Preisanpassungswert ist erforderlich",
  "PriceAdjustments": "Preisanpassungen",
  "Adjustment": "Anpassung",
  "Adjustment value is required": "Anpassungswert ist erforderlich",
  "Display name": "Anzeigename",
  "Display name on welcome card": "Anzeigename auf der Willkommenskarte",
  "Display name is required": "Anzeigename ist erforderlich",
  "Display name max 255 characters": "Anzeigename darf höchstens 255 Zeichen haben",
  "Lead form": "Kontaktformular",
  "Reset link URL": "Reset-Link URL",
  "Display Options": "Anzeige-Optionen",
  "Distribution by Duration": "Verteilung nach Laufzeit",
  "Distribution by Duration (Bar)": "Verteilung nach Laufzeit (Balken)",
  "Distribution by Status": "Verteilung nach Status",
  "Distribution by Tariff": "Verteilung nach Tarif",
  "Distribution by Time Period": "Verteilung nach Zeitraum",
  "Distribution by Time Period (Bar)": "Verteilung nach Zeitraum (Balken)",
  "Diverse": "divers",
  "Do not contact": "nicht mehr kontaktieren",
  "Do you really want to cancel this direct debit?": "Möchten Sie diese Lastschrift wirklich stornieren?",
  "Do you really want to cancel this entire direct debit run?": "Möchten Sie diesen kompletten Lastschriftlauf wirklich stornieren?",
  "Do you really want to cancel this payment?": "Möchten Sie diese Zahlung wirklich stornieren?",
  "Do you really want to clean up all orphaned open items? This removes OpenItem references from the contribution calendar that are not in booked direct debit runs. This action cannot be undone.": "Möchten Sie wirklich alle verwaisten offenen Posten bereinigen? Dies entfernt OpenItem-Referenzen aus dem Beitragskalender, die nicht in verbuchten Lastschriftläufen sind. Diese Aktion kann nicht rückgängig gemacht werden.",
  "Do you really want to delete this access medium?": "Möchten Sie dieses Zutrittsmedium wirklich löschen?",
  "Do you really want to delete this bank account?": "Willst du diese Bankverbindung wirklich löschen?",
  "Do you really want to delete this contribution?": "Möchten Sie diesen Beitrag wirklich löschen?",
  "Do you really want to delete this direct debit run?": "Möchten Sie diesen Lastschriftlauf wirklich löschen?",
  "Do you really want to delete this reader device?": "Möchten Sie dieses Lesegerät wirklich löschen?",
  "Do you really want to permanently delete all changes for this person?": "Möchten Sie wirklich alle Änderungen für diese Person unwiderruflich löschen?",
  "Do you really want to post this direct debit run? Payments will be recorded with the specified booking date.": "Möchten Sie diesen Lastschriftlauf wirklich verbuchen? Die Zahlungen werden mit dem angegebenen tatsächlichen Ausführungsdatum erfasst.",
  "Do you really want to post this direct debit run? Payments will be recorded with the actual execution date.": "Möchten Sie diesen Lastschriftlauf wirklich verbuchen? Die Zahlungen werden mit dem tatsächlichen Ausführungsdatum erfasst.",
  "Do you really want to post this direct debit run? Payments will be recorded with the execution date.": "Möchten Sie diesen Lastschriftlauf wirklich verbuchen? Die Zahlungen werden mit dem Ausführungsdatum erfasst.",
  "Do you really want to revoke the cancellation?": "Möchten Sie die Kündigung wirklich zurücknehmen?",
  "Do you want to delete all logs matching the current filter (even if multiple pages are affected)?": "Möchten Sie alle Protokolleinträge löschen, die zum aktuellen Filter passen (auch wenn mehrere Seiten betroffen sind)?",
  "Do you want to delete all system logs matching the current filter?": "Möchten Sie alle Protokolleinträge löschen, die zum aktuellen Filter passen?",
  "Do you want to import bank data from the German Bundesbank? This may take a few minutes.": "Möchten Sie die Bankdaten von der Deutschen Bundesbank importieren? Dies kann einige Minuten dauern.",
  "Document": "Dokument",
  "Document file not available": "Zu diesem Vorgang ist keine Datei hinterlegt.",
  "No file": "keine Datei",
  "Document deleted.": "Dokument gelöscht.",
  "Document generation": "Dokumentenerstellung",
  "Document is being resent.": "Dokument wird erneut versendet.",
  "Document title (digital file)": "Dokumententitel",
  "Document uploaded.": "Dokument hochgeladen.",
  "done": "erledigt",
  "Done__alt1": "erledigt",
  "Done__alt2": "fertig",
  "Door": "Tür",
  "down": "ab",
  "Download": "herunterladen",
  "Download PDF": "PDF herunterladen",
  "Download backup": "herunterladen",
  "Download document": "Dokument herunterladen",
  "Download failed": "Fehler beim Download",
  "Download SEPA file": "SEPA-Datei herunterladen",
  "Download SEPA file again": "SEPA-Datei erneut herunterladen",
  "Draft": "Entwurf",
  "Drag column to change order": "Spalte ziehen, um Reihenfolge zu ändern",
  "Due Date": "Fälligkeitsdatum",
  "Due date until": "Fälligkeit bis",
  "Due date": "Fälligkeit",
  "Due date__alt2": "Fälligkeitsdatum",
  "Due since": "fällig seit",
  "Due on": "fällig am",
  "Originally due": "ursprünglich fällig",
  "Next action date": "ausführbar ab",
  "Next reminder on": "nächste Mahnung am",
  "Sent on": "versendet am",
  "Due": "fällig",
  "Due__alt2": "mahnfällig",
  "Dues": "Beiträge",
  "Dunning": "Mahnwesen",
  "Dunning / overdue": "Mahnung / mahnfällig",
  "Duplicate": "duplizieren",
  "Copy from template": "Kopie aus Vorlage",
  "None (empty tenant)": "keine (leerer Mandant)",
  "Optional. Only tenants marked as copy template are listed. Configuration and assets will be copied.": "Optional. Es werden nur Mandanten angezeigt, die als Kopiervorlage markiert sind. Einstellungen und Dateien werden übernommen.",
  "Use as copy template": "als Kopiervorlage nutzen",
  "If enabled, this tenant appears in the template dropdown when creating new tenants.": "Wenn aktiviert, erscheint dieser Mandant beim Anlegen neuer Mandanten in der Vorlagen-Auswahl.",
  "Duplicate Contract Template": "Vertragspaket duplizieren",
  "Copy holiday configuration from one scope to another.": "Feiertagskonfiguration von einem Bereich in einen anderen kopieren.",
  "Duplicate holidays": "Feiertage duplizieren",
  "Duplicate of": "Kopie von",
  "Duplicate rest period template": "Ruhezeitmodell duplizieren",
  "Duplicate units": "Einheiten duplizieren",
  "Duplicated.": "dupliziert.",
  "Duplicated": "dupliziert",
  "Zoom in": "vergrößern",
  "Zoom out": "verkleinern",
  "Duplicate record name suffix": " (Kopie)",
  "Duration (Minutes)": "Dauer (Minuten)",
  "Duration (Months)": "Laufzeit (Monate)",
  "Duration changed.": "Dauer geändert.",
  "Drag appointment end": "Terminende ziehen",
  "Drag appointment start": "Terminbeginn ziehen",
  "Duration is required": "Dauer ist erforderlich",
  "Duration": "Dauer",
  "Duration__alt2": "Laufzeit",
  "E-Mail": "E-Mail",
  "e.g. 0.99": "z. B. 0,99",
  "e.g. 0176…": "z. B. 0176…",
  "e.g. 02:00": "z. B. 02:00",
  "e.g. 040…": "z. B. 040…",
  "e.g. 10 Card EMS": "z. B. 10er Karte EMS",
  "e.g. 19": "z. B. 19",
  "e.g. 19% VAT": "z. B. 19% USt",
  "e.g. 6 installments": "z. B. 6 Raten",
  "e.g. 8400": "z. B. 8400",
  "e.g. Cancellation confirmation - {{person.firstName}} {{person.lastName}}": "z. B. Kündigungsbestätigung - {{person.firstName}} {{person.lastName}}",
  "e.g. Rest period confirmation - {{person.firstName}} {{person.lastName}}": "z. B. Ruhezeitbestätigung - {{person.firstName}} {{person.lastName}}",
  "e.g. Cancellation confirmation, Contract, etc.": "z. B. Kündigungsbestätigung, Vertrag, etc.",
  "e.g. COBADEFFXXX": "z. B. COBADEFFXXX",
  "e.g. Company Holiday": "z. B. Betriebsferien",
  "e.g. CONS, TT, CHK": "z. B. BER, PT, CHK",
  "e.g. Consultation, Trial Training, Checkup": "z. B. Beratung, Probetraining, Checkup",
  "e.g. Consulting Team": "z. B. Beratungsteam",
  "e.g. Course Room A": "z. B. Kursraum A",
  "e.g. DE89370400440532013000": "z. B. DE89370400440532013000",
  "e.g. Dr., Prof.": "z. B. Dr., Prof.",
  "e.g. Inactive leads after 3 months": "z. B. inaktive Kontakte nach 3 Monaten",
  "e.g. JD, CT, TM1": "z. B. MM, BT, TG1",
  "e.g. John Doe": "z. B. Max Müller",
  "e.g. Trainer, Consultant": "z. B. Trainer, Berater",
  "e.g. m1member Studio Ltd.": "z. B. m1member Studio GmbH",
  "e.g. Main location, Branch North": "z. B. Hauptstandort, Filiale Nord",
  "e.g. Max Mustermann": "z. B. Max Mustermann",
  "e.g. member_welcome_email": "z. B. member_welcome_email",
  "e.g. Membership fees": "z. B. Mitgliedsbeiträge",
  "e.g. MK": "z. B. MK",
  "e.g. Office365": "z. B. Office365",
  "e.g. pelvic floor, back pain": "z. B. Beckenboden, Rücken",
  "e.g. reminders, welcome emails": "z. B. Mahnungen, Willkommensmails",
  "e.g. Rest period ending reminder": "z. B. Ruhezeit-Ende-Erinnerung",
  "e.g. SEPA Direct Debit": "z. B. SEPA-Lastschrift",
  "e.g. ST01, Center": "z. B. ST01, Mitte",
  "e.g. Standard": "z. B. Standard",
  "e.g. standard rest period": "z. B. Standard-Ruhezeit",
  "e.g. Standard Week": "z. B. Standard-Woche",
  "e.g. Standard, Dark, Minimal": "z. B. Standard, Dark, Minimal",
  "e.g. Student priceAdjustment": "z. B. Studentenabzug",
  "e.g. Summer rest period": "z. B. Sommerruhezeit",
  "e.g. Trainer A, Room 1": "z. B. Trainer A, Raum 1",
  "e.g. Training Machine 1": "z. B. Trainingsgerät 1",
  "e.g. Trial": "z. B. Probetraining",
  "e.g. trial (optional)": "z. B. probe",
  "e.g. Trial session": "z. B. Probetraining",
  "e.g. Welcome Email": "z. B. Willkommens-E-Mail",
  "e.g. welcome email": "z. B. Willkommens-E-Mail",
  "e.g. xxxx-xxxx-xxxx-xxxx": "z. B. xxxx-xxxx-xxxx-xxxx",
  "Each source must have exactly ONE of either ContractTemplateId OR WalletProductId": "Jede Quelle muss entweder ContractTemplateId oder WalletProductId haben, aber nicht beides.",
  "Edit": "bearbeiten",
  "Edit account": "Konto bearbeiten",
  "Edit appointment": "Termin bearbeiten",
  "Edit appointment duration": "Termindauer bearbeiten",
  "Edit appointment price": "Terminpreis bearbeiten",
  "Edit appointment notification": "Termin-Benachrichtigung",
  "Edit Appointment Outcome": "Abschluss-Szenario",
  "Edit Appointment Type": "Terminart bearbeiten",
  "Edit bank account": "Bankverbindung bearbeiten",
  "Edit bank account__alt2": "Bankverbindung ändern",
  "Edit bank account__bankverbindung-ändern": "Bankverbindung ändern",
  "Edit booking link": "Termin bearbeiten URL",
  "Edit before sending": "noch bearbeiten",
  "Editing is required when no template is selected.": "Ohne ausgewählte Vorlage ist die Bearbeitung vor dem Versand verpflichtend.",
  "Document is not ready yet.": "Das Dokument ist noch nicht bereit.",
  "Edit confirmation document": "Bestätigung bearbeiten",
  "Edit Calendar Role": "Kalender-Rolle bearbeiten",
  "Edit Cancellation Model": "Kündigungsmodell",
  "Edit Cancellation Reason": "Kündigungsgrund",
  "Edit category": "Kategorie bearbeiten",
  "Edit check-in settings": "Check-in-Einstellungen bearbeiten",
  "Edit columns": "Spalten bearbeiten",
  "Edit contracts": "Verträge bearbeiten",
  "Edit digital file": "Dokumente bearbeiten",
  "Edit contract": "Vertrag bearbeiten",
  "Edit contract block": "Vertragsbaustein",
  "Edit Contract Template": "Vertragsbaustein",
  "Edit Contract Template__alt1": "Vertragsbaustein bearbeiten",
  "Edit Contract Template__alt2": "Vertragspaket bearbeiten",
  "Edit contribution": "Beitrag bearbeiten",
  "Edit Debt Collection Agency": "Inkasso-Dienstleister",
  "Edit details": "Details bearbeiten",
  "Edit priceAdjustment": "Preisanpassung bearbeiten",
  "Edit PriceAdjustment": "Preisanpassung bearbeiten",
  "Edit price adjustment": "Preisanpassung bearbeiten",
  "Edit email account": "E-Mail-Konto bearbeiten",
  "Edit finances": "Finanzen bearbeiten",
  "Edit holiday": "Feiertag bearbeiten",
  "Edit Holiday": "Feiertag bearbeiten",
  "Edit lead": "Kontakt bearbeiten",
  "Edit Lead Source": "Kontaktquelle bearbeiten",
  "Edit leads": "Kontakte bearbeiten",
  "Edit online booking": "Online-Buchung bearbeiten",
  "Edit open items": "offene Posten bearbeiten",
  "Agree installment plan": "Ratenzahlung vereinbaren",
  "Edit payment": "Zahlung bearbeiten",
  "Edit Payment Cancellation Reason": "Zahlungsstornogrund",
  "Edit Rest Period Reason": "Ruhezeitgrund bearbeiten",
  "Edit payment method": "Zahlungsart bearbeiten",
  "Edit Payment Plan": "Zahlungsplan bearbeiten",
  "Edit people": "Personen bearbeiten",
  "Edit person": "Person bearbeiten",
  "Edit phase": "Phase bearbeiten",
  "Edit pipeline": "Phasenmodell bearbeiten",
  "Edit preset": "Vorlage bearbeiten",
  "Edit reader device": "Lesegerät bearbeiten",
  "Edit Resource": "Ressource bearbeiten",
  "Edit rest period": "Ruhezeit bearbeiten",
  "Edit Rest Period Template": "Ruhezeitmodell",
  "Edit rest period template": "Ruhezeitmodell bearbeiten",
  "Edit role": "Rolle bearbeiten",
  "Edit rule": "Regel bearbeiten",
  "Edit SEPA Group": "SEPA-Gruppe bearbeiten",
  "Edit settings": "Einstellungen bearbeiten",
  "Edit Studio": "Studio bearbeiten",
  "Edit Template": "Vorlage bearbeiten",
  "Edit templates": "Textvorlagen bearbeiten",
  "Edit tenant": "Mandant bearbeiten",
  "Edit text template": "Textvorlage bearbeiten",
  "Edit system email template": "System-E-Mail-Vorlage bearbeiten",
  "Edit transitions": "Übergänge bearbeiten",
  "Edit unavailability": "Abwesenheit bearbeiten",
  "Edit unavailability reason": "Abwesenheitsgrund",
  "Edit user": "Benutzer bearbeiten",
  "Edit VAT setting": "USt-Einstellung bearbeiten",
  "Edit version": "Version bearbeiten",
  "Edit wallet": "Wertekonto bearbeiten",
  "Edit Wallet Product": "Vorlage",
  "Edit widget": "Formular bearbeiten",
  "Edit zone": "Zone bearbeiten",
  "Editor not ready - please reload page": "Editor nicht bereit - bitte Seite neu laden",
  "Email": "E‑Mail",
  "Email (optional)": "E‑Mail",
  "Email / username": "E-Mail / Benutzername",
  "Email / username__alt2": "E-Mail / Benutzername",
  "Email account added.": "E-Mail-Konto hinzugefügt.",
  "Email accounts": "E-Mail-Konten",
  "Email accounts and system templates (password reset)": "E-Mail-Konten und System-Vorlagen (Passwort-Reset)",
  "Email address": "E-Mail-Adresse",
  "Email address added": "E-Mail-Adresse hinzugefügt",
  "Email address or username": "E-Mail-Adresse oder Benutzername",
  "Email and letter can be combined. SMS must be separate.": "E-Mail und Brief können kombiniert werden. SMS muss separat sein.",
  "Email Body": "E-Mail-Text",
  "Email cannot be removed for the primary account": "E-Mail kann für den primären Account nicht entfernt werden",
  "Email details": "E-Mail-Details",
  "All time": "gesamter Zeitraum",
  "Last 7 days": "letzte 7 Tage",
  "Analysis queued": "Analyse wurde eingereiht",
  "Reanalysis failed": "Erneute Analyse fehlgeschlagen",
  "Next automatic attempt": "Nächster automatischer Versuch",
  "No further automatic retry is scheduled.": "Es ist kein weiterer automatischer Versuch geplant.",
  "The automatic analysis attempts are exhausted.": "Die automatischen Analyseversuche sind ausgeschöpft.",
  "Classification": "Klassifizierung",
  "Effective request type": "gültige Vorgangsart",
  "Analysis reason": "Begründung der Analyse",
  "Contract selection reason": "Begründung der Vertragsauswahl",
  "Initial notice period": "anfängliche Kündigungsfrist",
  "Renewal notice period": "Kündigungsfrist nach Verlängerung",
  "Uncertainties": "Unsicherheiten",
  "Selected": "ausgewählt",
  "Selected by analysis": "von der Analyse ausgewählt",
  "Contract no longer exists": "Vertrag nicht mehr vorhanden",
  "Unique sender address": "eindeutige Absenderadresse",
  "Analyze again": "erneut analysieren",
  "The analysis model is not configured.": "Das Analysemodell ist nicht konfiguriert.",
  "The analysis result could not be validated.": "Das Analyseergebnis konnte nicht validiert werden.",
  "The classification could not be created because of an invalid AI response.": "Die Klassifizierung konnte wegen einer fehlerhaften KI-Antwort nicht erstellt werden.",
  "The analysis answer was cut off at the token limit.":
    "Die Analyseantwort wurde am Token-Limit abgeschnitten.",
  "The analysis model is currently unavailable.": "Das Analysemodell ist derzeit nicht erreichbar.",
  "The analysis model did not respond in time.": "Das Analysemodell hat nicht rechtzeitig geantwortet.",
  "At least one attachment requires manual review.": "Mindestens eine Anlage muss manuell geprüft werden.",
  "No person could be assigned from the sender address.": "Über die Absenderadresse konnte keine Person zugeordnet werden.",
  "No person could be matched to this message.": "Zu dieser Nachricht konnte keine Person zugeordnet werden.",
  "More than one person matches this message.": "Mehrere Personen kommen für diese Nachricht infrage.",
  "Person candidates": "Personenkandidaten",
  "No person candidates found.": "Es wurden keine Personenkandidaten gefunden.",
  "The sender address belongs to more than one person.": "Die Absenderadresse gehört zu mehreren Personen.",
  "No active contract could be assigned.": "Es konnte kein aktiver Vertrag zugeordnet werden.",
  "The contract selection requires manual review.": "Die Vertragsauswahl muss manuell geprüft werden.",
  "This request requires a manual response.": "Diese Anfrage benötigt eine manuelle Antwort.",
  "The classification is uncertain.": "Die Klassifizierung ist unsicher.",
  "The analysis failed because of a system error.": "Die Analyse ist wegen eines Systemfehlers fehlgeschlagen.",
  "An attachment is too large for automatic analysis.": "Eine Anlage ist für die automatische Analyse zu groß.",
  "The message is too large for automatic analysis.": "Die Nachricht ist für die automatische Analyse zu groß.",
  "The attachment format is not supported.": "Das Anlagenformat wird nicht unterstützt.",
  "Text recognition is currently unavailable.": "Die Texterkennung ist derzeit nicht verfügbar.",
  "Text recognition of the attachment failed.": "Die Texterkennung der Anlage ist fehlgeschlagen.",
  "No readable text was found in the attachment.": "In der Anlage wurde kein lesbarer Text gefunden.",
  "The text extracted from the attachment is too large.":
    "Der aus der Anlage gelesene Text ist zu groß.",
  "The attachment is damaged and could not be read.": "Die Anlage ist beschädigt und konnte nicht gelesen werden.",
  "The message requires manual review.": "Die Nachricht muss manuell geprüft werden.",
  "InboundEmailReanalysisInProgress": "Die Nachricht wird bereits analysiert.",
  "InboundEmailReanalysisInvalidState": "Die Nachricht kann in ihrem aktuellen Status nicht erneut analysiert werden.",
  "InboundEmailAccountHasMessages": "Das E-Mail-Konto kann nicht gelöscht werden, solange Eingangsnachrichten darauf verweisen.",
  "InboundEmailInboxMaintenanceBusy": "Der Posteingang wird gerade abgerufen oder verarbeitet. Versuchen Sie das Löschen nach Abschluss erneut.",
  "InboundEmailProviderUnavailable": "IMAP-Verbindung konnte nicht hergestellt werden. Bitte Zugangsdaten und Servereinstellungen prüfen.",
  "InboundEmailAnalysisUnavailable": "Für die E-Mail-Analyse ist kein nutzbares Modellprofil hinterlegt.",
  "Email has been restored": "E-Mail wurde wiederhergestellt",
  "Email is required for the primary account": "E-Mail ist für den primären Account erforderlich",
  "Email is required__alt1": "E-Mail fehlt",
  "Email is required__alt2": "E-Mail ist erforderlich",
  "Email sending": "E-Mail-Versand",
  "Email spooler": "E-Mail-Spooler",
  "Email subject": "Betreff der E-Mail",
  "Email Subject": "E-Mail-Betreff",
  "Email template used as signature.": "E-Mail-Vorlage, die als Signatur verwendet wird.",
  "Email/username": "E-Mail/Benutzername",
  "Email/username is required": "E-Mail/Benutzername fehlt",
  "email@example.com": "email@beispiel.de",
  "Embed": "einbetten",
  "Embed code": "Embed-Code",
  "Embed Code for Widget": "Embed-Code für Formular",
  "Employee": "Mitarbeiter",
  "Employee name (without user account)": "Mitarbeitername (ohne Benutzerkonto)",
  "Employee assignable": "Mitarbeiter zuweisbar",
  "Empty = all studios.": "Leer = alle Studios.",
  "Empty = all studios. Already assigned studios are disabled.": "Leer = alle Studios. Jedes Studio kann nur einmal zugeordnet werden.",
  "Empty = all studios. Multiple selection (e.g. for lead assignment).": "Leer = alle Studios. Mehrere wählbar (z. B. für Kontakt-Zuordnung).",
  "Empty = available for all studios.": "Leer = für alle Studios verfügbar.",
  "Empty = for all studios. Multiple selection – resource is then available in all selected studios (same availability).": "Leer = für alle Studios. Mehrere wählbar – Ressource steht dann in allen gewählten Studios zur Verfügung (gleiche Verfügbarkeit).",
  "Empty = for all studios. Multiple selection.": "Leer = für alle Studios. Mehrere wählbar.",
  "Empty = for all studios. Studios without access are disabled.": "Leer = für alle Studios. Studios ohne Zugriff sind ausgegraut.",
  "Empty = not filtered": "Leer = nicht gefiltert",
  "Enable automatic updates": "automatische Updates aktivieren",
  "Enable assignment for at least one m1connect reader in reader device settings.": "Aktiviere die Zuweisung für mindestens einen m1connect-Leser in den Lesegeräteeinstellungen.",
  "Enable Dark Mode": "Dark Mode aktivieren",
  "Enable lead time": "Vorlaufzeit aktivieren",
  "Email typography": "E-Mail-Typografie",
  "Enabled": "aktiviert",
  "End": "Ende",
  "End (optional)": "Ende",
  "End Date": "Enddatum",
  "End date must be after start date": "Enddatum muss nach Startdatum liegen",
  "End date must not be before start date": "Ende darf nicht vor dem Start liegen",
  "End must be after start": "Ende muss nach Beginn liegen",
  "End of half-year only": "nur zum Halbjahresende",
  "End of month only": "nur zum Monatsende",
  "End of quarter only": "nur zum Quartalsende",
  "End of year only": "nur zum Jahresende",
  "End time must be after start time": "Endzeit muss nach Startzeit liegen",
  "Ended": "beendet",
  "Ending (optional)": "Endung",
  "Ending Balance": "Bestand Ende",
  "English": "Englisch",
  "Enrollment Fee": "Aufnahmegebühren",
  "Enter description...": "Beschreibung eingeben…",
  "Enter name": "Name eingeben",
  "Enter note...": "Notiz eingeben…",
  "Enter password": "Passwort eingeben",
  "Enter QR code...": "QR-Code eingeben…",
  "Enter reason...": "Grund eingeben…",
  "Enter the email address of your account.": "Geben Sie die E-Mail-Adresse Ihres Kontos ein.",
  "Enter this code in m1connect to connect the reader device.": "Geben Sie diesen Code in m1connect ein, um das Lesegerät zu verbinden.",
  "Enter title...": "Bezeichnung eingeben…",
  "Enter your API key": "API-Schlüssel",
  "LeadImport API key tooltip": "Diesen Schlüssel in Make.com oder n8n als Header X-Api-Key eintragen. Geheim halten.",
  "LeadImport copy success": "In die Zwischenablage kopiert.",
  "LeadImport data for automation label": "Daten für den API-Endpunkt",
  "LeadImport data for automation tooltip": "Diese URL beim Aufruf des API-Endpunkts verwenden.",
  "LeadImport default studio placeholder": "kein Standard-Studio",
  "LeadImport generate key": "generieren",
  "M1member integration functions": "Funktionen",
  "M1member integration function required": "Mindestens eine Funktion wählen",
  "M1member integration leads": "Leads",
  "M1member integration calendar": "Kalender",
  "M1member integration appointment types": "Erlaubte Terminarten",
  "M1member integration appointment type required": "Mindestens eine Terminart wählen",
  "Enter your new password.": "Geben Sie Ihr neues Passwort ein.",
  "Entitlement Sources": "Zugriffsquellen",
  "Entitlement sources updated": "Zugriffsquellen aktualisiert",
  "entries__alt1": "Einträge",
  "entries__alt2": "Einträgen",
  "Entries": "Einträge",
  "Entries (dative)": "Einträgen",
  "entries__einträge": "Einträge",
  "entries__einträgen": "Einträgen",
  "Entry created.": "Eintrag angelegt.",
  "Equipment (Machine)": "Gerät (Maschine, Equipment)",
  "Equipment": "Gerät",
  "Equipment__alt2": "Geräte",
  "Equipment__gerät": "Gerät",
  "Equipment__geräte": "Geräte",
  "Escalation": "Eskalation",
  "Error": "Fehler",
  "Error booking": "Fehler beim Buchen",
  "(system default)": "(System-Standard)",
  "Error changing password": "Fehler beim Ändern",
  "Error checking deletion possibility": "Fehler bei der Prüfung",
  "Error checking status": "Fehler beim Prüfen des Status",
  "Error copying": "Fehler beim Kopieren",
  "Error creating account.": "Fehler beim Anlegen des Kontos.",
  "Error creating direct debit run": "Fehler beim Anlegen des Lastschriftlaufs",
  "Error deleting": "Fehler beim Löschen",
  "Error deleting.": "Fehler beim Löschen.",
  "Error duplicating": "Fehler beim Duplizieren",
  "Error during cleanup": "Fehler bei der Bereinigung",
  "Error during import": "Fehler beim Import",
  "Error fetching folders.": "Fehler beim Abrufen der Ordner.",
  "Error fetching integrations": "Fehler beim Abrufen der Schnittstellen",
  "Error fetching status": "Fehler beim Status-Abruf",
  "Error generating": "Fehler beim Generieren",
  "Error generating code": "Fehler beim Generieren des Codes",
  "Check-in indicators could not be loaded": "Check-in-Kennzeichen konnten nicht geladen werden.",
  "E_CheckInIndicatorLimit": "Pro Anfrage sind höchstens 100 Personen zulässig.",
  "Error loading": "Fehler beim Laden",
  "Error loading accounts": "Fehler beim Laden der Konten",
  "Error loading email": "Fehler beim Laden der E-Mail",
  "Error loading holidays": "Fehler beim Laden der Feiertage",
  "Error loading items": "Fehler beim Laden der Positionen",
  "Error loading open items.": "Fehler beim Laden der offenen Posten.",
  "Error loading persons": "Fehler beim Laden der Personen",
  "Error loading resources": "Fehler beim Laden der Ressourcen",
  "Error loading roles": "Fehler beim Laden der Rollen",
  "Error loading settings": "Fehler beim Laden der Einstellungen",
  "Error loading studios": "Fehler beim Laden der Studios",
  "Error loading users": "Fehler beim Laden der Benutzer",
  "Error loading.": "Fehler beim Laden.",
  "Error opening": "Fehler beim Öffnen",
  "Error opening device": "Fehler beim Öffnen des Geräts",
  "Error opening imported document": "Fehler beim Öffnen des importierten Dokuments",
  "Error opening report": "Fehler beim Öffnen des Berichts",
  "Error refreshing folders.": "Fehler beim Aktualisieren der Ordner.",
  "Error resending.": "Fehler beim erneuten Versenden.",
  "Error retrieving balance": "Fehler beim Abrufen des Guthabens",
  "Error saving": "Fehler beim Speichern",
  "Error saving order": "Fehler beim Speichern der Reihenfolge",
  "Error saving resources": "Fehler beim Speichern der Ressourcen",
  "Error sending": "Fehler beim Senden",
  "Error submitting": "Fehler beim Absenden",
  "Error testing": "Fehler beim Testen",
  "Error testing connection": "Fehler beim Testen der Verbindung",
  "Error testing ping": "Fehler beim Ping-Test",
  "Error updating sub-contract": "Fehler beim Aktualisieren eines Untervertrags",
  "Error uploading.": "Fehler beim Hochladen.",
  "Error while changing language:": "Fehler beim Ändern der Sprache:",
  "Error while loading": "Fehler beim Laden",
  "Error while saving": "Fehler beim Speichern",
  "Error while sending": "Fehler beim Versand",
  "Errors": "Fehler",
  "Events": "Ereignisse",
  "every n days": "alle n Tage",
  "every n weeks (weekday)": "alle n Wochen (Wochentag)",
  "Example Street 1": "Musterstraße 1",
  "Example: Step 1.00 + Ending 0.99 results in prices like 9.99 / 10.99 / 11.99 … (depending on mode).": "Beispiel: Schritt 1,00 + Endung 0,99 ergibt Preise wie 9,99 / 10,99 / 11,99 … (je nach Modus).",
  "Exception details": "Exception Details",
  "Executed": "ausgeführt",
  "Execution": "Ausführung",
  "Execution date": "Ausführungsdatum",
  "Actual execution date": "tatsächliches Ausführungsdatum",
  "Execution date is required": "Ausführungsdatum ist erforderlich",
  "Execution date must not be in the past": "Ausführungsdatum darf nicht in der Vergangenheit liegen",
  "Execution date of direct debit in format DD.MM.YY": "Ausführungsdatum der Lastschrift im Format TT.MM.JJ",
  "Exclude": "auslassen",
  "Exclude from run": "aus Lauf auslassen",
  "Include": "aufnehmen",
  "Include in run": "wieder aufnehmen",
  "Excluded": "ausgelassen",
  "Expense": "Aufwand",
  "Expenses": "Ausgaben",
  "expired": "abgelaufen",
  "Expiring Contracts": "Auslaufende Verträge",
  "Export": "exportieren",
  "Export reports": "Auswertungen exportieren",
  "Export and print reports": "Auswertungen exportieren und drucken",
  "Export and print reports permission help": "Erlaubt Export und Druckansichten für Auswertungen, für die ein Leserecht besteht.",
  "Download report and accounting export files.": "Auswertungs- und Buchhaltungsexporte herunterladen.",
  "Export as CSV": "als CSV exportieren",
  "Export as Excel": "als Excel exportieren",
  "Export as PDF": "als PDF exportieren",
  "Export & Import": "Export & Import",
  "Backup & Restore": "Sicherungen",
  "Tools": "Werkzeuge",
  "Duplicate finder": "Duplikatfinder",
  "Rules & log for leads, auto-communication and other automation": "Regeln und Protokoll für Kontakte, Auto-Kommunikation und weitere Automatisierungen",
  "Find and merge duplicate person records": "doppelte Personendaten finden und zusammenführen",
  "Fields for comparison": "Felder für den Vergleich",
  "Group": "Gruppe",
  "Records": "Datensätze",
  "Persons affected": "Personen betroffen",
  "Lenient": "locker",
  "Strict": "streng",
  "Duplicate search": "Duplikatsuche",
  "Score": "Bewertung",
  "Score threshold": "Score-Schwelle",
  "Minimum checkable criteria": "Mindestanzahl prüfbarer Kriterien",
  "Start scan": "Suche starten",
  "Review selected": "ausgewählte prüfen",
  "Merge": "zusammenführen",
  "Merge selected": "ausgewählte zusammenführen",
  "Merge selected duplicate groups?": "ausgewählte Duplikat-Gruppen zusammenführen?",
  "Merge confirmation text": "{groups} Gruppen mit insgesamt {persons} Personen werden zusammengeführt. Älteste Person bleibt als Master, leere Felder werden ergänzt.",
  "Merge completed": "Zusammenführung abgeschlossen.",
  "Bank account holder": "Kontoinhaber",
  "Merge review": "Zusammenführung prüfen",
  "Merge assistant": "Zusammenführungsassistent",
  "No duplicate review job available": "kein Prüfauftrag für Duplikate verfügbar.",
  "No duplicate merge job available": "kein Zusammenführungsauftrag für Duplikate verfügbar.",
  "Review before merge": "Vor dem Zusammenführen prüfen",
  "Merge one group at a time": "Eine Gruppe nach der anderen zusammenführen",
  "Duplicate review warning": "Die gewählte Zusammenführung wird direkt ausgeführt. Prüfe Master-Person und Feldentscheidungen, bevor du die Gruppe zusammenführst.",
  "Duplicate merge assistant warning": "Wenn du diese Gruppe bestätigst, wird sie sofort zusammengeführt. Fehler kannst du vorher direkt in der jeweiligen Person öffnen und korrigieren.",
  "Choose master person": "Master-Person wählen",
  "Merge decision": "Zusammenführungsentscheidung",
  "Apply to same cases": "für gleiche Fälle übernehmen",
  "Merge same cases?": "Gleichartige Fälle zusammenführen?",
  "{count} groups share the same matching pattern and will all be merged in one step. The suggested master person is kept for each group.": "{count} Gruppen haben dasselbe Treffermuster und werden in einem Schritt zusammengeführt. Pro Gruppe wird die vorgeschlagene Master-Person übernommen.",
  "{count} groups merged": "{count} Gruppen zusammengeführt.",
  "Merge all matching groups": "alle gleichartigen Gruppen zusammenführen",
  "Drag a value into the result column to choose it": "Wert in die Ergebnis-Spalte ziehen (oder anklicken), um ihn zu übernehmen",
  "from {person}": "aus {person}",
  "Merge with selected decisions": "mit gewählten Entscheidungen zusammenführen",
  "Merge into selected master": "in gewählte Master-Person zusammenführen",
  "Merge this group now": "diese Gruppe jetzt zusammenführen",
  "Skip duplicate group": "Duplikat-Gruppe überspringen",
  "Field decisions": "Feldentscheidungen",
  "Comparison": "Vergleich",
  "Conflict": "Konflikt",
  "No conflict": "kein Konflikt",
  "Person A": "Person A",
  "Person B": "Person B",
  "Person {index}": "Person {index}",
  "Review finished": "Prüfung abgeschlossen.",
  "Merge workflow finished": "Zusammenführung abgeschlossen.",
  "Merge group details": "Details zur Match-Gruppe",
  "Merge this group": "diese Gruppe zusammenführen",
  "Criterion": "Kriterium",
  "Matched fields": "Trefferfelder",
  "Suggested master": "vorgeschlagener Master",
  "Backup downloaded.": "Sicherung heruntergeladen.",
  "Backup failed.": "Sicherung fehlgeschlagen.",
  "Create backup": "Sicherung erstellen",
  "Restore from backup": "Wiederherstellung",
  "Restore completed.": "Wiederherstellung abgeschlossen.",
  "Restore failed.": "Wiederherstellung fehlgeschlagen.",
  "Create and restore tenant backup (database + files)": "Sicherungen verwalten",
  "Adding tenant backup": "Sicherung wird erstellt.",
  "Create tenant backup": "Sicherung erstellen",
  "Delete backup": "löschen",
  "Delete backup blocked body": "Diese Sicherung kann gerade nicht gelöscht werden.",
  "Delete backup blocked title": "Kann nicht gelöscht werden",
  "Delete backup confirm body": "Diese Sicherung wird dauerhaft gelöscht.",
  "Delete backup confirm title": "Sicherung löschen?",
  "Delete tenant backup": "Sicherung gelöscht.",
  "Job title TenantBackupCreate": "Sicherung",
  "Job title TenantBackupRestore": "Wiederherstellung",
  "Restore backup": "wiederherstellen",
  "Tenant backup restore confirm body": "Die Sicherung vom {0} wird wiederhergestellt.",
  "Tenant backup restore confirm title": "Sicherung wiederherstellen?",
  "Tenant backup restore target tenant": "Zielmandant",
  "Tenant backup restore cross tenant warning": "Der Zielmandant wird vollständig durch diese Sicherung überschrieben.",
  "Tenant backup restore no selectable areas": "In dieser Sicherung sind keine Teilsicherungsbereiche enthalten.",
  "Tenant backup restore scope": "Rücksicherungsumfang",
  "Tenant backup restore scope full": "vollständige Rücksicherung",
  "Tenant backup restore select at least one area": "Bitte mindestens einen Bereich auswählen.",
  "Tenant backups": "Sicherungen",
  "Tenant restore job started": "Wiederherstellung wurde gestartet.",
  "Tenant backup column created at": "erstellt",
  "Tenant backup column kind": "Art",
  "Tenant backup column label": "Bezeichnung",
  "Tenant backup column schema version": "Schema-Version",
  "Tenant backup column size": "Größe",
  "Tenant backup column status": "Status",
  "Tenant backup kind automated": "automatisiert",
  "Tenant backup kind configuration": "Konfiguration",
  "Tenant backup kind manual": "manuell",
  "Tenant backup scope": "Umfang",
  "Tenant backup scope configuration": "Teilsicherung",
  "Tenant backup scope full": "vollständige Sicherung",
  "Tenant backup scope reader devices": "Lesegeräte",
  "Tenant backup scope calendar appointments": "Kalender und Termine",
  "Tenant backup scope reminder levels": "Mahnstufen",
  "Tenant backup scope reminders and templates": "nur Mahnstufen und Dokumentvorlagen",
  "Tenant backup status creating": "wird erstellt",
  "Tenant backup status failed": "fehlgeschlagen",
  "Tenant backup status ready": "bereit",
  "tenantBackup.job.download": "wird geladen",
  "tenantBackup.job.export": "wird erstellt",
  "tenantBackup.job.verify": "wird geprüft",
  "tenantBackup.job.import": "wird wiederhergestellt",
  "tenantBackup.job.databaseDelete": "bestehende Daten werden vorbereitet",
  "tenantBackup.job.databaseImport": "Datenbank wird wiederhergestellt",
  "tenantBackup.job.files": "Dateien werden wiederhergestellt",
  "tenantBackup.job.promote": "Dateien werden veröffentlicht",
  "tenantBackup.job.commit": "Vorgang wird abgeschlossen",
  "tenantBackup.job.cleanup": "Aufräumarbeiten",
  "tenantBackup.job.upload": "wird gespeichert",
  "sepaDirectDebitRuns.job.prepare": "Verbuchung wird vorbereitet",
  "sepaDirectDebitRuns.job.createPayments": "Zahlungen werden angelegt",
  "sepaDirectDebitRuns.job.savePayments": "Zahlungen werden gespeichert",
  "sepaDirectDebitRuns.job.refreshCalendar": "Beitragskalender wird aktualisiert",
  "sepaDirectDebitRuns.deleteJob.prepare": "Löschen wird vorbereitet",
  "sepaDirectDebitRuns.deleteJob.cleanup": "Positionen und offene Posten werden zurückgesetzt",
  "sepaDirectDebitRuns.deleteJob.refreshCalendar": "Beitragskalender wird aktualisiert",
  "sepaDirectDebitRuns.deleteJob.done": "Lastschriftlauf wurde gelöscht",
  "sepaDirectDebitRuns.deleteJob.systemFailure": "Der Lastschriftlauf konnte wegen eines Systemfehlers nicht gelöscht werden. Der Fehler wurde protokolliert.",
  "sepaDirectDebitRuns.job.done": "Lastschriftlauf wurde verbucht",
  "Tenant backup restore blocking title": "Die Datensicherung wird wiederhergestellt…",
  "Tenant backup restore blocking hint": "Bitte warte, bis die Wiederherstellung abgeschlossen ist.",
  "Tenant backup restore progress pending": "startet",
  "Cancel job": "abbrechen",
  "Job active label": "aktiv",
  "Job running label": "wird ausgeführt …",
  "tenantBackup.activeJobInProgress.modalBody": "Es läuft bereits eine Sicherung oder Wiederherstellung. Bitte warten, bis der Vorgang beendet ist.",
  "tenantBackup.activeJobInProgress.modalTitle": "Sicherung oder Wiederherstellung aktiv",
  "Realtime status idle": "Realtime: inaktiv",
  "Realtime status connecting": "Realtime: verbindet",
  "Realtime status connected": "Realtime: verbunden",
  "Realtime status reconnecting": "Realtime: verbindet neu",
  "Realtime status closed": "Realtime: geschlossen",
  "Complete PostgreSQL dump and all stored files (all tenants). For disaster recovery.": "Vollständiger PostgreSQL-Dump und alle gespeicherten Dateien (alle Mandanten). Zur Notfallwiederherstellung.",
  "Export CSV": "CSV exportieren",
  "Export downloaded.": "Export heruntergeladen.",
  "Export failed": "Export fehlgeschlagen",
  "Export failed.": "Export fehlgeschlagen.",
  "Export started": "Export gestartet",
  "extends": "verlängert",
  "Extends contract": "verlängert Vertrag",
  "External APIs & integrations (e.g. letter sending)": "Externe APIs & Schnittstellen (z. B. Briefversand)",
  "External logo URL (optional)": "Externe Logo-URL",
  "failed": "fehlgeschlagen",
  "Failed to copy": "Fehler beim Kopieren",
  "Failed to copy template": "Fehler beim Kopieren der Vorlage",
  "Failed to delete": "Fehler beim Löschen",
  "Failed to load": "Fehler beim Laden",
  "Failed to load content": "Fehler beim Laden des Inhalts",
  "Failed to load preferences": "Fehler beim Laden der Präferenzen",
  "Failed to load recipients": "Fehler beim Laden der Empfänger",
  "Failed to load resources": "Fehler beim Laden der Ressourcen",
  "Failed to load templates": "Fehler beim Laden der Vorlagen",
  "Failed to load users": "Fehler beim Laden der Benutzer",
  "Failed to load.": "Fehler beim Laden.",
  "Failed to save": "Fehler beim Speichern",
  "Failed to send": "Fehler beim Versenden",
  "Failed": "Fehler",
  "Failed__alt2": "fehlgeschlagen",
  "Fee": "Pauschale",
  "Fee Type": "Gebührentyp",
  "Female": "weiblich",
  "Fetch folders": "Ordner abrufen",
  "File": "Datei",
  "File name": "Dateiname",
  "File too large (max 200MB)": "Datei zu groß (max 200 MB)",
  "Filter": "Filter",
  "More filters": "weitere Filter",
  "Filter by resources": "Ressourcen filtern",
  "Sales studio": "Verkaufsstudio",
  "Filter by studio": "Studio filtern",
  "Filter by studio(s)": "Studio(s) filtern",
  "Filter by status": "Status filtern",
  "Filter by type": "Typ filtern",
  "Finance": "Finanzen",
  "Finance Reports": "Finanzen Auswertungen",
  "Finance reports": "Finanz-Auswertungen",
  "Finances": "Finanzen",
  "first 8 characters of person ID (without hyphens)": "erste 8 Zeichen der Person-ID (ohne Bindestriche)",
  "First Check-In": "erster Check-in",
  "First collection": "erster Einzug",
  "First debit": "Erstlastschrift",
  "First name": "Vorname",
  "First name (default)": "Vorname (Standard)",
  "First Name": "Vorname",
  "first name (sanitized), max. 12 characters": "Vorname (bereinigt), max. 12 Zeichen",
  "First name and last name are required": "Vorname und Nachname sind erforderlich",
  "First name is required": "Vorname ist erforderlich",
  "First name Last name": "Vorname Nachname",
  "First name or last name required": "Vorname oder Nachname erforderlich",
  "First name or last name required.": "Vorname oder Nachname erforderlich.",
  "Fix errors": "Fehlerdetails",
  "SEPA error fix pending exclusion": "zum Auslassen vorgemerkt",
  "SEPA error fix remember": "merken",
  "SEPA error fixes applied.": "Änderungen übernommen.",
  "Discard pending SEPA error fixes?": "Offene Korrekturen verwerfen?",
  "Discard pending SEPA error fixes detail": "Noch nicht übernommene Änderungen gehen verloren.",
  "Fixed": "Fix",
  "Fixed amount__alt1": "fester Beitrag",
  "Fixed amount__alt2": "Fixer Betrag",
  "Fixed per installment": "Fix pro Rate",
  "Flags": "Kennzeichen",
  "Flat fee": "Pauschale",
  "Follow-up": "Wiedervorlage",
  "Font & Style": "Schrift & Stil",
  "Font Family": "Schriftart",
  "Font family": "Schriftart",
  "Line height": "Zeilenabstand",
  "Line height tooltip": "Vielfaches der Schriftgröße; 1 ist einzeilig.",
  "Fonts": "Schriftarten",
  "Custom fonts for letters, emails and templates (this tenant only)": "eigene Schriftarten für Briefe, E-Mails und Vorlagen (nur dieser Mandant).",
  "Fonts for all tenants (letters, emails, templates)": "Schriftarten für alle Mandanten (Briefe, E-Mails, Vorlagen).",
  "FontsSettingsConfirmDelete": "Schriftart wirklich löschen?",
  "FontsSettingsCreatedAt": "hochgeladen am",
  "FontsSettingsDeleteError": "Fehler beim Löschen der Schriftart",
  "FontsSettingsDeleteSuccess": "Schriftart gelöscht",
  "FontsSettingsDisplayName": "Anzeigename",
  "FontsSettingsFileName": "Dateiname",
  "FontsSettingsFontFamilyName": "Schriftfamilie (CSS)",
  "FontsSettingsOnlyTtfOtf": "Nur TTF- und OTF-Dateien sind erlaubt.",
  "FontsSettingsSelectFile": "Datei auswählen",
  "FontsSettingsUploadError": "Fehler beim Hochladen",
  "FontsSettingsUploading": "wird hochgeladen",
  "FontsSettingsUploadFont": "Schriftart hochladen",
  "FontsSettingsUploadHint": "Laden Sie eine TTF- oder OTF-Datei hoch. Die Schrift steht danach in Briefen, E-Mails und Vorlagen zur Verfügung.",
  "FontsSettingsUploadSuccess": "Schriftart hochgeladen",
  "FontsSettingsUploadHintAdmin": "Laden Sie eine TTF- oder OTF-Datei hoch. Die Schrift steht danach für alle Mandanten in Briefen, E-Mails und Vorlagen zur Verfügung.",
  "FontsSettingsDropHint": "Schriftdatei(en) hierher ziehen oder klicken",
  "FontsSettingsFilesSelected": "{0} Datei(en) ausgewählt",
  "FontsSettingsUploadSuccessMultiple": "{0} Schriftarten hochgeladen.",
  "FontsSettingsUploadBackgroundSingle": "Schriftart wird im Hintergrund hochgeladen. Bei Fehlern: Einstellungen → Systemprotokoll.",
  "FontsSettingsUploadBackgroundMultiple": "{0} Schriftarten werden im Hintergrund hochgeladen. Bei Fehlern: Einstellungen → Systemprotokoll.",
  "FontsSettingsUploadBackgroundAdminSingle": "Schriftart wird im Hintergrund hochgeladen. Bei Fehlern: Admin → Systemprotokoll.",
  "FontsSettingsUploadBackgroundAdminMultiple": "{0} Schriftarten werden im Hintergrund hochgeladen. Bei Fehlern: Admin → Systemprotokoll.",
  "FontsSettingsRefreshMetadata": "Metadaten aktualisieren",
  "FontsSettingsRefreshMetadataSuccess": "Anzeigename und Schriftfamilie wurden aus den Font-Dateien nachgetragen.",
  "FontsSettingsRefreshMetadataSuccessCount": "{0} Schriftarten aktualisiert.",
  "Footer Text": "Fußzeilentext",
  "For": "für",
  "At least one option must be selected": "Mindestens eine Option muss aktiv sein",
  "For members": "Für Mitglieder",
  "For non-members": "Für Nicht-Mitglieder",
  "For direct debits: run date and remittance info for matching on the bank statement": "Bei Lastschriften: LS-Datum und Verwendungszweck-Info zur Prüfung auf dem Kontoauszug",
  "For relative fee (Enrollment Fee), a number > 0 must be entered": "Bei relativem Beitrag (Aufnahmegebühren) muss eine Anzahl > 0 eingegeben werden",
  "For relative fee (Main Contract), a number > 0 must be entered": "Bei relativem Beitrag (Hauptvertrag) muss eine Anzahl > 0 eingegeben werden",
  "For relative fee (Proportional Fee), a number > 0 must be entered": "Bei relativem Beitrag (Anteiliger Beitrag) muss eine Anzahl > 0 eingegeben werden",
  "For SEPA direct debits, e.g. DE98ZZZ…": "Für SEPA-Lastschriften, z. B. DE98ZZZ…",
  "Force Delete": "erzwungenes Löschen",
  "Forgot password?": "Passwort vergessen?",
  "Form of address (formal/informal)": "Ansprache (Sie/Du)",
  "Form of address is required": "Ansprache ist erforderlich",
  "Formal": "Sie",
  "Former__alt1": "Ehemalig",
  "Former__alt2": "Ehemalige",
  "free": "kostenlos",
  "free at end": "gratis ans Ende",
  "Free": "kostenlos",
  "Free__alt1": "kostenfrei",
  "Fri": "Fr",
  "Friday": "Freitag",
  "From": "von",
  "Full name": "Vor- und Nachname",
  "Welcome card name": "Willkommenskarte Name",
  "Welcome display name format tooltip": "FirstName = nur Vorname, FullName = Vor- und Nachname, Email = E-Mail-Adresse.",
  "From:": "Von:",
  "Full cancellation": "Vollständige Stornierung",
  "Future": "zukünftig",
  "Future contributions": "zukünftige Beiträge",
  "Gallery": "Galerie",
  "Gallery layout & icons (per user)": "Galerie-Layout & Symbole (pro Benutzer)",
  "Gateway Address": "Gateway-Adresse",
  "Gateway connection": "Gateway-Anbindung",
  "Gateway HTTP timeout (seconds)": "Gateway HTTP-Timeout (Sekunden)",
  "Gateway ping interval (minutes)": "Gateway-Ping-Intervall (Minuten)",
  "Gender": "Geschlecht",
  "General": "Allgemein",
  "Generate": "generieren",
  "Generating code...": "Code wird generiert…",
  "German": "Deutsch",
  "Get balance": "Guthaben abfragen",
  "Global default (reference)": "globale Standardeinstellung (Referenz)",
  "Go to dashboard": "zum Dashboard",
  "Go to existing lead": "zum bestehenden Kontakt",
  "Go to person file": "zum Karteiblatt",
  "Good day": "Guten Tag",
  "Green": "Grün",
  "Group by": "Gruppierung",
  "Group by customer": "nach Kunde gruppieren",
  "Group created.": "Gruppe angelegt.",
  "Group direct debits by person": "Einzüge pro Person als eine Buchung zusammenfassen",
  "Group not available": "Gruppe nicht verfügbar",
  "Group not found": "Gruppe nicht gefunden",
  "Group saved.": "Gruppe gespeichert.",
  "Grouping": "Gruppierung",
  "Growth": "Wachstum",
  "h": "Std.",
  "Hamburg": "Hamburg",
  "Handle overpayment": "Überzahlung behandeln",
  "Header Text": "Kopfzeilentext",
  "Hello": "Hallo",
  "Hello + first name": "Hallo + Vorname",
  "Hello + Mr./Ms. last name": "Hallo + Herr/Frau Nachname",
  "Here you define whether SEPA direct debit is used and which pain version is used to generate the XML file.": "Hier legst du fest, ob SEPA-Lastschrift genutzt wird und in welcher pain-Version die XML-Datei erzeugt wird.",
  "Here you manage SEPA bank details (tenant account) as well as additional bank accounts and their studio assignment.": "Hier verwaltest du die Bankdaten für SEPA (Firmenkonto) sowie zusätzliche Bankverbindungen und deren Studio-Zuweisung.",
  "Hide diagnostics": "Diagnose ausblenden",
  "Hide": "ausblenden",
  "Hide__alt2": "nicht anzeigen",
  "Historical contributions": "historische Beiträge",
  "Historical contracts": "historische Verträge",
  "Historical wallets": "historische Wertekonten",
  "Historical article sales": "historische Artikelverkäufe",
  "History": "Historie",
  "History only": "Nur Historie",
  "History title": "Historie-Titel",
  "Holiday added": "Feiertag hinzugefügt",
  "Holiday calendar": "Feiertagskalender",
  "Holiday configuration duplicated.": "Feiertagskonfiguration dupliziert.",
  "Holidays all studios scope already exists": "Ein Bereich „alle Studios“ existiert bereits.",
  "Holidays studio already in another scope": "Mindestens ein Studio ist bereits einem anderen Bereich zugeordnet.",
  "Holiday created": "Feiertag angelegt",
  "Holiday deleted": "Feiertag gelöscht",
  "Holiday hidden": "Feiertag ausgeblendet",
  "Holiday shown again": "Feiertag wieder eingeschaltet",
  "Holiday updated": "Feiertag aktualisiert",
  "Failed to save holiday": "Feiertag konnte nicht gespeichert werden",
  "Holidays": "Feiertage",
  "Home studio": "Stammstudio",
  "Home studio is required": "Stammstudio ist erforderlich",
  "Home studio is required.": "Stammstudio ist erforderlich.",
  "Home studio only": "nur Stammstudio",
  "Hourly Distribution": "Stündliche Verteilung",
  "hour": "Stunde",
  "hours": "Stunden",
  "Hours": "Stunden",
  "How far in advance can appointments be booked? Default: 90 days (approx. 3 months)": "Wie weit im Voraus können Termine gebucht werden? Standard: 90 Tage (ca. 3 Monate)",
  "How long the test tab waits for a device ACK before stopping.": "Wie lange im Test-Tab auf ein ACK vom Gerät gewartet wird, bevor die UI abbricht.",
  "How many emails per tenant/studio setup should be sent at most per run.": "Wie viele E-Mails pro Tenant/Studio-Setup pro Durchlauf maximal versendet werden sollen.",
  "hrs": "Std.",
  "https://gateway.example.com": "https://m1gateway.mqorva.de",
  "I accept the ": "Ich akzeptiere die ",
  "I am": "Ich bin",
  "IBAN": "IBAN",
  "IBAN (optional)": "IBAN",
  "Icons": "Symbole",
  "If an account with this email address exists, a link to reset your password has been sent.": "Falls ein Konto mit dieser E-Mail-Adresse existiert, wurde ein Link zum Zurücksetzen des Passworts gesendet.",
  "If empty, the code is generated automatically. Appears in URL: /#/lead/{code}": "Wenn leer, wird der Code automatisch erstellt. Erscheint in der URL: /#/lead/{code}",
  "If enabled, check-in will be blocked for persons with overdue items at this reminder level.": "Wenn aktiviert, wird der Check-in für Personen mit überfälligen Posten in dieser Mahnstufe gesperrt.",
  "If no duration is defined, no renewal may be defined either.": "Wenn keine Laufzeit definiert ist, darf auch keine Verlängerung definiert werden.",
  "If no studio is selected, the template applies to all studios.": "Wenn kein Studio ausgewählt ist, gilt die Vorlage für alle Studios.",
  "If set: User gets a confirmation dialog and may create the appointment. If not set: No permission – appointment is refused.": "Erlaubt das Anlegen von Terminen außerhalb hinterlegter Ressourcen- oder Mitarbeiter-Verfügbarkeit.",
  "iFrame Code": "iFrame-Code",
  "Image for booking widget header": "Bild für Buchungsformular-Header",
  "Image is too large (max 500KB). Please move closer or use file upload.": "Bild zu groß (max 500KB). Bitte näher ran oder nutze Datei-Upload.",
  "Image": "Bild",
  "Image (Booking Widget)": "Bild (Buchungsformular)",
  "Image removed": "Bild entfernt",
  "Image uploaded": "Bild hochgeladen",
  "Image too large max 1 MB": "Bild zu groß (max. 1 MB).",
  "Drag & drop image here or click to upload": "Bild hierher ziehen oder klicken zum Hochladen",
  "IMAP configured": "IMAP konfiguriert",
  "IMAP folders refreshed.": "IMAP-Ordner aktualisiert.",
  "IMAP host": "IMAP Host",
  "IMAP test failed.": "IMAP-Test fehlgeschlagen.",
  "IMAP test successful.": "IMAP-Test erfolgreich.",
  "Import bank data": "Bankdaten importieren",
  "Import bank data from the German Bundesbank to get started.": "Importieren Sie die Bankdaten von der Deutschen Bundesbank, um zu beginnen.",
  "Import completed.": "Import abgeschlossen.",
  "Import completed. Paths were adjusted.": "Import abgeschlossen. Pfade wurden angepasst.",
  "Import diagnostics (metafile conversion)": "Import-Diagnose (Metafile-Konvertierung)",
  "Import failed": "Import fehlgeschlagen",
  "Import failed.": "Import fehlgeschlagen.",
  "Import from Bundesbank": "Von Bundesbank importieren",
  "Import holidays": "Feiertage importieren",
  "Import successful": "Import erfolgreich",
  "Import": "importieren",
  "Import__alt1": "Import",
  "Import__alt2": "importieren",
  "Imprint": "Impressum",
  "in": "im",
  "Inactive": "inaktiv",
  "Inactive for months": "inaktiv seit Monaten",
  "Inactive Members": "Inaktive Mitglieder",
  "Inbox": "Posteingang",
  "Open inbox": "Posteingang öffnen",
  "No incoming messages": "Keine eingegangenen Nachrichten",
  "Inbox card description": "eingehende Nachrichten",
  "Inbox folder": "Inbox Ordner",
  "Inbox letter dispatch local": "lokal (Druck)",
  "Inbox letter route": "Briefweg",
  "Income": "Einnahmen",
  "Incoming (IMAP)": "Eingang (IMAP)",
  "Individual persons always have capacity 1": "Einzelpersonen haben immer Kapazität 1",
  "Info": "Info",
  "Informal": "Du",
  "Information": "Informationen",
  "Desktop downloads": "Desktop-App herunterladen",
  "Download m1connect": "m1connect herunterladen",
  "Initial": "Erstlaufzeit",
  "Initial balance": "Startsaldo",
  "Initial notice": "Frist Erstlaufzeit",
  "Initial Notice Period": "Kündigungsfrist Erstlaufzeit",
  "Insert variable…": "Variable einfügen…",
  "Formula part": "Formel/Option",
  "Formula part placeholder": "Formel oder Option einfügen",
  "No formula at cursor": "keine passende Formel oder Option am Cursor",
  "Link text required": "Text für klickbare Ausgabe erforderlich",
  "No link at cursor": "keine klickbare Variable am Cursor",
  "Link text could not be changed": "Text der klickbaren Ausgabe konnte nicht geändert werden",
  "Formula option link": "als Link",
  "Formula option link with text": "Klickbar mit Text \"klick\"",
  "Formula option plus 1 day": "+ 1 Tag",
  "Formula option plus 3 days": "+ 3 Tage",
  "Formula option plus 1 week": "+ 1 Woche",
  "Formula option plus 3 weeks": "+ 3 Wochen",
  "Formula option plus 1 month": "+ 1 Monat",
  "Formula option plus 1 year": "+ 1 Jahr",
  "Formula option minus 1 day": "- 1 Tag",
  "Formula option minus 1 week": "- 1 Woche",
  "Formula option minus 1 month": "- 1 Monat",
  "Formula option minus 10 percent": "- 10 %",
  "Formula option plus 10 percent": "+ 10 %",
  "Formula option 10 percent of": "davon 10 %",
  "Formula option plus 5": "+ 5",
  "Formula option minus 5": "- 5",
  "Formula option times 2": "* 2",
  "Formula option divided by 2": "/ 2",
  "Main term total amount": "Gesamtbeitrag Hauptlaufzeit",
  "Paid contract amount": "bisher gezahlter Vertragsbeitrag",
  "Remaining contract amount": "offener Restbeitrag Vertrag",
  "Installment": "Rate",
  "Installment payments / payment plans": "Ratenzahlungen / Zahlungspläne",
  "Installment plan": "Ratenzahlung",
  "Installment plan created": "Ratenzahlung angelegt",
  "Installment plans can only be created for open items, not contributions.": "Ratenzahlung kann nur für offene Posten angelegt werden, nicht für Beiträge.",
  "installments": "Raten",
  "Installments": "Raten",
  "Installments__alt1": "Beiträge",
  "Installments__alt3": "Ratenzahlungen",
  "Integration added": "Schnittstelle hinzugefügt",
  "Integration deleted": "Schnittstelle gelöscht",
  "Integration drawer title add": "neue Schnittstelle",
  "Integration drawer title edit": "Schnittstelle",
  "Integration Token": "Integrationstoken",
  "Integration type": "Schnittstellen-Art",
  "Integration type description": "Beschreibung der Schnittstellen-Art",
  "Integration updated": "Schnittstelle aktualisiert",
  "Integrations": "Schnittstellen",
  "Interval (days)": "Intervall (Tage)",
  "Interval (weeks)": "Intervall (Wochen)",
  "IBAN is required": "IBAN ist erforderlich",
  "Invalid balance": "Saldo ungültig",
  "Invalid BIC": "ungültige BIC",
  "Invalid BIC__alt2": "Ungültiger BIC",
  "Invalid creditor ID": "ungültige Gläubiger-ID",
  "Invalid email": "ungültige E‑Mail",
  "Invalid format": "ungültiges Format",
  "Invalid email address.": "ungültige E-Mail-Adresse.",
  "Invalid file type. Allowed: Images (JPG, PNG, GIF, WEBP), PDF, Text (TXT, CSV), Word (DOC, DOCX)": "Ungültiger Dateityp. Zulässig: Bilder (JPG, PNG, GIF, WEBP), PDF, Text (TXT, CSV), Word (DOC, DOCX)",
  "Invalid IBAN": "ungültige IBAN",
  "Invalid JSON": "ungültiges JSON",
  "Invalid phone number": "ungültige Telefonnummer",
  "Invalid range (1-53)": "Ungültiger Zeitraum (1-53)",
  "Invalid server response: token missing": "ungültige Server-Antwort: Token fehlt",
  "Invalid website URL": "ungültige Website-URL",
  "Items": "Positionen",
  "Join Date": "Beitrittsdatum",
  "Keep contributions (no change)": "Beiträge beibehalten (keine Änderung)",
  "Key": "Schlüssel",
  "Key is required": "Key ist erforderlich",
  "Keyword": "Stichwort",
  "Keyword/text contains (any)": "Stichwort/Text enthält (eines davon)",
  "Label (optional)": "Bezeichnung",
  "Language": "Sprache",
  "Large": "Groß",
  "Last": "letzte",
  "Last duration prefix": "letzte",
  "Last Check-In": "letzter Check-in",
  "Last checked in": "Zuletzt eingecheckt",
  "Last name": "Nachname",
  "Last Name": "Nachname",
  "last name (sanitized), max. 12 characters": "Nachname (bereinigt), max. 12 Zeichen",
  "Last name is required": "Nachname ist erforderlich",
  "Last name, First name": "Nachname, Vorname",
  "Last No-Show": "letzter No-Show",
  "Last Run": "Zuletzt ausgeführt",
  "Last seen": "Zuletzt gesehen",
  "Last Updated": "Zuletzt aktualisiert",
  "Last year": "letztes Jahr",
  "Lead": "Kontakt",
  "Lead closed.": "Kontakt abgeschlossen.",
  "Lead created.": "Kontakt angelegt.",
  "Lead deleted.": "Kontakt gelöscht.",
  "Lead details": "Kontakt-Daten",
  "Lead compose requires linked person": "Zum Versand aus dem System ist eine verknüpfte Person nötig.",
  "Lead history by": "von {0}",
  "Studio app module": "Modul Studio-App",
  "Lead on Booking": "Kontakt bei Buchung",
  "Create lead on booking (when booking as non-member)": "Kontakt anlegen, wenn Person noch unbekannt",
  "Update person contact from booking": "Person-Kontaktdaten bei Buchung mit Formulardaten aktualisieren",
  "Update person contact from booking (help)": "Wenn aus: Bestätigung und Erinnerung gehen an die im Formular angegebenen Daten (nur für diesen Termin), die Person wird nicht geändert.",
  "Studio (for lead)": "Studio (für Kontakt)",
  "Lead reports": "Kontakt-Auswertungen",
  "Reports restrict to own data": "Auswertungen nur eigene Daten (Studio-Zugriff)",
  "Restrict reports to the user's assigned studios.": "Auswertungen auf die dem Benutzer zugeordneten Studios beschränken.",
  "Lead saved.": "Kontakt gespeichert.",
  "Lead new badge": "neu",
  "ICM import": "ICM-Import",
  "Lead since": "Kontakt seit",
  "Lead source": "Kontaktquelle",
  "Lead home studio change warning": "Das Stammstudio wird auf „{0}“ geändert. Dadurch können sich Zuständigkeit, Pipeline und Sichtbarkeit ändern. Mitarbeiter ohne Zugriff auf dieses Studio können den Kontakt anschließend nicht mehr sehen oder bearbeiten.",
  "Lead phase": "Kontaktphase",
  "Lead source created": "Kontaktquelle angelegt",
  "Lead source deleted": "Kontaktquelle gelöscht",
  "Lead source updated": "Kontaktquelle aktualisiert",
  "Lead times": "Vorlaufzeiten",
  "Lead widgets": "Kontaktformulare",
  "Lead widget": "Kontaktformular",
  "Lead-Widgets": "Kontaktformulare",
  "Manage online lead widgets and design presets": "Kontaktformulare und Design-Vorlagen verwalten",
  "Leads": "Kontakte",
  "Leads & Sales Reports": "Kontakte & Sales Auswertungen",
  "Leads Only": "Nur für Kontakte",
  "Leave empty = auto-generated (server)": "Leer lassen = automatisch generiert (Server)",
  "Leave empty for unlimited capacity": "leer lassen für unbegrenzte Kapazität",
  "Leave empty to use data source": "Leer lassen für Standard-Absenderangaben",
  "Legend": "Legende",
  "Letter": "Brief",
  "Letter (print)": "Brief (Druck)",
  "Letter sending": "Briefversand",
  "Level": "Stufe",
  "Liability": "Passivkonto",
  "Light": "hell",
  "Limits": "Grenzen",
  "Limits/throttle for email sending": "Limits/Throttle für den E-Mail-Versand",
  "Link": "Link",
  "Link copied to clipboard": "Link in Zwischenablage kopiert",
  "Link copied!": "Link kopiert!",
  "Link to booking edit/cancel page": "Link zur Seite zum Bearbeiten/Stornieren der Buchung",
  "Linked User": "Verknüpfter Benutzer",
  "List": "Liste",
  "Load failed": "Fehler beim Laden",
  "Load more": "mehr laden",
  "Loading calendar…": "Kalender wird geladen…",
  "Loading history...": "Historie wird geladen …",
  "Loading items...": "Positionen werden geladen …",
  "Loading resources and studios…": "Ressourcen und Studios werden geladen…",
  "Loading resources…": "Ressourcen werden geladen…",
  "Loading…": "Lädt…",
  "Loading...": "wird geladen …",
  "Loading…__alt2": "Wird geladen…",
  "local": "lokal",
  "Lock": "sperren",
  "Lock person": "Person sperren",
  "locked": "gesperrt",
  "Manually locked": "manuell gesperrt",
  "Locked": "gesperrt",
  "Locked wallets cannot be used.": "Gesperrte Wertekonten können nicht genutzt werden.",
  "Lock…": "sperren…",
  "Log": "Protokoll",
  "Log call": "Anruf protokollieren",
  "Log contact": "Kontakt protokollieren",
  "Log details": "Log-Details",
  "Log details copied to clipboard": "Log-Details in Zwischenablage kopiert",
  "Current plan": "aktueller Tarif",
  "Ends soon": "endet demnächst",
  "Payment pending": "Zahlung ausstehend",
  "Expired": "abgelaufen",
  "No subscription": "kein Abo",
  "Net plus VAT": "netto zzgl. USt.",
  "Paid through": "bezahlt bis",
  "Cancelled at period end": "zum Periodenende gekündigt",
  "Cancel subscription": "Abo kündigen",
  "No plan selected yet": "Es ist noch kein Tarif gewählt.",
  "Choose plan": "Tarif wählen",
  "Choose Plan": "Tarif wählen",
  "per studio and year": "je Studio und Jahr",
  "per studio and month": "je Studio und Monat",
  "On request": "auf Anfrage",
  "Request quote": "Angebot anfragen",
  "Enterprise inquiry": "Angebot anfordern",
  "individual prices": "individuelle Preise",
  "Add address": "Adresse hinzufügen",
  "Remove address?": "Adresse entfernen?",
  "Use for billing": "als Rechnungsadresse",
  "Use for shipping": "als Lieferadresse",
  "Choose this plan": "diesen Tarif wählen",
  "Billing details": "Rechnungsdaten",
  "Billing email": "Rechnungs-E-Mail",
  "Street and number": "Straße und Hausnummer",
  "Address addition": "Adresszusatz",
  "VAT ID": "USt-IdNr.",
  "Invoices": "Rechnungen",
  "Invoice number": "Rechnungsnummer",
  "Invoice date": "Rechnungsdatum",
  "Service period": "Leistungszeitraum",
  "Billing": "Abrechnung",
  "Admin.BillingAndPaymentIntegration": "Tarife & Zahlungen",
  "Seller data, VAT, payment providers and plan catalog": "Verkäuferdaten, Umsatzsteuer, Zahlungsanbieter und Tarifkatalog",
  "Plan catalog and payment providers": "Tarifkatalog und Zahlungsanbieter",
  "Invoice overview, sender data and invoice design": "Rechnungsübersicht, Rechnungssteller und Rechnungsdesign",
  "Seller and tax": "Verkäufer und Steuer",
  "Seller data incomplete": "Verkäuferdaten unvollständig",
  "Without complete seller data no invoice can be created": "Ohne vollständige Verkäuferdaten kann keine Rechnung erzeugt werden.",
  "Yearly discount percent": "Jahresnachlass in Prozent",
  "Tax number": "Steuernummer",
  "Home country": "Sitzland",
  "Standard VAT rate": "Regelsteuersatz",
  "Reverse charge for EU business customers": "Reverse Charge bei EU-Unternehmen mit USt-IdNr.",
  "Exempt outside the EU": "steuerfrei außerhalb der EU",
  "Payment providers": "Zahlungsanbieter",
  "Publishable key": "öffentlicher Schlüssel",
  "Leave empty to keep": "leer lassen, um zu behalten",
  "Secret configured": "Geheimnis hinterlegt",
  "No secret": "kein Geheimnis",
  "Webhook configured": "Webhook eingerichtet",
  "One-time payments": "Einmalzahlung",
  "Plans": "Tarife",
  "Add-ons": "Bausteine",
  "Trial days": "Testtage",
  "Per studio": "je Studio",
  "Archived": "archiviert",
  "Included in plans": "enthalten in Tarifen",
  "Failed to load payment providers": "Die Zahlungsanbieter konnten nicht geladen werden.",
  "Failed to load billing policy": "Die Abrechnungseinstellungen konnten nicht geladen werden.",
  "Failed to save billing policy": "Die Abrechnungseinstellungen konnten nicht gespeichert werden.",
  "Invoice design": "Rechnungsdesign",
  "Failed to load invoices": "Die Rechnungen konnten nicht geladen werden.",
  "Failed to download invoice": "Die Rechnung konnte nicht heruntergeladen werden.",
  "No invoices yet": "Noch keine Rechnungen vorhanden",
  "Log out": "abmelden",
  "Subscription & billing": "Tarif & Abrechnung",
  "No invoices available yet": "Es liegen noch keine Rechnungen vor",
  "Login": "Login",
  "Web login": "Web-Login",
  "Online login allowed": "Online-Login erlaubt",
  "m1app access": "m1app-Zugriff",
  "m1app access allowed": "m1app-Zugriff erlaubt",
  "(required for m1app access)": "(erforderlich für m1app-Zugriff)",
  "List as staff": "als Mitarbeiter führen",
  "No change": "keine Änderung",
  "CenterCom only newly imported staff accounts": "nur für neu importierte Mitarbeiterkonten",
  "Listed as staff": "Mitarbeiter",
  "Login failed": "Login fehlgeschlagen",
  "LoginAccountDeactivated": "Account deaktiviert",
  "LoginFailedGeneric": "Anmeldung fehlgeschlagen",
  "LoginInvalidCredentials": "E-Mail oder Passwort stimmt nicht.",
  "LoginRateLimited": "Zu viele fehlgeschlagene Anmeldeversuche. Bitte versuchen Sie es später erneut.",
  "LoginTenantBackupRestoreInProgress": "Für diesen Mandanten läuft eine Datenrücksicherung. Bitte später erneut versuchen.",
  "LoginTenantImportInProgress": "Für diesen Mandanten läuft ein Datenimport. Bitte später erneut versuchen.",
  "LoginTenantDeactivated": "Firma ist deaktiviert",
  "LoginTenantNotFound": "Firma nicht gefunden",
  "TenantBackupRestoreInProgress": "Für diesen Mandanten läuft eine Datenrücksicherung. Bitte später erneut versuchen.",
  "TenantImportCommitInProgress": "Für diesen Mandanten läuft ein Datenimport. Bitte später erneut versuchen.",
  "E_SUBSCRIPTION_REQUIRED": "Der Tarif ist abgelaufen. Bis zur Verlängerung ist nur Lesen möglich.",
  "Logo": "Logo",
  "mQorva logo": "mQorva-Logo",
  "Logo (optional)": "Logo",
  "Logo removed": "Logo entfernt",
  "Logo uploaded": "Logo hochgeladen",
  "Logs": "Systemprotokoll",
  "Logs & Information": "Systemprotokoll & Informationen",
  "logs deleted.": "Protokolleinträge gelöscht.",
  "Longest Contracts": "Längste Verträge",
  "m1gateway": "m1gateway",
  "m1connect Registration": "m1connect Registrierung",
  "m1member – Business Console": "m1member – Business Console",
  "From the first contact to daily access.": "Vom ersten Kontakt bis zum täglichen Zutritt.",
  "m1member – Platform administration": "m1member – Plattform-Verwaltung",
  "Mail from your sports club": "Post von deinem Sportclub",
  "Main Contract": "Hauptvertrag",
  "Male": "männlich",
  "Manage access reader devices": "Zutritts-Lesegeräte verwalten",
  "Manage and edit leads": "Kontakte verwalten und bearbeiten",
  "Manage and import global holidays by country & region": "globale Feiertage pro Land & Region verwalten und importieren",
  "Manage appointment types, roles and calendar settings.": "Arten, Rollen und Kalender-Einstellungen für Termine verwalten.",
  "Manage appointments": "Termine bearbeiten",
  "Edit appointments": "Termine bearbeiten",
  "Manage availabilities": "Verfügbarkeiten verwalten",
  "Manage background services & view logs": "Hintergrunddienste verwalten & Protokolleinträge anzeigen",
  "Manage email and SMS queue": "System-Warteschlange für E-Mail- und SMS-Versand (Technik)",
  "Manage global bank data & configure automatic updates": "globale Bankdaten verwalten & automatische Updates konfigurieren",
  "Manage lead sources": "Kontaktquellen verwalten",
  "Manage open and overdue dues": "offene & überfällige Beiträge verwalten",
  "Manage payment methods for payments": "Zahlungsarten für Zahlungen pflegen",
  "Manage reader devices": "Lesegeräte verwalten",
  "View reader devices": "Lesegeräte ansehen",
  "Manage report & table templates": "Auswertungs- & Tabellen-Vorlagen verwalten",
  "Manage roles": "Rollen verwalten",
  "Manage SEPA direct debits": "SEPA-Lastschriften verwalten",
  "Manage users": "Benutzer verwalten",
  "Manage version descriptions and automatic changelog entries": "Versionsbeschreibungen und automatische Changelog-Einträge verwalten",
  "Mandate date": "Mandatsdatum",
  "Mandate date__alt1": "Mandat-Datum",
  "Mandate date is required": "Mandatsdatum ist erforderlich",
  "Mandate reference": "Mandatsreferenz",
  "Mandate Reference": "Mandatsreferenz",
  "Mandate reference (optional)": "Mandatsreferenz",
  "Mandate reference format": "Mandatsreferenz-Format",
  "Mandate reference is required": "Mandatsreferenz ist erforderlich",
  "Mandate signed date": "Mandatsunterzeichnungsdatum",
  "Mandate signed date is required": "Mandatsunterzeichnungsdatum ist erforderlich",
  "Mandate signed on": "Mandat unterschrieben am",
  "Manual bank transfers": "manuelle Banküberweisungen",
  "Manually cancelled": "manuell storniert",
  "Manually cancelled (Admin)": "manuell storniert (Admin)",
  "Manufacturer": "Hersteller",
  "Mark task as done": "Aufgabe erledigen",
  "Marketing": "Marketing",
  "Master data": "Stammdaten",
  "Matched against inbound text/notes/referral name.": "Wird gegen Inbound-Text/Notizen/Empfehlungsname geprüft.",
  "Max days in advance": "Max. Tage im Voraus",
  "Max members": "Max. Mitglieder",
  "Max Mustermann": "Max Mustermann",
  "Max readers": "Max. Leser",
  "Max studios": "Max. Studios",
  "Max users": "max. Benutzer",
  "Max. 80 characters": "Max. 80 Zeichen",
  "Max. Participants": "Max. Teilnehmer",
  "max@…": "max@…",
  "Maximum Capacity (Persons)": "Maximale Kapazität (Personen)",
  "Medium ID": "Medium-ID",
  "Medium": "Medium",
  "Medium__alt2": "Mittel",
  "Member": "Mitglied",
  "Allow usage for": "Nutzung erlauben für",
  "Member assignable": "Mitglied zuweisbar",
  "Member management": "Mitgliederverwaltung",
  "Studio cockpit": "Studio Cockpit",
  "Member Reports": "Mitglieder Auswertungen",
  "Member reports": "Mitglieder-Auswertungen",
  "Members": "Mitglieder",
  "Members are automatically checked out after this duration.": "Personen werden nach dieser Zeit automatisch ausgecheckt.",
  "Members Only": "Nur für Mitglieder",
  "Membership end date": "Ende der Mitgliedschaft",
  "Membership end date changed": "Ende der Mitgliedschaft geändert",
  "Membership end date is required": "Ende der Mitgliedschaft ist erforderlich",
  "Message": "Hinweis",
  "Log message": "Nachricht",
  "Message__alt2": "Nachricht",
  "Method": "Kontaktart",
  "min": "Min",
  "Min": "Min",
  "Min. 8 chars, upper/lowercase, digit, special char": "Mind. 8 Zeichen, Groß-/Kleinbuchstabe, Ziffer, Sonderzeichen",
  "Min. Participants": "Min. Teilnehmer",
  "Min. time in advance": "Mindestvorlauf",
  "Min. time in advance (staff)": "Mindestvorlauf (Mitarbeiter)",
  "Min. time in advance (online)": "Mindestvorlauf (Online)",
  "Cancellation deadline (minutes before start)": "Stornofrist (Minuten vor Terminbeginn)",
  "Cancellation deadline (staff)": "Stornofrist (Mitarbeiter)",
  "Cancellation deadline (online)": "Stornofrist (Online)",
  "Minimum rest period (unit)": "Mindestruhezeit (Einheit)",
  "Minimum rest period (value)": "Mindestruhezeit (Wert)",
  "Minimum seconds between batches": "Mindestabstand zwischen Batches (Sekunden)",
  "Minimum time between batches (seconds)": "Mindestabstand zwischen Batches (Sekunden)",
  "Minimum time is required": "Mindestabstand ist erforderlich",
  "Minimum wait time in seconds between two batches (0-86400). 0 = no limit. Default: 0": "Minimale Wartezeit in Sekunden zwischen zwei Batches (0-86400). 0 = kein Limit. Standard: 0",
  "minutes": "Minuten",
  "No messages": "keine Nachrichten",
  "No calls": "keine Anrufe",
  "Mobile": "Mobil",
  "Mobile (optional)": "Mobil",
  "Mode": "Modus",
  "Modules": "Module",
  "Mon": "Mo",
  "Monday": "Montag",
  "Month": "Monat",
  "Quarter": "Quartal",
  "Monthly": "monatlich",
  "Monthly Churn Rate": "Monatliche Kündigungsquote",
  "Monthly Fee": "Monatliche Gebühr",
  "Monthly flat fee": "Monatliche Pauschale",
  "Monthly flat fee (optional)": "Monatliche Pauschale",
  "Monthly flat fee must be >= 0": "Monatliche Pauschale muss >= 0 sein",
  "Months": "Monate",
  "More colors": "weitere Farben",
  "Most Popular Time": "Beliebteste Zeit",
  "Move appointment": "Termin verschieben",
  "Mr.": "Herr",
  "Ms.": "Frau",
  "Multi-select creates a separate template per studio.": "Mehrfachauswahl erzeugt automatisch je Studio eine eigene Vorlage.",
  "Multi-select creates the template for multiple studios.": "Mehrfachauswahl legt die Vorlage für mehrere Studios an.",
  "Must be >= 1": "Muss >= 1 sein",
  "Name & QR Code": "Name & QR-Code",
  "Name (e.g. Entrance)": "Name (z. B. Eingang)",
  "Name (e.g. Exit)": "Name (z. B. Ausgang)",
  "Name (from m1connect)": "Name (aus m1connect)",
  "Name (optional)": "Name",
  "Name for this configuration": "Name für diese Konfiguration",
  "Name format": "Namensformat",
  "Name is required__alt1": "Bezeichnung fehlt",
  "Name is required__alt2": "Name fehlt",
  "Name required": "Name erforderlich",
  "Name/first name…": "Name/Vorname…",
  "Name/Title": "Name/Titel",
  "Name/title": "Name/Titel",
  "Name/Title is required": "Name/Titel ist erforderlich",
  "Name/title is required": "Name/Titel ist erforderlich",
  "Name: The Name field is required": "Name: Das Namensfeld ist erforderlich",
  "Name__alt1": "Bezeichnung",
  "national": "bundesweit",
  "National": "bundesweit",
  "nearest": "nächstliegend",
  "Negative": "negativ",
  "Negative = before, 0 = on day, Positive = after": "negativ = vorher, 0 = am Tag, positiv = danach",
  "Net": "Netto",
  "Net Cashflow": "Netto-Cashflow",
  "Net Growth": "Netto-Wachstum",
  "Never Checked In": "Nie eingecheckt",
  "New": "neu",
  "new": "neu",
  "New admin": "neuer Admin",
  "New appointment": "neuer Termin",
  "New Appointment Type": "neue Terminart",
  "New Booking": "neue Buchung",
  "New Calendar Role": "neue Kalender-Rolle",
  "New Cancellation Model": "neues Kündigungsmodell",
  "New Cancellation Reason": "neuer Kündigungsgrund",
  "New category": "neue Kategorie",
  "New configuration": "neue Konfiguration",
  "New Contract Template": "neuer Vertragsbaustein",
  "New debt collection agency": "neuer Inkasso-Dienstleister",
  "New PriceAdjustment": "neue Preisanpassung",
  "New price adjustment": "neue Preisanpassung",
  "New Group": "neue Gruppe",
  "New lead": "neuer Kontakt",
  "New Lead Source": "neue Kontaktquelle",
  "New leads": "neue Kontakte",
  "New Members": "neue Mitglieder",
  "New Members__alt1": "Neuabschlüsse",
  "New password": "neues Passwort",
  "New password saved (server) and filled into the field.": "neues Passwort gespeichert (Server) und ins Feld übernommen.",
  "New Payment Cancellation Reason": "neuer Zahlungsstornogrund",
  "New Rest Period Reason": "neuer Ruhezeitgrund",
  "New payment method": "neue Zahlungsart",
  "New Payment Plan": "neuer Zahlungsplan",
  "New person": "neue Person",
  "New pipeline": "neues Phasenmodell",
  "New reader device": "neues Lesegerät",
  "New reminder": "neue Mahnung",
  "New reminder level": "neue Mahnstufe",
  "New Resource": "neue Ressource",
  "New rest period model": "neues Ruhezeitmodell",
  "New rest period template": "neues Ruhezeitmodell",
  "New role": "neue Rolle",
  "New rule": "neue Regel",
  "New run": "neuer Lauf",
  "New Scenario": "neues Szenario",
  "New Studio": "neues Studio",
  "New Template": "neue Vorlage",
  "New template": "neue Vorlage",
  "New tenant": "neuer Mandant",
  "New unavailability reason": "neuer Abwesenheitsgrund",
  "New user": "neuer Benutzer",
  "New zone": "neue Zone",
  "Next": "weiter",
  "Next 30 Days": "nächste 30 Tage",
  "Next 60 Days": "nächste 60 Tage",
  "Next 90 Days": "nächste 90 Tage",
  "Next reminder level": "nächste Mahnstufe",
  "Reminder channel": "Kanal",
  "Reminder channel suggest failed": "Kanal konnte nicht ermittelt werden.",
  "Reminder level routing at least one rule": "Bitte mindestens eine Vorlagen-Route konfigurieren.",
  "Reminder level routing templates required": "Bitte für jede Route die Vorlage für den bevorzugten Kanal auswählen; mit Fallback auch Kanal und zweite Vorlage vollständig setzen.",
  "Reminder level routing channels must differ": "Bevorzugter Kanal und Fallback müssen unterschiedlich sein.",
  "Reminder level routing fallback partial": "Fallback-Kanal und Vorlage müssen zusammen gesetzt werden.",
  "Reminder template routing": "Vorlagen-Routing",
  "Payment methods for rule": "Zahlungsarten",
  "Payment methods for rule tooltip": "Leer = alle Zahlungsarten, die nicht von spezifischeren Regeln abgedeckt sind.",
  "Payment methods for rule placeholder": "alle, wenn leer",
  "Reset reminder level scope hint": "Alle gemahnten Positionen dieses Mahnvorgangs werden zurückgenommen:",
  "Take back reminder fee": "Mahngebühr zurücknehmen",
  "ReminderResetFeeSettled": "Die Mahngebühr ist bereits ausgeglichen und kann nicht mehr zurückgenommen werden.",
  "No reminder fee in this dispatch": "Für diesen Mahnvorgang wurde keine Mahngebühr berechnet.",
  "Delivery failed": "Versand fehlgeschlagen",
  "To dispatch": "zum Versand",
  "Attempts": "Versuche",
  "Document created": "Dokument erstellt",
  "Delivery retry policy": "Zustellwiederholung",
  "Delivery retry policy description": "Gilt für alle Versand-Warteschlangen. Bei einer vorübergehenden Störung bleibt die Nachricht offen und wird mit wachsendem Abstand erneut versucht.",
  "Delivery max attempts": "Versuche",
  "Delivery retry base minutes": "Basisabstand (Minuten)",
  "Reset reminder level": "Mahnstufe zurücksetzen",
  "Reset reminder level confirm": "Mahnstufe und Mahngebühr werden zurückgenommen.",
  "Reminder level reset.": "Mahnstufe zurückgesetzt.",
  "Reminder level reset status": "zurückgesetzt",
  "ReminderLevelReset": "Mahnstufe zurückgesetzt",
  "Reminder reasons for rule": "Mahngründe",
  "Reminder reasons for rule tooltip": "Jeder Mahngrund kann nur einer Regel zugeordnet werden. Leer übernimmt alle übrigen Mahngründe; bei einem gemischten Fall gilt eine ausdrückliche Zuordnung vor der leeren Regel.",
  "Reminder reasons for rule placeholder": "alle übrigen, wenn leer",
  "All remaining reminder reasons": "alle übrigen Mahngründe",
  "Reminder routing only one fallback rule": "Nur eine Routingregel darf leere Mahngründe haben.",
  "Reminder routing reason only once": "Jeder Mahngrund darf nur einer Routingregel zugeordnet sein.",
  "ReminderRoutingFallbackDuplicate": "Nur eine Routingregel darf leere Mahngründe haben.",
  "ReminderRoutingReasonDuplicate": "Jeder Mahngrund darf nur einer Routingregel zugeordnet sein.",
  "All reminder reasons": "alle Mahngründe",
  "Routing rule priority hint": "Ausdrückliche Mahngründe gelten vor der leeren Regel. Passen bei einem gemischten Fall mehrere ausdrückliche Regeln, entscheidet deren Reihenfolge.",
  "Regular open item": "regulärer offener Posten",
  "Legacy reminder routing conversion required": "Diese Mahnstufe verwendet noch Zahlungsarten als Filter. Ordnen Sie die Regeln den Mahngründen zu und speichern Sie die Mahnstufe.",
  "Reminder reason": "Mahngrund",
  "Regular open amount": "regulär offener Betrag",
  "Chargeback open amount": "offener Rücklastschriftbetrag",
  "Chargeback fee open amount": "offene Rücklastschriftgebühren",
  "Preferred channel": "bevorzugter Kanal",
  "Fallback channel": "Fallback-Kanal",
  "Reminder template": "Mahnvorlage",
  "Reminder template required": "Bitte eine Mahnvorlage wählen.",
  "Remove routing rule": "Regel entfernen",
  "Add routing rule": "Regel hinzufügen",
  "Reminder template routing inkasso hint": "Diese Stufe wird zuerst regulär gemahnt; die Inkasso-Übergabe folgt erst nach Ablauf der Zahlungsfrist. Vorlage und Kanal gelten für diese reguläre Mahnung.",
  "Reminder escalation after this level": "nach dieser Mahnstufe",
  "Templates for debt collection handover": "Vorlagen für Inkasso-Übergabeschreiben",
  "Debt collection template handover": "Vorlage Übergabeschreiben",
  "Debt collection template payment notice": "Vorlage Zahlungsmeldung",
  "Debt collection template cancellation notice": "Vorlage Stornomeldung",
  "Debt collection handover letter template": "Vorlage Übergabeschreiben",
  "Debt collection handover letter hint": "Das Übergabeschreiben geht an den Inkasso-Dienstleister, nicht an das Mitglied.",
  "Debt collection transmissions": "Meldungen an den Dienstleister",
  "Debt collection transmission kind submission": "Übergabe",
  "Debt collection transmission kind payment": "Zahlungsmeldung",
  "Debt collection transmission kind cancellation": "Stornomeldung",
  "Debt collection transmission status pending": "offen",
  "Debt collection transmission status sent": "versendet",
  "Debt collection transmission status failed": "fehlgeschlagen",
  "Debt collection transmission status manual": "manuell zu übermitteln",
  "Debt collection transmission resend": "erneut senden",
  "Debt collection transmission none": "Für diesen Fall ist keine Meldung protokolliert.",
  "Comment (optional)": "Kommentar (optional)",
  "Reminder block action": "Mahnsperre",
  "Reminder block set": "Mahnsperre gesetzt",
  "Reminder block released": "Mahnsperre aufgehoben",
  "Reminder blocked tag": "Mahnwesen ausgesetzt",
  "Reminder blocked until": "ausgesetzt bis",
  "Manage reminder block": "Mahnsperre verwalten",
  "Set reminder block": "Mahnsperre setzen",
  "Release reminder block": "Mahnsperre aufheben",
  "Active reminder blocks": "bestehende Mahnsperren",
  "Reminder block saved.": "Mahnsperre gespeichert.",
  "Reminder block released.": "Mahnsperre aufgehoben.",
  "Reminder block person wide": "gesamte Person aussetzen",
  "Reminder block person wide tooltip": "Setzt das Mahnwesen für alle Verträge der Person aus, nicht nur für die ausgewählten.",
  "Reminder block limited": "befristet",
  "Reminder block until required": "Bitte Datum wählen, bis wann ausgesetzt wird.",
  "Reminder block unlimited": "unbefristet",
  "Reminder block expired": "abgelaufen",
  "Reminder block scope": "Umfang",
  "Reminder block scope persons": "{0} Personen",
  "Reminder block reason placeholder": "z. B. Ratenzahlung vereinbart",
  "Reminder block keeps cases listed": "Ausgesetzte Fälle bleiben mahnfällig gelistet und sichtbar — es wird nur nicht gemahnt.",
  "Reminder block without contract hint": "Für diese Auswahl gibt es keinen Vertragsbezug — es wird das gesamte Mahnwesen der Person ausgesetzt.",
  "Reminder block mixed scope hint": "Posten ohne Vertragsbezug in der Auswahl werden personenweit ausgesetzt.",
  "ReminderBlocked": "Für diesen Fall ist das Mahnwesen ausgesetzt.",
  "ReminderBlockContractMismatch": "Der Vertrag gehört nicht zu dieser Person.",
  "Reminder escalation none": "keine weitere Mahnstufe",
  "Reminder escalation completed tag": "Mahnverfahren beendet",
  "Reminder escalation none hint": "Nach dieser Stufe wird nicht weiter gemahnt. Die offenen Posten bleiben mahnfällig gelistet, markiert als Mahnverfahren beendet.",
  "Reminder escalation none skips existing level": "Stufe {0} ({1}) existiert, wird aus diesem Studio-Bereich aber nicht angesteuert.",
  "Reminder escalation follow level": "weitere Mahnstufe",
  "Reminder escalation derived next level": "danach folgt automatisch Stufe",
  "Reminder escalation derived no next level": "Danach folgt keine weitere Stufe — hier endet die Eskalation. Die offenen Posten bleiben mahnfällig gelistet, markiert als Mahnverfahren beendet.",
  "Reminder escalation inkasso": "Inkasso",
  "Reminder escalation inkasso agency": "Inkasso-Dienstleister",
  "Reminder escalation select agency required": "Bitte Inkasso-Dienstleister wählen.",
  "ReminderLevelEscalationModeInvalid": "Unbekannte Auswahl für die Eskalation nach dieser Mahnstufe.",
  "ReminderLevelDebtCollectionAgencyRequired": "Für die Übergabe ans Inkasso ist ein Dienstleister erforderlich.",
  "Fallback channel optional placeholder": "optional",
  "OnlineBrief24 integration": "OnlineBrief24",
  "Text template channel label": "{0}",
  "Reminder level number": "Stufe",
  "Reminder level number required": "Stufe ist erforderlich.",
  "Reminder level number min": "Stufe muss mindestens 1 sein.",
  "Payment deadline days": "Zahlungsfrist (Tage)",
  "no": "nein",
  "No": "Nein",
  "No access media": "keine Zutrittsmedien",
  "No access – You have read-only or no access to this studio.": "kein Zugriff – Sie haben nur Lesezugriff bzw. keinen Zugriff auf dieses Studio.",
  "No active SEPA group available. Please create a SEPA group.": "keine aktive Lastschriftgruppe verfügbar. Bitte erstellen Sie eine Lastschriftgruppe.",
  "No assignment reader configured": "kein Zuweisungsleser konfiguriert",
  "No appointments available": "keine Termine verfügbar",
  "No slot available": "kein Slot verfügbar",
  "No slot available for this week. Try another week.": "Für diese Woche ist kein Slot verfügbar. Bitte wählen Sie eine andere Woche.",
  "Next week": "nächste Woche",
  "Previous week": "vorherige Woche",
  "Selected slot": "ausgewählter Termin",
  "No assignment": "keine Zuordnung",
  "No bank data available": "keine Bankdaten vorhanden",
  "No camera found.": "keine Kamera gefunden.",
  "No cancellation reasons available. Please create some in settings.": "Keine Zahlungsstornogründe verfügbar. Bitte legen Sie welche in den Einstellungen an.",
  "No chargeback": "keine Rücklastschrift",
  "No chip detected. Please present the chip to the reader again.": "kein Chip erkannt. Bitte den Chip erneut an den Leser halten.",
  "No column settings available": "keine Spalten-Einstellungen vorhanden",
  "No content to export": "kein Inhalt zum Exportieren",
  "No content.": "kein Inhalt.",
  "No contract blocks in package.": "keine Vertragsbausteine im Paket.",
  "No contract blocks in this package.": "keine Vertragsbausteine im Paket.",
  "No contributions found for selected months.": "keine Beiträge für die ausgewählten Monate gefunden.",
  "No editable holidays in this scope.": "keine änderbaren Feiertage in diesem Bereich.",
  "No email address on file.": "keine E-Mail-Adresse hinterlegt.",
  "No entries yet.": "Noch keine Einträge.",
  "No events yet.": "Noch keine Ereignisse.",
  "no ext.": "ohne Verl.",
  "No fee": "keine Gebühr",
  "No flags available": "keine Flags verfügbar",
  "No groups available": "keine Gruppen verfügbar",
  "No history available.": "keine Historie verfügbar.",
  "No notes yet": "noch keine Notizen",
  "No holidays for this location yet. Global holidays are managed in the Admin area.": "Noch keine Feiertage für diesen Standort. Globale Feiertage werden im Admin-Bereich verwaltet.",
  "Holidays list empty hint": "Land und Bundesland oben legen den Feiertagskalender fest. Eigene Feiertage sind optional – Sie können bei Bedarf welche hinzufügen.",
  "No image": "kein Bild",
  "No items found": "keine Positionen gefunden",
  "No letter sending integration configured. Please configure an integration in settings.": "keine Briefversand-Schnittstelle konfiguriert. Bitte konfigurieren Sie eine Schnittstelle in den Einstellungen.",
  "No logs to copy": "keine Protokolleinträge zum Kopieren",
  "No matches": "keine Treffer",
  "No next phase configured (end phase).": "keine nächste Phase konfiguriert (Endphase).",
  "No one checked in yet.": "Noch niemand eingecheckt.",
  "No open items found for installment plan. Installments are only available for open items (not contributions).": "keine offenen Posten für Ratenzahlung gefunden.",
  "No open items found for installment plan.": "keine offenen Posten für Ratenzahlung gefunden.",
  "No open items found.": "keine offenen Positionen gefunden.",
  "No password to copy.": "kein Passwort zum Kopieren.",
  "No payments": "keine Zahlungen",
  "No permission": "keine Berechtigung",
  "PermissionDenied": "keine Berechtigung",
  "InvoiceLogoFileRequired": "Bitte eine Bilddatei auswählen",
  "InvoiceLogoNotFound": "Es ist kein Logo hinterlegt",
  "InvoiceLogoSizeInvalid": "Das Logo darf höchstens 5 MB groß sein",
  "InvoiceLogoFormatInvalid": "Als Logo sind PNG, JPEG und WebP zulässig",
  "InvoiceLogoKeyInvalid": "Das Logo wurde zwischenzeitlich geändert; bitte die Seite neu laden",
  "InvoiceDesignInvalid": "Das Rechnungsdesign enthält unzulässige Werte",
  "InvoicePreviewInvalid": "Für die Vorschau fehlen Angaben des Rechnungsstellers",
  "PriceAdjustmentManualFieldsRequired": "Für eine manuelle Preisanpassung sind Bezeichnung, Typ, Wert und Zyklus erforderlich",
  "IntegrationTypeRequired": "IntegrationType ist erforderlich",
  "DisplayNameRequired": "Anzeigename ist erforderlich",
  "DisplayNameMaxLength": "Anzeigename darf höchstens 255 Zeichen haben",
  "BaseUrlMaxLength": "Base-URL darf höchstens 500 Zeichen haben",
  "UnknownIntegrationType": "Unbekannter IntegrationType",
  "IntegrationTypeNotAllowed": "Dieser Schnittstellentyp ist für den Mandanten nicht freigeschaltet",
  "IntegrationConfigInvalid": "Die Konfiguration ist ungültig. Bitte überprüfen Sie alle Felder",
  "InvalidCapability": "ungültige Capability",
  "CapabilityDisabled": "Dieses Modul ist nicht freigeschaltet. Bestehende Daten können weiterhin angesehen, aber nicht geändert werden.",
  "BalanceRetrievalFailed": "Guthaben konnte nicht abgerufen werden",
  "Request entity too large": "Die Datei ist zu groß (Upload-Limit). Bitte eine kleinere Datei verwenden oder das Limit beim Server/Proxy erhöhen (z. B. nginx client_max_body_size).",
  "Server returned error page": "Der Server hat eine Fehlerseite zurückgegeben. Bitte später erneut versuchen.",
  "PersonHasNoEmail": "Das Dokument wurde erzeugt und abgelegt, konnte aber nicht per E-Mail zugestellt werden: Die Person hat keine E-Mail-Adresse.",
  "StudioAccessDenied": "kein Zugriff auf das gewählte Studio.",
  "AdminOnly": "Nur für Administratoren.",
  "No permission (CompanyAdmin)": "keine Berechtigung (CompanyAdmin)",
  "No permission to book outside availability.": "Keine Berechtigung, Termine außerhalb der Verfügbarkeit zu buchen.",
  "No permission to create appointments.": "keine Berechtigung zum Anlegen von Terminen.",
  "No permission to book over capacity.": "Keine Berechtigung, Termine trotz Überschneidung oder fehlender Kapazität zu buchen.",
  "No permissions": "keine Rechte",
  "No permissions available": "keine Berechtigungen verfügbar",
  "No person selected.": "keine Person ausgewählt.",
  "No phases yet. Click „Add phase“.": "Noch keine Phasen. Klicken Sie auf „Phase anlegen“.",
  "No pipelines yet.": "Noch keine Phasenmodelle.",
  "Document file not found.": "Die Datei wurde nicht gefunden.",
  "Document preview could not be loaded.": "Die Dokumentvorschau konnte nicht geladen werden.",
  "No preview available for this file type.": "keine Vorschau verfügbar für diesen Dateityp.",
  "PDF preview could not be loaded.": "Die PDF-Vorschau konnte nicht geladen werden.",
  "PDF reset zoom": "PDF-Zoom zurücksetzen",
  "PDF optimal zoom": "optimal",
  "PDF zoom in": "PDF vergrößern",
  "PDF zoom out": "PDF verkleinern",
  "Preview reset zoom": "Vorschau-Zoom zurücksetzen",
  "Preview zoom in": "Vorschau vergrößern",
  "Preview zoom out": "Vorschau verkleinern",
  "No protocol for this automation type": "Für diese Automatisierungsart gibt es kein Protokoll.",
  "No recipients added. Click 'Add person' or 'Add email address'.": "keine Empfänger hinzugefügt. Klicken Sie auf 'Person hinzufügen' oder 'E-Mail-Adresse hinzufügen'.",
  "No recipients found": "keine Empfänger gefunden",
  "No resource available": "keine Ressource verfügbar",
  "No resource is available at this time (or no availability entered). Create appointment anyway?": "In dieser Zeit ist keine Ressource verfügbar (oder keine Verfügbarkeit eingetragen). Trotzdem Termin anlegen?",
  "No resource is available at this time.": "In dieser Zeit ist keine Ressource verfügbar.",
  "No resources are set up or no availability has been entered. Create appointment anyway?": "Es sind keine Ressourcen angelegt oder keine Verfügbarkeit eingetragen. Trotzdem Termin anlegen?",
  "No resources available.": "keine Ressourcen vorhanden.",
  "No resources available. Please create resources in settings.": "keine Ressourcen verfügbar. Bitte legen Sie Ressourcen in den Einstellungen an.",
  "No resources created": "keine Ressourcen angelegt",
  "No resources in calendar": "keine Ressourcen im Kalender",
  "No response from server": "keine Antwort vom Server erhalten",
  "No results.": "keine Treffer.",
  "No selection = for all studios": "keine Auswahl = für alle Studios",
  "No slots": "keine Slots",
  "No slots defined yet": "Noch keine Slots definiert",
  "No sub-contracts": "keine Unterverträge",
  "No sub-devices synced yet": "Noch keine Untergeräte synchronisiert",
  "No default template selected": "keine Standardvorlage ausgewählt",
  "No templates available": "keine Vorlagen vorhanden",
  "No valid link. Please request a new reset link.": "kein gültiger Link. Bitte fordern Sie einen neuen Link zum Zurücksetzen an.",
  "No-show": "nicht erschienen",
  "No-Show Count": "Anzahl No-Shows",
  "No-Show Rate": "No-Show Rate",
  "None (global settings)": "keine (globale Einstellungen)",
  "None__alt1": "keine",
  "None__alt2": "Nichts",
  "not allowed": "nicht erlaubt",
  "Not available": "nicht verfügbar",
  "Not Found": "nicht gefunden",
  "This booking code does not exist.": "Dieser Buchungscode existiert nicht.",
  "Booking form unavailable title": "Terminbuchung nicht verfügbar",
  "Booking widget: week from": "Woche vom",
  "Booking widget: date range separator": " bis ",
  "Booking form unavailable message": "Dieses Buchungsformular ist nicht verfügbar. Bitte wende dich direkt an den Sportclub.",
  "Booking form load failed title": "Terminbuchung konnte nicht geladen werden",
  "Booking form load failed message": "Bitte lade das Formular erneut.",
  "Not found": "nicht gefunden",
  "Not implemented yet": "Noch nicht implementiert",
  "Not interested": "kein Interesse",
  "Not reached": "nicht erreicht",
  "Not required (registered)": "nicht erforderlich (registriert)",
  "Not set": "nicht gesetzt",
  "not set": "nicht gesetzt",
  "Note (optional)": "Notiz",
  "Contract package note": "Notiz zum Vertragspaket",
  "Contract package note (optional)": "Notiz zum Vertragspaket",
  "Note: At least one embedded image could not be converted server-side to a browser-friendly format (e.g. EMF/WMF).": "Hinweis: Mindestens ein eingebettetes Bild konnte serverseitig nicht in ein Browser-Format konvertiert werden (z. B. EMF/WMF).",
  "Note: You can set a monthly fee and/or weekly dues. If both are empty, the rest period is free.": "Hinweis: Monatliche Pauschale und/oder Wochenbeiträge können angegeben werden. Wenn beides leer ist, ist die Ruhezeit kostenlos.",
  "Note": "Notiz",
  "Note__alt1": "Hinweis",
  "Notes__alt1": "Hinweise",
  "Notifications": "Benachrichtigungen",
  "Appointment notification template": "Vorlage für Termin-Benachrichtigungen",
  "Nth weekday of month (e.g. 1st Monday)": "n-ter Wochentag im Monat (z. B. 1. Montag)",
  "Number format (Locale)": "Zahlenformat (Locale)",
  "Number must be > 0": "Anzahl muss > 0 sein",
  "Number of contracts for multiple transactions": "Anzahl der Verträge bei mehreren Buchungen",
  "Number of contributions": "Anzahl Beiträge",
  "Number of dues (optional)": "Anzahl Beiträge",
  "Number of dues must be >= 0": "Anzahl Beiträge muss >= 0 sein",
  "Number of emails sent per batch (1-500). Default: 10": "Anzahl der E-Mails, die pro Batch versendet werden (1-500). Standard: 10",
  "Number of fees": "Anzahl Beiträge",
  "Number of fees is required": "Anzahl Beiträge ist erforderlich",
  "Number of installments": "Anzahl Raten",
  "Number of installments__alt2": "Ratenanzahl",
  "Number of recipients": "Anzahl Empfänger",
  "Number of weekly dues (optional)": "Anzahl Wochenbeiträge",
  "of": "von",
  "of month": "des Monats",
  "in month": "im Monat",
  "of month__alt2": "im Monat",
  "Offline": "Offline",
  "Offset (days)": "Zeitversatz (Tage)",
  "OK": "OK",
  "Oldest Entry": "Ältester Eintrag",
  "Once": "einmalig",
  "One or more selected studios are already in another entry. Each studio may only have one entry. Please choose different studios or edit the existing entry.": "Ein oder mehrere gewählte Studios sind bereits in einem anderen Eintrag. Jedes Studio darf nur einen Eintrag haben. Bitte andere Studios wählen oder den bestehenden Eintrag bearbeiten.",
  "One or more studios are already assigned in another entry.": "Ein oder mehrere Studios sind bereits in einem anderen Eintrag vergeben.",
  "One-time": "einmalig",
  "Online": "Online",
  "Online booking created": "Online-Buchung erstellt",
  "Online booking deleted": "Online-Buchung gelöscht",
  "Online booking saved": "Online-Buchung gespeichert",
  "Online bookings": "Online-Buchungen",
  "Online lead": "Online-Kontakt",
  "Online leads": "Online-Kontakte",
  "Preset name": "Vorlagen-Name",
  "Reader device status offline": "offline",
  "Reader device status online": "online",
  "Online login cannot be disabled for the primary account": "Online-Login kann für den primären Account nicht deaktiviert werden",
  "Online payments via PayPal": "Online-Zahlungen via PayPal",
  "Only add history entry (no status/phase change)": "Nur Historie-Eintrag (keine Status/Phase-Änderung)",
  "Only company administrators can edit priceAdjustments.": "Nur Firmen-Administratoren können Preisanpassungen bearbeiten.",
  "Only company administrators can edit price adjustments.": "Nur Firmen-Administratoren können Preisanpassungen bearbeiten.",
  "Only company administrators can edit payment plans.": "Nur Firmen-Administratoren können Zahlungspläne bearbeiten.",
  "Only CompanyAdmin can edit categories.": "Nur Firmen-Administrator kann Kategorien bearbeiten.",
  "Only CompanyAdmin can edit payment methods.": "Nur Firmen-Administrator kann Zahlungsarten bearbeiten.",
  "Only CompanyAdmin can edit rest period templates.": "Nur Firmen-Administrator kann Ruhezeitmodelle bearbeiten.",
  "Only lowercase letters, digits and hyphens": "Nur Kleinbuchstaben, Ziffern und Bindestriche",
  "Only one source allowed": "Nur eine Quelle erlaubt",
  "Only these appointment types are bookable in this online booking.": "Nur diese Terminarten sind in dieser Online-Buchung buchbar.",
  "open": "offen",
  "Open amount__detail": "offener Betrag",
  "Open Contributions": "offene Beiträge",
  "Open Design Editor": "Design-Editor öffnen",
  "Open details": "Details öffnen",
  "Open appointment": "zum Termin",
  "Open door": "Tür öffnen",
  "Open in person management": "in Personenverwaltung öffnen",
  "Open item": "offener Posten",
  "Open items": "offene Posten",
  "Open Items": "offene Posten",
  "Open items (overdue)": "offene Posten (mahnfällig)",
  "Open items payment multiple persons": "Es können nur Posten einer Person gleichzeitig bezahlt werden. Bitte die Auswahl anpassen.",
  "Open items payment no payable rows in selection": "Von den ausgewählten Posten kann keiner für eine Zahlung verwendet werden (z. B. bereits SEPA-Einzug oder nicht offen).",
  "Open items payment requires flat list": "Zahlung erfassen ist in dieser Ansicht nur ohne Kundengruppierung möglich.",
  "Open items payment select payable rows first": "Bitte mindestens einen zahlbaren Posten in der Liste auswählen.",
  "Open items debt collection marker column": "Mahnwesen",
  "Open items in debt collection filter": "im Mahnwesen",
  "Open items reminder level status": "Mahnstufe",
  "Open items column paid": "bezahlt",
  "Open items column open": "offen",
  "Open person file": "Karteiblatt öffnen",
  "Open test: max wait time (seconds)": "Open-Test: maximale Wartezeit (Sekunden)",
  "Open test: polling interval (ms)": "Open-Test: Polling-Intervall (ms)",
  "Open": "öffnen",
  "Open (status)": "offen",
  "Open item status debt collected": "Inkasso",
  "Open item status open": "offen",
  "Open item status paid": "bezahlt",
  "Open item status cancelled": "storniert",
  "openItems.cancel.button": "stornieren",
  "openItems.cancel.title": "Posten stornieren",
  "openItems.cancel.confirm": "stornieren",
  "openItems.cancel.reasonLabel": "Stornogrund",
  "openItems.cancel.hintPaid": "Da der Posten bereits bezahlt ist, wird der Stornobetrag als Wallet-Guthaben gebucht.",
  "openItems.cancel.hintOpen": "Der offene Posten und ggf. zugehörige Forderungen werden auf storniert gesetzt.",
  "openItems.cancel.successWithWallet": "Storno gebucht. {0} als Guthaben auf dem Wertekonto erfasst.",
  "openItems.cancel.successWithoutWallet": "Storno gebucht.",
  "openItems.cancel.error": "Storno fehlgeschlagen: {0}",
  "Contribution calendar status pending": "ausstehend",
  "Contribution calendar status due": "fällig",
  "Contribution calendar status overdue": "mahnfällig",
  "Contribution calendar status reserved": "vorgemerkt",
  "Contribution calendar status debt collection": "Inkasso",
  "Payment method sepa": "SEPA-Lastschrift",
  "Payment method transfer": "Überweisung",
  "Payment method cash": "Bar",
  "Payment method card": "Kartenzahlung",
  "Payment method voucher": "Gutschein",
  "Payment method paypal": "PayPal",
  "Payment method debt collection": "Inkasso",
  "Payment method standing order": "Dauerauftrag",
  "Payment method other": "Sonstige",
  "Open__alt1": "offen",
  "optional": "optional",
  "Optional": "optional",
  "Optional description": "optionale Beschreibung",
  "Optional note or description for the document": "optionale Notiz oder Beschreibung zum Dokument",
  "Optional properties of this payment method": "optionale Eigenschaften dieser Zahlungsart",
  "Optional, e.g. „Automation: Inactive“": "optional, z. B. „Automatik: inaktiv“",
  "Optional: Amount per month during the rest period. If flat fee and number of dues are empty, the rest period is free.": "Optional: Betrag pro Monat während der Ruhezeit. Wenn Pauschale und Anzahl Beiträge leer sind, ist die Ruhezeit kostenlos.",
  "Optional: Cancellation model used as default for this contract package.": "Optional: Kündigungsmodell, das für dieses Vertragspaket als Standard verwendet wird.",
  "Optional: Custom name (e.g. 'Entrance'). If empty, 'QR1' will be used.": "Optional: Benutzerdefinierter Name (z. B. 'Eingang'). Falls leer, wird 'QR1' verwendet.",
  "Optional: Custom name (e.g. 'Exit'). If empty, 'QR2' will be used.": "Optional: Benutzerdefinierter Name (z. B. 'Ausgang'). Falls leer, wird 'QR2' verwendet.",
  "Optional: English description": "Optional: englische Beschreibung",
  "Optional: Link a user from the system": "Optional: Benutzer aus dem System verknüpfen",
  "Optional: Number of dues during the rest period. If flat fee and number of dues are empty, the rest period is free.": "Optional: Anzahl der Beiträge in der Ruhezeit. Wenn Pauschale und Anzahl Beiträge leer sind, ist die Ruhezeit kostenlos.",
  "Optional: Reference or note": "Optional: Referenz oder Notiz",
  "Options": "Optionen",
  "Orange": "Orange",
  "Order": "Reihenfolge",
  "Order saved": "Reihenfolge gespeichert",
  "Organization & Users": "Organisation & Benutzer",
  "Other__alt1": "divers",
  "Other__alt2": "Sonstiges",
  "Other payment methods": "Sonstige Zahlungsarten",
  "Outbox": "Postausgang",
  "Outbound tab system queue": "System-Ausgang",
  "Outcome": "Ergebnis",
  "Overdue": "überfällig",
  "Overdue Amount": "überfälliger Betrag",
  "Overdue Items": "überfällige Posten",
  "overdue only": "nur mahnfällige",
  "Open items search placeholder": "Person oder Beschreibung suchen…",
  "Overdue open items (subject to reminders)": "mahnfällige offene Posten",
  "Overlap or insufficient availability": "Überschneidung oder keine ausreichende Verfügbarkeit",
  "Overview": "Übersicht",
  "Overwrite": "überschreiben",
  "Package": "Paket",
  "Paid": "bezahlt",
  "Paid (status)": "bezahlt",
  "Paid__alt1": "beglichen",
  "pain version": "pain-Version",
  "pain version (XML)": "pain-Version (XML)",
  "pain version required": "pain-Version erforderlich",
  "Partial cancellation": "Teilstorno",
  "Partial cancellation is not yet supported. Full cancellation will be performed.": "Teilstorno wird noch nicht unterstützt. Vollständige Stornierung wird durchgeführt.",
  "Partially paid": "teilweise bezahlt",
  "Participants": "Teilnehmer",
  "Password": "Passwort",
  "Password (optional)": "Passwort",
  "Password changed": "Passwort geändert",
  "Password copied to clipboard.": "Passwort in die Zwischenablage kopiert.",
  "Password is required": "Passwort ist erforderlich",
  "Password remains unchanged (leave empty)": "Passwort bleibt unverändert (leer lassen)",
  "Password reset": "Passwort zurücksetzen",
  "OTP login": "OTP-Login",
  "OTP code (6 digits)": "OTP-Code (6 Ziffern)",
  "Password too short (min. 8)": "Passwort zu kurz (min. 8)",
  "Password will be cleared when saving.": "Passwort wird beim Speichern gelöscht.",
  "Passwords": "Passwörter",
  "Passwords do not match": "Passwörter stimmen nicht überein",
  "Path": "Pfad",
  "Pattern": "Muster",
  "Pattern for mandate references (e.g. MU-{LN12}-{ID8}).": "Pattern für Mandatsreferenzen (z. B. MU-{LN12}-{ID8}).",
  "Pattern is required": "Pattern ist erforderlich",
  "Paused": "pausiert",
  "Pay contributions": "Beiträge bezahlen",
  "Payment": "Zahlung",
  "Payment amount": "Zahlbetrag",
  "Payment cancellation reason created": "Zahlungsstornogrund angelegt",
  "Payment cancellation reason deleted": "Zahlungsstornogrund gelöscht",
  "Payment cancellation reason updated": "Zahlungsstornogrund aktualisiert",
  "Payment cancellation reasons": "Zahlungsstornogründe",
  "Payment cancelled.": "Zahlung storniert.",
  "Payment cycle": "Zahlungszyklus",
  "Payment cycle is missing for the primary tariff block.": "Zahlungszyklus fehlt beim primären Vertragsbaustein.",
  "Payment date": "Zahlungsdatum",
  "Payment date is required": "Zahlungsdatum ist erforderlich",
  "Payment date must not be in the future": "Zahlungsdatum darf nicht in der Zukunft liegen",
  "Payment cancellation date": "Stornodatum",
  "Payment cancellation date is required": "Stornodatum ist erforderlich",
  "Payment cancellation date must not be in the future": "Stornodatum darf nicht in der Zukunft liegen",
  "Booking date must not be in the future": "Tatsächliches Ausführungsdatum darf nicht in der Zukunft liegen",
  "Actual execution date must not be in the future": "Tatsächliches Ausführungsdatum darf nicht in der Zukunft liegen",
  "Payment Deadline (Days)": "Zahlungsfrist (Tage)",
  "Payment for multiple contributions": "Zahlung für mehrere Beiträge",
  "Payment method": "Zahlungsart",
  "Payment Method": "Zahlungsart",
  "Payment method deleted.": "Zahlungsart gelöscht.",
  "Payment method for overpayment": "Zahlungsart für Überzahlung",
  "Payment method is required": "Zahlungsart ist erforderlich",
  "Payment method type is required": "Zahlungsart-Typ ist erforderlich",
  "Payment method saved.": "Zahlungsart gespeichert.",
  "Payment method drawer info title": "Zahlungsart bearbeiten",
  "Payment method drawer info description": "Legen Sie einen Namen fest und ordnen Sie die passende Zahlungsart (SEPA, Bar, Karte usw.) zu. Pro Typ ist nur eine Definition erlaubt.",
  "Payment methods can no longer be created manually.": "Zahlungsarten können nicht mehr manuell erstellt werden.",
  "payment paused": "Beitrag pausiert",
  "Payment plan": "Ratenzahlungsmodell",
  "Payment plan not found": "Ratenzahlungsmodell nicht gefunden",
  "Payment plans": "Zahlungspläne",
  "Payment recorded.": "Zahlung erfasst.",
  "Payment saved.": "Zahlung gespeichert.",
  "Payment type": "Zahlungsart",
  "Payment(s) recorded.": "Zahlung(en) erfasst.",
  "Payment amount must not exceed the outstanding amount.": "Der Zahlungsbetrag darf den offenen Betrag nicht überschreiten.",
  "The payment amount could not be fully allocated. Select more items or transfer the overpayment to a credit wallet.": "Der Zahlbetrag konnte nicht vollständig zugeordnet werden. Wählen Sie weitere Posten aus oder übertragen Sie die Überzahlung auf ein Guthabenkonto.",
  "Payments": "Zahlungen",
  "Payments & Billing": "Zahlungen & Abrechnung",
  "Payments recorded.": "Zahlungen erfasst.",
  "PayPal": "PayPal",
  "Pay…": "bezahlen…",
  "PDF (compact)": "PDF (kompakt)",
  "PDF (detailed)": "PDF (detailliert)",
  "Peak Day": "Peak-Tag",
  "Peak Hour": "Peak-Stunde",
  "Peak Time": "Peak-Zeit",
  "Peak Times (Weekday × Hour)": "Peak-Zeiten (Wochentag × Stunde)",
  "Pending": "ausstehend",
  "pending": "ausstehend",
  "People": "Personen",
  "Person deleted.": "Person gelöscht.",
  "per day": "pro Tag",
  "per month": "pro Monat",
  "Per studio, exactly one default template can be set per channel.": "Pro Studio kann je Kanal genau eine Standardvorlage gesetzt werden.",
  "per week": "pro Woche",
  "per year": "pro Jahr",
  "Percent": "Prozent",
  "Percent of total": "Prozent vom Gesamtbetrag",
  "Percentage priceAdjustment cannot exceed 100%": "Prozentualer Abzug darf nicht über 100 % liegen",
  "Percentage reduction cannot exceed 100%": "Prozentualer Abzug darf nicht über 100 % liegen",
  "Percentage": "Prozent",
  "Public (online)": "öffentlich (online)",
  "Internal (at the counter)": "intern (am Tresen)",
  "Both": "beides",
  "Delivery": "Zustellung",
  "No signing profile is enabled for internal use.": "Kein Abschlussformular ist für den internen Abschluss freigegeben.",
  "Set a profile's channel to internal or both in the settings.": "Setze in den Einstellungen den Kanal eines Formulars auf intern oder beides.",
  "I want to start training before the withdrawal period ends and understand that my right of withdrawal expires once the service has been fully provided.": "Ich möchte schon vor Ablauf der Widerrufsfrist mit dem Training beginnen und weiß, dass mein Widerrufsrecht mit der vollständigen Leistungserbringung erlischt.",
  "Please agree to starting before the withdrawal period ends.": "Bitte dem vorzeitigen Trainingsbeginn zustimmen.",
  "Withdrawal period until": "Widerrufsfrist bis",
  "Offer as tariff feature when signing": "beim Abschluss als Tarifmerkmal anbieten",
  "Proof required": "Nachweis erforderlich",
  "Proof validity (months)": "Gültigkeit des Nachweises (Monate)",
  "Proof validity is required": "Bitte eine Gültigkeitsdauer angeben, sonst entsteht keine Wiedervorlage",
  "Tariff features": "Tarifmerkmale",
  "A tariff feature is a permanent tariff based on a personal attribute — not a time-limited promotion.": "Ein Tarifmerkmal ist ein dauerhafter Tarif aufgrund eines Personenmerkmals — keine befristete Aktion.",
  "Right of withdrawal": "Widerrufsrecht",
  "Withdrawal policy": "Widerrufsbelehrung",
  "Sample withdrawal form": "Muster-Widerrufsformular",
  "Required for public online signing. Place it in the contract document template where it should appear.": "Für den öffentlichen Online-Abschluss erforderlich. Im Vertragsdokument dort einsetzen, wo sie erscheinen soll.",
  "Close contract (new)": "Vertrag abschließen",
  "New signing engine — runs in parallel with the existing wizard": "Erlebnisformular zum Vertragsabschluss",
  "Sales promotions permission help": "Verkaufsaktionen anlegen und pflegen. Sie werden in den Abschlussformularen einem Angebot zugeordnet.",
  "Option groups permission help": "Zusatzangebote (Zubuchoptionen und Bündel) anlegen und pflegen.",
  "Tariff feature proofs": "Tarifmerkmal-Nachweise",
  "Proofs that expired or expire soon": "Nachweise, die abgelaufen sind oder demnächst ablaufen",
  "Expiring soon": "läuft bald ab",
  "Sales promotion": "Verkaufsaktion",
  "Offer": "Angebot",
  "Add offer": "Angebot hinzufügen",
  "An offer combines a contract package with an optional promotion and add-on options. The same package can appear several times with different promotions.": "Ein Angebot verbindet ein Vertragspaket mit einer optionalen Aktion und Zusatzangeboten. Dasselbe Paket kann mehrfach mit unterschiedlichen Aktionen erscheinen.",
  "Sales promotions": "Verkaufsaktionen",
  "Sales models": "Verkaufsmodelle",
  "Sales model": "Verkaufsmodell",
  "Sales model term": "Laufzeit des Verkaufsmodells",
  "Sales models permission help": "Erlaubt das Anzeigen oder Bearbeiten regulärer Laufzeit- und Preisvarianten von Vertragspaketen.",
  "Select sales model": "Verkaufsmodell auswählen",
  "Select at least one sales model": "Mindestens ein Verkaufsmodell auswählen",
  "Base package": "Basispaket",
  "Specific service bundle": "bestimmtes Leistungsbündel",
  "Entire selection": "gesamte Auswahl",
  "Regular term and price variants of a contract package": "Reguläre Laufzeit- und Preisvarianten eines Vertragspakets",
  "New sales model": "neues Verkaufsmodell",
  "Create sales model": "Verkaufsmodell anlegen",
  "Edit sales model": "Verkaufsmodell bearbeiten",
  "Delete sales model": "Verkaufsmodell löschen",
  "Sellability": "Verkaufbarkeit",
  "Sellable": "verkaufbar",
  "Sales model has conflicts": "Verkaufsmodell hat Konflikte",
  "Contract signing: selection": "Auswahl prüfen",
  "Sales model conflict: modelInactive": "Das Verkaufsmodell ist deaktiviert.",
  "Sales model conflict: packageInactive": "Das Vertragspaket ist nicht mehr aktiv.",
  "Sales model conflict: termInactive": "Die Laufzeit ist nicht mehr aktiv.",
  "Sales model conflict: studioScopeConflict": "Die Studiofreigaben der Abhängigkeiten decken das Verkaufsmodell nicht vollständig ab.",
  "Sales model conflict: componentConflict": "Die Paketbausteine oder ihre Konditionen passen nicht mehr zum Verkaufsmodell.",
  "Sales model conflict: paymentPlanConflict": "Mindestens ein Zahlungsplan ist nicht mehr zulässig oder aktiv.",
  "Sales model conflict: bundleConflict": "Mindestens ein Leistungsbündel ist nicht mehr kompatibel oder aktiv.",
  "Sales model conflict: pricingCycleConflict": "Ein Bündelpreis kann wegen unterschiedlicher Zahlungszyklen nicht eindeutig verteilt werden.",
  "Service bundles": "Leistungsbündel",
  "Service bundle revenue": "Bündelumsatz",
  "Service bundle benefit": "Bündelvorteil",
  "Sales promotion effects": "Wirkung der Verkaufsaktionen",
  "Signing form": "Erlebnisformular",
  "Signing channel": "Abschlussart",
  "Component conditions": "Bausteinkonditionen",
  "Regular price": "regulärer Preis",
  "Cycle value": "Zykluswert",
  "Cycle unit": "Zykluseinheit",
  "Lifetime rule": "Laufzeitregel",
  "Follows sales model": "folgt dem Verkaufsmodell",
  "Own duration": "eigene Dauer",
  "Allowed payment plans": "zulässige Zahlungspläne",
  "Default payment plan": "Standardzahlungsplan",
  "Available service bundles": "verfügbare Leistungsbündel",
  "Service bundle": "Leistungsbündel",
  "Included": "enthalten",
  "Bundle price override": "abweichender Bündelpreis",
  "Service start": "Leistungsbeginn",
  "Training start": "Trainingsbeginn",
  "Weeks": "Wochen",
  "Years": "Jahre",
  "Time-limited offers applied when a contract is signed": "Befristete Angebote, die beim Vertragsabschluss greifen",
  "New sales promotion": "neue Verkaufsaktion",
  "Create sales promotion": "neue Verkaufsaktion",
  "Edit sales promotion": "Verkaufsaktion",
  "Delete sales promotion": "Verkaufsaktion löschen",
  "Free period": "Gratis-Zeitraum",
  "Free period mode": "Art des Gratis-Zeitraums",
  "Free period as duration": "als Dauer",
  "Fixed contract start": "fester Vertragsbeginn",
  "Round contract start": "Vertragsbeginn runden",
  "No rounding": "nicht runden",
  "Next first of month": "nächster Monatserster",
  "Price benefit": "Preisvorteil",
  "Benefit duration": "Dauer des Vorteils",
  "Benefit starts": "Vorteil ab",
  "From contract start": "ab Vertragsbeginn",
  "From training start": "ab Trainingsbeginn",
  "Sales window": "Verkaufsfenster",
  "Sellable from": "verkaufbar ab",
  "Sellable until": "verkaufbar bis",
  "Maximum redemptions": "maximale Einlösungen",
  "Redemptions": "Einlösungen",
  "Promotion code": "Aktionscode",
  "Code required": "Code erforderlich",
  "The promotion only appears after the code has been entered.": "Die Aktion erscheint erst nach Eingabe des Codes.",
  "Presentation": "Darstellung",
  "Public title": "öffentlicher Titel",
  "Public subtitle": "öffentlicher Untertitel",
  "Badge text": "Badge-Text",
  "Public description": "öffentliche Beschreibung",
  "Charge setup fee at training start": "Aufnahmegebühr zum Trainingsbeginn",
  "Cancellable during free period": "Kündigung in der Gratiszeit möglich",
  "Restore quota on revocation": "Kontingent bei Widerruf zurückbuchen",
  "Combinable with other discounts": "mit anderen Rabatten kombinierbar",
  "Effect": "Wirkung",
  "Contribution-free start": "beitragsfreie Startphase",
  "Early service start": "vorgezogener Leistungsbeginn",
  "Reduced price": "reduzierter Preis",
  "Early start and reduced price": "vorgezogener Leistungsbeginn mit Preisvorteil",
  "Early service start mode": "Art des vorgezogenen Leistungsbeginns",
  "Select an effect": "Bitte eine Wirkung wählen.",
  "No effect selected": "Noch keine Wirkung gewählt.",
  "Action summary": "Zusammenfassung der Aktion",
  "Training immediately, contract from {0}": "Training sofort, Vertragsbeginn am {0}",
  "Training immediately, contract starts after {0} {1}": "Training sofort, Vertragsbeginn nach {0} {1}",
  "First {0} {1} contribution-free": "Die ersten {0} {1} beitragsfrei",
  "Reduced price: {0} for {1} {2}": "Preisvorteil {0} für {1} {2}",
  "Only redeemable with a promotion code": "nur mit Aktionscode einlösbar",
  "Promotion code is required": "Aktionscode ist erforderlich",
  "Limit the number of redemptions": "Anzahl der Einlösungen begrenzen",
  "Contract from": "Vertrag ab",
  "Option groups": "Leistungsbündel",
  "Option group": "Leistungsbündel",
  "Offer reusable option groups in this contract package — included or bookable on top.": "Wiederverwendbare Zusatzangebote in diesem Vertragspaket anbieten — fest enthalten oder zubuchbar.",
  "No option groups available (Settings → Option groups).": "Keine Zusatzangebote vorhanden (Einstellungen → Zusatzangebote).",
  "Add option group": "Zusatzangebot hinzufügen",
  "Price override": "Preis für dieses Paket",
  "Optional (customer decides)": "zubuchbar (Kunde entscheidet)",
  "Included (not deselectable)": "fest enthalten (nicht abwählbar)",
  "Preselected": "vorausgewählt",
  "A price override replaces the group's quantity tiers.": "Ein eigener Preis ersetzt die Mengenstaffeln der Gruppe.",
  "Add-on options": "Zusatzangebote",
  "Included in the package": "im Paket enthalten",
  "Select at least {0}": "bitte mindestens {0} wählen",
  "Select at most {0}": "bitte höchstens {0} wählen",
  "instead of {0}": "statt {0}",
  "Book all or nothing": "nur vollständig buchbar",
  "Bundles and add-on options within contract packages": "Bündel und Zusatzangebote innerhalb von Vertragspaketen",
  "New option group": "neues Leistungsbündel",
  "Create option group": "neues Leistungsbündel",
  "Edit option group": "Leistungsbündel",
  "Delete option group": "Leistungsbündel löschen",
  "Bundle (all or nothing)": "Bündel (alles oder nichts)",
  "Choice (n of m)": "Auswahl (n aus m)",
  "Bundle": "Bündel",
  "Choice": "Auswahl",
  "Selection": "Auswahlart",
  "Offer type": "Art des Leistungsbündels",
  "Components": "Bausteine",
  "Select at least one component": "bitte mindestens einen Baustein wählen",
  "Sum of components": "Summe der Bausteine",
  "Total price": "Gesamtpreis",
  "Percentage off": "prozentualer Nachlass",
  "Amount off": "Betrag Nachlass",
  "A total price requires all components to share the same payment cycle.": "Ein Gesamtpreis ist nur möglich, wenn alle Bausteine denselben Zahlungszyklus haben.",
  "Quantity tiers": "Mengenstaffeln",
  "From count": "ab Anzahl",
  "Add tier": "Staffel hinzufügen",
  "Remove tier": "Staffel entfernen",
  "Bundle price": "Bündelpreis",
  "Bundle price type": "Preisart",
  "Fixed price": "Festpreis",
  "Discount in percent": "Nachlass in Prozent",
  "Individual price total": "Summe der Einzelpreise",
  "Permanent bundle advantage": "dauerhafter Bündelvorteil",
  "Minimum": "Mindestens",
  "Maximum": "Höchstens",
  "Target price": "Zielpreis",
  "Target price cannot be negative": "Der Zielpreis darf nicht negativ sein",
  "Price adjustment": "Preisanpassung",
  "Price adjustment is required": "Preisanpassung ist erforderlich",
  "Price adjustment name placeholder": "z. B. Studentenabzug oder jährlicher Zuschlag",
  "Price adjustments": "Preisanpassungen",
  "Percentage__alt1": "Anteil",
  "Percentage__alt3": "Prozentsatz",
  "Fixed amount": "fester Betrag",
  "Fixed amount__fixer-betrag": "fixer Betrag",
  "Period": "Periode",
  "Period range": "Zeitraum",
  "Period__alt1": "Frist",
  "Period__alt2": "Zeitraum",
  "Permissions": "Rechte",
  "Permissions & roles": "Berechtigungen & Rollen",
  "Person": "Person",
  "Person (Employee, Trainer)": "Person (Mitarbeiter, Trainer)",
  "Person added": "Person hinzugefügt",
  "Person created.": "Person angelegt.",
  "Person entities": "Person-Entitäten",
  "Person file": "Kundenblatt",
  "Person locked.": "Person gesperrt.",
  "Person search failed": "Personensuche fehlgeschlagen",
  "Person unlocked.": "Person entsperrt.",
  "Person's name (last name, first name)": "Name der Person (Nachname, Vorname)",
  "Persons": "Personen",
  "Persons & person pools": "Personen & Personengruppen (Pools)",
  "Persons, pools, equipment & rooms": "Personen, Pools, Geräte & Räume",
  "Phase": "Phase",
  "Phase (for new leads)": "Phase (für neue Kontakte)",
  "Phase completed.": "Phase abgeschlossen.",
  "Phase created": "Phase angelegt",
  "Phase deleted": "Phase gelöscht",
  "Delete phase and reset leads warning": "{0} Kontakte werden auf die Startphase zurückgesetzt. Phase trotzdem löschen?",
  "Phase updated": "Phase aktualisiert",
  "Phone": "Telefon",
  "Phone (optional)": "Telefon",
  "Phone or Mobile": "Telefon oder Mobil",
  "Phone or mobile is required": "Bitte geben Sie eine Telefon- oder Mobilnummer an.",
  "Photo saved.": "Foto gespeichert.",
  "PIN, login & studio assignment": "PIN, Login & Studio-Zuordnung",
  "Ping failed": "Ping fehlgeschlagen",
  "Ping successful!": "Ping erfolgreich!",
  "Pipeline": "Pipeline",
  "Pipeline created": "Phasenmodell angelegt",
  "Pipeline deleted": "Phasenmodell gelöscht",
  "Pipeline updated": "Phasenmodell aktualisiert",
  "Pipelines & phases": "Pipelines & Phasen",
  "Plan": "Tarif",
  "Please accept": "Bitte akzeptieren",
  "(Privacy policy text can be configured in settings)": "(Datenschutztext in den Einstellungen hinterlegen)",
  "(Terms can be configured in settings)": "(AGB in den Einstellungen hinterlegen)",
  "Please add at least one recipient.": "Bitte mindestens einen Empfänger hinzufügen.",
  "Please confirm password": "Bitte Passwort bestätigen",
  "Please confirm…": "Bitte bestätigen…",
  "Please enter a name.__alt1": "Bitte einen Namen angeben.",
  "Please enter a name.__alt2": "Bitte einen Namen eingeben.",
  "Please enter a password (for the test).": "Bitte Passwort eingeben (für den Test).",
  "Please enter a password.": "Bitte Passwort eingeben.",
  "Please enter a reason": "Bitte geben Sie einen Grund ein",
  "Please enter an abbreviation.": "Bitte ein Kürzel eingeben.",
  "Please enter an amount": "Bitte geben Sie einen Betrag ein",
  "Please enter an amount.": "Bitte geben Sie einen Betrag an.",
  "Please enter an email address.": "Bitte E-Mail-Adresse eingeben.",
  "Please enter current password": "Bitte aktuelles Passwort eingeben",
  "Please enter Device ID and QR ID": "Bitte geben Sie Device-ID und QR-ID ein",
  "Please enter end time": "Bitte Endzeit eingeben",
  "Please enter host and port.": "Bitte Host und Port eingeben.",
  "Please enter host, port and username.": "Bitte Host, Port und Benutzername eingeben.",
  "Please enter password": "Bitte Passwort eingeben",
  "Please enter sender email.": "Bitte Absender E-Mail eingeben.",
  "Please enter start time": "Bitte Startzeit eingeben",
  "Please enter the number of installments": "Bitte geben Sie die Anzahl der Raten ein",
  "Please enter your abbreviation (as stored in the user profile).": "Bitte Ihr Kürzel eingeben (wie im Benutzerprofil hinterlegt).",
  "Please enter your email/username.": "Bitte E-Mail/Benutzername eingeben.",
  "Please enter your password.": "Bitte Passwort eingeben.",
  "Please fill in both fields before testing the connection.": "Bitte füllen Sie beide Felder aus, bevor Sie die Verbindung testen.",
  "Please fill in Studio, Name, and Manufacturer first before the registration code is generated.": "Bitte füllen Sie zuerst Studio, Name und Hersteller aus, bevor der Registrierungscode generiert wird.",
  "Please fix the following errors:": "Bitte beheben Sie die folgenden Fehler:",
  "Please select": "Bitte wählen",
  "Please select a chargeback reason": "Bitte wählen Sie einen RL-Grund aus",
  "Please select a contract package": "Bitte Vertragspaket wählen",
  "Please select a contract package first to view included items.": "Bitte zuerst ein Vertragspaket wählen, um die enthaltenen Positionen zu sehen.",
  "Please select a contribution handling option.": "Bitte wählen Sie eine Beitragsbehandlung aus.",
  "Please select a customer first.": "Bitte zuerst einen Kunden auswählen.",
  "Please select a customer to continue.": "Bitte einen Kunden auswählen, um fortzufahren.",
  "Please select a handling method": "Bitte wählen Sie eine Behandlung",
  "Please select a handling method for the overpayment.": "Bitte wählen Sie eine Behandlung für die Überzahlung.",
  "Please select a home studio.": "Bitte ein Stammstudio auswählen.",
  "Please select a pain version": "Bitte eine pain-Version auswählen",
  "Please select a payment plan": "Bitte wählen Sie ein Ratenzahlungsmodell aus",
  "Please select a period.": "Bitte wählen Sie einen Zeitraum aus.",
  "Please select a person…": "Bitte Person wählen…",
  "Please select a pipeline first": "Bitte zuerst ein Phasenmodell auswählen",
  "Please select a reader device to manage assignments.": "Bitte wählen Sie ein Lesegerät aus, um die Zuordnungen zu verwalten.",
  "Please select a studio.": "Bitte ein Studio auswählen.",
  "Check-in no studios hint": "Für den Check-in muss mindestens ein Studio eingerichtet sein. Richten Sie zuerst in den Einstellungen ein Studio ein.",
  "Open studio settings": "zu den Studio-Einstellungen",
  "Please select a template": "Bitte Vorlage auswählen",
  "Please select a template first": "Bitte zuerst eine Vorlage auswählen",
  "Please select a template if you want to send a confirmation.": "Bitte wählen Sie eine Vorlage aus, wenn Sie eine Bestätigung versenden möchten.",
  "Please select a type": "Bitte wählen Sie eine Art aus",
  "Please select a user": "Bitte Benutzer auswählen",
  "Please select a wallet product": "Bitte Wertekonto-Produkt wählen",
  "Please select a wallet.": "Bitte wählen Sie ein Wertekonto aus.",
  "Please select an open item": "Bitte wählen Sie einen offenen Posten aus",
  "Please select at least one appointment type.": "Bitte wählen Sie mindestens eine Terminart aus.",
  "Please select a delivery channel.": "Bitte wählen Sie einen Versandkanal aus.",
  "Please select at least one delivery channel.": "Bitte wählen Sie mindestens einen Versandkanal aus.",
  "Please select at least one resource.": "Bitte wählen Sie mindestens eine Ressource aus.",
  "Please select at least one studio.": "Bitte mindestens ein Studio wählen.",
  "Please select at least one payment to cancel.": "Bitte wählen Sie mindestens eine Zahlung zur Stornierung aus.",
  "Select at least one payment above to cancel.": "Bitte wählen Sie oben mindestens eine Zahlung zur Stornierung aus.",
  "Select payments to cancel": "Zahlungen zur Stornierung auswählen",
  "No payments available to cancel.": "keine Zahlungen zum Stornieren vorhanden.",
  "Please select contract package.": "Bitte Vertragspaket wählen.",
  "Please select customer.": "Bitte Kunde wählen.",
  "Please select number of installments.": "Bitte Ratenanzahl wählen.",
  "Please specify target range": "Bitte Ziel-Zeitraum angeben",
  "Please use contract packages (manual adding is currently disabled).": "Bitte Vertragspakete verwenden (manuelles Hinzufügen ist aktuell deaktiviert).",
  "point": "Punkt",
  "Points": "Punkte",
  "Pool Members (Users)": "Pool-Mitglieder (Benutzer)",
  "Port": "Port",
  "Positive": "positiv",
  "Possible duplicate": "mögliche Dublette",
  "Member since": "Mitglied seit",
  "Member care trigger new member": "neues Mitglied",
  "Member care trigger inactive": "keine Besuche",
  "Member care trigger open item": "offener Posten",
  "Member care trigger wallet balance": "Wertekonto fast leer",
  "Member care trigger wallet unused": "Wertekonto ungenutzt",
  "Member care trigger contract start": "Vertragsbeginn",
  "Member care trigger contract end": "Vertragsende",
  "Member care trigger contract cancelled": "Kündigung",
  "Member care trigger rest period end": "Ruhezeit endet",
  "No check-in during rest period": "kein Check-in",
  "Person account tab": "Konto",
  "Person history tab": "Verlauf",
  "Remaining contributions": "noch fällige Beiträge",
  "Cancellation equal contribution summary": "{0} × {1} = {2}",
  "Cancellation mixed contribution summary": "{0} Beiträge, insgesamt {1}",
  "Cancellation no remaining contributions": "{0} – keine Beiträge mehr offen",
  "Cancellation no dropped contributions": "{0} – keine Beiträge entfallen",
  "Dropped contributions": "entfallende Beiträge",
  "Rest period summary fee": "Gebühr: {0}",
  "Rest period summary contributions": "{0} Beiträge",
  "More details": "weitere Angaben",
  "Fewer details": "weniger Angaben",
  "Possible duplicate exists": "mögliche Dublette vorhanden",
  "PossiblePersonDuplicate": "mögliche Dublette",
  "Possible person duplicate help": "Es gibt bereits ähnliche Einträge. Gleiche Nummern kommen vor, zum Beispiel bei Mutter und Kind — bitte prüfen, ob es dieselbe Person ist.",
  "Create anyway": "trotzdem anlegen",
  "Use this person": "diese Person verwenden",
  "Post": "verbuchen",
  "Post direct debit run": "Lastschriftlauf verbuchen",
  "Posting": "wird verbucht",
  "Posting direct debit run": "Lastschriftlauf wird verbucht",
  "Posting failed": "Verbuchung fehlgeschlagen",
  "Posted": "verbucht",
  "Preparing appointment…": "Termin wird vorbereitet…",
  "Present the chip to a m1connect reader. The chip will be assigned to the current person immediately.": "Chip an einen m1connect-Leser halten. Der Chip wird sofort der aktuellen Person zugewiesen.",
  "Present the chip to a m1connect reader. The chip will be assigned to the current user immediately.": "Chip an einen m1connect-Leser halten. Der Chip wird sofort dem aktuellen Benutzer zugewiesen.",
  "Preset created": "Vorlage angelegt",
  "Preset deleted": "Vorlage gelöscht",
  "Preset updated": "Vorlage aktualisiert",
  "Prevents the spooler from sending batches too frequently for the same tenant.": "Verhindert, dass der Spooler zu häufig hintereinander Batches für denselben Tenant sendet.",
  "Preview": "Vorschau",
  "Data": "Daten",
  "Done": "fertig",
  "Preview and adjust design visually": "Design visuell anpassen und Vorschau",
  "Preview booking group": "Buchungsgruppe für Vorschau",
  "Base price": "Basispreis",
  "Price": "Preis",
  "Price editable on sale": "Preis beim Verkauf änderbar",
  "Price changeable on create": "Preis beim Anlegen änderbar",
  "Price changes are disabled for this contract package at closing.": "Für dieses Vertragspaket sind Preisänderungen beim Abschluss deaktiviert.",
  "Price is fixed in contract package.": "Preis ist im Vertragspaket fix.",
  "Price is fixed in the contract package.": "Preis ist im Vertragspaket fix.",
  "Price is missing for the primary tariff block.": "Preis fehlt beim primären Vertragsbaustein.",
  "Price per installment": "Preis pro Rate",
  "Price Settings": "Preis-Einstellungen",
  "Primary": "Primär",
  "Primary Color": "Primärfarbe",
  "Primary color": "Primärfarbe",
  "Primary admin role cannot be changed": "Die Rolle des primären Administrator-Accounts kann nicht geändert werden.",
  "Color buttons and accents": "Schaltflächen, Akzente und Rahmen",
  "Color buttons and accents tooltip": "Farbe für die Schaltflächen „weiter“ und „Buchung abschließen“, Schrittanzeige, Firmenname im Kopfbereich, Rahmen von Karten (Studio/Terminart), Wochen- und Tagesauswahl sowie gewählte Zeitslots.",
  "Color availability indicator": "Verfügbarkeits-Anzeige",
  "Color availability indicator tooltip": "Farbe des Punkts an Tagen, an denen freie Slots verfügbar sind (sonst grau).",
  "Page": "Seite",
  "Page background (outside widget)": "Seiten-Hintergrund (außerhalb der Karte)",
  "General text color": "Standard-Textfarbe (Fallback)",
  "General text color tooltip": "Wird als Fallback für viele Überschriften, Kartentexte und Fließtexte genutzt, sofern ein Bereich keine eigene Farbe hat. Einzelne Bereiche (Header, Schritte, Karten usw.) können eigene Farben haben.",
  "Print": "drucken",
  "Print preview": "Druckvorschau",
  "Print preview is only available in letter view": "Druckvorschau ist nur in der Brief-Ansicht verfügbar",
  "Copy first page to following pages": "Erste Seite auf Folgeseiten kopieren",
  "Copy first page to following pages confirmation": "Möchten Sie den Aufbau der ersten Seite auf die Folgeseiten übertragen? Bestehende Bausteine auf den Folgeseiten werden dabei ersetzt.",
  "First page copied to following pages": "Erste Seite auf Folgeseiten kopiert",
  "Reset zoom": "Zoom zurücksetzen",
  "Fit to page": "An Seite anpassen",
  "Remove block confirmation": "Möchten Sie diesen Baustein wirklich aus dem Dokument entfernen?",
  "Format block": "Block gestalten",
  "Labels": "Bezeichnungen",
  "Values": "Werte",
  "Table headings": "Tabellenüberschriften",
  "Table values": "Tabellenwerte",
  "Privacy": "Datenschutz",
  "Privacy Policy": "Datenschutzerklärung",
  "Privacy policy: Text": "Datenschutzerklärung: Text",
  "Privacy policy: URL": "Datenschutzerklärung: URL",
  "Privacy policy text": "Datenschutztext",
  "Terms: Text": "AGB: Text",
  "Terms: URL": "AGB: URL",
  "Terms and conditions text": "AGB-Text",
  "Imprint: Text": "Impressum: Text",
  "Imprint: URL": "Impressum: URL",
  "Imprint text": "Impressumtext",
  "Privacy Policy Text": "Datenschutz-Text",
  "Last version": "letzte Version",
  "Legal texts": "Rechtstexte",
  "Privacy, terms, imprint": "Datenschutz, AGB, Impressum",
  "Privacy, terms, imprint – assign in app, leads, booking, contract signing": "Datenschutz, AGB, Impressum zentral – in App, Kontakten, Buchung, Vertragsabschluss zuweisbar",
  "Use legal texts from settings": "Rechtstexte aus Einstellungen verwenden",
  "None – use fields below": "keine – Felder unten nutzen",
  "Edit legal texts": "Rechtstexte bearbeiten",
  "New legal texts": "neue Rechtstexte",
  "e.g. Standard, Studio Nord": "z. B. Standard, Studio Nord",
  "Privacy Policy URL": "Datenschutz-URL",
  "Proceed with import": "Import trotzdem durchführen",
  "Processing": "in Bearbeitung",
  "Product": "Produkt",
  "Products & Contracts": "Produkte & Verträge",
  "Profile": "Stammdaten",
  "Pronouns": "Pronomen",
  "Proportional Calculation": "Anteilige Berechnung",
  "Proportional Fee": "anteiliger Beitrag",
  "Prorated fee editable": "Anteiliger Beitrag änderbar",
  "Prospect": "Interessent",
  "Prospect female": "Interessentin",
  "Prospects": "Interessenten",
  "Purple": "Violett",
  "QR": "QR",
  "Reverse-QR": "RQR",
  "QR Code 1": "QR-Code 1",
  "QR Code 1 and QR Code 2 must not be identical": "QR-Code 1 und QR-Code 2 dürfen nicht identisch sein",
  "QR Code 2": "QR-Code 2",
  "QR ID": "QR-ID",
  "Queue and sending status": "Warteschlange und Versandstatus",
  "Rate": "Satz",
  "Rate %": "Quote %",
  "Rate is required": "Steuersatz ist erforderlich",
  "Rate must be between 0 and 100": "Steuersatz muss zwischen 0 und 100 liegen",
  "Raw": "Quelltext",
  "Reader": "Lesegerät",
  "Reader device": "Lesegerät",
  "Reader device created.": "Lesegerät angelegt.",
  "Reader device deleted.": "Lesegerät gelöscht.",
  "Reader device saved.": "Lesegerät gespeichert.",
  "Reader devices": "Lesegeräte",
  "Reader devices (with flags)": "Lesegeräte (mit Flags)",
  "Readers": "Leser",
  "Really delete this account?": "Dieses Konto wirklich löschen?",
  "Really delete this configuration?": "Konfiguration wirklich löschen?",
  "Really delete this entry?": "Eintrag wirklich löschen?",
  "Really delete this payment method?": "Diese Zahlungsart wirklich löschen?",
  "Really delete this preset?": "Vorlage wirklich löschen?",
  "Really delete this unavailability reason?": "Abwesenheitsgrund wirklich löschen?",
  "Really delete this unavailability?": "Abwesenheit wirklich löschen?",
  "Really delete this VAT setting?": "Diese USt-Einstellung wirklich löschen?",
  "Really delete this widget?": "Formular wirklich löschen?",
  "Really delete?": "Wirklich löschen?",
  "Studio app config delete hint": "Beim Löschen dieser Konfiguration werden auch alle zugehörigen Bilder (Logo und Slot-Bilder) gelöscht.",
  "Really lock this person? (No access/check-in possible.)": "Person wirklich sperren? (kein Zutritt/Check-in möglich.)",
  "Really unlock this person?": "Person wirklich entsperren?",
  "Reason": "Grund",
  "Classification reason": "Klassifizierungsgrund",
  "Reasons for cancellations": "Gründe für Kündigungen",
  "Reasons for payment cancellations": "Gründe für Zahlungsstornierungen",
  "Reversal reasons": "Stornogründe",
  "Reasons for payment and contribution cancellations": "Gründe für Zahlungs- und Beitragsstornierungen",
  "every {0} {1}": "alle {0} {1}",
  "Used in {0} contract packages": "in {0} Vertragspaketen hinterlegt",
  "Edit model": "Modell bearbeiten",
  "Contract module template usage notice": "In {0} Vertragspaketen hinterlegt – Änderungen gelten für alle Pakete; laufende Verträge behalten ihre Werte.",
  "Contract module template change notice": "Änderungen gelten für alle Vertragspakete mit dieser Vorlage; laufende Verträge behalten ihre Werte.",
  "A change applies to all of these contract packages.": "Eine Änderung gilt für alle diese Vertragspakete.",
  "Rest periods not allowed": "Ruhezeiten nicht erlaubt",
  "Open model": "Modell öffnen",
  "Running sales promotions": "laufende Aktionen",
  "until {0}": "bis {0}",
  "Membership agreement from the contract data, the same for all contract packages": "Mitgliedschaftsvereinbarung aus den Vertragsdaten, für alle Vertragspakete gleich",
  "Sold in contract signing widgets": "verkauft in Vertragsformularen",
  "Not offered in any contract signing widget": "in keinem Vertragsformular angeboten",
  "Effect of signing today": "Wirkung bei Abschluss heute",
  "Effect could not be calculated": "Die Wirkung konnte nicht berechnet werden.",
  "term until {0}": "Laufzeit bis {0}",
  "open-ended": "unbefristet",
  "due once": "einmalig fällig",
  "Total for the initial term": "Gesamtpreis der Erstlaufzeit",
  "Saved state, without sales promotions and optional bookings": "gespeicherter Stand, ohne Aktionen und optionale Zubuchungen",
  "Discard unsaved changes?": "Ungespeicherte Änderungen verwerfen?",
  "The contract package has unsaved changes.": "Das Vertragspaket hat ungespeicherte Änderungen.",
  "Received and agree to privacy information": "Datenschutzinformationen erhalten und zugestimmt",
  "Received at": "Empfangen am",
  "Receiving is disabled.": "Empfang ist deaktiviert.",
  "Recent leads": "neueste Kontakte",
  "Tasks": "Aufgaben",
  "Task": "Aufgabe",
  "Tasks column due at": "fällig am",
  "No tasks": "keine Aufgaben",
  "No new leads": "keine neuen Kontakte",
  "All tasks": "alle Aufgaben",
  "Recent tasks": "neueste Aufgaben",
  "Open tasks": "offene Aufgaben",
  "Contact data change request": "Stammdaten-Änderungswunsch",
  "Adress-/Kontaktdaten-Änderungswunsch": "Adress-/Kontaktdaten-Änderungswunsch",
  "Bankdaten-Änderungswunsch": "Bankdaten-Änderungswunsch",
  "Stammdaten-Änderungswunsch": "Stammdaten-Änderungswunsch",
  "New task": "neue Aufgabe",
  "Manual": "manuell",
  "Google Calendar": "Google Kalender",
  "Google Calendar description": "Aufgaben und Kalender aus Google. Verbinden Sie ein Konto und weisen Sie pro Kalender ein oder mehrere Studios zu. Aktivieren Sie „Aufgaben aus Kalender nutzen“, damit Aufgaben in der Aufgabenliste erscheinen.",
  "Google Calendar setup guide title": "So richten Sie Google Kalender ein",
  "Google Calendar setup integration title": "Integration anlegen",
  "Google Calendar setup integration text": "Falls noch keine Integration „Google Kalender“ existiert, in der Liste oben auf „hinzufügen“ klicken, Typ „Google Kalender“ wählen, Namen vergeben und speichern.",
  "Google Calendar setup integration connected title": "Integration und Verbindung",
  "Google Calendar setup integration connected text": "Die Integration ist angelegt und mit Google verbunden.",
  "Google Calendar setup connect with google title": "Mit Google verbinden",
  "Google Calendar connect step title": "Mit Google verbinden",
  "Google Calendar setup connect with google text": "Unten auf „mit Google verbinden“ klicken, in Google anmelden und den Zugriff auf Kalender erlauben. Anschließend landen Sie hier zurück; die Kalenderliste wird geladen.",
  "Google Calendar setup enable tasks title": "Aufgaben aktivieren",
  "Google Calendar setup enable tasks text": "",
  "Google Calendar column use for tasks": "für Aufgaben",
  "Google Calendar setup assign calendars to studios title": "Kalender den Studios zuweisen",
  "Google Calendar setup assign calendars to studios text": "Für jeden erkannten Kalender: Kalender und Studios in den Auswahlboxen wählen, darunter „Aufgaben“ anhaken.",
  "Google Calendar setup save title": "speichern",
  "Google Calendar setup save text": "„speichern“ klicken. Die Einrichtung ist damit abgeschlossen.",
  "Google Calendar where to get credentials": "Woher kommen Client-ID und Client Secret?",
  "Google Calendar credentials help": "Für die Anbindung muss ein Administrator in der Google Cloud Console (console.cloud.google.com) ein Projekt anlegen, die „Google Calendar API“ aktivieren und unter „APIs & Dienste“ → „Anmeldedaten“ eine OAuth-2.0-Client-ID (Typ „Webanwendung“) erstellen. Als autorisierte Weiterleitungs-URI z. B. eintragen: https://ihre-api-domain/api/v1/integrations/google-calendar/callback (ihre tatsächliche API-Basis-URL verwenden). Client-ID und Client Secret werden serverseitig in der Konfiguration (z. B. appsettings) eingetragen – nicht hier in m1member.",
  "Google Calendar credentials link prefix": "Für Admins: Client-ID und Client Secret",
  "Google Calendar credentials link": "in der Google Cloud Console anlegen",
  "Google Calendar credentials help short": "Redirect-URI: …/api/v1/integrations/google-calendar/callback (serverseitig konfigurieren).",
  "Google Calendar setup connect with google connected": "Mit Google verbunden. Bei Bedarf können Sie die Verbindung erneuern.",
  "Google Calendar start setup": "Einrichtung starten",
  "Google Calendar connect hint": "Mit Google verbinden, um Kalender zu laden und zuzuordnen.",
  "Connect with Google": "mit Google verbinden",
  "Reconnect with Google": "erneut mit Google verbinden",
  "Use tasks from calendar": "Aufgaben aus Kalender nutzen",
  "Use calendar (coming soon)": "Kalender nutzen (demnächst)",
  "Assign calendar to studio(s)": "Kalender Studio(s) zuweisen",
  "Google Calendar calendars and studios": "Kalender & Studios",
  "Google Calendar connected": "Google Kalender verbunden.",
  "Google Calendar connection failed": "Verbindung mit Google Kalender fehlgeschlagen.",
  "Google Calendar not configured admin hint": "Die Google-Anbindung ist für dieses System noch nicht eingerichtet. ClientId und ClientSecret (aus der Google Cloud Console) tragen Sie in der Konfiguration des Backends ein: in appsettings.json unter „GoogleCalendar“ (ClientId, ClientSecret) oder als Umgebungsvariablen GoogleCalendar__ClientId und GoogleCalendar__ClientSecret.",
  "Google Calendar OAuth application": "OAuth-Anwendung (Google Cloud)",
  "Google Calendar OAuth application hint": "Tragen Sie die Zugangsdaten Ihrer OAuth-Anwendung ein. In der Google Cloud Console ein Projekt anlegen, „Google Calendar API“ aktivieren und unter „APIs & Dienste“ → „Anmeldedaten“ eine OAuth-2.0-Client-ID (Typ „Webanwendung“) erstellen. Als autorisierte Weiterleitungs-URI eintragen: {0}",
  "Google Calendar OAuth client id": "Client-ID",
  "Google Calendar OAuth client id placeholder": "z. B. …apps.googleusercontent.com",
  "Google Calendar OAuth client secret": "Client Secret",
  "Google Calendar OAuth client secret placeholder": "Client Secret aus der Google Cloud Console",
  "Google Calendar OAuth callback base url": "Callback-Basis-URL (für redirect_uri)",
  "Google Calendar OAuth callback base url placeholder": "z. B. https://api.example.com – nur nötig, wenn redirect_uri_mismatch",
  "Google Calendar OAuth redirect base url": "Redirect-Basis-URL",
  "Google Calendar connection test": "Verbindungstest Google Kalender",
  "Google Calendar connection test success": "Verbindung erfolgreich. {0} Kalender gefunden.",
  "Google Calendar not configured tenant hint": "OAuth noch nicht eingerichtet. Bitte bei Bearbeiten der Schnittstelle unter „OAuth-Anwendung“ Client-ID und Client Secret aus der Google Cloud Console eintragen und speichern.",
  "Google Calendar connection expired hint": "Die Verbindung ist abgelaufen oder ungültig. Bitte erneut mit Google verbinden, damit Kalender und Aufgaben wieder verfügbar sind.",
  "Google Calendar disconnect connection": "Verbindung trennen",
  "Google Calendar disconnect confirm": "Google-Verbindung wirklich trennen? Die Kalenderzuordnung bleibt gespeichert; Sie können sich später erneut verbinden.",
  "Google Calendar admin setup required": "Google Kalender noch nicht eingerichtet",
  "Google Calendar admin setup required description": "Ein Administrator muss unter Admin → Einstellungen → Google Kalender die OAuth-Anwendung (Client-ID und Geheimnis aus der Google Cloud Console) einmalig konfigurieren. Danach können Mandanten nur noch „Mit Google verbinden“ nutzen.",
  "Google Calendar redirect uri for Google": "Weiterleitungs-URI bei Google eintragen",
  "Admin Google Calendar settings title": "Google Kalender",
  "Admin Google Calendar settings description": "Eine plattformweite OAuth-Anwendung. Nach der Einrichtung können alle Mandanten unter Einstellungen → Integrations nur noch „Mit Google verbinden“ klicken – ohne Client-ID oder Geheimnis.",
  "Admin Google Calendar API settings title": "Google Kalender API",
  "Admin Google Calendar API card title": "Google Kalender API",
  "Admin Google Calendar API card description": "OAuth-Anwendung (Client-ID und Geheimnis) für alle Mandanten",
  "Admin integrations settings card description": "APIs und Anbindungen für den Admin-Mandanten (z. B. Briefversand, WhatsApp, Lead-Import).",
  "Admin Google Calendar settings card description": "OAuth einmal einrichten – alle Mandanten verbinden dann nur ihr Google-Konto",
  "Admin Google Calendar redirect uri label": "Diese Weiterleitungs-URI bei Google eintragen",
  "Admin Google Calendar callback base url": "Callback-Basis-URL",
  "Admin Google Calendar callback base url placeholder": "z. B. https://api.example.com – nur bei abweichendem Host",
  "Admin Google Calendar configured hint": "OAuth ist eingerichtet. Mandanten können unter Einstellungen → Integrations → Google Kalender API „Mit Google verbinden“ nutzen.",
  "Google Calendar connected successfully": "Mit Google verbunden. Sie können nun Kalender auswählen und Studios zuordnen.",
  "Google Calendar connection error": "Verbindung mit Google fehlgeschlagen.",
  "Create manual task": "manuelle Aufgabe anlegen",
  "Task title": "Aufgabentitel",
  "Due date (optional)": "fällig am",
  "Due time (optional)": "Uhrzeit",
  "Person (optional)": "Person",
  "Change request drawer title": "Änderungswunsch",
  "Change request close": "schließen",
  "Change request apply": "übernehmen",
  "Change request discard": "verwerfen",
  "Change request apply confirm": "Änderungswunsch übernehmen?",
  "Change request apply confirm detail": "Die gewünschten Daten werden in die Stammdaten übernommen und die Aufgabe wird beendet.",
  "Change request discard confirm": "Änderungswunsch verwerfen?",
  "Change request discard confirm detail": "Die Anfrage wird abgelehnt und die Aufgabe beendet. Die Stammdaten bleiben unverändert.",
  "Request discarded.": "Anfrage verworfen.",
  "Contact data before": "aktuell (vorher)",
  "Contact data after": "gewünscht (nachher)",
  "Contact data changed": "geändert",
  "Tasks filter": "Anzeige",
  "Open tasks only": "Nur offene",
  "Completed tasks only": "Nur erledigte",
  "Withdrawn": "widerrufen",
  "Dashboard contents": "Dashboard-Inhalte",
  "Dashboard contents description": "Festlegen, welche Bereiche auf dem Dashboard angezeigt werden.",
  "Apply dashboard configuration": "Dashboard-Konfiguration anwenden",
  "Recent Payments": "letzte Zahlungen",
  "Recipient name": "Name des Empfängers",
  "Recipients": "Empfänger",
  "Record payment": "Zahlung erfassen",
  "Recurrence": "Wiederholung",
  "Recurring": "Wiederkehrend",
  "Recurring debit": "Folgelastschrift",
  "Red": "Rot",
  "Redemption of vouchers/credits": "Einlösung von Gutscheinen/Wertguthaben",
  "Reference (optional)": "Referenz",
  "Reference": "Referenz",
  "Reference__alt1": "Bezugspunkt",
  "Reference__bezugspunkt": "Bezugspunkt",
  "Referrer": "Werber",
  "Recommended by": "Empfohlen von",
  "Referrer name (if not a member)": "Name des Empfehlenden (falls kein Mitglied)",
  "Referring member": "Empfehlendes Mitglied",
  "Refresh": "aktualisieren",
  "Refund": "Erstattung",
  "Refund method": "Zahlungsart der Erstattung",
  "Please select a refund method": "bitte Zahlungsart wählen",
  "Refundable": "Erstattungsfähig",
  "Regenerate": "Neu generieren",
  "Regenerate booking code?": "Buchungscode neu generieren?",
  "Regenerate mandate reference?": "Mandatsreferenz neu erstellen?",
  "Region": "Region",
  "regional": "regional",
  "Regional": "Regional",
  "Relative amount": "relativer Beitrag",
  "Reload": "Neu laden",
  "Reminder": "Mahnung",
  "Reminder & confirmation (lead times, email/SMS, templates)": "Erinnerung & Bestätigung (Vorlaufzeiten, Kanäle, Vorlagen)",
  "Reminder created.": "Mahnung erstellt.",
  "Reminder level": "Mahnstufe",
  "Reminder level created.": "Mahnstufe angelegt.",
  "Reminder level saved.": "Mahnstufe gespeichert.",
  "Reminder Levels": "Mahnstufen",
  "Reminder fee": "Mahngebühr",
  "Reminder levels & collection agencies": "Mahnstufen & Inkasso-Dienstleister",
  "Reminders__alt2": "Mahnwesen",
  "Reminders view due": "mahnfällig",
  "Reminders view pending": "Vorschau",
  "Reminders bulk success all": "Alle ausgewählten Mahnungen wurden ausgeführt.",
  "Reminders bulk partial": "Teilweise ausgeführt; einige Zeilen wurden übersprungen oder sind fehlgeschlagen.",
  "Reminders bulk failed": "Es konnte keine Mahnung ausgeführt werden.",
  "Reminder bulk drawer title": "Mahnungen erstellen",
  "Reminder bulk preview failed": "Die ausgewählten Mahnfälle konnten nicht geprüft werden.",
  "Reminder bulk blocked title": "Ausführung noch nicht möglich",
  "Reminder bulk blocked description": "Mindestens ein Mahnfall benötigt eine Klärung. Es wird keine Mahnung erstellt, solange die Auswahl nicht vollständig ausführbar ist.",
  "Reminder bulk clarification required": "Dieser Mahnfall muss vor der Ausführung einzeln geprüft werden.",
  "Reminder bulk status created": "erstellt",
  "Reminder bulk status failed": "fehlgeschlagen",
  "Reminder bulk status clarification": "Klärung erforderlich",
  "Reminder bulk letter per level": "Schreiben je Mahnstufe",
  "Reminder bulk concrete delivery and template required": "Bitte für jede Mahnstufe einen konkreten Versandkanal und eine Mahnvorlage auswählen.",
  "Automatic (per reminder rule)": "automatisch (nach Mahnregel)",
  "Debt collection handover without delivery selection": "Übergabe an das Inkasso — kein Versandkanal und keine Vorlage wählbar.",
  "Reminder cases": "Mahnfälle",
  "No studio": "kein Studio",
  "Reminders group by person": "nach Person gruppieren",
  "Reminders group multiple studios": "mehrere Studios",
  "Reminders group level varied": "unterschiedliche Stufen",
  "Reminders group due varied": "unterschiedliche Fälligkeiten",
  "Reminders create action": "erstellen",
  "Reminder include case open items": "alle fälligen Posten dieses Mahnfalls einschließen",
  "Open items count": "Anzahl Posten",
  "Debt collection handover": "Inkasso-Übergabe",
  "Debt collection prepared": "Inkasso vorbereitet",
  "Debt collection handover mode": "Inkasso-Übergabe",
  "Debt collection handover immediate": "Sofort übergeben (final)",
  "Debt collection handover prepare": "Zweistufig: Fall ohne Kennung, Abschluss später",
  "Debt collection finalize": "Jetzt final übergeben",
  "Debt collection case status active": "aktiv",
  "Debt collection case status closed": "geschlossen",
  "Debt collection case status prepared": "vorbereitet",
  "Debt collection case status cancelled": "storniert",
  "Debt collection cancel action": "stornieren",
  "Debt collection list all cases": "alle Vorgänge",
  "Debt collection list by person": "nach Person",
  "Debt collection cases count": "Anzahl Vorgänge",
  "Debt collection case items": "Positionen",
  "Debt collection manual payments": "manuelle Zahlungen",
  "Debt collection payment reported at": "Zahlung gemeldet am",
  "Debt collection cancellation reported at": "Storno gemeldet am",
  "Debt collection payment report title": "Zahlung an Inkasso melden",
  "Debt collection payment report action": "Zahlung melden",
  "Debt collection payment report hint":
    "Die Zahlung wird als manuelle Zahlung am Inkassofall vermerkt und für die Meldung an den Anbieter vorgemerkt. Der Inkassofall bleibt aktiv; Beiträge und offene Posten werden dadurch nicht als bezahlt gebucht.",
  "Debt collection create manual": "Inkassofall manuell anlegen",
  "Debt collection submit manual": "jetzt übergeben",
  "Debt collection manual create hint":
    "Die ausgewählten offenen Posten werden einem neuen Inkassofall zugeordnet, auf Inkasso gesetzt und mit einer Übermittlungs-Kennung versehen. Es wird keine Zahlungsbuchung erzeugt.",
  "Debt collection agency is required.": "Inkasso-Dienstleister ist erforderlich.",
  "Debt collection payment confirm title": "Zahlung melden?",
  "Debt collection payment confirm text":
    "Die Zahlung wird als manuelle Zahlung am Inkassofall vermerkt und für die Anbieter-Meldung vorgemerkt. Der Fall bleibt aktiv.",
  "Debt collection cancel confirm title": "Inkasso-Fall stornieren?",
  "Debt collection cancel confirm text":
    "Der gesamte Inkassofall wird storniert, die zugeordneten Posten werden wieder geöffnet und das Storno wird für die Anbieter-Meldung vorgemerkt. Je nach Anbieter können für eine Stornierung Kosten anfallen.",
  "Last submission": "letzte Übergabe",
  "Debt collection prepare only": "Zweistufig: Fall ohne Übermittlungs-Kennung anlegen",
  "Debt collection prepare only hint":
    "Ohne Häkchen: sofort wie gewohnt mit Kennung und Abschluss. Mit Häkchen: Fall wird angelegt und Posten zugeordnet; Übermittlungs-Kennung und finale interne Abwicklung folgen später über „Jetzt final übergeben“ in der Fallliste.",
  "Debt collection open items select placeholder": "Posten wählen oder leer lassen für alle …",
  "Debt collection open items select hint":
    "Ohne Auswahl in diesem Feld werden alle offenen Posten der gewählten Person übernommen. Einzelne Posten können in der Liste angeklickt werden.",
  "Debt collection case selection multiple persons":
    "mehrere Personen in der Fallliste markiert: bitte die Person im Formular wählen.",
  "Debt collection case prepared": "Inkasso-Fall vorbereitet.",
  "Debt collection case finalized": "Inkasso-Fall final übergeben.",
  "Debt collection payment registered": "Zahlung für Inkassofall gemeldet.",
  "Debt collection case cancelled": "Inkasso-Fall storniert.",
  "DebtCollectionCasePaymentNotAllowed": "Die Zahlung kann für diesen Inkasso-Fall nicht verbucht werden.",
  "DebtCollectionCaseCancellationNotAllowed": "Dieser Inkasso-Fall kann nicht storniert werden.",
  "External reference (optional)": "Externe Referenz",
  "Remittance info for multiple contracts": "Verwendungszweck für mehrere Verträge",
  "Remittance info for single transaction": "Verwendungszweck für einzelne Buchung",
  "Remittance Information": "Verwendungszweck",
  "Purpose": "Verwendungszweck",
  "Remove": "entfernen",
  "Enlarge image": "Bild vergrößern",
  "Select another image": "Anderes Bild auswählen",
  "Remove assignment": "Zuordnung entfernen",
  "Remove contributions (from end date)": "Beiträge entfernen (ab Enddatum)",
  "Removed.": "Entfernt.",
  "Renewal": "Verlängerung",
  "Renewal notice": "Frist Verlängerung",
  "Renewal Notice Period": "Kündigungsfrist Verlängerungslaufzeit",
  "Reply": "antworten",
  "Reply sent to queue": "Antwort in Warteschlange eingereiht",
  "Reply to": "Antwort an",
  "Reply-to": "Antwort an",
  "Report": "Bericht",
  "Report preview": "Berichtsvorschau",
  "Report templates": "Auswertungs-Vorlagen",
  "Reports": "Auswertungen",
  "Require Customer Type": "Kunden-Typ erforderlich",
  "Require full periods only": "Nur volle Perioden erlauben",
  "Required fields": "Pflichtfelder",
  "Required Fields": "Pflichtfelder",
  "Required fields missing": "Pflichtdaten erforderlich",
  "Required or specify duration": "Erforderlich oder Dauer angeben",
  "Required Resources__alt1": "benötigte Ressourcen",
  "Required Resources__alt2": "Pflicht-Ressourcen",
  "Required__alt1": "Bitte wählen",
  "Required__alt3": "Pflicht",
  "Required__alt4": "Pflichtfeld",
  "Resend email": "E-Mail erneut senden",
  "Resend letter": "Brief erneut senden",
  "Reserved": "vorgemerkt",
  "Reset filter": "Filter zurücksetzen",
  "Reset password": "Passwort zurücksetzen",
  "Reset password?": "Passwort zurücksetzen?",
  "Reset password__alt1": "Passwort neu setzen",
  "Reset selection": "Auswahl zurücksetzen",
  "Related data": "verbundene Daten",
  "Reset to default": "auf Standard zurücksetzen",
  "Reset to default hint": "Die gespeicherte Vorlage wird entfernt. Danach greift wieder die nächste Ebene: Studio, dann Mandant, dann der ausgelieferte Standard.",
  "Reset units?": "Einheiten zurücksetzen?",
  "Delete units?": "Einheiten löschen?",
  "Units delete confirmation": "Gespeicherte Einstellungen werden entfernt.",
  "Units deleted.": "Einheiten gelöscht.",
  "Copy units to scope": "Einheiten in Bereich kopieren",
  "Reset": "zurücksetzen",
  "Remove color": "Farbe entfernen",
  "No custom color": "keine eigene Farbe",
  "No color": "keine Farbe",
  "Reset.": "Zurückgesetzt.",
  "Reset__alt1": "neu setzen",
  "Reset__zurücksetzen": "zurücksetzen",
  "Resource": "Ressource",
  "Resource created": "Ressource angelegt",
  "Resource deleted": "Ressource gelöscht",
  "Resource pro studio": "pro Studio",
  "Resource pro studio tooltip": "Gleichzeitig pro Studio buchbar.",
  "Resource updated": "Ressource aktualisiert",
  "Resource bookable simultaneously in each studio": "Ressource in jedem Studio gleichzeitig buchbar",
  "Delete resource in use title": "Ressource ist Terminarten zugeordnet",
  "Delete resource in use intro": "Diese Ressource ist noch folgenden Terminarten zugeordnet:",
  "Delete resource in use effect": "Beim Löschen wird die Ressource aus diesen Terminarten und aus bestehenden Terminen entfernt.",
  "Resources": "Ressourcen",
  "Rest period": "Ruhezeit",
  "Rest period request type": "Art der Ruhezeit",
  "Rest period extension": "Ruhezeitverlängerung",
  "New rest period": "neue Ruhezeit",
  "Derived from previous rest period": "aus vorheriger Ruhezeit ermittelt",
  "Rest period confirmation": "Ruhezeitbestätigung",
  "Confirmation sent": "Bestätigung versendet",
  "Confirmation open": "Bestätigung offen",
  "Confirmation unclear": "Bestätigung unklar",
  "Rest period confirmation cannot be sent in this context":
    "Die Ruhezeit wird gespeichert, die Bestätigung kann in diesem Kontext aber nicht versendet werden.",
  "Cancellation confirmation cannot be sent in this context":
    "Die Kündigung wird gespeichert, die Bestätigung kann in diesem Kontext aber nicht versendet werden.",
  "Default rest period document": "Standard-Ruhezeitdokument",
  "Rest period edit prior confirmation hint":
    "Zu dieser Ruhezeit wurde bereits eine Bestätigung versendet. Wenn Sie Zeitraum oder Konditionen ändern, prüfen Sie bitte Beiträge/Forderungen und informieren Sie das Mitglied ggf. erneut (z. B. Korrektur-Brief).",
  "Rest period confirmation already sent": "Ruhezeitbestätigung bereits versendet",
  "Rest period resend confirmation question":
    "Zu dieser Ruhezeit wurde bereits eine Bestätigung versendet. Soll beim Speichern erneut eine Bestätigung versendet werden?",
  "Send again": "erneut versenden",
  "Rest period info: contributions recalculated":
    "Der Beitragskalender wurde neu berechnet. Bitte offene Posten und Zahlungen prüfen.",
  "Rest period warning: contribution calendar failed":
    "Der Beitragskalender konnte nicht vollständig neu berechnet werden. Bitte Vertragspaket und Beiträge manuell prüfen.",
  "Rest period warning: retroactive correction failed":
    "Rückwirkende Gegenbuchungen konnten nicht vollständig erstellt werden. Bitte die betroffenen Beiträge prüfen.",
  "Rest period warning: inform member outdated confirmation":
    "Es liegt eine frühere Ruhezeit-Bestätigung vor; die Änderung wurde ohne neuen Versand gespeichert. Bitte das Mitglied informieren, falls nötig.",
  "Rest period warning: letter send failed":
    "Der gewünschte Brief/E-Mail-Versand ist fehlgeschlagen. Ruhezeit wurde trotzdem gespeichert.",
  "Rest period preview cancelled at": "storniert am",
  "Rest period preview assignment changed": "Zuordnung geändert",
  "Rest period preview send confirmation": "Bestätigung versenden",
  "Rest period preview bookings": "Buchungen und offene Posten",
  "Rest period preview wallet movements": "Wertekonto-Buchungen",
  "Rest period preview further changes": "Weitere Änderungen",
  "Rest period preview follow-up actions": "Folgeaktionen",
  "Rest period preview review confirmation": "Bestätigung vor dem Versand zur Prüfung öffnen",
  "Rest period preview history action": "Änderung in der Historie protokollieren",
  "Rest period preview fee cycle": "Gebührenzyklus",
  "Rest period preview cycle count": "Zykluslänge",
  "Rest period preview calculation method": "Anteilige Berechnung",
  "Rest period preview extension days": "Verlängerungstage",
  "Rest period preview billing model": "Beitragsmodell",
  "Rest period preview current period only": "nur laufende Beitragsperiode korrigieren",
  "Rest period preview regular end": "Reguläres Vertragsende",
  "Rest period preview original end": "Grundlaufzeitende",
  "Rest period preview period start": "Periodenbeginn",
  "Rest period preview period end": "Periodenende",
  "Rest period preview rest link": "Ruhezeitzuordnung",
  "Rest period preview submitted": "Zur Lastschrift eingereicht",
  "Rest period preview original booking": "Ursprüngliche Buchung",
  "Rest period preview original amount": "Ursprünglicher Betrag",
  "Rest period preview correction amount": "Korrekturbetrag",
  "Rest period preview allocated booking": "Zahlungszuordnung",
  "Rest period preview cancelled amount": "Stornierter Betrag",
  "Rest period preview reversal": "Gegenbuchung",
  "Rest period preview year proration": "nach Tagen im Jahr",
  "Rest period preview month30 proration": "nach 30 Tagen im Monat",
  "Rest period preview actual proration": "nach tatsächlichen Monatstagen",
  "Valid to": "Gültig bis",
  "Cancellation effective date": "Kündigung wirksam zum",
  "Rest period billing model keep extending description": "Betroffene Beiträge werden anteilig korrigiert. Die Ruhezeit verlängert die Vertragslaufzeit.",
  "Rest period custom configuration hint": "Für eigene Einstellungen „individuell“ wählen.",
  "E_RestPeriodFeeChangeBlocked": "Die Gebührenänderung ist durch eine manuelle Buchung, einen aktiven Lastschriftlauf oder Inkasso gesperrt.",
  "RestPeriodRetroactiveBlockedBySepa":
    "Die Ruhezeit kann nicht rückgängig gemacht werden, weil eine zugehörige Korrekturbuchung in einem aktiven SEPA-Lauf enthalten ist. Bitte den SEPA-Lauf verbuchen oder zurücksetzen.",
  "RestPeriodOutsideContractPackage":
    "Die Ruhezeit darf nicht nach dem Vertragsende beginnen. Bei beendeten Verträgen ist der Beginn höchstens heute bzw. am Vertragsende.",
  "Rest period suspended contributions": "ausgesetzte Beiträge",
  "Rest period costs": "Kosten der Ruhezeit",
  "Request channel": "Eingang",
  "Request channel desk": "Theke",
  "Request channel phone": "Telefon",
  "Request channel email": "E-Mail",
  "Request channel app": "App",
  "Request channel letter": "Brief",
  "Rest period impact preview title": "Auswirkungen nach dem Speichern",
  "Rest period preview change": "Änderung",
  "Rest period preview before value": "vorher {0}",
  "Rest period preview requires complete input": "Bitte Vertragspaket und Zeitraum vollständig angeben.",
  "Rest period preview row changed": "geändert",
  "Rest period preview row new": "neu",
  "Rest period preview row removed": "entfällt",
  "Rest period preview row unchanged": "unverändert",
  "Rest period preview more rows": "{0} weitere Änderung(en)",
  "Rest period preview unavailable": "Die Vorschau konnte nicht berechnet werden.",
  "Next contribution after saving": "Nächster Beitrag nach dem Speichern",
  "Contract end after saving": "korrigiertes Vertragsende",
  "Contribution correction": "Beitragskorrektur",
  "Contribution changes after saving": "Beitragsänderungen nach dem Speichern",
  "Rest period preview changed contributions count": "Beiträge mit Änderung: {0}",
  "Rest period preview no contribution changes": "keine Beitragsänderungen",
  "Contributions after saving": "korrigierter Beitragskalender",
  "No open contributions": "keine offenen Beiträge",
  "No end date": "kein Enddatum",
  "Rest period save follow-up title": "Ruhezeit gespeichert – Hinweise",
  "Rest period end date": "Ruhezeit-Enddatum",
  "Rest period ending": "Ruhezeitende",
  "Rest period model": "Ruhezeitmodell",
  "Rest period model (optional)": "Ruhezeitmodell",
  "Rest period models": "Ruhezeit-Modelle",
  "Rest period monthly fee": "Ruhezeitbeitrag",
  "Rest period total fee amount": "Gesamtbetrag der Ruhezeit",
  "Rest period next contribution due date": "nächste Beitragsfälligkeit",
  "Rest period next contribution amount": "nächster Beitragsbetrag",
  "Rest period note": "Ruhezeit Notiz",
  "Rest period reason": "Ruhezeitgrund",
  "Rest period reason created": "Ruhezeitgrund angelegt",
  "Rest period reason deleted": "Ruhezeitgrund gelöscht",
  "Rest period reason updated": "Ruhezeitgrund aktualisiert",
  "Rest period reasons": "Ruhezeitgründe",
  "Select rest period reason…": "Ruhezeitgrund auswählen …",
  "Rest period request date": "Ruhezeit-Anfragedatum",
  "Rest period saved.": "Ruhezeit gespeichert.",
  "Rest period start date": "Ruhezeit-Startdatum",
  "Rest period starting": "Ruhezeit beginnt",
  "Rest period template": "Ruhezeitmodell",
  "Rest period template name": "Ruhezeitmodell-Name",
  "Rest period templates": "Ruhezeitmodelle",
  "Rest period weeks count": "Ruhezeit-Wochenbeiträge",
  "Rest periods": "Ruhezeiten",
  "Reasons for rest periods": "Gründe für Ruhezeiten",
  "Result": "Ergebnis",
  "Result/status templates": "Ergebnis-/Status-Vorlagen",
  "Retake": "erneut aufnehmen",
  "Retries": "Versuche",
  "Revenue": "Ertrag",
  "Revenue (Year)": "Umsatz (Jahr)",
  "Revenue (€)": "Umsatz (€)",
  "Revoke": "zurücknehmen",
  "Revoke cancellation": "Kündigung zurücknehmen",
  "Role": "Rolle",
  "Role created": "Rolle angelegt",
  "Role deleted": "Rolle gelöscht",
  "Role is required": "Rolle ist erforderlich",
  "Role is required for the primary account": "Rolle ist für den primären Account erforderlich",
  "Role saved": "Rolle gespeichert",
  "Roles": "Rollen",
  "Roles (Reverse-QR)": "Rollen (Reverse-QR)",
  "Roles (access)": "Rollen (Zutritt)",
  "Room": "Raum",
  "Room (Course room, Area)": "Raum (Kursraum, Bereich)",
  "Rooms": "Räume",
  "Round down": "abrunden",
  "Round up": "aufrunden",
  "Rounded": "rund",
  "Rounding": "Rundung",
  "Rounding (optional)": "Rundung",
  "Rounding: Ending must be < Step": "Rundung: Endung muss < Schritt sein",
  "Rounding: Step must be > 0": "Rundung: Schritt muss > 0 sein",
  "Rule": "Regel",
  "Rule created": "Regel angelegt",
  "Rule deleted": "Regel gelöscht",
  "Rule updated": "Regel aktualisiert",
  "Rules": "Regeln",
  "Run ID not found": "Lauf-ID nicht gefunden",
  "Run": "ausführen",
  "Run__alt2": "Lauf",
  "Sales & Leads": "Sales & Kontakte",
  "Sales pipelines and phases": "Vertriebspipelines und Phasen",
  "Sales__alt1": "Mitgliedergewinnung",
  "Sales": "Vertrieb",
  "Sales__alt2": "Verkäufe",
  "Salutation": "Anrede",
  "Salutation is required": "Anrede ist erforderlich",
  "Sat": "Sa",
  "Saturday": "Samstag",
  "Apply": "übernehmen",
  "Select template": "Vorlage auswählen",
  "Save": "speichern",
  "Save entitlement sources": "Zugriffsquellen speichern",
  "Save failed": "Fehler beim Speichern",
  "Save failed__alt1": "Fehler beim Speichern",
  "Save failed see console": "Fehler beim Speichern. Details in der Browser-Konsole (F12).",
  "Saved": "gespeichert",
  "Saved settings will be removed.": "Die gespeicherten Einstellungen werden gelöscht.",
  "Saved.": "gespeichert.",
  "Scheduled": "geplant",
  "Scheduled for": "geplant für",
  "Schedules": "Rhythmen",
  "Scope": "Bereich",
  "Add scope": "Bereich anlegen",
  "All scopes already configured.": "Alle Bereiche sind bereits konfiguriert.",
  "Save to scope": "In Bereich speichern",
  "Select scope to add:": "Bereich zum Anlegen wählen:",
  "Select at least one scope.": "Bitte wählen Sie mindestens einen Bereich.",
  "Select at least one studio.": "Bitte wählen Sie mindestens ein Studio.",
  "Scopes": "Bereiche",
  "Units add scopes tooltip": "Wählen Sie ein oder mehrere Studios, für die die Einstellungen angelegt werden. Leer = Mandanten-Standard (gilt für alle Studios).",
  "Units add scope studios tooltip": "Leer = Mandanten-Standard (alle Studios) anlegen; sonst gewählte Studios. jedes Studio nur einmal.",
  "Units add scope placeholder": "Studios wählen oder leer für Mandanten-Standard",
  "Units duplicate target tooltip": "Leer = Mandanten-Standard (alle Studios); sonst gewähltes Studio. jedes Studio nur einmal.",
  "Units duplicate target placeholder": "Leer = Mandanten-Standard (alle Studios)",
  "Units default scope already exists": "Ein Bereich „Mandanten-Standard“ (alle Studios) existiert bereits.",
  "Script Code": "Script-Code",
  "Search by mandate reference...": "Nach Mandatsreferenz suchen…",
  "Search by name...": "Nach Name suchen…",
  "Search columns...": "Spalten durchsuchen…",
  "Search failed__alt1": "Fehler bei der Suche",
  "Search failed__alt2": "Suche fehlgeschlagen",
  "Search name/email/phone": "Suche Name/E-Mail/Telefon",
  "Search people (name or email)...": "Personen suchen (Name oder E-Mail)…",
  "Search permissions…": "Rechte suchen…",
  "Search person...": "Person suchen …",
  "Search person: name, email, phone …": "Person suchen: Name, E-Mail, Telefon …",
  "Search person or user: name, email, phone …": "Person oder Benutzer suchen: Name, E-Mail, Telefon …",
  "Search person: name, email, phone…": "Person suchen: Name, E-Mail, Telefon …",
  "Search person…": "Person suchen…",
  "Search results": "Suchergebnisse",
  "Search": "suchen",
  "Search__alt1": "Suche",
  "Searching…": "Suche…",
  "Secondary Color": "Sekundärfarbe",
  "Secondary color": "Sekundärfarbe",
  "Security Warning": "Sicherheitswarnung",
  "Select": "auswählen",
  "Select years": "Jahre auswählen",
  "Select a booking group to preview": "Buchungsgruppe für Vorschau auswählen",
  "Preview will appear when a widget is loaded": "Vorschau erscheint, sobald ein Formular geladen ist",
  "Select account": "Konto auswählen",
  "Select an Appointment": "Termin auswählen",
  "Select an Appointment Type": "Terminart auswählen",
  "Select Appointment": "Termin wählen",
  "Select an assignment reader to start scanning.": "Wähle einen Zuweisungsleser aus, um den Scan zu starten.",
  "Select appointment types": "Terminarten auswählen",
  "Select assignment reader": "Zuweisungsleser auswählen",
  "Select booking group": "Buchungsgruppe auswählen",
  "Select resources first": "Zuerst Ressourcen auswählen",
  "Select bank account (optional)": "Bankverbindung auswählen",
  "Select calendar first": "Zuerst Kalender wählen",
  "Select cancellation model": "Kündigungsmodell auswählen",
  "Select cancellation reason…": "Kündigungsgrund wählen…",
  "Select capabilities": "Fähigkeiten auswählen",
  "Select category": "Kategorie auswählen",
  "Select channel": "Kanal auswählen",
  "Select chargeback reason...": "RL-Grund wählen…",
  "Select columns to display and drag them to change the order.": "Wählen Sie die anzuzeigenden Spalten und ziehen Sie sie, um die Reihenfolge zu ändern.",
  "Select contract": "Vertrag auswählen",
  "Select contract package": "Vertragspaket auswählen",
  "Select contract block": "Vertragsbaustein auswählen",
  "Contracts without contract package": "Verträge ohne Vertragspaket",
  "Select contribution handling…": "Beitragsbehandlung wählen…",
  "Select date": "Datum wählen",
  "Select date (optional)": "Datum wählen",
  "Select date and time": "Datum und Uhrzeit wählen",
  "Select direct debit group(s)": "Lastschrift-Gruppe(n) auswählen",
  "Select priceAdjustment": "Preisanpassung auswählen",
  "Select price adjustment": "Preisanpassung auswählen",
  "Select price adjustment or configure individually…": "Preisanpassung wählen oder individuell konfigurieren…",
  "Price adjustment designation": "Bezeichnung",
  "Price adjustment model": "Preisanpassungsmodell",
  "Manual price adjustment requires customize permission": "Für manuelle Preisanpassungen fehlt die Berechtigung.",
  "Manual price adjustment name is required": "Bezeichnung der manuellen Preisanpassung ist erforderlich",
  "Manual price adjustment name placeholder": "z. B. Kulanzrabatt",
  "Select end date": "Enddatum wählen",
  "Select end or enter duration": "Ende wählen oder Dauer eingeben",
  "Select handling…": "Behandlung wählen…",
  "Select integration": "Integration wählen",
  "Select manufacturer...": "Hersteller auswählen…",
  "Select next phase:": "nächste Phase wählen:",
  "Select payment method type": "Zahlungsart-Typ wählen",
  "Select payment method…": "Zahlungsart wählen…",
  "Change payment method (open contributions)": "Zahlungsart ändern",
  "No open contributions to change payment method": "keine offenen Beiträge zum Ändern der Zahlart",
  "Payment method changed for contributions": "Zahlart für {0} Beiträge geändert",
  "Affected contributions count": "{0} offene Beiträge betroffen",
  "Select payment method… (optional)": "Zahlungsart wählen…",
  "Select person": "Person auswählen",
  "Select persons...": "Personen auswählen…",
  "Select plan": "Modell wählen",
  "Select product": "Produkt auswählen",
  "Select reader device...": "Lesegerät auswählen…",
  "Select reason": "Grund auswählen",
  "Select reason (e.g. vacation, sick)": "Grund wählen (z. B. Urlaub, Krank)",
  "Select recurrence rule": "Wiederholungsregel wählen",
  "Select resource": "Ressource wählen",
  "Select resources (optional)": "Ressourcen auswählen",
  "Select resources...": "Ressourcen auswählen…",
  "Select rest period model": "Ruhezeitmodell auswählen",
  "Select start and end month. All contributions in this period will be considered.": "Wählen Sie Start- und Endmonat aus. Alle Beiträge in diesem Zeitraum werden berücksichtigt.",
  "Select studio": "Studio auswählen",
  "Select phase (optional)": "Phase auswählen",
  "Select studio(s)": "Studio(s) auswählen",
  "Select studios...": "Studios wählen…",
  "Select studio…": "Studio wählen…",
  "Select target": "Ziel wählen",
  "Select target phase": "Zielphase wählen",
  "Select target scope:": "Zielbereich wählen:",
  "Select template (optional)": "Vorlage auswählen",
  "Select template or configure individually…": "Modell wählen oder individuell konfigurieren…",
  "Select template…": "Vorlage auswählen…",
  "Select template/variant": "Vorlage/Variante auswählen",
  "Select template...": "Vorlage wählen …",
  "Select tenant...": "Mandant auswählen…",
  "Select the persons to be assigned to this calendar.": "Wählen Sie die Personen aus, die diesem Kalender zugeordnet werden sollen.",
  "Select the resources required for this appointment type. Capacity will be checked during booking.": "Wählen Sie die Ressourcen aus, die für diese Terminart benötigt werden. Die Kapazität wird bei der Buchung geprüft.",
  "Select type__general": "Art auswählen",
  "Select type...": "Typ auswählen…",
  "Select user": "Benutzer wählen",
  "Select user(s)...": "Benutzer auswählen…",
  "Select user:": "Benutzer auswählen:",
  "Select VAT setting (optional)": "USt-Einstellung auswählen",
  "Select tax setting (optional)": "Steuereinstellung auswählen",
  "Select wallet…": "Wertekonto wählen…",
  "Select week": "Woche auswählen",
  "Select week__alt2": "Woche wählen",
  "Select weekday": "Wochentag auswählen",
  "Select which fields must be filled in during booking.": "Wählen Sie, welche Felder bei der Buchung ausgefüllt werden müssen.",
  "selected": "ausgewählt",
  "Selected contributions": "ausgewählte Beiträge",
  "Selected person": "ausgewählte Person",
  "Selected studios only": "nur ausgewählte Studios",
  "Selected template unavailable": "ausgewählte Vorlage nicht verfügbar",
  "Selection failed": "Auswahl fehlgeschlagen",
  "Send a single email (e.g. to one person).": "Einzelversand von E-Mails (z. B. an eine Person).",
  "Send a single letter (PDF/DOCX, print/export).": "Einzelversand von Briefen (PDF/DOCX, Druck/Export).",
  "Reminder text variant": "Textvariante der Mahnung",
  "Debt collection handover text variant": "Textvariante der Inkasso-Meldung",
  "Email templates": "E-Mail-Vorlagen",
  "Attach letter to email": "Brief-PDF an die E-Mail anhängen",
  "Attach letter to email tooltip": "Trägt die Mail das Schreiben selbst, ist das PDF eine Zugabe fürs Archiv des Mitglieds. Beim Vertragsdokument liegt es unabhängig davon bei — dort ist der Anhang der Punkt der Nachricht. Abgelegt wird das PDF in jedem Fall.",
  "Card": "Karte",
  "Payment methods": "Zahlungsarten",
  "SEPA direct debit": "SEPA-Lastschrift",
  "Text set": "Vorlage",
  "Select text set…": "Vorlage wählen …",
  "Please select a text set": "Bitte eine Vorlage wählen",
  "Please select a text set first": "Bitte zuerst eine Vorlage wählen",
  "Bulk dispatch result: {0} sent, {1} skipped": "Serienversand: {0} verschickt, {1} ausgelassen",
  "Bulk send too many recipients": "Zu viele Empfänger für einen Durchgang (höchstens {0}). Bitte die Auswahl eingrenzen.",
  "BulkSendTooManyRecipients": "Zu viele Empfänger für einen Durchgang. Bitte die Auswahl eingrenzen.",
  "SystemDocumentNeedsOneSurface": "Die Vorlage muss mindestens für Brief oder E-Mail gelten.",
  "Send confirmation": "Bestätigung versenden",
  "Send email": "E-Mail senden",
  "Send email__alt1": "E-Mail schreiben",
  "Send email__alt2": "E-Mail versenden",
  "Send via integration": "Über {integrationName} versenden",
  "Send emails or letters to selected recipients": "E-Mails oder Briefe an ausgewählte Empfänger versenden",
  "Send email…": "E‑Mail senden…",
  "Send letter/email": "Brief/E-Mail senden",
  "Send letter…": "Brief senden…",
  "Send link": "Link senden",
  "Send messages": "Nachrichten versenden",
  "Send reminder": "Erinnerung versenden",
  "Send": "senden",
  "Send__alt2": "Versand",
  "Send__versand": "Versand",
  "Send__alt3": "versenden",
  "Sender email": "Absender E-Mail",
  "Sender name": "Absender Name",
  "sending": "wird gesendet",
  "Sending (SMTP)": "Versand (SMTP)",
  "Sending is disabled.": "Versand ist deaktiviert.",
  "Sending": "wird gesendet",
  "Sending__alt1": "Versand",
  "Sending__versand": "Versand",
  "Sent": "gesendet",
  "Sent__gesendet": "gesendet",
  "Sent__alt2": "versendet",
  "sent__alt2": "versendet",
  "SEPA": "SEPA",
  "SEPA direct debit active": "SEPA-Lastschrift aktiv",
  "SEPA direct debit is disabled. Create/download is blocked (Settings → SEPA → Direct debit export).": "SEPA-Lastschrift ist deaktiviert. Erstellen/Download sind gesperrt (Einstellungen → SEPA → Lastschrift-Export).",
  "SEPA file downloaded": "SEPA-Datei heruntergeladen",
  "SEPA file not yet generated": "SEPA-Datei noch nicht generiert",
  "SEPA report available after download or posting": "Der Bericht steht erst nach dem Download der SEPA-Datei oder nach dem Verbuchen zur Verfügung.",
  "Post available after SEPA file download": "Verbuchen ist erst möglich, wenn die SEPA-Datei heruntergeladen oder außerhalb von m1member eingereicht wurde.",
  "SEPA file was submitted outside m1member": "SEPA-Datei wurde außerhalb von m1member eingereicht",
  "SEPA group": "Lastschriftgruppe",
  "SEPA groups": "SEPA-Gruppen",
  "SEPA Report": "SEPA-Bericht",
  "SEPA Share": "SEPA-Anteil",
  "Server time: ": "Server-Zeit: ",
  "Server/host": "Server/Host",
  "Service": "Dienst",
  "Service products": "Vertragsbausteine",
  "Services": "Dienste",
  "set": "gesetzt",
  "Set as default": "als Standard",
  "Set new password": "neues Passwort festlegen",
  "Set password": "Passwort setzen",
  "Settings": "Einstellungen",
  "Settings saved": "Einstellungen gespeichert",
  "Settings saved.": "Einstellungen gespeichert.",
  "Shape": "Form (Ecken)",
  "Short code for the studio (e.g. for mandate reference pattern {STUDIO})": "Kurzzeichen des Studios (z. B. für Mandatsreferenz-Pattern {STUDIO})",
  "Short name": "Kurzname",
  "Short Name": "Kurzname",
  "Show": "anzeigen",
  "show (field column)": "anzeigen",
  "required (field column)": "erforderlich",
  "Show again": "wieder einschalten",
  "Show all": "alle anzeigen",
  "Show Appointment Type Icons": "Terminart-Icons anzeigen",
  "Show diagnostics": "Diagnose anzeigen",
  "Show expired contracts": "abgelaufene Verträge anzeigen",
  "Show past": "Vergangene anzeigen",
  "Show Prices": "Preise anzeigen",
  "Show Privacy Policy": "Datenschutzerklärung anzeigen",
  "Show Step Indicator": "Schritt-Indikator anzeigen",
  "Show Terms & Conditions": "AGB anzeigen",
  "Sign in": "anmelden",
  "Sign in__alt2": "Zur Anmeldung",
  "Signature (text template)": "Signatur (Textvorlage)",
  "Signing date": "Abschlussdatum",
  "Simulates without sending": "Simuliert ohne zu versenden",
  "Since start of day": "seit Tagesbeginn",
  "Size": "Größe",
  "Skipped": "übersprungen",
  "Slot (min)": "Slot (Min)",
  "Slot Duration (Minutes)": "Slot-Dauer (Minuten)",
  "Slots": "Zeitfenster",
  "Small": "klein",
  "Smaller number = higher up": "Kleinere Zahl = weiter oben",
  "SMS": "SMS",
  "SMS cannot be combined with other channels.": "SMS kann nicht mit anderen Kanälen kombiniert werden.",
  "SMS details": "SMS-Details",
  "SMS text (max. 160 characters recommended). Variables: {{variable}}": "SMS-Text (max. 160 Zeichen empfohlen). Variablen: {{variable}}",
  "SMS text (max. 160 chars recommended)": "SMS-Text (max. 160 Zeichen empfohlen)",
  "WhatsApp": "WhatsApp",
  "WhatsApp cannot be combined with other channels.": "WhatsApp kann nicht mit anderen Kanälen kombiniert werden.",
  "WhatsApp cannot be combined with SMS.": "WhatsApp kann nicht mit SMS kombiniert werden.",
  "WhatsApp available": "hat WhatsApp",
  "No WhatsApp": "kein WhatsApp",
  "Webhook recipient number (for inbound)": "Webhook-Empfängernummer (für Inbound)",
  "Webhook number placeholder": "z. B. +491771234567",
  "Webhook number must be international format": "Nummer im internationalen Format (z. B. +491771234567)",
  "Phone number that receives inbound SMS/WhatsApp. Used to route webhook to this tenant.": "Rufnummer, die Inbound-SMS/WhatsApp empfängt. Wird zur Zuordnung des Webhooks zum Mandanten genutzt.",
  "SMTP host": "SMTP-Host",
  "Delivery route": "Versandweg",
  "Own SMTP server": "eigener SMTP-Server",
  "A relay carries only the provider login. The sender address stays with this account, so several accounts can share one relay.": "Ein Relay trägt nur die Anmeldung beim Anbieter. Die Absenderadresse bleibt an diesem Konto — dadurch können mehrere Konten dasselbe Relay mit je eigenem Absender nutzen.",
  "SMTP test failed.": "SMTP-Test fehlgeschlagen.",
  "SMTP test successful (test email was sent).": "SMTP-Test erfolgreich (Test-E-Mail wurde gesendet).",
  "Sort order": "Sortierung",
  "Source": "Quelle",
  "Check-in source manual": "manuell",
  "Check-in reader reception": "Tresen",
  "Check-in source reader": "Lesegerät",
  "Check-in source app": "App",
  "Check-in source system": "System",
  "Source and target must be different.": "Quelle und Ziel müssen unterschiedlich sein.",
  "Source and target must have the same number of studios and resources.": "Quelle und Ziel müssen gleiche Anzahl Studios und Ressourcen haben.",
  "Sources": "Quellen",
  "Specify end date": "Ende angeben",
  "Spooler": "Spooler",
  "Square": "eckig",
  "SSL": "SSL",
  "Stack trace": "Stack Trace",
  "Start date": "Startdatum",
  "Start date is required": "Startdatum ist erforderlich",
  "Price adjustment starts in the past warning": "Achtung, die neue Preisanpassung beginnt in der Vergangenheit.",
  "Start date is required.": "Startdatum ist erforderlich.",
  "Start Date__alt1": "Start-Datum",
  "Start Date__alt2": "Startdatum",
  "Start is required": "Start ist erforderlich",
  "Start is required.": "Start ist erforderlich.",
  "Start page": "Startseite",
  "Start page after login": "Startseite nach Anmeldung",
  "Start": "Start",
  "Start__alt1": "Beginn",
  "State": "Bundesland",
  "State/Region": "Bundesland",
  "Status": "Status",
  "Status (Member/Lead/Former)": "Status (Mitglied/Interessent/Ehemalig)",
  "Status updated": "Status aktualisiert",
  "Status: New · Click opens lead manager": "Status: neu · Klick öffnet Kontakt-Manager",
  "Step": "Schritt",
  "Step is required": "Schritt ist erforderlich",
  "Stored per user (key:": "Wird pro Benutzer gespeichert (Schlüssel:",
  "Street": "Straße",
  "Street (optional)": "Straße",
  "Studio (optional)": "Studio",
  "Studio already assigned": "Studio bereits vergeben",
  "Studio created": "Studio angelegt",
  "Studio deleted": "Studio gelöscht",
  "Studio display": "Studioanzeige",
  "Studio is required.": "Studio ist erforderlich.",
  "Studio is required": "Studio ist erforderlich",
  "Studio is required__alt1": "Studio erforderlich",
  "Studio updated": "Studio aktualisiert",
  "Studio(s)": "Studio(s)",
  "Studio:": "Studio:",
  "Studio__alt1": "Standort",
  "Studios": "Studios",
  "Studios (usage)": "Studios (Verwendung)",
  "Sub Device": "Untergerät",
  "Sub-devices are synced from m1connect-service after registration. Then you can configure allowed actions per sub-device here.": "Untergeräte werden vom m1connect-service nach erfolgreicher Registrierung automatisch an m1member übertragen. Danach kannst du hier pro Untergerät die erlaubten Aktionen pflegen.",
  "Subject": "Betreff",
  "Subject is required": "Betreff ist erforderlich",
  "Submission deadline": "Abgabe bis",
  "Submit request": "Anfrage absenden",
  "Successful": "erfolgreich",
  "Successfully saved": "erfolgreich gespeichert",
  "Summary": "Zusammenfassung",
  "Summary__alt1": "Kurzbeschreibung",
  "Summary__kurzbeschreibung": "Kurzbeschreibung",
  "Sun": "So",
  "Sunday": "Sonntag",
  "Surcharge": "Aufschlag",
  "Surcharge Type": "Aufschlag-Typ",
  "Switch duration (ms)": "Schaltdauer (ms)",
  "Switch light or dark": "Hell oder dunkel",
  "Switch duration must be >= 0": "Schaltdauer muss >= 0 sein",
  "System": "System",
  "System email templates": "System-E-Mail-Vorlagen",
  "System error notifications": "System-Fehlerbenachrichtigungen",
  "System error recipient": "Empfänger für System-Fehler",
  "Email address to receive system error notifications in release mode.": "E-Mail-Adresse für System-Fehlerbenachrichtigungen im Release-Modus.",
  "System Logs": "Systemprotokoll",
  "System role": "Systemrolle",
  "Table": "Tabelle",
  "Table columns": "Tabellen-Spalten",
  "Table header": "Kopfzeile",
  "Table cells": "Zellen",
  "Table total": "Gesamtsumme",
  "Insert table": "Tabelle einfügen",
  "Remove table from layout": "Tabelle aus der Arbeitsfläche entfernen",
  "Reset table appearance": "Tabellengestaltung zurücksetzen",
  "Reset table appearance confirmation": "Die gespeicherte Tabellengestaltung für diesen Kanal wird auf den Standard zurückgesetzt. Die Mustertabelle bleibt in der Arbeitsfläche.",
  "Take photo": "Foto aufnehmen",
  "Target": "Ziel",
  "Target phase": "Ziel-Phase",
  "Target pipeline status": "Ziel-Pipeline-Status",
  "Target scope": "Zielbereich",
  "Tariff": "Tarif",
  "Tariff Blocks": "Vertragsbausteine",
  "Tariff: For „Selected studios only“, studios must be selected.": "Tarif: Bei „nur ausgewählte Studios“ müssen Studios ausgewählt werden.",
  "Task completed.": "Aufgabe erledigt.",
  "Tax Rate (%)": "Steuersatz (%)",
  "Team/Pool": "Team/Pool",
  "Team/Pool (Group of persons)": "Team/Pool (Gruppe von Personen)",
  "Teams/Pools": "Teams/Pools",
  "Telefon": "Telefon",
  "template": "Vorlage",
  "Template categories": "Vorlagenkategorien",
  "Template could not be loaded.": "Vorlage konnte nicht geladen werden.",
  "Template created": "Vorlage angelegt",
  "Template deleted": "Vorlage gelöscht",
  "Template deleted.": "Vorlage gelöscht.",
  "Template is required": "Vorlage ist erforderlich",
  "Template saved.": "Vorlage gespeichert.",
  "Template updated": "Vorlage aktualisiert",
  "Template": "Modell",
  "Template__alt2": "Vorlage",
  "Template__vorlage": "Vorlage",
  "Templates & variants (packages)": "Vorlagen & Varianten (Pakete)",
  "Templates apply per studio (sender = studio).": "Vorlagen gelten pro Studio (Absender = Studio).",
  "Tenant": "Mandant",
  "Tenant default: {0}": "Mandanten-Standard: {0}",
  "Open user account menu": "Konto-Menü öffnen",
  "Open window menu": "Fenstermenü öffnen",
  "Minimize window": "Minimieren",
  "Maximize window": "Maximieren",
  "Restore window": "Wiederherstellen",
  "Close window": "Schließen",
  "Tenant (default)": "Mandant (Standard)",
  "Tenant cannot be deleted": "Mandant kann nicht gelöscht werden",
  "Tenant created": "Mandant erstellt",
  "Tenant deleted": "Mandant gelöscht",
  "Tenant integrations access all": "alle Schnittstellen (auch künftig neue Typen)",
  "Tenant integrations access mode label": "erlaubte Schnittstellen-Typen",
  "Tenant integrations access selected": "nur ausgewählte Typen",
  "Tenant integrations allowed types label": "Typen auswählen",
  "Tenant modules access all": "alle Module (auch künftig neue)",
  "Tenant modules access mode label": "aktivierte Module",
  "Tenant modules access selected": "nur ausgewählte Module",
  "Tenant modules allowed label": "Module auswählen",
  "Tenant modules section title": "Module",
  "Tenant modules select at least one": "mindestens ein Modul auswählen.",
  "Tenant modules all active tag": "alle Module",
  "Tenant integrations section title": "Schnittstellen",
  "Tenant integrations select at least one": "mindestens eine Schnittstellen-Art auswählen.",
  "Tenant ID": "Mandant-ID",
  "Tenant name": "Mandantenname",
  "Tenant name is required": "Mandantenname ist erforderlich",
  "Tenants": "Mandanten",
  "Tenants__alt1": "Firmen",
  "Tenant data": "Daten kopieren/löschen",
  "Tenant data card description": "Vorlagen, Stammdaten und Konfiguration zwischen Mandanten kopieren oder gruppenweise löschen",
  "Tenant data additive copy description": "Konfigurationsdaten und zugehörige Vorlagendateien werden additiv ins Ziel kopiert. Bestehende Daten im Ziel bleiben erhalten.",
  "Tenant data allow copy template deletion": "Löschung im Kopiervorlage-Mandanten ausdrücklich erlauben",
  "Tenant data automatic dependency tag": "automatisch (Abhängigkeit)",
  "Tenant data available count": "verfügbar",
  "Tenant data changed reload preview": "Daten haben sich geändert. Bitte Vorschau erneut laden.",
  "Tenant data confirm tenant name label": "Zur Bestätigung den Mandantennamen exakt eingeben",
  "Tenant data copy action": "kopieren",
  "Tenant data copy complete": "Kopie abgeschlossen",
  "Tenant data copy failed": "Kopie fehlgeschlagen",
  "Tenant data copy modal title": "Mandantendaten kopieren",
  "Tenant data copy selection help": "Einzelne Einträge per Checkbox abwählen, um sie nicht zu kopieren.",
  "Tenant data copy tab": "Daten kopieren",
  "Tenant data copy template warning": "Achtung: Mandant ist als Kopiervorlage markiert.",
  "Tenant data create preview action": "Vorschau erstellen",
  "Tenant data delete permanently action": "endgültig löschen",
  "Tenant data delete tab": "Daten löschen",
  "Tenant data delete target first help": "Vor dem Kopieren werden die ausgewählten Gruppen im Ziel komplett gelöscht.",
  "Tenant data delete target first label": "Im Ziel zuerst löschen (Replace-Mode)",
  "Tenant data deletion complete": "Löschung abgeschlossen",
  "Tenant data deletion failed": "Löschung fehlgeschlagen",
  "Tenant data deletion preview title": "Diese Daten werden gelöscht",
  "Tenant data deletion selection help": "Einzelne Einträge per Checkbox abwählen, um sie nicht zu löschen.",
  "Tenant data deletion warning": "Löschung entfernt Vorlagen, Stamm- und Konfigurationsdaten unwiderruflich. Personen, Verträge, Zahlungen und Termine bleiben unangetastet.",
  "Tenant data excluded label": "ausgeschlossen",
  "Tenant data files copied": "Dateien kopiert",
  "Tenant data files removed": "Dateien entfernt",
  "Tenant data groups label": "Gruppen",
  "Tenant data of count": "von",
  "Tenant data preview action": "Vorschau",
  "Tenant data preview failed": "Vorschau fehlgeschlagen",
  "Tenant data remaining rows": "Restzeilen",
  "Tenant data replace mode data loss": "Die bestehenden Daten der gewählten Gruppen im Ziel gehen verloren.",
  "Tenant data replace mode warning": "Replace-Mode: Im Ziel werden die ausgewählten Gruppen zuerst gelöscht und dann durch die Quelle ersetzt.",
  "Tenant data select source tenant": "Quell-Mandanten wählen",
  "Tenant data select target tenant": "Ziel-Mandanten wählen",
  "Tenant data select tenant": "Mandant wählen",
  "Tenant data source label": "Quelle",
  "Tenant data source preview title": "Vorschau des Quell-Mandanten",
  "Tenant data start copy action": "kopieren starten",
  "Tenant data target label": "Ziel",
  "Tenant data target rows": "Datensätze im Ziel",
  "Tenant data target state title": "Stand im Ziel-Mandanten",
  "Tenant data tenant label": "Mandant",
  "Tenant data tenant name mismatch": "Mandantenname passt nicht.",
  "Tenant data tenants load failed": "Mandanten konnten nicht geladen werden",
  "Tenant data transfer description": "Vorlagen, Stamm- und Konfigurationsdaten zwischen Mandanten kopieren oder gruppenweise löschen. Personen, Verträge, Zahlungen und Termine sind ausgeschlossen.",
  "Mandantendaten": "Daten kopieren/löschen",
  "Daten kopieren": "Daten kopieren",
  "Daten loeschen": "Daten löschen",
  "Vorlagen, Stamm- und Konfigurationsdaten zwischen Mandanten kopieren oder gruppenweise loeschen. Personen, Vertraege, Zahlungen und Termine sind ausgeschlossen.": "Vorlagen, Stamm- und Konfigurationsdaten zwischen Mandanten kopieren oder gruppenweise löschen. Personen, Verträge, Zahlungen und Termine sind ausgeschlossen.",
  "Quelle": "Quelle",
  "Ziel": "Ziel",
  "Quell-Mandant waehlen": "Quell-Mandanten wählen",
  "Ziel-Mandant waehlen": "Ziel-Mandanten wählen",
  "Mandant waehlen": "Mandant wählen",
  "Vorschau": "Vorschau",
  "Vorschau erstellen": "Vorschau erstellen",
  "Vorschau Quell-Mandant": "Vorschau Quell-Mandant",
  "Vorschau fehlgeschlagen": "Vorschau fehlgeschlagen",
  "Stand im Ziel-Mandant": "Stand im Ziel-Mandant",
  "Mandantendaten kopieren": "Mandantendaten kopieren",
  "Konfigurationsdaten und zugehoerige Vorlage-Dateien (Templates, Logos, Schriften) werden additiv ins Ziel kopiert. Bestehende Daten im Ziel bleiben erhalten.": "Konfigurationsdaten und zugehörige Vorlagendateien (Vorlagen, Logos, Schriften) werden additiv ins Ziel kopiert. Bestehende Daten im Ziel bleiben erhalten.",
  "Kopieren": "kopieren",
  "Kopieren starten": "kopieren starten",
  "Kopie abgeschlossen": "Kopie abgeschlossen",
  "Kopie fehlgeschlagen": "Kopie fehlgeschlagen",
  "Datensaetze im Ziel": "Datensätze im Ziel",
  "Dateien kopiert": "Dateien kopiert",
  "Dateien entfernt": "Dateien entfernt",
  "Restzeilen": "Restzeilen",
  "von": "von",
  "verfuegbar": "verfügbar",
  "Ausgeschlossen": "Ausgeschlossen",
  "Einzelne Eintraege per Checkbox abwaehlen, um sie nicht zu kopieren.": "Einzelne Einträge per Checkbox abwählen, um sie nicht zu kopieren.",
  "Einzelne Eintraege per Checkbox abwaehlen, um sie nicht zu loeschen.": "Einzelne Einträge per Checkbox abwählen, um sie nicht zu löschen.",
  "entity.ContractTemplate": "Vertragsvorlagen",
  "entity.ContractPackageTemplate": "Vertragspaket-Vorlagen",
  "entity.Plan": "Tarife",
  "entity.TermDefinition": "Laufzeiten",
  "entity.RestPeriodTemplate": "Ruhezeit-Vorlagen",
  "entity.CancellationModelTemplate": "Kündigungsmodelle",
  "entity.PaymentPlan": "Ratenpläne",
  "entity.PriceAdjustment": "Preisanpassungen",
  "entity.ReportTemplate": "Auswertungs-Vorlagen",
  "entity.AvailabilityTemplate": "Verfügbarkeitsvorlagen",
  "entity.WhatsAppMetaTemplate": "WhatsApp-Vorlagen",
  "entity.Studio": "Studios",
  "entity.AppointmentType": "Termin-Typen",
  "entity.AppointmentGroup": "Buchungs-Gruppen",
  "entity.AppointmentOutcome": "Termin-Ergebnisse",
  "entity.AppointmentNotificationSettings": "Termin-Benachrichtigungs-Einstellungen",
  "entity.Resource": "Ressourcen",
  "entity.ReaderDevice": "Lesegeräte",
  "entity.ReaderDeviceQrCode": "Lesegerät-QR-Codes",
  "entity.ReaderDeviceHardware": "Lesegerät-Hardware",
  "entity.HolidayConfig": "Feiertags-Konfigurationen",
  "entity.Holiday": "Feiertage",
  "entity.LeadSource": "Lead-Quellen",
  "entity.LeadPipeline": "Lead-Pipelines",
  "entity.LeadPhase": "Lead-Phasen",
  "entity.Article": "Artikel",
  "entity.PersonTag": "Personen-Tags",
  "entity.BankAccount": "Bankkonten",
  "entity.SepaGroup": "SEPA-Gruppen",
  "entity.SepaSettings": "SEPA-Einstellungen",
  "entity.PaymentMethodDefinition": "Zahlungsarten",
  "entity.WalletProduct": "Wertekonten",
  "entity.ReminderLevel": "Mahnstufen",
  "entity.DebtCollectionAgency": "Inkassodienstleister",
  "entity.VatSettings": "USt.-Einstellungen",
  "entity.AccountingDefaults": "Buchhaltungs-Vorgaben",
  "entity.AccountingAccount": "Buchhaltungskonten",
  "entity.MemberAppSettings": "Member-App-Einstellungen",
  "entity.MemberAppAsset": "Member-App-Bilder",
  "entity.BookingWidgetSettings": "Buchungs-Widget-Einstellungen",
  "entity.LeadWidget": "Lead-Widgets",
  "entity.WidgetDesignTemplate": "Designvorlagen öffentlicher Formulare",
  "entity.ContractSigningWidget": "Vertragsunterschrift-Widgets",
  "entity.ContractSigningWidgetTemplate": "Widget-Vorlagen-Verknüpfungen",
  "entity.DashboardConfig": "Dashboard-Konfigurationen",
  "entity.AppearanceSettings": "Erscheinungsbild",
  "entity.UnitsSettings": "Einheiten/Lokalisierung",
  "entity.EmailProcessingSettings": "E-Mail-Verarbeitung",
  "entity.OutboundMessageSettings": "Versand-Einstellungen",
  "entity.LegalTextSettings": "AGB/Rechtstexte",
  "entity.ApiIntegration": "API-Schnittstellen",
  "entity.CommunicationRule": "Kommunikationsregeln",
  "entity.UserRole": "Benutzerrollen",
  "entity.CalendarSettings": "Kalender-Einstellungen",
  "Diese Daten werden geloescht": "Diese Daten werden gelöscht",
  "Loeschung entfernt Vorlagen, Stamm- und Konfigurationsdaten unwiderruflich. Personen, Vertraege, Zahlungen und Termine bleiben unangetastet.": "Löschung entfernt Vorlagen, Stamm- und Konfigurationsdaten unwiderruflich. Personen, Verträge, Zahlungen und Termine bleiben unangetastet.",
  "Zur Bestaetigung den Mandantennamen exakt eingeben": "Zur Bestätigung den Mandantennamen exakt eingeben",
  "Mandantenname passt nicht.": "Mandantenname passt nicht.",
  "Mandant": "Mandant",
  "Endgueltig loeschen": "Endgültig löschen",
  "Loeschung abgeschlossen": "Löschung abgeschlossen",
  "Loeschung fehlgeschlagen": "Löschung fehlgeschlagen",
  "Daten haben sich geaendert. Bitte Vorschau erneut laden.": "Daten haben sich geändert. Bitte Vorschau erneut laden.",
  "Tenants konnten nicht geladen werden": "Mandanten konnten nicht geladen werden",
  "Abbrechen": "abbrechen",
  "Vorlagen": "Vorlagen",
  "Stammdaten": "Stammdaten",
  "Zahlungs-Konfiguration": "Zahlungs-Konfiguration",
  "App- & Widget-Konfiguration": "App- & Widget-Konfiguration",
  "rows": "Zeilen",
  "Entity": "Entität",
  "Gruppen": "Gruppen",
  "automatisch (Abhaengigkeit)": "automatisch (Abhängigkeit)",
  "Im Ziel zuerst loeschen (Replace-Mode)": "Im Ziel zuerst löschen (Replace-Mode)",
  "Vor dem Kopieren werden die ausgewaehlten Gruppen im Ziel komplett geloescht.": "Vor dem Kopieren werden die ausgewählten Gruppen im Ziel komplett gelöscht.",
  "Replace-Mode: Im Ziel werden die ausgewaehlten Gruppen ZUERST geloescht und dann durch die Quelle ersetzt.": "Replace-Mode: Im Ziel werden die ausgewählten Gruppen ZUERST gelöscht und dann durch die Quelle ersetzt.",
  "Bestehende Daten der gewaehlten Gruppen im Ziel gehen verloren.": "Die bestehenden Daten der gewählten Gruppen im Ziel gehen verloren.",
  "Konfigurationsdaten und zugehoerige Vorlage-Dateien werden additiv ins Ziel kopiert. Bestehende Daten im Ziel bleiben erhalten.": "Konfigurationsdaten und zugehörige Vorlagendateien werden additiv ins Ziel kopiert. Bestehende Daten im Ziel bleiben erhalten.",
  "Achtung: Mandant ist als Kopiervorlage markiert.": "Achtung: Mandant ist als Kopiervorlage markiert.",
  "Loeschung im Kopiervorlage-Mandanten ausdruecklich erlauben": "Löschung im Kopiervorlage-Mandanten ausdrücklich erlauben",
  "Term": "Laufzeit",
  "Termination Dates": "Kündigungstermine",
  "Terms & Conditions": "AGB",
  "Terms Text": "AGB-Text",
  "Terms and Conditions Text": "AGB-Text",
  "Terms URL": "AGB-URL",
  "URL placeholder": "https://…",
  "Test API integration": "API-Schnittstelle testen",
  "Test connection": "Verbindung testen",
  "Test failed. Please check settings.": "Test fehlgeschlagen. Bitte Einstellungen prüfen.",
  "Test IMAP": "IMAP testen",
  "Test mode": "Testmodus",
  "Test Open": "Open testen",
  "Test Ping": "Ping testen",
  "Test SMTP": "SMTP testen",
  "Test successful! Connection works.": "Test erfolgreich! Verbindung funktioniert.",
  "Test": "testen",
  "Test__alt1": "Test",
  "Text Color": "Textfarbe",
  "Text color": "Textfarbe",
  "Text alignment": "Textausrichtung",
  "Company and studio": "Firma mit Studiokontakt",
  "Bold": "fett",
  "Italic": "kursiv",
  "Underline": "unterstrichen",
  "Widget & steps": "Formular & Schritte",
  "Widget background": "Formular-Hintergrund (Buchungskarte)",
  "Widget background tooltip": "Hintergrund der weißen Karte, in der das gesamte Buchungsformular liegt.",
  "Week bar background": "Wochenauswahl Hintergrund",
  "Week bar background tooltip": "Hintergrund der Leiste „Woche X“ mit den Pfeilen zum Wechseln.",
  "Week bar text color": "Wochenauswahl Textfarbe",
  "Week bar text color tooltip": "Textfarbe in der Leiste „Woche X“.",
  "Day selector background": "Tagesauswahl Hintergrund",
  "Day selector background tooltip": "Hintergrund des Bereichs mit den Tages-Kacheln (Mo, Di, …).",
  "Day selector text color": "Tagesauswahl Textfarbe",
  "Day selector text color tooltip": "Textfarbe auf den Tages-Kacheln (Datum, Wochentag).",
  "Day tile background (unselected)": "Tages-Kachel Hintergrund (nicht gewählt)",
  "Day tile background (selected)": "Tages-Kachel Hintergrund (gewählt)",
  "Text is required": "Text ist erforderlich",
  "Text processing": "Textverarbeitung",
  "Text templates": "Textvorlagen",
  "Thank you for your booking!": "Vielen Dank für Ihre Buchung!",
  "Thank you for your request!": "Vielen Dank für Ihre Anfrage!",
  "The account (including stored credentials) will be deleted.": "Das Konto (inkl. gespeicherter Zugangsdaten) wird gelöscht.",
  "The booking group could not be found.": "Die Buchungsgruppe konnte nicht gefunden werden.",
  "The lead widget could not be found.": "Das Kontaktformular konnte nicht gefunden werden.",
  "These texts are displayed in the Studio app (Datenschutz & AGB & Impressum). Full text is embedded; no external links.": "Diese Texte werden in der Studio-App angezeigt (Datenschutz & AGB & Impressum). Vollständiger Text eingebettet, keine externen Links.",
  "The email spooler processes outgoing emails from the queue. These settings control how many emails are sent per batch and how much time must elapse between batches.": "Der E-Mail-Spooler verarbeitet ausgehende E-Mails aus der Warteschlange. Diese Einstellungen steuern, wie viele E-Mails pro Batch versendet werden und wie viel Zeit zwischen den Batches liegen muss.",
  "The final mandate reference should be max. 35 characters.": "Die finale Mandatsreferenz sollte max. 35 Zeichen haben.",
  "The following sub-contracts will also be deleted:": "Es werden auch die folgenden Unterverträge gelöscht:",
  "The following wallets will also be deleted:": "Es werden auch die folgenden Wertekonten gelöscht:",
  "The membership end date has been changed. What should happen to the contributions?": "Das Ende der Mitgliedschaft wurde geändert. Was soll mit den Beiträgen passieren?",
  "What should happen to the contributions for this cancellation?": "Was soll mit den Beiträgen für diese Kündigung passieren?",
  "The cancellation preview could not be loaded.": "Die Kündigungsvorschau konnte nicht geladen werden.",
  "The minimum time between batches helps comply with provider limits (e.g., max. X emails per minute).": "Der Mindestabstand zwischen Batches hilft, Provider-Limits einzuhalten (z. B. max. X E-Mails pro Minute).",
  "The old link will become invalid.": "Der alte Link wird ungültig.",
  "The password is generated automatically and shown once.": "Das Passwort wird automatisch generiert und einmal angezeigt.",
  "The password is shown only here once.": "Passwort wird nur hier einmal angezeigt.",
  "The payment method for the overpayment can differ from the main payment. If nothing is selected, the main payment method will be used.": "Die Zahlungsart für die Überzahlung kann von der Hauptzahlung abweichen. Wird nichts gewählt, wird die Hauptzahlungsart verwendet.",
  "The primary administrator account cannot be deactivated.": "Der primäre Administrator-Account kann nicht deaktiviert werden.",
  "The primary administrator account cannot be deleted.": "Der primäre Administrator-Account kann nicht gelöscht werden.",
  "The primary administrator account must have an email address.": "Der primäre Administrator-Account muss eine E-Mail-Adresse haben.",
  "The role of the primary account cannot be changed": "Die Rolle des primären Accounts kann nicht geändert werden",
  "The role of the primary account cannot be changed.": "Die Rolle des primären Accounts kann nicht geändert werden.",
  "The spooler checks the queue every 30 seconds.": "Der Spooler prüft alle 30 Sekunden die Warteschlange.",
  "Theme": "Design",
  "Theme JSON": "Theme-JSON",
  "Themes": "Designs",
  "There are overlaps or resource capacity is insufficient. Book anyway?": "Es gibt Überschneidungen oder die Ressourcen-Kapazität reicht nicht aus. Dennoch buchen?",
  "These values are prefilled automatically when creating new people.": "Diese Werte werden beim Anlegen neuer Personen automatisch vorbelegt.",
  "This action cannot be undone.": "Diese Aktion kann nicht rückgängig gemacht werden.",
  "This contribution is already included in a SEPA direct debit run and cannot be paid manually": "Dieser Beitrag ist bereits in einem SEPA-Lastschriftlauf enthalten und kann nicht manuell bezahlt werden",
  "This device is already connected to m1connect. A registration code is not required.": "Dieses Gerät ist bereits mit m1connect verbunden. Ein Registrierungscode wird nicht benötigt.",
  "This device is already registered. A new registration code will disconnect the existing connection. The device must register again. Do you want to continue?": "Dieses Gerät ist bereits registriert. Ein neuer Registrierungscode wird die bestehende Verbindung trennen. Das Gerät muss sich dann erneut registrieren. Möchten Sie fortfahren?",
  "This DeviceId is already in use": "Diese Geräte-Id ist bereits vergeben",
  "This feature is planned but not available yet.": "Diese Funktion ist geplant, aber aktuell noch nicht verfügbar.",
  "This field can be edited directly. Cursor can append entries automatically.": "Dieses Feld kann direkt bearbeitet werden. Cursor kann Einträge automatisch anhängen.",
  "This field is fixed in studio accounts.": "Dieses Feld ist im Studioaccount fest vorgegeben.",
  "This page does not exist (anymore).": "Die Seite existiert nicht (mehr).",
  "This pattern is used when creating mandate references in person records.": "Dieses Muster wird beim Erstellen von Mandatsreferenzen in Personendatensätzen verwendet.",
  "This person has no email address.": "Diese Person hat keine E-Mail-Adresse.",
  "This QR code is already in use": "Dieser QR-Code ist bereits vergeben",
  "This system role always has full access.": "Diese Systemrolle hat immer Vollzugriff.",
  "This template does not allow overrides on creation — items are taken from the package and shown here for review only.": "Diese Vorlage erlaubt keine Overrides beim Anlegen – die Positionen werden aus dem Paket übernommen und sind hier nur zur Ansicht.",
  "This template will be available in these studios.": "Die Vorlage wird in diesen Studios verfügbar sein.",
  "This time is already booked in another studio.": "Diese Zeit ist in einem anderen Studio bereits belegt.",
  "This time range overlaps an existing entry.": "Dieser Zeitraum überschneidet sich mit einem bestehenden Eintrag.",
  "This widget currently accepts contact requests only. Appointment booking is not set up.": "Dieses Formular nimmt derzeit nur Kontaktanfragen entgegen. Terminbuchung ist nicht eingerichtet.",
  "Thu": "Do",
  "Thursday": "Donnerstag",
  "Time range": "Zeitraum",
  "Time Slots": "Zeitslots",
  "Time zone": "Zeitzone",
  "Time": "Uhrzeit",
  "Time__alt2": "Zeit",
  "Timeout: Device did not respond in time": "Timeout: Gerät hat nicht rechtzeitig geantwortet",
  "Timeouts": "Timeouts",
  "Times, settings & holidays": "Zeiten, Einstellungen & Feiertage",
  "Timestamp": "Zeitpunkt",
  "Title": "Titel",
  "Title__alt1": "Bezeichnung",
  "TLS/SSL": "TLS/SSL",
  "To contract end": "zum Vertragsende",
  "To end of month": "zum Monatsende",
  "To end of quarter": "zum Quartalsende",
  "To login": "Zur Anmeldung",
  "To renewal end": "zum Verlängerungsende",
  "To:__alt1": "Bis:",
  "To:__alt2": "Nach:",
  "To person": "zur Person",
  "To": "An",
  "Until": "bis",
  "Until__time": "bis",
  "Please check the highlighted fields.": "Bitte prüfen Sie die markierten Felder.",
  "To__alt2": "bis",
  "Good morning": "Guten Morgen",
  "Good afternoon": "Guten Tag",
  "Good evening": "Guten Abend",
  "Today": "heute",
  "Token invalid or expired": "Token ungültig oder abgelaufen",
  "Token missing. Please use the link from the email.": "Token fehlt. Bitte nutzen Sie den Link aus der E-Mail.",
  "Tokens:": "Tokens:",
  "Total": "Gesamt",
  "Total amount": "Gesamtbetrag",
  "Total Amount": "Gesamtbetrag",
  "Total Appointments": "Termine gesamt",
  "Total Cancellations": "Kündigungen gesamt",
  "Total Chargeback Amount": "Gesamtbetrag Rücklastschriften",
  "Total Check-ins": "Check-ins gesamt",
  "Total Contracts": "Gesamt Verträge",
  "Total Leads": "Kontakte gesamt",
  "Total New Members": "neue Mitglieder gesamt",
  "Total No-Shows": "No-Shows gesamt",
  "Total Revenue": "Gesamtumsatz",
  "Total Slots": "Slots gesamt",
  "Total Transactions": "Transaktionen gesamt",
  "Trainer": "Trainer",
  "Training start date is required": "Trainingsbeginn ist erforderlich",
  "Training start is required": "Trainingsbeginn ist erforderlich",
  "Training start is required.": "Trainingsbeginn ist erforderlich.",
  "Standing order": "Dauerauftrag",
  "Transfer": "Überweisung",
  "Transfer to credit wallet": "auf Guthabenkonto buchen",
  "Transitions": "Übergänge",
  "Transitions saved": "Übergänge gespeichert",
  "Trial": "Probezeit",
  "Trial period": "Probezeit",
  "Trial Period": "Probezeit",
  "Trial Period Cancellation Fee": "Probezeit-Kündigungsgebühr",
  "Trigger": "Auslöser",
  "TTL (ms, optional)": "TTL (ms, optional)",
  "Tue": "Di",
  "Tuesday": "Dienstag",
  "Type": "Typ",
  "Type is required__general": "Typ ist erforderlich",
  "Type to search (name or email); up to 50 results per search.": "Tippen Sie zum Suchen (Name oder E-Mail); maximal 50 Treffer pro Suche.",
  "Type to search or no results": "Tippen zum Suchen oder keine Treffer",
  "Type__alt1": "Art",
  "Type__art": "Art",
  "Types": "Arten",
  "Types of appointments": "Arten von Terminen",
  "Unavailabilities": "Abwesenheiten",
  "Unavailabilities & configurable reasons (e.g. vacation, sick)": "Abwesenheiten & konfigurierbare Gründe (z. B. Urlaub, Krank)",
  "Unavailability created": "Abwesenheit angelegt",
  "Unavailability deleted": "Abwesenheit gelöscht",
  "Unavailability reason created": "Abwesenheitsgrund angelegt",
  "Unavailability reason deleted": "Abwesenheitsgrund gelöscht",
  "Unavailability reason updated": "Abwesenheitsgrund aktualisiert",
  "Unavailability reasons": "Abwesenheitsgründe",
  "Unavailability entries": "Einträge",
  "Unavailability updated": "Abwesenheit aktualisiert",
  "Uncategorized": "ohne Kategorie",
  "Underpayment": "Unterzahlung",
  "Active members": "aktive Mitglieder",
  "Unique Members": "Einzigartige Mitglieder",
  "Unit": "Einheit",
  "Units": "Einheiten",
  "Units duplicated.": "Einheiten dupliziert.",
  "Units reset.": "Einheiten zurückgesetzt.",
  "Units saved.": "Einheiten gespeichert.",
  "Units – Default (my settings)": "Einheiten – Standard (meine Einstellungen)",
  "Unknown": "unbekannt",
  "Unknown error": "Unbekannter Fehler",
  "Unlimited": "unbegrenzt",
  "unlimited": "unbegrenzt",
  "Unlock": "entsperren",
  "Unlock device": "Gerät freischalten",
  "Unlock person": "Person entsperren",
  "Unlock…": "entsperren…",
  "Unnamed contract package": "Unbenanntes Vertragspaket",
  "Unnamed sub-contract": "Unbenannter Untervertrag",
  "Unnamed wallet": "Unbenanntes Wertekonto",
  "up": "auf",
  "Update interval (days)": "Update-Intervall (Tage)",
  "Update time": "Update-Zeit",
  "Upload": "hochladen",
  "Upload document": "Dokument hochladen",
  "Upload failed": "Upload fehlgeschlagen",
  "Upload logo": "Logo hochladen",
  "Uploading...": "wird hochgeladen …",
  "Replace logo": "Logo ersetzen",
  "Save first to upload logo": "Bitte zuerst speichern, um ein Logo hochzuladen.",
  "Save configuration first to add reader device assignments": "Bitte zuerst die Konfiguration speichern, um Lesegerät-Zuweisungen hinzuzufügen.",
  "Transaction history": "Transaktionshistorie",
  "Upload image": "Bild hochladen",
  "URL": "URL",
  "Usage history": "Nutzungshistorie",
  "Usage limit": "Nutzungslimit",
  "Usage purposes": "Verwendungszwecke",
  "Usage Reports": "Nutzung Auswertungen",
  "Usage reports": "Nutzungs-Auswertungen",
  "Usage__alt2": "Verwendung",
  "Usage__verwendung": "Verwendung",
  "Use check-in": "Check-in nutzen",
  "Use normal availabilities": "Normale Verfügbarkeiten verwenden",
  "Use sending": "Versand nutzen",
  "Used as default when assigning to contract packages and when manually creating for persons.": "Wird als Standard beim Zuordnen zu Vertragspaketen und beim manuellen Anlegen bei Personen verwendet.",
  "Used by": "genutzt von",
  "Used when multiple contracts for a person are grouped together.": "Wird verwendet, wenn mehrere Verträge einer Person zusammengefasst werden.",
  "Used when only one transaction per person is created.": "Wird verwendet, wenn nur eine Buchung pro Person erstellt wird.",
  "User availabilities": "Benutzer-Verfügbarkeiten",
  "User availability": "Benutzer-Verfügbarkeit",
  "User created": "Benutzer erstellt",
  "User deleted.": "Benutzer gelöscht.",
  "User ID": "Benutzer-ID",
  "User templates": "Benutzervorlagen",
  "Username / email": "Benutzername / E-Mail",
  "Username is required": "Benutzername ist erforderlich",
  "Username or password is incorrect.": "Benutzername oder Passwort stimmt nicht.",
  "User": "Benutzer",
  "Username__alt1": "Benutzer",
  "Users": "Benutzer",
  "Users (staff) belonging to this pool.": "Benutzer (Mitarbeiter), die zu diesem Pool gehören.",
  "Users__alt2": "Nutzer",
  "Users__alt3": "Benutzer",
  "Utilization": "Auslastung",
  "Utilization %": "Auslastung %",
  "Valid from": "gültig ab",
  "Valid from is required": "Gültig ab ist erforderlich",
  "Valid until": "gültig bis",
  "Valid until (optional)": "gültig bis",
  "Valid until:": "gültig bis:",
  "Validity": "Gültigkeit",
  "Pre-training period": "Vorlaufzeit",
  "Value": "Wert",
  "Value account products": "Wertekonto-Produkte",
  "Value accounts": "Wertekonten",
  "Value accounts with balance grant member status": "Wertekonten mit Guthaben gewähren Mitgliedsstatus",
  "Value must be between 0 and 86400": "Wert muss zwischen 0 und 86400 liegen",
  "Value must be between 1 and 500": "Wert muss zwischen 1 und 500 liegen",
  "Variables": "Variablen",
  "Variables: {{resetLink}}, {{displayName}}": "Variablen: {{resetLink}}, {{displayName}}",
  "VAT": "Umsatzsteuer",
  "VAT setting created.": "USt-Einstellung angelegt.",
  "VAT setting deleted.": "USt-Einstellung gelöscht.",
  "VAT setting saved.": "USt-Einstellung gespeichert.",
  "Version": "Version",
  "All rights reserved": "Alle Rechte vorbehalten.",
  "Contact (m1member)": "m1member@mqorva.de",
  "Version added": "Version hinzugefügt",
  "Version deleted": "Version gelöscht",
  "Version updated": "Version aktualisiert",
  "Versions / Changelog": "Versionen / Changelog",
  "View": "ansehen",
  "View logs": "Protokolleinträge ansehen",
  "View logs description": "Systemprotokoll oben rechts und Zugriff auf das Systemprotokoll der Firma.",
  "View appointments": "Termine ansehen",
  "View change history": "Änderungshistorie ansehen",
  "Block/unblock access": "Zutritt sperren/entsperren",
  "View contracts": "Verträge ansehen",
  "View dashboard": "Dashboard anzeigen",
  "View digital file": "Dokumente ansehen",
  "View rest periods": "Ruhezeiten ansehen",
  "Edit rest periods": "Ruhezeiten bearbeiten",
  "View priceAdjustments": "Preisanpassungen ansehen",
  "Edit priceAdjustments": "Preisanpassungen bearbeiten",
  "View tasks": "Aufgaben ansehen",
  "View email queue": "E-Mail-Warteschlange ansehen",
  "View inbox": "Posteingang ansehen",
  "View finances": "Finanzen ansehen",
  "View leads": "Kontakte ansehen",
  "View open items": "offene Posten ansehen",
  "View payments": "Zahlungen ansehen",
  "View people": "Personen ansehen",
  "View reminder levels": "Mahnstufen ansehen",
  "View reminders": "Mahnungen ansehen",
  "View roles": "Rollen ansehen",
  "View SEPA direct debits": "SEPA-Lastschriften ansehen",
  "View settings": "Einstellungen ansehen",
  "View system logs": "Systemprotokoll ansehen",
  "View templates": "Textvorlagen ansehen",
  "View users": "Benutzer ansehen",
  "Visits": "Besuche",
  "Voucher": "Gutschein",
  "Waiting for chip…": "warte auf Chip…",
  "Waiting for device...": "warte auf Gerät…",
  "Wallet": "Wertekonten",
  "Wallet added.": "Wertekonto hinzugefügt.",
  "WalletPaymentMethodRequired": "Bitte eine Zahlungsart wählen.",
  "WalletCannotBeDeletedAlreadyBooked": "Wertekonto darf nicht gelöscht werden (bereits Buchungen vorhanden).",
  "Wallet created": "erstellt",
  "Wallet created (points)": "aufgeladen",
  "Wallet created (currency)": "aufgebucht",
  "Wallet Product": "Wertekonto",
  "Wallet product": "Wertekonto-Produkt",
  "Wallet product__alt2": "Wertprodukt",
  "Wallet Products": "Wertekonten",
  "Wallet products": "Wertekonten",
  "Wallet products__alt2": "Wertekonto-Vorlagen",
  "Wallet saved.": "Wertekonto gespeichert.",
  "Wallet updated": "geändert",
  "Wallets": "Wertekonten",
  "WARNING: Delete direct debit run with downloaded SEPA file?": "WARNUNG: Lastschriftlauf mit heruntergeladener SEPA-Datei löschen?",
  "Warnings": "Warnungen",
  "Webcam": "Webcam",
  "Webcam is only available over HTTPS or localhost.": "Webcam ist nur über HTTPS oder localhost verfügbar.",
  "Website": "Website",
  "Wed": "Mi",
  "Wednesday": "Mittwoch",
  "week": "Woche",
  "Week of month": "Woche im Monat",
  "Week": "Woche",
  "Week__alt1": "KW",
  "Weekday": "Wochentag",
  "Weekday Rule": "Wochentag-Regel",
  "Weekly": "wöchentlich",
  "weekly dues": "Wochenbeiträge",
  "Weekly dues must be >= 0": "Wochenbeiträge müssen >= 0 sein",
  "Weekly planning & templates": "Wochenplanung & Vorlagen",
  "Welcome to our booking system": "Willkommen bei unserem Buchungssystem",
  "We will get back to you shortly.": "Wir melden uns in Kürze bei Ihnen.",
  "When enabled, all open items for a person are combined into a single direct debit transaction.": "Wenn aktiviert, werden alle offenen Posten einer Person zu einer einzelnen Lastschriftbuchung zusammengefasst.",
  "When enabled: Persons with active value account (Balance > 0) are considered members, even without an active contract.": "Wenn aktiviert: Personen mit aktivem Wertekonto (Balance > 0) gelten als Mitglieder, auch ohne aktiven Vertrag.",
  "When enabled, a lead is created when a person logs in via OTP for the first time (if they do not already have one).": "Wenn aktiviert, wird beim ersten OTP-Login einer Person ein Kontakt angelegt (falls sie noch keinen hat).",
  "When the customer books as a lead (customerType = lead), a lead is created. Set default source and studio here.": "Wenn der Kunde als Kontakt bucht (customerType = lead), wird ein Kontakt angelegt. Hier die Standard-Quelle und das Studio.",
  "Widget created": "Formular angelegt",
  "Widget deleted": "Formular gelöscht",
  "Widget updated": "Formular aktualisiert",
  "Widget URL": "Formular-URL",
  "Widget preview": "Formular-Vorschau",
  "Lead widget preview": "Kontaktformular-Vorschau",
  "Color hex placeholder": "#1677ff",
  "Time placeholder": "1:00",
  "Widget UI": "Formular-UI",
  "Header style": "Header-Stil",
  "Day selector style": "Tagesauswahl-Stil",
  "Element alignment": "Ausrichtung",
  "Align left": "links",
  "Align center": "Mitte",
  "Align right": "rechts",
  "Time slots style": "Zeitslots-Stil",
  "Tiles": "Kacheln",
  "Pills": "Pills",
  "Boxed": "Kacheln",
  "Tabs": "Tabs",
  "Premium": "Premium",
  "Minimal": "Minimal",
  "Time slots columns (mobile)": "Zeitslots-Spalten (Mobil)",
  "Time slots columns (desktop)": "Zeitslots-Spalten (Desktop)",
  "Will be displayed as label in the digital file. Variables like {{person.firstName}} will be replaced.": "Wird in den Dokumenten als Bezeichnung angezeigt. Variablen wie {{person.firstName}} werden ersetzt.",
  "with extension": "mit Verlängerung",
  "Withdrawal": "Widerruf",
  "Withdrawal & Trial Period": "Widerruf & Probezeit",
  "Withdrawal Period": "Widerrufsfrist",
  "without extension": "ohne Verlängerung",
  "Word file exported.": "Word-Datei exportiert.",
  "Word file imported.": "Word-Datei importiert.",
  "Wrong confirmation text": "Falscher Bestätigungstext",
  "xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx": "xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx",
  "Year": "Jahr",
  "Yearly": "jährlich",
  "yearly": "jährlich",
  "Yes": "Ja",
  "Yes, book anyway": "ja, dennoch buchen",
  "Yes, change home studio": "Ja, Stammstudio ändern",
  "Yes, create": "Ja, anlegen",
  "Yes, create appointment": "Ja, Termin anlegen",
  "Yes, delete": "Ja, löschen",
  "Yes, regenerate": "Ja, neu erstellen",
  "you (accusative)": "dich/Sie",
  "you (dative)": "dir/Ihnen",
  "you (nominative)": "du/Sie",
  "You are not allowed to open this page.": "Du hast keine Berechtigung, diese Seite zu öffnen.",
  "You can copy or edit table column settings between users here.": "Hier können Sie Tabellen-Spalteneinstellungen zwischen Benutzern kopieren oder bearbeiten.",
  "You can copy templates between users here. The copy is independent of the original.": "Hier können Sie Vorlagen zwischen Benutzern kopieren. Die Kopie ist unabhängig vom Original.",
  "You__alt1": "Du",
  "You__alt2": "Sie",
  "your (feminine)": "deine/Ihre",
  "your (masculine)": "dein/Ihr",
  "Your abbreviation for confirmation (e.g. MK)": "Ihr Kürzel zur Bestätigung (z. B. MK)",
  "Your reply": "Ihre Antwort",
  "Your booking has been confirmed...": "Ihre Buchung wurde erfolgreich bestätigt…",
  "Your booking is confirmed": "Ihre Buchung wurde bestätigt",
  "Booking step appointment": "Terminart",
  "Booking step data": "Daten",
  "Booking step confirm": "Bestätigung",
  "Booking step date": "Termin",
  "Booking step done": "fertig",
  "Booking step studio": "Studio",
  "Select a studio": "Studio wählen",
  "Choose your preferred location": "Wählen Sie Ihren gewünschten Standort",
  "Your Contact Details": "Ihre Kontaktdaten",
  "Your Details": "Ihre Daten",
  "Your password has been changed successfully. You can now sign in.": "Ihr Passwort wurde erfolgreich geändert. Sie können sich jetzt anmelden.",
  "Your privacy policy text...": "Ihr Datenschutztext…",
  "Your imprint text...": "Ihr Impressumstext…",
  "Your terms and conditions...": "Ihre AGB…",
  "Your terms...": "Ihre AGB…",
  "ZIP": "PLZ",
  "Zoom": "Vergrößerung",
  "Zip": "PLZ",
  "ZIP (optional)": "PLZ",
  "Zone created": "Zone angelegt",
  "Zone deleted": "Zone gelöscht",
  "Zone updated": "Zone aktualisiert",
  "Zones saved": "Zonen gespeichert",
  "–": "–",
  "—": "—",
  "— (not specified) —": "— (nicht angegeben) —",
  "…": "…",
  "⚠️ IMPORTANT: This direct debit has already been posted. Cancellation will cancel the associated payment.": "⚠️ WICHTIG: Diese Lastschrift wurde bereits verbucht. Die Stornierung wird die zugehörige Zahlung stornieren.",
  "⚠️ IMPORTANT: This direct debit run has already been posted! All associated payments will be cancelled and open items will be reopened.": "⚠️ WICHTIG: Dieser Lastschriftlauf wurde bereits verbucht! Alle zugehörigen Zahlungen werden storniert und die offenen Posten wieder geöffnet.",
  "⚠️ IMPORTANT: This posting cannot be undone!": "⚠️ WICHTIG: Diese Verbuchung kann nicht mehr rückgängig gemacht werden.",
  "🇩🇪 German": "🇩🇪 Deutsch",
  "🇬🇧 English": "🇬🇧 Englisch",
  "(Global - all studios)": "(Global - alle Studios)",
  "Account active": "Konto aktiv",
  "ActingAccountConfirmationRequired": "Bitte mit deinem Kürzel bestätigen.",
  "AccountAbbreviationAlreadyTaken": "Das Kürzel ist bereits vergeben.",
  "AccountEmailAlreadyTaken": "Diese E-Mail-Adresse ist bereits vergeben.",
  "AccountEmailCollidesWithUsername": "Die E-Mail-Adresse kollidiert mit einem bestehenden Benutzernamen.",
  "AccountUserIdentifiersConflict": "E-Mail, Kürzel oder Benutzername sind bereits vergeben.",
  "AccountUsernameAlreadyTaken": "Der Benutzername ist bereits vergeben.",
  "AccountUsernameCollidesWithEmail": "Der Benutzername kollidiert mit einer bestehenden E-Mail-Adresse.",
  "All": "alle",
  "Appointment Utilization": "Terminauslastung",
  "At least one usage purpose must be selected": "Mindestens ein Verwendungszweck muss ausgewählt sein",
  "City": "Ort",
  "Company": "Firma",
  "Company name is required": "Firmenname ist erforderlich",
  "Confirmation (on booking)": "Bestätigung (bei Buchung)",
  "Confirmation SMS": "SMS-Bestätigung",
  "Confirmation by Email": "Bestätigung per E-Mail",
  "Confirmation by SMS": "Bestätigung per SMS",
  "Confirmation by WhatsApp": "Bestätigung per WhatsApp",
  "Confirmation WhatsApp": "WhatsApp-Bestätigung",
  "Content (HTML)": "Inhalt (HTML)",
  "Create": "anlegen",
  "anlegen": "anlegen",
  "erweiterte Suche": "erweiterte Suche",
  "neue Person": "neue Person",
  "Preisanpassung hinzufügen": "Preisanpassung hinzufügen",
  "Ratenzahlung anlegen": "Ratenzahlung anlegen",
  "suchen": "suchen",
  "Vertragspaket hinzufügen": "Vertragspaket hinzufügen",
  "Zahlung bearbeiten": "Zahlung bearbeiten",
  "Zahlung erfassen": "Zahlung erfassen",
  "Zahlung für mehrere Beiträge": "Zahlung für mehrere Beiträge",
  "Zahlung stornieren": "Zahlung stornieren",
  "Create Contract Template": "Vertragsbaustein anlegen",
  "Create email signature": "E-Mail-Signatur anlegen",
  "Create email template": "E-Mail-Vorlage anlegen",
  "Delete signature": "Signatur löschen",
  "Description": "Beschreibung",
  "Detail": "Detail",
  "Edit email signature": "E-Mail-Signatur bearbeiten",
  "Edit email template": "E-Mail-Vorlage bearbeiten",
  "e.g. Standard signature": "z. B. Standard-Signatur",
  "Email content": "E-Mail-Inhalt",
  "Email content is required": "E-Mail-Inhalt ist erforderlich",
  "Email subject (may contain variables)": "E-Mail-Betreff (kann Variablen enthalten)",
  "Email template confirmation": "E-Mail-Vorlage für Bestätigung",
  "Email template reminder": "E-Mail-Vorlage für Erinnerung",
  "Error loading data": "Fehler beim Laden der Daten",
  "For email + mobile: send both channels": "Bei E-Mail + Mobil: beide Kanäle senden",
  "Former": "ehemalig",
  "Former members": "Ehemalige",
  "Lead Sources": "Kontaktquellen",
  "Lead time SMS (days, hrs, min)": "Vorlaufzeit SMS (Tage, Std., Min.)",
  "Lead time WhatsApp (days, hrs, min)": "Vorlaufzeit WhatsApp (Tage, Std., Min.)",
  "Lead time email (days, hrs, min)": "Vorlaufzeit E-Mail (Tage, Std., Min.)",
  "Member Frequency": "Mitgliederfrequenz",
  "Name": "Name",
  "Name is required": "Name ist erforderlich",
  "Max 255 characters": "Max. 255 Zeichen",
  "New Contracts": "Neuabschlüsse",
  "New signature": "neue Signatur",
  "No signature": "keine Signatur",
  "No text templates available. Please create text templates under 'Templates' first.": "keine Textvorlagen vorhanden. Bitte legen Sie unter „Vorlagen“ zunächst Textvorlagen an.",
  "No-shows": "No-Shows",
  "None (default)": "keine (Standard)",
  "Notes": "Notizen",
  "Notes label": "Notizen-Beschriftung",
  "Open person": "Person öffnen",
  "Person data is managed in Persons": "Stammdaten werden unter Personen gepflegt.",
  "Optional: Assign to a studio. If empty, the account is global for all studios.": "Optional: Zuordnung zu einem Studio. Wenn leer, ist das Konto global für alle Studios.",
  "Other": "Sonstige",
  "Origin and assignment": "Herkunft und Zuordnung",
  "Outgoing (SMTP)": "Versand (SMTP)",
  "Password Delivery": "Passwort-Versand",
  "Please enter a name.": "Bitte einen Namen eingeben",
  "Please enter password (for the test).": "Bitte Passwort eingeben (für den Test).",
  "Popular Appointments": "Beliebte Termine",
  "Reminder (before appointment)": "Erinnerung (vor Termin)",
  "Reminder by Email": "Erinnerung per E-Mail",
  "Reminder by SMS": "Erinnerung per SMS",
  "Reminder by WhatsApp": "Erinnerung per WhatsApp",
  "Reminder Email": "Erinnerungs-E-Mail",
  "Reminder letter document not found": "Der Brief zu dieser Mahnung wurde nicht gefunden.",
  "Reminder SMS": "Erinnerungs-SMS",
  "Reminder WhatsApp": "WhatsApp-Erinnerung",
  "Reminders": "Mahnungen",
  "Required": "erforderlich",
  "Required (checkbox label)": "erforderlich",
  "Resource must be available": "muss verfügbar sein",
  "SMS template confirmation": "SMS-Vorlage für Bestätigung",
  "SMS template reminder": "SMS-Vorlage für Erinnerung",
  "Suppress reminder if confirmation is inside reminder window": "keine Erinnerung senden, wenn die Bestätigung im Erinnerungsfenster erfolgt",
  "WhatsApp template confirmation": "WhatsApp-Vorlage für Bestätigung",
  "WhatsApp template reminder": "WhatsApp-Vorlage für Erinnerung",
  "Sales Performance": "Verkaufsperformance",
  "Standard templates": "Standard-Vorlagen",
  "Studio": "Studio",
  "Studio app": "Studio-App",
  "Studio app design": "Studio-App-Design",
  "Studio app audience former": "ehemaliges Mitglied",
  "Studio app features": "Studio-App-Features",
  "Colors for the Studio app (headers, buttons, backgrounds).": "Farben für die Studio-App (Überschriften, Schaltflächen, Hintergründe).",
  "FinTS (bank connection)": "FinTS (Bankanbindung)",
  "TAN method": "TAN-Verfahren",
  "Select TAN method": "TAN-Verfahren wählen",
  "Test FinTS connection": "FinTS-Verbindung prüfen",
  "FinTS configuration valid.": "FinTS-Konfiguration gültig.",
  "FinTS test failed.": "FinTS-Prüfung fehlgeschlagen.",
  "Save credentials for next time (no need to enter them again for connection test)": "Zugangsdaten speichern",
  "You can save them so you are not asked again next time (TAN may still be required).": "Sie können sie speichern, dann werden Sie beim nächsten Mal nicht mehr danach gefragt (TAN kann weiterhin nötig sein).",
  "Credentials saved. You will not be asked again for the connection test.": "Zugangsdaten gespeichert. Beim nächsten Verbindungstest werden sie nicht erneut abgefragt.",
  "Credentials could not be saved.": "Zugangsdaten konnten nicht gespeichert werden.",
  "Save anyway": "Trotzdem speichern",
  "FinTS bank URL": "FinTS-Bank-URL",
  "FinTS version": "FinTS-Version",
  "FinTS version 3.0": "FinTS 3.0",
  "FinTS version HBCI 2.2": "HBCI 2.2",
  "Bank code (BLZ)": "Bankleitzahl (BLZ)",
  "Bank code (BLZ) is required for FinTS": "Bankleitzahl (BLZ) ist für FinTS erforderlich.",
  "Bank code must be exactly 8 digits": "Bankleitzahl muss genau 8 Ziffern haben.",
  "First run connection test": "Zuerst Verbindung prüfen",
  "First run connection test (with credentials) to see available methods.": "Zuerst Verbindung prüfen (mit Zugangsdaten), um verfügbare TAN-Verfahren zu laden.",
  "Online banking user ID": "Online-Banking-Benutzerkennung",
  "Run test": "Test ausführen",
  "FinTS bank URL is required for connection test": "FinTS-Bank-URL ist für den Verbindungstest erforderlich.",
  "User ID and PIN are required for the connection test.": "Benutzerkennung und PIN sind für den Verbindungstest erforderlich.",
  "Enter your online banking credentials for the connection test. They are not stored.": "Geben Sie Ihre Online-Banking-Zugangsdaten für den Verbindungstest ein. Sie werden nicht gespeichert.",
  "PIN": "PIN",
  "Online connections": "Online-Anbindungen",
  "Add online connection": "Online-Anbindung anlegen",
  "Edit online connection": "Online-Anbindung bearbeiten",
  "Online connection saved.": "Online-Anbindung gespeichert.",
  "Online connection deleted.": "Online-Anbindung gelöscht.",
  "Online connection disabled.": "Online-Anbindung deaktiviert.",
  "Online connections could not be loaded.": "Online-Anbindungen konnten nicht geladen werden.",
  "List data could not be loaded.": "Listendaten konnten nicht geladen werden.",
  "Online bank connections are not enabled for this tenant.": "Online-Bankanbindungen sind für diesen Mandanten nicht freigeschaltet.",
  "All bank accounts already have an online connection.": "Alle Bankkonten haben bereits eine Online-Anbindung.",
  "No online bank connection configured. Set up FinTS in Settings → Bank → Online connections.": "keine Online-Bankanbindung eingerichtet. Richten Sie FinTS unter Einstellungen → Bank → Online-Anbindungen ein.",
  "Please select a bank account.": "Bitte Bankkonto wählen.",
  "Bank account for online connection": "Bankkonto",
  "Select bank account for online connection": "Bankkonto wählen",
  "Connection type": "Anbindungstyp",
  "Credentials": "Zugangsdaten",
  "stored": "gespeichert",
  "not stored": "nicht gespeichert",
  "ready": "bereit",
  "incomplete": "unvollständig",
  "not configured": "nicht eingerichtet",
  "Set up": "einrichten",
  "Disable online connection?": "Online-Anbindung deaktivieren?",
  "Delete online connection?": "Online-Anbindung löschen?",
  "The bank account remains unchanged. Only the online connection will be disabled.": "Das Bankkonto bleibt unverändert. Nur die Online-Anbindung wird deaktiviert.",
  "The bank account remains unchanged. Only the online connection will be deleted.": "Das Bankkonto bleibt unverändert. Nur die Online-Anbindung wird gelöscht.",
  "Disable": "deaktivieren",
  "Enter online banking credentials": "Online-Banking-Zugangsdaten eingeben",
  "FinTS steps": "FinTS-Verlauf",
  "Last tested": "Zuletzt getestet",
  "Save the online connection before running the connection test.": "Speichern Sie die Online-Anbindung, bevor Sie den Verbindungstest ausführen.",
  "Studio app settings card description": "App-Design und Einstellungen pro Mandant.",
  "Studio app settings": "App-Einstellungen (Studio-App)",
  "Studio app settings label": "Bezeichnung",
  "Studio app brand name": "Brand-Name (Login)",
  "Studio app brand name placeholder": "z. B. mQorva Fitness, GRAZIÖS Sportclub",
  "Studio app settings label placeholder": "z. B. Haupt-App, Studio Nord",
  "Studio app settings edit title": "App-Einstellung bearbeiten",
  "Studio app settings basic": "Bezeichnung und Mandant",
  "Distribution and updates": "Verteilung und Updates",
  "Distribution and updates description": "Store-Kennungen werden je Basis-App einmal gepflegt. Optionale und verpflichtende Updates werden nach bestätigter Store-Verfügbarkeit automatisch wirksam.",
  "Save app configuration before distribution": "Speichere die Basis-App zuerst, damit ihre Verteilung zugeordnet werden kann.",
  "Android": "Android",
  "Android package ID": "Android-Paket-ID",
  "Closed test link": "Link zum geschlossenen Test",
  "iPhone and iPad": "iPhone und iPad",
  "iOS bundle ID": "iOS-Bundle-ID",
  "App Store ID": "App-Store-ID",
  "TestFlight invitation link": "TestFlight-Einladungslink",
  "Approve app release": "App-Release freigeben",
  "Create app release": "App-Release anlegen",
  "Create release draft": "Releaseentwurf anlegen",
  "Advance app release": "App-Release weiterführen",
  "Release": "Release",
  "Release state": "Release-Status",
  "Production available": "in Produktion verfügbar",
  "Enforce update": "Update verpflichtend machen",
  "Store verification reference": "Nachweis der Store-Verfügbarkeit",
  "Save release state": "Release-Status speichern",
  "Release history": "Releasehistorie",
  "Enforced": "verpflichtend",
  "Platform": "Plattform",
  "Build number": "Build-Nummer",
  "Release channel": "Freigabekanal",
  "Production": "Produktion",
  "Closed test": "geschlossener Test",
  "Update type": "Update-Art",
  "Optional update": "optionales Update",
  "Mandatory update": "verpflichtendes Update",
  "Await store availability": "Store-Verfügbarkeit abwarten",
  "AppRelease.apps": "Apps",
  "AppRelease.applicationId": "Paket-/Bundle-ID",
  "AppRelease.createConnection": "Store-Zugang anlegen",
  "AppRelease.assignmentCoverage": "Zugeordnete Apps",
  "AppRelease.confirmTest": "Testverfügbarkeit bestätigen",
  "app_release_test_confirmation_invalid": "Für die Testfreigabe wird ein noch nicht freigegebener Testbuild mit hinterlegtem Testlink benötigt.",
  "AppRelease.releases": "App-Updates",
  "AppRelease.deliveries": "Auslieferungen",
  "AppRelease.connections": "Store-Zugänge",
  "AppRelease.policy": "App-Update",
  "AppRelease.mandatory": "Pflichtupdate",
  "AppRelease.mandatoryEnforces": "Ältere App-Versionen werden gesperrt, sobald dieser Build verfügbar ist.",
  "AppRelease.updateKind": "Update-Art",
  "AppRelease.mandatoryUpdate": "Pflichtupdate",
  "AppRelease.optionalUpdate": "optional",
  "AppRelease.internalNote": "Interne Notiz",
  "AppRelease.storeBinding": "Store-Anbindung",
  "AppRelease.storeAvailability": "Store-Verfügbarkeit",
  "AppRelease.confirmedAvailability": "Bestätigte Store-Verfügbarkeit",
  "AppRelease.storeBuild": "Store-Build",
  "AppRelease.buildMissing": "Build noch nicht zugeordnet",
  "AppRelease.testPending": "Testfreigabe ausstehend",
  "AppRelease.testConfirmed": "Testfreigabe bestätigt",
  "AppRelease.testLinkMissing": "Den Testlink bitte in der Store-Anbindung dieser App hinterlegen.",
  "AppRelease.noAccountRequired": "Kein Zugang erforderlich",
  "AppRelease.channelReset": "Beim Kanalwechsel entfallen bisherige Verfügbarkeitsbestätigungen und daraus entstandene Sperren dieses Updates. Für den neuen Kanal müssen die Builds erneut bestätigt werden.",
  "AppRelease.noStoreBindings": "Für diese Plattformen ist noch keine Store-Anbindung an einer App eingerichtet.",
  "app_release_channel_conflict": "Im gewählten Kanal besteht für eine der Apps bereits eine andere Zuordnung dieser Store-Version oder Buildnummer.",
  "AppRelease.technicalVersion": "Technischer Release",
  "AppRelease.platforms": "Plattformen",
  "AppRelease.connection": "Store-Zugang",
  "AppRelease.store": "Store",
  "AppRelease.credentials": "Zugangsdaten",
  "AppRelease.configured": "hinterlegt",
  "AppRelease.notConfigured": "nicht hinterlegt",
  "AppRelease.serviceEmail": "E-Mail des Google-Servicekontos",
  "AppRelease.issuerId": "Apple Issuer-ID",
  "AppRelease.keyId": "Apple Key-ID",
  "AppRelease.privateKey": "Privater Schlüssel (PEM)",
  "AppRelease.keyUnchanged": "Leer lassen, um den gespeicherten Schlüssel beizubehalten. Bei einer geänderten Kontokennung den passenden Schlüssel erneut eingeben.",
  "AppRelease.delivery": "Store-Auslieferung",
  "AppRelease.storeVersion": "Store-Version",
  "AppRelease.availability": "Store-Verfügbarkeit",
  "AppRelease.lastCheck": "Letzte Prüfung",
  "AppRelease.checkError": "Prüfergebnis",
  "AppRelease.notChecked": "noch nicht geprüft",
  "AppRelease.notAvailable": "noch nicht verfügbar",
  "AppRelease.available": "verfügbar",
  "AppRelease.checkFailed": "Prüfung fehlgeschlagen",
  "AppRelease.loadFailed": "Die App-Release-Verwaltung konnte nicht geladen werden.",
  "AppRelease.checkNone": "Keine Fehler",
  "AppRelease.checkConfiguration": "Die Store-Zuordnung oder die Zugangsdaten fehlen oder sind ungültig. Bitte die Konfiguration prüfen.",
  "AppRelease.checkAuthentication": "Die Store-Anmeldung wurde abgelehnt. Bitte die Zugangsdaten prüfen.",
  "AppRelease.checkPermission": "Der Store-Zugang hat keinen Zugriff auf diese App. Bitte die Berechtigungen prüfen.",
  "AppRelease.checkUnreachable": "Der Store ist vorübergehend nicht erreichbar. Bitte später erneut prüfen.",
  "AppRelease.checkResponse": "Die Store-Antwort konnte nicht ausgewertet werden.",
  "AppRelease.connectionSuccessful": "Der Store-Zugang für diese App funktioniert.",
  "AppRelease.testConnection": "Verbindung prüfen",
  "AppRelease.publishedImmutable": "Die Identität einer bereits freigegebenen Auslieferung kann nicht geändert werden.",
  "AppRelease.storeDistribution": "Store-Verteilung",
  "AppRelease.country": "Store-Land (Ländercode)",
  "AppRelease.checkMethod": "Versionsprüfung",
  "AppRelease.publicVersion": "Öffentliche Versionsabfrage",
  "AppRelease.authenticatedBuild": "Genaue Buildprüfung mit Store-Zugang",
  "app_store_configuration_invalid": "Bitte gültige Store-Kennungen und Zugangsdaten angeben.",
  "app_store_connection_missing": "Der gewählte Store-Zugang ist nicht mehr vorhanden.",
  "app_store_private_key_required": "Für diesen Store-Zugang wird ein passender privater Schlüssel benötigt.",
  "app_store_private_key_invalid": "Der private Schlüssel ist ungültig oder passt nicht zum Store.",
  "app_store_connection_in_use": "Dieser Store-Zugang ist einer App zugeordnet und kann deshalb nicht gelöscht werden.",
  "app_store_public_version_ambiguous": "Mehrere Builds verwenden dieselbe Store-Version. Bitte die genaue Buildprüfung verwenden oder eine eindeutige Store-Version zuordnen.",
  "app_release_configuration_invalid": "Bitte Version, Plattformen und Update-Art vollständig und gültig angeben.",
  "app_release_version_exists": "Dieser technische Release ist für den Kanal bereits vorhanden.",
  "app_release_identity_in_use": "Die Zuordnung wird bereits verwendet. Die bestehende Auslieferung darf dadurch nicht verändert oder gelöscht werden.",
  "app_release_platform_disabled": "Der technische Release gilt nicht für die gewählte Plattform.",
  "app_release_delivery_exists": "Für diese App ist der Build oder der technische Release bereits zugeordnet.",
  "Mandatory update reason": "Grund für das verpflichtende Update",
  "Security": "Sicherheit",
  "Authentication": "Anmeldung",
  "API compatibility": "API-Kompatibilität",
  "Data integrity": "Datenintegrität",
  "Native runtime": "native Laufzeit",
  "Dependency security": "Abhängigkeitssicherheit",
  "Approve release": "Release freigeben",
  "Studio app settings description": "Zentrale Liste: Mandant (gebrandet oder Standard) und Studio-Gültigkeit; eine Zeile mit Mandant „Standard (mQorva)“ für Mandanten ohne eigenes Branding.",
  "Studio app settings add title": "App-Einstellungen anlegen",
  "Studio app settings default tenant": "Standard (mQorva)",
  "Studio app settings delete confirm title": "App-Einstellung löschen?",
  "Studio app settings studio scope": "Studio-Gültigkeit",
  "Studio app settings tenant extra": "Leer = Standard (mQorva) für Mandanten ohne eigenes Branding.",
  "Studio app settings tenant placeholder": "Mandant wählen oder Standard",
  "Studio app settings duplicate default hint": "Standardzeile kann nicht dupliziert werden (nur eine erlaubt).",
  "Studio app settings edit design and config": "Design und Einstellungen bearbeiten",
  "Duplicate failed": "Fehler beim Duplizieren",
  "Scope, appointments & access": "Umfang, Termine & Zugang",
  "Features & profile": "Funktionen & Profil",
  "Logo & design": "Logo & Design",
  "Logo and images": "Logo & Bilder",
  "Logo and images intro": "Logo und Slot-Bilder für die Studio-App. Zuerst Konfiguration speichern, dann hochladen.",
  "Studio app preview Home": "Start",
  "Studio app preview Contracts": "Verträge",
  "Studio app preview Bookings": "Termine",
  "Studio app preview Wallets": "Wallet",
  "Studio app preview Open items": "offene Posten",
  "Studio app preview Payments": "Zahlungen",
  "Studio app preview Check-in history": "Besuchshistorie",
  "Studio app preview Studios": "Standorte",
  "Studio app preview Welcome name": "Max",
  "Studio app preview Welcome name full": "Max Mustermann",
  "Studio app preview Welcome name email": "max@beispiel.de",
  "Studio app preview Primary": "primär",
  "Studio app preview Secondary": "sekundär",
  "Studio app preview Sample text color": "Beispieltext in Textfarbe",
  "Studio app preview Sample input": "Beispiel-Eingabe",
  "Studio app preview Sample link": "Beispiel-Link",
  "Studio app preview Your contracts": "deine Verträge",
  "Studio app preview My appointments": "meine Termine",
  "Studio app preview Appointments": "Termine und Reservierungen",
  "Studio app preview Value accounts": "Wertekonten",
  "Studio app preview Points and balance": "Punkte & Guthaben",
  "Studio app preview Dashboard open items": "offene Beiträge",
  "Studio app preview Outstanding amounts": "ausstehende Beträge",
  "Studio app preview Payment history": "Zahlungshistorie",
  "Studio app preview My visits": "Meine Besuche",
  "Studio app preview Visit history subtitle": "Besuchshistorie und Aktivität",
  "Studio app preview Studios and contact": "Studios und Kontakt",
  "Studio app preview Active until …": "aktiv bis …",
  "Studio app preview Active": "aktiv",
  "Studio app preview Appointment type 1": "Yoga",
  "Studio app preview Tomorrow 10:00": "Morgen 10:00",
  "Studio app preview Appointment type 2": "Fitness",
  "Studio app preview In 3 days": "In 3 Tagen",
  "Studio app preview Wallet product": "Trainingseinheiten",
  "Studio app preview 5 units": "5 Einheiten",
  "Studio app preview Open item 1": "Monatsbeitrag März",
  "Studio app preview 50,00 €": "50,00 €",
  "Studio app preview Payment 1": "März 2025",
  "Studio app preview Paid": "bezahlt",
  "Studio app preview Paid on": "bezahlt am",
  "Studio app preview Visit history": "Besuchshistorie",
  "Studio app preview Last 6 weeks": "letzte 6 Wochen",
  "Studio app preview Visit chart placeholder": "Diagramm Besuche pro Woche",
  "Studio app preview Recent visits": "letzte Besuche",
  // Vorschau-Texte im Wortlaut der App (m1app), damit Vorschau und Gerät übereinstimmen.
  "Studio app page contracts": "Verträge",
  "Studio app page bookings": "Termine",
  "Studio app page wallets": "Wertekonten",
  "Studio app page open items": "offene Beiträge",
  "Studio app page payments": "Zahlungen",
  "Studio app page checkin history": "Meine Besuche",
  "Studio app page studios": "Standorte",
  "Studio app card contracts": "Verträge",
  "Studio app card contracts subtitle": "Ihre Verträge",
  "Studio app card bookings": "Meine Termine",
  "Studio app card bookings subtitle": "Termine und Reservierungen",
  "Studio app card wallets": "Wertekonten",
  "Studio app card wallets subtitle": "Punkte & Guthaben",
  "Studio app card open items": "offene Beiträge",
  "Studio app card open items subtitle": "ausstehende Beiträge",
  "Studio app card payments": "Zahlungen",
  "Studio app card payment methods": "Zahlungsarten",
  "Studio app card payment methods subtitle": "Bankverbindung und Zahlungsdaten",
  "Studio app card payments subtitle": "Zahlungshistorie",
  "Studio app card staff schedule": "Dienstplan",
  "Studio app card staff schedule subtitle": "Schichten im Überblick",
  "Studio app card checkin history": "Meine Besuche",
  "Studio app card checkin history subtitle": "Besuchshistorie und Aktivität",
  "Studio app card studios": "Standorte",
  "Studio app card studios subtitle": "Studios und Kontakt",
  "Studio app preview Ends on": "Endet am",
  "Studio app preview Contract ended": "Beendet",
  "Studio app preview Contract active": "aktiv",
  "Studio app preview One-time item": "Startpaket",
  "Studio app preview Trainer name": "A. Schmidt",
  "Studio app preview New appointment": "neuer Termin",
  "Studio app preview Next appointment": "nächster Termin",
  "Studio app preview Tomorrow": "morgen",
  "Studio app preview This week": "diese Woche",
  "Studio app preview Next week": "nächste Woche",
  "Studio app preview places free": "Plätze frei",
  "Studio app preview Balance": "Guthaben",
  "Studio app preview points": "Punkte",
  "Studio app preview Total amount": "Gesamtsumme",
  "Studio app preview Due": "Fällig",
  "Studio app preview Open item generic": "Offener Beitrag",
  "Studio app preview Payment generic": "Zahlung",
  "Studio app preview Payment method transfer": "Überweisung",
  "Studio app preview Average visits": "Im Schnitt",
  "Studio app preview visits per week": "Besuche pro Woche",
  "Studio app preview Heatmap none": "Keine",
  "Studio app preview Studio name 2": "Studio Süd",
  "Bottom bar over limit": "Die App zeigt fünf Plätze. Die weiteren Einträge bleiben gespeichert und rücken nach, sobald Sie ein Symbol darüber entfernen oder eines davon für ein Konto nicht in Frage kommt.",
  "Bottom bar primary": "hervorgehoben",
  "Bottom bar scan needs reader": "nur sichtbar, wenn ein Reverse-QR-Lesegerät zugeordnet ist",
  "Bottom bar order tooltip": "Fünf Plätze. Es erscheint nur, was hier zugeordnet ist — fällt ein Eintrag für ein Konto weg, rückt der nächste zugeordnete nach. Der hervorgehobene Eintrag erscheint als runder Knopf in der Mitte und rückt dafür automatisch dorthin.",
  "QR check-in": "QR-Check-in",
  "Bottom bar entry beyond limit": "Wird in der App derzeit nicht angezeigt – steht hinter dem letzten verfügbaren Platz.",
  "Studio app preview Studio name": "Hauptstudio",
  "Studio app preview Address": "Adresse",
  "Studio app preview Sample address": "Musterstraße 1, 12345 Musterstadt",
  "Studio app preview Sample city": "Musterstadt",
  "Welcome": "Willkommen",
  "Images": "Bilder",
  "Save configuration first to upload images": "Bitte zuerst speichern, um Bilder hochladen zu können",
  "Save configuration first to upload logo and images": "Bitte zuerst die Konfiguration speichern, um Logo und Bilder hochladen zu können.",
  "No images uploaded yet.": "Noch keine Bilder hochgeladen.",
  "No image set.": "kein Bild gesetzt.",
  "Image set": "Bild übernommen.",
  "Click image to use as slot image": "Bild anklicken, um es für diesen Slot zu verwenden.",
  "Image catalog": "Bildkatalog",
  "Ideal size": "Idealgröße",
  "Recommended format": "empfohlenes Format",
  "Choose from catalog": "aus Katalog wählen",
  "No catalog images yet.": "Noch keine Katalogbilder.",
  "Move back to catalog": "zurück in den Katalog",
  "Assign to slot": "Slot zuweisen",
  "Upload to catalog": "in den Katalog hochladen",
  "Load sample images": "Beispielbilder laden",
  "Load sample images tooltip": "Fügt bis zu 10 Indoor-Fitness-/Studio-Bilder (CC0/PD von Wikimedia Commons) in zufälliger Reihenfolge zum Katalog hinzu. Der Slot AuthBackground wird bei Bedarf zufällig befüllt.",
  "Library": "Bibliothek",
  "Adopt": "übernehmen",
  "Studio app standard template": "Studio-App Standardvorlage",
  "Standard template for Studio app": "Standardvorlage für die Studio-App",
  "Standard image (read-only)": "System",
  "New tenant configurations copy design and use these images as fallback. Tenants can override with their own images.": "Mandanten-Konfigurationen übernehmen beim Anlegen das Design und nutzen diese Bilder als Fallback. Mandanten können eigene Bilder verwenden.",
  "Default design and images for the Studio app (used when tenants create new configurations)": "Standard-Design und -Bilder für die Studio-App (wird bei neuen Mandanten-Konfigurationen verwendet)",
  "Order updated": "Reihenfolge aktualisiert",
  "Home hero image": "Startseite Hero-Bild",
  "Auth background image": "Login-Hintergrundbild",
  "Empty state image": "Empty-State-Bild",
  "Card image: Contracts": "Kartenbild: Verträge",
  "Card image: Appointments": "Kartenbild: Termine",
  "Card image: Bookings": "Kartenbild: Termine",
  "Card image: Wallets": "Kartenbild: Wallet",
  "Card image: Open items": "Kartenbild: offene Posten",
  "Card image: Payment methods": "Kartenbild: Zahlungsarten",
  "Card image: Payments": "Kartenbild: Zahlungen",
  "Card image: Staff schedule": "Kartenbild: Dienstplan",
  "Card image: Check-in history": "Kartenbild: Besuchshistorie",
  "Card image: Studios": "Kartenbild: Standorte",
  "Shown on the dashboard. Recommended: wide (16:9) and high contrast.": "Wird auf der Startseite angezeigt. Empfehlung: breit (16:9) und kontrastreich.",
  "Shown on login / onboarding screens. Recommended: portrait and subtle.": "Wird beim Login/Onboarding angezeigt. Empfehlung: Hochformat und dezent.",
  "Shown when lists are empty. Recommended: clean and optimistic.": "Wird bei leeren Listen angezeigt. Empfehlung: klar und positiv.",
  "Image above the Contracts card on the dashboard. Optional.": "Bild über der Verträge-Karte auf der Startseite. Optional.",
  "Image above the Appointments card. Optional.": "Bild über der Termine-Karte. Optional.",
  "Image above the Wallets card. Optional.": "Bild über der Wallet-Karte. Optional.",
  "Image above the Open items card. Optional.": "Bild über der Karte offene Posten. Optional.",
  "Image above the Payment methods card. Optional.": "Bild über der Zahlungsarten-Karte. Optional.",
  "Image above the Payments card. Optional.": "Bild über der Zahlungen-Karte. Optional.",
  "Image above the Staff schedule card. Optional.": "Bild über der Dienstplan-Karte. Optional.",
  "Image above the Check-in history card. Optional.": "Bild über der Besuchshistorie-Karte. Optional.",
  "Image above the Studios card. Optional.": "Bild über der Standorte-Karte. Optional.",
  "Removed": "Entfernt.",
  "Reverse QR (check-in/out)": "Reverse-QR (Check-in/-out)",
  "Reverse QR reader for app": "Reverse-QR-Lesegerät für App",
  "Reverse QR reader assignments for app": "Reverse-QR-Lesegerät-Zuweisungen für die App",
  "Add reader assignment": "Lesegerät-Zuweisung hinzufügen",
  "Sub device (QR code)": "Untergerät (QR-Code)",
  "Actions on scan": "Aktionen beim Scan",
  "No actions available": "keine Aktionen verfügbar",
  "No actions available for selected device": "keine Aktionen für das gewählte Gerät verfügbar",
  "If set, only this reader device accepts scans from the app. Empty = any Reverse-QR device.": "Wenn gesetzt, akzeptiert nur dieses Lesegerät Scans aus der App. Leer = beliebiges Reverse-QR-Gerät.",
  "Studio scope in app": "Studio-Bereich in der App",
  "Studio app config studios": "Studios",
  "HomeStudioOnly = show only home studio. AllStudios = show all studios.": "HomeStudioOnly = nur Heimatstudio. AllStudios = alle Studios.",
  "Advanced": "erweitert",
  "All studios": "alle Studios",
  "All studios (default)": "alle Studios (Standard)",
  "Active studio scope": "aktiver Studio-Scope",
  "Global studio scope aria": "Studio-Sicht für Listen und Dashboard",
  "Global studio scope count": "{0} Studios",
  "Search all studios": "alle Studios durchsuchen",
  "No matches in studio scope": "keine Treffer in „{0}“",
  "Few matches in studio scope": "nur {0} Treffer in „{1}“",
  "Manual check-in computer studio": "Studio für manuellen Check-in an diesem Rechner",
  "Manual check-in computer studio placeholder": "Studio wählen",
  "Manual check-in computer studio missing":
    "kein Studio für manuellen Check-in an diesem Rechner eingestellt – bitte oben im Check-in festlegen",
  "Set manual check-in computer studio": "setzen",
  "Manual check-in computer studio saved toast": "Studio für manuellen Check-in an diesem Rechner gespeichert.",
  "Check-in icon locked": "gesperrt",
  "Bank name": "Bankname",
  "Booking": "Buchung",
  "Button": "Schaltfläche",
  "Check-in & Access": "Check-in & Zutritt",
  "Show password": "Passwort anzeigen",
  "Hide password": "Passwort verbergen",
  "Change plan": "Tarif ändern",
  "Legal": "Rechtliches",
  "The document could not be loaded.": "Das Dokument konnte nicht geladen werden.",
  "Close": "schließen",
  "Member area": "Mitgliederbereich",
  "Profile fields": "Profilfelder",
  "Requires studio approval": "Studio-Bestätigung erforderlich",
  "Self-editable": "selbst bearbeitbar",
  "Show Imprint": "Impressum anzeigen",
  "AllStudios (default)": "alle Studios (Standard)",
  "Profile self-editable fields": "Profil-Felder selbst bearbeitbar",
  "Comma-separated: firstName,lastName,phone,mobile,street,zip,city,country,bankAccountHolder,iban,bic,bankName. Empty = all allowed.": "Komma-getrennt: firstName,lastName,phone,mobile,street,zip,city,country,bankAccountHolder,iban,bic,bankName. Leer = alle erlaubt.",
  "Profile requires approval fields": "Profil-Felder mit Studio-Bestätigung",
  "Comma-separated: Fields that require studio approval. Changes are rejected.": "Komma-getrennt: Felder, die Studio-Bestätigung erfordern. Änderungen werden abgelehnt.",
  "Booking overview": "Termine",
  "Booking widget for app": "Buchungsformular für App",
  "Appointments (App)": "Termine (App)",
  "Select studios, resources and appointment types – these will be bookable in the app under \"Appointments\". With \"Home studio only\", only home studio appointments are shown.": "Wählen Sie Studios, Ressourcen und Terminarten aus – diese werden in der App unter „Termine“ buchbar angezeigt. Bei „nur Stammstudio“ werden nur Termine des Stammstudios angezeigt.",
  "Booking widget for members": "Buchungsformular für Mitglieder",
  "Booking widget for non-members": "Buchungsformular für Nicht-Mitglieder",
  "Online booking group for members in the Studio app": "Online-Buchungsgruppe für Mitglieder in der Studio-App",
  "Online booking group for non-members in the Studio app": "Online-Buchungsgruppe für Nicht-Mitglieder in der Studio-App",
  "Online booking group used in the Studio app for appointments": "Online-Buchungsgruppe, die in der Studio-App für Terminbuchungen verwendet wird",
  "Contract overview": "Verträge",
  "Check-in history": "Check-in-Verlauf",
  "Edit data": "Daten bearbeiten",
  "Pause request": "Ruhezeiten",
  "News": "Neuigkeiten",
  "Opening hours": "Öffnungszeiten",
  "Opening hours block label": "Bezeichnung des Blocks (z. B. Trainerzeiten, Sauna)",
  "Add opening hours block": "Öffnungszeiten-Block hinzufügen",
  "Remove block": "Block entfernen",
  "Move block up": "Block nach oben",
  "Move block down": "Block nach unten",
  "Move up": "nach oben verschieben",
  "Move down": "nach unten verschieben",
  "Duplicate day to next": "Tag zum Folgetag duplizieren",
  "Add time range": "Zeitraum hinzufügen",
  "Studio info": "Studio-Infos",
  "Features and profile intro": "Diese Optionen legen fest, welche Bereiche und Funktionen in der Studio-App sichtbar sind.",
  "Dashboard card order": "Reihenfolge der Dashboard-Karten",
  "Dashboard card order help": "Reihenfolge der Karten auf der Startseite. Ziehen zum Umsortieren.",
  "New row": "neue Zeile",
  "Profile card order": "Reihenfolge der Profil-Karten",
  "Profile card order help": "Die Reihenfolge der Karten auf der Profilseite der App (Persönliche Daten, Einstellungen). Per Drag & Drop anpassen.",
  "Personal data": "Persönliche Daten",
  "Enable at least one dashboard card in the sections above.": "Aktivieren Sie mindestens eine Dashboard-Karte in den Abschnitten oben.",
  "Dashboard cards": "Karten der Startseite",
  "Dashboard cards help": "Haken setzen schaltet die Karte in der App ein, Ziehen ändert die Reihenfolge. Abgehakte Karten bleiben an ihrer Stelle stehen.",
  "More features without a card": "weitere Funktionen ohne eigene Karte",
  "No dashboard cards available for this audience.": "Für diese Zielgruppe gibt es keine Karten.",
  "Appointment scope needs a tenant": "Studios, Ressourcen und Terminarten gehören zu einem Mandanten. Wählen Sie oben einen Mandanten, um sie vorzubelegen.",
  "Studio app brand name required": "Der Markenname ist erforderlich. Ohne ihn zeigt die App „m1app“ und die Store-Übergabe schlägt fehl.",
  "Activate": "aktivieren",
  "Deactivate": "deaktivieren",
  "Bottom bar icons": "Symbole der unteren Leiste",
  "Bottom bar": "untere Leiste",
  "Bottom bar background": "Hintergrund der unteren Leiste",
  "Bottom bar icon color": "Symbolfarbe der unteren Leiste",
  "Bottom bar selected icon color": "Symbolfarbe der unteren Leiste (ausgewählt)",
  "Bottom bar colors": "Farben der unteren Leiste",
  "Bottom bar label home": "Start",
  "Bottom bar label contracts": "Verträge",
  "Bottom bar label bookings": "Termine",
  "Bottom bar label wallets": "Wertekonten",
  "Bottom bar label openItems": "Beiträge",
  "Bottom bar label payments": "Zahlungen",
  "Bottom bar label paymentMethods": "Zahlungsarten",
  "Bottom bar label checkinHistory": "Besuche",
  "Bottom bar label profile": "Profil",
  "Bottom bar label settings": "Einstellungen",
  "Bottom bar label studios": "Standorte",
  "Bottom bar label restPeriods": "Ruhezeiten",
  "Bottom bar label cancellation": "Kündigung",
  "Bottom bar label staffSchedule": "Dienstplan",
  "Bottom bar label scan": "Check-in",
  "Bottom bar empty hint": "Ohne zugeordnete Symbole zeigt die App keine Leiste.",
  "Bottom bar primary icon color": "Symbolfarbe des Primärsymbols",
  "Bottom bar primary button background": "Hintergrund der Primärschaltfläche",
  "Icon order": "Icon-Reihenfolge",
  "Max 4 icons when QR check-in reader is connected.": "Max. 4 Icons, wenn ein QR-Check-in-Lesegerät verbunden ist.",
  "Max 5 icons when no QR check-in reader; with reader, max 4.": "Max. 5 Icons ohne QR-Check-in-Lesegerät; mit Lesegerät max. 4.",
  "Max 5 icons without QR check-in reader.": "Max. 5 Icons ohne QR-Check-in-Lesegerät.",
  "Comma-separated: home, contracts, bookings, wallets, openItems, payments, paymentMethods, checkinHistory, profile, settings, studios, restPeriods, cancellation. Empty = defaults from feature flags.": "Komma-getrennt: home, contracts, bookings, wallets, openItems, payments, paymentMethods, checkinHistory, profile, settings, studios, restPeriods, cancellation. Leer = Standard aus Feature-Flags.",
  "Min. app version": "Min. App-Version",
  "Minimum app version for update check (e.g. 1.2.0)": "Minimale App-Version für Update-Prüfung (z. B. 1.2.0)",
  "Design JSON": "Design-JSON",
  "Optional JSON for colors and styles (primaryColor, secondaryColor, etc.).": "Optionales JSON für Farben und Stile (primaryColor, secondaryColor usw.).",
  "Enable or disable features shown in the Studio app. These settings apply tenant-wide.": "Aktivieren oder deaktivieren Sie Funktionen in der Studio-App. Diese Einstellungen gelten mandantenweit.",
  "Lead on first login": "Kontakt beim ersten Login",
  "Studio for leads created on login": "Studio für beim Login erzeugte Kontakte",
  "Feature selection, lead on login, privacy policy, terms, imprint": "Funktionsauswahl, Kontakt-Anlage beim Login, Datenschutz, AGB, Impressum",
  "Subject required": "Betreff erforderlich",
  "T": "T",
  "Template loaded, but the editor did not apply the content.": "Vorlage wurde geladen, aber der Editor hat den Inhalt nicht übernommen.",
  "Templates": "Vorlagen",
  "Templates for Cancellations": "Vorlagen für Kündigungen",
  "Templates for notifications": "Vorlagen für Benachrichtigungen",
  "Templates for Reminders": "Vorlagen für Mahnungen",
  "Text template category: contract confirmation": "Vorlagen für Vertragsbestätigung",
  "Templates for Rest Periods": "Vorlagen für Ruhezeiten",
  "Trainer Utilization": "Trainer-Auslastung",
  "Username": "Benutzername",
  "Start time": "Startzeit",
  "End time": "Endzeit",
  "What should this email account be used for?": "Wofür soll dieses E-Mail-Konto verwendet werden?",
  "Who can book": "Wer darf buchen",
  "e.g. Cancellation confirmation email": "z. B. Kündigungsbestätigung E-Mail",
  "e.g. Contact": "z. B. Kontakt",
  "e.g. m1member Studio LLC": "z. B. m1member Studio GmbH",
  "e.g. 09:00": "z. B. 09:00",
  "e.g. 18:00": "z. B. 18:00",
  "e.g. Standard Sales": "z. B. Standard Vertrieb",
  "sent": "gesendet",
  "An error occurred": "Ein Fehler ist aufgetreten",
  "Error details": "Fehlerdetails",
  "Error cause": "Fehlerursache",
  "Error ID support hint": "Diese ID dem Support nennen.",
  "Copy error details": "Fehlerdetails kopieren",
  "Copy full error report": "kompletten Fehlerbericht kopieren",
  "Copy support info": "Support-Infos kopieren",
  "Copy technical details": "Technische Details kopieren",
  "Full error report copied to clipboard": "Kompletter Fehlerbericht wurde in die Zwischenablage kopiert.",
  "Support info copied": "Support-Infos wurden in die Zwischenablage kopiert.",
  "Technical details copied": "Technische Details wurden in die Zwischenablage kopiert.",
  "API": "API",
  "Body text preview": "Body-Text (erste 2000 Zeichen)",
  "Component stack": "Component-Stack",
  "Error properties": "Fehlereigenschaften",
  "Error report URL": "URL",
  "Error report user agent": "User-Agent",
  "Error source": "Fehlerquelle",
  "React error decoder": "React-Fehler entschlüsseln",
  "Decode React error": "React-Fehler entschlüsseln",
  "Shows full message": "zeigt die vollständige Meldung",
  "Probable source (app code)": "Vermutliche Quelle (App-Code)",
  "Copy error info": "Fehlerinfo kopieren",
  "Error info copied": "Fehlerinfo kopiert",
  "Error message": "Fehlermeldung",
  "The person could not be loaded.": "Die Person konnte nicht geladen werden.",
  "No details available.": "keine Details verfügbar.",
  "Critical startup error": "Kritischer Fehler beim Start",
  "Database is being checked…": "Datenbank wird geprüft…",
  "Database is being updated…": "Datenbank wird aktualisiert…",
  "Database migration failed": "Datenbankmigration fehlgeschlagen",
  "Migration failure support instruction": "m1member kann nicht gestartet werden. Bitte wenden Sie sich an {0}. Nach der Behebung wird die Anwendung automatisch neu geladen.",
  "Developer information": "Entwickler-Information",
  "Error location": "Ort des Fehlers",
  "Line": "Zeile",
  "Page where error occurred": "Aufgerufene Seite",
  "module of this page": "Modul dieser Seite",
  "Error ID (for support):": "Fehler-ID (für Support):",
  "Request ID (for support):": "Anfrage-ID (für Support):",
  "Collapse main sidebar": "Seitenleiste zuklappen",
  "Collapse section": "Abschnitt einklappen",
  "Expand main sidebar": "Seitenleiste aufklappen",
  "Expand section": "Abschnitt ausklappen",
  "m1member": "m1member",
  "Page could not be loaded": "Seite konnte nicht geladen werden",
  "Page could not be loaded after update":
    "Seite konnte nicht geladen werden: ein Teil der Anwendung ließ sich nicht nachladen. Das kann nach einem Release passieren, aber auch durch Netzwerk, Browser-Cache, Werbeblocker oder einen vorgeschalteten Proxy (z. B. Cloudflare). Bitte hart neu laden (Strg+F5) oder den direkten Aufruf der genannten .js-URL im Netzwerk-Tab prüfen (Status, nicht HTML).",
  "Page could not be loaded reload": "Seite konnte nicht geladen werden. Bitte Seite neu laden (F5).",
  "Please wait a moment.": "Bitte einen Moment warten.",
  "Please wait a moment. During this time, the application may be temporarily unavailable.": "Bitte einen Moment warten. Währenddessen kann die Anwendung kurzzeitig nicht genutzt werden.",
  "Reload page": "Seite neu laden",
  "Server is still starting…": "Server startet noch…",
  "Stack": "Stack",
  "The application is currently in maintenance mode. Please inform an administrator.": "Die Anwendung ist aktuell im Wartungsmodus. Bitte informieren Sie einen Administrator.",
  "The application is currently under maintenance. Please reload. If the problem persists, please inform an administrator.": "Die Anwendung wird gerade gewartet. Bitte laden Sie neu. Falls das Problem bestehen bleibt, informieren Sie bitte einen Administrator.",
  "The application is currently in maintenance mode. Please contact support.": "Die Anwendung ist aktuell im Wartungsmodus. Bitte wenden Sie sich an {0}.",
  "The database could not be updated. Please contact support so the migration can be checked.": "Die Datenbank konnte nicht aktualisiert werden. Bitte wenden Sie sich an {0}, damit die Migration geprüft werden kann.",
  "The page could not be loaded. You can navigate to another page or reload this page.": "Die Seite konnte nicht geladen werden. Sie können zu einer anderen Seite navigieren oder die Seite neu laden.",
  "Unhandled error. See details below; reload the page or go to dashboard.": "Ein unerwarteter Fehler ist aufgetreten. Details siehe unten; Seite neu laden oder zum Dashboard wechseln.",
  "This can happen after an update. Please reload the page (F5).": "Das kann nach einem Update passieren. Bitte laden Sie die Seite neu (F5).",
  "Booking group not found": "Buchungsgruppe nicht gefunden",
  "This booking page does not exist or is not available.": "Diese Buchungsseite existiert nicht oder ist nicht verfügbar.",
  "Booking successful!": "Buchung erfolgreich!",
  "Booking number": "Terminnummer",
  "Please keep your booking number. You have received a confirmation by email.": "Bitte bewahren Sie Ihre Terminnummer auf. Sie haben eine Bestätigung per E-Mail erhalten.",
  "1. Select appointment type": "1. Terminart wählen",
  "Please select an appointment type": "Bitte wählen Sie eine Terminart",
  "2. Select appointment": "2. Termin auswählen",
  "3. Your details": "3. Ihre Daten",
  "Please enter": "Bitte eingeben",
  "Please enter a valid email": "Bitte gültige E-Mail eingeben",
  "Notes (optional)": "Anmerkungen",
  "Book now (binding)": "Jetzt verbindlich buchen",
  "Login account created": "Login-Account angelegt",
  "Password is only shown here once.": "Passwort wird nur hier einmal angezeigt.",
  "Selected studios": "ausgewählte Studios",
  "Sum (selected)": "Summe (ausgewählt)",
  "Selected payments__alt": "ausgewählte Zahlungen",
  "No permission.": "keine Berechtigung.",
  "New login account": "neuer Login-Account",
  "Edit login account": "Login-Account bearbeiten",
  "Create login account": "Login-Account anlegen",
  "Studio access": "Studio-Zugriff",
  "Please select studios": "Bitte Studios auswählen",
  "Password is only shown when creating.": "Passwort wird nur beim Anlegen angezeigt.",
  "e.g. MANDATE-REF-12345": "z. B. MANDATE-REF-12345",
  "e.g. 1:00 for one hour": "z. B. 1:00",
  "e.g. 1:00 for one hour, 0:30 for 30 minutes": "z. B. 1:00 für eine Stunde, 0:30 für 30 Minuten",
  "e.g. 49.00": "z. B. 49,00",
  "System Default": "System-Standard",
  ".booking-widget { /* your styles */ }": ".booking-widget { /* your styles */ }",
  "Studio assignment": "Studio-Zuweisung",
  "House No.": "Hausnr.",
  "Delete reminder level": "Mahnstufe löschen",
  "Edit reminder level": "Mahnstufe bearbeiten",
  "Create reminder level": "Mahnstufe anlegen",
  "e.g. 14": "z. B. 14",
  "e.g. 1. reminder": "z. B. „1. Mahnung“",
  "(no further escalation)": "(keine Folgestufe)",
  "(no debt collection)": "(kein Inkasso)",
  "e.g. noreply@company.com": "z. B. noreply@firma.de",
  "e.g. imap.gmail.com": "z. B. imap.gmail.com",
  "e.g. sepa": "z. B. sepa",
  "e.g. B": "z. B. B",
  "Regenerate password": "Passwort neu erstellen",
  "Select role...": "Rolle wählen…",
  "pain.008.001.08": "pain.008.001.08",
  "pain.008.001.02": "pain.008.001.02",
  "YYYYMMDD": "YYYYMMDD",
  "--:--": "--:--",
  "None (without installments)": "keine (ohne Raten)",
  "Delete contract module": "Vertragsbaustein löschen",
  "Select locations…": "Standorte wählen…",
  "Default term (optional)": "Standard-Laufzeit",
  "Default renewal (optional)": "Standard-Verlängerung",
  "Default payment method": "Standard-Zahlungsart",
  "{0} → {1} from {2}": "{0} → {1} ab {2}",
  "remains {0}": "bleibt {0}",
  "Payment method fixed": "Zahlart fest",
  "Payment method fixed hint": "Ein Wechsel des Zahlungsprofils ändert die Zahlart dieses Bausteins nicht, z. B. für einen Barzahler-Tarif.",
  "Default direct debit group": "Standard-Lastschriftgruppe",
  "None": "keine",
  "Default payment cycle (optional)": "Standard-Zahlungszyklus",
  "Payment cycle: every {0} {1}": "alle {0} {1}",
  "Default usage limit (optional)": "Standard-Nutzungslimit",
  "Please choose…": "Bitte wählen…",
  "Installments (min/max)": "Raten (Min/Max)",
  "Contributions {DUE_DATE} ({CONTRACT_COUNT} contracts)": "Beiträge {DUE_DATE} ({CONTRACT_COUNT} Verträge)",
  "Tomorrow": "morgen",
  "First of next month": "nächster Monatserster",
  "e.g. Premium membership": "z. B. Premium-Mitgliedschaft",
  "Start preset": "Start-Voreinstellung",
  "Initial value": "Startwert",
  "Loading context data …": "Kontextdaten werden geladen …",
  "Basic": "Basis",
  "m1access M1AU-RQR.R01": "m1access M1AU-RQR.R01",
  "m1connect": "m1connect",
  "One-time (this year only)": "einmalig (nur dieses Jahr)",
  "Yearly on the same date": "jährlich am gleichen Datum",
  "Yearly on X. weekday of month": "jährlich am X. Wochentag im Monat",
  "1.": "1.",
  "2.": "2.",
  "3.": "3.",
  "4.": "4.",
  "1st": "1.",
  "2nd": "2.",
  "3rd": "3.",
  "4th": "4.",
  "last": "letzter",
  "Min.": "Min.",
  "Max.": "Max.",
  "Preview mode: submission disabled": "Vorschau-Modus: Absenden ist deaktiviert.",
  "Lead widget: thank you title": "Danke!",
  "Lead widget: thank you subtitle": "Wir melden uns in Kürze bei dir.",
  "Lead widget: accept privacy policy": "Ich akzeptiere die Datenschutzerklärung",
  "Lead widget: privacy policy link": "Datenschutzerklärung",
  "Lead widget: privacy acceptance required": "Bitte akzeptiere die Datenschutzerklärung.",
  "Lead widget: accept terms": "Ich akzeptiere die AGB",
  "Lead widget: terms link": "AGB",
  "Lead widget: terms acceptance required": "Bitte akzeptiere die AGB.",
  "Lead widget: accept impressum": "Ich akzeptiere das Impressum",
  "Lead widget: impressum acceptance required": "Bitte bestätige das Impressum.",
  "Lead widgets: create": "Kontaktformular anlegen",
  "Lead widgets: code tooltip": "Optional. Wenn leer, wird automatisch ein Code erzeugt.",
  "Lead widgets: regenerate code": "Code neu erzeugen",
  "Lead widgets: embed hint": "Formular speichern, um Einbindungs-Code zu erzeugen.",
  "Design name": "Design-Name",
  "Background": "Hintergrund",
  "Font": "Schriftart",
  "Show privacy policy": "Datenschutzerklärung anzeigen",
  "Require privacy acceptance": "Datenschutz-Bestätigung erforderlich",
  "Privacy policy URL": "Datenschutz-URL",
  "Show terms": "AGB anzeigen",
  "Require terms acceptance": "AGB-Bestätigung erforderlich",
  "Compatible reader devices (assign with checkbox, set flags)": "Kompatible Lesegeräte: mit Häkchen zuordnen, Flags setzen.",
  "Select icons (order = display order)": "Icons wählen (Reihenfolge = Anzeige)",
  "Reverse QR enables members to check in and out via the app by scanning the reader device QR code.": "Reverse QR ermöglicht Mitgliedern, sich per App ein- und auszuchecken, indem sie den QR-Code des Lesegeräts scannen.",
  "Add icon": "Icon hinzufügen",
  "No icons selected. Use Add icon to add items.": "keine Icons ausgewählt. Nutzen Sie „Icon hinzufügen“, um Einträge hinzuzufügen.",
  "Studio App": "Studio-App",
  "Content area": "Inhaltsbereich",
  "Primary button": "primäre Schaltfläche",
  "App title": "App-Titel",
  "Company name": "Firmenname / Studios",
  "Your company or studio name": "Ihr Firmen- oder Studiosname",
  "Cards": "Karten",
  "Card border radius": "Eckenradius",
  "Card elevation": "Schatten (Elevation)",
  "Card border color": "Rahmenfarbe",
  "Card border width": "Karten-Rahmenstärke",
  "Inputs, divider & links": "Eingabefelder, Trennlinien & Links",
  "Input background color": "Eingabe-Hintergrundfarbe",
  "Input border color": "Eingabe-Rahmenfarbe",
  "Input text color": "Eingabe-Textfarbe",
  "Input border radius": "Eingabe-Eckenradius",
  "Divider color": "Trennlinien-Farbe",
  "Divider thickness": "Trennlinien-Stärke",
  "Card text color (title)": "Textfarbe (Titel)",
  "Card subtitle color": "Untertitel-Farbe",
  "Card background color": "Hintergrundfarbe",
  "Header background (logo area)": "Kopfbereich (Logo) – Hintergrund",
  "Header text and icon color": "Kopfbereich – Text und Icon",
  "Secondary text color (meta)": "Zweittextfarbe (Meta)",
  "Colors": "Farben",
  "Design colors and surfaces": "Design: Farben und Flächen",
  "Accent color (header)": "Akzentfarbe (Header)",
  "Accent color (buttons, header)": "Akzentfarbe (Schaltflächen, Kopfbereich)",
  "Secondary accent": "Zweitakzent",
  "Buttons": "Schaltflächen",
  "Button colors, border, shadow": "Schaltflächenfarben, Rahmen, Schatten",
  "Primary button background": "Hintergrund der primären Schaltfläche",
  "Primary button text color": "Textfarbe der primären Schaltfläche",
  "Primary button border color": "Rahmenfarbe der primären Schaltfläche",
  "Button border radius": "Eckenradius der Schaltfläche",
  "Button border color": "Rahmenfarbe der Schaltfläche",
  "Button border width": "Rahmenstärke der Schaltfläche",
  "Button elevation": "Schatten der Schaltfläche",
  "Secondary button border color": "Rahmenfarbe der sekundären Schaltfläche",
  "Secondary button text color": "Textfarbe der sekundären Schaltfläche",
  "Secondary button background": "Hintergrund der sekundären Schaltfläche",
  "Tertiary button text color": "Textfarbe der tertiären Schaltfläche",
  "Background color where logo and app title are shown": "Hintergrundfarbe des Bereichs, in dem Logo und App-Titel angezeigt werden.",
  "Shadows and corners": "Schatten und Ecken",
  "Login overlay": "Login-Overlay",
  "Overlay style": "Overlay-Art",
  "Darken": "abdunkeln",
  "Lighten": "aufhellen",
  "Overlay opacity": "Overlay-Deckkraft",
  "Text and icon color on overlay": "Text- und Icon-Farbe auf dem Overlay",
  "Design texts": "Texte",
  "Card border radius tooltip": "z. B. 12",
  "Card elevation tooltip": "0 = kein Schatten",
  "Show QR reader in preview": "QR-Leser in Vorschau anzeigen",
  "QR-Scanner": "QR-Scanner",
  "Usage": "Nutzung",
  "Leads & Sales": "Kontakte & Sales",
  "Member stock development": "Bestandsentwicklung",
  "Member stock development over time": "Entwicklung des Mitgliederbestands über Zeit",
  "New acquisitions": "Neuabschlüsse",
  "Analysis of new members and contracts": "Analyse neuer Mitglieder und Verträge",
  "Cancellation analysis and churn rate": "Kündigungsanalyse und Kündigungsquote",
  "Inactive members": "inaktive Mitglieder",
  "Retention: members without check-ins": "Bindung: Mitglieder ohne Check-ins",
  "Contract distribution": "Vertragsverteilung",
  "Distribution by tariff and term": "Verteilung nach Tarifen und Laufzeiten",
  "Term analysis": "Laufzeitanalyse",
  "Contract terms and renewals": "Vertragslaufzeiten und Verlängerungen",
  "Expiring contracts": "auslaufende Verträge",
  "Contracts ending soon": "Verträge mit bevorstehendem Ende",
  "Revenue overview": "Umsatzübersicht",
  "Total revenue and trend": "Gesamtumsatz und Entwicklung",
  "Open and overdue items analysis": "Analyse offener und überfälliger Posten",
  "Chargebacks and failure rate": "Rücklastschriften und Fehlerquote",
  "Cashflow analysis": "Cashflow-Analyse",
  "Cash in and out over time": "Ein- und Auszahlungen über Zeit",
  "Revenue by tariff": "Umsatz nach Tarifen",
  "Revenue distribution by tariff/product": "Umsatzverteilung pro Tarif/Produkt",
  "Check-in analysis": "Check-in-Analyse",
  "Check-ins over time and per studio": "Check-ins über Zeit und pro Studio",
  "Peak times": "Peak-Zeiten",
  "Utilization by time of day and weekday": "Auslastung nach Tageszeit und Wochentag",
  "Studio utilization": "Studio-Auslastung",
  "Studio usage comparison": "Vergleich der Studio-Frequentierung",
  "Member frequency": "Mitgliederfrequenz",
  "Visit frequency distribution": "Verteilung der Besuchshäufigkeit",
  "Visit frequency per member": "Besuchshäufigkeit pro Mitglied",
  "Appointment utilization": "Terminauslastung",
  "Appointments and classes utilization": "Auslastung von Terminen und Kursen",
  "No-show analysis": "No-Show-Analyse",
  "Missed appointments": "nicht wahrgenommene Termine",
  "Trainer utilization": "Trainer-Auslastung",
  "Utilization per trainer/resource": "Auslastung pro Trainer/Ressource",
  "Popular appointments": "Beliebte Termine",
  "Most booked appointments and times": "Meist gebuchte Termine und Zeiten",
  "Lead sources": "Kontaktquellen",
  "Lead origin and distribution": "Herkunft und Verteilung von Kontakten",
  "Conversion rate": "Conversion-Rate",
  "Lead to member conversion": "Konversion von Kontakt zu Mitglied",
  "Pipeline analysis": "Pipeline-Analyse",
  "Leads by status and phase": "Kontakte pro Status und Phase",
  "Sales performance": "Verkaufsperformance",
  "Sales per employee": "Abschlüsse pro Mitarbeiter",
  "WhatsApp templates and phone onboarding": "WhatsApp-Einrichtung",
  "WhatsApp Meta templates": "WhatsApp-Meta-Vorlagen",
  "Sync from Meta": "von Meta abrufen",
  "Submit template": "Vorlage einreichen",
  "Phone number onboarding": "Nummern-Onboarding",
  "Country code (e.g. 49)": "Ländervorwahl (z. B. 49)",
  "Phone number (without +)": "Telefonnummer (ohne +)",
  "Display name at Meta": "Anzeigename bei Meta",
  "Add phone number": "Nummer hinzufügen",
  "Request verification code": "Verifizierungscode anfordern",
  "Code delivery": "Code-Zustellung",
  "Voice": "Anruf",
  "2-step verification PIN": "2-Schritt-Verifizierungs-PIN",
  "Register phone number": "Nummer registrieren",
  "Phone number registered successfully": "Nummer erfolgreich registriert",
  "Template name (lowercase, underscores)": "Vorlagenname (Kleinbuchstaben, Unterstriche)",
  "Language code": "Sprachcode",
  "Components (JSON, Meta format)": "Komponenten (JSON, Meta-Format)",
  "Error loading templates": "Vorlagen konnten nicht geladen werden",
  "WhatsApp templates synced": "WhatsApp-Vorlagen abgeglichen",
  "Template submitted to Meta": "Vorlage bei Meta eingereicht",
  "Body preview": "Textvorschau",
  "Verification code sent. Enter code and 2-step PIN to register.": "Verifizierungscode wurde versendet. Code und 2-Schritt-PIN eingeben und registrieren.",
  "Contract document": "Vertragsdokument",
  "Skip": "überspringen",
  "Generate and send contract document": "Vertragsdokument erzeugen und versenden",
  "Generate contract document and send via the selected channels?": "Vertragsdokument erzeugen und über die gewählten Kanäle versenden?",
  "Send by email": "per E-Mail versenden",
  "Contract document generated and sent.": "Vertragsdokument erzeugt und versendet.",
  "Integration": "Schnittstelle",
  "Signature and send": "Unterschrift & Versand",
  "Close contract wizard: contract for": "Vertrag für",
  "Close contract wizard: read then sign hint": "Vertrag oben durchlesen, unten unterschreiben.",
  "Capture signature": "Unterschrift erfassen",
  "Without signature": "ohne Unterschrift",
  "With signature (tablet)": "mit Unterschrift (Tablet)",
  "Contract will be created and the contract document will be generated from the selected template.": "Vertrag wird angelegt und das Vertragsdokument wird aus der gewählten Vorlage erzeugt.",
  "Contract will be created without generating a contract document.": "Vertrag wird ohne Vertragsdokument angelegt.",
  "Sign here (finger or stylus). The contract document will be generated with your signature and can be sent immediately.": "Hier unterschreiben (Finger oder Stift). Das Vertragsdokument wird mit Ihrer Unterschrift erzeugt und kann sofort versendet werden.",
  "Close contract wizard: no contract document template": "Bitte wählen Sie eine Vertragsdokument-Vorlage, wenn der Vertrag unterschrieben oder versendet werden soll.",
  "Contract document template": "Vertragsdokument-Vorlage",
  "Please select a contract document template.": "Bitte Vertragsdokument-Vorlage wählen.",
  "Contract document could not be generated after contract closing.": "Der Vertrag wurde angelegt, aber das Vertragsdokument konnte nicht erzeugt werden.",
  "Signature": "Unterschrift",
  "Signature (appended to email)": "Signatur (an E-Mail anhängen)",
  "Signature content": "Signaturinhalt",
  "Signature created": "Signatur angelegt",
  "Signature updated": "Signatur aktualisiert",
  "Signatures": "Signaturen",
  "Close contract with signature": "Vertrag mit Unterschrift abschließen",
  "Please sign in the signature field before submitting.": "Bitte im Unterschriftenfeld unterschreiben, bevor Sie abschließen.",
  "Online contracts": "Online-Verträge",
  "Contract widget": "Vertragsformular",
  "Contract widget: widget not found or not available": "Formular nicht gefunden oder nicht verfügbar.",
  "Contract widget: please select a template": "Bitte wählen Sie eine Vertragsvorlage.",
  "Contract widget: signature required": "Unterschrift ist erforderlich.",
  "Contract widget: SEPA mandate title": "SEPA-Lastschriftmandat",
  "Contract widget: SEPA mandate info": "Diese Mitgliedschaft wird per Lastschrift bezahlt. Bitte geben Sie die Bankverbindung ein und bestätigen Sie das SEPA-Lastschriftmandat.",
  "Contract widget: mandate reference generated": "Die Mandatsreferenz wird beim Abschluss automatisch erstellt und in den Stammdaten gespeichert.",
  "Contract widget: SEPA mandate acceptance": "Ich ermächtige das Studio, Zahlungen von meinem Konto mittels SEPA-Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die vom Studio auf mein Konto gezogenen Lastschriften einzulösen.",
  "Contract widget: SEPA mandate acceptance required": "Das SEPA-Lastschriftmandat muss bestätigt werden.",
  "Account holder is required": "Kontoinhaber ist erforderlich.",
  "Contract widget: error submitting": "Beim Absenden ist ein Fehler aufgetreten.",
  "Contract widget: email required": "E-Mail ist erforderlich.",
  "Contract widget: first name required": "Vorname ist erforderlich.",
  "Contract widget: last name required": "Nachname ist erforderlich.",
  "Contract widget: first or last name required": "Bitte geben Sie einen Vor- oder Nachnamen an.",
  "Contract widget: date of birth required": "Geburtsdatum ist erforderlich.",
  "Contract widget: phone required": "Telefonnummer ist erforderlich.",
  "Contract widget: mobile required": "Mobilnummer ist erforderlich.",
  "Contract widget: phone or mobile required": "Telefon oder Mobil ist erforderlich.",
  "Contract widget: address required": "Adresse ist erforderlich.",
  "Contract widget: notes required": "Notizen sind erforderlich.",
  "Contract widget: signature": "Unterschrift",
  // Gleiche Pflicht wie beim Nachfolger-Formular (§ 312j Abs. 3 BGB); auch das ältere öffentliche
  // Formular ist noch erreichbar.
  "Contract preview unavailable before signing": "Der Vertrag steht nach dem Abschluss als Dokument in der Akte. Eine Vorschau vorab gibt es nicht.",
  "Contract widget: next step book appointment": "nächster Schritt: Termin buchen",
  "Contract widget: steps": "Schritte",
  "Contract signing widgets: contract package templates label": "Vertragsvorlagen",
  "Contract signing widgets: embed": "einbinden",
  "Contract signing widgets: embed code": "Embed-Code",
  "Contract signing widgets: saved": "gespeichert.",
  "Contract signing widgets: created": "angelegt.",
  "Contract signing widgets: edit": "Vertragsformular bearbeiten",
  "Contract signing widgets: colors": "Farben",
  "Contract signing widgets": "Vertragsformulare",
  "Public widgets for online contract signing": "öffentliche Formulare für Online-Vertragsabschluss",
  "Contract signing widgets: add": "Erlebnis-Vertragsformular hinzufügen",
  "Contract signing widgets: tab basis": "Basis",
  "Contract signing widgets: tab display": "Darstellung",
  "Contract signing widgets: tab content": "Inhalte",
  "Contract signing widgets: promotion target": "gilt für",
  "Contract signing widgets: promotion start scope": "Beginn ab",
  "Contract signing widgets: images": "Bilder",
  "Contract signing widgets: tab form fields": "Formularfelder",
  "Contract signing widgets: tab success": "Erfolg und Folgeaktion",
  "Contract signing widgets: headline": "Überschrift",
  "Contract signing widgets: preview fallback widget name": "Vertrag online abschließen",
  "Updated at": "aktualisiert am",
  "Accent color": "Akzentfarbe",
  "Contract widget: default widget name": "Online-Mitgliedschaft",
  "Contract widget: default headline": "Starte deine Mitgliedschaft",
  "Contract widget: preview no offer configured": "noch kein Vertragspaket ausgewählt — die Vorschau zeigt nur, was hier konfiguriert ist.",
  "Contract signing widgets: contract packages hint": "Diese Vertragspakete verkauft das Formular. Die Reihenfolge ist die Reihenfolge der Kacheln; Laufzeit und Preise kommen aus dem Paket. Verkaufsaktionen hängen am Paket, weil sie dessen Preis bewerben.",
  "Contract signing widgets: service bundles hint": "Zusätzlich verkäufliche Leistungen. Sie gelten für alle Vertragspakete des Formulars und werden im Abschluss in einem eigenen Schritt gewählt. Was ein Vertragspaket ohnehin enthält, wird dort nicht noch einmal angeboten.",
  "Contract signing widgets: contract packages": "Vertragspakete",
  "Contract signing widgets: service bundles": "Leistungsbündel",
  "Contract signing widgets: add contract package": "Vertragspaket zufügen",
  "Contract signing widgets: add service bundle": "Leistungsbündel zufügen",
  "Contract signing widgets: select contract package": "Vertragspaket wählen",
  "Contract signing widgets: select service bundle": "Leistungsbündel wählen",
  "Contract signing widgets: no sales promotion yet": "keine Verkaufsaktion vorhanden.",
  "Contract signing widgets: apply promotions to all packages": "Aktionen auf alle Vertragspakete übernehmen",
  "Contract signing widgets: bundle price": "Preis in diesem Formular",
  "Contract signing widgets: bundle start": "Start",
  "Contract signing widgets: bundle exceptions": "Abweichungen je Vertragspaket",
  "Contract signing widgets: add exception": "Abweichung zufügen",
  "Contract signing widgets: bundle offered with own price": "wird angeboten, eigener Preis",
  "Contract signing widgets: bundle unavailable": "hier nicht anbieten",
  "Contract signing widgets: preselect not allowed online": "im öffentlichen Formular darf eine kostenpflichtige Zusatzleistung nicht vorausgewählt sein (§ 312a Abs. 3 BGB). Am Tresen ist die Vorauswahl die Empfehlung des Mitarbeiters.",
  "Contract signing widgets: draft banner": "Entwurf — noch nicht veröffentlicht.",
  "Contract signing widgets: cannot activate": "zum Aktivieren fehlt noch etwas.",
  "Contract term": "Laufzeit",
  "Status draft": "Entwurf",
  "E_ContractSigningAvailability_NoInternalWidget": "Kein Erlebnisformular ist für den internen Abschluss freigegeben. Setze in den Einstellungen unter Erlebnisformulare > Basis den Haken bei „intern (am Tresen)\".",
  "E_ContractSigningAvailability_WidgetInactive": "Das interne Erlebnisformular ist nicht aktiv. Öffne es in den Einstellungen — im Kopf steht, was zum Aktivieren fehlt.",
  "E_ContractSigningAvailability_NoContractPackage": "Dem internen Erlebnisformular fehlt ein aktives Vertragspaket.",
  "E_ContractSigningAvailability_NoStudio": "Für das interne Erlebnisformular ist kein erreichbares Studio aktiv.",
  "E_ContractWidget_NoOffer": "Es ist kein Vertragspaket zugewiesen.",
  "E_ContractWidget_PackageWithoutComponents": "Ein zugewiesenes Vertragspaket hat keinen aktiven Baustein.",
  "E_ContractWidget_PublicWithoutContractDocument": "Einem Vertragspaket fehlt das Vertragsdokument; ohne das ist kein Online-Abschluss möglich.",
  "E_ContractWidget_NoStudio": "Für dieses Formular ist kein aktives Studio erreichbar.",
  "ContractWidgetInvalidCode": "Der Widget-Code enthält unzulässige Zeichen oder ist bereits vergeben.",
  "ContractWidgetNameRequired": "Bitte einen Namen angeben.",
  "ContractWidgetDuplicateContractPackage": "Dasselbe Vertragspaket steht zweimal im Formular.",
  "ContractWidgetDuplicateAddon": "Dasselbe Leistungsbündel steht zweimal im Formular.",
  "ContractWidgetPromotionTargetMissing": "Die Aktion zielt auf ein Leistungsbündel, das dieses Vertragspaket nicht anbietet.",
  "ContractOptionGroupIncomplete": "Das Leistungsbündel hat keine verkäuflichen Bausteine.",
  "ContractOptionGroupCycleConflict": "Ein Gesamtpreis über verschiedene Zahlungszyklen ist nicht bestimmbar.",
  "ImageTooLarge": "Das Bild ist zu groß (max. 4 MB).",
  "ImageTypeNotAllowed": "Nur JPG, PNG, GIF und WebP sind erlaubt.",
  "Contract signing widgets: no contract package yet": "noch kein Vertragspaket zugewiesen.",
  "Contract signing widgets: no service bundle yet": "noch kein Leistungsbündel zugewiesen.",
  "Contract signing widgets: manage contract packages": "Vertragspakete verwalten",
  "Contract signing widgets: manage option groups": "Leistungsbündel verwalten",
  "Contract signing widgets: manage sales promotions": "Verkaufsaktionen verwalten",
  "Contract widget: default header text": "Wähle dein passendes Modell, ergänze kurz deine Daten und sichere dir deinen Start im Studio.",
  "Contract widget: default confirmation title": "Willkommen im Training",
  "Contract widget: default confirmation message": "Deine Mitgliedschaft ist angelegt. Wir senden dir deine Unterlagen per E-Mail und freuen uns auf deinen Start.",
  "Contract widget: preview template name": "Flex-Mitgliedschaft",
  "Contract widget: preview template subtitle": "flexibel starten und frei bleiben",
  "Contract widget: preview template description": "Ideal, wenn du direkt loslegen und dein Training flexibel gestalten möchtest.",
  "Contract widget: preview highlight ready": "sofort startklar",
  "Contract widget: preview highlight classes": "Kurse und Training inklusive",
  "Contract widget: preview highlight monthly": "monatlich flexibel",
  "Contract widget: choose membership": "Wähle deine Mitgliedschaft",
  "Contract widget: choose membership subtitle": "Vergleiche die Optionen und wähle das Modell, das zu deinem Training passt.",
  "Contract widget: step studio": "Studio",
  "Contract widget: step offer": "Vertrag",
  "Contract widget: step details": "Deine Daten",
  "Contract widget: step finish": "Abschluss",
  "Contract widget: document label": "Deine Unterlagen",
  "Contract widget: email note": "Deine Unterlagen senden wir dir nach dem Abschluss per E-Mail.",
  "ContractSigningStartAppointmentExpired": "Die Reservierung des Starttermins ist abgelaufen.",
  "Calendar: held during contract signing": "reserviert – Vertragsabschluss läuft",
  "Contract signing: early start consent": "Ich verlange, dass das Training vor Ablauf der Widerrufsfrist beginnt. Widerrufe ich, zahle ich den Anteil für die bis dahin genutzte Leistung.",
  "Contract signing: step start": "Starttermin",
  "Contract signing: start appointment": "Starttermin",
  "Contract signing: start today": "ohne Termin – Beginn heute",
  "Contract signing: start without appointment": "ohne Termin – Beginn frei festlegen",
  "Contract signing: minutes {0}": "{0} Min.",
  "Contract signing: previous week": "‹ vorherige Woche",
  "Contract signing: next week": "nächste Woche ›",
  "Contract signing: no free slots this week": "In dieser Woche ist nichts frei.",
  "Contract signing: start appointment unavailable": "Termine lassen sich gerade nicht laden. Du kannst ohne Termin fortfahren.",
  "Contract signing: start appointment booked": "Dein Starttermin ist gebucht. Die Bestätigung kommt per E-Mail.",
  "ContractSigningStartAppointmentUnavailable": "Der gewählte Starttermin ist nicht mehr frei. Bitte wähle einen anderen.",
  "Contract widget: SEPA mandate text generic": "Ich ermächtige das Studio, Zahlungen von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die vom Studio auf mein Konto gezogenen Lastschriften einzulösen. Hinweis: Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen. Gläubiger-ID und Mandatsreferenz werden mir mit der Vertragsbestätigung mitgeteilt.",
  "Contract widget: preview submit disabled": "In der Vorschau wird nichts abgeschlossen.",
  "Contract signing: start": "Beginn",
  "Contract signing: minimum term": "Mindestlaufzeit",
  "Contract signing: until {0}": "bis {0}",
  "Contract signing: open-ended": "unbefristet",
  "Contract signing: renews by {0}": "danach um je {0}",
  "Contract signing: ends automatically": "endet automatisch",
  "Contract signing: notice period": "Kündigungsfrist",
  "Contract signing: notice {0} before term end": "{0} vor Ablauf der Laufzeit",
  "Contract signing: after renewal {0}": "nach Verlängerung {0}",
  "Contract signing: notice end of month": "nur zum Monatsende",
  "Contract signing: notice end of quarter": "nur zum Quartalsende",
  "Contract signing: notice end of half year": "nur zum Halbjahresende",
  "Contract signing: notice end of year": "nur zum Jahresende",
  "Contract signing: starts {0}": "Beginn {0}",
  "Contract signing: minimum term until {0}": "Mindestlaufzeit bis {0}",
  "Contract signing: withdrawal form": "Muster-Widerrufsformular",
  "Contract signing: creditor id missing": "In den SEPA-Einstellungen fehlt die Gläubiger-ID. Ohne sie ist das Mandat unvollständig.",
  "Contract widget: SEPA mandate text {0} {1}": "Ich ermächtige {0} (Gläubiger-ID {1}), Zahlungen von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von {0} auf mein Konto gezogenen Lastschriften einzulösen. Hinweis: Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen. Die Mandatsreferenz wird mir mit der Vertragsbestätigung mitgeteilt.",
  "ContractSigningMinorNotAllowed": "Online können nur Volljährige einen Vertrag abschließen. Bitte komm für den Abschluss mit einem Erziehungsberechtigten ins Studio.",
  "ContractSigningDateOfBirthInvalid": "Bitte prüfe das Geburtsdatum.",
  "Contract signing: privacy document": "Datenschutzerklärung",
  "Contract signing: terms document": "Allgemeinen Geschäftsbedingungen",
  "Contract signing: privacy consent {0}": "Ich habe die {0} zur Kenntnis genommen.",
  "Contract signing: terms consent {0}": "Ich akzeptiere die {0}.",
  "Contract signing: imprint consent {0}": "Ich habe das {0} zur Kenntnis genommen.",
  "Contract signing: step contract data": "Vertragsdaten",
  "Contract widget: step payment": "Zahlung",
  "Contract signing: existing mandate {0}": "vorhandenes Mandat {0} wird weiterverwendet",
  "Contract signing: grant SEPA mandate": "Ich erteile das SEPA-Lastschriftmandat für die angegebene Bankverbindung.",
  "Contract signing: choose or enter a person": "Bitte eine vorhandene Person wählen oder eine neue erfassen.",
  "Contract widget: book bundle": "Bündel buchen",
  "Contract signing: existing person": "vorhandene Person",
  "Contract signing: no person found": "keine Person gefunden",
  "Contract signing: other person": "andere Person",
  "Contract signing: or new person": "oder neue Person erfassen",
  "Contract signing: no email address": "keine E-Mail-Adresse hinterlegt",
  "Contract signing: no delivery": "nicht zustellen",
  "Contract signing: open person": "Person öffnen",
  "Contract widget: change offer": "ändern",
  "Contract widget: read full contract": "vollständigen Vertrag lesen",
  "Contract widget: collapse contract": "Vertrag einklappen",
  "Contract signing widgets: preview desktop": "Desktopansicht",
  "Contract signing widgets: preview mobile": "Handyansicht",
  "Contract signing widgets: open as customer": "als Kunde öffnen",
  "Contract signing widgets: style": "Farbvorlage",
  "Widget design: form style": "Formstil",
  "Widget design: form style standard": "Standard",
  "Widget design: form style elegant": "elegant",
  "Contract signing widgets: style dark": "dunkel",
  "Contract signing widgets: style light": "hell",
  "Contract signing widgets: button contrast low": "Der Buttontext ist auf der Primärfarbe schlecht lesbar.",
  "Contract signing widgets: fix button text": "Buttontext anpassen",
  "Contract signing widgets: text contrast low": "Der Text ist auf dem Seitenhintergrund schlecht lesbar.",
  "Contract signing widgets: fine tuning": "Feinabstimmung",
  "Contract signing widgets: page background": "Seitenhintergrund",
  "Contract signing widgets: texts": "Texte",
  "Contract widget: sent to email": "Deine Unterlagen wurden an {{email}} gesendet.",
  // § 312j Abs. 3 BGB schreibt für den Absende-Button „zahlungspflichtig bestellen" oder eine
  // entsprechend eindeutige Formulierung vor. Ohne sie kommt der Vertrag nach Absatz 4 gar nicht
  // zustande — deshalb steht hier der Gesetzeswortlaut und keine schönere Umschreibung.
  "Contract widget: submit": "zahlungspflichtig bestellen",
  "This offer includes an action": "Dieses Angebot enthält eine Verkaufsaktion",
  "Total price for the initial term of {0}": "Gesamtpreis für die Erstlaufzeit von {0}",
  "Recurring contributions": "laufende Beiträge",
  "One-off items": "einmalige Positionen",
  "Contract signing widgets: background image": "Hintergrundbild",
  "Contract signing widgets: background image help": "Das Bild wird im öffentlichen Formular als abgedunkelter Hintergrund verwendet.",
  "Contract signing widgets: logo": "Logo",
  "Contract signing widgets: logo help": "Das Logo erscheint im Kopfbereich des öffentlichen Formulars.",
  "Contract signing widgets: no asset": "Noch kein Bild hinterlegt.",
  "Contract signing widgets: public presentation": "Öffentliche Darstellung",
  "Contract signing widgets: public presentation hint": "Diese Inhalte erscheinen in den Auswahlkarten des Erlebnis-Vertragsformulars.",
  "Contract signing widgets: public title": "Öffentlicher Titel",
  "Contract signing widgets: public subtitle": "Unterzeile",
  "Contract signing widgets: public description": "Beschreibung",
  "Contract signing widgets: highlights": "Highlights",
  "Contract signing widgets: add highlight": "Highlight hinzufügen",
  "Contract signing widgets: highlight placeholder": "z. B. Studiozugang inklusive",
  "Contract signing widgets: highlight required": "Bitte einen Highlight-Text eingeben.",
  "Contract signing widgets: badge text": "Badge-Text",
  "Contract signing widgets: option image": "Bild für die Vertragsoption",
  "Contract signing widgets: option image empty": "Ohne Bild nutzt die Karte eine moderne grafische Fläche.",
  "Contract signing widgets: save package before image": "Bitte speichern Sie die Vorlage zuerst, bevor Sie ein Bild hochladen.",
  "Contract signing widgets: save studio before image": "Bitte speichern Sie das Studio zuerst, bevor Sie ein Bild hochladen.",
  "Legal details for business letters": "Pflichtangaben für Geschäftsbriefe",
  "Legal details hint": "Diese Angaben erscheinen im Fußbereich erzeugter Briefe und E-Mails. Leere Felder werden weggelassen — ein Einzelunternehmen braucht weder Registereintrag noch Vertretungsberechtigte.",
  "Legal company name": "Firmenbezeichnung",
  "Legal company name tooltip": "Vollständiger Name inklusive Rechtsform. Leer lassen, wenn der Studio-Name bereits vollständig ist.",
  "Commercial register court": "Registergericht",
  "Commercial register number": "Registernummer",
  "e.g. HRB 12345": "z. B. HRB 12345",
  "VAT identification number": "Umsatzsteuer-Identifikationsnummer",
  "Correspondence logo": "Logo für Briefe und E-Mails",
  "Correspondence logo hint": "Erscheint im Briefkopf erzeugter Dokumente und im Kopf der E-Mails. Bewusst getrennt vom Widget-Bild, weil ein Briefkopf ein anderes Bild braucht.",
  "Save studio before uploading the logo": "Bitte speichern Sie das Studio zuerst, bevor Sie ein Logo hochladen.",
  "Left": "links",
  "Right": "rechts",
  "System documents": "Brief- und E-Mail-Vorlagen",
  "Variant": "Variante",
  "Base case": "Grundfall",
  "Add text set": "Vorlage anlegen",
  "Add text set hint": "Eine Vorlage je Fall. Ohne Variante ist sie der Grundfall; eine Variante bildet beispielsweise eine Ablehnung ab.",
  "Variant name tooltip": "Erscheint in der Auswahl beim Versand.",
  "Empty = base case": "leer = Grundfall",
  "Delete text set?": "Vorlage löschen?",
  "Delete text set hint": "Danach greift wieder die nächste Ebene: Studio, dann Mandant, dann der ausgelieferte Standard.",
  "Insert variable": "Variable einfügen",
  "Introduction": "Einleitung",
  "Main text": "Haupttext",
  "Modern contract signing widgets with tenant assets": "moderne Vertragsformulare mit mandanteneigenen Bildern",
  "View experience contract widgets": "Erlebnis-Vertragsformulare anzeigen",
  "Edit experience contract widgets": "Erlebnis-Vertragsformulare bearbeiten",
  "Contract signing widgets: primary color": "Primärfarbe",
  "Contract signing widgets: confirmation email": "Abschluss-E-Mail",
  "Contract signing widgets: confirmation email template": "E-Mail-Vorlage",
  "Contract signing widgets: confirmation email template placeholder": "Vorlage wählen (optional) …",
  "Contract signing widgets: linked booking widget select placeholder": "Buchungsformular wählen",
  "Contract signing widgets: linked booking widget label": "Terminformular",
  "Contract signing widgets: enable subsequent booking": "anschließende Terminbuchung ermöglichen",
  "Contract signing widgets: regenerate link?": "Formular-Link neu erzeugen?",
  "Contract signing widgets: regenerate link hint": "Der bisherige Link wird ungültig. Ein neuer Link wird erzeugt und in die Zwischenablage kopiert.",
  "Contract signing widgets: link regenerated": "Link wurde neu erzeugt.",
  "Contract signing widgets: save first to get widget link": "Bitte zuerst speichern, um den Formular-Link zu erhalten.",
  "Contract signing widgets: v2 widget link label": "Erlebnis-Vertragsformular-Link",
  "Contract signing widgets: confirmation email template hint": "Es gibt keine Vorlagen aus der Gruppe „Vertragsbestätigung“. Unter Einstellungen → Textvorlagen-Kategorien eine Kategorie mit „Vorlagen für Vertragsbestätigung“ anlegen und E-Mail-Vorlagen dieser Kategorie zuweisen.",
  "Contract signing widgets: confirmation email template optional hint": "Optional. Die Abschluss-E-Mail wird aus der gewählten Vorlage versendet; ohne Vorlage kann gespeichert werden, dann wird keine Abschluss-E-Mail gesendet.",
  "Contract signing widgets: edit email templates": "Vorlagen bearbeiten",
  "Contract signing widgets: privacy policy": "Datenschutz",
  "Contract signing widgets: require privacy": "Zustimmung erforderlich",
  "Contract signing widgets: terms and conditions": "AGB",
  "Contract signing widgets: require terms": "Zustimmung erforderlich",
  "Contract signing widgets: require impressum": "Impressum muss bestätigt werden.",
  "Contract signing widgets: preview": "Vorschau",
  "Contract signing widgets: preview live hint": "Änderungen an Farben und Texten werden live in der Vorschau angezeigt.",
  "Contract signing widgets: preview after save": "Vorschau nach dem ersten Speichern",
  "Contract signing widgets: preview after save description": "Speichern Sie das Formular einmal, um einen Link zu erhalten. Die Live-Vorschau erscheint dann hier und zeigt Ihre Design-Änderungen.",
  "Contract signing widgets: lead on completion": "Kontakt bei Abschluss",
  "Contract signing widgets: create lead on completion": "Kontakt bei Vertragsabschluss anlegen",
  "Display options": "Anzeigeoptionen",
  "Error loading embed code": "Embed-Code konnte nicht geladen werden.",
  "Copy failed": "Fehler beim Kopieren.",
  "Copy": "kopieren",
  "Copied": "kopiert",
  "Uploaded": "hochgeladen",
  "{0} is required": "{0} ist erforderlich",
  "Not reached ({0})": "nicht erreicht ({0})",
  "Contact: {0}": "Kontakt: {0}",
  "{0} log entries copied to clipboard": "{0} Log-Einträge in Zwischenablage kopiert",
  "Permanently delete \"{0}\" ({1})? This action cannot be undone.": "Möchten Sie \"{0}\" ({1}) unwiderruflich löschen? Diese Aktion kann nicht rückgängig gemacht werden!",
  "Error saving (HTTP {0})": "Fehler beim Speichern (HTTP {0})",
  "Error deleting (HTTP {0})": "Fehler beim Löschen (HTTP {0})",
  "SEPA file cannot be downloaded ({0} errors)": "SEPA-Datei kann nicht heruntergeladen werden ({0} Fehler)",
  "Deadline tight: only {0} day(s) until execution. File must be submitted to bank by {1}.": "Frist ist knapp. Nur noch {0} Tag(e) bis zum Ausführungsdatum. Datei muss bis {1} bei der Bank eingereicht werden.",
  "Submit by {0} ({1} days remaining)": "Abgabe bis {0} (noch {1} Tage)",
  "Fix errors: {0}": "Fehlerdetails: {0}",
  "Send via {0}": "über {0} versenden",
  "Error (HTTP {0})": "Fehler (HTTP {0})",
  "Transitions from \"{0}\"": "Übergänge von „{0}\"",
  "Time of day (optional)": "Tageszeit",
  "Text (label)": "Text",
  "Document (label)": "Dokument",
  "Document is required": "Dokument ist erforderlich",
  "{0}–{1} characters": "{0}–{1} Zeichen",
  "{0} characters": "{0} Zeichen",
  "Channel (label)": "Kanal",
  "Type (label)": "Typ",
  "{0} on {1} – really delete?": "{0} am {1} – wirklich löschen?",
  "Error: {0}": "Fehler: {0}",
  "every 1 min.": "alle 1 Min.",
  "every {0} min.": "alle {0} Min.",
  "daily {0}": "täglich {0}",
  "every {0} days, {1}": "alle {0} Tage, {1}",
  "daily (interval)": "täglich",
  "every {0} days": "alle {0} Tage",
  "Last Error": "letzter Fehler",
  "Configure": "konfigurieren",
  "Run (action)": "ausführen",
  "Configuration saved": "Konfiguration gespeichert",
  "every {0} weeks ({1})": "alle {0} Wochen ({1})",
  "Schedule {0}": "Rhythmus {0}",
  "Availabilities will be copied to {0} week(s).": "Verfügbarkeiten werden auf {0} Wochen kopiert.",
  "Copy weeks open range hint": "Leer lassen verwendet die aktuelle Woche. Ist nur ein Feld gesetzt, gilt genau diese Woche.",
  "Reset weeks to default": "Wochen auf Standard zurücksetzen",
  "Reset explicit week availabilities so the default for all weeks applies again.": "Löscht nur direkt gesetzte Wochen-Verfügbarkeiten. Die Standard-Verfügbarkeiten bleiben erhalten und gelten danach wieder.",
  "Reset weeks open range hint": "Leer lassen verwendet die aktuelle Woche. Ist nur ein Feld gesetzt, gilt genau diese Woche.",
  "Weeks reset to default.": "Wochen auf Standard zurückgesetzt.",
  "Contract component name placeholder": "Name des Vertragsbausteins (z. B. \"GRAZIOES 12 Monate\")",
  "Contract package name placeholder": "Name des Vertragspakets (z. B. \"BASIS-Paket\")",
  "Due date format placeholder": "Fälligkeitsdatum im Format TT.MM.JJ (z. B. \"05.01.26\")",
  "Amount format placeholder": "Betrag im Format XXXX.XX (z. B. \"35.99\")",
  "Note: For multiple contracts you can use different formats.": "Hinweis: Bei mehreren Verträgen können Sie verschiedene Formate verwenden, z. B. \"Beiträge {DUE_DATE}\" für eine zusammenfassende Meldung oder mehrere Zeilen mit jeweils \"{DUE_DATE} {CONTRACT_NAME} {AMOUNT} €\" für detaillierte Auflistungen.",
  "Inactive ≥ {0} months": "inaktiv ≥ {0} Monate",
  "Lead status New": "neu",
  "Lead status Contacted": "kontaktiert",
  "Lead status Appointment": "Termin",
  "Lead status Showed up": "erschienen",
  "Lead status Closed won": "gewonnen",
  "Lead status Closed lost": "verloren",
  "To confirm, type the tenant ID: {0}": "Tippe zur Bestätigung die Mandant-ID: {0}",
  "Type {0} to confirm": "Geben Sie zur Bestätigung {0} ein.",
  "Installment payment ({0})": "Ratenzahlung ({0})",
  "Number of installments must be between {0} and {1}.": "Ratenanzahl muss zwischen {0} und {1} liegen.",
  "Min. {0} / Max. {1}": "Min. {0} / Max. {1}",
  "Last consent: {0}": "letzte Zustimmung: {0}",
  "{0}-{1} of {2}": "{0}-{1} von {2}",
  "Manage tenants and companies": "Mandanten und Firmen verwalten",
  "Tenant administration card description": "Mandanten, Firmen und Stammdaten verwalten",
  "Tenant management": "Mandantenverwaltung",
  "Tenant operations": "Mandantenwerkzeuge",
  "Tenant operations card description": "Sicherungen und erzwungenes Löschen pro Mandant ausführen",
  "Tenant operations description": "Betriebswerkzeuge für ausgewählte Mandanten: Sicherungen, Wiederherstellung und erzwungenes Löschen.",
  "Tenant backup management": "Mandantensicherungen",
  "Tenant backups card description": "Sicherungen pro Mandant erstellen und wiederherstellen",
  "Tenant backups description": "Sicherungen und Wiederherstellungen für den ausgewählten Mandanten verwalten.",
  "Tenant force delete": "erzwungenes Löschen",
  "Tenant force delete card description": "erzwungenes Löschen pro Mandant ausführen",
  "Tenant force delete description": "erzwungenes Löschen für den ausgewählten Mandanten ausführen.",
  "Select tenant": "Mandant auswählen",
  "Platform admin users": "Plattform-Admins verwalten",
  "Background services and scheduler": "Hintergrunddienste und Scheduler",
  "Admin settings": "Admin-Einstellungen",
  "View and export system logs": "Systemprotokolle anzeigen und exportieren",
  "Incidents": "Störungen",
  "Connections on hold": "Zugänge angehalten",
  "Operations card description": "Störungen, Fehlerfälle und angehaltene Zugänge der Mandanten",
  "FailureSource_sms_send": "SMS-Versand",
  "FailureSource_whatsapp_send": "WhatsApp-Versand",
  "Outbound email queue (admin scope)": "ausgehende E-Mail-Warteschlange (Admin)",
  "SEPA direct debit runs (admin)": "SEPA-Lastschriftläufe (Admin)",
  "Really delete role \"{0}\"?": "Rolle \"{0}\" wirklich löschen?",
  "Column: {0}": "Spalte: {0}",
  "Table key: {0}": "Tabelle: {0}",
  "Column settings for \"{0}\" copied successfully": "Spalten-Einstellung für \"{0}\" wurde erfolgreich kopiert",
  "Really delete column settings for \"{0}\"?": "Möchten Sie die Spalten-Einstellung für \"{0}\" wirklich löschen?",
  "Capability: {0}": "Funktion: {0}",
  "View master data": "Stammdaten ansehen",
  "Edit master data": "Stammdaten ändern",
  "View member defaults": "Mitgliederverwaltung ansehen",
  "Edit member defaults": "Mitgliederverwaltung bearbeiten",
  "View check-in view settings": "Check-in-Ansicht ansehen",
  "Edit check-in view settings": "Check-in-Ansicht bearbeiten",
  "View contract packages": "Vertragspakete ansehen",
  "Edit contract packages": "Vertragspakete bearbeiten",
  "View contract components": "Vertragsbausteine ansehen",
  "Edit contract components": "Vertragsbausteine bearbeiten",
  "View payment plans": "Zahlungspläne ansehen",
  "Edit payment plans": "Zahlungspläne bearbeiten",
  "View wallet products": "Wertekonten ansehen",
  "Edit wallet products": "Wertekonten bearbeiten",
  "View cancellation reasons": "Kündigungsgründe ansehen",
  "Edit cancellation reasons": "Kündigungsgründe bearbeiten",
  "View cancellation models": "Kündigungsmodelle ansehen",
  "Edit cancellation models": "Kündigungsmodelle bearbeiten",
  "View accounting settings": "Buchführung ansehen",
  "Edit accounting settings": "Buchführung bearbeiten",
  "View bank account settings": "Bankkonten ansehen",
  "Edit bank account settings": "Bankkonten bearbeiten",
  "View default wallet payment settings": "Guthabenkonto ansehen",
  "Edit default wallet payment settings": "Guthabenkonto bearbeiten",
  "View payment methods settings": "Zahlungsarten ansehen",
  "Edit payment methods settings": "Zahlungsarten bearbeiten",
  "View payment cancellation reasons": "Zahlungsstornogründe ansehen",
  "Edit payment cancellation reasons": "Zahlungsstornogründe bearbeiten",
  "View debt management settings": "Mahnwesen ansehen",
  "Edit debt management settings": "Mahnwesen bearbeiten",
  "View lead sources settings": "Kontaktquellen ansehen",
  "Edit lead sources settings": "Kontaktquellen bearbeiten",
  "View lead pipelines settings": "Kontakt-Pipelines ansehen",
  "Edit lead pipelines settings": "Kontakt-Pipelines bearbeiten",
  "View lead widgets settings": "Kontaktformulare ansehen",
  "Edit lead widgets settings": "Kontaktformulare bearbeiten",
  "View contract signing widgets": "Vertragsformulare ansehen",
  "Edit contract signing widgets": "Vertragsformulare bearbeiten",
  "View lead automation settings": "Kontakt-Automatik ansehen",
  "Edit lead automation settings": "Kontakt-Automatik bearbeiten",
  "View email settings": "E-Mail-Einstellungen ansehen",
  "Edit email settings": "E-Mail-Einstellungen bearbeiten",
  "View auto communication settings": "Auto-Kommunikation ansehen",
  "Edit auto communication settings": "Auto-Kommunikation bearbeiten",
  "View appointment configuration": "Kalender-Einstellungen ansehen",
  "Edit appointment configuration": "Kalender-Einstellungen bearbeiten",
  "View appointment types": "Terminarten ansehen",
  "Edit appointment types": "Terminarten bearbeiten",
  "View resources settings": "Ressourcen ansehen",
  "Edit resources settings": "Ressourcen bearbeiten",
  "View unavailabilities settings": "Abwesenheiten ansehen",
  "Edit unavailabilities settings": "Abwesenheiten bearbeiten",
  "View appointment outcomes": "Termin-Ergebnisse ansehen",
  "Edit appointment outcomes": "Termin-Ergebnisse bearbeiten",
  "View booking widgets": "Buchungsformulare ansehen",
  "Edit booking widgets": "Buchungsformulare bearbeiten",
  "View appointment notifications": "Termin-Benachrichtigungen ansehen",
  "Edit appointment notifications": "Termin-Benachrichtigungen bearbeiten",
  "View member app settings": "Studio-App ansehen",
  "Edit member app settings": "Studio-App bearbeiten",
  "View units settings": "Einheiten ansehen",
  "Edit units settings": "Einheiten bearbeiten",
  "View default theme settings": "Standard-Theme ansehen",
  "Edit default theme settings": "Standard-Theme bearbeiten",
  "View user templates settings": "Benutzer-Vorlagen ansehen",
  "Edit user templates settings": "Benutzer-Vorlagen bearbeiten",
  "View integrations settings": "Schnittstellen ansehen",
  "Edit integrations settings": "Schnittstellen bearbeiten",
  "View backup and restore settings": "Datensicherung ansehen",
  "Edit backup and restore settings": "Datensicherung bearbeiten",
  "Template (column)": "Vorlage",
  "Language (column)": "Sprache",
  "Subject (column)": "Betreff",
  "Appointment created.": "Termin angelegt.",
  "Appointment saved.": "Termin gespeichert.",
  "Appointment start must not be in the past": "Der Termin darf nicht in der Vergangenheit liegen.",
  "Appointments in the past cannot be booked.": "Termine in der Vergangenheit können nicht gebucht werden.",
  "Appointment start violates staff minimum advance": "Diese Terminart erfordert {0} Minuten Mindestvorlauf für Mitarbeiter-Buchungen. Frühester möglicher Start: {1}.",
  "Staff minimum advance hint": "Mindestvorlauf für diese Terminart: {0} Minuten. Frühester möglicher Start: {1}.",
  "Required resources": "Benötigte Ressourcen",
  "Required resources not available": "Benötigte Ressourcen nicht verfügbar.",
  "Appointment type requires resources": "Diese Terminart benötigt: {0}.",
  "Selected appointment resources are not available.": "Die benötigten Ressourcen sind zu dieser Zeit nicht verfügbar.",
  "Appointment availability check failed": "Die Ressourcenverfügbarkeit konnte gerade nicht geprüft werden.",
  "Person resource option": "Person (ein Mitarbeiter, Kapazität 1)",
  "Team pool resource option": "Team/Pool (mehrere Mitarbeiter, gemeinsame Kapazität)",
  "Online booking and staff schedule": "Online-Buchung und Dienstplan",
  "Limit online booking once the week is published": "Online nur nach Veröffentlichung der Woche",
  "Limit online booking once the week is published hint": "Sobald die Woche im Dienstplan veröffentlicht ist, sind Online-Termine nur noch in Schichten mit der passenden Tätigkeit buchbar.",
  "Limit online booking within lead time": "Online nur innerhalb der Vorlaufzeit",
  "Limit online booking within lead time hint": "Liegt der Termin in der Vorlaufzeit, sind Online-Termine nur noch in Schichten mit der passenden Tätigkeit buchbar. Mit beiden Haken müssen Veröffentlichung und Vorlauf zutreffen.",
  "Internal calendar hide staff without availability hint": "Im Kalender folgt die Ressource dem Dienstplan immer. Ressourcen und Mitarbeiter ohne Verfügbarkeit blendet das Auge in der Tages- und Wochenansicht aus.",
  "Person resource linked user hint": "ordnet dieser Rolle einen Mitarbeiter zu, Kapazität bleibt 1",
  "Team pool members hint": "mehrere Mitarbeiter teilen sich diesen Pool; die Kapazität bestimmt, wie viele Termine gleichzeitig abgedeckt werden",
  "Resource assigned staff": "Mitarbeiter",
  "Resource assigned staff pool": "Mitarbeiter",
  "Resource staff section title": "zugeordnete Mitarbeiter",
  "Required resources for booking": "Ressourcenbedarf",
  "Select required resources...": "Ressourcen auswählen...",
  "Resources per row": "Bedarf / Alternativen",
  "Select alternatives...": "Ressourcen auswählen...",
  "Remove requirement row": "Bedarfszeile entfernen",
  "Add requirement row": "Zeile hinzufügen",
  "Check resource availability for booking": "Verfügbarkeit bei Buchung prüfen",
  "Required for booking": "für Buchung erforderlich",
  "Resource requirement": "Ressourcenanforderung",
  "Pool name": "Pool-Name",
  "Pool rule": "Pool-Regel",
  "Booking requirement": "Buchungsanforderung",
  "AND pool (all)": "Und-Pool (alle)",
  "OR pool (one)": "Oder-Pool (eine)",
  "All selected resources": "alle ausgewählten Ressourcen",
  "One resource": "eine Ressource",
  "Camera only available over HTTPS or localhost. Use file upload as fallback.": "Kamera ist nur über HTTPS oder localhost verfügbar. Bitte nutze den Datei-Upload als Fallback.",
  "Select format…": "Format wählen…",
  "Select time zone…": "Zeitzone wählen…",
  "Placeholder country code": "D",
  "Placeholder country code abbreviated": "DE…",
  "Placeholder country calling code": "49",
  "Placeholder ellipsis": "…",
  "Placeholder URL": "https://…",
  "Placeholder number 90": "90",
  "Placeholder number 30": "30",
  "Placeholder number 14": "14",
  "Placeholder number 1": "1",
  "Placeholder number 0": "0",
  "Placeholder number 1500": "1500",
  "Placeholder IBAN example": "DE89 3704 0044 0532 0130 00",
  "Placeholder email example": "info@firma.de",
  "Placeholder bank code": "12345678",
  "Placeholder HBCI URL": "https://hbci-01.hypovereinsbank.de/bank/hbci",
  "Placeholder my business name": "Mein Unternehmen",
  "6-digit PIN": "6-stellige PIN",
  "Placeholder template key": "appointment_reminder",
  "Placeholder locale code": "de",
  "Placeholder phone number": "1712345678",
  "Placeholder JSON message template": "[{\"type\":\"BODY\",\"text\":\"Hallo {{1}}\"}]",
  "Registration code generated: {0}": "Registrierungscode generiert: {0}",
  "Device could not be opened (Request-ID: {0})": "Gerät konnte nicht geöffnet werden (Request-ID: {0})",
  "Reader device assignments description": "Hier ordnest du das Lesegerät den Vertragsbausteinen und Wertekonten zu. Die Flags steuern, welche Aktionen (Punkte abziehen / Gerät freischalten / Tür öffnen) dieses Lesegerät beim Scan ausführen darf. Ob zusätzlich Check-in und Check-out protokolliert werden, stellst du am Lesegerät selbst über \"Checkin & Checkout\" ein.",
  "{0} direct debit runs created successfully.": "{0} Lastschriftläufe erfolgreich angelegt.",
  "Direct debit run created successfully.": "Lastschriftlauf erfolgreich angelegt.",
  "Cleanup completed: {0} contribution calendar entries cleaned, {1} open items deleted": "Bereinigung abgeschlossen: {0} Beitragskalender-Einträge bereinigt, {1} offene Posten gelöscht",
  "WARNING: SEPA file already downloaded confirm": "ACHTUNG: Die SEPA-Datei wurde bereits heruntergeladen und möglicherweise bereits an die Bank übermittelt. Das Löschen dieses Laufs kann zu Problemen führen, wenn die Datei bereits bei der Bank eingereicht wurde.\n\nMöchten Sie diesen Lastschriftlauf wirklich löschen?",
  "SEPA file already generated not downloaded confirm": "Die SEPA-Datei wurde bereits generiert, aber noch nicht heruntergeladen. Das Löschen dieses Laufs ist weniger kritisch, da die Datei noch nicht bei der Bank eingereicht wurde.\n\nMöchten Sie diesen Lastschriftlauf wirklich löschen?",
  "Error: {0} items have missing IBAN or mandate reference": "Fehler: {0} Positionen haben fehlende IBAN oder Mandatsreferenz",
  "{0} items with missing data found. Please fix the errors so the SEPA file can be generated.": "Es wurden {0} Positionen mit fehlenden Daten gefunden. Bitte beheben Sie die Fehler, damit die SEPA-Datei generiert werden kann.",
  "{0} customers with missing data found. Please fix the errors so the SEPA file can be generated.": "Es wurden {0} Lastschriftpositionen mit Fehlern gefunden. Bitte prüfen Sie die Details, bevor Sie fortfahren.",
  "{0} direct debit items with errors were found. Please review the details before continuing.": "Es wurden {0} Lastschriftpositionen mit Fehlern gefunden. Bitte prüfen Sie die Details, bevor Sie fortfahren.",
  "{0} direct debit items": "{0} Lastschriftpositionen",
  "Only company administrators can edit rest period templates.": "Nur Firmen-Administratoren können Ruhezeitmodelle bearbeiten.",
  "Rest period fee": "Ruhezeitbeitrag",
  "Rest period fee per cycle": "Ruhezeitbeitrag",
  "Rest period fee per cycle tooltip": "Fester Betrag für die Ruhezeit. Die Einheit daneben legt fest, ob der Betrag pro Beitragsperiode, Tag, Woche, Monat oder Jahr berechnet wird. Die Fälligkeit liegt zu Beginn der Ruhezeit.",
  "Rest period fee per cycle proportional tooltip": "Der Betrag wird für die Ruhezeit anteilig berechnet. Die Einheit daneben legt fest, ob die Grundlage pro Beitragsperiode, Tag, Woche, Monat oder Jahr gilt.",
  "Rest period fee unit": "Ruhezeitbeitrag pro",
  "Rest period fee unit tooltip": "Zeiteinheit, auf die sich der Ruhezeitbeitrag bezieht. Bei anteiliger Berechnung wird dieser Betrag pro Tag, Woche, Monat oder Jahr umgerechnet.",
  "Rest period fee automatic calculation hint": "Die anteilige Berechnung richtet sich automatisch nach dieser Einheit: pro Monat kalendermonatsbezogen, pro Jahr jahresbezogen, pro Beitragsperiode auf die jeweilige Beitragsperiode.",
  "per contribution period": "pro Beitragsperiode",
  "Rest period fee due": "Fälligkeit des Ruhezeitbeitrags",
  "Rest period fee due (column)": "Fälligkeit",
  "Rest period fee due tooltip": "Einmalige Pauschale für die gesamte Ruhezeit oder derselbe Rhythmus wie der Zahlungszyklus des Mitglieds (z. B. monatlich, alle 2 Wochen je nach Vertrag).",
  "Rest period fee due one-time": "einmalige Pauschale",
  "Rest period fee due same as member": "wie Zahlungszyklus",
  "Rest period billing model": "Abrechnungsmodell",
  "Rest period billing model tooltip": "Legt fest, ob Beitragsfälligkeiten durch die Ruhezeit verschoben werden oder ob die bestehenden Fälligkeiten bleiben und nur betroffene Perioden korrigiert werden.",
  "Rest period balance options": "Ausgleich der Ruhezeit",
  "Recover rest period time": "Zeit nachholen",
  "Recover rest period at the end": "Ruhezeit am Ende nachholen",
  "Correct contributions": "Beiträge korrigieren",
  "Shift contribution due dates": "Fälligkeiten verschieben",
  "Keep contribution due dates": "Fälligkeiten beibehalten",
  "Correct affected period only": "nur betroffene Periode korrigieren",
  "Rest period billing model shift description": "Keine Beitragsgutschrift; die ausgesetzte Zeit wird über spätere Fälligkeiten ausgeglichen.",
  "Rest period billing model recover time description": "Die ausgesetzte Zeit wird nachgeholt. Noch offene Beiträge werden passend korrigiert; bereits abgegoltene Zeit wird über die Nachholung ausgeglichen.",
  "Rest period billing model keep description": "Die Laufzeit bleibt unverändert. Betroffene Beiträge werden anteilig reduziert oder gutgeschrieben.",
  "Rest period billing model current period description": "Nur die aktuell betroffene Periode wird korrigiert; künftige Planbeiträge bleiben unverändert.",
  "Rest period contract options description": "Wählen Sie zuerst das fachliche Modell. Die darunterliegenden Optionen werden passend dazu eingeschränkt.",
  "Rest period costs calculation description": "Lege fest, ob die Ruhezeit kostenlos ist, ein eigener Ruhezeitbeitrag anfällt oder eine bestimmte Anzahl regulärer Beiträge weiterläuft.",
  "Rest period access restrictions description": "Regelt, ob Check-ins während der Ruhezeit erlaubt bleiben.",
  "Rest period fee mode": "Art des Ruhezeitbeitrags",
  "Rest period fee mode none": "kein Ruhezeitbeitrag",
  "Rest period fee mode none description": "Während der Ruhezeit fällt kein zusätzlicher Ruhezeitbeitrag an.",
  "Rest period fee mode amount": "Ruhezeitbeitrag",
  "Rest period fee mode amount description": "Ein fixer Betrag wird anteilig nach der gewählten Einheit berechnet.",
  "Rest period fee mode contributions": "Anzahl Beiträge",
  "Rest period fee mode contributions description": "Eine feste Anzahl regulärer Beiträge läuft während der Ruhezeit weiter.",
  "due dates shifted": "Fälligkeiten verschoben",
  "Rest period fee cycle": "Abrechnungszyklus Ruhezeitbeitrag",
  "Rest period fee cycle tooltip": "In welchem Rhythmus der Ruhezeitbeitrag fällig wird (z. B. monatlich, alle 2 Wochen).",
  "Rest period fee cycle value": "Intervall",
  "Rest period fee cycle value tooltip": "z. B. 2 bei Einheit „Woche“ = alle 2 Wochen.",
  "One-time (whole rest period)": "einmalig (gesamte Ruhezeit)",
  "Default from template": "Standard aus Vorlage",
  "Number of contributions tooltip": "Anzahl der Wochenbeiträge, die während der Ruhezeit weitergezahlt werden.",
  "Rest period number of weekly contributions": "Anzahl Beiträge",
  "Rest period number of weekly contributions tooltip": "Anzahl der während der Ruhezeit fälligen Beiträge (im Rhythmus des Zahlungszyklus). Z. B. 2 = zwei Beiträge werden fällig.",
  "Rest period fee amount required": "Bitte einen Ruhezeitbeitrag größer als 0 eingeben.",
  "Rest period fee unit required": "Bitte eine Einheit wählen.",
  "Rest period contributions required": "Bitte eine Anzahl größer als 0 eingeben.",
  "Minimum rest period value required": "Bitte einen Wert größer als 0 eingeben.",
  "Minimum rest period unit required": "Bitte eine Einheit wählen.",
  "Calculate proportionally tooltip": "Wenn aktiviert, wird der Betrag je Fälligkeit anteilig aus dem Basisbeitrag des Vertrags berechnet. Der Abrechnungszyklus (unten) legt fest, wann fällig wird.",
  "Calculation Method tooltip": "Methode zur anteiligen Berechnung basierend auf dem Basisbeitrag des Vertrags.",
  "Extends contract tooltip": "Die ausgesetzte Zeit wird später nachgeholt, statt als normale Vertragszeit zu zählen.",
  "Continue payment tooltip": "Reguläre Beiträge laufen während der Ruhezeit weiter.",
  "Append to end tooltip": "Die Ruhezeit wird ans Vertragsende angehängt und dort kostenfrei genutzt.",
  "Check-in allowed tooltip": "Check-ins bleiben während der Ruhezeit erlaubt.",
  "Require full periods only tooltip": "Wenn aktiviert, werden nur volle Zeiträume erlaubt. Die Einheit ergibt sich aus dem Vertrag (z. B. monatlicher Vertrag = volle Monate).",
  "Rest period duration restrictions": "Dauer und Beschränkungen",
  "Rest period duration restrictions description": "Lege fest, ob Ruhezeiten frei, mit Mindestdauer oder nur in ganzen Perioden möglich sind.",
  "Rest period duration rule": "Dauerregel",
  "Rest period duration rule none": "keine Mindestregel",
  "Rest period duration rule none description": "Ruhezeiten können ohne zusätzliche Dauerbeschränkung eingetragen werden.",
  "Rest period duration rule minimum": "Mindestruhezeit",
  "Rest period duration rule minimum description": "Ruhezeiten müssen mindestens die angegebene Dauer haben.",
  "Rest period duration rule full periods": "nur volle Perioden",
  "Rest period duration rule full periods description": "Ruhezeiten sind nur in ganzen Perioden des Vertrags möglich.",
  "time recovered": "Zeit wird nachgeholt",
  "no time recovery": "keine Nachholung",
  "Minimum rest period value tooltip": "Mindestdauer der Ruhezeit.",
  "Minimum rest period unit tooltip": "Einheit für die Mindestruhezeit.",
  "Really delete entity \"{0}\" ({1})?": "Möchten Sie \"{0}\" ({1}) wirklich unwiderruflich löschen?\n\nDies wird auch alle anhängigen Daten löschen (Zahlungen, Buchungen, etc.).\n\nDiese Aktion kann nicht rückgängig gemacht werden!",
  "Do you really want to delete the integration \"{0}\"?": "Möchten Sie die Schnittstelle \"{0}\" wirklich löschen?",
  "HTTP warning password unencrypted": "⚠️ WARNUNG: Diese Seite wird über HTTP geladen. Passwörter werden unverschlüsselt übertragen!\n\nBitte verwenden Sie HTTPS in der Produktion.\n\nFortfahren?",
  "Do you really want to delete the admin \"{0}\"? This action cannot be undone.": "Möchten Sie den Admin \"{0}\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  "Do you really want to delete the tenant \"{0}\"? This action cannot be undone.": "Möchten Sie den Mandanten \"{0}\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  "Tenant language change confirm": "Die Standard-Sprache des Mandanten wird von {0} auf {1} geändert.\n\nTippe zur Bestätigung die Mandant-ID: {2}",
  "Do you really want to delete the version \"{0}\"?": "Möchten Sie die Version \"{0}\" wirklich löschen?",
  "Admin units description": "Datum, Uhrzeit, Zeitzone und Währung für Ihre Ansicht im Admin-Bereich. Diese Einstellungen werden pro Benutzer gespeichert.",
  "Service \"{0}\" executed successfully": "Dienst „{0}“ erfolgreich ausgeführt",
  "{0} holidays imported": "{0} Feiertage importiert",
  "Date and name required": "Datum und Name erforderlich",
  "Region (optional)": "Region",
  "All regions": "alle Regionen",
  "Automatic holiday import": "automatischer Feiertags-Import",
  "Which holiday calendars automatic": "Welche Feiertagskalender sollen automatisch abgerufen werden? Wählen Sie die Länder per Häkchen.",
  "Direct debit run cancelled. {0} items and {1} payments affected.": "Lastschriftlauf storniert. {0} Positionen und {1} Zahlungen betroffen.",
  "Really delete setting for \"{0}\"?": "Einstellung für \"{0}\" wirklich löschen?",
  "Really delete rule for \"{0}\"?": "Regel für \"{0}\" wirklich löschen?",
  "Template \"{0}\" copied successfully": "Vorlage „{0}“ wurde erfolgreich kopiert",
  "Do you really want to delete the template \"{0}\"?": "Möchten Sie die Vorlage \"{0}\" wirklich löschen?",
  "Copied from {0} to {1}.": "Von {0} nach {1} kopiert.",
  "Lead phase transitions description": "Ein Kontakt in dieser Phase kann in die folgenden Phasen wechseln. Pro Auslöser (z. B. „bei Kontakt protokolliert“) können Sie mehrere Übergänge mit unterschiedlichen Zielphasen anlegen. So lassen sich z. B. „Anruf → terminiert → Probetraining“ und „Anruf → verloren → Verloren“ abbilden.",
  "Phase transition trigger manual": "manuell",
  "Phase transition trigger appointment created": "bei Termin vereinbart",
  "Phase transition trigger appointment removed": "bei keinem Termin (mehr)",
  "Phase transition trigger appointment conducted": "bei Termin durchgeführt",
  "Phase transition trigger appointment completed": "bei Termin abgeschlossen",
  "Phase transition trigger appointment not completed": "bei Termin nicht abgeschlossen",
  "Phase transition trigger contact logged": "bei Kontakt protokolliert",
  "Phase transition trigger task done": "bei Aufgabe erledigt",
  "When to switch": "Wann wechseln?",
  "Contact outcome (phase)": "Ergebnis (nächste Phase)",
  "Contact outcome placeholder": "z. B. Terminiert → Probetraining oder Verloren",
  "Task outcome (phase)": "Ergebnis der Aufgabe (nächste Phase)",
  "Appointment phase („Termin gemacht“)": "Termin-Phase („Termin gemacht“)",
  "Lead pipeline appointment phase description": "Nur Termine mit einer der gewählten Terminarten zählen für „Termin gemacht“. Wenn gesetzt: Kontakt wechselt in „Phase bei Termin“, sobald ein solcher Termin existiert; in „Phase bei keinem Termin“, wenn keiner (mehr) existiert.",
  "Appointment group (relevance)": "Termingruppe (Relevanz)",
  "Select appointment type": "Terminart wählen",
  "Email message (body)": "Nachricht",
  "Write your email here …": "E-Mail-Text hier eingeben …",
  "Send email from system": "E-Mail aus dem System senden",
  "Email queued for sending": "E-Mail wurde in die Warteschlange gestellt.",
  "Email subject placeholder": "z. B. Ihre Terminanfrage",
  "Phase when appointment exists": "Phase bei Termin vorhanden",
  "Phase when no appointment": "Phase bei keinem Termin",
  "Failed to load events (HTTP {0})": "Ereignisse konnten nicht geladen werden (HTTP {0}).",
  "Failed to load events": "Ereignisse konnten nicht geladen werden.",
  "Only administrators can edit entries.": "Nur Administratoren können Einträge bearbeiten.",
  "How far in advance can appointments be booked? Default: 90 days.": "Wie weit im Voraus können Termine gebucht werden? Standard: 90 Tage.",
  "Level {0} cannot be created because level {1} does not exist yet. Please create level {1} first.": "Mahnstufe {0} kann nicht angelegt werden, da Mahnstufe {1} noch nicht existiert. Bitte legen Sie zuerst Mahnstufe {1} an.",
  "Level {0} cannot be set because level {1} does not exist yet. Please create level {1} first.": "Mahnstufe {0} kann nicht gesetzt werden, da Mahnstufe {1} noch nicht existiert. Bitte legen Sie zuerst Mahnstufe {1} an.",
  "Level {0} cannot be created because level {1} does not exist yet.": "Mahnstufe {0} kann nicht angelegt werden, da Mahnstufe {1} noch nicht existiert.",
  "Level {0} cannot be set because level {1} does not exist yet.": "Mahnstufe {0} kann nicht gesetzt werden, da Mahnstufe {1} noch nicht existiert.",
  "Bulk send to {0} recipients is being prepared (feature in development)": "Serienversand an {0} Empfänger wird vorbereitet (Funktion in Entwicklung)",
  // --- i18n-check batch (missing tr/text keys) ---
  "Application is loading…": "Anwendung wird geladen…",
  "Application update in progress": "Anwendung wird aktualisiert",
  "New version deploying wait hint": "Eine neue Version wird bereitgestellt. Bitte kurz warten …",
  "Signature deleted": "Signatur gelöscht.",
  "UI deploy reload failed hint": "Neu laden ist fehlgeschlagen. Bitte erneut auf „Neu laden“ klicken.",
  "e.g. ops@company.com": "z. B. ops@firma.de",
  "2-step PIN required": "2-Schritt-PIN erforderlich",
  "Action": "Aktion",
  "Approve": "freigeben",
  "Approved": "freigegeben",
  "Are you sure you want to delete {0}?": "{0} wirklich löschen?",
  "Attachment file name": "Anhang-Dateiname",
  "Attachment object key": "Anhang-Objektschlüssel",
  "Body format": "Nachrichtenformat",
  "Add phone failed": "Telefonnummer konnte nicht hinzugefügt werden.",
  "Apply payment reversal": "Zahlungskorrektur anwenden",
  "Attendance sessions": "Check-in-Sitzungen",
  "BLZ / BIC / Bank name": "BLZ / BIC / Bankname",
  "Check-In": "Check-in",
  "Check-out": "Check-out",
  "Consent": "Einwilligung",
  "Contract block name": "Name Vertragsblock",
  "Contract package display name": "Anzeigename Vertragspaket",
  "Contract package name required": "Name des Vertragspakets ist erforderlich.",
  "Critical": "kritisch",
  "Delete user": "Benutzer löschen",
  "Design style text": "Text-Darstellungsstil",
  "Drag & drop or click": "per Drag & Drop oder Klick",
  "Document title": "Dokumenttitel",
  "Einreichungsdatum": "Einreichungsdatum",
  "EUR": "EUR",
  "Edit admin": "Administrator bearbeiten",
  "Edit contract package": "Vertragspaket",
  "Edit contract package and block": "Paket und Baustein",
  "Empty = all studios. Each studio can only be assigned once.": "Leer = alle Studios. Jedes Studio darf nur einmal vergeben werden.",
  "End date is required (or specify duration)": "Enddatum ist erforderlich (oder Dauer angeben).",
  "Error saving.": "Fehler beim Speichern.",
  "Full URL with https:// and path. Example HypoVereinsbank (verified): https://hbci-01.hypovereinsbank.de/bank/hbci. If your program shows port 3000, use https://host:3000/path. Key file not needed for PIN/TAN.": "Vollständige URL mit https:// und Pfad. Beispiel HypoVereinsbank (verifiziert): https://hbci-01.hypovereinsbank.de/bank/hbci. Zeigt Ihr Programm Port 3000, nutzen Sie https://host:3000/pfad. Schlüsseldatei ist für PIN/TAN nicht nötig.",
  "Go to wallets tab": "zum Tab Wertekonten",
  "HTML": "HTML",
  "Immediate payment": "Sofortzahlung",
  "Import contribution paid override field amount": "Feld: Betrag",
  "Import contribution paid override field contract_id": "Feld: Vertrags-ID",
  "Import contribution paid override field contract_name": "Feld: Vertragsname",
  "Import contribution paid override field contract_package_id": "Feld: Vertragspaket-ID",
  "Import contribution paid override field due_date": "Feld: Fälligkeitsdatum",
  "Import contribution paid override field entry_type": "Feld: Buchungsart",
  "Import contribution paid override field person_id": "Feld: Personen-ID",
  "Import contribution paid override field plan_name": "Feld: Planname",
  "Import contribution paid override field status": "Feld: Status",
  "Import run commit db committed with post processing issues": "Datenbankübernahme abgeschlossen, bei der Nachverarbeitung sind Probleme aufgetreten.",
  "Import run commit errors more": "weitere Fehler",
  "Import run commit errors more suffix": "weitere",
  "Import run commit errors ungrouped": "Allgemein",
  "Import run commit post processing detail intro": "Details zur Nachverarbeitung:",
  "Import run commit post processing errors title": "Fehler bei der Nachverarbeitung",
  "Import run commit post processing issues toast": "Import abgeschlossen mit Hinweisen zur Nachverarbeitung.",
  "Import run commit unknown error": "Unbekannter Fehler bei der Datenbankübernahme.",
  "Import run commit unknown state detail": "Der Importlauf befindet sich in einem unbekannten Zustand. Bitte Seite neu laden und Status prüfen.",
  "Import run commit unknown state reload": "neu laden",
  "Import run commit unknown state title": "Importstatus unbekannt",
  "Import run commit warnings detail intro": "Hinweise zur Datenbankübernahme:",
  "Import run commit warnings title": "Hinweise bei der Datenbankübernahme",
  "Import run execute committed detail": "Die Importdaten wurden übernommen. Wenn die Mandantendatenbank auf einen Stand vor diesem Import zurückgespielt wurde, gib den Lauf über zurückrollen/Freigabe wieder für einen Reimport frei.",
  "Import run execute committed title": "Import ausgeführt",
  "Import run execute rolled back detail": "Der Lauf ist für einen erneuten Import freigegeben. Die hochgeladenen Quelldateien bleiben erhalten.",
  "Import run execute rolled back title": "Import freigegeben",
  "Import run progress committing contribution calendar": "Beitragskalender wird geschrieben …",
  "Import run progress committing contribution calendar detail": "Beitragskalender wird geschrieben ({0} von {1})",
  "Import run progress committing contribution calendar sub": "{2} ({0} von {1})",
  "Import schema csv format delimiter comma": "Komma (,)",
  "Import schema csv format delimiter label": "Feldtrennzeichen",
  "Import schema csv format delimiter pipe": "Pipe (|)",
  "Import schema csv format delimiter semicolon": "Semikolon (;)",
  "Import schema csv format delimiter tab": "Tabulator",
  "Import schema csv format encoding label": "Zeichencodierung",
  "Import schema csv format encoding utf8": "UTF-8",
  "Import schema csv format encoding win1252": "Windows-1252",
  "Import schema csv format fixup disabled": "CSV-Bereinigung aus",
  "Import schema csv format fixup enabled": "CSV-Bereinigung an",
  "Import schema csv format fixup label": "CSV-Bereinigung (Zeilenenden, BOM)",
  "Import schema csv format hint": "Einstellungen für das Einlesen der CSV-Dateien dieses Laufs.",
  "Import schema csv format title": "CSV-Format",
  "Import schema mapping add source button": "weitere Quelle",
  "Import schema mapping checkins issue missing created_at source": "Check-ins: Quellspalte für Erfassungszeit fehlt oder ist leer.",
  "Import schema mapping checkins issue missing id source": "Check-ins: Quellspalte für ID fehlt oder ist leer.",
  "Import schema mapping checkins issue missing person source": "Check-ins: Quellspalte für Person fehlt oder ist leer.",
  "Import schema mapping checkins summary": "Check-in-Zuordnung",
  "Import schema mapping fk check badge error": "FK-Fehler",
  "Import schema mapping fk check badge warning": "FK-Hinweis",
  "Import schema mapping fk check issue direct key mismatch": "{0}: Quellspalte \"{1}\" passt nicht zum erwarteten Schlüssel \"{2}\".",
  "Import schema mapping fk check issue manual source": "{0}: manuelle Quelle — Fremdschlüssel kann nicht geprüft werden.",
  "Import schema mapping fk check issue missing own key source": "Ziel-Entität \"{0}\" wird von [{1}] referenziert, hat aber keine eigene Schlüssel-Quelle (kein importiertes id-Feld und kein Reference-Mapping).",
  "Import schema mapping fk check issue missing reference source": "{0}: Es gibt kein importiertes Target für die Ziel-Entität \"{1}\" (weder Import noch Reference-Mapping). Bitte die Ziel-Tabelle \"{1}\" in der Datenauswahl aktivieren oder ein Reference-Mapping dafür anlegen.",
  "Import schema mapping fk check issue missing relation path": "{0}: Quellpfad \"{1}\" passt nicht zur erwarteten Schlüssel-Quelle \"{2}\".",
  "Import schema mapping fk check issue missing source": "{0}: Quelltabelle oder Quellspalte fehlt.",
  "Import schema mapping fk check issue missing target entity": "{0}: Ziel-Entität fehlt.",
  "Import schema mapping fk check issue relation path end mismatch": "{0}: Relationspfad endet bei \"{1}\", erwartet wird \"{2}\".",
  "Import schema mapping fk check issue relation path start mismatch": "{0}: Relationspfad startet bei \"{2}\", erwartet wird \"{1}\".",
  "Import schema mapping fk check more issues": "weitere FK-Probleme",
  "Import schema mapping fk check summary": "Fremdschlüssel-Prüfung",
  "Import schema mapping lookup assistant path prepend row": "Pfadzeile davor einfügen",
  "Import schema mapping lookup assistant path start mismatch": "Pfad beginnt nicht mit der gewählten Quelltabelle.",
  "Import schema mapping remove source button": "Quelle entfernen",
  "Import schema mapping skip row on enum miss": "Zeile überspringen, wenn Enum-Wert fehlt",
  "Import schema mapping source check badge error": "Quelle: Fehler",
  "Import schema mapping source check badge warning": "Quelle: Hinweis",
  "Import schema mapping source check issue column not found": "Spalte in der Quelltabelle nicht gefunden.",
  "Import schema mapping enum miss required field warning": "{0}: nicht zugeordnete Quellwerte ({1}) blockieren den Import. Bitte alle Werte zuordnen oder „Zeile überspringen“ aktivieren.",
  "Import schema mapping enum check pending": "{0}: Quelldaten werden noch geladen; Prüfung steht aus.",
  "Import schema mapping source check issue missing column": "{0}: Quellspalte nicht zugeordnet.",
  "Import schema mapping source check issue missing table": "Quelltabelle nicht gesetzt.",
  "Import schema mapping source check issue table not found": "Quelltabelle nicht in den Importdateien gefunden.",
  "Import schema mapping source check more issues": "weitere Quellen-Probleme",
  "Import schema mapping source check summary": "Quellen-Prüfung",
  "Import schema mapping source preview empty": "keine Vorschaudaten.",
  "Import schema mapping source preview loading": "Vorschau wird geladen …",
  "Import schema mapping source preview tooltip": "Vorschau der Quelldaten für diese Zuordnung",
  "Import schemas column target model": "Zielmodell",
  "Import schemas target model outdated tag": "Zielmodell veraltet",
  "Invalid JSON in components": "ungültiges JSON in Komponenten",
  "Invalid duration": "ungültige Dauer",
  "Invalid start date": "ungültiges Startdatum",
  "Max": "Max.",
  "Max 4 icons (5th slot is QR when a reader is assigned).": "Maximal 4 Symbole (5. Slot ist QR, wenn ein Lesegerät zugewiesen ist).",
  "Studio app preview Open item 2": "Studio-App-Vorschau: offener Posten 2",
  "Studio app preview Open item 3": "Studio-App-Vorschau: offener Posten 3",
  "No icons selected. Use 'Add icon'.": "keine Symbole gewählt. „Symbol hinzufügen“ nutzen.",
  "Online-Buchungen": "Online-Buchungen",
  "Payload JSON": "Payload-JSON",
  "Plain text": "Klartext",
  "Open item is paid or in SEPA run": "offener Posten ist bezahlt oder in einem SEPA-Lauf.",
  "Optional fee booked as open item when this reminder is sent.": "Optionale Gebühr wird als offener Posten gebucht, wenn diese Mahnung versendet wird.",
  "Other reader device actions": "weitere Lesegerät-Aktionen",
  "Password too short (min. 4)": "Passwort zu kurz (mind. 4 Zeichen)",
  "Payment fully reversed": "zurückgebucht",
  "Payment rebooked": "umgebucht",
  "Payment partially voided": "teilweise zurückgebucht",
  "Payment refund": "Rückerstattung",
  "Payment reversal line": "Korrektur",
  "Payment reversal reason": "Grund für Korrektur",
  "Payment status reversed": "Zahlungsstatus: storniert",
  "Person defaults": "Personen-Standards",
  "Person profile photo enlarged alt": "Profilfoto vergrößert",
  "Phone Number ID": "Telefonnummern-ID",
  "Phone number added. Request verification code.": "Telefonnummer hinzugefügt. Bitte Bestätigungscode anfordern.",
  "Platform admin at least one must stay active": "Mindestens ein Plattform-Administrator muss aktiv bleiben.",
  "Platform admin cannot deactivate self": "Plattform-Administrator kann sich nicht selbst deaktivieren.",
  "Please select at least one open item": "Bitte mindestens einen offenen Posten auswählen.",
  "Previous": "zurück",
  "Quantity": "Menge",
  "Regenerate password confirm message": "neues Passwort erzeugen und dem Benutzer mitteilen?",
  "Register failed": "Registrierung fehlgeschlagen",
  "Recipient": "Empfänger",
  "Report events stacked by action": "Ereignisse nach Aktion gestapelt",
  "Report heatmap attendance subtitle": "Heatmap Anwesenheit",
  "Resetting…": "Wird zurückgesetzt…",
  "Saving…": "Wird gespeichert…",
  "Request code failed": "Code konnte nicht angefordert werden.",
  "Retry": "erneut versuchen",
  "Back to CenterCom imports": "zurück zu Adapter-Importen",
  "CenterCom action back": "zurück",
  "CenterCom import": "CenterCom-Import",
  "CenterCom imports": "Adapter-Importe",
  "CenterCom imports group card description": "Eigener CenterCom-Importpfad mit Upload, Analyse, Sonderregeln, Kontrollabgleich und Importausführung.",
  "CenterCom import analysis pending": "Upload gespeichert. Starte jetzt Schritt 2: Prüfung und Analyse.",
  "CenterCom import analysis error": "Analyse konnte nicht aktualisiert werden.",
  "CenterCom import analysis refreshed": "Analyse wurde aktualisiert.",
  "CenterCom import analyze button": "Analyse aktualisieren",
  "CenterCom import column name": "Bezeichnung",
  "CenterCom import column uploaded": "CSV/Dateien",
  "CenterCom import commit": "Import ausführen",
  "CenterCom import already committed": "Dieser Lauf wurde bereits importiert.",
  "CenterCom import already running": "Dieser Import läuft bereits oder wurde vor dem Abschluss unterbrochen.",
  "CenterCom import commit confirm content": "Der CenterCom-Import schreibt jetzt Personen, Verträge, Forderungen, Zahlungen und per Sonderregel entschiedene Artikel in den Zielmandanten.",
  "CenterCom base import commit confirm content": "Dieser Schritt importiert Grunddaten und Mitarbeiterkonten. Personen, konkrete Verträge, Zahlungen und andere personengebundene Daten werden noch nicht übernommen.",
  "CenterCom person import commit confirm content": "Dieser Schritt importiert alle Personen und die zugehörigen Vertrags-, Finanz-, Dokument- und Zutrittsdaten aus dem aktuellen CenterCom-Export.",
  "CenterCom import commit confirm title": "CenterCom-Import wirklich ausführen?",
  "CenterCom import commit error": "CenterCom-Import konnte nicht ausgeführt werden.",
  "CenterCom import commit failed detail": "Der Import wurde nicht abgeschlossen. Er ist entweder durch einen Systemfehler fehlgeschlagen oder durch einen Neustart unterbrochen worden. Details stehen im System-Log.",
  "CenterCom import commit success": "CenterCom-Import wurde ausgeführt.",
  "CenterCom import commit summary": "CenterCom-Import abgeschlossen",
  "Adapter import column adapter": "Adapter",
  "Adapter import create button": "neuer Import",
  "Adapter import create title": "neuer Import",
  "Adapter import action edit": "bearbeiten",
  "Adapter import action duplicate": "duplizieren",
  "Adapter import action reset status": "Status zurücksetzen",
  "Adapter import action rollback": "zurückrollen",
  "Adapter import action clear uploads": "Dateien löschen",
  "Adapter import action delete": "Import löschen",
  "Adapter import edit title": "Adapter-Import bearbeiten",
  "Adapter import edit display name label": "Bezeichnung",
  "Adapter import maintenance section title": "bereinigen",
  "Adapter import maintenance section hint": "Diese Aktionen wirken sofort auf den ausgewählten Import-Vorgang.",
  "Adapter import save success": "Adapter-Import gespeichert.",
  "Adapter import adapter required": "Bitte einen Adapter auswählen.",
  "Adapter import confirm duplicate": "Adapter-Import duplizieren?",
  "Adapter import confirm duplicate detail": "Die Konfiguration wird kopiert, hochgeladene Dateien jedoch nicht.",
  "Adapter import duplicate success": "Adapter-Import dupliziert.",
  "Adapter import duplicate error": "Adapter-Import konnte nicht dupliziert werden.",
  "Adapter import confirm reset status": "Importlauf zurücksetzen?",
  "Adapter import confirm reset status detail": "Der Lauf wird so zurückgesetzt, dass Mapping, Precheck und Import erneut durchlaufen werden können. Hochgeladene Dateien, Mapping-Entscheidungen und das Analyseergebnis bleiben erhalten; das Precheck-Ergebnis wird verworfen. Bei einem bereits importierten Lauf bleiben die importierten Datensätze in der Datenbank; dafür ist die Aktion „zurückrollen“ gedacht.",
  "Adapter import reset status success": "Status zurückgesetzt.",
  "Adapter import reset status error": "Status konnte nicht zurückgesetzt werden.",
  "Adapter import confirm rollback": "Import zurückrollen?",
  "Adapter import confirm rollback detail": "Durch den Import angelegte Datensätze werden gelöscht. Vorgang nicht reversibel.",
  "Adapter import rollback success": "Import zurückgerollt.",
  "Adapter import rollback error": "Zurückrollen fehlgeschlagen.",
  "Adapter import rollback progress": "Zurückrollen: {0}",
  "Adapter import rollback phase download": "Sicherung wird geladen",
  "Adapter import rollback phase verify": "Sicherung wird geprüft",
  "Adapter import rollback phase import": "Wiederherstellung wird vorbereitet",
  "Adapter import rollback phase databaseDelete": "Importdaten werden entfernt",
  "Adapter import rollback phase databaseImport": "Datenbank wird wiederhergestellt",
  "Adapter import rollback phase files": "Dateien werden wiederhergestellt",
  "Adapter import rollback phase promote": "Dateien werden aktiviert",
  "Adapter import rollback phase commit": "Wiederherstellung wird abgeschlossen",
  "Adapter import rollback phase cleanup": "temporäre Daten werden entfernt",
  "Adapter import confirm clear uploads": "hochgeladene Dateien löschen?",
  "Adapter import confirm clear uploads detail": "Alle Uploads des Vorgangs werden aus dem Speicher gelöscht. Zuordnungen bleiben erhalten.",
  "Adapter import clear uploads success": "hochgeladene Dateien gelöscht.",
  "Adapter import clear uploads error": "Dateien konnten nicht gelöscht werden.",
  "Adapter import clear uploads job started": "Löschen der hochgeladenen Dateien wurde gestartet.",
  "Import adapter centercom": "CenterCom",
  "Import adapter icm": "ICM",
  "ICM import created": "ICM-Import angelegt.",
  "ICM import display name placeholder": "z. B. ICM-Import Mai 2026",
  "ICM import load error": "ICM-Import konnte nicht geladen werden.",
  "Adapter import run load error": "Importlauf konnte nicht geladen werden.",
  "Import adapter status Committed": "abgeschlossen",
  "Import adapter status Committing": "wird ausgeführt",
  "Import adapter status ClearingUploads": "Upload wird gelöscht",
  "Import adapter status Draft": "Entwurf",
  "Import adapter status Failed": "fehlgeschlagen",
  "Import adapter status Prechecking": "Vorprüfung läuft",
  "Import adapter status PrecheckFailed": "Vorprüfung fehlgeschlagen",
  "Import adapter status Ready": "bereit",
  "Import adapter status RolledBack": "zurückgerollt",
  "Import adapter status UploadProcessing": "Upload wird verarbeitet",
  "Import adapter status Uploaded": "hochgeladen",
  "Import adapter step upload": "hochladen",
  "Import adapter step verify": "prüfen und analysieren",
  "Import adapter step decisions": "Zuordnungen",
  "Import adapter step precheck": "Vorprüfung",
  "Import adapter step import": "Import",
  "Import adapter action back": "zurück",
  "Import adapter continue verify": "weiter zur Prüfung",
  "Import adapter continue decisions": "weiter zu Zuordnungen",
  "Import adapter continue precheck": "weiter",
  "Import adapter save and continue precheck": "speichern und weiter",
  "Import adapter continue import": "weiter zum Import",
  "Import adapter decisions title": "zuordnen",
  "Import adapter decision area selector": "Zuordnungsbereich",
  "Import adapter decision next area": "nächster Zuordnungsbereich",
  "Import adapter decision previous area": "vorheriger Zuordnungsbereich",
  "Import adapter decision invalid assignments": "{0} Zuordnungen verweisen auf nicht mehr vorhandene Zielobjekte. Bitte die betroffenen Auswahlen korrigieren oder auf „neu importieren“/„ignorieren“ setzen.",
  "Import adapter unsaved changes": "ungespeicherte Änderungen",
  "Import adapter unsaved changes blocking": "Bitte zuerst offene Änderungen speichern oder verwerfen.",
  "Import adapter save selection": "speichern",
  "Import adapter discard changes": "Änderungen verwerfen",
  "Import adapter selection saved": "gespeichert.",
  "Import adapter changes discarded": "Änderungen wurden verworfen.",
  "Import adapter no issues": "keine Hinweise.",
  "Import adapter run precheck": "Vorprüfung ausführen",
  "Import adapter precheck not run": "Die Vorprüfung wurde für diesen Stand noch nicht ausgeführt.",
  "Import adapter commit": "Import ausführen",
  "Import adapter upload title": "hochladen",
  "Import adapter upload button": "Dateien hochladen",
  "Import adapter upload committed run title": "dieser Import ist abgeschlossen",
  "Import adapter upload committed run detail": "Dateien können gelöscht und nachgeladen werden. Ein erneuter Import ersetzt die Sicherung, auf die das Zurückrollen zeigt.",
  "Import adapter verify title": "Daten prüfen und analysieren",
  "Import adapter verify missing analysis": "Noch keine geprüften Daten vorhanden. Starte die Prüfung und Analyse.",
  "Import adapter workflow status upload": "Dateien hochladen. Der Prüfschritt folgt danach.",
  "Import adapter workflow status import committed": "Import wurde ausgeführt.",
  "Import adapter workflow status import rolled back": "Import wurde zurückgerollt. Die importierten Daten wurden entfernt.",
  "Import adapter progress server processing": "Server verarbeitet Dateien",
  "Import adapter progress prechecking": "Vorprüfung läuft",
  "Import adapter progress committing": "Import wird ausgeführt",
  "Import adapter progress clearing uploads": "hochgeladene Dateien werden gelöscht",
  "Import adapter progress working": "Vorgang läuft",
  "Import adapter target tenant": "Zielmandant",
  "Import adapter rollback confirm": "Der gesamte Mandant wird auf den Sicherungsstand unmittelbar vor diesem Importschritt zurückgesetzt. Auch alle danach vorgenommenen Änderungen gehen verloren. Fortfahren?",
  "Import adapter commit confirm": "Import jetzt ausführen? Vor dem Import wird eine Mandantensicherung erzeugt.",
  "Import adapter confirm delete": "Import und alle hochgeladenen Dateien wirklich löschen?",
  "Import adapter deleted": "Import gelöscht.",
  "Import adapter delete error": "Import konnte nicht gelöscht werden.",
  "Import adapter created": "Import angelegt.",
  "Import adapter select tenant": "Mandant auswählen",
  "Import adapter tenant required": "Bitte einen Mandanten auswählen.",
  "Import adapter display name": "Bezeichnung",
  "Import adapter display name placeholder": "z. B. Import Mai 2026",
  "Import adapter column name": "Bezeichnung",
  "Import adapter column uploaded": "Einheiten/Dateien",
  "Import adapter column import mode": "Umfang",
  "Import adapter commit error": "Import konnte nicht gestartet werden.",
  "Import adapter precheck error": "Vorprüfung konnte nicht gestartet werden.",
  "Import adapter upload error": "Upload konnte nicht gestartet werden.",
  "Import adapter configuration download": "Konfiguration herunterladen",
  "Import adapter configuration upload": "Konfiguration hochladen",
  "Import adapter configuration downloaded": "Konfiguration wurde heruntergeladen.",
  "Import adapter configuration uploaded": "Konfiguration wurde hochgeladen.",
  "Import adapter configuration upload invalid": "Bitte eine gültige Import-Konfigurationsdatei auswählen.",
  "ICM import person run": "CenterCom-Import mit Personen",
  "ICM import person run required": "Bitte einen abgeschlossenen CenterCom-Import mit Personen wählen.",
  "ICM import person run placeholder": "abgeschlossenen CenterCom-Import wählen",
  "ICM import person run hint": "Personen kommen aus einem abgeschlossenen CenterCom-Import desselben Mandanten — vollständiger Import oder restliche Daten.",
  "ICM import person run empty": "Für diesen Mandanten gibt es keinen abgeschlossenen CenterCom-Import mit Personen. Zuerst CenterCom als vollständigen Import oder mit restlichen Daten (Personen und Vorgänge) abschließen.",
  "ICM import person run empty short": "kein passender CenterCom-Import",
  "ICM import person run load error": "Die CenterCom-Importe konnten nicht geladen werden.",
  "ICM import mode none": "Leads und Termine",
  "ICM step upload": "Dateien",
  "ICM step scope": "Umfang",
  "ICM step decisions": "Zuordnungen",
  "ICM step precheck": "Vorprüfung",
  "ICM step import": "Import",
  "ICM import upload step hint": "ICM-Studio-ZIPs hier hochladen.",
  "ICM import upload hint": "ICM-Studio-ZIPs hier ablegen.",
  "ICM import analysis summary": "{0} Pakete, {1} Leads, {2} künftige Termine, {3} Vergangenheit übersprungen, {4} leere Termine.",
  "ICM import package": "Paket",
  "ICM import webtenant": "webtenant",
  "ICM package scope lead": "Leads",
  "ICM package scope kalender": "Termine",
  "ICM import scope": "Inhalt",
  "ICM import leads": "Leads",
  "ICM import appointments": "Termine",
  "ICM import future appointments": "künftige Termine",
  "ICM import scope leads": "Leads importieren",
  "ICM import scope appointments": "Termine importieren",
  "ICM import from date": "Termine ab",
  "ICM import from date hint": "Termine, deren Ende vor diesem Tag liegt, werden übersprungen.",
  "ICM import past appointments": "Vergangenheit",
  "ICM decision kind leadStudio": "Lead-Studio (MandantID)",
  "ICM decision kind calendarStudio": "Kalender-Studio (webtenant)",
  "ICM decision kind appointmentType": "Terminarten",
  "ICM decision kind studio": "Studio",
  "ICM decision kind leadStatus": "Phasenmodell",
  "ICM decision kind leadPipeline": "Phasenmodell",
  "ICM lead pipeline placeholder": "Phasenmodell wählen",
  "ICM import person run unnamed": "CenterCom-Import ohne Bezeichnung",
  "ICM decision kind appointmentStatus": "Terminstatus",
  "ICM decision source": "Quelle",
  "ICM decision target": "Ziel",
  "ICM decision skip": "nicht importieren",
  "ICM import run precheck": "Vorprüfung starten",
  "ICM import precheck ready": "Vorprüfung ohne Blocker.",
  "ICM import precheck blocked": "Vorprüfung hat noch Lücken.",
  "ICM import precheck counts": "{0} Leads importierbar, {1} davon schon vorhanden, {2} Termine importierbar, {3} Vergangenheit übersprungen, {4} ohne Person.",
  "ICM skipped appointments": "Termine ohne Person oder nicht übernommen",
  "ICM appointment skip outcome": "Übernahme",
  "ICM appointment skip importable": "wird importiert",
  "ICM appointment skip omitted": "wird nicht importiert",
  "ICM appointment skip reason without_person": "ohne Person",
  "ICM appointment skip reason unresolved_person": "Person nicht auflösbar",
  "ICM appointment skip reason type_skipped": "Terminart nicht übernommen",
  "ICM appointment skip reason type_unmapped": "Terminart nicht zugeordnet",
  "ICM appointment skip reason studio_skipped": "Studio nicht übernommen",
  "ICM appointment skip reason studio_unmapped": "Studio nicht zugeordnet",
  "ICM appointment skip reason status_unmapped": "Status nicht zugeordnet",
  "ICM verify hint": "Pakete, Leads und Termine prüfen.",
  "ICM statistic packages": "Pakete",
  "ICM gap s3nr": "S3Nr",
  "ICM gap kind": "Art",
  "ICM gap reason": "Grund",
  "ICM gap count": "Anzahl",
  "ICM import confirm commit": "ICM-Import jetzt ausführen?",
  "ICM import action commit": "importieren",
  "ICM import rollback snapshot confirm": "Vor dem Import wird eine Mandantensicherung erzeugt. Ein Zurückrollen stellt diesen Stand wieder her; alles danach Geänderte geht mit verloren.",
  "ICM import commit summary": "{0} Leads angelegt, {1} Termine angelegt, {2} vor dem Stichtag übersprungen.",
  "IcmCenterComPersonRunRequired": "Wählen Sie einen abgeschlossenen CenterCom-Import mit Personen desselben Mandanten.",
  "IcmCenterComPersonRunModeInvalid": "Der gewählte CenterCom-Import enthält keine Personen.",
  "CenterCom import control comparisons": "Kontrollabgleich",
  "CenterCom import control reports": "Kontrollberichte",
  "CenterCom import confirm delete": "CenterCom-Import und alle hochgeladenen Dateien wirklich löschen?",
  "CenterCom import create": "CenterCom-Import anlegen",
  "CenterCom import created": "CenterCom-Import angelegt.",
  "CenterCom import mode": "Importumfang",
  "CenterCom import mode changed": "Importumfang gespeichert. Die Zuordnungen bleiben erhalten; bitte führen Sie die Vorprüfung erneut aus.",
  "CenterComImportModeLocked": "Der Importumfang kann während einer laufenden Verarbeitung, nach dem Import oder bei einem Nachimport nicht geändert werden.",
  "CenterCom import mode required": "Bitte wählen Sie den Importumfang.",
  "CenterCom import mode Full": "vollständiger Import",
  "CenterCom import mode BaseDataAndStaff": "Grunddaten und Mitarbeiter",
  "CenterCom import mode PersonsAndDependentData": "restliche Daten (Personen und Vorgänge)",
  "CenterComImportModeUnsupported": "Der gewählte CenterCom-Importumfang ist ungültig.",
  "CenterComBaseRunHasFollowUps": "Der Grunddatenlauf kann erst gelöscht werden, wenn seine Folgeläufe gelöscht wurden.",
  "CenterComPersonFollowUpUnavailable": "Der Vollimport konnte für diesen abgeschlossenen Grunddatenlauf nicht aktiviert werden.",
  "ImportAdapterPrecheckRequired": "Bitte zuerst die Vorprüfung ohne Blocker ausführen.",
  "ImportAdapterAlreadyCommitted": "Dieser Lauf wurde bereits importiert.",
  "ImportAdapterAlreadyRunning": "Dieser Import läuft bereits oder wurde vor dem Abschluss unterbrochen.",
  "ImportAdapterRollbackUnavailable": "Für diesen Import ist keine automatische Sicherung hinterlegt.",
  "CenterComFollowUpMustBeRolledBackFirst": "Die spätere Importstufe muss zuerst gelöscht oder zurückgerollt werden.",
  "CenterCom base import ready title": "Grunddaten und Mitarbeiter sind importiert",
  "CenterCom base import ready detail": "Stellen Sie den Importumfang auf „restliche Daten“, um diesen Lauf mit den vorhandenen Daten und Zuordnungen fortzusetzen. Anschließend lädt der Assistent den Schritt „Hochladen“, damit Sie einen frischen Export nachladen können.",
  "CenterCom upload committed run title": "dieser Import ist abgeschlossen",
  "CenterCom upload committed run detail": "Dateien können gelöscht und nachgeladen werden. Solange der Umfang nicht auf „restliche Daten“ steht, bezieht sich ein erneuter Import auf denselben Umfang wie der abgeschlossene Lauf. Die Sicherung, auf die das Zurückrollen zeigt, wird dabei durch die des nächsten Imports ersetzt.",
  "CenterCom upload stored files": "{0} Dateien im Speicher, davon {1} Quelltabellen.",
  "CenterCom import data selection": "Datenauswahl",
  "CenterCom import delete error": "CenterCom-Import konnte nicht gelöscht werden.",
  "CenterCom import deleted": "CenterCom-Import gelöscht.",
  "CenterCom import display name": "Bezeichnung",
  "CenterCom import display name placeholder": "z. B. CenterCom-Import Mai 2026",
  "CenterCom import issues": "Hinweise und Fehler",
  "CenterCom import no issues": "keine Hinweise.",
  "CenterCom issue centercom.analysis.person_table_missing": "Es wurde keine eindeutige CenterCom-Personentabelle erkannt. Erwartet wird STAMMDATEN oder IDENTITAET.",
  "CenterCom issue centercom.analysis.contract_history_missing": "Es wurde keine VERTHIST-Tabelle erkannt. Die Vertragsplanung ist dadurch unvollständig.",
  "CenterCom issue centercom.analysis.payments_without_invoices": "Zahlungsdaten wurden ohne Rechnungsdaten erkannt. Die Zahlungsabstimmung benötigt eventuell eine Saldenstrategie.",
  "CenterCom issue centercom.knowledge.no_mapping_source": "Es wurde kein bestehendes CenterCom-Mapping-Schema gefunden. Der CenterCom-Adapter verwendet eingebaute Standardregeln und laufbezogene Sonderregeln.",
  "CenterCom issue centercom.knowledge.relations_parse_failed": "Quellbeziehungen aus Mapping-Schema „{0}“ konnten nicht als CenterCom-Wissen gelesen werden: {1}",
  "CenterCom issue centercom.knowledge.schema_parse_failed": "Mapping-Schema „{0}“ konnte nicht als CenterCom-Wissen gelesen werden: {1}",
  "CenterCom issue centercom.plan.person_table_missing": "STAMMDATEN oder IDENTITAET wird für den CenterCom-Import benötigt.",
  "CenterCom issue centercom.plan.person_follow_up_missing_base_run": "Für den Personenimport ist kein abgeschlossener Grunddatenlauf hinterlegt.",
  "CenterCom issue centercom.plan.person_follow_up_invalid_base_run": "Der zugehörige Grunddatenlauf fehlt, gehört zu einem anderen Mandanten oder ist nicht mehr abgeschlossen.",
  "CenterCom issue centercom.plan.person_follow_up_mapping_missing": "Das ID-Mapping des Grunddatenlaufs fehlt. Die übernommenen Zuordnungen können nicht sicher geprüft werden.",
  "CenterCom issue centercom.plan.unused_source_tables": "Diese erkannten CenterCom-Tabellen werden in diesem Adapterablauf nicht importiert: {0}.",
  "CenterCom issue centercom.person.missing_id": "{0} Personenzeilen wurden übersprungen, weil kein Personenschlüssel gefunden wurde.",
  "CenterCom issue centercom.person.duplicate_id": "{0} doppelte Personen-Schlüssel wurden übersprungen.",
  "CenterCom issue centercom.cancellation_model.skipped": "{0} KUENDTARIFE-Zeilen wurden übersprungen, weil ID oder Name fehlen.",
  "CenterCom issue centercom.rest_period_template.skipped": "{0} RUHEZEITGRUND-Zeilen wurden übersprungen, weil ID oder Name fehlen.",
  "CenterCom issue centercom.rest_period_reason.skipped": "{0} RUHEZEITGRUND-Zeilen wurden übersprungen, weil ID oder Name fehlen.",
  "CenterCom issue centercom.contract.skipped": "{0} VERTHIST-Zeilen wurden übersprungen, weil Person, Vertrags-ID oder Startdatum fehlen.",
  "CenterCom issue centercom.contract.name_ignored": "{0} VERTHIST-Zeilen wurden durch feste Vertragsnamen-Ausnahmen ignoriert.",
  "CenterCom issue centercom.contract.exclusion_ignored": "{0} VERTHIST-Zeilen wurden durch Ausschlussentscheidungen ignoriert.",
  "CenterCom issue centercom.contract.ignored": "{0} VERTHIST-Zeilen wurden durch Positionsregeln ignoriert.",
  "CenterCom issue centercom.contract.article_missing": "{0} VERTHIST-Zeilen passen zu einer Artikelregel, haben aber keinen Zielartikel.",
  "CenterCom issue centercom.contract_template.accounting_account_conflict": "{0} Vertragsvorlagen hatten Rechnungspositionen mit mehreren Buchführungskonten. Das am häufigsten verwendete Konto wurde als Erstzuweisung gesetzt.",
  "CenterCom issue centercom.contract.package_primary_missing": "{0} VERTHIST-Zeilen gehören zu Vertragspaket-Gruppen, bei denen kein Hauptvertrag aus der Quelle gefunden oder ausgewählt wurde.",
  "CenterCom issue centercom.contract.cancellation_model_combination_missing": "{0} VERTHIST-Zeilen haben abweichende fachliche Kündigungsfristen aus Erstlaufzeit und Verlängerung, aber keine passende Kündigungsmodell-Zuordnung. Die Verträge werden trotzdem mit den CenterCom-Laufzeit- und Verlängerungsdaten importiert; nur der optionale Kündigungsmodell-Snapshot bleibt leer.",
  "CenterCom issue centercom.contract.template_missing": "{0} VERTHIST-Zeilen haben keine aufgelöste Vertragsvorlage. Das ist kein blockierender Fehler; bitte den Precheck mit der aktuellen Adapterlogik erneut starten.",
  "CenterCom issue centercom.invoice.skipped": "{0} RECHNUNG-Zeilen wurden übersprungen, weil Person, Rechnungs-ID oder Fälligkeitsdatum fehlen.",
  "CenterCom issue centercom.invoice.ignored": "{0} RECHNUNG-Zeilen wurden durch Ausschlüsse ignoriert.",
  "CenterCom issue centercom.special_payment.skipped": "{0} SONDERZAHLUNG-Zeilen wurden übersprungen, weil Vertrag, Person oder Datum fehlen.",
  "CenterCom issue centercom.special_payment.ignored": "{0} SONDERZAHLUNG-Zeilen wurden durch Sonderregeln ignoriert.",
  "CenterCom issue centercom.special_payment.article_missing": "{0} SONDERZAHLUNG-Zeilen passen zu einer Artikelregel, haben aber keinen Zielartikel.",
  "CenterCom issue centercom.special_payment.package_missing": "{0} SONDERZAHLUNG-Zeilen sind als Vertragsbestandteile konfiguriert, konnten aber keinem VERTHIST-Vertragspaket mit Hauptvertrag zugeordnet werden.",
  "CenterCom issue centercom.special_payment.contract_template_missing": "{0} SONDERZAHLUNG-Zeilen haben keine aufgelöste Vertragsvorlage. Das ist kein blockierender Fehler; bitte den Precheck mit der aktuellen Adapterlogik erneut starten.",
  "CenterCom issue centercom.payment.skipped": "{0} ZAHLUNG-Zeilen wurden übersprungen, weil Person, Zahlungs-ID oder Zahlungsdatum fehlen.",
  "CenterCom issue centercom.payment.unlinked": "{0} ZAHLUNG-Zeilen wurden ohne Verknüpfung mit einem offenen Posten importiert, weil keine nutzbare Rechnung und kein nutzbarer offener Posten aufgelöst werden konnte.",
  "CenterCom issue centercom.payment.unlinked_skipped": "{0} ZAHLUNG-Zeilen wurden übersprungen, weil kein nutzbarer Bezug zu einer Rechnung oder einem offenen Posten aufgelöst werden konnte.",
  "CenterCom issue centercom.plausibility.payment_zero_amount_with_date": "{0} ZAHLUNG-Zeilen haben ein Zahlungsdatum, aber Betrag 0.",
  "CenterCom issue centercom.plausibility.sepa_payment_zero_amount_with_date": "{0} ZAHLUNG-Zeilen haben ein Zahlungsdatum und Betrag 0, obwohl der verknüpfte Beitrag auf Lastschrift steht.",
  "CenterCom issue centercom.plausibility.submitted_sepa_open_item_already_paid": "{0} Beiträge sind einem aktiven Lastschriftlauf zugeordnet und gleichzeitig bereits vollständig bezahlt.",
  "CenterCom issue centercom.rest_period.skipped": "{0} RUHEZEIT-Zeilen wurden übersprungen, weil kein importierbarer Vertrag mit Paket, keine Person oder kein Datum aufgelöst werden konnte.",
  "CenterCom issue centercom.rest_period.ignored": "{0} RUHEZEIT-Zeilen wurden durch bestätigte Ausschlussentscheidungen ignoriert.",
  "CenterCom issue centercom.rest_period.cancelled_imported": "{0} stornierte RUHEZEIT-Zeilen wurden als stornierte Ruhezeiten importiert.",
  "CenterCom issue centercom.wallet.skipped": "{0} LEISTUNG-Zeilen wurden übersprungen, weil Person oder Wertekonto-ID fehlen.",
  "CenterCom issue centercom.wallet_transaction.skipped": "{0} LEISTUNGSNUTZUNG-Zeilen zu importierten Wertekonten wurden übersprungen, weil Buchungs-ID oder Zeitpunkt fehlen.",
  "CenterCom issue centercom.sepa_run.skipped": "{0} RECHNUNGSLAUFAUFTRAG-Zeilen wurden übersprungen, weil Pflichtdaten für den Lastschriftlauf fehlen.",
  "CenterCom issue centercom.sepa_item.skipped": "{0} Lastschriftpositionen wurden übersprungen, weil Person, Lauf-ID oder Fälligkeit fehlen.",
  "CenterCom issue centercom.sepa_item.run_missing": "{0} Lastschriftpositionen wurden übersprungen, weil der zugehörige Lastschriftlauf nicht importiert wurde.",
  "CenterCom issue centercom.sepa_item.open_item_missing": "{0} Lastschriftpositionen wurden ohne Verknüpfung mit einem offenen Posten importiert, weil kein importierter offener Posten aufgelöst werden konnte.",
  "CenterCom issue centercom.access_media.skipped": "{0} KARTENNUMMER-Zeilen wurden übersprungen, weil Kartendaten fehlen, die Person existiert, aber nicht importiert wurde, oder die Medium-ID doppelt ist.",
  "CenterCom issue centercom.access_media.person_missing": "{0} KARTENNUMMER-Zeilen wurden übersprungen, weil die referenzierte Person in den CenterCom-Personentabellen nicht existiert.",
  "CenterCom issue centercom.staff_member.access_media_skipped": "{0} KARTENNUMMER-Zeilen wurden übersprungen, weil die Person als Mitarbeiter erkannt und nicht als Mitglied importiert wird.",
  "CenterCom issue centercom.checkin.skipped": "{0} LEISTUNGSNUTZUNG-Zeilen wurden für Check-ins übersprungen, weil Person oder Zeitstempel fehlen.",
  "CenterCom issue centercom.checkin.checkout_finalized": "{0} synthetische Check-out-Ereignisse wurden ergänzt, damit importierte CenterCom-Verläufe keine Personen aktiv eingecheckt lassen.",
  "CenterCom issue centercom.person_note.skipped": "{0} NOTIZ-Zeilen wurden übersprungen, weil Person oder Text fehlen.",
  "CenterCom issue centercom.person_document.skipped": "{0} DOKUMENTE-Zeilen wurden übersprungen, weil Dokument-ID, Person oder Dateiverweis fehlen oder die Person nicht importiert wurde.",
  "CenterCom issue centercom.staff_member.person_document_skipped": "{0} DOKUMENTE-Zeilen wurden übersprungen, weil die Person als Mitarbeiter erkannt und nicht als Mitglied importiert wird.",
  "CenterCom issue centercom.person_document.file_missing": "{0} DOKUMENTE-Zeilen wurden übersprungen, weil die referenzierte Datei im hochgeladenen Dokumentarchiv nicht gefunden wurde.",
  "CenterCom issue centercom.person_document.kept_without_file": "{0} DOKUMENTE-Zeilen wurden ohne Datei übernommen, weil die referenzierte Datei im hochgeladenen Dokumentarchiv nicht gefunden wurde.",
  "CenterCom issue centercom.person_document.file_shared": "{0} DOKUMENTE-Zeilen verweisen auf eine Datei, die auch von anderen Zeilen verwendet wird. Die Datei wurde nicht angehängt, weil die Quelle nicht sagt, zu welcher Zeile sie gehört.",
  "CenterCom issue centercom.contract_price_adjustment.skipped": "{0} VERTRAGSPREISANPASSUNG-Zeilen wurden übersprungen, weil Vertrag, ID oder Datum fehlen.",
  "CenterCom issue centercom.payment_cancellation_reason.skipped": "{0} STORNOGRUND-Zeilen wurden übersprungen, weil ID oder Name fehlen.",
  "CenterCom issue centercom.cancellation_reason.skipped": "{0} KUENDIGUNGSGRUND-Zeilen wurden übersprungen, weil ID oder Name fehlen.",
  "CenterCom issue centercom.reminder_level.skipped": "{0} MAHNSTUFE-Zeilen wurden übersprungen, weil ID oder Mahnstufe fehlen.",
  "CenterCom issue centercom.reminder.skipped": "{0} MAHNUNG-Zeilen wurden übersprungen, weil offener Posten, Mahnstufe oder Datum fehlen.",
  "CenterCom issue centercom.reminder.document_linked": "{0} MAHNUNG-Zeilen wurden mit importierten DOKUMENTE-Zeilen verknüpft.",
  "CenterCom issue centercom.debt_collection_agency.skipped": "{0} EXTERNERZAHLUNGSVERFOLGER-Zeilen wurden übersprungen, weil ID oder Name fehlen.",
  "CenterCom issue centercom.debt_collection_case.skipped": "{0} EXTERNEZAHLUNGSVERFOLGUNG-Zeilen wurden übersprungen, weil Person oder Inkassofall fehlen.",
  "CenterCom issue centercom.debt_collection_case_item.skipped": "{0} EXTERNEZAHLUNGSVERFOLGUNGRECHNUNG-Zeilen wurden übersprungen, weil Fall oder offener Posten fehlen.",
  "CenterCom issue centercom.open_item_correction.skipped": "{0} RECHNUNGKORREKTURRECHNUNG-Zeilen wurden übersprungen, weil Ursprungsrechnung oder Korrekturposten fehlen.",
  "CenterCom issue centercom.open_item_correction.auto_linked": "{0} CenterCom-Stornopaare offener Posten wurden per Fallback-Zuordnung verknüpft und neutralisiert.",
  "CenterCom issue centercom.vat_settings.skipped": "{0} STEUERSCHLUESSEL-Zeilen wurden übersprungen, weil ID, Name oder Steuersatz fehlen.",
  "CenterCom issue centercom.accounting_account.skipped": "{0} BUCHUNGSKONTO-Zeilen wurden übersprungen, weil ID, Kontonummer oder Name fehlen.",
  "CenterCom issue centercom.accounting_account.duplicate_number_reused": "{0} BUCHUNGSKONTO-Zeilen verwendeten eine bereits geplante Kontonummer und wurden mit dem ersten geplanten Konto verknüpft.",
  "CenterCom issue centercom.accounting_account.duplicate_planned_number": "{0} Buchungskonto-Zuordnungen würden mehrere neue Buchungskonten mit derselben Kontonummer anlegen oder eine bestehende Kontonummer erneut verwenden.",
  "CenterCom issue centercom.accounting_account.planned_number_missing": "{0} geplante Buchungskonten konnten nicht angelegt werden, weil keine Kontonummer gesetzt ist.",
  "CenterCom issue centercom.accounting_account.type_defaulted": "{0} BUCHUNGSKONTO-Zeilen hatten unbekannte Kontotypen und wurden als Ertragskonten importiert.",
  "CenterCom issue centercom.article.skipped": "{0} ARTIKEL-Zeilen wurden übersprungen, weil ID oder Name fehlen.",
  "CenterCom issue centercom.article.ignored": "{0} ARTIKEL-Zeilen wurden durch Ausschlussentscheidungen ignoriert.",
  "CenterCom issue centercom.article.exclusion_available": "ARTIKEL-Zeilen können weiterhin über Quelltabellen- oder Zeilenignorierung ausgeschlossen werden.",
  "CenterCom issue centercom.article.price_missing": "{0} ARTIKEL-Zeilen hatten keine passende ARTIKELPREIS-Zeile und wurden mit Preis 0 importiert.",
  "CenterCom issue centercom.article.account_missing": "{0} ARTIKELPREIS-Zeilen verweisen auf kein importiertes BUCHUNGSKONTO. Die Artikel wurden ohne Buchungskonto importiert.",
  "CenterCom issue centercom.staff_member.contract_skipped": "{0} VERTHIST-Zeilen wurden übersprungen, weil die Person als Mitarbeiter erkannt und nicht als Mitglied importiert wird.",
  "CenterCom issue centercom.staff_member.invoice_skipped": "{0} RECHNUNG-Zeilen wurden übersprungen, weil die Person als Mitarbeiter erkannt und nicht als Mitglied importiert wird.",
  "CenterCom issue centercom.staff_member.wallet_skipped": "{0} LEISTUNG-Zeilen wurden übersprungen, weil die Person als Mitarbeiter erkannt und nicht als Mitglied importiert wird.",
  "CenterCom issue centercom.staff_member.person_skipped": "{0} Personenzeilen wurden übersprungen, weil sie als Mitarbeiter erkannt wurden und nicht als Mitglied importiert werden.",
  "CenterCom issue centercom.staff.accounts_imported_without_access": "{0} CenterCom-Mitarbeiter-/Benutzerzeilen werden als neue m1member-Konten geplant. Passwörter und CenterCom-Rechte werden nicht importiert; Rollen kommen aus der Rollenauswahl für neue Konten oder fallen auf ImportedStaff zurück.",
  "CenterCom issue centercom.staff.user_personal_match": "Der Abgleich von CenterCom USER/PERSONAL nutzt USER.Trainernummer -> PERSONAL.Personalnummer ({0} passende USER-Zeilen, {1} reine USER-Zeilen, {2} reine PERSONAL-Zeilen).",
  "CenterCom issue centercom.audit.crm": "CenterCom-CRM-Quelltabellen wurden erkannt, werden in dieser Adapterversion aber nur geprüft.",
  "CenterCom issue centercom.audit.staff": "CenterCom-Mitarbeiter-Quelltabellen wurden erkannt, werden in dieser Adapterversion aber nur geprüft.",
  "CenterCom issue centercom.open_item.external_duplicate": "{0} CenterCom-offene-Posten existieren bereits im Zielmandanten. Der Import ist blockiert, damit er eindeutig wiederholbar bleibt.",
  "CenterCom issue centercom.references.studio_missing": "{0} zugeordnete Studio-Referenzen existieren nicht im Zielmandanten.",
  "CenterCom issue centercom.references.package_template_missing": "{0} zugeordnete Paketvorlagen existieren nicht im Zielmandanten.",
  "CenterCom issue centercom.references.contract_template_missing": "{0} zugeordnete Vertragsvorlagen existieren nicht im Zielmandanten.",
  "CenterCom issue centercom.references.article_missing": "{0} zugeordnete Artikel existieren nicht im Zielmandanten.",
  "CenterCom control comparison csv only": "Der Kontrollbericht wurde erkannt, aber nur CSV-Berichte können in diesem Import automatisch verglichen werden.",
  "CenterCom control comparison count matches": "Die Zeilenanzahl des Kontrollberichts passt zur geplanten Importanzahl.",
  "CenterCom control comparison count differs": "Die Zeilenanzahl des Kontrollberichts weicht von der geplanten Importanzahl ab ({0} zu {1}).",
  "CenterCom control comparison count amount matches": "Der Kontrollbericht passt bei Anzahl und Betrag zum geplanten Import.",
  "CenterCom control comparison count amount differs": "Der Kontrollbericht weicht vom geplanten Import ab (Anzahl {0} zu {1}, Betrag {2} zu {3}).",
  "CenterCom precheck decision column": "Entscheidung",
  "CenterCom precheck decision required": "entscheiden",
  "CenterCom precheck decision ignore": "nicht importieren",
  "CenterCom precheck ignore confirm title": "betroffene Daten nicht importieren?",
  "CenterCom precheck ignore confirm content": "Diese Entscheidung schreibt eine Ausschluss-/Ignorier-Regel in die Zuordnung. Danach speichern und den Precheck erneut starten.",
  "CenterCom precheck ignore confirm action": "nicht importieren",
  "CenterCom precheck decision open packages": "Kundenverträge öffnen",
  "CenterCom precheck decision open special payments": "Sonderzahlungen öffnen",
  "CenterCom precheck decision open studios": "Studios öffnen",
  "CenterCom precheck decision open articles": "Artikel öffnen",
  "CenterCom import not found": "CenterCom-Import nicht gefunden.",
  "CenterCom import plan counts": "Importplan",
  "CenterCom import precheck": "Precheck ausführen",
  "CenterCom import precheck completed": "Precheck abgeschlossen.",
  "CenterCom import precheck cancelled": "Precheck abgebrochen.",
  "CenterCom import precheck error": "Precheck konnte nicht ausgeführt werden.",
  "CenterCom import save selection": "speichern",
  "CenterCom import discard changes": "Änderungen verwerfen",
  "CenterCom import changes discarded": "Änderungen wurden verworfen.",
  "CenterCom import select tenant": "Mandant auswählen",
  "CenterCom import selection saved": "gespeichert.",
  "CenterCom import source tables": "erkannte Basisdaten",
  "CenterCom import hidden source tables": "{0} weitere Quelltabellen werden hier ausgeblendet, weil der CenterCom-Adapter sie in diesem Ablauf nicht importiert.",
  "CenterCom import status Committed": "abgeschlossen",
  "CenterCom import status Committing": "wird ausgeführt",
  "CenterCom import status ClearingUploads": "Upload wird gelöscht",
  "CenterCom import status Draft": "Entwurf",
  "CenterCom import status Failed": "fehlgeschlagen",
  "CenterCom import status Prechecking": "Precheck läuft",
  "CenterCom import status PrecheckFailed": "Precheck fehlgeschlagen",
  "CenterCom import status Ready": "bereit",
  "CenterCom import status RolledBack": "zurückgerollt",
  "CenterCom import status UploadProcessing": "Upload wird verarbeitet",
  "CenterCom import status Uploaded": "hochgeladen",
  "CenterCom import tenant required": "Bitte einen Mandanten auswählen.",
  "CenterCom target tenant": "Zielmandant",
  "CenterCom target tenant change title": "Zielmandanten ändern?",
  "CenterCom target tenant change confirm": "Der Lauf wird auf {0} umgestellt. Danach werden Zuordnungen neu geprüft und der Precheck muss erneut laufen.",
  "CenterCom target tenant change action": "Zielmandant ändern",
  "CenterCom target tenant changed": "Zielmandant wurde geändert.",
  "CenterCom target tenant unsaved changes": "Bitte zuerst offene Änderungen speichern oder verwerfen.",
  "CenterCom configuration download": "Konfiguration herunterladen",
  "CenterCom configuration upload": "Konfiguration hochladen",
  "CenterCom configuration downloaded": "Konfiguration wurde heruntergeladen.",
  "CenterCom configuration uploaded": "Konfiguration wurde hochgeladen.",
  "CenterCom configuration upload invalid": "Bitte eine gültige CenterCom-Konfigurationsdatei auswählen.",
  "CenterCom import upload button": "Dateien hochladen",
  "CenterCom import upload hint": "CenterCom-ZIP oder CenterCom-Basisdaten hier ablegen.",
  "CenterCom import server progress count": "{0} von {1} Dateien",
  "CenterCom import server upload progress": "Server verarbeitet den Upload",
  "CenterCom import upload failed": "Dateien konnten nicht hochgeladen werden.",
  "CenterCom import upload file unreadable": "Die Datei \"{0}\" kann vom Browser nicht gelesen werden. Bitte die Datei erneut auswählen und prüfen, ob sie lokal verfügbar ist.",
  "CenterCom import upload network error": "Der Upload konnte nicht gestartet werden. Die Anfrage hat den Server nicht erreicht. Bitte Dateien erneut auswählen und prüfen, ob sie lokal verfügbar sind.",
  "CenterCom import upload no readable files": "keine lesbaren Dateien zum Hochladen ausgewählt.",
  "CenterCom import upload timeout": "Die serverseitige Upload-Verarbeitung dauert zu lange. Bitte den Lauf neu laden und den Fortschritt prüfen.",
  "CenterCom import upload success": "Dateien hochgeladen.",
  "CenterCom import upload title": "hochladen",
  "CenterCom statistic csv": "CSV",
  "CenterCom statistic files": "Dateien",
  "CenterCom step analysis": "Analyse",
  "CenterCom step commit": "Import",
  "CenterCom step decisions": "Zuordnungen",
  "CenterCom step import": "Import",
  "CenterCom step precheck": "Vorprüfung",
  "CenterCom step selection": "Auswahl",
  "CenterCom step upload": "hochladen",
  "CenterCom step verify": "prüfen und analysieren",
  "CenterCom table column confidence": "Sicherheit",
  "CenterCom table column report type": "Berichtstyp",
  "CenterCom file role ControlData": "Kontrolldaten",
  "CenterCom file role PrimaryData": "Primärdaten",
  "CenterCom file role RegressionCase": "Regressionstest",
  "CenterCom file role Unknown": "unbekannt",
  "CenterCom source role AccessCard": "Zugangskarte",
  "CenterCom source role BankAccount": "Bankverbindung",
  "CenterCom source role ContractHistory": "Vertragshistorie",
  "CenterCom source role Document": "Dokument",
  "CenterCom source role ImportSupplement": "ergänzende Importdaten",
  "CenterCom source role Invoice": "Rechnung",
  "CenterCom source role Other": "sonstige",
  "CenterCom source role Payment": "Zahlung",
  "CenterCom source role Person": "Person",
  "CenterCom source role RestPeriod": "Ruhezeit",
  "CenterCom source role SepaMandate": "SEPA-Mandat",
  "CenterCom source role SpecialPayment": "Sonderzahlung",
  "CenterCom issue severity filter": "nach Schweregrad filtern",
  "CenterCom issue clipboard more details": "… (+{0} weitere Beispiele nicht kopiert)",
  "CenterCom issue clipboard truncated": "… Ausgabe für die Zwischenablage gekürzt.",
  "CenterCom issue details": "Beispiele",
  "CenterCom issue detail field": "Feld",
  "CenterCom issue detail value": "Wert",
  "CenterCom issue details show all": "alle {0} Beispiele anzeigen",
  "CenterCom issue message": "Meldung",
  "CenterCom issue severity": "Schweregrad",
  "CenterCom issue severity Blocking": "blockierend",
  "CenterCom issue severity Error": "Fehler",
  "CenterCom issue severity Info": "Info",
  "CenterCom issue severity Warning": "Warnung",
  "CenterCom data selection": "zuordnen",
  "CenterCom data selection hint": "Die fachlich erkannten CenterCom-Basistabellen werden automatisch verwendet. Danach werden nur laufbezogene Zuordnungen gepflegt.",
  "CenterCom data selection automatic hint": "Die fachlich erkannten CenterCom-Basistabellen werden automatisch verwendet. Hier wird nicht mehr jede Rohdatei einzeln ausgewählt.",
  "CenterCom data selection no primary tables": "Es wurden keine fachlich bekannten CenterCom-Basistabellen erkannt. Bitte prüfe den Upload.",
  "CenterCom include control reports": "Kontrollberichte beim Precheck berücksichtigen",
  "CenterCom control reports detected hint": "Kontrollberichte wurden erkannt. Wähle nur die Berichte aus, die im Precheck gegen den geplanten Import geprüft werden sollen.",
  "CenterCom control reports select placeholder": "Kontrollberichte für den Precheck auswählen",
  "CenterCom control report type balanceSnapshot": "Saldenabgleich",
  "CenterCom control report type contractSnapshot": "Vertragsabgleich",
  "CenterCom control report type memberSnapshot": "Mitgliederabgleich",
  "CenterCom control report type openItemSnapshot": "Forderungsabgleich",
  "CenterCom control report type paymentSnapshot": "Zahlungsabgleich",
  "CenterCom control report type restPeriodSnapshot": "Ruhezeitenabgleich",
  "CenterCom control report type sepaMandateSnapshot": "SEPA-Abgleich",
  "CenterCom control report type unknown": "Kontrollbericht",
  "CenterCom upload step hint": "CenterCom-Basisdaten oder ein CenterCom-Archiv hier hochladen.",
  "CenterCom continue verify": "weiter zur Prüfung",
  "CenterCom verify title": "Daten prüfen und analysieren",
  "CenterCom verify hint": "Upload, Hinweise und erkannte Basistabellen prüfen.",
  "CenterCom verify missing analysis": "Noch keine geprüften Daten vorhanden. Starte die Prüfung und Analyse.",
  "CenterCom verify refresh": "Prüfung aktualisieren",
  "CenterCom verify start": "Prüfung und Analyse starten",
  "CenterCom source tables title": "erkannte Basistabellen",
  "CenterCom continue decisions": "weiter zu Zuordnungen",
  "CenterCom continue precheck": "weiter",
  "CenterCom save and continue precheck": "speichern und weiter",
  "CenterCom precheck title": "Vorprüfung",
  "CenterCom precheck hint": "Der Precheck prüft die gespeicherten Zuordnungen vor dem Import.",
  "CenterCom precheck simulation switch": "Import-Simulation ausführen",
  "CenterCom precheck not run": "Der Precheck wurde für diesen Stand noch nicht ausgeführt.",
  "CenterCom precheck stale": "Der frühere Precheck passt nicht mehr zu diesem Stand. Starte den Precheck erneut.",
  "CenterCom precheck invalid assignments": "{0} ungültige Zuordnungen müssen vor dem Precheck korrigiert werden.",
  "CenterCom precheck current phase": "Aktuell: {0}",
  "CenterCom precheck waiting for progress": "Precheck startet. Phasen werden angezeigt, sobald der Server Fortschritt meldet.",
  "CenterCom precheck phase configuration": "Konfiguration und Adapterwissen laden",
  "CenterCom precheck phase source tables": "Quelltabellen laden",
  "CenterCom precheck phase target mappings": "Zielsystem und Zuordnungen prüfen",
  "CenterCom precheck phase persons": "Personen, Studios und Bankdaten vorbereiten",
  "CenterCom precheck phase contracts": "Kundenverträge, Vertragsbausteine und Artikel planen",
  "CenterCom precheck phase invoices": "Rechnungen, Zahlungen und offene Posten prüfen",
  "CenterCom precheck phase wallets": "Wertekonten und Bewegungen prüfen",
  "CenterCom precheck phase sepa": "Lastschriftläufe und Lastschriftgruppen auflösen",
  "CenterCom precheck phase documents": "Notizen, Dokumente und Zugänge prüfen",
  "CenterCom precheck phase reminders": "Kündigungen, Mahnwesen und Inkasso prüfen",
  "CenterCom precheck phase control reports": "Kontrollberichte und Plausibilitäten prüfen",
  "CenterCom precheck phase save result": "Precheck-Ergebnis speichern",
  "CenterCom continue import": "weiter zum Import",
  "CenterCom import needs precheck": "Vor dem Import muss ein gültiger Precheck ausgeführt werden.",
  "CenterCom back to precheck": "zurück zum Precheck",
  "CenterCom progress working": "Vorgang läuft",
  "CenterCom progress loading run": "CenterCom-Lauf wird geladen",
  "CenterCom progress loading committed verification": "PrüfViews werden geladen",
  "CenterCom progress uploading": "Dateien werden hochgeladen ({0}%)",
  "CenterCom progress server processing": "Server verarbeitet Dateien",
  "CenterCom progress server processing count": "Server verarbeitet Dateien: {0} von {1}",
  "CenterCom progress current package": "aktuelles Paket: {0}",
  "CenterCom progress current file": "aktuelle Datei: {0}",
  "CenterCom progress verifying": "Dateien werden geprüft und analysiert",
  "CenterCom progress saving decisions": "wird gespeichert",
  "CenterCom progress changing tenant": "Zielmandant und Zuordnungen werden geprüft",
  "CenterCom progress exporting configuration": "Konfiguration wird heruntergeladen",
  "CenterCom progress importing configuration": "Konfiguration wird hochgeladen und geprüft",
  "CenterCom progress prechecking": "Precheck läuft",
  "CenterCom progress committing": "Import wird ausgeführt",
  "CenterCom import reset commit state": "Importstatus zurücksetzen",
  "CenterCom import reset commit state success": "Importstatus wurde zurückgesetzt.",
  "CenterCom import reset commit state error": "Importstatus konnte nicht zurückgesetzt werden.",
  "CenterCom progress deleting": "Importlauf wird gelöscht",
  "CenterCom progress clearing uploads": "hochgeladene Dateien werden gelöscht",
  "CenterCom workflow status upload": "Dateien hochladen. Der Prüfschritt folgt danach.",
  "CenterCom workflow status verify missing": "Noch keine geprüften Daten vorhanden. Starte die Prüfung.",
  "CenterCom workflow status verify ready": "Daten sind geprüft.",
  "CenterCom workflow status verify index ready": "{0} fachliche CenterCom-Basistabellen erkannt; weiter mit Zuordnungen.",
  "CenterCom workflow status decisions": "Kundenverträge, Sonderzahlungen, Studios, Wertekonten, Zahlungsarten, Kündigungsgründe, Inkasso und Lastschriftgruppen prüfen und speichern.",
  "CenterCom workflow status precheck missing": "Die Änderungen sind gespeichert. Starte den Precheck für diesen Stand.",
  "CenterCom workflow status precheck failed": "Der Precheck enthält blockierende Hinweise. Zurück zu den Zuordnungen.",
  "CenterCom workflow status precheck ready": "Precheck ist gültig. Der Import kann ausgeführt werden.",
  "CenterCom workflow status import ready": "Precheck ist gültig. Import ausführen, wenn der Stand geprüft ist.",
  "CenterCom workflow status import failed": "Der Import wurde durch einen Systemfehler oder einen Neustart nicht abgeschlossen.",
  "CenterCom workflow status import committed": "Import wurde ausgeführt.",
  "CenterCom workflow status import rolled back": "Import wurde zurückgerollt. Die importierten Daten wurden entfernt.",
  "CenterCom import report title": "Import-Bericht",
  "CenterCom import rollback report title": "Import zurückgerollt",
  "CenterCom import rollback danger hint": "Der gesamte Mandant wird auf den Sicherungsstand unmittelbar vor diesem Importschritt zurückgesetzt. Spätere Änderungen gehen ebenfalls verloren.",
  "CenterCom import rollback snapshot confirm": "Der gesamte Mandant wird auf den Sicherungsstand unmittelbar vor diesem Importschritt zurückgesetzt. Auch alle danach vorgenommenen Änderungen gehen verloren. Fortfahren?",
  "CenterCom import planned counts": "geplante Daten ({0})",
  "CenterCom import committed counts": "importierte Daten ({0}) · {1}",
  "CenterCom import no committed counts": "keine importierten Datensätze im Bericht.",
  "CenterCom import count table item": "Bereich",
  "CenterCom import entity Persons": "Personen",
  "CenterCom import entity VatSettings": "Steuereinstellungen",
  "CenterCom import entity AccountingAccounts": "Buchungskonten",
  "CenterCom import entity Accounts": "Benutzerkonten",
  "CenterCom import entity AccountStudios": "Benutzer-Studio-Zuordnungen",
  "CenterCom import entity AccountAvailabilities": "Benutzer-Verfügbarkeiten",
  "CenterCom import entity PaymentMethodDefinitions": "Zahlungsarten",
  "CenterCom import entity Articles": "Artikel",
  "CenterCom import entity SepaGroups": "Lastschriftgruppen",
  "CenterCom import entity CancellationReasons": "Kündigungsgründe",
  "CenterCom import entity ContractTemplates": "Vertragsbausteine",
  "CenterCom import entity ContractPackageTemplates": "Tarifvorlagen",
  "CenterCom import entity ContractPackageTemplateComponents": "Tarifvorlagen-Bausteine",
  "CenterCom import entity CancellationModels": "Kündigungsmodelle",
  "CenterCom import entity RestPeriodTemplates": "Ruhezeitenvorlagen",
  "CenterCom import entity RestPeriodReasons": "Ruhezeitgründe",
  "CenterCom import entity ContractPackageCancellationModelSnapshots": "Paket-Kündigungsmodelle",
  "CenterCom import entity ContractPackageRestPeriodSnapshots": "Paket-Ruhezeitenmodelle",
  "CenterCom import entity ContractPackages": "Kundenverträge",
  "CenterCom import entity Contracts": "Vertragsbausteine",
  "CenterCom import entity ArticleSales": "Artikelverkäufe",
  "CenterCom import entity ArticleSaleItems": "Artikelpositionen",
  "CenterCom import entity OpenItems": "Forderungen",
  "CenterCom import entity Payments": "Zahlungen",
  "CenterCom import entity ContributionCalendar": "Beiträge",
  "CenterCom import entity ContributionCalendars": "Beiträge",
  "CenterCom import entity RestPeriods": "Ruhezeiten",
  "CenterCom import entity WalletProducts": "Wertekonten",
  "CenterCom import entity Wallets": "Wertekonten",
  "CenterCom import entity WalletTransactions": "Wertekonto-Bewegungen",
  "CenterCom import entity SepaDirectDebitRuns": "Lastschriftläufe",
  "CenterCom import entity SepaDirectDebitItems": "Lastschriftpositionen",
  "CenterCom import entity AccessMedia": "Zutrittsmedien",
  "CenterCom import entity Checkins": "Check-ins",
  "CenterCom import entity PersonNotes": "Notizen",
  "CenterCom import entity PersonDocuments": "Dokumente",
  "CenterCom import entity PriceAdjustments": "Preisanpassungs-Vorlagen",
  "CenterCom import entity ContractPriceAdjustments": "Preisanpassungen",
  "CenterCom import entity PaymentCancellationReasons": "Zahlungsstornogründe",
  "CenterCom import entity ReminderLevels": "Mahnstufen",
  "CenterCom import entity Reminders": "Mahnungen",
  "CenterCom import entity DebtCollectionAgencies": "Inkassodienstleister",
  "CenterCom import entity DebtCollectionCases": "Inkassofälle",
  "CenterCom import entity DebtCollectionCaseItems": "Inkassopositionen",
  "CenterCom import entity OpenItemCorrections": "Forderungskorrekturen",
  "CenterCom stock assignment": "Zuordnungen",
  "CenterCom exclusions": "Ausschlüsse",
  "CenterCom import block fallback": "Bereich",
  "CenterCom import block enabled": "{0} importieren",
  "CenterCom import block source tables": "Quelltabellen: {0}",
  "CenterCom position decisions": "Positionen",
  "CenterCom position all actions": "alle Zuordnungen",
  "CenterCom position action filter placeholder": "Zuordnung anzeigen",
  "CenterCom position visible positions": "{0} von {1} Positionen sichtbar",
  "CenterCom source grouped positions hint": "Positionen werden nach Quelltabelle gruppiert. VERTHIST und SONDERZAHLUNG werden separat konfiguriert.",
  "CenterCom source group all": "alle",
  "CenterCom package groups": "Kundenverträge/Sonderzahlungen",
  "CenterCom package groups hint": "Konfiguriere Kundenverträge aus VERTHIST und SONDERZAHLUNG einmal je Quellbezeichnung. Gleiche Bezeichnungen werden gemeinsam zugeordnet.",
  "CenterCom package groups empty": "keine VERTHIST- oder SONDERZAHLUNG-Positionen erkannt",
  "CenterCom person addressing": "Ansprache",
  "CenterCom person addressing field": "Anredeform für importierte Personen",
  "CenterCom person addressing hint": "Bei „CenterCom-Wert übernehmen“ wird STAMMDATEN.Du-Sie nach Du/Sie übernommen; leere Quellwerte bleiben unbekannt.",
  "CenterCom person addressing source": "CenterCom-Wert übernehmen",
  "CenterCom person addressing all du": "alle auf Du setzen",
  "CenterCom person addressing all sie": "alle auf Sie setzen",
  "CenterCom import cleanup options": "Datenbereinigung",
  "CenterCom clean empty address data": "leere Adressdaten bereinigen",
  "CenterCom use payment date from remark": "Zahlungsdatum aus Bemerkung übernehmen",
  "CenterCom clean empty address data hint": "Bei Personen werden PLZ und Ort nur geleert, wenn die PLZ exakt 11111 und der Ort exakt Unbekannt ist.",
  "CenterCom attach shared document files": "geteilte Dateien dennoch anhängen",
  "CenterCom attach shared document files hint": "Verweisen mehrere DOKUMENTE-Zeilen auf dieselbe Datei, bekommt normalerweise keine davon die Datei — die Quelle sagt nicht, zu welchem Vorgang sie gehört. Mit dieser Option erhält jede Zeile der Gruppe dieselbe Datei.",
  "CenterCom keep shared document entries": "Vorgänge mit geteilter Datei übernehmen",
  "CenterCom keep shared document entries hint": "Der Eintrag entsteht ohne Datei, Bezeichnung, Datum und Vertragsbezug bleiben erhalten. Ohne diese Option werden die Zeilen übersprungen.",
  "CenterCom keep missing document entries": "Vorgänge ohne Datei im Archiv übernehmen",
  "CenterCom keep missing document entries hint": "Fehlt die referenzierte Datei im Dokumentarchiv, bleibt der Vorgang als Eintrag ohne Datei erhalten. Ohne diese Option werden die Zeilen übersprungen.",
  "CenterCom package group person": "Person",
  "CenterCom package group bundle": "Vertragsnummer",
  "CenterCom package group import": "Import",
  "CenterCom package group primary": "Hauptvertrag",
  "CenterCom package group package name": "Kundenvertragsname",
  "CenterCom package component name": "Name",
  "CenterCom package component article contract": "Artikel-/Vertragsname",
  "CenterCom package group models": "Modelle",
  "CenterCom package group cancellation model": "Kündigungsmodell",
  "CenterCom package group rest period template": "Ruhezeitvorlage",
  "CenterCom rest period reasons hint": "Ordne Ruhezeitgründe bestehenden Gründen im Zielmandanten zu oder lege sie beim Import neu an.",
  "CenterCom rest period reasons empty": "keine Ruhezeitgründe erkannt",
  "CenterCom package component import": "Import",
  "CenterCom package component role": "Zuordnung",
  "CenterCom special payments": "Sonderzahlungen",
  "CenterCom special payments hint": "Konfiguriere SONDERZAHLUNG-Positionen einmal je Quellposition als Vertrag, Artikel oder Ausschluss.",
  "CenterCom studios hint": "Ordne CenterCom-Standorte bestehenden Studios zu.",
  "CenterCom studios empty": "keine Studio-Zuordnungen erkannt",
  "CenterCom all assignments": "alle Zuordnungen",
  "CenterCom all assignments hint": "Zeigt alle erkannten Referenz-Zuordnungen aus dem Adapter-Import, auch wenn es keinen eigenen Fachbereich gibt.",
  "CenterCom all assignments empty": "keine Zuordnungen erkannt",
  "CenterCom contract templates": "Vertragsbausteine",
  "CenterCom contract templates hint": "Ordne CenterCom-Vertragsarten aus VERTRAGSART bestehenden Vertragsbausteinen zu oder lasse sie beim Import neu anlegen.",
  "CenterCom contract templates empty": "keine Vertragsbaustein-Zuordnungen erkannt",
  "CenterCom articles hint": "Ordne CenterCom-Artikel aus ARTIKEL und ARTIKELPREIS bestehenden Artikeln zu oder lasse sie beim Import neu anlegen.",
  "CenterCom articles empty": "keine Artikel-Zuordnungen erkannt",
  "CenterCom staff accounts": "Personal und Benutzer",
  "CenterCom staff account placeholder": "Mitarbeiter wählen",
  "CenterCom staff accounts empty": "keine Personal- oder Benutzer-Zuordnungen erkannt",
  "CenterCom staff accounts role column": "Benutzerrolle",
  "CenterCom staff account rights column": "Mitarbeiter-Rechte",
  "CenterCom staff accounts role placeholder": "Rolle wählen",
  "CenterCom accounting accounts": "Buchführungskonten",
  "CenterCom accounting assignments": "Kontenzuordnungen",
  "CenterCom accounting assignment label": "Bezeichnung",
  "CenterCom accounting assignment select": "Konto zuordnen",
  "CenterCom accounting assignments empty": "Keine Importdaten für diese Zuordnung.",
  "CenterCom accounting assignment contract templates": "Vertragsbausteine",
  "CenterCom accounting assignment contracts": "Mitgliedsverträge",
  "CenterCom accounting assignment article sales": "Artikelverkäufe",
  "CenterCom accounting accounts empty": "keine Buchführungskonto-Zuordnungen erkannt",
  "CenterCom vat settings": "USt.-Einstellungen",
  "CenterCom vat settings hint": "Ordne CenterCom-Steuerschlüssel aus STEUERSCHLUESSEL bestehenden USt.-Einstellungen zu oder lasse sie beim Import neu anlegen.",
  "CenterCom vat settings empty": "keine USt.-Zuordnungen erkannt",
  "CenterCom wallets hint": "Ordne LEISTUNG/LEISTUNGSART-Werte bestehenden Wertekonten zu.",
  "CenterCom wallets empty": "keine Wertekonto-Zuordnungen erkannt",
  "CenterCom payment methods hint": "Ordne CenterCom-Zahlungsarten bestehenden Zahlungsarten zu oder lasse sie beim Import neu anlegen. Die System-Zahlungsart kann zusätzlich gesetzt werden.",
  "CenterCom payment methods empty": "keine Zahlungsarten-Zuordnungen erkannt",
  "CenterCom payment method system type": "System-Zahlungsart",
  "CenterCom payment method system type placeholder": "System-Zahlungsart wählen",
  "CenterCom price adjustments": "Preisanpassungen",
  "CenterCom price adjustments hint": "Ordne Vertragspreisanpassungen bestehenden Preisanpassungs-Vorlagen zu oder lasse sie beim Import neu anlegen.",
  "CenterCom price adjustments empty": "keine Preisanpassungs-Zuordnungen erkannt",
  "CenterCom cancellations hint": "Ordne Kündigungsgründe bestehenden Gründen im Zielmandanten zu.",
  "CenterCom cancellations empty": "keine Kündigungsgründe erkannt",
  "CenterCom cancellation models hint": "Ordne CenterCom-Kündigtarife aus KUENDTARIFE bestehenden Kündigungsmodellen zu oder lasse sie beim Import neu anlegen.",
  "CenterCom cancellation models empty": "keine Kündigungsmodell-Zuordnungen erkannt",
  "CenterCom cancellation initial notice": "Frist Erstlaufzeit",
  "CenterCom cancellation renewal notice": "Frist Verlängerung",
  "CenterCom cancellation source label": "CenterCom-Bezeichnung",
  "CenterCom payment cancellations": "Zahlungsstornogründe",
  "CenterCom payment cancellations hint": "Ordne Zahlungsstornogründe bestehenden Gründen im Zielmandanten zu.",
  "CenterCom payment cancellations empty": "keine Zahlungsstornogründe erkannt",
  "CenterCom debt collection": "Inkasso/Mahnwesen",
  "CenterCom debt collection hint": "Ordne Inkassodienstleister und Mahnstufen bestehenden Stammdaten zu.",
  "CenterCom debt collection empty": "keine Inkasso- oder Mahnwesen-Zuordnungen erkannt",
  "CenterCom reminder levels": "Mahnstufen",
  "CenterCom reminder levels empty": "keine Mahnstufen-Zuordnungen erkannt",
  "CenterCom debt collection agencies": "Inkassodienstleister",
  "CenterCom debt collection agencies empty": "keine Inkassodienstleister-Zuordnungen erkannt",
  "CenterCom sepa groups": "Lastschriftgruppen",
  "CenterCom sepa groups hint": "Ordne Abbuchungstage und Einzugsgruppen aus VERTHIST bestehenden Lastschriftgruppen zu oder lasse sie beim Import neu anlegen.",
  "CenterCom sepa groups empty": "keine Lastschriftgruppenwerte erkannt",
  "CenterCom sepa group target": "zuordnen",
  "CenterCom sepa group name": "Name",
  "CenterCom sepa group create": "neu anlegen",
  "CenterCom sepa group assignment": "Lastschriftgruppen anlegen/zuordnen",
  "CenterCom target sepa group": "Lastschriftgruppe",
  "CenterCom target studio": "Studio",
  "CenterCom schema mapping": "Schema-Abgleich",
  "CenterCom schema mapping empty": "keine Schema-Mappings erkannt",
  "CenterCom schema target entity": "Zieltabelle",
  "CenterCom schema source table": "Quelltabelle",
  "CenterCom schema note": "Hinweis",
  "CenterCom schema classification implemented": "umgesetzt",
  "CenterCom schema classification replacedBySourceDecision": "durch Quellzuordnung ersetzt",
  "CenterCom schema classification referenceOnly": "nur Referenz",
  "CenterCom schema classification notRelevant": "nicht relevant",
  "CenterCom schema classification gap": "Lücke",
  "CenterCom position source table placeholder": "Positionsquelle auswählen",
  "CenterCom position source value placeholder": "Positionswert aus Quelle auswählen",
  "CenterCom position source required": "Bitte Quelle und Spalte für die Position auswählen.",
  "CenterCom position add": "Position hinzufügen",
  "CenterCom article target not found": "Artikel nicht gefunden",
  "CenterCom decision target area": "Zielbereich",
  "CenterCom decision position": "Position",
  "CenterCom decision source value": "Quellwert aus Spalte",
  "CenterCom decision source value placeholder": "Quellwert aus erkannter Spalte auswählen",
  "CenterCom decision source value required": "Bitte einen Quellwert aus der Quelle auswählen.",
  "CenterCom decision suggested target": "Vorschlag",
  "CenterCom decision target": "zuordnen",
  "CenterCom decision invalid assignments": "{0} Zuordnungen verweisen auf nicht mehr vorhandene Zielobjekte. Bitte die betroffenen Auswahlen korrigieren oder auf „neu importieren“/„ignorieren“ setzen.",
  "CenterCom decision ignore": "ignorieren",
  "CenterCom decision new import": "neu importieren",
  "CenterCom decision new import named": "neu importieren: {0}",
  "CenterCom decision planned target": "geplantes neues Ziel",
  "CenterCom decision planned target name": "Name des neuen Ziels",
  "CenterCom decision planned target drawer title": "neues Ziel bearbeiten",
  "CenterCom decision planned target edit": "Namen des neuen Ziels bearbeiten",
  "CenterCom decision planned target hint": "Dieses Ziel wird beim Import neu angelegt.",
  "CenterCom decision existing target hint": "Dieses Ziel wird direkt zugeordnet.",
  "CenterCom decision all target areas": "alle Zielbereiche",
  "CenterCom decision all source tables": "alle Quelltabellen",
  "CenterCom decision target area filter placeholder": "Zielbereich anzeigen",
  "CenterCom decision source table filter placeholder": "Quelltabelle anzeigen",
  "CenterCom decision visible assignments": "{0} von {1} Zuordnungen sichtbar",
  "CenterCom decision source key": "Schlüssel",
  "CenterCom decision target area placeholder": "Zielbereich auswählen",
  "CenterCom decision area selector": "Zuordnungsbereich",
  "CenterCom decision previous area": "vorheriger Zuordnungsbereich",
  "CenterCom decision next area": "nächster Zuordnungsbereich",
  "CenterCom decision target placeholder": "Zuordnung wählen",
  "CenterCom decision group target placeholder": "Zuordnung für diese Gruppe wählen",
  "CenterCom decision apply group target": "auf Gruppe anwenden",
  "CenterCom decision no target options": "Für diesen Zielbereich wurden keine Zielobjekte geladen.",
  "CenterCom decision add stock assignment": "Zuordnung hinzufügen",
  "CenterCom decision already exists": "Diese Zuordnung ist bereits vorhanden.",
  "CenterCom decision edit status title": "Änderungen an Zuordnungen",
  "CenterCom decision edit status detail": "Änderungen in diesem Schritt und neue Abweichungen aus Schema, Systemdaten oder Quelldaten werden erst für Precheck und Import verwendet, nachdem sie gespeichert wurden.",
  "CenterCom decision unsaved changes": "ungespeicherte Änderungen",
  "CenterCom decision saved changes": "keine ungespeicherten Änderungen",
  "CenterCom stock assignment usage": "Zuordnung",
  "CenterCom stock assignment status confirmed": "zuordnen",
  "CenterCom stock assignment status suggested": "nicht zuordnen",
  "CenterCom stock assignment status ignored": "nicht zuordnen",
  "CenterCom stock assignment status open": "offen",
  "CenterCom stock assignment checkbox": "zuordnen",
  "CenterCom decision target required for assignment": "Bitte zuerst ein Zielobjekt auswählen.",
  "CenterCom decision status": "Status",
  "CenterCom decision table": "Tabelle",
  "CenterCom decision column": "Spalte",
  "CenterCom decision condition": "Bedingung",
  "CenterCom decision examples": "Beispiele",
  "CenterCom decision action": "Zuordnung",
  "CenterCom exclusion effect": "Wirkung",
  "CenterCom exclusion usage": "Verwendung",
  "CenterCom exclusion visible exclusions": "{0} von {1} Ausschlüssen sichtbar",
  "CenterCom exclusion add": "Ausschluss hinzufügen",
  "CenterCom exclusion source table placeholder": "Quelltabelle auswählen",
  "CenterCom exclusion source column placeholder": "Quellspalte auswählen",
  "CenterCom exclusion effect placeholder": "Wirkung auswählen",
  "CenterCom exclusion no manual sources": "Für diesen Upload wurden keine Quellbereiche erkannt, in denen manuelle Ausschlüsse sinnvoll sind.",
  "CenterCom exclusion source required": "Bitte Tabelle und Spalte für den Ausschluss auswählen.",
  "CenterCom exclusion value placeholder": "Wert",
  "CenterCom exclusion value required": "Bitte einen Wert für die Ausschlussregel eingeben.",
  "CenterCom decision no stock assignments": "keine Zuordnungen erkannt.",
  "CenterCom decision no exclusions": "keine Ausschlüsse erkannt.",
  "CenterCom decision no positions": "keine Positionsgruppen erkannt.",
  "CenterCom decision status confirmed": "übernehmen",
  "CenterCom decision status suggested": "vorgeschlagen",
  "CenterCom decision status ignored": "ignorieren",
  "CenterCom decision status open": "offen",
  "CenterCom exclusion status confirmed": "aktiv ausschließen",
  "CenterCom exclusion status suggested": "nicht verwenden",
  "CenterCom exclusion status ignored": "nicht verwenden",
  "CenterCom exclusion status open": "offen",
  "CenterCom reference kind AccountingAccount": "Buchführungskonten",
  "CenterCom reference kind Account": "Mitarbeiter",
  "CenterCom reference kind Article": "Artikel",
  "CenterCom reference kind CancellationReason": "Kündigungsgründe",
  "CenterCom reference kind CancellationModel": "Kündigungsmodelle",
  "CenterCom reference kind ContractTemplate": "Vertragsbausteine",
  "CenterCom reference kind DebtCollectionAgency": "Inkassodienstleister",
  "CenterCom reference kind PaymentMethod": "Zahlungsarten",
  "CenterCom reference kind PaymentCancellationReason": "Zahlungsstornogründe",
  "CenterCom reference kind PriceAdjustment": "Preisanpassungen",
  "CenterCom reference kind ReminderLevel": "Mahnstufen",
  "CenterCom source value prefix": "Quelle:",
  "CenterCom reference kind RestPeriodReason": "Ruhezeitgründe",
  "CenterCom reference kind RestPeriodTemplate": "Ruhezeitvorlagen",
  "CenterCom reference kind SepaGroup": "Lastschriftgruppen",
  "CenterCom reference kind Studio": "Studios",
  "CenterCom reference kind Unknown": "unbekannt",
  "CenterCom reference kind VatSettings": "USt-Einstellungen",
  "CenterCom reference kind WalletProduct": "Wertekonten",
  "CenterCom exclusion effect excludeFromArticles": "nicht als Artikel importieren",
  "CenterCom exclusion effect excludeFromContracts": "nicht als Vertrag importieren",
  "CenterCom exclusion effect excludeFromOpenItems": "nicht als Forderung importieren",
  "CenterCom exclusion effect excludeFromRestPeriods": "nicht als Ruhezeit importieren",
  "CenterCom exclusion effect excludeFromWallets": "nicht als Wallet/Leistung importieren",
  "CenterCom exclusion effect ignore": "komplett ignorieren",
  "CenterCom exclusion effect technicalQuality": "technische Qualitätsregel",
  "CenterCom exclusion target area articles": "Artikel",
  "CenterCom exclusion target area contracts": "Verträge",
  "CenterCom exclusion target area import": "Import",
  "CenterCom exclusion target area openItems": "Forderungen",
  "CenterCom exclusion target area restPeriods": "Ruhezeiten",
  "CenterCom exclusion target area technicalQuality": "technische Qualität",
  "CenterCom exclusion target area wallets": "Wallets/Leistungen",
  "CenterCom exclusion operator contains": "enthält",
  "CenterCom exclusion operator equals": "ist gleich",
  "CenterCom exclusion operator is_empty": "ist leer",
  "CenterCom exclusion operator starts_with": "beginnt mit",
  "CenterCom contract position rules": "Positionsregeln für VERTHIST",
  "CenterCom contract position rules hint": "Regeln legen fest, ob eine VERTHIST-Position als Vertrag, als Artikel oder gar nicht importiert wird.",
  "CenterCom contract position match placeholder": "Text enthält, z. B. Startpaket oder *",
  "CenterCom contract position add rule": "VERTHIST-Regel hinzufügen",
  "CenterCom contract position action ignore": "ignorieren",
  "CenterCom position show examples": "Beispiele anzeigen",
  "CenterCom special payment rules": "Positionsregeln für Sonderzahlungen",
  "CenterCom special payment rules hint": "Regeln werden auf den Text der CenterCom-Sonderzahlung angewendet. Ohne Treffer bleibt die Position als Forderung am Vertrag.",
  "CenterCom special payment match placeholder": "Text enthält, z. B. Startpaket oder *",
  "CenterCom special payment article placeholder": "Artikel auswählen",
  "CenterCom special payment add rule": "Positionsregel hinzufügen",
  "CenterCom special payment action contract open item": "Forderung am Vertrag",
  "CenterCom special payment action ignore": "ignorieren",
  "CenterCom file selected count": "{0} Dateien ausgewählt",
  "CenterCom plan count articles": "Artikelverkäufe",
  "CenterCom plan count contract templates": "Vertragsbausteine",
  "CenterCom plan count open items": "Forderungen",
  "CenterCom plan count packages": "Kundenverträge",
  "CenterCom plan count payment method definitions": "Zahlungsarten",
  "CenterCom plan count price adjustments": "Preisanpassungs-Vorlagen",
  "CenterCom plan count accounts": "Benutzerkonten",
  "CenterCom plan count vat settings": "Steuersätze",
  "CenterCom plan count accounting accounts": "Buchungskonten",
  "CenterCom plan count source articles": "Artikelstamm",
  "CenterCom plan count wallet products": "Wertekonto-Produkte",
  "CenterCom plan count sepa items": "Lastschriftpositionen",
  "CenterCom staff assignment": "Mitarbeiter",
  "CenterCom staff import contracts": "Verträge importieren",
  "CenterCom staff import member": "Mitglied importieren",
  "CenterCom staff member imports": "Mitarbeiter-Nutzungsrechte",
  "CenterCom staff member imports empty": "keine Personen mit Mitarbeiter-Nutzungsrecht gefunden.",
  "CenterCom staff member imports select usage right": "Wähle ein Nutzungsrecht aus.",
  "CenterCom staff skip member": "nicht als Mitglied",
  "CenterCom staff usage right": "Nutzungsrecht",
  "CenterCom staff usage right filter": "Nutzungsrecht auswählen",
  "CenterCom usage action source type": "Typ",
  "CenterCom usage action row count": "Zeilen",
  "CenterCom usage action target": "Zielaktion",
  "CenterCom usage action target check in": "Check-in",
  "CenterCom usage action target check out": "Check-out",
  "CenterCom usage action target deduct points": "Punkte abziehen",
  "CenterCom usage action target ignore": "ignorieren",
  "CenterCom usage action target open door": "Tür öffnen",
  "CenterCom usage action target unlock device": "Gerät freischalten",
  "CenterCom usage action terminal address": "Terminaladresse",
  "CenterCom usage action terminal info": "Terminalinfo",
  "CenterCom usage actions": "Nutzungsaktionen",
  "CenterCom usage actions empty": "keine Nutzungsaktionen aus den Quelldaten abgeleitet.",
  "CenterCom usage checkout check in end": "aus Check-in-Ende",
  "CenterCom usage checkout none": "kein Check-out",
  "CenterCom usage checkout source": "automatischer Check-out",
  "CenterCom usage checkout source row": "aus Quellzeitpunkt",
  "CenterCom commit blocked by precheck": "Import blockiert: Precheck enthält Fehler.",
  "CenterCom comparison planned amount": "geplanter Betrag",
  "CenterCom comparison planned count": "geplante Anzahl",
  "CenterCom comparison scope": "Quelle",
  "CenterCom comparison source amount": "Quellbetrag",
  "CenterCom comparison source count": "Quellanzahl",
  "Select a template (Einstellungen → Rechtstexte). Then choose per section whether to show and require acceptance.": "Vorlage wählen (Einstellungen → Rechtstexte). Pro Bereich festlegen, ob angezeigt und ob Zustimmung nötig ist.",
  "Send failed": "Fehler beim Senden",
  "Actual items": "tatsächliche Positionen",
  "Actual total amount": "tatsächlicher Gesamtbetrag",
  "Direct debit run status booked": "verbucht",
  "Direct debit run status cancelled": "storniert",
  "Direct debit runs": "Lastschriftläufe",
  "Force delete direct debit run confirm": "Lastschriftlauf \"{0}\" ({1}) wirklich erzwungen löschen? Der Lauf und seine Positionen werden entfernt. Offene Posten werden nur von dieser Lauf-ID gelöst; Forderungen und Zahlungen werden nicht gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
  "Emails": "E-Mails",
  "In processing": "in Bearbeitung",
  "Delete inbox": "Posteingang löschen",
  "Force delete inbound inbox confirm": "Posteingang mit {0} E-Mails unwiderruflich leeren? Nachrichten, Klassifizierungen und Anhänge werden aus m1member entfernt. Die E-Mails im Mailkonto werden nicht gelöscht. Der Abruf beginnt anschließend bei neu eingehenden E-Mails.",
  "Inbound inbox deleted success": "Posteingang geleert. {0} E-Mails wurden gelöscht.",
  "Item count differs": "Positionszahl abweichend",
  "SEPA file": "SEPA-Datei",
  "Stored items": "gespeicherte Positionen",
  "Stored total amount": "gespeicherter Gesamtbetrag",
  "Test run": "Probelauf",
  "Submit": "absenden",
  "Submit failed": "Fehler beim Absenden",
  "Sync failed": "Synchronisation fehlgeschlagen",
  "Tenant data import in progress": "Wir übernehmen die Daten…",
  "Tenant data import in progress hint": "Nach dem Import geht es automatisch weiter.",
  "Tenant data import progress pending": "startet",
  "ValidationError": "Validierungsfehler",
  "TemplateSelectionInvalid": "Die gewählte Vorlage passt nicht zu diesem Vorgang.",
  "ReminderRoutingTemplateInvalid": "Die gewählte Textvorlage passt nicht zu dieser Mahnstufe.",
  "ReminderTemplateSelectionRequired": "Für diese Mahnregel fehlt eine Textvorlage.",
  "Verlauf (FinTS-Schritte)": "Verlauf (FinTS-Schritte)",
  "Voidable remaining": "noch stornierbar",
  "Warning": "Warnung",
  "active": "aktiv",
  "assigned": "zugeordnet",
  "day": "Tag",
  "days": "Tage",
  "e.g. \"1st & 15th of month\"": "z. B. „1. und 15. des Monats“",
  "e.g. \"Main account\" or \"Studio Center\"": "z. B. „Hauptkonto“ oder „Studio Mitte“",
  "e.g. 1:00 for one hour, 0:30 for 30 minutes. Empty = cancel until start": "z. B. 1:00 für eine Stunde, 0:30 für 30 Minuten. Leer = bis zum Start stornierbar",
  "e.g. smtp.office365.com": "z. B. smtp.office365.com",
  "https://m1gateway.mqorva.de": "https://m1gateway.mqorva.de",
  "inactive": "inaktiv",
  "not assigned": "nicht zugeordnet",
  "month": "Monat",
  "points": "Punkte",
  "yes": "ja",

  // Personalplanung (Dienstplan, Tätigkeiten)
  "Staff": "Personal",
  "Staff schedule": "Dienstplan",
  "This week": "diese Woche",
  "Activity": "Tätigkeit",
  "Activity types": "Tätigkeiten",
  "Really delete this activity type?": "Diese Tätigkeit wirklich löschen?",
  "Activity is required": "Tätigkeit ist erforderlich",
  "New shift": "neue Schicht",
  "Edit shift": "Schicht bearbeiten",
  "Shift created": "Schicht erstellt",
  "Shift updated": "Schicht aktualisiert",
  "Shift deleted": "Schicht gelöscht",
  "Really delete this shift?": "Diese Schicht wirklich löschen?",
  "Shift note": "Notiz",
  "Shift planned": "geplant",
  "Shift confirmed": "bestätigt",
  "Shift cancelled": "abgesagt",
  "Worked this week": "geleistet diese Woche",
  "Apply opening hours": "Öffnungszeiten übernehmen",
  "Opening hours block": "Öffnungszeiten-Block",
  "Shifts created": "Schichten erstellt",
  "Please select at least one employee": "Bitte mindestens einen Mitarbeiter auswählen",
  "Please select an opening hours block": "Bitte einen Öffnungszeiten-Block auswählen",
  "View staff schedule": "Dienstplan ansehen",
  "Edit staff schedule": "Dienstplan bearbeiten",
  "View staff settings": "Personal-Einstellungen ansehen",
  "Edit staff settings": "Personal-Einstellungen bearbeiten",

  // Personal: Abwesenheiten & Urlaub
  "Absences": "Abwesenheiten",
  "Absence types": "Abwesenheitsgründe",
  "Vacation management": "Urlaubsverwaltung",
  "Counts as vacation": "zählt als Urlaub",
  "Requested": "beantragt",
  "General entitlement": "genereller Anspruch",
  "enter a different value only for this year (e.g. pro rata in the year of joining)": "abweichenden Wert nur für dieses Jahr eintragen (z. B. anteilig im Eintrittsjahr)",
  "Pre-filled with the general entitlement — change it only if it differs for this year (e.g. pro rata in the year of joining).": "Vorbelegt mit dem generellen Anspruch — nur ändern, wenn er für dieses Jahr abweicht (z. B. anteilig im Eintrittsjahr).",
  "Vacation counts against the vacation entitlement, sick leave is counted separately, holidays identify holiday absence.": "Urlaub zählt gegen den Urlaubsanspruch, Krankheit wird separat gezählt, Feiertag kennzeichnet Feiertagsabwesenheiten.",
  "Holiday": "Feiertag",
  "Working time": "Arbeitszeit",
  "Weekly target hours are required for a monthly minimum wage": "Für ein Monatsgehalt zum Mindestlohn sind Wochenstunden nötig.",
  "Minimum wage": "Mindestlohn",
  "Minimum hourly wage": "Mindestlohn je Stunde",
  "Used for employees with the minimum wage option enabled": "Wird für Mitarbeiter mit aktivierter Mindestlohn-Option verwendet",
  "Minimum wage rates": "Mindestlohn-Sätze",
  "Requires active time tracking": "Erfordert aktive Zeiterfassung",
  "Employment period": "Beschäftigungszeitraum",
  "Weekdays": "Wochentage",
  "Really delete this absence type?": "Diesen Abwesenheitsgrund wirklich löschen?",
  "This employee has legacy recurrence rules that must be resolved before the availabilities can be saved.": "Für diesen Mitarbeiter bestehen alte Wiederholungsregeln. Diese müssen zuerst geklärt werden, bevor die Verfügbarkeiten gespeichert werden können.",
  "Annual entitlement is required": "Jahresanspruch ist erforderlich",
  "Manual carry-over": "manueller Übertrag",
  "Carry-over expiry": "Verfall des Übertrags",
  "View staff absences": "Abwesenheiten ansehen",
  "Edit staff absences": "Abwesenheiten bearbeiten",
  "View vacation management": "Urlaubsverwaltung ansehen",
  "Edit vacation management": "Urlaubsverwaltung bearbeiten",
  "Conflict: shift overlaps an absence": "Konflikt: Schicht überschneidet eine Abwesenheit",
  "Conflict: overlapping shifts": "Konflikt: überlappende Schichten",
  "Activity catalog for the staff schedule (counts as work time)": "Tätigkeitskatalog für den Dienstplan (zählt als Arbeitszeit)",
  "Absence reason catalog (vacation, sick, …)": "Abwesenheitsgrund-Katalog (Urlaub, Krankheit, …)",

  // Personal: Abrechnungsvorbereitung & Einstellungen
  "June": "Juni",
  "Payroll preparation": "Lohnvorbereitung",
  "Difference": "Differenz",
  "Unresolved days": "ungeklärte Tage",
  "View payroll preparation": "Abrechnungsvorbereitung ansehen",
  "Export payroll": "Abrechnung exportieren",
  "Employee master data": "Mitarbeiter-Stammdaten",
  "Assignable studios": "einsetzbare Studios",
  "Assignable studios tooltip": "Leer = alle Studios. Das sind die Studios, in denen die Person typischerweise eingesetzt wird.",
  "Target hours & employment period per employee": "Soll-Arbeitszeit & Beschäftigungszeitraum je Mitarbeiter",
  "Staff schedule settings": "Dienstplan",
  "Time grid, working days & shared week plan links": "Zeitraster, Arbeitstage & geteilte Wochenplan-Links",
  "Grid start": "Rasterbeginn",
  "Grid end": "Rasterende",
  "Grid resolution": "Rasterauflösung",
  "Planning advance period (days)": "Vorlauf (Tage)",
  "Working days": "Arbeitstage",
  "Allow booking against default plan": "Terminbuchung auf Basis des Standardplans erlauben",
  "Appointments without staff coverage": "Termine ohne Personal-Deckung",
  "{0} appointments without staff": "{0} Termine ohne Personal",
  "without staff": "ohne Personal",
  "Understood": "verstanden",
  "Shared week plan links": "geteilte Wochenplan-Links",
  "Week plan links": "Wochenplan-Links",
  "Schedule settings": "Dienstplan",
  "Share link scope": "Geltungsbereich",
  "Copied to clipboard": "In die Zwischenablage kopiert",
  "Week copied": "Woche kopiert",
  "Confirm week": "Woche bestätigen",
  "Week confirmed": "Woche bestätigt",
  "Publication": "Veröffentlichung",
  "draft": "Entwurf",
  "Publish": "Veröffentlichen",
  "Publish all planned shifts of this week?": "alle geplanten Schichten dieser Woche veröffentlichen?",
  "Confirm all planned shifts of this week?": "alle geplanten Schichten dieser Woche bestätigen?",
  "All shifts of the source week are copied to the target week (existing identical shifts are skipped).": "Alle Schichten der Quellwoche werden in die Zielwoche kopiert (bereits vorhandene identische Schichten werden übersprungen).",
  "Back to Staff": "zurück zum Personal",
  "A FinTS connection test is already running.": "Es läuft bereits ein FinTS-Verbindungstest.",
  "Automations": "Automatisierungen",
  "View automations": "Automatisierungen ansehen",
  "Manage automations": "Automatisierungen verwalten",
  "Operations": "Betrieb",
  "New automation": "neue Automatisierung",
  "Edit automation": "Automatisierung",
  "New member": "neues Mitglied",
  "Inactive for days": "inaktiv seit Tagen",
  "Open app/contact request": "offene App-/Kontaktanfrage",
  "Overdue open item": "überfälliger offener Posten",
  "SEPA run due": "SEPA-Lauf fällig",
  "Chargeback recorded": "Rücklastschrift erfasst",
  "Contract ending soon": "Vertrag endet bald",
  "Repeated check-in denied": "wiederholte Zutrittsablehnung",
  "Access device problem": "Geräte-/Zutrittsproblem",
  "Create task": "Aufgabe erstellen",
  "Send SMS": "SMS senden",
  "Send WhatsApp": "WhatsApp senden",
  "Prepare SEPA run": "SEPA-Lauf vorbereiten",
  "Prepare debt collection case": "Inkasso-Fall vorbereiten",
  "Internal notification": "interne Meldung",
  "Waiting for approval": "wartet auf Freigabe",
  "Succeeded": "erfolgreich",
  "Approval": "Freigabe",
  "Live": "live",
  "Direct": "direkt",
  "Offset days": "Versatz in Tagen",
  "Limit": "Limit",
  "Last run": "letzte Ausführung",
  "Executed at": "ausgeführt am",
  "Text template": "Textvorlage",
  "Automation is required": "Automatisierung ist erforderlich",
  "Text template is required": "Textvorlage ist erforderlich",
  "Execution time": "Ausführungszeit",
  "Execution time empty hint": "Leer lassen, wenn die Automatisierung beim nächsten regulären Lauf ausgeführt werden soll.",
  "Automation area": "Bereich",
  "Automation goal": "Ziel",
  "Automation trigger": "Anlass",
  "Automation execution": "Ausführung",
  "All contract package templates": "alle Vertragspaketvorlagen",
  "All contract templates": "alle Vertragsbausteine",
  "Automation scenario member welcome": "Willkommensnachricht zum Mitgliedsstart",
  "Automation scenario member birthday": "Geburtstagsnachricht",
  "Automation scenario member inactive": "Betreuung bei Inaktivität",
  "Automation scenario finance overdue": "Mahnstufe für offenen Posten",
  "Automation scenario finance sepa": "SEPA-Lauf vorbereiten",
  "Automation scenario finance chargeback": "Folgeprozess nach Rücklastschrift",
  "Automation scenario wallet balance low": "Aktion bei niedrigem Wertekonto",
  "Automation scenario wallet unused": "Aktion bei ungenutztem Wertekonto",
  "Automation scenario contract starting": "Kommunikation zum Vertragsstart",
  "Automation scenario contract ending": "Aufgabe oder Nachricht vor Vertragsende",
  "Automation scenario rest period ending": "Rückkehr aus Ruhezeit",
  "Automation scenario check-in denied": "wiederholte Zutrittsablehnung",
  "New members from the last days": "neue Mitglieder der letzten Tage",
  "Member recorded within days": "Tage seit Mitgliedserfassung",
  "Days before birthday": "Tage vor dem Geburtstag",
  "Without check-in for days": "ohne Check-in seit",
  "Overdue for days": "Tage nach Fälligkeit",
  "Due items up to days": "fällige Posten bis in",
  "Chargebacks from the last days": "Rücklastschriften der letzten Tage",
  "Chargeback recorded within days": "Tage seit Rücklastschrift",
  "Wallet balance below threshold": "Wertekonto unter Schwelle",
  "Wallet threshold": "Schwellenwert",
  "Wallet unused for days": "Tage ohne Wertekonto-Nutzung",
  "Wallet unused since days": "Wertekonto ungenutzt",
  "Contract starts in days": "Tage vor Vertragsstart",
  "Contract ends in days": "Tage vor Vertragsende",
  "Rest period ends in days": "Tage vor Ende der Ruhezeit",
  "Denied check-ins from the last days": "abgelehnte Zutritte der letzten Tage",
  "Automation applies to": "Gilt für",
  "When": "Wann",
  "Then": "Dann",
  "Safety": "Sicherheit",
  "Run in test mode": "im Testmodus ausführen",
  "Require approval before final execution": "vor finaler Ausführung freigeben lassen",
  "Approval required hint": "Die Ausführung erzeugt zuerst einen prüfbaren Entwurf oder Freigabeeintrag.",
  "Run automations": "Automatisierungen ausführen",
  "Approve automations": "Automatisierungen freigeben",
  "Member automations": "Mitgliederautomatisierungen",
  "Finance automations": "Finanzautomatisierungen",
  "Contract automations": "Vertragsautomatisierungen",
  "Operations automations": "Betriebsautomatisierungen",
  "Please reload the page. If the error occurs repeatedly, contact support.": "Bitte laden Sie die Seite neu. Bei wiederholten Fehlern wenden Sie sich an den Support.",
  "No data received from server": "keine Daten vom Server erhalten",
  "New user default name": "neuer Benutzer",
  "Contract modules": "Vertragsbausteine",
  "Contract module": "Vertragsbaustein",
  "Contract module assignment description": "mehrere Vertragsbausteine zuordnen und konfigurieren (Laufzeit, Verlängerung, Zahlungszyklus, Preis, Nutzungslimit).",
  "No contract modules available": "keine Vertragsbausteine vorhanden (Einstellungen -> Vertragsbausteine).",
  "Main contract": "Hauptvertrag",
  "Installment payment": "Ratenzahlung",
  "Direct debit group": "Lastschriftgruppe",
  "Wallet assignment description": "mehrere Wertekonten zuordnen und konfigurieren (Startwert, Gültigkeit, Nutzungslimit, Zugriff).",
  "No wallet products available": "keine Wertekonto-Vorlagen vorhanden (Einstellungen -> Wertekonten).",
  "Value account": "Wertekonto",
  "Copy suffix": "Kopie",
  "Copy suffix numbered": "Kopie {0}",
  "Installments max min error": "Raten: Max muss größer oder gleich Min sein",
  "Default price must be non-negative": "Standardpreis muss größer oder gleich 0 sein",
  "Optional default rest period model for this contract package": "Optional: Ruhezeitmodell, das für dieses Vertragspaket als Standard verwendet wird.",
  "Allow rest periods": "Ruhezeiten erlauben",
  "No rest period allowed": "keine Ruhezeit erlauben",
  "Utilization of appointments and courses": "Auslastung von Terminen und Kursen",
  "Utilization per trainer or resource": "Auslastung pro Trainer/Ressource",
  "Home": "Start",
  "Queued": "in Warteschlange",
  "FinTS": "FinTS",
  "Lead widget: widget not found or not available": "Lead-Widget nicht gefunden oder nicht verfügbar",
  "Open item amount": "Betrag des offenen Postens",
  "Open item due date": "Fälligkeit des offenen Postens",
  "Open item description": "Beschreibung des offenen Postens",
  "Total open amount": "gesamter offener Betrag",
  "Reminder level name": "Name der Mahnstufe",
  "Booking widget link": "Terminformular URL",
  "Booking widget as link": "Terminformular klickbar",
  "Appointment booking link": "Termin buchen URL",
  "Appointment booking as link": "Termin buchen klickbar",
  "Email as link": "E-Mail klickbar",
  "Website as link": "Website klickbar",
  "Cancel booking as link": "Termin stornieren klickbar",
  "Edit booking as link": "Termin bearbeiten klickbar",
  "Reset link as link": "Passwort zurücksetzen klickbar",
  "Email link text": "E-Mail schreiben",
  "Website link text": "Website öffnen",
  "Cancel booking link text": "Termin stornieren",
  "Edit booking link text": "Termin bearbeiten",
  "Booking widget link text": "Terminformular öffnen",
  "Appointment booking link text": "Termin buchen",
  "Reset link text": "Passwort zurücksetzen",
  "CenterCom verification views title": "Prüf-Views",
  "CenterCom verification views empty": "keine Prüf-Views erkannt",
  "CenterCom verification status ok": "ok",
  "CenterCom verification status deviation": "Abweichung",
  "CenterCom verification status not checkable": "nicht prüfbar",
  "CenterCom verification status unknown": "unbekannt",
  "CenterCom verification details": "Details",
  "CenterCom verification metric": "Prüfwert",
  "CenterCom verification evaluated records": "bewertete Datensätze",
  "CenterCom verification amount column": "Betragsspalte",
  "CenterCom committed verification views title": "Prüfung nach dem Import",
  "CenterCom committed verification refreshed": "Die Prüfung nach dem Import wurde aktualisiert.",
  "CenterCom committed verification refresh error": "Die Prüfung nach dem Import konnte nicht aktualisiert werden.",
  "Time restriction": "zeitliche Einschränkung",
  "Limit by time": "zeitlich einschränken",
  "Available time": "verfügbare Zeit",
  "No time restriction": "keine zeitliche Einschränkung",
  "Auth": "Authentifizierung",
  "Connect": "Connect",
  "OTP": "OTP",
  "ReaderDevices": "Lesegeräte",
  "TenantBackup": "Mandantensicherung",
  "More tabs": "weitere Tabs",
  "Promotions & bonuses": "Aktionen & Boni",
  "Manage referrals, bonus cases and redemptions": "Empfehlungen, Bonusfälle und Einlösungen verwalten",
  "Promotion templates": "Bonusmodelle",
  "Rules for referral bonuses and campaigns": "Regeln für Empfehlungsboni und Aktionen",
  "Promotion template": "Bonusmodell",
  "Qualification": "Qualifikation",
  "New promotion template": "Bonusmodell anlegen",
  "Edit promotion template": "Bonusmodell",
  "Create promotion template": "Bonusmodell erstellen",
  "Name is required.": "Name ist erforderlich.",
  "Delete promotion template": "Bonusmodell löschen",
  "Bonus type": "Bonusart",
  "Price adjustment only": "nur Preisanpassung",
  "Value account only": "nur Wertekonto",
  "Selectable when entering": "beim Eintragen auswählbar",
  "Price adjustment type": "Preisanpassungstyp",
  "Promotion amount per duration unit": "Betrag je Einheit",
  "Contribution cycles": "Beitragszyklen",
  "Start mode": "Startmodus",
  "Next due date": "nächste Fälligkeit",
  "Fixed start date": "festes Startdatum",
  "Contract end": "Vertragsende",
  "Before contract renewal": "vor Vertragsverlängerung",
  "Append after contract end": "nach Vertragsende anhängen",
  "Qualification timing": "Qualifikationszeitpunkt",
  "Immediately": "sofort",
  "Fixed date": "fester Stichtag",
  "After referred contract start": "nach Vertragsbeginn des geworbenen Mitglieds",
  "Qualification condition": "Qualifikationsbedingung",
  "Promotion qualification condition tooltip": "Diese Bedingung wird pro Bonusfall auf den Vertrag des geworbenen Mitglieds geprüft, also auf das gewählte Vertragspaket, nicht allgemein auf die Person.",
  "Active on due date": "aktiv am Stichtag",
  "No cancellation recorded": "keine Kündigung erfasst",
  "No effective cancellation": "keine Kündigung wirksam",
  "Manual review": "manuelle Prüfung",
  "Later cancellation behavior": "Verhalten bei späterer Kündigung",
  "Promotion later cancellation behavior tooltip": "Legt fest, was passiert, wenn nach der Qualifikation am Vertrag des geworbenen Mitglieds doch noch eine Kündigung erfasst oder wirksam wird.",
  "Ignore after qualification": "nach Qualifikation ignorieren",
  "Block until redemption": "bis Einlösung blockieren",
  "Revocable until benefit end": "bis Leistungsende widerrufbar",
  "Value account product": "Wertekonto-Produkt",
  "Credit amount": "Gutschriftbetrag",
  "Offset": "Versatz",
  "New bonus": "Bonus anlegen",
  "Edit bonus": "Bonus bearbeiten",
  "Create bonus": "Bonus erstellen",
  "Referred member": "geworbenes Mitglied",
  "Referred contract package": "Vertrag des geworbenen Mitglieds",
  "Referral date": "Empfehlungsdatum",
  "Requested start date": "gewünschtes Startdatum",
  "Internal note": "interne Notiz",
  "Target contract package": "Ziel-Vertragspaket",
  "Target contract": "Zielvertrag",
  "Target value account": "Ziel-Wertekonto",
  "Open price adjustment": "Preisanpassung öffnen",
  "Open value account booking": "Wertekonto-Buchung öffnen",
  "qualified": "qualifiziert",
  "redeemed": "eingelöst",
  "rejected": "abgelehnt",
  "cancelled": "storniert",
  "review needed": "Prüfung nötig",
  "Qualify": "qualifizieren",
  "Redeem": "einlösen",
  "Qualified.": "qualifiziert.",
  "Redeemed.": "eingelöst.",
  "Cancelled.": "storniert.",
  "Value account booking": "Wertekonto-Buchung",
  "Role in referral": "Rolle in der Empfehlung",
  "Current person is referrer": "aktuelle Person ist Werber",
  "Current person was referred": "aktuelle Person wurde geworben",
  "Referral situation": "Empfehlung",
  "This person referred a member": "diese Person hat ein Mitglied geworben",
  "This person was referred": "diese Person wurde geworben",
  "Other person": "andere Person",
  "Referral bonus": "Empfehlungsbonus",
  "Search person": "Person suchen",
  "Select promotion template": "Bonusmodell auswählen",
  "Referrer is required.": "Werber ist erforderlich.",
  "Promotion template is required.": "Bonusmodell ist erforderlich.",
  "View promotions and bonuses": "Aktionen & Boni sehen",
  "Edit promotions and bonuses": "Aktionen & Boni bearbeiten",
  "Execute promotions and bonuses": "Aktionen & Boni ausführen",

  // Import-Merges
  "Merge imports": "Merge-Importe",
  "Merge imports group card description": "mehrere Quellsystem-Exporte vor dem Adapter-Import konsolidieren",
  "Back to Merge imports": "zurück zu Merge-Importen",
  "Merge import column name": "Name",
  "Merge import column sources": "Quellen",
  "Merge import create button": "Merge-Import anlegen",
  "Merge import create title": "Merge-Import anlegen",
  "Merge import edit title": "Merge-Import bearbeiten",
  "Merge import name placeholder": "z. B. CenterCom-Filialmerge",
  "Merge import tenant required": "Bitte einen Zielmandanten auswählen.",
  "Merge import created": "Merge-Import angelegt",
  "Merge import save success": "Merge-Import gespeichert",
  "Merge import confirm delete": "Merge-Import löschen?",
  "Merge import confirm delete detail": "Quellen, Ergebnisse und Reports dieses Merge-Imports werden dauerhaft gelöscht.",
  "Merge import deleted": "Merge-Import gelöscht",
  "Merge import delete error": "Merge-Import konnte nicht gelöscht werden.",
  "Merge import detail title": "Merge-Import",
  "Merge import status Draft": "Entwurf",
  "Merge import status Uploaded": "hochgeladen",
  "Merge import status Analyzed": "analysiert",
  "Merge import status Merged": "zusammengeführt",
  "Merge import status Failed": "fehlgeschlagen",
  "Merge import step upload": "Quellen hochladen",
  "Merge import step analyze": "Quellen prüfen",
  "Merge import step mapping": "Studios zuordnen",
  "Merge import step merge": "Merge ausführen",
  "Merge import step handover": "Ergebnis übergeben",
  "Merge import overview title": "Übersicht",
  "Merge import upload title": "Quellen hochladen",
  "Merge import upload hint": "ZIP-Dateien oder einzelne CenterCom-Dateien je Filiale hochladen.",
  "Merge import upload drag text": "Dateien hier ablegen oder auswählen",
  "Merge import upload button": "Quellen hochladen",
  "Merge import upload no files": "Bitte mindestens eine Datei auswählen.",
  "Merge import upload failed": "Quellen konnten nicht hochgeladen werden.",
  "Merge import upload success": "Quellen hochgeladen",
  "Merge import analyze button": "Quellen prüfen",
  "Merge import analyze success": "Quellen geprüft",
  "Merge import analysis title": "Quellenprüfung",
  "Merge import analysis issues": "Hinweise zur Quellenprüfung",
  "Merge import source": "Quelle",
  "Merge import table": "Tabelle",
  "Merge import path": "Pfad",
  "Merge import rows": "Zeilen",
  "Merge import studio mapping title": "Studio-Zuordnung",
  "Merge import default studio placeholder": "Standard-Studio für diese Quelle",
  "Merge import source studio value": "CenterCom-Studio",
  "Merge import target studio": "m1member-Studio",
  "Merge import no source studio values": "keine Studio-Werte in dieser Quelle erkannt.",
  "Merge import merge button": "Merge ausführen",
  "Merge import merge success": "Merge abgeschlossen",
  "Merge import report title": "Merge-Report",
  "Merge import result objects": "Ergebnisdateien",
  "Merge import duplicate persons": "mögliche Personen-Dubletten",
  "Merge import duplicate key": "Dubletten-Schlüssel",
  "Merge import duplicate matches": "Treffer",
  "Merge import download result": "Ergebnis herunterladen",
  "Merge import create import run": "als CenterCom-Import öffnen",
  "Merge import create import run failed": "CenterCom-Import konnte nicht aus dem Merge-Ergebnis erstellt werden.",
  "Merge import create import run success": "CenterCom-Import aus Merge-Ergebnis erstellt",
  "Merge import open import run": "CenterCom-Import öffnen",
  "Merge import result suffix": "Import",
  "CenterCom merge result select title": "Merge-Ergebnis auswählen",
  "CenterCom merge result select hint": "Alternativ zum Upload kann ein fertiges CenterCom-Merge-Ergebnis in einen neuen Adapter-Importlauf übergeben werden.",
  "CenterCom merge result select placeholder": "Merge-Ergebnis auswählen",
  "CenterCom merge result select empty": "kein fertiges Merge-Ergebnis verfügbar",
  "CenterCom merge result create import": "Importlauf erstellen",
  "CenterCom merge result apply failed": "Merge-Ergebnis konnte nicht in den Importlauf übernommen werden.",
  "Preview values": "Vorschau",
  "Appointment start (date + time)": "Terminstart (Datum + Uhrzeit)",
  "Appointment end (date + time)": "Terminende (Datum + Uhrzeit)",
  "Appointment date": "Termindatum",
  "Appointment time": "Termin-Uhrzeit",
  "Appointment name": "Terminbezeichnung",
  "Appointment type name": "Terminart-Name",
  "Duration in minutes": "Dauer in Minuten",
  "Guest first name": "Gast-Vorname",
  "Guest last name": "Gast-Nachname",
  "One-time booking confirmation code (5 digits)": "Einmalcode zur Terminbestätigung (5-stellig)",
  "Document text": "Dokumenttext",
  "Privacy status": "Datenschutzstatus",
  "Privacy notice received": "Datenschutzhinweis erhalten",
  "Document privacy notice": "Datenschutzhinweis dokumentieren",
  "Erasure requested": "Löschung angefragt",
  "Erasure requested at": "Löschung angefragt am",
  "Anonymized at": "Anonymisiert am",
  "anonymized": "anonymisiert",
  "normal": "normal",
  "Mark erasure request": "Löschanfrage vormerken",
  "Mark erasure request?": "Löschanfrage vormerken?",
  "Mark erasure request text": "Es wird nur eine Datenschutzaufgabe erstellt. Stammdaten werden noch nicht verändert.",
  "Mark request": "Anfrage vormerken",
  "Complete anonymization": "Anonymisierung abschließen",
  "Complete anonymization?": "Anonymisierung abschließen?",
  "Complete anonymization text": "Die Person wird jetzt anonymisiert, direkte Kontaktdaten, Foto, Bankdaten, aktive Zugangsmedien und nicht aufbewahrungspflichtige sonstige Dokumente werden entfernt. Die Aufgabe wird danach als erledigt markiert.",
  "Anonymization completed.": "Anonymisierung abgeschlossen.",
  "Privacy task": "Datenschutzaufgabe",
  "Privacy task is open.": "Datenschutzaufgabe ist offen.",
  "Edit privacy task": "Datenschutzaufgabe bearbeiten",
  "No permission for privacy actions.": "keine Berechtigung für Datenschutzaktionen.",
  "Manage privacy": "Datenschutz verwalten",
  "Web": "Web",
  "Forgot password": "Passwort vergessen?",
  "Email required": "Bitte gib deine E-Mail-Adresse ein.",
  "Password required": "Bitte gib dein Passwort ein.",
  "Logging in...": "Anmeldung läuft...",
  "PasswordResetDescription": "Gib die E-Mail-Adresse deines Kontos ein. Wenn ein Konto existiert, wird ein Rücksetzlink gesendet.",
  "Request reset link": "Rücksetzlink anfordern",
  "PasswordResetRequested": "Rücksetzlink angefordert",
  "PasswordResetEmailHint": "Prüfe deine E-Mails und öffne den Link zum Zurücksetzen.",
  "DevelopmentResetTokenHint": "Lokale Entwicklung: Der Rücksetz-Token wird hier angezeigt.",
  "Password reset successful": "Passwort geändert",
  "PasswordResetSuccessfulDescription": "Dein Passwort wurde geändert. Du kannst dich jetzt anmelden.",
  "InvalidResetToken": "Der Link zum Zurücksetzen ist ungültig oder abgelaufen.",
  "PasswordMinLength": "Das Passwort muss mindestens 8 Zeichen lang sein.",
  "Please confirm your new password": "Bitte bestätige dein neues Passwort.",
  "No access": "kein Zugriff",
  "Create permission level": "anlegen",
  "Manage": "verwalten",
  "Dashboard permission help": "Erlaubt den Zugriff auf die Startseite mit Kennzahlen und Aufgabenübersicht.",
  "Check-in permission help": "Erlaubt die Nutzung der Check-in-Ansicht und manueller Zutrittsabläufe.",
  "Tasks permission help": "Aufgaben ansehen oder neue Aufgaben anlegen. Erledigen ist ein separater Zusatzschalter.",
  "Complete tasks": "Aufgaben erledigen",
  "Complete tasks help": "Erlaubt, Aufgaben als erledigt zu markieren oder vergleichbare Aufgabenaktionen abzuschließen.",
  "People permission help": "Personen ansehen, bearbeiten oder neu anlegen. Risikoaktionen bleiben separate Zusatzrechte.",
  "Change home studio help": "Erlaubt, das Stammstudio einer Person zu ändern.",
  "Block check-in help": "Erlaubt, Check-ins einer Person zu sperren oder wieder freizugeben.",
  "Manage privacy help": "Erlaubt Datenschutzaufgaben wie Anonymisierung, Export und Löschung personenbezogener Daten.",
  "Digital file permission help": "Steuert den Zugriff auf Dokumente, Fotos und die digitale Akte einer Person.",
  "Change history": "Änderungshistorie",
  "Change history permission help": "Erlaubt das Anzeigen protokollierter Änderungen an Personendaten.",
  "Promotions and bonuses": "Aktionen und Boni",
  "Promotions permission help": "Aktionen und Bonusfälle ansehen oder bearbeiten. Aktionsvorlagen sind ein eigenes Einstellungsrecht.",
  "Absences and availabilities": "Abwesenheiten & Verfügbarkeiten",
  "Accounting and cash registers": "Buchhaltung & Kassen",
  "Cancel payments": "Zahlungen stornieren",
  "Cancellation models and reasons": "Kündigungsmodelle & -gründe",
  "Dispatch settings": "Versandeinstellungen",
  "Payment and contribution cancellation reasons": "Stornogründe",
  "Payroll and hour balance": "Lohn & Stundenkonto",
  "Price adjustment models": "Preisanpassungsmodelle",
  "Rest period models and reasons": "Ruhezeitmodelle & -gründe",
  "Submit and book direct debit runs": "Lastschriftläufe einreichen und buchen",
  "Accounting exports permission help": "Buchhaltungsexporte erstellen und herunterladen. Kontenrahmen und Kassen sind ein eigenes Einstellungsrecht.",
  "Bank statement permission help": "Kontoauszug abrufen, Umsätze zuordnen und buchen.",
  "Close contract permission help": "Neue Verträge abschließen und Vertragspakete hinzufügen. Verkaufsaktionen und Zubuchoptionen werden dabei angewendet, nicht gepflegt.",
  "Debt collection cases permission help": "Inkassofälle anlegen und führen. Inkassobüros und Mahnstufen sind ein eigenes Einstellungsrecht.",
  "Execute promotions and bonuses help": "Erlaubt, Aktionen oder Bonusfälle auszuführen.",
  "Contracts permission help": "Verträge ansehen oder bearbeiten. Abschließen, Löschen und Kündigen sind eigene Rechte.",
  "Delete contracts": "Verträge löschen",
  "Delete contracts help": "Erlaubt das Löschen von Verträgen oder Vertragspaketen.",
  "Cancel contracts help": "Erlaubt das Kündigen von Verträgen mit den normalen Kündigungsregeln.",
  "Rest periods permission help": "Ruhezeiten an Verträgen ansehen oder eintragen. Ruhezeitmodelle und -gründe sind ein eigenes Einstellungsrecht.",
  "Price adjustments permission help": "Preisanpassungen an Verträgen ansehen oder anwenden. Preisanpassungsmodelle sind ein eigenes Einstellungsrecht.",
  "Customize price adjustments": "Preisanpassungen individuell anpassen",
  "Customize price adjustments help":
    "Preisanpassungen ohne Modell manuell setzen oder bestehende manuelle Preisanpassungen bearbeiten. Ohne dieses Recht können nur vorhandene Preisanpassungsmodelle zugeordnet werden (Voraussetzung: Preisanpassungen bearbeiten).",
  "Leads permission help": "Erlaubt das Anzeigen und Bearbeiten von Kontakten im Vertrieb.",
  "Delete leads help": "Erlaubt das Löschen von Kontakten.",
  "Article sales permission help": "Erlaubt das Anzeigen oder Buchen von Artikelverkäufen.",
  "Communication send permission help": "Erlaubt das manuelle Versenden von E-Mails oder Briefen.",
  "Outbound communication": "ausgehende Kommunikation",
  "Outbound communication permission help": "Steuert vorbereitete und prüfpflichtige ausgehende Kommunikation.",
  "Review outbound communication": "ausgehende Kommunikation prüfen",
  "Review outbound communication help": "Erlaubt die Freigabe prüfpflichtiger ausgehender Kommunikation.",
  "Review own outbound communication": "eigene ausgehende Kommunikation prüfen",
  "Review own outbound communication help": "Erlaubt die Freigabe eigener prüfpflichtiger ausgehender Kommunikation.",
  "Skip outbound review": "Prüfung überspringen",
  "Skip outbound review help": "Erlaubt das Senden ohne Freigabeprüfung.",
  "Cancel outbound communication": "ausgehende Kommunikation abbrechen",
  "Cancel outbound communication help": "Erlaubt das Abbrechen geplanter oder vorbereiteter Kommunikation.",
  "Retry outbound communication": "ausgehende Kommunikation erneut versuchen",
  "Retry outbound communication help": "Erlaubt das erneute Anstoßen fehlgeschlagener Kommunikation.",
  "Manage outbound settings": "Versandeinstellungen verwalten",
  "Manage outbound settings help": "Erlaubt Einstellungen für ausgehende Kommunikation.",
  "Inbox permission help": "Erlaubt das Anzeigen des Kommunikationseingangs.",
  "Email queue": "E-Mail-Warteschlange",
  "Email queue permission help": "Erlaubt das Anzeigen der technischen E-Mail-Warteschlange.",
  "Templates permission help": "Brief- und E-Mail-Texte, Kategorien sowie SMS- und WhatsApp-Vorlagen ansehen oder bearbeiten.",
  "Appointments permission help": "Erlaubt das Anzeigen oder Bearbeiten von Terminen.",
  "Availabilities permission help": "Verfügbarkeitsvorlagen und Feiertage für Termine ansehen oder pflegen.",
  "Staff absences": "Abwesenheiten",
  "Staff schedule permission help": "Erlaubt das Anzeigen oder Bearbeiten des Dienstplans.",
  "Staff absences permission help": "Abwesenheiten und Verfügbarkeiten der Mitarbeiter ansehen oder bearbeiten.",
  "Vacation management permission help": "Erlaubt das Anzeigen oder Bearbeiten der Urlaubsverwaltung.",
  "Payroll permission help": "Erlaubt das Anzeigen der Abrechnungsvorbereitung und des Stundenkontos.",
  "Export payroll help": "Erlaubt den Export von Abrechnungsdaten und des Stundenkontos.",
  "Staff settings": "Personal-Einstellungen",
  "Staff settings permission help": "Erlaubt nur die Personal-Einstellungen, auch ohne allgemeines Einstellungsrecht.",
  "Finance permission help": "Erlaubt das Anzeigen oder Bearbeiten zentraler Finanzdaten.",
  "Open items permission help": "Erlaubt das Anzeigen oder Bearbeiten offener Posten.",
  "Agree installment plan help": "Erlaubt das Vereinbaren von Ratenzahlungen für offene Posten.",
  "Payments permission help": "Erlaubt das Anzeigen oder Buchen von Zahlungen.",
  "SEPA direct debits": "SEPA-Lastschriften",
  "SEPA direct debits permission help": "Erlaubt das Anzeigen oder Verwalten von SEPA-Lastschriften.",
  "Reminder levels": "Mahnstufen",
  "Reminders permission help": "Erlaubt das Anzeigen oder Erstellen von Mahnungen.",
  "Reminder levels permission help": "Erlaubt das Anzeigen oder Konfigurieren von Mahnstufen.",
  "Member reports permission help": "Erlaubt Auswertungen zu Mitgliedern.",
  "Report lists permission help": "Erlaubt eigene Auswertungslisten.",
  "Finance reports permission help": "Erlaubt Finanzauswertungen.",
  "Contract reports permission help": "Erlaubt Vertragsauswertungen.",
  "Usage reports permission help": "Erlaubt Nutzungsauswertungen.",
  "Calendar reports permission help": "Erlaubt Kalenderauswertungen.",
  "Lead reports permission help": "Erlaubt Kontaktauswertungen.",
  "Automations permission help": "Erlaubt das Anzeigen oder Verwalten von Automatisierungen.",
  "Run automations help": "Erlaubt das manuelle Ausführen von Automatisierungen.",
  "Approve automations help": "Erlaubt das Freigeben von Automatisierungen.",
  "Member automations help": "Erlaubt Automatisierungen für Mitgliederprozesse.",
  "Finance automations help": "Erlaubt Automatisierungen für Finanzprozesse.",
  "Contract automations help": "Erlaubt Automatisierungen für Vertragsprozesse.",
  "Operations automations help": "Erlaubt Automatisierungen für operative Prozesse.",
  "Duplicate finder permission help": "Erlaubt das Suchen nach möglichen Dubletten und, in der Verwaltungsstufe, das Zusammenführen.",
  "Settings base permission help": "Erlaubt den Zugriff auf den Einstellungsbereich. Ohne dieses Recht sind einzelne Einstellungsseiten nicht erreichbar.",
  "Users permission help": "Erlaubt das Anzeigen oder Verwalten von Benutzern.",
  "Roles permission help": "Erlaubt das Anzeigen oder Verwalten von Rollen und Rechten.",
  "Master data permission help": "Erlaubt das Anzeigen oder Bearbeiten von Stammdaten.",
  "Member defaults": "Mitgliederverwaltung",
  "Member defaults permission help": "Erlaubt das Anzeigen oder Bearbeiten von Standardwerten für Mitglieder.",
  "Check-in view settings": "Check-in-Ansicht",
  "Check-in view settings permission help": "Erlaubt das Anzeigen oder Bearbeiten der Check-in-Ansicht.",
  "Contract packages permission help": "Erlaubt das Anzeigen oder Bearbeiten von Vertragspaketen.",
  "Contract components permission help": "Erlaubt das Anzeigen oder Bearbeiten von Vertragsbausteinen.",
  "Payment plans permission help": "Erlaubt das Anzeigen oder Bearbeiten von Zahlungsplänen.",
  "Wallet products permission help": "Erlaubt das Anzeigen oder Bearbeiten von Wertekonten.",
  "Articles permission help": "Erlaubt das Anzeigen oder Bearbeiten von Artikeln.",
  "Cancellation reasons permission help": "Erlaubt das Anzeigen oder Bearbeiten von Kündigungsgründen.",
  "Cancellation models permission help": "Erlaubt das Anzeigen oder Bearbeiten von Kündigungsmodellen.",
  "Accounting settings": "Buchführung",
  "Accounting settings permission help": "Kontenrahmen, Steuersätze, Buchungszuordnungen und Kassen ansehen oder bearbeiten.",
  "Bank account settings": "Bankkonten",
  "Bank account settings permission help": "Erlaubt das Anzeigen oder Bearbeiten von Bankkonten.",
  "Default wallet payment settings": "Guthabenkonto",
  "Default wallet payment settings permission help": "Erlaubt das Anzeigen oder Bearbeiten der Standardzahlung für Guthaben.",
  "Payment methods settings": "Zahlungsarten",
  "Payment methods settings permission help": "Erlaubt das Anzeigen oder Bearbeiten von Zahlungsarten.",
  "Payment cancellation reasons permission help": "Erlaubt das Anzeigen oder Bearbeiten von Zahlungsstornogründen.",
  "Debt management settings": "Mahnwesen",
  "Debt management settings permission help": "Mahnstufen und Inkassobüros ansehen oder pflegen.",
  "Lead sources settings": "Kontaktquellen",
  "Lead sources settings permission help": "Erlaubt das Anzeigen oder Bearbeiten von Kontaktquellen.",
  "Lead pipelines settings": "Kontakt-Pipelines",
  "Lead pipelines settings permission help": "Erlaubt das Anzeigen oder Bearbeiten von Kontakt-Pipelines.",
  "Lead widgets settings": "Kontaktformulare",
  "Lead widgets settings permission help": "Erlaubt das Anzeigen oder Bearbeiten von Kontaktformularen.",
  "Contract signing widgets permission help": "Erlaubt das Anzeigen oder Bearbeiten von Vertragsformularen.",
  "Experience contract widgets": "Erlebnis-Vertragsformulare",
  "Experience contract widgets permission help": "Erlaubt das Anzeigen oder Bearbeiten von Erlebnis-Vertragsformularen.",
  "Lead automation settings": "Kontakt-Automatik",
  "Lead automation settings permission help": "Erlaubt das Anzeigen oder Bearbeiten der Kontakt-Automatik.",
  "Email settings": "E-Mail-Einstellungen",
  "Outer background": "Außenhintergrund",
  "Content background": "Inhaltshintergrund",
  "Logo background": "Logo-Hintergrund",
  "Place footer outside content": "Fußbereich außerhalb des Inhaltsbereichs platzieren",
  "Email settings permission help": "Erlaubt das Anzeigen oder Bearbeiten von E-Mail-Einstellungen.",
  "Auto communication settings": "Auto-Kommunikation",
  "Auto communication settings permission help": "Erlaubt das Anzeigen oder Bearbeiten automatischer Kommunikation.",
  "Appointment configuration": "Kalender-Einstellungen",
  "Appointment configuration permission help": "Erlaubt das Anzeigen oder Bearbeiten der Kalender-Einstellungen.",
  "Appointment types permission help": "Erlaubt das Anzeigen oder Bearbeiten von Terminarten.",
  "Resources settings": "Ressourcen",
  "Resources settings permission help": "Erlaubt das Anzeigen oder Bearbeiten von Ressourcen.",
  "Unavailabilities settings": "Abwesenheiten",
  "Unavailabilities settings permission help": "Erlaubt das Anzeigen oder Bearbeiten von Abwesenheiten.",
  "Appointment outcomes permission help": "Erlaubt das Anzeigen oder Bearbeiten von Termin-Ergebnissen.",
  "Booking widgets permission help": "Erlaubt das Anzeigen oder Bearbeiten von Buchungsformularen.",
  "Appointment notifications permission help": "Erlaubt das Anzeigen oder Bearbeiten von Termin-Benachrichtigungen.",
  "Reader devices permission help": "Erlaubt das Anzeigen oder Verwalten von Lesegeräten.",
  "Studio app settings permission help": "Erlaubt das Anzeigen oder Bearbeiten der Studio-App-Einstellungen.",
  "Units settings": "Einheiten",
  "Units settings permission help": "Erlaubt das Anzeigen oder Bearbeiten von Einheiten.",
  "Default theme settings": "Standard-Design",
  "Default theme settings permission help": "Erlaubt das Anzeigen oder Bearbeiten des Standard-Themes.",
  "User templates settings": "Benutzer-Vorlagen",
  "User templates settings permission help": "Erlaubt das Anzeigen oder Bearbeiten von Benutzer-Vorlagen.",
  "Integrations settings": "Schnittstellen",
  "Integrations settings permission help": "Erlaubt das Anzeigen oder Bearbeiten von Schnittstellen.",
  "Backup and restore settings": "Datensicherung",
  "Backup and restore settings permission help": "Erlaubt das Anzeigen oder Ausführen von Datensicherung und Wiederherstellung.",
  "Tenant capabilities permission help": "Erlaubt das Anzeigen oder Bearbeiten von Mandantenfähigkeiten.",
  "Back to Application": "zurück zur Anwendung",
  "Undo change history entries": "Änderungen rückgängig machen",
  "Undo change history entries help": "Erlaubt das Rückgängigmachen geprüfter Änderungshistorie-Einträge. Zusätzlich ist das jeweilige Fachrecht erforderlich.",
  "Person data change": "Personendatenänderung",
  "Undo": "Rückgängig machen",
  "rollback": "zurückgerollt",
  "rolled back": "zurückgerollt",
  "recorded": "aufgezeichnet",
  "Area": "Bereich",
  "Undo change?": "Änderung rückgängig machen?",
  "The selected change will be rolled back.": "Die ausgewählte Änderung wird zurückgenommen.",
  "Change rolled back.": "Änderung wurde zurückgerollt.",
  "This change cannot be rolled back.": "Diese Änderung kann nicht zurückgenommen werden.",
  "partially recorded": "teilweise aufgezeichnet",
  "not recorded": "nicht aufgezeichnet",
  "External delivery": "externer Versand",
  "Only entries with a complete snapshot and the required special permission can be rolled back.": "Nur Einträge mit vollständigem Snapshot und erforderlicher Spezialberechtigung können zurückgenommen werden.",
  "Delete contact including person": "Kontakt inklusive Person löschen",
  "Delete including person": "Inklusive Person löschen",
  "Delete contact including person confirmation": "Kontakt und zugehörige Person wirklich löschen? Dies ist nur möglich, wenn keine weiteren verknüpften Daten vorhanden sind.",
  "Contact and person deleted.": "Kontakt und Person wurden gelöscht.",
  "Test environment — external sending disabled": "Testumgebung — automatische Kommunikation ist aus",
  "Safe mode — external sending blocked": "Sicherheitsmodus — externer Versand blockiert",
  "Appointment change history": "Änderungshistorie",
  "No appointment history yet": "Noch keine Änderungshistorie vorhanden",
  "Appointment history could not be loaded": "Die Änderungshistorie konnte nicht geladen werden.",
  "Appointment history created": "angelegt",
  "Appointment history updated": "bearbeitet",
  "Appointment history deleted": "gelöscht",
  "Appointment history moved": "verschoben",
  "Appointment history cancelled": "abgesagt",
  "Appointment history confirmed": "bestätigt",
  "Appointment history no-show": "als nicht erschienen markiert",
  "Appointment history archived": "archiviert",
  "Appointment history moved summary": "verschoben von {0} auf {1}",
  "Appointment history duration summary": "Länge von {0} auf {1} geändert",
  "Appointment history price summary": "Preis von {0} auf {1} geändert",
  "Participant statuses": "Teilnehmerstatus",
  "No value": "kein Wert",
  "Unknown account": "Unbekannter Mitarbeiter",
  "Minutes short": "Min.",
  "Mixed reminder case": "gemischter Mahnfall",
  "Contract template filter": "Vertragsbaustein-Filter",
  "Empty contract template filter applies to all contracts": "Ohne Auswahl gilt die Regel für alle Vertragsbausteine.",
  "Manual template selection": "manuelle Vorlagenauswahl",
  "After a chargeback": "Nach einer Rücklastschrift",
  "Retry direct debit": "Erneut einziehen",
  "Wait for payment": "Zahlung abwarten",
  "Further handling after chargeback": "weiteres Vorgehen nach der Rücklastschrift",
  "Please select further handling after chargeback": "Bitte das weitere Vorgehen nach der Rücklastschrift wählen.",
  "Include in next regular SEPA run": "beim nächsten regulären SEPA-Lauf erneut berücksichtigen",
  "Block SEPA until contribution is paid": "für SEPA sperren, bis der Beitrag bezahlt ist",
  "Block returned items only; continue collecting future contributions": "nur zurückgegebene Forderungen sperren; Folgebeiträge weiter einziehen",
  "Further direct debits blocked by return reason": "Der Rücklastschriftgrund sperrt weitere Lastschriften. Das SEPA-Mandat muss zuerst geklärt werden.",
  "Unavailable delivery integration": "nicht verfügbare Versandschnittstelle",
  "Block type": "Sperrtyp",
  "Dunned contribution": "Angemahnter Beitrag",
  "Blocked at": "Gesperrt am",
  "Release condition": "Aufhebungsbedingung",
  "All contracts": "Alle Verträge",
  "This open item": "Dieser offene Posten",
  "Mandate block": "Mandatssperre",
  "After payment of dunned contribution": "Nach Zahlung des angemahnten Beitrags",
  "Manual release": "Manuelle Freigabe",
  "Released automatically": "automatisch aufgehoben",
  "Released at": "aufgehoben am",
  "Released by": "aufgehoben durch",
  "Release blocks of this contract": "Sperren dieses Vertrags aufheben",
  "Releasing also lifts the person-wide mandate block.": "Die Aufhebung entfernt auch die personenweite Mandatssperre.",
  "Releasing also lifts the person-wide mandate block affecting other contracts.": "Die Aufhebung entfernt auch die personenweite Mandatssperre — sie betrifft ebenfalls andere Verträge dieser Person.",
  "Manage SEPA block": "SEPA-Sperre verwalten",
  "No active SEPA blocks.": "keine aktiven SEPA-Sperren.",
  "Block history": "Sperr-Historie",
  "After a mandate block the mandate is voided — capture the new bank details and mandate here.": "Nach einer Mandatssperre ist das Mandat entwertet — hier neue Bankverbindung und neues Mandat erfassen.",
  "Released manually": "manuell aufgehoben",
  "According to reminder rule": "Gemäß Mahnregel",
  "According to reminder rule per payment": "Gemäß Mahnregel je Zahlung",
  "Open SEPA block": "SEPA-Sperre öffnen",
  "Pin": "anpinnen",
  "Remove pin": "Anpinnung entfernen",
  "Pinned pages": "angepinnte Seiten",
  "Maximum number of pinned pages reached": "maximale Anzahl angepinnter Seiten erreicht",
  "This page is no longer available": "diese Seite ist nicht mehr verfügbar",
  "Not classified": "nicht klassifiziert",

  "AiProviderAdministration.MenuTitle": "KI-Anbieterverwaltung",
  "AiProviderAdministration.ProviderTab": "Anbieter",
  "AiProviderAdministration.ModelsTab": "Modelle",
  "AiProviderAdministration.AgentsTab": "Agenten",
  "AiProviderAdministration.CostsTab": "Kosten",
  "Default billing": "Standard-Rechnungsadresse",
  "Default shipping": "Standard-Lieferadresse",
  "Label": "Bezeichnung",
  "Last 12 months": "letzte 12 Monate",
  "Last month": "letzter Monat",
  "Max output tokens": "maximale Ausgabe-Token",
  "Max parallel": "maximal parallel",
  "Max retry attempts": "maximale Wiederholversuche",
  "Model": "Modell",
  "No models configured": "keine Modelle eingerichtet",
  "OfferedModels.ModelLocation": "Ausführung",
  "Pricing": "Preise",
  "Pricing managed automatically": "Preise werden automatisch gepflegt",
  "Profile Name": "Profilname",
  "Provider": "Anbieter",
  "ProviderAccess.AccessData": "Zugangsdaten",
  "ProviderAccess.Provider": "Anbieter",
  "ProviderAccess.Status": "Status",
  "ProviderCost.UnknownCurrency": "unbekannte Währung",
  "Request delay": "Anfrageverzögerung",
  "Request timeout": "Anfrage-Zeitlimit",
  "Additional offers": "Zusatzangebote",
  "Promotion free period detail": "{value} {unit} gratis",
  "Promotion free period training start": "{value} {unit} beitragsfrei ab Trainingsbeginn",
  "Promotion fixed start detail": "Vertragsbeginn am {date}",
  "Promotion discount detail": "{cadence} Preisvorteil ab {anchor}: {duration}",
  "Promotion discount limited duration": "Preisvorteil für {duration} ab {anchor}",
  "Promotion discount recurring unlimited": "{cadence} Preisvorteil",
  "Promotion discount one time": "Einmaliger Preisvorteil ab {anchor}",
  "Promotion: {0}": "Aktion: {0}",
  "ContractSigningStudioRequired": "Bitte wähle zuerst ein Studio aus.",
  "ContractSigningOfferUnavailableForStudio": "Dieses Angebot ist für das gewählte Studio leider nicht verfügbar. Bitte wähle ein anderes Studio oder Angebot.",
  "ContractWidgetPackageTemplateNotFound": "Mindestens ein gewähltes Vertragspaket existiert nicht oder ist ungültig.",
  "ContractWidgetOptionGroupNotFound": "Mindestens ein gewähltes Leistungsbündel existiert nicht oder ist ungültig.",
  "ContractWidgetPromotionNotFound": "Mindestens eine zugewiesene Verkaufsaktion existiert nicht oder ist ungültig.",
  "Legal texts & Data protection": "Rechtstexte & Datenschutz",
  "Legal texts, privacy, terms and impressum": "Rechtstexte, Datenschutz, AGB & Impressum",
  "Inherited from master data": "Standard aus Stammdaten",
  "Custom widget logo": "Eigenes Logo",
  "Reset to master data logo": "Auf Stammdaten zurücksetzen",
  "Surface background": "Karten- & Panelhintergrund",
  "Card background": "Kachelhintergrund",
  "Heading text color": "Textfarbe Überschriften",
  "Body text color": "Textfarbe Fließtext",
  "Border color": "Rahmenfarbe",
  "Button text color": "Button-Textfarbe",
  "Package highlights": "Leistungs-Highlights",
  "Promotion highlight": "Aktions-Highlight",
  "Promotion discount duration": "{value} {unit}",
  "Contract period": "Vertragslaufzeit",
  "Cycle unit days": "Tage",
  "Cycle unit weeks": "Wochen",
  "Cycle unit months": "Monate",
  "Cycle unit years": "Jahre",
  "Contract signing": "Vertragsabschluss",
  "Complete the contract together in a few friendly steps.": "Den Vertrag gemeinsam in wenigen angenehmen Schritten abschließen.",
  "You can create or edit the person in the person record before closing.": "Die Person kann vor dem Abschluss in der Personenakte angelegt oder bearbeitet werden.",
  "The signing experience is still being checked. Please try again in a moment.": "Das Erlebnisformular wird noch geprüft. Bitte versuche es gleich noch einmal.",
  "The signing experience is not configured yet. Configure at least one active offer before opening it.": "Das Erlebnisformular ist noch nicht konfiguriert. Lege zuerst mindestens ein aktives Angebot an, bevor du es öffnest.",
  "Contract signing widgets: configure an active offer before sharing the link": "Lege zuerst mindestens ein aktives Angebot an, bevor du den Link teilst.",
  "Open signing experience": "Erlebnisformular",
  "Included in this offer": "In diesem Angebot enthalten",
  "Included service": "Enthaltene Leistung",
  "Included wallet": "Enthaltenes Guthaben",
  "Contract signing: price summary": "Preisübersicht",
  "Contract signing: price preview unavailable": "Die verbindliche Preisvorschau konnte nicht geladen werden. Bitte Auswahl und Aktionscode prüfen.",
  "Review your contract": "Deine Vertragsübersicht",
  "Experience form": "Erlebnisformular",
  "Installment total": "Gesamtsumme der Raten",
  "Price per billing cycle": "Preis je Zahlungsintervall",
  "Cycle unit contract period": "pro Vertragszeitraum",
  "Promotion benefit": "Aktionsvorteil",
  "Choose an offer": "Angebot auswählen",
  "Choose the experience contract profile": "Erlebnisformular auswählen",
  "Choose the experience contract profile to continue.": "Wähle das Erlebnisformular aus, um fortzufahren.",
  "No offers are currently available.": "Aktuell sind keine Angebote verfügbar.",
  "Check the experience contract configuration and active actions.": "Prüfe die Konfiguration des Erlebnisformulars und die aktiven Aktionen.",
  "The experience contract form could not be loaded. Please try again.": "Das Erlebnisformular konnte nicht geladen werden. Bitte versuche es erneut.",
  "This experience contract profile has no studio that you are allowed to use.": "Für dieses Erlebnisformular ist kein Studio freigegeben, das du verwenden darfst.",
  "Letter integration": "Briefintegration",
  "Contract signing: SEPA mandate confirmed": "SEPA-Lastschriftmandat für diesen Vertrag bestätigt",
  "Component terms (legacy)": "Bausteinlaufzeiten (Bestand)",
  "Legacy sales model uses component terms": "Bestands-Verkaufsmodell verwendet Bausteinlaufzeiten",
  "Choose a regular term before saving this migrated sales model.": "Wähle vor dem Speichern dieses migrierten Verkaufsmodells eine reguläre Laufzeit.",
  "Review legacy migration": "Bestandsmigration prüfen",
  "Legacy sales model migration": "Bestandsmigration der Verkaufsmodelle",
  "Migrate eligible legacy offers": "Eindeutige Bestandsangebote migrieren",
  "Only unambiguous offers will be migrated. Blocked offers remain unchanged.": "Nur eindeutige Angebote werden migriert. Blockierte Angebote bleiben unverändert.",
  "Migrate": "Migrieren",
  "Legacy inventory changed. Review the preview again.": "Der Bestand hat sich geändert. Prüfe die Vorschau erneut.",
  "Eligible legacy offers migrated.": "Eindeutige Bestandsangebote wurden migriert.",
  "Legacy migration preview": "Vorschau der Bestandsmigration",
  "{0} eligible, {1} blocked, {2} legacy offers total": "{0} eindeutig, {1} blockiert, insgesamt {2} Bestandsangebote",
  "Legacy cutover status: eligible": "eindeutig",
  "Legacy cutover status: migrated": "migriert",
  "Legacy cutover status: blocked": "blockiert",
  "Legacy cutover status: alreadyMapped": "bereits zugeordnet",
  "Sales model conflict: partialTargetRelations": "Das Angebot enthält bereits unvollständige Zielmodell-Zuordnungen.",
  "Sales model conflict: legacyPromotionMissing": "Die bisherige Verkaufsaktion des Angebots ist nicht mehr auflösbar.",
  "Conflicts": "Konflikte",
  "No conflicts": "Keine Konflikte",
  "CenterCom access gaps": "Zutrittslücken",
  "CenterCom access gaps empty": "Keine Zutrittslücken erkannt.",
  "CenterCom access gaps affected contracts": "{0} betroffene Verträge",
  "CenterCom access gaps contract template": "Vertragsart",
  "CenterCom access gaps affected": "Verträge",
  "CenterCom access gaps person": "Mitglied",
  "CenterCom access gaps usage right": "Zutrittsrecht",
  "CenterCom access gaps period": "Zeitraum",
  "CenterCom access gaps open end": "offen",
  "CenterCom access gaps decision": "Entscheidung zur Zutrittslücke",
  "CenterCom access gaps action assign": "vorhandenen Vertragsbaustein zuweisen",
  "CenterCom access gaps action create": "Vertragsbaustein anlegen",
  "CenterCom access gaps action leave open": "Lücke offen lassen",
  "CenterCom access gaps no components": "Kein aktiver Vertragsbaustein mit Zutrittsrecht vorhanden - über „Vertragsbaustein anlegen“ einen erzeugen.",
  "CenterCom access gaps component": "Vertragsbaustein mit Zutrittsrecht",
  "CenterCom access gaps create component name": "Name des neuen Vertragsbausteins",
  "Document appearance": "Erscheinungsbild",
  "Contents per column": "Inhalte je Spalte",
  "Font size": "Schriftgröße",
  "Page and typography": "Seite und Schrift",
  "Body font size": "Grundschriftgröße",
  "Small font size": "Schriftgröße Nebenangaben",
  "Small font size tooltip": "Gilt für Fußbereich und Absenderzeile.",
  "Margin top": "Rand oben",
  "Margin bottom": "Rand unten",
  "Margin left": "Rand links",
  "Margin right": "Rand rechts",
  "Address field top": "Anschriftfeld ab Blattoberkante",
  "Address field top tooltip": "Feste Lage, damit das Anschriftfeld nicht mit der Logohöhe wandert und das Sichtfenster des Kuverts trifft. DIN 5008: 45 mm.",
  "Fold marks": "Falzmarken",
  "Fold marks tooltip": "Kurze Striche am linken Rand als Hilfe beim Falzen und Abheften (DIN 5008: 87 mm, 148,5 mm, 192 mm). Wer maschinell kuvertiert, braucht sie nicht.",
  "Document appearance choice tooltip": "Bestimmt Aufbau, Kopf, Fuß und Gestaltung dieses Schreibens. Ohne Auswahl lässt sich der Text bearbeiten, aber nicht versenden.",
  "No document appearance selected": "kein Erscheinungsbild gewählt",
  "Without a document appearance this text set cannot be sent": "Ohne Erscheinungsbild kann diese Vorlage nicht versendet werden.",
  "Letter and email differ": "Brief und E-Mail unterscheiden sich",
  "Split channel content tooltip": "Getrennte Texte: Die E-Mail wird zum Anschreiben, der Brief liegt als PDF bei. Gemeinsamer Text: Eine Änderung gilt für beide Ausgaben.",
  "Letterhead, logo and footer for letters and emails": "Briefkopf, Logo und Fußzeile für Briefe und E-Mails",
  "Format name": "Bezeichnung des Formats",
  "mQorva standard": "mQorva-Standard",
  "Add format": "Format anlegen",
  "Delete format?": "Format löschen?",
  "Delete format hint": "Das Format wird entfernt. Danach greift wieder die nächste Ebene: Studio, dann Mandant, dann der ausgelieferte mQorva-Standard.",
  "Default format": "Standardformat",
  "Default format tooltip": "Greift, wenn nichts anderes gewählt ist — je Geltungsbereich höchstens eines.",
  "Email shell": "Gerüst der E-Mail",
  "Email shell tooltip": "Die Karte ist die geschäftliche Ausgabe; schlicht wirkt wie eine von Hand geschriebene Nachricht. Der Brief bleibt in beiden Fällen ein vollständiger Geschäftsbrief.",
  "Email appearance": "E-Mail-Erscheinungsbild",
  "Branded card": "Karte mit Markenkopf",
  "Plain message": "schlichte Nachricht",
  "Logo position": "Logo-Position",
  "Logo size": "Logo-Größe",
  "Logo size tooltip": "Die Breite folgt dem Seitenverhältnis des Bildes. Über dem Anschriftenfeld sind nach DIN 5008 rund 45 mm Platz; ein größeres Logo ragt ins Sichtfenster des Kuverts.",
  "Fill logo background": "Logo-Hintergrund ausfüllen",
  "Fill logo background tooltip": "Verwendet automatisch die erkennbare Randfarbe des Logos. Ohne Füllung bleibt der Kopfbereich neutral.",
  "Sender line": "Absenderzeile",
  "Footer columns": "Spalten im Fußbereich",
  "Preprinted stationery": "vorgedrucktes Briefpapier",
  "Preprinted stationery tooltip": "Kopf und Fuß entfallen; die Ränder bleiben, damit der Inhalt an derselben Stelle steht.",
  "Email logo position": "Logo-Position in der E-Mail",
  "Centered": "mittig",
  "Letter preview": "Brief-Vorschau",
  "Email preview": "E-Mail-Vorschau",
  "Notice text": "Hinweis",
  "Click a paragraph in the preview to edit it": "auf einen Absatz in der Vorschau klicken, um ihn zu bearbeiten",
  "Empty = shipped default": "leer = ausgelieferter Standard",
  "Check PDF": "PDF prüfen",
  "Footer layout": "Aufbau des Fußbereichs",
  "Number of rows": "Anzahl der Zeilen",
  "Block position": "Position des Blocks",
  "Three columns": "drei Spalten",
  "Two columns": "zwei Spalten",
  "One below another": "untereinander",
  "Show divider line": "Trennlinie anzeigen",
  "Footer placement": "Platzierung des Fußbereichs",
  "Footer outside content": "Fußbereich außerhalb des Inhalts",
  "Outside content": "außerhalb des Inhalts",
  "Inside content": "im Inhaltsbereich",
  "Footer layout tooltip": "Spalten stehen nebeneinander, Zeilen untereinander über die volle Breite.",
  "Footer columns tooltip": "Die Spalten sind gleich breit.",
  "New format": "neues Format",
  "Unnamed format": "ohne Bezeichnung",
  "Format name is required": "Bitte eine Bezeichnung für das Format eingeben.",
  "Add block": "Baustein hinzufügen",
  "Show in document": "im Dokument anzeigen",
  "Address field": "Anschriftenfeld",
  "Contract data": "Vertragsdaten",
  "Footer": "Fußbereich",
  "Fixed text": "fester Text",
  "Fixed text tooltip": "Steht in jedem Dokument dieses Formats — unabhängig vom Vorgang.",
  "Divider": "Trennlinie",
  "Spacing": "Abstand",
  "Height": "Höhe",
  "Blocks": "Bausteine",
  "Redo": "wiederherstellen",
  "Outputs": "Ausgaben",
  "Letter enabled tooltip": "Ohne Brief entsteht kein PDF — der Vorgang geht nur per E-Mail heraus.",
  "Email enabled tooltip": "Ohne E-Mail bleibt es bei reiner Briefpost.",
  "A format needs a letter or an email": "Ein Format braucht mindestens eine Ausgabe: Brief oder E-Mail.",
  "A text set needs a letter or an email": "Die Vorlage muss mindestens für Brief oder E-Mail gelten.",
  "Import texts": "Texte übernehmen",
  "Import proposal hint": "Vorschlag aus der Datei. Er ersetzt Betreff, Anrede, Einleitung, Hinweis und Schluss erst, wenn Sie übernehmen — gespeichert wird auch dann noch nichts.",
  "SystemDocumentImportUnsupportedFile": "Diese Dateiart wird nicht gelesen. Möglich sind Word-Dateien (.docx) und reiner Text (.txt, .md).",
  "SystemDocumentImportTruncated": "Die Datei hat mehr Absätze als ein Anschreiben; die überzähligen wurden weggelassen.",
  "SystemDocumentImportNoStructure": "Weder Anrede noch Grußformel erkannt — alles liegt in der Einleitung.",
  "SystemDocumentImportTablesDropped": "Tabellen wurden nicht übernommen. Die Vertragsdaten entstehen aus dem Vorgang.",
  "Reorder": "verschieben",
  "Closing formula": "Grußformel",
  "Logos": "Logos",
  "Letter logo": "Logo für Briefe",
  "Standard logo": "Standardlogo",
  "Studio image": "Studiobild",
  "Format channel tooltip": "Für welche Ausgaben dieses Erscheinungsbild gilt. Für jeden gewählten Typ steht im Editor eine eigene Gestaltungsfläche bereit.",
  "System text channel tooltip": "Bestimmt, ob diese Vorlage als Brief, als E-Mail oder in beiden Ausgaben verwendet werden kann.",
  "Visible in document": "im Dokument sichtbar",
  "Hidden in document": "im Dokument ausgeblendet",
  "Company legal name": "Firmenname",
  "Address in one line": "Anschrift einzeilig",
  "Designation of the representatives": "Bezeichnung der Vertretung",
  "Register court": "Registergericht",
  "Register number": "Registernummer",
  "Register court and number": "Registergericht und -nummer",
  "Footer text": "Text des Fußbereichs",
  "Differs from the appearance": "weicht vom Erscheinungsbild ab",
  "Reset this block": "diesen Baustein auf Vorgabe",
  "Reset all blocks": "alle auf Vorgabe",
  "Date line": "Ort und Datum",
  "Text": "Text",
  "Merge letter and email": "Brief und E-Mail zusammenlegen",
  "Merge letter and email hint": "Danach gibt es nur noch einen Text für beide Ausgaben. Welche Fassung soll bleiben? Die andere wird gelöscht.",
  "Keep the letter version": "Brief-Fassung behalten",
  "Keep the email version": "E-Mail-Fassung behalten",
  "Write text": "Text schreiben…",
  "Block name": "Name des Bausteins",
  "Block name tooltip": "Textvorlagen verweisen über diesen Namen auf den Baustein. Wird er geändert, zeigen bestehende Verweise ins Leere.",
  "Block name must be unique": "Dieser Name ist im Dokument schon vergeben.",
  "Block": "Baustein",
  "Remove block?": "Baustein entfernen?",
  "No block selected": "kein Baustein gewählt",
  "Footer order": "Reihenfolge im Fußbereich",
  "Contents per row": "Inhalte pro Zeile",
  "Studio address": "Studioadresse",
  "Studio phone": "Studiotelefon",
  "Studio email": "Studio-E-Mail",
  "Studio website": "Studio-Website",
  "Company address": "Firmenadresse",
  "Company phone": "Firmentelefon",
  "Company email": "Firmen-E-Mail",
  "Company website": "Firmen-Website",
  "Legal representatives": "Vertretungsberechtigte",
  "Commercial register": "Handelsregister",
  "Separator character": "Trennzeichen",
  "Separator color": "Farbe des Trennzeichens",
  "Separator formatting": "Format des Trennzeichens",
  "Placed": "platziert",
  "Full width": "volle Breite",
  "Sender placement": "Lage der Absenderzeile",
  "Above the address field": "über dem Anschriftenfeld",
  "Top right": "rechts oben",
  "Sender placement hint": "Über dem Anschriftenfeld ist die Lage nach DIN 5008 — klein und unterstrichen, direkt über dem Sichtfenster.",
  "Spacing above": "Abstand darüber",
  "Distance from sheet edge": "Abstand vom Blattrand",
  "Spacing below": "Abstand darunter",
  "Standard": "Standard",
  "Subject label": "Beschriftung der Betreffzeile",
  "Subject only": "nur der Betreff",
  "With label": "mit „Betreff:“",
  "Subject label hint": "Gilt nur für den Brief. In der E-Mail ist der Betreff die Betreffzeile und steht nicht im Text.",
  "Data source": "Datenquelle",
  "Legal details": "Rechtliche Angaben",
  "Legal details tab": "rechtliche Angaben",
  "Legal form": "Rechtsform",
  "Registered office": "Sitz der Gesellschaft",
  "Supervisory board chair": "Vorsitz des Aufsichtsrats",
  "Appointment series": "Serientermine",
  "Allow appointment series for staff": "Serientermine für Mitarbeiter erlauben",
  "Allow appointment series online": "Serientermine für Online-Buchungen erlauben",
  "Applies to the booking widget and member app.": "Gilt für das Buchungswidget und die Mitglieder-App.",
  "Staff and online": "Mitarbeiter und online",
  "Staff only": "nur Mitarbeiter",
  "Online only": "nur online",
  "No appointment series": "keine Serientermine",
  "Single appointment": "einzelner Termin",
  "Recurring appointment series": "Terminserie",
  "Recurrence pattern": "Wiederholung",
  "Daily": "täglich",
  "Monthly on the same calendar day": "monatlich am gleichen Kalendertag",
  "Interval in days": "Intervall in Tagen",
  "Interval in weeks": "Intervall in Wochen",
  "Interval in months": "Intervall in Monaten",
  "Monday short": "Mo",
  "Tuesday short": "Di",
  "Wednesday short": "Mi",
  "Thursday short": "Do",
  "Friday short": "Fr",
  "Saturday short": "Sa",
  "Sunday short": "So",
  "Select at least one weekday.": "Wähle mindestens einen Wochentag aus.",
  "Months without this calendar day are skipped.": "Monate ohne diesen Kalendertag werden übersprungen.",
  "Series ends": "Serienende",
  "After number of appointments": "nach Anzahl",
  "On date": "bis Datum",
  "Number of appointments": "Anzahl der Termine",
  "End date": "Enddatum",
  "Check appointment series": "Terminserie prüfen",
  "All {0} appointments are available.": "Alle {0} Termine sind verfügbar.",
  "{0} of {1} appointments are available.": "{0} von {1} Terminen sind verfügbar.",
  "Show appointments": "Termine anzeigen",
  "Only this appointment": "nur diesen Termin",
  "This and all following appointments": "diesen und alle folgenden Termine",
  "Entire appointment series": "gesamte Serie",
  "Select affected appointments": "Betroffene Termine auswählen",
  "The appointment series must be checked before saving.": "Die Terminserie muss vor dem Speichern geprüft werden.",
  "Resolve all appointment series conflicts before saving.": "Lösen Sie alle Konflikte der Terminserie vor dem Speichern.",
  "The appointment series could not be checked.": "Die Terminserie konnte nicht geprüft werden.",
  "Appointment series has conflicts": "Terminserie hat Konflikte",
  "Only available appointments will be created. Conflicting occurrences remain excluded from the series.": "Nur verfügbare Termine werden angelegt. Konflikte bleiben als Ausschlüsse in der Serie erhalten.",
  "Book available appointments": "verfügbare Termine buchen",
  "The appointment series is not fully available. Change its start, recurrence or end.": "Die Terminserie ist in dieser Zusammenstellung nicht vollständig verfügbar. Ändere Beginn, Wiederholung oder Ende.",
  "Appointment series created.": "Terminserie erstellt.",
  "Appointment series booked successfully": "Terminserie erfolgreich gebucht",
  "{0} appointments": "{0} Termine",
  "Every {0} days": "alle {0} Tage",
  "Every {0} weeks": "alle {0} Wochen",
  "Every {0} months": "alle {0} Monate",
  "Price per appointment": "Preis je Termin",
  "Series appointment": "Serientermin",
  "Series appointments can only be moved within the same calendar.": "Serientermine können nur innerhalb desselben Kalenders verschoben werden.",
  "The duration of a series appointment cannot be changed here.": "Die Dauer eines Serientermins kann hier nicht geändert werden.",
  "This change is not supported for appointment series.": "Diese Änderung wird für Serientermine nicht unterstützt.",
  "Page number": "Seitenangabe",
  "Page number text": "Wortlaut der Seitenangabe",
  "Page number text tooltip": "steht unten rechts auf jeder Seite. Leer bedeutet den Standardsatz.",
  "Current page": "aktuelle Seite",
  "Total pages": "Seiten insgesamt",
  "Every page": "jede Seite",
  "From page 2": "ab Seite 2",
  "Pages": "Seiten",
  "All pages": "alle Seiten",
  "First page": "erste Seite",
  "Following pages": "Folgeseiten",
  "Format settings": "Formateinstellungen",
  "Page and format settings": "Seiten- und Formateinstellungen",
  "Email format and styling": "E-Mail-Format und Gestaltung",
  "Paragraph spacing": "Absatzabstand",
  "Paragraph spacing tooltip": "Abstand unter den Absätzen des Textes.",
  "Document elements": "Dokumentelemente",
  "Custom elements": "Eigene Elemente",
  "Block already added": "Baustein bereits im Dokument",
  "Drag into document or click to add": "Ins Dokument ziehen oder klicken zum Hinzufügen",
  "Standard (6 pt)": "Standard (6 pt)",
  "Standard (1,35)": "Standard (1,35)",
  "Standard (10 pt)": "Standard (10 pt)",
  "Standard (12 pt)": "Standard (12 pt)",
  "Standard (1,6)": "Standard (1,6)",
  "Standard (14 px)": "Standard (14 px)",
  "System document subject tooltip": "Betreffzeile der E-Mail. Im Brief steht der Betreff als Baustein im Blatt und wird dort geschrieben.",
  "Reset content to template": "Inhalt auf Vorlage zurücksetzen",
  "Reset content to template confirmation": "Alle Textänderungen und ausgeblendeten Bausteine dieser Vorlage gehen verloren.",
  "A text set needs a title": "Eine Vorlage braucht einen Titel",
  "A text set needs a document appearance": "Eine Vorlage braucht ein Erscheinungsbild",
  "Duplicate text set": "Vorlage duplizieren",
  "Letter and email templates": "Brief- und E-Mail-Vorlagen",
  "Letter and email template": "Brief- und E-Mail-Vorlage",
  "Reusable letters and emails for recurring workflows": "Wiederverwendbare Briefe und E-Mails für wiederkehrende Abläufe",
  "WhatsApp templates": "WhatsApp-Vorlagen",
  "Local assignments to approved Meta templates": "Lokale Zuordnungen zu freigegebenen Meta-Vorlagen",
  "SMS templates": "SMS-Vorlagen",
  "Plain-text messages for notifications and workflows": "Textnachrichten für Benachrichtigungen und Abläufe",
  "The contract document is generated from the saved contract data.": "Das Vertragsdokument wird aus den gespeicherten Vertragsdaten erzeugt.",
  "The contract will be created without a signature.": "Der Vertrag wird ohne Unterschrift angelegt.",
  "Payment reminder": "Mahnung",
  "Free message": "Freie Nachricht",
  "Message text": "Nachrichtentext",
  "Delete SMS template?": "SMS-Vorlage löschen?",
  "Delete SMS template hint": "Die SMS-Vorlage wird dauerhaft gelöscht.",
  "Add SMS template": "SMS-Vorlage hinzufügen",
  "Edit SMS template": "SMS-Vorlage bearbeiten",
  "Message text is required": "Ein Nachrichtentext ist erforderlich",
  "1 character": "1 Zeichen",
  "1 SMS segment": "1 SMS-Segment",
  "{0} SMS segments": "{0} SMS-Segmente",
  "Approved Meta template": "freigegebene Meta-Vorlage",
  "Meta template is required": "Eine Meta-Vorlage ist erforderlich",
  "Select Meta template": "Meta-Vorlage auswählen",
  "Remove binding": "Zuordnung entfernen",
  "Selected Meta template is no longer available": "Die gewählte Meta-Vorlage ist nicht mehr verfügbar",
  "Provider bindings": "Provider-Zuordnungen",
  "Meta approval required": "Meta-Freigabe erforderlich",
  "Delete WhatsApp template?": "WhatsApp-Vorlage löschen?",
  "Delete WhatsApp template hint": "Die WhatsApp-Vorlage und ihre Provider-Zuordnungen werden dauerhaft gelöscht.",
  "Add WhatsApp template": "neue WhatsApp-Vorlage",
  "Edit WhatsApp template": "WhatsApp-Vorlage",
  "WhatsApp appearance": "WhatsApp-Erscheinungsbild",
  "No appearance": "kein Erscheinungsbild",
  "Parameter mapping": "Parameterzuordnung",
  "Select variables in provider order": "Variablen in der Reihenfolge der Provider-Platzhalter auswählen",
  "At least one provider binding is required": "Mindestens eine Provider-Zuordnung ist erforderlich",
  "Add provider binding": "Provider-Zuordnung hinzufügen",
  "An appearance needs at least one output type": "Ein Erscheinungsbild braucht mindestens eine Ausgabeart",
  "WhatsApp profile": "WhatsApp-Profil",
  "Header type": "Kopfart",
  "Header type is required": "Eine Kopfart ist erforderlich",
  "No header": "kein Kopf",
  "Text header": "Textkopf",
  "Image header": "Bildkopf",
  "Video header": "Videokopf",
  "Document header": "Dokumentkopf",
  "Header text": "Kopftext",
  "Header text is required": "Ein Kopftext ist erforderlich",
  "WhatsApp buttons": "WhatsApp-Schaltflächen",
  "Button type": "Schaltflächentyp",
  "Button type is required": "Ein Schaltflächentyp ist erforderlich",
  "Quick view": "Kurzansicht",
  "Quick reply": "Schnellantwort",
  "Button label is required": "Eine Beschriftung ist erforderlich",
  "Target URL": "Ziel-URL",
  "Phone number": "Telefonnummer",
  "Button target is required": "Ein Ziel ist erforderlich",
  "Add WhatsApp button": "WhatsApp-Schaltfläche hinzufügen",
  "Message variable availability hint": "Personen- und Studioangaben gelten allgemein. Terminangaben werden nur in Terminbestätigungen und -erinnerungen aufgelöst.",
  "Provider parameter {0}": "Provider-Parameter {0}",
  "A variable is required": "Eine Variable ist erforderlich",
  "Select variable": "Variable auswählen",
  "Remove parameter": "Parameter entfernen",
  "Add parameter": "Parameter hinzufügen",
  "Template length": "Vorlagenlänge",
  "SMS segment count runtime hint": "Die tatsächliche Zeichenkodierung und Anzahl der SMS-Segmente stehen erst nach dem Auflösen der Variablen beim Versand fest.",
  "WhatsApp message preview": "Hier steht später der Nachrichtentext der verknüpften WhatsApp-Vorlage.",
  "WhatsApp media header preview": "{0} als Medienkopf",
  "WhatsApp button preview": "WhatsApp-Schaltfläche",
  "WhatsApp appearance reapproval hint": "Die Meta-Vorlage mit dem aktuellen Erscheinungsbild erneut einreichen und nach der Freigabe synchronisieren.",
  "Configure categories": "Kategorien konfigurieren",
  "No category": "keine Kategorie",
  "System document category tooltip": "Die Kategorie grenzt die angebotenen Variablen ein. Ohne Kategorie stehen alle Variablen zur Auswahl.",
  "Send document subject tooltip": "Betreff dieser Sendung. Leer lassen hei\u00dft: der gepflegte Betreff der Vorlage samt seiner Variablen.",
  "As maintained": "wie gepflegt",
  "Send document title tooltip": "Unter diesem Titel liegt das Schreiben in der digitalen Akte. Ohne Angabe gilt der Betreff.",
  "Send document appearance tooltip": "Briefpapier f\u00fcr dieses eine Schreiben. Die Vorlage bleibt unver\u00e4ndert.",
  "Send document appearance permission missing": "Das Erscheinungsbild dieser Sendung darf nur \u00e4ndern, wer das Recht dazu hat.",
  "Choose document appearance when sending": "Erscheinungsbild beim Versand w\u00e4hlen",
  "Choose document appearance when sending help": "Erlaubt, f\u00fcr ein einzelnes Schreiben ein anderes Briefpapier zu w\u00e4hlen. Die Vorlage bleibt unver\u00e4ndert.",
  "Review before sending": "vor dem Versand ansehen",
  "Confirmation not sent": "Bestätigung nicht versendet",
  "Rest period saved without confirmation hint": "Die Ruhezeit ist gespeichert. Es wurde kein Schreiben versendet.",
  "Contract cancelled without confirmation hint": "Die Kündigung ist gespeichert. Es wurde kein Schreiben versendet.",
  "Confirmation sent.": "Bestätigung versendet.",
  "Dispatch details": "Details zur Sendung",
  "Created by": "erstellt von",
  "Approved at": "freigegeben am",
  "Queued at": "eingereiht am",
  "Cancelled at": "abgebrochen am",
  "External message id": "Kennung beim Anbieter",
  "Reject": "ablehnen",
  "Working time permission help": "Zeitmeldungen sehen und bearbeiten",
  "Approve working time": "Zeitmeldungen freigeben",
  "Approve working time help": "Meldungen freigeben oder korrigieren und freigeben sowie den Monat abschließen",
  "Without time tracking the plan alone counts, as before.": "Ohne Zeiterfassung gilt allein der Plan, wie bisher.",
  "Automatic break": "Pausenvorgabe",
  "Deduct break automatically": "Pause automatisch abziehen",
  "Applies when no break was reported.": "gilt, solange keine Pause gemeldet wurde",
  "The highest exceeded step applies. German law asks for 30 minutes above six hours and 45 above nine; other countries and collective agreements differ.": "Es gilt die höchste überschrittene Stufe. In Deutschland sind 30 Minuten ab mehr als sechs Stunden und 45 ab mehr als neun vorgeschrieben; andere Länder und Tarifverträge weichen davon ab.",
  "Read only": "nur lesend",
  "Adjust hour balance": "Stundenkonto",
  "Please enter hours": "Bitte Stunden eingeben",
  "Pay out hours from the hour balance": "Stunden vom Konto abrechnen",
  "Take hours from the balance into this month.": "vom Konto in diesen Monat übernehmen",
  "Add hours to the hour balance": "Stunden aufs Konto legen",
  "Credit extra hours without paying them out.": "zusätzlich gutschreiben, ohne sie auszuzahlen",
  "Hours the employee already has before the first payroll month.": "Stunden, die der Mitarbeiter vor dem ersten Abrechnungsmonat schon hat. Ohne Angabe gilt 0.",
  "Hours to pay out": "auszuzahlende Stunden",
  "Hours to add to the hour balance": "gutzuschreibende Stunden",
  "Plus and minus hours stay on the hour balance when you close the month.": "Plus- und Minusstunden bleiben mit dem Monatsabschluss auf dem Konto.",
  "This booking": "diese Buchung",
  "Keep extra hours on the hour balance.": "Plusstunden bleiben auf dem Stundenkonto.",
  "Hand extra hours to payroll this month.": "Plusstunden gehen in diesem Monat an die Abrechnung.",
  "Pay extra hours only while monthly pay stays within the mini-job limit.": "Plusstunden nur auszahlen, solange das Monatsentgelt unter der Geringfügigkeitsgrenze bleibt.",
  "Overtime on monthly salary": "Überstunden bei Gehalt",
  "Overtime on hourly wage": "Überstunden bei Stundenlohn",
  "Overtime this month": "Überstunden in diesem Monat",
  "Use the default overtime rule": "Vorgabe übernehmen",
  "Uses the HR setting for salary or hourly wage.": "es gilt die Vorgabe aus dem Personalwesen für Gehalt oder Stundenlohn",
  "Not tracked": "nicht geführt",
  "Time grid, working days, time tracking & shared week plan links": "Zeitraster, Arbeitstage, Zeiterfassung & geteilte Wochenplan-Links",
  "Time grid, working days and booking fallback": "Zeitraster, Arbeitstage und Buchung gegen den Standardplan",
  "Working time recording, daily confirmation and break rules": "Arbeitszeit erfassen, Tagesbestätigung und Pausenvorgabe",
  "Vacation, payroll and minimum wage": "Urlaub, Abrechnung und Mindestlohn",
  "Public links for the shared week plan": "öffentliche Links für den geteilten Wochenplan",
  "Hour balance": "Stundenkonto",
  "Daily confirmation": "Tagesbestätigung",
  "Require daily confirmation in the employee app": "Tagesbestätigung in m1app verlangen",
  "(required for online login)": "(erforderlich für Online-Login)",
  "(required for online login and m1app)": "(erforderlich für Online-Login und m1app)",
  "Sign-in options": "Zugang",
  "Studio role": "Rolle im Studio",
  "Place of birth": "Geburtsort",
  "Nationality": "Staatsangehörigkeit",
  "Time tracking and HR": "Zeiterfassung und Personalwesen",
  "Working time recording, HR and overtime defaults": "Arbeitszeit, Personalwesen, Überstunden und Pausenvorgabe",
  "StaffHrDisabled": "Personalwesen ist ausgeschaltet.",
  "StaffIsStaffRequiresScheduling": "Mitarbeiter führen setzt das Modul Personalplanung voraus.",
  "Channel not configured": "Kanal nicht konfiguriert",
  "No integration is configured for this channel. Configure one under Settings › Integrations or remove the channel.": "Für diesen Kanal ist keine Schnittstelle konfiguriert. Unter Einstellungen › Schnittstellen einrichten oder den Kanal entfernen.",
  "Contact outcome": "Ergebnis des Kontakts",
  "Contact result none": "kein Ergebnis",
  "Contact result appointment booked": "Termin gebucht",
  "Contact result training agreed": "Training vereinbart",
  "Contact result retained": "gehalten",
  "Contact result declined": "abgelehnt",
  "Contact result follow-up": "Wiedervorlage",
  "Contact channel in person": "persönlich",
  "Contact blocked calls notice": "Die Person möchte nicht angerufen werden. Ein ausgehender Anruf wird nicht gespeichert — eingehende Anrufe und Gespräche im Studio sind erlaubt.",
  "Contact blocked messages notice": "Die Person möchte keine Nachrichten erhalten. Nachrichten aus eigenem Antrieb werden nicht gespeichert — Antworten auf eingehende Nachrichten sind erlaubt.",
  "Contact direction": "Richtung",
  "Contact direction outbound call": "wir haben angerufen",
  "Contact direction inbound call": "Person hat angerufen",
  "Contact direction outbound": "ausgehend",
  "Contact direction inbound": "eingehend",
  "Contact automated": "automatisch",
  "Log in-person contact": "Gespräch im Studio",
  "Member care": "Betreuung",
  "New member care case": "Vorgang anlegen",
  "Member care cases": "Betreuungsvorgänge",
  "Member care permission help": "Betreuungsvorgänge für bestehende Mitglieder sehen und bearbeiten.",
  "Delete member care cases": "Betreuungsvorgänge löschen",
  "Delete member care cases help": "erlaubt das Löschen von Betreuungsvorgängen samt Historie.",
  "Member care pipelines settings": "Betreuungspipelines",
  "Member care pipelines settings permission help": "Pipelines und Phasen der Mitgliederbetreuung verwalten.",
  "Member care reports": "Auswertungen Mitgliederbetreuung",
  "Member care reports permission help": "Tagesproduktion und Betreuungskennzahlen einsehen.",
  "Member care settings": "Mitgliederbetreuung",
  "Back to member care settings": "zurück zur Mitgliederbetreuung",
  "Member care pipelines description": "Pipelines und Phasen für Onboarding, Geburtstag, Reaktivierung, Rückgewinnung",
  "Member care reopen after days": "Mindestabstand in Tagen",
  "Member care reopen after days help": "So viele Tage nach dem Abschluss eines Vorgangs entsteht für dieselbe Person kein neuer Vorgang in dieser Pipeline.",
  "Phase transition requires reached": "nur wenn erreicht",
  "Please select a member": "bitte ein Mitglied wählen",
  "Search member": "Mitglied suchen …",
  "Type at least 2 characters": "mindestens 2 Zeichen eingeben",
  "Please select a pipeline": "bitte eine Pipeline wählen",
  "Select pipeline": "Pipeline wählen",
  "Capability member care": "Mitgliederbetreuung",
  "ContactBlockedCalls": "Die Person möchte nicht angerufen werden. Der ausgehende Anruf wurde nicht gespeichert.",
  "ContactBlockedMessages": "Die Person möchte keine Nachrichten erhalten. Die Nachricht wurde nicht versendet.",
  "LeadContactChannelRequired": "Kanal und Richtung des Kontakts fehlen.",
  "LeadContactAppointmentNotFound": "Der verknüpfte Termin wurde nicht gefunden.",
  "ReceptionContactStudioRequired": "Das Studio am Tresen fehlt oder ist diesem Konto nicht zugeordnet.",
  "ReceptionContactKindRequired": "Bitte hereinkommenden Besucher oder eingehenden Anruf wählen.",
  "ReceptionContactPersonRequired": "Für den Kontakt oder den Termin braucht es eine Person — suchen oder Vor- und Nachname eingeben.",
  "ReceptionContactAppointmentAlreadySet": "Dieser Empfangskontakt hat bereits einen Termin.",
  "ReceptionContactLeadDefaultsInvalid": "Der Lead lässt sich nicht anlegen, weil Pipeline oder Phase nicht eindeutig sind.",
  "MemberCarePipelineInvalid": "Die gewählte Pipeline ist keine aktive Betreuungspipeline oder hat noch keine Phase.",
  "MemberCarePersonNotMember": "Betreuungsvorgänge gibt es nur für Mitglieder.",
  "MemberCareOpenCaseExists": "In dieser Pipeline läuft für die Person bereits ein offener Vorgang.",
  "MemberCareEpisodeAlreadyHandled": "Dieser Anlass wurde für die Person bereits bearbeitet.",
  "MemberCareWithinReopenInterval": "Der letzte Vorgang dieser Pipeline wurde erst vor Kurzem abgeschlossen — der Mindestabstand der Pipeline ist noch nicht verstrichen.",
  "RegistrationInvalid": "Bitte alle Angaben vollständig ausfüllen.",
  "RegistrationPasswordWeak": "Das Passwort braucht mindestens 8 Zeichen mit Groß- und Kleinbuchstaben, Ziffer und Sonderzeichen.",
  "RegistrationRateLimited": "Zu viele Registrierungsversuche. Bitte später erneut versuchen.",
  "RegistrationDisabled": "Die Registrierung ist derzeit nicht möglich.",
  "RegistrationLimitReached": "Derzeit sind keine weiteren Registrierungen möglich.",
  "RegistrationConflict": "Für diese E-Mail-Adresse gibt es bereits ein Konto oder eine offene Registrierung.",
  "RegistrationEmailNotConfigured": "Die Registrierung ist systemseitig noch nicht eingerichtet (kein Versandpostfach).",
  "RegistrationEmailNotSent": "Die Bestätigungs-E-Mail konnte nicht zugestellt werden. Bitte erneut versuchen.",
  "Without a template tenant, a new tenant starts empty.": "Ohne Mustermandant startet ein neuer Mandant leer.",
  "RegistrationProvisioningFailed": "Das Konto konnte systemseitig nicht angelegt werden. Der Betreiber ist informiert.",
  "InvalidEmailConfirmationToken": "Der Bestätigungslink ist ungültig oder abgelaufen.",
  "Self-registration": "Selbstregistrierung",
  "Maximum self-registered tenants": "Höchstzahl selbst registrierter Mandanten",
  "Template tenant": "Mustermandant",
  "Self-registered tenants": "selbst registrierte Mandanten",
  "Phase entry action": "beim Eintritt in die Phase",
  "Phase entry action what": "automatische Aktion",
  "Phase entry action help": "Läuft für jeden Vorgang, der ab jetzt in diese Phase kommt — der Bestand bleibt unberührt.",
  "Phase entry action none": "keine",
  "Phase entry action send email": "E-Mail senden",
  "Phase entry action send sms": "SMS senden",
  "Phase entry action send whatsapp": "WhatsApp senden",
  "Phase entry action create follow-up": "Wiedervorlage für Mitarbeiter anlegen",
  "Phase entry fallback follow-up": "bei Kontaktsperre Wiedervorlage „persönlich ansprechen“ anlegen",
  "Phase entry fallback follow-up help": "Ohne diese Option wird die Nachricht bei Nachrichtensperre übersprungen und die Kette läuft weiter.",
  "SMS template": "SMS-Vorlage",
  "WhatsApp template": "WhatsApp-Vorlage",
  "Follow-up title": "Titel der Wiedervorlage",
  "Follow-up title placeholder": "z. B. anrufen",
  "Follow-up due after days": "fällig nach Tagen",
  "Follow-up due after days help": "0 = sofort fällig. Gezählt ab dem Eintritt in die Phase.",
  "Phase transition trigger dwell elapsed": "nach Verweildauer in der Phase",
  "Phase transition dwell days": "Verweildauer in Tagen",
  "Phase transition only without contact": "nur ohne erreichten Kontakt seit Eintritt",
  "Create member care case": "Betreuungsvorgang anlegen",
  "Member care pipeline": "Betreuungspipeline",
  "Member care pipeline automation help": "Der Vorgang entsteht in dieser Pipeline — je Person und Anlass nur einmal, mit dem Mindestabstand der Pipeline.",
  "No member care pipelines yet": "noch keine Betreuungspipeline angelegt",
  "Automation scenario contract cancelled": "Kündigung eingegangen",
  "Cancellations of the last days": "Kündigungen der letzten Tage",
  "No open member care cases": "kein offener Betreuungsvorgang",
  "Case since {0}": "Vorgang seit {0}",
  "Closed member care cases: {0}": "abgeschlossen: {0}",
  "last {0} on {1}": "zuletzt {0} am {1}",
  "Member care lost": "verloren",
  "Open member care cases": "offene Betreuungsvorgänge",
  "Member care follow-ups due": "Betreuung fällig",
  "Daily production": "Tagesproduktion",
  "Daily production description": "Anrufe, Probetrainings, Besucher und Betreuungsgespräche je Tag",
  "All employees": "alle Mitarbeiter",
  "DPR inbound calls": "eingehende Anrufe",
  "DPR outbound call attempts": "Anwahlversuche",
  "DPR outbound calls reached": "ausgehend erreicht",
  "DPR trials booked from inbound": "PTs aus eingehenden Anrufen",
  "DPR trials booked from outbound": "PTs aus ausgehenden Anrufen",
  "DPR trials scheduled": "PTs im Terminbuch",
  "DPR trials held": "PTs stattgefunden",
  "DPR trials closed": "PTs abgeschlossen",
  "DPR walk-ins": "Besucher",
  "DPR walk-ins booked": "Besucher gebucht",
  "DPR walk-ins closed": "Besucher abgeschlossen",
  "DPR birthday calls": "Geburtstagsanrufe",
  "DPR win-back calls reached": "Kündigungsanrufe erreicht",
  "DPR win-back talks in studio": "Kündigungsgespräche im Studio",
  "DPR win-back retained": "gedrehte Kündigungen",
  "DPR reactivation call attempts": "Motivationsanrufe Anwahl",
  "DPR reactivation calls reached": "Motivationsanrufe erreicht",
  "DPR reactivation trainings agreed": "Motivations-Trainings vereinbart",
  "DPR automated messages": "automatische Anschreiben",
  "DPR booking rate inbound": "Buchungsquote eingehend",
  "DPR reach rate outbound": "Erreichbarkeitsquote ausgehend",
  "DPR booking rate outbound": "Buchungsquote ausgehend",
  "DPR show rate trials": "Erscheinungsquote PTs",
  "DPR close rate trials": "Verkaufsquote PTs",
  "DPR close rate walk-ins": "Verkaufsquote Besucher",
  "DPR win-back rate": "Quote gedrehte Kündigungen",
  "DPR reactivation success": "Erfolgsquote Motivationsanrufe",
  "DPR reactivation open cases": "Motivationsliste (offen)",
  "Pipeline report role": "Rolle in der Tagesproduktion",
  "Pipeline report role help": "Die Tagesproduktion ordnet Geburtstags-, Motivations- und Kündigungsgespräche über diese Rolle zu — nicht über den Namen.",
  "Pipeline report role none": "keine",
  "Pipeline report role onboarding": "Onboarding",
  "Pipeline report role birthday": "Geburtstag",
  "Pipeline report role reactivation": "Reaktivierung (Motivationsliste)",
  "Pipeline report role win-back": "Rückgewinnung (Kündigung)",
  "Pipeline report role renewal": "Verlängerung",
  "Pipeline report role reentry": "Wiedereinstieg",
  "Locations & Branches": "Standorte & Filialen",
  "Members, Finance & Access": "Mitglieder, Finanzen & Zutritt",
  "Studio Operations & App": "Studio-Betrieb & App",
  "Staff & Sales": "Mitarbeiter & Vertrieb",
  "AI & Support": "KI-Unterstützung & Support",
  "To report": "zur Auswertung",
  "App requests": "App-Anliegen",
  "Rest period from": "Ruhezeit von",
  "Rest period until": "Ruhezeit bis",
  "Days remaining": "verbleibende Tage",
  "Rest period ends within 30 days": "Ruhezeit endet in 30 Tagen",
  "Contract ends": "Vertragsenden",
  "Contract ends by month": "Vertragsenden je Monat",
  "Remaining term in days": "Restlaufzeit in Tagen",
  "Wallet type": "Art",
  "Wallet type value": "Guthaben",
  "Wallet type points": "Punkte",
  "Last transaction": "letzte Buchung",
  "Balance total": "Guthaben gesamt",
  "Average balance": "Ø Guthaben",
  "Contracts with a rest period running today": "Verträge mit heute laufender Ruhezeit",
  "Cancelled contracts that have not ended yet": "gekündigte Verträge, die noch nicht abgelaufen sind",
  "Active wallets and their balances": "aktive Wertekonten und ihre Guthaben",
  "Fee exempt": "kostenfrei",
  "E_TenantDeletionSubscriptionActive": "Der Tarif läuft noch. Nach der Kündigung kann die Löschung beantragt werden.",
  "E_TenantDeletionAlreadyRequested": "Die Löschung ist bereits beantragt.",
  "E_TenantDeletionConfirmationMismatch": "Der Name stimmt nicht mit dem Mandantennamen überein.",
  "E_TenantDeletionPasswordInvalid": "Das Passwort ist nicht korrekt.",
  "E_TenantDeletionNotRevocable": "Es gibt keinen widerrufbaren Löschantrag.",
  "E_TenantDeletionFailed": "Der Mandant konnte nicht gelöscht werden. Der Vorgang ist protokolliert.",
  "Type {name} to confirm": "zur Bestätigung „{name}“ eingeben",
  "The name does not match.": "Der Name stimmt nicht überein.",
  "Your password": "eigenes Passwort",
  "Deletion requested": "Löschung beantragt",
  "Tenant will be deleted on {date}": "Deine Daten werden am {date} endgültig gelöscht.",
  "All data and documents will then be permanently deleted.": "Dann werden alle Daten und Dokumente endgültig gelöscht.",
  "The tenant is being deleted.": "Deine Daten werden gelöscht.",
  "Deletion revoke": "Löschung zurücknehmen",
  "Deleting the tenant permanently removes all studios, members, contracts, payments, documents, users and settings.": "Die Löschung des Mandanten entfernt endgültig alle Studios, Mitglieder, Verträge, Zahlungen, Dokumente, Benutzer und Einstellungen.",
  "Your data will be permanently deleted {days} days after your request. Until then, you can cancel the deletion here yourself.": "Deine Daten werden {days} Tage nach deinem Antrag endgültig gelöscht. Bis dahin kannst du die Löschung hier selbst zurücknehmen.",
  "Until then, you can cancel the deletion here yourself.": "Bis dahin kannst du die Löschung hier selbst zurücknehmen.",
  "Requested by {name}. Until then, any company administrator can revoke the request.": "Beantragt von {name}. Bis dahin kann jeder Firmenadministrator den Antrag widerrufen.",
  "Only company administrators can request the deletion.": "Nur Firmenadministratoren können die Löschung beantragen.",
  "The deletion takes place {days} days after the request and can be revoked until then.": "Die Löschung erfolgt {days} Tage nach dem Antrag und kann bis dahin widerrufen werden.",
  "Enter the tenant name and your password to request the deletion.": "Gib zur Beantragung den Mandantennamen und dein Passwort ein.",
  "Request deletion": "Löschung beantragen",
  "Request the deletion of all data after the plan has ended": "Löschung aller Daten nach Tarifende beantragen",
  "All data and documents of the tenant will be permanently deleted immediately. Our invoices to the tenant remain.": "Alle Daten und Dokumente des Mandanten werden sofort endgültig gelöscht. Unsere Rechnungen an den Mandanten bleiben erhalten.",
  "E_StudioOperationLocked": "Dieser Standort ist im Tarif gesperrt. Betrieb und Änderungen an seinen Mitgliedern und Verträgen sind erst nach einer Erhöhung der Standortanzahl wieder möglich.",
  "E_StudioLockSelectionInvalid": "Bitte genau so viele Standorte zur Sperre wählen, wie wegfallen.",
  "Plan lock": "Tarifsperre",
  "locked from {date}": "gesperrt ab {date}",
  "Unlock location": "Standort freischalten",
  "Unlock location?": "Standort freischalten?",
  "Location unlocked": "Standort freigeschaltet",
  "The location becomes operational again and occupies one of the booked locations.": "Der Standort ist dann wieder in Betrieb und belegt einen der gebuchten Standorte.",
  "Locked in plan: {names}": "Im Tarif gesperrt: {names}",
  "No check-in, no payments, no new contracts and no changes to members and contracts of these locations. Data remains readable.": "Kein Check-in, keine Zahlungen, keine neuen Verträge und keine Änderungen an Mitgliedern und Verträgen dieser Standorte. Die Daten bleiben lesbar.",
  "{count} locations": "{count} Standorte",
  "E_StudioQuotaReached": "Alle gebuchten Standorte sind belegt. Erhöhen Sie die Standortanzahl im Tarif, um ein weiteres Studio zu aktivieren.",
  "Increase number of locations?": "Standortanzahl erhöhen?",
  "to the plan page": "zur Tarifseite",
  "E_StudioQuotaBelowActive": "Die gewählte Standortanzahl liegt unter der Zahl der aktiven Studios.",
  "E_MemberLimitReached": "Die im Tarif enthaltene Mitgliederzahl ist erreicht.",
  "E_UserLimitReached": "Die im Tarif enthaltene Benutzerzahl ist erreicht.",
  "E_ReaderLimitReached": "Die im Tarif enthaltene Zahl an Lesegeräten ist erreicht.",
  "Locations": "Standorte",
  "number of usable studio locations": "Anzahl nutzbarer Studio-Standorte",
  "1 location": "1 Standort",
  "single license": "Einzellizenz",
  "up to {count} locations": "bis {count} Standorte",
  "bookable": "zubuchbar",
  "any number": "beliebig",
  "any number of locations bookable": "beliebig viele Standorte zubuchbar",
  "{count} / mo.": "{count} / Mo.",
  "up to {count} members": "bis {count} Mitglieder",
  "up to {count} users": "bis {count} Benutzer",
  "up to {count} reader devices": "bis {count} Lesegeräte",
  "{count} AI contract cases / month included": "{count} KI-Vertragsvorgänge / Mo. inklusive",
  "individual": "individuell",
  "as needed": "nach Bedarf",
  "included": "inklusive",
  "TenantFeeExemptionDescription": "Tarif und Zubuchungen werden mit 0 € abgerechnet. Funktionen und Mengenlimits des gebuchten Tarifs bleiben bestehen. Nach dem Ausschalten gilt für neue Buchungen und Verlängerungen wieder der reguläre Preis.",
  "Payment allocation count": "{0} Zuordnungen",
  "Payment transactions could not be loaded": "Zahlungen konnten nicht geladen werden.",
  "Payment allocation": "Zuordnung",
  "Payment allocation item": "Posten",
  "Payment allocated amount": "zugeordneter Betrag",
  "Reminder action": "Aktion",
  "ReminderRetryCreated": "Erneuten Lastschrifteinzug vorgemerkt",
  "ReminderRetryNotificationConfirmed": "Briefversand der Einzugsankündigung bestätigt",
  "Request payment": "Zahlung anfordern",
  "Retry collection date": "Erneuter Einzug am",
  "Retry notification required": "Versand der Ankündigung klären",
  "Retry collection scheduled": "erneuter Einzug geplant",
  "Retry collection submitted": "erneuter Einzug im Lastschriftlauf",
  "Retry collection processing": "Einzug in Nachverarbeitung",
  "Retry collection missed": "Einzugstermin verpasst",
  "Retry collection cancelled": "Einzugsversuch abgebrochen",
  "Retry collection failed": "erneuter Einzug ohne Ausgleich",
  "Retry amount changed": "angekündigter Betrag hat sich geändert",
  "Confirm retry letter sent": "Briefversand bestätigen",
  "Confirm retry letter sent hint": "Bestätigen Sie nur, wenn die Einzugsankündigung heute tatsächlich als Brief versandt wurde. Eine erzeugte oder gedruckte PDF reicht dafür nicht aus.",
  "Payment chargeback line": "Rücklastschrift",
  "E_ReminderRetryIneligible": "Ein erneuter Einzug ist mit der aktuellen Zahlungsart, dem Mandat oder der SEPA-Sperre nicht möglich. Bitte prüfen Sie die betroffenen Posten.",
  "E_ReminderRetryDate": "Es gibt keinen gemeinsamen passenden Einzugstermin nach Ablauf der Ankündigungsfrist von 14 Tagen. Bitte prüfen Sie Termin, Lastschriftgruppen und Postenauswahl.",
  "E_ReminderRetryNotification": "Die Einzugsankündigung ist noch nicht wirksam versandt. Bitte prüfen Sie Dokument, Briefversand oder E-Mail-Status. Das Erscheinungsbild muss Einleitung und Hinweis enthalten.",
  "E_ReminderRetryRun": "Der Einzugsauftrag passt nicht mehr zum aktuellen Vorgang. Bitte prüfen Sie Versand, Termin, offene Beträge und den verknüpften Lastschriftlauf.",
  "E_ReminderActionConflict": "Die ausgewählten Posten führen zu unterschiedlichen Mahnaktionen. Bitte prüfen Sie Postenauswahl und Regeln der beteiligten Mahnstufen.",
  "USC platform access": "Urban Sports Club – Plattformzugang",
  "USC client ID": "Client-ID",
  "USC client secret": "Client-Secret",
  "USC secret unchanged": "gespeichertes Secret beibehalten",
  "USC platform settings unavailable": "Der Plattformzugang konnte nicht geladen werden.",
  "USC application authentication successful": "Der zentrale USC-Zugang wurde erfolgreich geprüft. Die Studio-Freigaben erfolgen separat durch USC.",
  "USC removing platform access disables tenant USC access": "Das Entfernen des Plattformzugangs sperrt die USC-Zutrittsprüfung für alle Mandanten. Die Studio-Zuordnungen bleiben erhalten.",
  "USC studio approval required": "USC schaltet Ihr Studio für m1member frei; anschließend werden die freigegebenen Standorte geladen.",
  "E_UscPlatformCredentialsInvalid": "Der zentrale USC-Zugang ist unvollständig oder ungültig. Prüfen Sie Client-ID und Client-Secret. Bei einer neuen Client-ID ist ein neues Secret erforderlich.",
  "E_UscPlatformUnavailable": "Der zentrale USC-Zugang konnte derzeit nicht geprüft werden.",
  "E_UscOnboardingNotConfigured": "Der USC-Antrag kann noch nicht versendet werden. Der Plattformbetreiber muss Empfängeradresse und USC-Webhook einrichten.",
  "E_UscRequestConflict": "Für diese USC-Kennung besteht bereits ein Antrag oder eine Zuordnung.",
  "E_UscPlatformMailUnavailable": "Der Plattform-Mailversand für Benachrichtigungen ist nicht eingerichtet.",
  "E_UscProviderInvalid": "Die USC-Partner-/Studionummer oder bestätigte Provider-ID ist ungültig.",
  "USC support request email": "USC-Empfänger für Freischaltungsanträge",
  "USC webhook URL": "öffentliche Webhook-URL",
  "USC webhook URL help": "HTTPS-Adresse dieser Installation mit dem Pfad /api/v1/webhooks/urban-sports-club.",
  "USC webhook registration missing": "Der USC-Webhook ist noch nicht registriert. Prüfen Sie die Einstellungen und speichern Sie erneut.",
  "USC connections unavailable": "Die USC-Anträge und Standorte konnten nicht geladen werden.",
  "USC provider ID": "USC-Betreiber-ID",
  "USC provider ID help": "Provider-ID von USC; keine Mitgliedsnummer oder Standort-ID.",
  "Request USC approval": "USC-Freischaltung beantragen",
  "Refresh USC locations": "USC-Standorte aktualisieren",
  "USC status Requested": "Freigabe ausstehend",
  "USC status Synchronizing": "Standorte werden geladen",
  "USC status Active": "freigeschaltet",
  "USC status Removed": "Freigabe beendet",
  "USC status SyncFailed": "Standortabruf fehlgeschlagen",
  "USC request mail failed": "Antragsversand fehlgeschlagen",
  "USC request mail queued": "Antrag wird versendet",
  "Retry USC request email": "Antragsversand erneut versuchen",
  "USC partner ID": "USC-Partner-/Studionummer",
  "USC partner ID help": "Ihre Partner-/Studionummer aus der USC-Zusammenarbeit.",
  "USC pending request": "ausstehender USC-Antrag",
  "USC confirmed provider ID": "von USC bestätigte Provider-ID",
  "USC confirmed assignment help": "Nur die von USC für diesen Antrag bestätigte Provider-ID zuordnen. Der Webhook enthält keine Partner-/Studionummer.",
  "Confirm USC assignment": "USC-Zuordnung bestätigen",
  "E_UscDisconnectPending": "USC hat die Trennung noch nicht bestätigt. Eine neue Freischaltung kann anschließend beantragt werden.",
  "USC status Disconnected": "lokal getrennt",
  "Disconnect USC integration": "USC-Anbindung trennen",
  "Disconnect USC integration confirmation": "Der USC-Zutritt für diesen Betreiber und alle zugeordneten Standorte wird sofort gesperrt. USC erhält automatisch den Trennungsantrag. Die Vertrags- und Leserzuordnungen bleiben erhalten.",
  "USC removal pending": "USC-Bestätigung ausstehend",
  "USC removal email failed": "Trennungsantrag nicht versendet; lokal bleibt der Zutritt gesperrt",
  "Request USC approval again": "USC-Freischaltung erneut beantragen",
  "Disconnect": "trennen",
  "Lead widget: default headline": "Kontakt aufnehmen",
  "Lead widget: step contact": "deine Daten",
  "Lead widget: choose studio": "Studio wählen",
  "Lead widget: submit failed": "Die Anfrage konnte nicht gesendet werden. Bitte versuche es erneut.",
  "Lead widgets: active": "Lead-Formular aktiv",
  "Lead widgets: tab basis": "Basis",
  "Lead widgets: tab form fields": "Formularfelder",
  "Lead widgets: tab success": "Bestätigung",
  "Lead widgets: tab display": "Darstellung",
  "Lead widgets: colors": "Farben",
  "Lead widgets: images": "Bilder",
  "Lead widgets: texts": "Texte",
  "Lead widgets: headline": "Überschrift",
  "Lead widgets: link": "Formular-Link",
  "Lead widgets: open as customer": "als Kunde öffnen",
  "Lead widgets: regenerate link?": "Link neu erzeugen?",
  "Lead widgets: regenerate link hint": "Der bisherige Link funktioniert danach nicht mehr.",
  "Lead widgets: save first": "Link und Einbettungscode stehen nach dem ersten Speichern bereit.",
  "Lead widgets: logo help": "Das Logo erscheint im Kopf des Formulars.",
  "Lead widgets: background help": "Das Bild liegt abgedunkelt hinter dem Formular.",
  "Lead widgets: preview form": "Formular",
  "Lead widgets: preview confirmation": "Bestätigung",
  "Lead widgets: saved": "Lead-Formular gespeichert",
  "Lead widgets: created": "Lead-Formular angelegt",
  "Lead widgets: copy suffix": "(Kopie)",
  "Widget design sources: load": "Design laden aus …",
  "Widget design sources: form": "Formular",
  "Widget design sources: choose": "Formular wählen",
  "Widget design sources: none": "keine weiteren Formulare verfügbar",
  "Widget design sources: load failed": "Die Formulare konnten nicht geladen werden.",
  "Widget design sources: Contact": "Kontaktformular",
  "Widget design sources: Booking": "Buchungsformular",
  "Widget design sources: Contract": "Vertragsformular",
  "E_WidgetDesignTemplate_NameRequired": "Bitte einen Namen für die Vorlage angeben.",
  "E_WidgetDesignTemplate_NameTaken": "Eine Vorlage mit diesem Namen gibt es bereits.",
  "E_WidgetDesignTemplate_DesignInvalid": "Die Darstellung konnte nicht gespeichert werden.",
  "Checking availability": "Verfügbarkeit wird geprüft",
  "{0} min": "{0} Min.",
  "Booking widget: default headline": "Termin buchen",
  "Booking widget: thank you title": "Danke für deine Buchung!",
  "Booking widget: thank you message": "Deine Buchung ist bestätigt. Du erhältst eine E-Mail mit allen Details.",
  "Booking widget: booking failed": "Die Buchung konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
  "Booking widget: step type": "Terminart",
  "Booking widget: step time": "Termin",
  "Booking widget: step contact": "deine Daten",
  "Booking widget: step finish": "Zusammenfassung",
  "Booking widget: choose studio": "Studio wählen",
  "Booking widget: choose type": "Terminart wählen",
  "Booking widget: choose time": "Tag und Uhrzeit wählen",
  "Booking widget: day": "Tag",
  "Booking widget: time": "Uhrzeit",
  "Booking widget: free": "kostenlos",
  "Booking widget: book as series": "als Terminserie buchen",
  "Booking widget: first appointment": "erster Termin",
  "Booking widget: appointment": "Termin",
  "Booking widget: series": "Terminserie",
  "Booking widget: contact": "Kontakt",
  "Booking widgets: active": "Online-Buchung aktiv",
  "Booking widgets: confirmation variables": "In Titel und Nachricht wird {{bookingNumber}} durch die Buchungsnummer ersetzt.",
  "Quick search placeholder": "Person oder Seite suchen …",
  "Quick search": "Suche",
  "Ask Qeddy": "Qeddy fragen",
  "Recently opened": "zuletzt geöffnet",
  "Ctrl+K": "Strg+K",
  "Cancellation…": "Kündigung …",
  "No cancellable contract package.": "Es gibt kein kündbares Vertragspaket.",
  "Dispatch approval": "Versand-Freigabe",
  "Chargeback task drawer title": "Rücklastschrift",
  "Chargeback task mark done": "als erledigt markieren",
  "Chargeback task done message": "Rücklastschrift erledigt.",
  "Dispatch approved.": "Versand freigegeben.",
  "Dispatch rejected.": "Versand abgelehnt.",
  "Reject dispatch?": "Versand ablehnen?",
  "Dashboard preset placeholder": "Vorlage übernehmen",
  "Dashboard preset reception": "Tresen",
  "Dashboard preset management": "Studioleitung",
  "Dashboard preset accounting": "Buchhaltung",
  "Admin dashboard active tenants": "aktive Mandanten",
  "Admin dashboard tenants caption": "von {0} · {1} neu in 30 Tagen",
  "Admin dashboard active studios": "aktive Studios",
  "Admin dashboard persons": "Personen",
  "Admin dashboard revenue": "Umsatz 30 Tage (netto)",
  "Admin dashboard open invoices": "offene Rechnungen",
  "Admin dashboard running jobs": "laufende Hintergrundaufgaben",
  "Admin dashboard queued jobs": "{0} wartend",
  "Admin dashboard action services": "Dienste",
  "Admin dashboard action logs": "Systemprotokoll",
  "Admin dashboard critical issues": "{0} kritische Startprobleme",
  "Admin dashboard system errors": "{0} Systemfehler in den letzten 24 Stunden",
  "Admin dashboard failed services": "Fehler beim letzten Lauf: {0}",
  "Admin dashboard failed jobs": "{0} Hintergrundaufgaben in 24 Stunden fehlgeschlagen",
  "Admin dashboard failed invoices": "{0} Rechnungen mit fehlgeschlagener Zahlung",
  "Admin dashboard failed emails": "{0} E-Mails in 7 Tagen nicht zugestellt ({1} Mandanten)",
  "Admin dashboard pending emails": "{0} E-Mails warten länger als eine Stunde",
  "Admin dashboard stopped services": "gestoppte Dienste: {0}",
  "Admin dashboard attention": "Handlungsbedarf",
  "Admin dashboard no attention": "kein Handlungsbedarf",
  "Admin dashboard load failed": "Die Übersicht konnte nicht geladen werden.",
  "Account statement": "Kontoauszug",
  "Account statement booking": "Buchung",
  "Account statement path": "Weg",
  "Account statement debit": "Soll",
  "Account statement credit": "Haben",
  "Account statement balance": "Saldo",
  "Account statement open balance": "{0} offen",
  "Account statement credit balance": "{0} Guthaben",
  "Account statement in collection amount": "davon im Einzug {0}",
  "Account statement debt collection amount": "Inkasso {0}",
  "Account statement due since": "fällig seit",
  "Account statement day": "{0} Tag",
  "Account statement days": "{0} Tagen",
  "Account statement reminder eligible from": "mahnfähig ab {0}",
  "Account statement next collection": "nächster Einzug",
  "Account statement next contribution": "nächster Beitrag",
  "Account statement all bookings": "alle Buchungen",
  "Account statement only open": "nur offene",
  "Account statement payment": "Zahlung",
  "Account statement show future": "{0} künftige Beiträge bis {1} · {2}",
  "Account statement hide future": "künftige Beiträge ausblenden",
  "Account statement rest": "Rest {0}",
  "Account statement credit offset": "Verrechnung mit Gutschrift",
  "Account statement unassigned payment": "keinem Posten zugeordnet",
  "Account statement installment plan": "Ratenplan",
  "Account statement installment plan detail": "{0} Raten à {1}, {2} offen",
  "Account statement load failed": "Der Kontoauszug konnte nicht geladen werden.",
  "Account statement status planned": "geplant",
  "Account statement status due": "fällig",
  "Account statement status reminder eligible": "mahnfällig",
  "Account statement status in collection": "im Einzug",
  "Account statement status paid": "bezahlt",
  "Account statement status settled": "verrechnet",
  "Account statement status cancelled": "storniert",
  "Account statement status debt collection": "Inkasso",
  "Account statement adjustment credit applied": "Gutschrift verrechnet",
  "Account statement adjustment cancelled": "storniert ohne Stornobeleg",
  "Account statement adjustment cancelled after payment": "Zahlung auf stornierter Forderung, nicht als Guthaben geführt",
  "Account statement adjustment overpayment": "Überzahlung, nicht als Guthaben geführt",
  "Account statement adjustment credit overapplied": "Gutschrift über ihren Betrag hinaus verrechnet",
  "Account statement adjustment other": "Ausgleich zu den offenen Posten",
  "Reminder eligible (status)": "mahnfällig",
  "Receivables": "Forderungen",
  "Receivables card description": "Weg jeder Forderung von fällig bis Inkasso",
  "Receivables permission help": "Erlaubt das Anzeigen des Forderungswegs. Läufe, Zahlungen und Sperren brauchen ihr eigenes Recht.",
  "Receivables stages": "Stufen des Forderungswegs",
  "Receivables stage due": "fällig",
  "Receivables stage inCollection": "im Einzug",
  "Receivables stage returned": "zurückgebucht",
  "Receivables stage reminded": "gemahnt",
  "Receivables stage debtCollection": "Inkasso",
  "Receivables column claim": "Forderung",
  "Receivables column stage": "Stufe",
  "Receivables column returned at": "zurück am",
  "Receivables column return reason": "Rückgabegrund",
  "Receivables reminder level value": "{0}. Stufe",
  "Receivables flag dunning due": "mahnfällig",
  "Receivables flag payment cancelled": "Zahlung storniert",
  "Receivables filter sepa blocked": "nur SEPA-gesperrte",
  "Receivables filter payment cancelled": "nur mit Zahlungsstorno",
  "Receivables action recollect": "erneut einziehen",
  "Receivables action prepare reminder run": "Mahnlauf vorbereiten",
  "Receivables action open run": "Lastschriftlauf",
  "Receivables dunning due summary": "davon mahnfällig: {0} · {1}",
  ...memberAdminNavigationDe,
} as const;
